(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return (window["webpackJsonp"] = window["webpackJsonp"] || []).push([[4],Array(37).concat([
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d499ab556d929865f461acb8f2a13bf.svg";

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Detailed History\",\"myAgencySubmissions\":\"My Agency's Submissions\",\"myTasks\":\"My Tasks\",\"grid\":{\"emptyMessage\":\"No matching items.\",\"header\":{\"colAction\":\"Action\",\"colDate\":\"Date\",\"colDetails\":\"Details\",\"colMessage\":\"Message\",\"colType\":\"Type\",\"colUser\":\"User\"},\"historyCount\":\"Showing startIndex to endIndex of total Record\",\"historyCounts\":\"Showing startIndex to endIndex of total Records\"},\"downloadCsv\":\"Download CSV\",\"downloadExcel\":\"Download Excel\"}");

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReassignSubmissionRepository = function ReassignSubmissionRepository(baseRepository, $timeout, $q) {
  angular.extend(this, baseRepository);
  this.reassignSubmissions = function (submissionParams) {
    var url = '/rest/Submission/bulkReassign';
    var defer = $q.defer();
    this.post(url, submissionParams).then(function (result) {
      defer.resolve({
        successCount: result.successCount,
        errorList: result.submissionIdsInError,
        totalRequested: result.totalProcessed
      });
    });
    return defer.promise;
  };
};
ReassignSubmissionRepository.$inject = ["baseRepository", "$timeout", "$q"];
angular.module('gw-um-submission-grid').service('reassignSubmissionRepository', ReassignSubmissionRepository);

/***/ }),
/* 77 */
/***/ (function(module, exports) {

var path = '/submissionDetailsDrawer/transactionGridTooltip/transactionGridTooltip.tpl.html';
var html = "<div class=\"transactionTooltip\"\n     ng-show=\"showTransactionTooltip\"\n     ng-style=\"locationStyle\"\n     ng-class=\"{'transactionTooltipLeftArrow' : direction === LEFT_ARROW,\n                'transactionTooltipRightArrow' : direction === RIGHT_ARROW,\n                'transactionTooltipTopArrow' : direction === TOP_ARROW,\n                'transactionTooltipBottomArrow': direction === BOTTOM_ARROW,\n                'transactionTooltipRightBttomArrow': direction === RIGHT_BOTTOM_ARROW\n            }\">\n\n    <div ng-repeat=\"column in colViewModel.columns\">\n        <div class=\"transactionRow\">\n                <div class=\"headingCol {{column._accessor}}Heading\">\n                    <h5>{{getTranslatedValueKey(rows,column)}}</h5>\n                </div>\n                <div class=\"valueCol {{column._accessor}}Value\">\n                    <span>{{getValue(rows,column)}}</span>\n                </div>\n        </div>\n    </div>\n\n    <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module) {

module.exports = JSON.parse("{\"cancelButton\":\"Cancel\",\"createEmailButton\":\"Create Correspondence\",\"loadingBar\":\"Creating Email...\",\"title\":\"Email Templates\"}");

/***/ }),
/* 80 */
/***/ (function(module) {

module.exports = JSON.parse("{\"defaultSubmissionNameLabel\":\"New Submission\",\"submissionListDownArrowTooltip\":\"Show/hide opened submissions.\"}");

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1bff5bf382ae180d224aa37e71dcdfc5.svg";

/***/ }),
/* 82 */
/***/ (function(module) {

module.exports = JSON.parse("{\"chatMembers\":{\"submissionParticipants\":\"Submission participants\",\"viewChatMembersButtonTooltip\":\"View participant list\",\"viewInviteChatMembersButtonTooltip\":\"View participant list and invite others\",\"you\":\"(you)\"}}");

/***/ }),
/* 83 */
/***/ (function(module) {

module.exports = JSON.parse("{\"chatMembersDropdown\":{\"inviteOthers\":\"Invite others\",\"submissionParticipants\":\"Submission participants\",\"you\":\"(you)\"}}");

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9c96672bf02cf409ca212da432564ea1.svg";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dff83ce4787b7539fe9ad5a5a67244d8.svg";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "28d455eaef98f31ead884c5a6d4abf03.svg";

/***/ }),
/* 87 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Note\",\"newTitle\":\"New Note\",\"deleteNoteTitle\":\"Delete Note\",\"deleteQuestion\":\"Are you sure you want to delete the selected note?\",\"confirmActionButtonLabel\":\"Yes\",\"cancelActionButtonLabel\":\"No\",\"visible\":\"Visible to agent\",\"labelAs\":\"Label as\",\"delete\":\"Delete\",\"save\":\"Save\",\"cancel\":\"Cancel\",\"placeholder\":\"Note...\",\"type\":\"Type\"}");

/***/ }),
/* 88 */
/***/ (function(module) {

module.exports = JSON.parse("{\"summary\":\"Task summary...\",\"description\":\"Task description...\",\"taskDetails\":\"Task details\",\"assignedTo\":\"Assigned to:\",\"priority\":\"Priority...\",\"receivedDate\":\"Received date\",\"remindMe\":\"Reminder date\",\"setDueDate\":\"Due date\",\"notes\":\"Resolution Notes\",\"confirmationTaskDelete\":\"Are you sure you want to delete this Task?\",\"deleteTask\":\"Delete Task\",\"confirmActionButtonLabel\":\"Yes\",\"cancelActionButtonLabel\":\"No\",\"nextAction\":\"Show on Home Page\",\"reminderEmail\":\"Email Reminder\",\"assignTask\":\"Assign Task\",\"cancel\":\"Cancel\",\"notify\":\"Notify\",\"taskNotifyTooltip\":\"Notify task assignee of changes\",\"taskNotifyFadingNotification\":\"The task assignee has been successfully notified.\",\"createTaskTitle\":\"New Task\",\"viewTaskTitle\":\"Task\",\"completedTaskTitle\":\"Completed Task\",\"assignTo\":\"Assign to...\",\"assignedBy\":\"Assigned by:\",\"received\":\"Received:\",\"reminder\":\"Reminder:\",\"due\":\"Due:\",\"resolvedBy\":\"Resolved by:\",\"visibleToAgent\":\"Visible to agent\",\"resolveTask\":\"Resolve Task\",\"longListMessage\":\"Please revise your search to display users other than submission participants.\",\"resolutionReason\":\"Resolution Reason...\"}");

/***/ }),
/* 89 */
/***/ (function(module) {

module.exports = JSON.parse("{\"none\":\"No\",\"policies\":\"Policies\",\"submissions\":\"Submissions\",\"submissionSelected\":\"Submission Selected\",\"submissionsSelected\":\"Submissions Selected\",\"totals\":\"Totals\",\"viewActiveOnly\":\"View Active Only\",\"columnFilterIconTooltip\":\"Manage columns.\",\"status\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Not Clear\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Rejected\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}},\"emptyMessage\":\"No matching items.\"}");

/***/ }),
/* 90 */
/***/ (function(module) {

module.exports = JSON.parse("{\"all\":\"All Policies\",\"emptyMessage\":\"Select one or more submissions to view policies\",\"defaultEndorsementDescription\":\"Endorsement\",\"defaultReissueDescription\":\"Policy Reissue\",\"defaultRewriteDescription\":\"Policy Rewrite\",\"defaultIssuanceDescription\":\"New Policy\",\"defaultCancellationDescription\":\"Policy Cancellation\",\"policyStatuses\":{\"beginIssuance\":\"Begin Issuance\",\"bound\":\"Bound\",\"issued\":\"Issued\",\"pendingIssuance\":\"Pending Issuance\"},\"endorsementStatuses\":{\"declined\":\"Declined\",\"draft\":\"Draft\",\"invalid\":\"Invalid\",\"issued\":\"Issued\",\"pendingIssuance\":\"Pending Issuance\",\"submitted\":\"Submitted\"},\"policyRewriteStatuses\":{\"draft\":\"Draft\",\"invalid\":\"Invalid\",\"issued\":\"Issued\",\"pendingIssuance\":\"Pending Issuance\",\"submitted\":\"Submitted\"},\"policyCancellationStatuses\":{\"cancelled\":\"Cancelled\",\"invalid\":\"Invalid\",\"pending\":\"Pending\",\"requested\":\"Requested\",\"rescinded\":\"Rescinded\",\"retracted\":\"Retracted\"},\"policyReinstatementStatuses\":{\"invalid\":\"Invalid\",\"reinstated\":\"Reinstated\"}}");

/***/ }),
/* 91 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Approve Endorsement\",\"cancelButton\":\"Cancel\",\"okayButton\":\"Confirm\",\"summary\":\"Processing Instructions:\",\"loading\":\"Approving Endorsement...\"}");

/***/ }),
/* 92 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Select Quotes To Be Copied\",\"cancelButton\":\"Cancel\",\"okayButton\":\"OK\",\"loading\":\"Copying Proposal...\"}");

/***/ }),
/* 93 */
/***/ (function(module) {

module.exports = JSON.parse("{}");

/***/ }),
/* 94 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Dynamic Data\",\"columns\":{\"name\":\"Name\",\"city\":\"City\",\"number\":\"Number\",\"email\":\"Email\",\"organization\":\"Organization\",\"type\":\"Type\",\"description\":\"Description\",\"lastModifiedBy\":\"Last Edited By\",\"timeLastModified\":\"Last Modified Date\"},\"emptyGrid\":\"No matching data\",\"recordCountText\":\"Showing startIndex to endIndex of total Data\",\"recordsCountText\":\"Showing startIndex to endIndex of total Data\",\"clearButton\":\"Clear All\",\"textInputFilter\":{\"nameSubstring\":{\"placeholder\":\"Search data\"}},\"bulkActionLabel\":\"Item Selected\",\"bulkActionCancelButtonLabel\":\"Cancel\",\"selectFilter\":{\"types\":{\"placeholder\":\"All Types\"},\"productNames\":{\"placeholder\":\"All Products\"}},\"actions\":{\"name\":\"Actions\",\"Test Action\":\"Test Action\"}}");

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/*@ngInject*/
angular.module('gw-um-grid-data-browser', ['umCore']).constant('gridDataBrowserConstant', {
  event: {
    BULK_ACTION_COMPLETE: 'gridDataBrowserModule.BulkActionComplete'
  }
}).run(function () {});
__webpack_require__(566);
module.exports = 'gw-um-grid-data-browser';

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(50);
var uirouter = __webpack_require__(53);
var ngIdle = __webpack_require__(54);
var angularSanitize = __webpack_require__(55);
var uiBootstrap = __webpack_require__(56);
var uiSelect = __webpack_require__(57);
var relativeDate = __webpack_require__(73);
var coreModule = __webpack_require__(58);

/*@ngInject*/
angular.module('gw-um-submission-grid', [angularSanitize, ngIdle, uirouter.default, uiBootstrap, uiSelect, relativeDate.default.name, 'currencyFilter', 'isoCurrency', 'dibari.angular-ellipsis', 'ux', coreModule]).config(function () {}).run(function () {});
__webpack_require__(145);
__webpack_require__(146);
__webpack_require__(147);
__webpack_require__(148);
__webpack_require__(150);
__webpack_require__(151);
__webpack_require__(152);
__webpack_require__(154);
__webpack_require__(155);
__webpack_require__(156);
__webpack_require__(77);
__webpack_require__(159);
__webpack_require__(160);
__webpack_require__(161);
module.exports = 'gw-um-submission-grid';

/***/ }),
/* 145 */
/***/ (function(module, exports) {

var submissionGridConstant = {
  event: {
    SUBMISSIONS_LOADED: 'umSubmissionGrid.submissionsLoaded',
    OPEN_SUBMISSION_DETAIL_DRAWER: 'umSubmissionGrid.openSubmissionDetailDrawer',
    CLOSE_SUBMISSION_DETAIL_DRAWER: 'umSubmissionGrid.closeSubmissionDetailDrawer',
    RESET_GRID_COLUMNS: 'umSubmissionGrid.resetGridColumns',
    RESET_GRID_LIST: 'umSubmissionGrid.resetGridList',
    MODIFIED_COLUMN_SELECTION: 'umSubmissionGrid.modifiedColumnSelection'
  }
};
angular.module('gw-um-submission-grid').constant('submissionGridConstant', submissionGridConstant);

/***/ }),
/* 146 */
/***/ (function(module, exports) {

var submissionGridComponent = {
  templateUrl: '/submissionGrid.tpl.html',
  controller: 'submissionGridController',
  bindings: {
    widgetConfig: '<',
    filterType: '<',
    alwaysShowSearch: '<'
  }
};
angular.module('gw-um-submission-grid').component('uiSubmissionGrid', submissionGridComponent);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var baseSubmissionGridController = function baseSubmissionGridController($rootScope, $controller, $scope, appTypeConfigurationModel, authorizationConstants, coreConstant, submissionGridConstant, gridColumnModel, loadSubmissionsRepository, persistentConnection, uiPerformanceLoggerConstant, currentUserModel) {
  angular.extend(this, $controller('baseGridWidgetController', {
    $scope: $scope
  }));
  this.userId = null;
  this.customIconPreferences = {};
  this.columnPreference = this.isAgent ? 'view.agent.homePageColumns' : 'view.uw.homePageColumns';
  this.$onInit = function () {
    this.initSubmissionGrid();
  };
  this.initSubmissionGrid = function () {
    this.uiPerformanceLogAction = uiPerformanceLoggerConstant.SUBMISSION_HOME;
    this.gridLoadedEvent = submissionGridConstant.event.SUBMISSIONS_LOADED;
    this.openDetailDrawerEvent = submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER;
    this.closeDetailDrawerEvent = submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER;
    this.requestParams = this.getFilterParams();
    this.hasFilterPermission = currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_ADVANCED_FILTER);
    this.onInitGridWidget();
  };
  this.loadRecordsInt = function (requestParams) {
    return loadSubmissionsRepository.loadSubmissions(this.requestParams);
  };
  this.updateDefaultSortColumn = function () {
    var submissionParams = gridColumnModel.getSubmissionParams();
    this.setFilterParams(submissionParams);
  };
  this.setFilterParams = function (filterParams) {
    gridColumnModel.setSubmissionParams(filterParams);
  };
  this.getFilterParams = function () {
    return gridColumnModel.getSubmissionParams();
  };
  this.setSelectedFilterName = function (filterName) {
    gridColumnModel.setSelectedSubmissionFilterName(filterName);
  };
  this.getSelectedFilterName = function () {
    return gridColumnModel.getSelectedSubmissionFilterName();
  };
  this.generateColumns = function () {
    var filterColumnPrefName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    this.updateColumnsFromPreferences(); // update the columnPreference in shared gridColumnModel
    this.colViewModel = gridColumnModel.getSubmissionGridColumns(filterColumnPrefName);
    this.dropdownColumns = gridColumnModel.getDropdownColumns(filterColumnPrefName);
  };
  this.resetParams = function (params) {
    gridColumnModel.setSubmissionParams(params);
  };
  this.getNextTaskDefinition = function (definition) {
    return _.replace(_.replace(definition, 'Other::', ''), 'Other - ', '');
  };
};
baseSubmissionGridController.$inject = ["$rootScope", "$controller", "$scope", "appTypeConfigurationModel", "authorizationConstants", "coreConstant", "submissionGridConstant", "gridColumnModel", "loadSubmissionsRepository", "persistentConnection", "uiPerformanceLoggerConstant", "currentUserModel"];
angular.module('gw-um-submission-grid').controller('baseSubmissionGridController', baseSubmissionGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(76);
var locale = __webpack_require__(149);
__webpack_require__(76);

/*@ngInject*/
var submissionGridController = function submissionGridController($rootScope, $timeout, $stateParams, $state, $controller, $scope, $filter, $uibModal, $window, localization, advancedFilterType, appTypeConfigurationModel, coreMediator, preferenceModel, coreConstant, submissionGridConstant, gridColumnModel, persistentConnection, submissionUploadStatus, submissionStatus, currencyUtil, formViewerConstant, currentUserModel, authorizationConstants, reassignSubmissionRepository, modalUtil, submissionMediator, filterRepository) {
  var _this2 = this;
  angular.extend(this, $controller('baseSubmissionGridController', {
    $scope: $scope
  }));
  this.i18n = locale;
  this.multiSelectMaximumBatchSize = preferenceModel.get('system.maxBulkReassignSubmissions');
  this.maxDownloadRows = 5000;
  this.userId = null;
  this.customIconPreferences = {};
  this.advancedFilterType = advancedFilterType.SUBMISSION_GRID;
  this.recordCountText = null;
  this.recordsCountText = null;
  this.isMultiSelectEnabled = false;
  this.pageSizeOptions = [25, 50, 100];
  this.startIndex = 0;
  this.$onInit = function () {
    this.isMultiSelectEnabled = currentUserModel.hasAuthorization(authorizationConstants.SUBMISSION_BULK_ASSIGN_SUBMISSION_PARTICIPANTS);
    coreMediator.loadDefaultPreferences().then(function (preferences) {
      if (preferences['system.maxDownloadRows']) {
        this.maxDownloadRows = parseInt(preferences['system.maxDownloadRows'].value);
      }
    }.bind(this));
    localization.getTranslations().then(function (translations) {
      this.translations = translations;
      this.recordCountText = _.get(translations, 'homePage.grid.submissionCount');
      this.recordsCountText = _.get(translations, 'homePage.grid.submissionsCount');
    }.bind(this));
    this.initSubmissionGrid();
    this.i18n = locale;
    this.pageSize = this.requestParams.pageSize;
  };
  this.onPagingChange = function ($event, params) {
    this.requestParams.pageSize = params.pageSize;
    this.requestParams.startIndex = params.startIndex;
    currentUserModel.filterInfoMap[this.selectedFilterName].startIndex = params.startIndex;
    this.loadGrid();
  };
  this.setOpenFilterUri = function (filterUri) {
    gridColumnModel.setOpenFilterUri(this.advancedFilterType, filterUri);
  };
  this.getOpenFilterUri = function () {
    return gridColumnModel.getOpenFilterUri(this.advancedFilterType);
  };
  this.setSelectedFilterName = function (filterName) {
    var fromUI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.selectedFilterName = filterName;
    gridColumnModel.setSelectedSubmissionFilterName(filterName);
    if (!fromUI && currentUserModel.filterInfoMap[this.selectedFilterName] !== undefined) {
      this.startIndex = currentUserModel.filterInfoMap[this.selectedFilterName].startIndex;
      $scope.$broadcast(coreConstant.event.RESET_GRID_PAGING, 0, this.startIndex);
    } else {
      this.startIndex = 0;
      currentUserModel.filterInfoMap[this.selectedFilterName] = {};
      currentUserModel.filterInfoMap[this.selectedFilterName].startIndex = 0;
    }
    if (this.advancedFilterType == "submissionGrid") {
      var filter = _.filter(this.filters, {
        'name': filterName
      })[0];
      this.filter = filter;
      var filterPrefName = this.getFilterPrefName(filter.uri);
      this.generateColumns(filterPrefName);
    }
  };
  this.getFilterPrefName = function (filterUri) {
    if (!filterUri && this.filter) {
      filterUri = this.filter.uri;
    }
    if (this.isFilterEdited()) {
      filterUri = gridColumnModel.getOpenFilterUri(this.advancedFilterType);
      if (!filterUri) {
        filterUri = gridColumnModel.getSavedFilterUri(this.advancedFilterType);
      }
    }
    var filterPrefName = filterUri ? "views.submissionGrid:" + filterUri : null;
    return filterPrefName;
  };
  this.getColumnClassName = function (name) {
    return _.lowerFirst(name).replace(/\s/g, '') + ' Checkbox';
  };
  this.getSubmissionsDownloadUrl = function (submissionParams, start, end) {
    var paramsString = "filterUri=".concat(submissionParams.filterUri);
    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    paramsString += "&timezone=".concat(timezone);
    return coreMediator.getSingleUseToken().then(function (token) {
      paramsString += "&t=".concat(encodeURIComponent(token));
      if (start >= 0) {
        paramsString += "&start=".concat(start);
      }
      if (end >= 0) {
        paramsString += "&end=".concat(end);
      }
      if (submissionParams.key) {
        var orderBy = submissionParams.key;
        if (submissionParams.sortType) {
          orderBy += ' ' + submissionParams.sortType;
        }
        paramsString += "&orderBy=".concat(encodeURIComponent(orderBy));
      }
      return "/submissions/submissions.csv?".concat(paramsString);
    });
  };
  this.onCsvDownloadClick = function (event) {
    if ($scope.requiresRangeDownload) {
      event.preventDefault();
      var urlFunction = function (result) {
        return this.getSubmissionsDownloadUrl(this.requestParams, result.start - 1, result.end - 1);
      }.bind(this);
      var options = function () {
        return {
          batch: this.maxDownloadRows,
          min: 1,
          max: this.totalRecords,
          urlFunction: urlFunction
        };
      }.bind(this);
      $uibModal.open({
        templateUrl: '/rangeModal/rangeModal.tpl.html',
        controller: 'rangeModalController',
        windowClass: 'rangeModal',
        resolve: {
          options: options
        }
      });
    } else {
      this.getSubmissionsDownloadUrl(this.requestParams).then(function (url) {
        $window.open(url, '_blank');
      });
    }
  }.bind(this);
  this.getClass = function (item, column) {
    var ngClass = '{}';
    if (column._accessor && column._accessor === 'nextTaskSummary.dueDate' && item.nextTaskSummary) {
      ngClass = '{ pastDue : ' + this.isPastDue(item.nextTaskSummary.dueDate) + ' }';
    }
    return ngClass;
  };
  this.getValueKey = function (item, column) {
    var valueKey = null;
    if (column._accessor === 'status') {
      var value = item['status'];
      var altValue = item['uploadStatus'];
      var isCancellationPending = item['cancellationPending'];
      if (!_.isNil(altValue) && value === submissionStatus.CREATED && (altValue === submissionUploadStatus.UPLOAD_IN_PROGRESS || altValue === submissionUploadStatus.UPLOAD_PENDING || altValue === submissionUploadStatus.UPLOAD_SUCCEEDED)) {
        if (appTypeConfigurationModel.isAgentConsole()) {
          valueKey = "agentStatus.uploadStatus.".concat(altValue);
        } else {
          valueKey = "status.uploadStatus.".concat(altValue);
        }
      } else if (isCancellationPending && value === submissionStatus.ISSUED) {
        valueKey = 'subStatus.cancellationPending';
      } else {
        if (appTypeConfigurationModel.isAgentConsole()) {
          valueKey = "agentStatus.".concat(value);
        } else {
          valueKey = "status.".concat(value);
        }
      }
    }
    return _.get(this.i18n, valueKey);
  };
  this.getTranslatedValueKey = function (item, column) {
    var valueKey = this.getValueKey(item, column);
    if (_.isNil(_.get(this.translations, valueKey))) {
      return this.getValueKey(item, column);
    }
    return _.get(this.translations, valueKey);
  };
  this.getValue = function (item, column) {
    if (column._accessor === 'identifiers') {
      var value = _.findLast(item.identifiers, ['type', column.__text]);
      if (!_.isNil(value)) {
        return value.identifier;
      }
    } else if (column._accessor === 'aliases') {
      return _.join(_.map(item.aliases, 'name'), ', ');
    } else {
      var props = [];
      if (column._accessor && column._accessor.indexOf('.' > 0)) {
        props = column._accessor.split('.');
      } else {
        props.push(column._accessor);
      }
      var _value = item;
      for (var i = 0; i < props.length; i++) {
        if (!_.isNil(_value)) {
          _value = _value[props[i]];
        }
      }
      if (_.isNil(_value)) {
        _value = _.findLast(item.dynamaccountcDisplayData, ['name', column.__text]);
        if (!_.isNil(_value)) {
          return _value.identifier;
        }
      }
      if (column._accessor === 'priority') {
        _value = null;
      } else if (column._accessor === 'status') {
        _value = null;
      } else if (column._accessor === 'submissionNumber') {
        _value = item.policyNumber || _value;
      } else if (column._accessor === 'nextTaskSummary.definition') {
        _value = this.getNextTaskDefinition(_value);
      } else if (column._accessor === 'account.name') {
        _value = item.accountName;
      }
      if (column._type && column._type.indexOf('shortDate') >= 0 || column._accessor === 'paymentReceivedDate' || column._accessor === 'receivedDate') {
        var filter = $filter('utcDateFilter');
        _value = filter(_value, this.shortDateFormat, true);
      }
      if (column._type && column._type.indexOf('utcShortDate') >= 0 || column._accessor === 'effectiveDate' || column._accessor === 'expirationDate' || column._accessor === 'nextTaskSummary.dueDate' || column._accessor === 'quoteNeededByDate') {
        var _filter = $filter('utcDateFilter');
        var useLocalTime = false;
        if (column._accessor === 'nextTaskSummary.dueDate') {
          useLocalTime = true;
        }
        _value = _filter(_value, this.shortDateFormat, useLocalTime);
      }
      if (column._type && column._type.indexOf('premium') >= 0) {
        var _filter2 = $filter('currency');
        var currencyFormat = currencyUtil.getCurrencyFormat(_value.currencyCode);
        _value = _filter2(_value.total, currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
      } else if (column._type && column._type.indexOf('currency') >= 0) {
        var _filter3 = $filter('currency');
        _value = _filter3(_value, item.currencyFormat.symbol, 0, item.currencyFormat.suffixSymbol, item.currencyFormat.customFormat);
      }
      return _value;
    }
  };
  this.loadListOnFilterChange = function () {
    this.openFilter = null;
    this.calculateFilterParams();
    this.resetGridPaging();
  };
  this.initLandingPage = function () {
    this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    this.updateDefaultSortColumn();
    this.updateColumnsFromPreferences();
    this.generateColumns();
    // use last saved startIndex
    if (currentUserModel.filterInfoMap[this.selectedFilterName] !== undefined) {
      this.startIndex = currentUserModel.filterInfoMap[this.selectedFilterName].startIndex;
      this.savedTotalRecords = currentUserModel.filterInfoMap[this.selectedFilterName].savedTotalRecords;
    }
    this.updateFilterFromPreferences();
  };
  this.isMultiSelectMode = function () {
    return $scope.multiSelectModel.isMultiSelectMode;
  };
  this.openSubmission = _.debounce(function (submissionId) {
    var _this = this;
    if (!this.isMultiSelectMode()) {
      submissionMediator.isUserAuthorizedForSubmissionProduct(submissionId).then(function () {
        var params = {
            submissionId: submissionId
          },
          stateName = 'submission.default';
        if (submissionId === parseInt($stateParams.submissionId)) {
          return;
        }
        if (_this.isColSelectDropdownOpen) {
          _this.updateDropdownClosed();
          return;
        }
        if (!_this.isSearchOpen) {
          _this.setOpenFilterUri(null);
        }
        _this.isLoading = true;
        $state.go(stateName, params);
      });
    }
    ;
  }.bind(this), 200, {
    leading: true
  });
  this.setSelectedItem = function (event, selectedItem) {
    if (!this.isMultiSelectMode()) {
      if (this.isBulkUpdateMode) {
        this.handleBulkUpdateRowClick(selectedItem);
      } else {
        if (selectedItem.selected) {
          selectedItem.selected = false;
          this.isDrawerOpen = false;
          return;
        }
        if ($(event.currentTarget).hasClass('toggleDrawer')) {
          this.isDrawerOpen = true;
        }
        _.forEach(this.records, function (item) {
          item.selected = item === selectedItem;
        });
        $scope.$broadcast(this.openDetailDrawerEvent);
      }
    } else {
      $scope.multiSelectUtil.handleMultiSelectRowClick(selectedItem);
    }
  };
  this.updatePageSize = function (pageSize) {
    var pageSizeInt = _.toInteger(pageSize);
    gridColumnModel.updateSubmissionParamByName('pageSize', pageSizeInt);
    _this2.resetGridPaging(pageSizeInt);
  };
  this.resetGridPaging = function (pageSize, startIndex) {
    if (_.isNil(startIndex) && !_.isNil(_this2.startIndex)) {
      startIndex = _this2.startIndex;
    }
    $scope.$broadcast(coreConstant.event.RESET_GRID_PAGING, pageSize, startIndex);
  };
  $scope.onReassignSelection = function () {
    var handleClose = function handleClose(selection) {
      var filterUri = _this2.filterModel.filter.uri;
      var openFilterUri = _this2.getOpenFilterUri();
      var _$scope$multiSelectMo = $scope.multiSelectModel,
        multiSelectItemList = _$scope$multiSelectMo.multiSelectItemList,
        isMultiSelectUsingExclusion = _$scope$multiSelectMo.isMultiSelectUsingExclusion;
      var params = {
        assignmentType: selection.assignementType,
        userToAssignId: selection.userToAssignId
      };
      if (isMultiSelectUsingExclusion) {
        params.excludedSubmissionIds = multiSelectItemList;
        params.filterUri = openFilterUri || filterUri;
      } else {
        params.submissionIds = multiSelectItemList;
      }
      if (selection.userToRemoveId) {
        params.userToRemoveId = selection.userToRemoveId;
      }
      $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR);
      reassignSubmissionRepository.reassignSubmissions(params).then(function (result) {
        var successCount = result.successCount,
          errorList = result.errorList,
          totalRequested = result.totalRequested;
        var selectionLength = $scope.multiSelectModel.multiSelectItemList.length;
        $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR);
        $uibModal.open({
          templateUrl: '/ui/grid/multiSelect/confirmationModal/confirmationModal.tpl.html',
          controller: 'multiSelectConfirmationModalController',
          windowClass: 'multiSelectConfirmationModal',
          resolve: {
            options: function options() {
              return {
                successCount: successCount,
                totalRequested: totalRequested,
                errorList: errorList
              };
            }
          }
        }).result.then(function () {
          var hadMaxCountLimit = $scope.multiSelectUtil.isMaximumSelectionCountWarningVisible();
          var selectAllCheckbox = $scope.multiSelectModel.selectAllCheckbox;
          $scope.multiSelectUtil.resetMultiSelect();
          _this2.resetGridPaging();
          $timeout(function () {
            if (hadMaxCountLimit) {
              $scope.multiSelectUtil.onBeginMultiSelect();
              if (selectAllCheckbox) {
                $scope.multiSelectUtil.activateSelectAllCheckbox();
              }
            } else {
              $scope.multiSelectUtil.onCancelMultiSelect();
              _this2.onCancelBulkUpdate();
            }
          }, 200);
        });
      });
    };
    $uibModal.open({
      templateUrl: '/ui/grid/multiSelect/userSelectionModal/userSelectionModal.tpl.html',
      controller: 'userSelectionModalController',
      windowClass: 'userSelectionModal'
    }).result.then(handleClose);
  };

  // this funny syntax is used to pass in the callback via a directive that doesn't
  // use isolate scope - multi-select-reassign-callback="$ctrl.onReassignSelectionCallback"
  $scope.onReassignSelectionCallback = $scope.onReassignSelection.bind($scope);
  $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function (event, type) {
    if (type === 'submissionGrid') {
      this.updateColumnsFromPreferences();
      var filterPrefName = this.getFilterPrefName();
      this.generateColumns(filterPrefName);
      this.loadGrid();
    }
  }.bind(this));
  $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, function () {
    this.loadListOnFilterChange();
  }.bind(this));
  $scope.$on(submissionGridConstant.event.SUBMISSIONS_LOADED, function () {
    $scope.requiresRangeDownload = this.totalRecords > this.maxDownloadRows;
  }.bind(this));
  $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
    persistentConnection.connect().then(function () {
      this.isUserTypeUpdated = true;
      this.isAgent = appTypeConfigurationModel.isAgentConsole();
      this.initLandingPage();
    }.bind(this));
  }.bind(this));
  $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
  $scope.$on(formViewerConstant.event.formBuilder.REARRANGE_COLUMN, function (event, columnToRearrange, targetColumn, isLeftDrop) {
    this.rearrangeColumn(this.colViewModel.columns, columnToRearrange, targetColumn, isLeftDrop);
  }.bind(this));
  $scope.$on(formViewerConstant.event.formBuilder.COLUMN_RESIZED, function (event, columnIdentifier, newWidth) {
    this.resizeColumn(this.colViewModel.columns, columnIdentifier, newWidth);
  }.bind(this));
};
submissionGridController.$inject = ["$rootScope", "$timeout", "$stateParams", "$state", "$controller", "$scope", "$filter", "$uibModal", "$window", "localization", "advancedFilterType", "appTypeConfigurationModel", "coreMediator", "preferenceModel", "coreConstant", "submissionGridConstant", "gridColumnModel", "persistentConnection", "submissionUploadStatus", "submissionStatus", "currencyUtil", "formViewerConstant", "currentUserModel", "authorizationConstants", "reassignSubmissionRepository", "modalUtil", "submissionMediator", "filterRepository"];
angular.module('gw-um-submission-grid').controller('submissionGridController', submissionGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 149 */
/***/ (function(module) {

module.exports = JSON.parse("{\"submissionListWidget\":{\"title\":\"Submissions\",\"titleSeparator\":\":\",\"submissionFiltersLabel\":\"Submission Filters\",\"myRecentSubmissionsFilter\":\"My Recent Submissions\",\"columnHeadings\":{\"insuredName\":\"Insured Name\",\"submissionNumber\":\"Submission No.\",\"status\":\"Status\",\"effectiveDate\":\"Effective Date\"},\"emptyMessage\":\"No matching submissions.\"},\"showOrHideToolsTooltip\":\"Show/hide tools.\",\"searchIconTooltip\":\"Show/hide filters.\",\"advancedFilter\":{\"dateRange\":{\"startDatePlaceHolder\":\"Start Date\",\"endDatePlaceHolder\":\"End Date\",\"to\":\"to\"},\"saveFilterLabel\":\"Save Filter\",\"saveFilterAsLabel\":\"Save Filter As...\",\"saveFilterAs\":{\"title\":\"Save Filter As\",\"filterLabel\":\"New Filter Name\",\"cancelButton\":\"Cancel\",\"saveAsButton\":\"Save\",\"loadingBar\":\"Saving Filter...\",\"duplicateWarning\":\"That name is already in use.\"},\"deleteFilterLabel\":\"Delete Filter\",\"deleteFilter\":{\"title\":\"Delete Filter\",\"summary\":\"Are you sure you want to delete the selected filter?\",\"cancelButton\":\"Cancel\",\"deleteButton\":\"Delete\",\"loadingBar\":\"Deleting Filter...\"},\"unselectedFilter\":{\"placeholder\":\"Additional Criteria\"},\"placeholder\":\"Please Enter\",\"selected\":\"Selected\",\"clearSelected\":\"Clear Selected\",\"removeButtonTooltip\":\"Remove Criterion\",\"clearButton\":\"Clear Criteria\",\"resetFilter\":\"Reset Filter\",\"editedFilter\":\"(Edited)\"},\"action\":{\"downloadCsv\":\"Download CSV\",\"bulkReassign\":\"Bulk Reassign\"},\"status\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Not Clear\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Rejected\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}},\"agentStatus\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Clearance Review\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Incomplete\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}},\"widgetActions\":{\"configureColumns\":\"Configure Columns\",\"resizeColumns\":\"Resize Columns\",\"minimize\":\"Minimize\",\"maximize\":\"Maximize\",\"returnToDefaultSize\":\"Return to Default Size\"},\"submissionGridTitlebarPrompt\":\"Resize Columns by Dragging the Column Dividers\",\"submissionGridTitlebarPromptClose\":\"Done\",\"subStatus\":{\"cancellationPending\":\"Cancellation Pending\"},\"pageSizeLabel\":\"Results per Page\"}");

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

var path = '/submissionGrid.tpl.html';
var html = "<div class=\"submissionGridContainer\"\n     ui-submission-grid-multi-select\n     multi-select-title=\"homePage.widgets.submissionGrid.bulkReassign.headerTitle\"\n     multi-select-cog-menu-label=\"homePage.widgets.submissionGrid.bulkReassign.cogMenuLabel\"\n     multi-select-reassign-callback=\"onReassignSelectionCallback\"\n     multi-select-maximum-batch-size=\"$ctrl.multiSelectMaximumBatchSize\"\n     ng-class=\"{ multiSelect: multiSelectModel.isMultiSelectMode}\">\n\n    <!--Titlebar-->\n    <div class=\"titlebarWidget\">\n        <div class=\"titlebarContainer\">\n            <span class=\"titleLabel\">{{ ::$ctrl.i18n.submissionListWidget.title }}</span>\n            <span class=\"titleSeparator\">{{ ::$ctrl.i18n.submissionListWidget.titleSeparator }}</span>\n            <!--Filter Dropdown-->\n            <um-dropdown class-name=\"submissionFilter\"\n                         class=\"landingTitle submissionFilter\"\n                         is-disabled=\"multiSelectModel.isMultiSelectMode\"\n                         option-list=\"$ctrl.filters\"\n                         required=\"'true'\"\n                         selected-value=\"$ctrl.selectedFilterName\"\n                         status-text=\"$ctrl.getFilterStatus()\"\n                         on-change=\"$ctrl.onFilterChange(selectedOption)\">\n            </um-dropdown>\n\n            <div class=\"btn-group saveButton\"\n                 uib-dropdown\n                 ng-if=\"$ctrl.isFilterEdited() || !$ctrl.isDefaultFilter()\">\n                <button id=\"split-button\"\n                        type=\"button\"\n                        class=\"btn large-button grey saveButton\"\n                        ng-click=\"$ctrl.onSaveFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter() && $ctrl.isFilterEdited()\">\n                    {{ ::$ctrl.i18n.advancedFilter.saveFilterLabel }}\n                </button>\n                <button id=\"split-button-as\"\n                        type=\"button\"\n                        class=\"btn large-button grey saveFilterAsButton saveButton\"\n                        ng-click=\"$ctrl.onSaveFilterAs()\"\n                        ng-if=\"$ctrl.isDefaultFilter() || (!$ctrl.isDefaultFilter() && !$ctrl.isFilterEdited())\">\n                    {{ ::$ctrl.i18n.advancedFilter.saveFilterAsLabel }}\n                </button>\n                <button type=\"button\"\n                        class=\"btn toggleButton grey saveButton\"\n                        uib-dropdown-toggle>\n                    <span class=\"caret\"></span>\n                </button>\n                <ul class=\"dropdown-menu\"\n                    uib-dropdown-menu role=\"menu\">\n                    <li role=\"menuitem\"\n                        ng-click=\"$ctrl.onSaveFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter() && $ctrl.isFilterEdited()\">\n                        <a class=\"saveFilter\">{{ ::$ctrl.i18n.advancedFilter.saveFilterLabel }}</a>\n                    </li>\n                    <li role=\"menuitem\"\n                        ng-click=\"$ctrl.onSaveFilterAs()\">\n                        <a class=\"saveFilterAs\">{{ ::$ctrl.i18n.advancedFilter.saveFilterAsLabel }}</a>\n                    </li>\n                    <li role=\"menuitem\"\n                        ng-click=\"$ctrl.onDeleteFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter()\">\n                        <a class=\"deleteFilter\">{{ ::$ctrl.i18n.advancedFilter.deleteFilterLabel }}</a>\n                    </li>\n                    <li role=\"menuitem\">\n                        <a class=\"resetFilter\"\n                           ng-click=\"$ctrl.resetFilter($event)\"\n                           ng-if=\"$ctrl.isFilterEdited()\">{{ ::$ctrl.i18n.advancedFilter.resetFilter }}</a></li>\n                </ul>\n            </div>\n\n            <!--Search-->\n            <div class=\"submissionFilter gridster-no-drag\"\n                 ng-click=\"$ctrl.onToggleSearch()\"\n                 ng-if=\"$ctrl.hasFilterPermission && $ctrl.filterModel && $ctrl.advancedFilterType\"\n                 uib-tooltip=\"{{ ::$ctrl.i18n.searchIconTooltip }}\"\n                 tooltip-popup-delay=\"500\"\n                 tooltip-append-to-body=\"true\"\n                 tooltip-placement=\"bottom\">\n                <span class=\"glyphicon glyphicon-search toggleButton\"></span>\n            </div>\n\n            <!--Action Buttons-->\n            <div class=\"actionButtonList\">\n\n              <span class=\"titlebarPrompt\" ng-if=\"$ctrl.colResizable\">{{ ::$ctrl.i18n.submissionGridTitlebarPrompt }}</span>\n            <button class=\"btn btn-xs\" ng-click=\"$ctrl.onFinishResize()\" ng-if=\"$ctrl.colResizable\">{{ ::$ctrl.i18n.submissionGridTitlebarPromptClose }}</button>\n\n                <div class=\"btn-group\"\n                     uib-dropdown\n                     dropdown-append-to-body=\"true\">\n\n                    <button type=\"button\"\n                            class=\"btn btn-xs\"\n                            uib-dropdown-toggle\n                            uib-tooltip=\"{{ ::$ctrl.i18n.showOrHideToolsTooltip }}\"\n                            tooltip-popup-delay=\"500\"\n                            tooltip-append-to-body=\"true\"\n                            tooltip-placement=\"bottom\">\n                        <span class=\"glyphicon glyphicon-cog submissionGridToolsCog\"></span>\n                    </button>\n\n                    <ul class=\"dropdown-menu-right\"\n                        uib-dropdown-menu>\n\n                        <!--Download Link-->\n                        <li role=\"menuitem\">\n                            <a uib-dropdown\n                               auto-close=\"outsideClick\"\n                               ng-click='$ctrl.onCsvDownloadClick($event)'>\n                                <span>{{ ::$ctrl.i18n.action.downloadCsv }}</span>\n                            </a>\n                        </li>\n\n                        <!--Configure Column Dropdown Row-->\n                        <li role=\"menuitem\">\n                            <a uib-dropdown\n                               uib-dropdown-toggle\n                               auto-close=\"outsideClick\"\n                               dropdown-append-to-body=\"true\"\n                               is-open=\"isColSelectDropdownOpen\"\n                               on-toggle=\"$ctrl.onColumnConfigDropdownToggle()\"\n                               class=\"submissionGridConfigureColumns\">\n\n                                <span>{{ ::$ctrl.i18n.widgetActions.configureColumns }}</span>\n\n                                <!--Configure Column Dropdown Menu-->\n                                <div class=\"submissionGridColumnDropdownMenu\"\n                                     uib-dropdown-menu>\n                                    <ul>\n                                        <!--Item List-->\n                                        <li class=\"columnFilterRow\"\n                                            ng-class=\"::{ disabled: col.disabled }\"\n                                            ng-repeat=\"col in $ctrl.dropdownColumns\"\n                                            ng-click=\"$ctrl.onColumnCheckboxClick($event, col)\">\n\n                                            <input type=\"checkbox\"\n                                                   class=\"columnCheckbox {{::$ctrl.getColumnClassName(col.displayName)}}\"\n                                                   ng-model=\"col.visible\"\n                                                   ng-change='$ctrl.onColumnCheckboxClick($event, col)'\n                                                   ng-disabled=\"::col.disabled\"/>\n\n                                            <span>{{ col.displayName }}</span>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </a>\n                        </li>\n\n                        <!--\n                        <li role=\"menuitem\"\n                            ng-class=\"submissionGridResizeColumns\">\n                            <a class=\"\" ng-click=\"$ctrl.onStartResize()\">\n                                {{ ::$ctrl.i18n.widgetActions.resizeColumns }}\n                            </a>\n                        </li>\n                        -->\n\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isMinimized() }\">\n                            <a class=\"taskGridMinimize\" ng-click=\"$ctrl.minimize($event)\">\n                                {{ ::$ctrl.i18n.widgetActions.minimize }}\n                            </a>\n                        </li>\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isMaximized() }\">\n                            <a class=\"taskGridMaximize\" ng-click=\"$ctrl.maximize($event)\">\n                                {{ ::$ctrl.i18n.widgetActions.maximize }}\n                            </a>\n                        </li>\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isAtDefaultSize() }\">\n                            <a class=\"taskGridReturnToDefaultSize\" ng-click=\"$ctrl.returnToDefaultSize($event)\">\n                                {{ ::$ctrl.i18n.widgetActions.returnToDefaultSize }}\n                            </a>\n                        </li>\n\n                        <li role=\"menuitem\"\n                            ng-if=\"$ctrl.isMultiSelectEnabled\"\n                            ng-include=\"'/ui/grid/multiSelect/template/multiSelectButton.tpl.html'\"></li>\n\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!--Datagrid-->\n    <div class=\"landing gridWindow\"\n         app-mode-configuration>\n\n        <!--Search Form-->\n        <div class=\"activityStreamSearchForm\"\n             ng-class=\"{ 'is-open': $ctrl.isSearchOpen }\">\n\n            <ui-advanced-filter-list\n                class=\"advancedFilterListWrapper\"\n                ng-if=\"$ctrl.isSearchOpen\"\n                filter-model=\"$ctrl.filterModel\"\n                show-all-templates=\"false\"\n                disable-auto-focus=\"multiSelectModel.isMultiSelectMode\"\n                advanced-filter-type=\"::$ctrl.advancedFilterType\">\n            </ui-advanced-filter-list>\n\n        </div>\n\n        <!--Grid-->\n        <div class=\"content landingContent\"\n             ui-widget-grid-scroll-manager\n             ui-scroll-detection\n             scroll-fixed-grid-arrow>\n\n            <div class=\"multiSelectHeader\"\n                 ng-include=\"'/ui/grid/multiSelect/template/multiSelectHeader.tpl.html'\"></div>\n\n            <!--Grid Header-->\n            <div class=\"columnHeader\">\n                <div class=\"columnRow columnDisposition\">\n\n                    <!--MultiSelect Column-->\n                    <div class=\"column col rowSelector\"\n                         ng-if=\"multiSelectModel.isMultiSelectMode\">\n\n                        <input type=\"checkbox\"\n                               ng-click=\"multiSelectUtil.onToggleSelectAllCheckbox()\"\n                               ng-checked=\"multiSelectUtil.isSelectAllCheckboxSelected()\">\n                    </div>\n\n                    <!-- Custom Columns List-->\n                    <div class=\"column draggableColumn {{::column.__text}} col{{::column.__text}}\"\n                         ng-if=\"::(column._visible==='true')\"\n                         ng-repeat=\"column in $ctrl.colViewModel.columns\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"{{::(column._sort || column._accessor)}}\"\n                         item-label=\"{{::column.__text}}\"\n                         resizable=\"$ctrl.colResizable\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-style=\"{'width': column._width + 'px'}\"\n                         ui-draggable-column\n                        ui-draggable-column-identifier=\"{{ ::column.__text }}\"\n                      ui-draggable-column-is-draggable=\"true\"\n                         >\n                    </div>\n\n                    <div class=\"col scrollBar\"></div>\n                </div>\n            </div>\n\n\n            <div class=\"scrollVerticalContainer\">\n\n                <div class=\"datagrid table\"\n                     ux-datagrid=\"$ctrl.records\"\n                     options=\"{chunks:{size: $ctrl.pageSize}}\"\n                     ng-if=\"!$ctrl.isLoading\">\n\n                    <script type=\"template/html\"\n                            data-template-item=\"item\"\n                            data-template-name=\"default\">\n\n                        <div class=\"rowDrawerWrapper\"\n                             ng-class=\"{ selected: item.selected && $ctrl.isDrawerOpen }\">\n\n                            <div class=\"columnRow\"\n                                 ng-class=\"{ selected: item.selected }\"\n                                 ng-click=\"$ctrl.setSelectedItem($event, item)\">\n\n                                <!--MultiSelect Column-->\n                                <div class=\"col rowSelector\"\n                                     ng-if=\"multiSelectModel.isMultiSelectMode\">\n\n                                    <input type=\"checkbox\"\n                                           ng-checked=\"multiSelectUtil.isRowSelected(item.id)\"/>\n                                </div>\n\n                                <div ng-repeat=\"column in $ctrl.colViewModel.columns\"\n                                     class=\"col {{::column.__text}}\"\n                                     ng-if=\"::(column._visible === 'true')\"\n                                     ng-class=\"{{::$ctrl.getClass(item,column)}}\"\n                                     ng-click=\"$ctrl.openSubmission(item.id)\"\n                                     ng-style=\"{'width': column._width + 'px'}\">\n\n                                    <span uib-tooltip=\"{{$ctrl.getValue(item,column)}}\"\n                                          tooltip-append-to-body=\"true\"\n                                          tooltip-placement=\"top-left\"\n                                          tooltip-popup-delay=\"{{ ::$ctrl.toolTipDelay }}\">\n                                        {{::$ctrl.getValue(item,column)}}</span>\n                                    <span uib-tooltip=\"{{$ctrl.getTranslatedValueKey(item,column)}}\"\n                                          tooltip-append-to-body=\"true\"\n                                          tooltip-placement=\"top-left\"\n                                          tooltip-popup-delay=\"{{ ::$ctrl.toolTipDelay }}\">\n                                        {{::$ctrl.getValueKey(item,column)}}\n                                    </span>\n\n                                    <ui-icon-viewer\n                                        ng-if=\"::(column._accessor==='insured.name')\"\n                                        class=\"iconViewer\"\n                                        item=\"item\"\n                                        user-id=\"$ctrl.userId\"></ui-icon-viewer>\n                                    <span class=\"glyphicon\"\n                                          ng-if=\"::(column._accessor==='priority')\"\n                                          ng-class=\"::{'glyphicon-arrow-down' : item.priority===1,\n                                                        'glyphicon-minus' : item.priority===2,\n                                                        'glyphicon-arrow-up' : item.priority===3\n                                                    }\"></span>\n                                </div>\n\n                            </div>\n\n                            <div class=\"toggleDrawer\"\n                                 ng-click=\"$ctrl.setSelectedItem($event, item)\">\n                                <span class=\"glyphicon glyphicon-chevron-right\"></span>\n                            </div>\n\n                            <submission-details-drawer-directive\n                                item-model=\"item\"\n                                col-view-model=\"$ctrl.colViewModel\"\n                                is-agent=\"$ctrl.isAgent\"></submission-details-drawer-directive>\n\n                        </div>\n\n                    </script>\n                </div>\n\n                <div class=\"gridEmpty\"\n                     ng-if=\"$ctrl.isGridEmpty && !$ctrl.isLoading\">\n                    {{ ::$ctrl.i18n.submissionListWidget.emptyMessage }}\n                </div>\n            </div>\n            <div class=\"icon-spinner\"\n                 ng-if=\"$ctrl.isLoading\"></div>\n        </div>\n\n    </div>\n\n    <ui-grid-paging-component\n        ng-hide=\"$ctrl.totalRecords === 0\"\n        class=\"landingPagination\"\n        start-index=\"$ctrl.requestParams.startIndex\"\n        page-size=\"$ctrl.pageSize\"\n        total-records=\"$ctrl.totalRecords\"\n        record-count-text=\"$ctrl.recordCountText\"\n        records-count-text=\"$ctrl.recordsCountText\"\n        on-change=\"$ctrl.onPagingChange($event, params)\"></ui-grid-paging-component>\n\n    <div class=\"submissionGridPageSize\" ng-if=\"$ctrl.totalRecords !== 0\">\n        <div class=\"submissionGridPageSizeLabel\">{{::$ctrl.i18n.pageSizeLabel}}</div>\n        <div class=\"submissionGridPageSizeDropdownWrapper\">\n            <select\n                ng-model=\"$ctrl.pageSize\"\n                ng-options=\"option for option in $ctrl.pageSizeOptions\"\n                ng-change=\"$ctrl.updatePageSize($ctrl.pageSize)\">\n            </select>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {var locale = __webpack_require__(153);

/*@ngInject*/
var SubmissionDetailsDrawerDirective = function SubmissionDetailsDrawerDirective($rootScope, $timeout, $document, $filter, $state, $window, coreMediator, submissionMediator, dateUtil, gridColumnModel, submissionGridConstant, currencyUtil, appTypeConfigurationModel, preferenceModel, submissionUtil, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm),
      timerDelay = 300,
      timeoutList = [];
    $scope.i18n = locale;
    $scope.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    $scope.itemModel.drawerOpen = false;
    $scope.underwriterImage = null;
    $scope.assignedToImage = null;
    $scope.referredToImage = null;
    $scope.producerImage = null;
    $scope.contactImage = null;
    $scope.underwriterImageLoading = false;
    $scope.assignedToImageLoading = false;
    $scope.referredToImageLoading = false;
    $scope.producerImageLoading = false;
    $scope.contactImageLoading = false;
    $scope.transactionRecords = [];
    function loadUnderwriterImage() {
      if (!$scope.itemModel.responsibleUnderwriterSummary) {
        return;
      }
      $scope.underwriterImageLoading = true;
      coreMediator.loadProfileImage($scope.itemModel.responsibleUnderwriterSummary.id).then(function (underwriterImage) {
        $scope.underwriterImage = underwriterImage;
        $scope.underwriterImageLoading = false;
      });
    }
    function loadAssignedToImage() {
      if (!$scope.itemModel.assignedUnderwriterSummary) {
        return;
      }
      $scope.assignedToImageLoading = true;
      coreMediator.loadProfileImage($scope.itemModel.assignedUnderwriterSummary.id).then(function (assignedToImage) {
        $scope.assignedToImage = assignedToImage;
        $scope.assignedToImageLoading = false;
      });
    }
    function loadReferredToImage() {
      if (!$scope.itemModel.referredUnderwriterSummary) {
        return;
      }
      $scope.referredToImageLoading = true;
      coreMediator.loadProfileImage($scope.itemModel.referredUnderwriterSummary.id).then(function (referredToImage) {
        $scope.referredToImage = referredToImage;
        $scope.referredToImageLoading = false;
      });
    }
    function loadProducerImage() {
      if (!$scope.itemModel.agentSummary) {
        return;
      }
      $scope.producerImageLoading = true;
      coreMediator.loadProfileImage($scope.itemModel.agentSummary.id).then(function (producerImage) {
        $scope.producerImage = producerImage;
        $scope.producerImageLoading = false;
      });
    }
    function loadContactImage() {
      if (!$scope.itemModel.agencyContactSummary) {
        return;
      }
      $scope.contactImageLoading = true;
      coreMediator.loadProfileImage($scope.itemModel.agencyContactSummary.id).then(function (contactImage) {
        $scope.contactImage = contactImage;
        $scope.contactImageLoading = false;
      });
    }
    function displayTransactionGrid() {
      if (!appTypeConfigurationModel.isAgentConsole()) {
        submissionMediator.getSubmissionTransactions($scope.itemModel.id).then(function (records) {
          $scope.transactionRecords = records;
        });
      }
    }
    function scrollDrawerIntoView() {
      var $scrollContainer = element.parents('.scrollVerticalContainer'),
        scrollContainerHeight = $scrollContainer.prop('offsetHeight'),
        scrollContainerPosition = $scrollContainer.prop('scrollTop'),
        currentRowPosition = element.parent().position().top,
        currentRowHeight = 60,
        drawerHeight = 0,
        drawerBottomPosition = 0,
        scrollToValue = 0;
      timeoutList.push($timeout(function () {
        drawerHeight = element.prop('offsetHeight');
        drawerBottomPosition = currentRowPosition + currentRowHeight + drawerHeight;
        drawerColumnsEmpty();
        if (drawerBottomPosition > scrollContainerHeight) {
          scrollToValue = scrollContainerPosition - (scrollContainerHeight - drawerBottomPosition);
          $scrollContainer.animate({
            scrollTop: scrollToValue
          }, 200);
        }
      }, timerDelay));
    }
    function drawerColumnsEmpty() {
      element.find('.drawerCol').each(function (index, item) {
        var $drawerColumn = $(item);
        if ($drawerColumn.children().length > 1) {
          $drawerColumn.css('visibility', 'visible');
          $drawerColumn.show();
        } else {
          $drawerColumn.hide();
        }
      });
    }
    $scope.getCreatedBy = function () {
      return $scope.itemModel.createdBy.name === 'AUTHENTICATION_SERVER' ? 'System' : $scope.itemModel.createdBy.name;
    };
    $scope.$on(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER, function () {
      if ($scope.itemModel.selected) {
        $scope.itemModel.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat($scope.itemModel.totalPremium.currencyCode);
        loadProducerImage();
        loadContactImage();
        loadUnderwriterImage();
        loadAssignedToImage();
        loadReferredToImage();
        displayTransactionGrid();
        $scope.itemModel.drawerOpen = true;
        scrollDrawerIntoView();
      }
    });
    $scope.$on(submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER, function () {
      if ($scope.itemModel.drawerOpen) {
        timeoutList.push($timeout(function () {
          $scope.itemModel.drawerOpen = false;
        }, timerDelay));
      }
    });
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
    $scope.openTransactionItem = function (item, column) {
      submissionMediator.isUserAuthorizedForSubmissionProduct($scope.itemModel.id).then(function () {
        if (column._navigation === 'true') {
          $scope.mouseLeave();
          if (preferenceModel.get('system.submissionHomePageTransactionLinkExternal') === 'true') {
            $window.open(submissionUtil.getSubmissionTransactionExternalLink(item.uri), '_blank');
          } else {
            if (item.uri.indexOf('Quote') !== -1) {
              var quoteId = parseInt(item.uri.split('Quote:')[1]);
              $state.go('submission.quote', {
                submissionId: $scope.itemModel.id,
                quoteId: quoteId
              });
              return;
            } else if (item.uri.indexOf('Policy') !== -1) {
              var policyId = parseInt(item.uri.split('Policy:')[1]);
              $state.go('submission.policy', {
                submissionId: $scope.itemModel.id,
                policyId: policyId
              });
              return;
            }
          }
        }
      });
    };
    $scope.getTransactionClassName = function (item) {
      var className = item.uri.indexOf('Quote') !== -1 ? 'quote' : 'policy';
      return className + _.toLower(item.columns.product);
    };
    $scope.getValue = function (item, column) {
      var props = [],
        value;
      props.push(column._accessor);
      value = item;
      for (var i = 0; i < props.length; i++) {
        if (!_.isNil(value)) {
          value = value.columns[props[i]];
        }
      }
      if (_.isUndefined(value)) {
        value = '-';
      }
      if (column._type && !_.isNil(value) && (column._type.indexOf('shortDate') >= 0 || column._type.indexOf('utcShortDate') >= 0)) {
        var filter = $filter('utcDateFilter');
        value = filter(parseInt(value), $scope.shortDateFormat);
      } else if (column._type && column._type.indexOf('currency') >= 0) {
        var _filter = $filter('currency');
        var currencyFormat = currencyUtil.getCurrencyFormat(value.currencyCode);
        if (parseInt(value.total) > 0) {
          value = _filter(parseInt(value.total), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
        } else {
          value = '-';
        }
      }
      return value;
    };
    $scope.mouseEnter = function (event, item) {
      $scope.isMouseEnterInProgress = true;
      $scope.mouseEnterTimer = $timeout(function () {
        if ($scope.isMouseEnterInProgress) {
          event.columns = item.columns;
          event.uri = item.uri;
          $scope.showTooltip(event);
        }
        $scope.isMouseEnterInProgress = false;
      }, 500);
    };
    $scope.mouseLeave = function () {
      $timeout.cancel($scope.mouseEnterTimer);
      $scope.isMouseEnterInProgress = false;
      $timeout.cancel($scope.mouseLeaveTimer);
      $scope.mouseLeaveTimer = $timeout(function () {
        $rootScope.$broadcast(coreConstant.event.HIDE_TRANSACTION_TOOLTIP_EVENT);
      }, 250);
    };
    $scope.showTooltip = function (event) {
      $rootScope.$broadcast(coreConstant.event.SHOW_TRANSACTION_TOOLTIP_EVENT, event);
    };
    if (!appTypeConfigurationModel.isAgentConsole()) {
      gridColumnModel.setColumnPreference('system.submissionTransactionsHomePageGridColumns');
      $scope.colViewModel = gridColumnModel.getSubmissionTransactionGridColumns();
    }
  };
  return {
    restrict: 'E',
    replace: true,
    scope: {
      itemModel: '<?',
      colViewModel: '<?',
      isAgent: '<?'
    },
    link: linkFunction,
    templateUrl: '/submissionDetailsDrawer/submissionDetailsDrawerDirective.tpl.html'
  };
};
SubmissionDetailsDrawerDirective.$inject = ["$rootScope", "$timeout", "$document", "$filter", "$state", "$window", "coreMediator", "submissionMediator", "dateUtil", "gridColumnModel", "submissionGridConstant", "currencyUtil", "appTypeConfigurationModel", "preferenceModel", "submissionUtil", "coreConstant"];
angular.module('gw-um-submission-grid').directive('submissionDetailsDrawerDirective', SubmissionDetailsDrawerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 153 */
/***/ (function(module) {

module.exports = JSON.parse("{\"createSubmissionButton\":\"Create Submission\",\"myAgencySubmissions\":\"My Agency's Submissions\",\"mySubmissions\":\"My Submissions\",\"myBranch\":\"My Branch\",\"myTasks\":\"My Tasks\",\"viewActiveOnly\":\"View Active Only\",\"searchPlaceholder\":\"search…\",\"defaultTitle\":\"Guidewire UM\",\"agentTitle\":\"UM Agent\",\"underwriterTitle\":\"Underwriting Management\",\"widgets\":{\"submissionGrid\":{\"title\":\"Submission List\"}},\"grid\":{\"title\":\"Submission List\",\"header\":{\"insured\":\"Insured\",\"submission\":\"Submission\",\"effective\":\"Effective\",\"expiration\":\"Expiration\",\"status\":\"Status\",\"statusReason\":\"Status Reason\",\"premium\":\"Premium\",\"nextAction\":\"Next Action\",\"actionDate\":\"Action Date\",\"assignedTo\":\"Assigned To\",\"underwriter\":\"Underwriter\",\"coverage\":\"Product\",\"agency\":\"Agency\",\"receivedDate\":\"Received Date\",\"quoteNeededBy\":\"Needed By\",\"priority\":\"Priority\",\"riskState\":\"Risk State\",\"totalLimit\":\"Total Limit\",\"nameOfObligation\":\"Name of Obligation\",\"quoteNeededByDate\":\"Needed By\",\"taskSummary\":\"Task Summary\",\"assignedBy\":\"Assigned By\",\"taskDescription\":\"Task Description\",\"dueDate\":\"Due Date\",\"resolved\":\"Resolved\",\"createdDate\":\"Created Date\",\"resolvedDate\":\"Resolved Date\"},\"itemCount\":\"Showing startIndex to endIndex of total item\",\"itemsCount\":\"Showing startIndex to endIndex of total items\",\"submissionCount\":\"Showing startIndex to endIndex of total Submission\",\"submissionsCount\":\"Showing startIndex to endIndex of total Submissions\",\"taskCount\":\"Showing startIndex to endIndex of total Task\",\"tasksCount\":\"Showing startIndex to endIndex of total Tasks\",\"emptyMessage\":\"No matching submissions.\",\"emptyTaskMessage\":\"No matching tasks.\",\"details\":{\"submissionDetails\":{\"title\":\"New Submission\",\"submissionNumber\":\"Submission Number:\",\"policyNumber\":\"Policy Number:\",\"accountName\":\"Account:\",\"account\":\"Account#:\",\"location\":\"Location:\",\"effective\":\"Effective:\",\"expiration\":\"Expiration:\",\"renewal\":\"Renewal On:\",\"priority\":\"Priority:\",\"product\":\"Product:\",\"insuredName\":\"Insured Name:\",\"status\":\"Status:\",\"received\":\"Received:\",\"products\":\"Products:\",\"effectiveDate\":\"Effective Date:\"},\"workflowDetails\":{\"title\":\"Workflow\",\"status\":\"Status:\",\"statusReason\":\"Status Reason:\",\"statusDetails\":\"Status Details:\",\"nextAction\":\"Next Action:\",\"dueOn\":\"Due On:\",\"premium\":\"Premium:\",\"lastModified\":\"Last Modified:\"},\"carrierTeamDetails\":{\"title\":\"Carrier Team\",\"carrierBranch\":\"Carrier Branch:\",\"underwriter\":\"Underwriter:\",\"assignedTo\":\"Assigned To:\",\"referredTo\":\"Referred to Underwriter:\"},\"agencyTeamDetails\":{\"title\":\"Agency Team\",\"agency\":\"Agency/Brokerage:\",\"producer\":\"Producer:\",\"agencyContact\":\"Agency Contact:\"},\"transactionDetails\":{\"title\":\"Quotes & Policies\"},\"taskDetails\":{\"title\":\"Task Details\",\"priority\":\"Priority:\",\"dueDate\":\"Due Date:\",\"taskDescription\":\"Task Description:\",\"assignedTo\":\"Assigned To:\"},\"taskResolution\":{\"title\":\"Task Resolution\",\"comments\":\"Comments:\",\"resolved\":\"Resolved:\",\"resolvedBy\":\"Resolved By:\",\"resolutionDate\":\"Resolution Date:\"},\"taskHistory\":{\"title\":\"Task History\",\"assignedBy\":\"Assigned By:\",\"assignedDate\":\"Assigned Date:\"}}},\"status\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Not Clear\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Rejected\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}},\"agentStatus\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Clearance Review\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Incomplete\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}}}");

/***/ }),
/* 154 */
/***/ (function(module, exports) {

var path = '/submissionDetailsDrawer/submissionDetailsDrawerDirective.tpl.html';
var html = "<div class=\"drawer\">\n\n\n    <div class=\"drawerRow\" ng-if=\"itemModel.drawerOpen\">\n\n\n        <div class=\"detailDrawerCol\"\n             ng-class=\"{drawerColWithGrid : transactionRecords.length > 0 }\">\n            <h5 class=\"detailTitle\">{{ i18n.grid.details.submissionDetails.title}}</h5>\n            <div class=\"detailItem\"\n                 ng-if=\"!colViewModel.colSubmissionNumber && !itemModel.policyNumber && itemModel.submissionNumber\">\n                <label>{{ i18n.grid.details.submissionDetails.submissionNumber }}</label>\n                <span class=\"detailValue\">{{ itemModel.submissionNumber }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"!colViewModel.colSubmissionNumber && itemModel.policyNumber\">\n                <label>{{ i18n.grid.details.submissionDetails.policyNumber }}</label>\n                <span class=\"detailValue\">{{ itemModel.policyNumber }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.accountName && !colViewModel.colAccountName\">\n                <label>{{ i18n.grid.details.submissionDetails.accountName }}</label>\n                <span class=\"detailValue\">{{ itemModel.accountName }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.accountNumber\">\n                <label>{{ i18n.grid.details.submissionDetails.account }}</label>\n                <span class=\"detailValue\">{{ itemModel.accountNumber }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.largestInsuredLocation\">\n                <label>{{ i18n.grid.details.submissionDetails.location }}</label>\n                <span class=\"detailValue\">{{ itemModel.largestInsuredLocation }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.expirationDate && !colViewModel.colExpirationDate\">\n                <label>{{ i18n.grid.details.submissionDetails.expiration }}</label>\n                <span class=\"detailValue\">{{ itemModel.expirationDate | utcDateFilter: shortDateFormat }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.transactionType && itemModel.expiringPolicyNumber\">\n                <label>{{ i18n.grid.details.submissionDetails.renewal }}</label>\n                <span class=\"detailValue\">{{ itemModel.expiringPolicyNumber }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.productShortNames && !colViewModel.colCoverage\">\n                <label>{{ i18n.grid.details.submissionDetails.product }}</label>\n                <span class=\"detailValue\">{{ itemModel.productShortNames }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.effectiveDate && !colViewModel.colEffectiveDate\">\n                <label>{{ i18n.grid.details.submissionDetails.effective }}</label>\n                <span class=\"detailValue\">{{ itemModel.effectiveDate | utcDateFilter: shortDateFormat }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.receivedDate && !colViewModel.colReceivedDate\">\n                <label class=\"receivedDateLabel\">{{ i18n.grid.details.submissionDetails.received }}</label>\n                <span class=\"detailValue\">{{ itemModel.receivedDate | utcDateFilter: shortDateFormat + ' hh:mm A' : true}}</span>\n            </div>\n        </div>\n\n\n        <div class=\"detailDrawerCol\"\n             ng-class=\"{drawerColWithGrid : transactionRecords.length > 0 }\">\n            <h5 class=\"detailTitle\">{{ i18n.grid.details.workflowDetails.title }}</h5>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.status && !colViewModel.colStatus\">\n                <label>{{ i18n.grid.details.workflowDetails.status }}</label>\n                <span class=\"detailValue\">{{ i18n.status[itemModel.status] }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"!isAgent && itemModel.statusReason && !colViewModel.colStatusReason\">\n                <label>{{ i18n .grid.details.workflowDetails.statusReason}}</label>\n                <span class=\"detailValue\">{{ itemModel.statusReason }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"!isAgent && itemModel.statusDetail\">\n                <label>{{ i18n .grid.details.workflowDetails.statusDetails}}</label>\n                <span class=\"detailValue\">{{ itemModel.statusDetail }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.nextTaskSummary.definition && !colViewModel.colNextAction\">\n                <label>{{ i18n.grid.details.workflowDetails.nextAction }}</label>\n                <span class=\"detailValue\">{{ itemModel.nextTaskSummary.definition }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.nextTaskSummary.dueDate && !colViewModel.colActionDate\">\n                <label>{{ i18n.grid.details.workflowDetails.dueOn }}</label>\n                <span class=\"detailValue\">{{ itemModel.nextTaskSummary.dueDate | utcDateFilter: shortDateFormat }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"!isAgent && itemModel.priority && !colViewModel.colPriority\">\n                <label>{{ i18n.grid.details.submissionDetails.priority }}</label>\n                <span class=\"detailValue\">\n                    <span class=\"glyphicon\"\n                          ng-class=\"{'glyphicon-arrow-down' : itemModel.priority===1,\n                            'glyphicon-minus' : itemModel.priority===2,\n                            'glyphicon-arrow-up' : itemModel.priority===3,\n                            'iconLowPriority' : itemModel.priority===1,\n                            'iconMediumPriority' : itemModel.priority===2,\n                            'iconHighPriority' : itemModel.priority===3\n                        }\"></span>\n                </span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.totalPremium.total && !colViewModel.colPremium\">\n                <label>{{ i18n.grid.details.workflowDetails.premium }}</label>\n                <span class=\"detailValue\">{{ itemModel.totalPremium.total | currency:itemModel.totalPremium.currencyFormat.symbol:0:itemModel.totalPremium.currencyFormat.suffixSymbol:itemModel.totalPremium.currencyFormat.customFormat }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.timeLastModified\">\n                <label class=\"lastModifiedDateLabel\">{{ i18n.grid.details.workflowDetails.lastModified }}</label>\n                <span class=\"detailValue\">{{ itemModel.timeLastModified | utcDateFilter: shortDateFormat + ' hh:mm A' : true}}</span>\n            </div>\n        </div>\n\n        <div class=\"detailDrawerCol\"\n             ng-class=\"{drawerColWithGrid : transactionRecords.length > 0 }\">\n            <h5 class=\"detailTitle\">{{ i18n.grid.details.carrierTeamDetails.title }}</h5>\n            <div class=\"detailItem carrierBranch\"\n                 ng-if=\"itemModel.carrierBranch.name\">\n                <label class=\"carrierBranchLabel\">{{ i18n.grid.details.carrierTeamDetails.carrierBranch }}</label>\n                <ui-user-avatar\n                    submissionid = \"{{itemModel.id}}\"\n                    organization-id=\"{{::itemModel.carrierBranch.id}}\"></ui-user-avatar>\n                <span class=\"detailValue carrierBranchValue\">{{ itemModel.carrierBranch.name }}</span>\n            </div>\n            <div class=\"detailItem underwriter\"\n                 ng-if=\"itemModel.responsibleUnderwriterSummary.name && !colViewModel.colUnderwriter\">\n                <label class=\"userLabel\">{{ i18n.grid.details.carrierTeamDetails.underwriter }}</label>\n                <ui-user-avatar\n                    submissionid = \"{{itemModel.id}}\"\n                    ng-src=\"{{ underwriterImage }}\"\n                    userid=\"{{::itemModel.responsibleUnderwriterSummary.id}}\"\n                    is-loading=\"underwriterImageLoading\"></ui-user-avatar>\n                <span class=\"detailValue\">{{ itemModel.responsibleUnderwriterSummary.name }}</span>\n            </div>\n            <div class=\"detailItem assignedTo\"\n                 ng-if=\"itemModel.assignedUnderwriterSummary.name && !colViewModel.colAssignedTo\">\n                <label class=\"userLabel\">{{ i18n.grid.details.carrierTeamDetails.assignedTo }}</label>\n                <ui-user-avatar\n                    submissionid = \"{{itemModel.id}}\"\n                    ng-src=\"{{ assignedToImage }}\"\n                    userid=\"{{::itemModel.assignedUnderwriterSummary.id}}\"\n                    is-loading=\"assignedToImageLoading\"></ui-user-avatar>\n                <span class=\"detailValue\">{{ itemModel.assignedUnderwriterSummary.name }}</span>\n            </div>\n            <div class=\"detailItem referredTo\"\n                 ng-if=\"!isAgent && itemModel.referredUnderwriterSummary.name\">\n                <label class=\"userLabel\">{{ i18n.grid.details.carrierTeamDetails.referredTo }}</label>\n                <ui-user-avatar\n                    submissionid = \"{{itemModel.id}}\"\n                    ng-src=\"{{ referredToImage }}\"\n                    userid=\"{{::itemModel.referredUnderwriterSummary.id}}\"\n                    is-loading=\"referredToImageLoading\"></ui-user-avatar>\n                <span class=\"detailValue\">{{ itemModel.referredUnderwriterSummary.name }}</span>\n            </div>\n        </div>\n\n\n        <div class=\"detailDrawerCol\"\n             ng-class=\"{drawerColWithGrid : transactionRecords.length > 0 }\">\n            <h5 class=\"detailTitle\">{{ i18n.grid.details.agencyTeamDetails.title }}</h5>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.agencyName && !colViewModel.colAgency\">\n                <label class=\"agencyNameLabel\"> {{ i18n.grid.details.agencyTeamDetails.agency }}</label>\n                <ui-user-avatar\n                    submissionid = \"{{itemModel.id}}\"\n                    organization-id=\"{{::itemModel.agencyId}}\"></ui-user-avatar>\n                <span class=\"detailValue agencyNameValue\">{{ itemModel.agencyName }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.agentSummary.name\">\n                <label class=\"userLabel\">{{ i18n.grid.details.agencyTeamDetails.producer }}</label>\n                <ui-user-avatar\n                    submissionid = \"{{itemModel.id}}\"\n                    ng-src=\"{{ producerImage }}\"\n                    userid=\"{{::itemModel.agentSummary.id}}\"\n                    is-loading=\"producerImageLoading\"></ui-user-avatar>\n                <span class=\"detailValue\">{{ itemModel.agentSummary.name }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.agencyContactSummary.name\">\n                <label class=\"userLabel\">{{ i18n.grid.details.agencyTeamDetails.agencyContact }}</label>\n                <ui-user-avatar\n                    submissionid = \"{{itemModel.id}}\"\n                    ng-src=\"{{ contactImage }}\"\n                    userid=\"{{::itemModel.agencyContactSummary.id}}\"\n                    is-loading=\"contactImageLoading\"></ui-user-avatar>\n                <span class=\"detailValue\">{{ itemModel.agencyContactSummary.name }}</span>\n            </div>\n        </div>\n\n        <div class=\"detailDrawerCol grid\" ng-if=\"transactionRecords.length > 0\">\n            <h5 class=\"detailTitle transactionTitle\"\n                ng-if=\"transactionRecords.length > 0\">{{::i18n.grid.details.transactionDetails.title }}({{transactionRecords.length}})</h5>\n            <div class=\"transactionGrid\"\n                 ng-if=\"transactionRecords.length > 0\">\n                <div class=\"gridBox\" ng-repeat=\"item in transactionRecords\">\n                    <div class=\"transactionRow {{getTransactionClassName(item)}}\"\n                         ng-mouseenter=\"mouseEnter($event, item)\"\n                         ng-mouseleave=\"mouseLeave()\">\n                        <div ng-repeat=\"column in colViewModel.columns\"\n                             class=\"col {{::column.__text}}\"\n                             ng-if=\"::(column._visible === 'true')\">\n                        <span ng-class=\"{'btn-link': column._navigation === 'true'}\"\n                              ng-click=\"openTransactionItem(item, column)\">\n                            {{getValue(item,column)}}\n                        </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var ScrollFixedGridArrowDirective = function ScrollFixedGridArrowDirective($window, $timeout, submissionGridConstant) {
  var linkFunction = function linkFunction($scope, $elm) {
    var element = $($elm),
      gridWindow = element.parent(),
      toggleArrowOffset = 59,
      timerDelay = 1000,
      timeoutList = [];
    $scope.getWindowWidth = function () {
      return {
        'width': gridWindow.width()
      };
    };
    $scope.$watch($scope.getWindowWidth, function (newValue) {
      $scope.windowWidth = newValue.width;
      element.trigger('scroll');
    }, true);
    element.on('scroll', function () {
      var elementPositionX = $scope.windowWidth + element.scrollLeft() - toggleArrowOffset;
      element.find('.toggleDrawer').css('left', elementPositionX);
    });
    $scope.$on(submissionGridConstant.event.SUBMISSIONS_LOADED, function () {
      timeoutList.push($timeout(function () {
        element.trigger('scroll');
      }, timerDelay));
    });
    $scope.$on('$destroy', function () {
      element.off('scroll');
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
ScrollFixedGridArrowDirective.$inject = ["$window", "$timeout", "submissionGridConstant"];
angular.module('gw-um-submission-grid').directive('scrollFixedGridArrow', ScrollFixedGridArrowDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(77);
__webpack_require__(157);
var locale = __webpack_require__(158);

/*@ngInject*/
var UITransactionGridTooltipDirective = function UITransactionGridTooltipDirective($window, $document, $rootScope, $timeout, $state, $filter, coreMediator, coreConstant, gridColumnModel, currencyUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.i18n = locale;
    $scope.mayCloseTooltip = true;
    $scope.xPos = -9999;
    $scope.yPos = -9999;
    $scope.tooltipWidth = 250;
    $scope.timeoutList = [];
    $scope.$on(coreConstant.event.SHOW_TRANSACTION_TOOLTIP_EVENT, function (event, showTransactionTooltipEvent) {
      gridColumnModel.setColumnPreference('system.submissionTransactionsHomePageGridColumns');
      $scope.colViewModel = gridColumnModel.getSubmissionTransactionGridColumns();
      $scope.rows = showTransactionTooltipEvent.columns;
      $scope.uri = showTransactionTooltipEvent.uri;
      var xPos = showTransactionTooltipEvent.pageX - showTransactionTooltipEvent.offsetX;
      var yPos = showTransactionTooltipEvent.pageY - showTransactionTooltipEvent.offsetY;
      showTransactionTooltipContinue(showTransactionTooltipEvent, xPos, yPos);
    });
    $scope.$on(coreConstant.event.HIDE_TRANSACTION_TOOLTIP_EVENT, function () {
      $scope.showTransactionTooltip = false;
      $scope.xPos = -9999;
      $scope.yPos = -9999;
    });
    $scope.$on('$destroy', function () {
      _.each($scope.timeoutList, function (item) {
        if (item) {
          $timeout.cancel(item);
        }
      });
    });
    $scope.getTranslatedValueKey = function (item, column) {
      if (column.__text === 'summary') {
        if ($scope.uri.indexOf('Quote') !== -1) {
          return _.get($scope.i18n.grid.summary, 'quote');
        } else if ($scope.uri.indexOf('Policy')) {
          return _.get($scope.i18n.grid.summary, 'policy');
        }
        return _.get($scope.i18n.grid, column.__text);
      } else {
        return _.get($scope.i18n.grid, column.__text);
      }
    };
    $scope.getValue = function (item, column) {
      var props = [],
        value;
      props.push(column._accessor);
      value = item;
      _.each(props, function (prop) {
        if (!_.isNil(value)) {
          value = value[prop];
        }
      });
      if (_.isUndefined(value)) {
        value = '-';
      }
      if (column._type && !_.isNil(value) && (column._type.indexOf('shortDate') >= 0 || column._type.indexOf('utcShortDate') >= 0)) {
        var filter = $filter('utcDateFilter');
        value = filter(parseInt(value), $scope.shortDateFormat);
      } else if (column._type && column._type.indexOf('currency') >= 0) {
        var _filter = $filter('currency');
        var currencyFormat = currencyUtil.getCurrencyFormat(value.currencyCode);
        if (parseInt(value.total) > 0) {
          value = _filter(parseInt(value.total), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
        } else {
          value = '-';
        }
      }
      return value;
    };
    function showTransactionTooltipContinue(event, xPos, yPos) {
      $scope.showTransactionTooltip = true;
      $scope.xPos = xPos;
      $scope.yPos = yPos;

      // transaction tooltip with right arrow
      $scope.direction = $scope.RIGHT_ARROW;
      $scope.xPos -= $scope.tooltipWidth + 15;
      $scope.yPos -= 15;
      $scope.locationStyle = {
        'left': $scope.xPos,
        'top': $scope.yPos
      };
    }
  };
  return {
    restrict: 'AE',
    link: linkFunction,
    templateUrl: '/submissionDetailsDrawer/transactionGridTooltip/transactionGridTooltip.tpl.html'
  };
};
UITransactionGridTooltipDirective.$inject = ["$window", "$document", "$rootScope", "$timeout", "$state", "$filter", "coreMediator", "coreConstant", "gridColumnModel", "currencyUtil"];
angular.module('gw-um-submission-grid').directive('uiTransactionGridTooltip', UITransactionGridTooltipDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 158 */
/***/ (function(module) {

module.exports = JSON.parse("{\"grid\":{\"proposal\":\"Proposal\",\"summary\":{\"quote\":\"Quote\",\"policy\":\"Policy\"},\"product\":\"Product\",\"status\":\"Status\",\"premium\":\"Premium\"}}");

/***/ }),
/* 159 */
/***/ (function(module, exports) {

/*@ngInject*/
var loadSubmissionsRepository = function loadSubmissionsRepository(baseRepository, $q) {
  angular.extend(this, baseRepository);
  var translationTable = {
    insuredName: 'insured.name',
    number: 'submissionNumber',
    premium: 'totalPremium.total',
    nextAction: 'nextTask.definition'
  };
  this.loadSubmissions = function (submissionParams) {
    var url = '/rest/Submission/filter',
      sortColumn = translationTable[submissionParams.key] || submissionParams.key,
      config = {
        params: {
          filterUri: submissionParams.filterUri,
          resultType: 'grid',
          startIndex: submissionParams.startIndex,
          numberOfRows: submissionParams.pageSize,
          sortBy: "".concat(sortColumn, " ").concat(submissionParams.sortType)
        }
      };
    this.lastLoadSubmissionsConfig = config;
    if (sortColumn === 'submissionNumber') {
      config.params.sortBy = "policyNumber ".concat(submissionParams.sortType, ", submissionNumber ").concat(submissionParams.sortType);
    }
    return $q(function (resolve, reject) {
      this.get(url, config).then(function sucess(r) {
        if (this.lastLoadSubmissionsConfig == config) resolve(r);
      }.bind(this), function error(e) {
        reject(e);
      });
    }.bind(this));
  }.bind(this);
};
loadSubmissionsRepository.$inject = ["baseRepository", "$q"];
angular.module('gw-um-submission-grid').service('loadSubmissionsRepository', loadSubmissionsRepository);

/***/ }),
/* 160 */
/***/ (function(module, exports) {

var path = '/rangeModal/rangeModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"okButton\"\n    cancel=\"cancelButton\"\n    class=\"rangeModal\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    confirm-button-url=\"viewModel.downloadUrl\">\n\n    <div class=\"headerContainer\">\n        <label class=\"descriptionColumn\" ui-translate>{{::description}}</label>\n    </div>\n\n    <div class=\"inputs\">\n      <div>\n          <input ng-model=\"viewModel.start\" name=\"start\" type=\"number\"\n              class=\"start\" value=\"\" placeholder=\"{{::minPlaceHolder}}\" min=\"1\" ng-blur=\"onBlur()\">\n          to\n          <input ng-model=\"viewModel.end\" name=\"end\" type=\"number\"\n              class=\"end\" value=\"\" placeholder=\"{{::maxPlaceHolder}}\" min=\"1\" ng-blur=\"onBlur()\">\n          <span ng-show=\"errorText\">{{errorText}}</span>\n      <div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RangeModalController = function RangeModalController($rootScope, $scope, $uibModalInstance, $window, coreConstant, options, coreMediator, currentUserModel, localization, loadingBarHandler) {
  localization.getTranslations().then(function (translations) {
    $scope.title = _.get(translations, 'rangeModal.title');
    $scope.description = options.description !== null ? options.description : _.get(translations, 'rangeModal.description');
    if (options.batch) {
      $scope.description = _.replace($scope.description, '${batch}', options.batch);
    }
    $scope.cancelButton = _.get(translations, 'rangeModal.cancelButton');
    $scope.okButton = _.get(translations, 'rangeModal.okButton');
    $scope.minPlaceHolder = _.get(translations, 'rangeModal.minPlaceHolder');
    $scope.maxPlaceHolder = _.get(translations, 'rangeModal.maxPlaceHolder');
    $scope.viewModel = {
      start: options.min ? options.min : 1,
      end: options.batch ? Math.min(options.max, options.batch) : options.max
    };
    $scope.onBlur = function () {
      if ($scope.viewModel.start && $scope.viewModel.start < options.min) {
        $scope.viewModel.start = options.min;
      }
      if ($scope.viewModel.start && $scope.viewModel.start > options.max) {
        $scope.viewModel.start = options.max;
      }
      if ($scope.viewModel.end && $scope.viewModel.end < options.min) {
        $scope.viewModel.end = options.min;
      }
      if ($scope.viewModel.end < $scope.viewModel.start) {
        $scope.viewModel.end = $scope.viewModel.start + options.batch;
      }
      if ($scope.viewModel.end && $scope.viewModel.end > options.max) {
        $scope.viewModel.end = options.max;
      }
      if (options.batch && $scope.viewModel.end - $scope.viewModel.start + 1 > options.batch) {
        $scope.viewModel.end = $scope.viewModel.start + options.batch - 1;
      }
    };
    $scope.onConfirm = function () {
      options.urlFunction($scope.viewModel).then(function (url) {
        $window.open(url, '_blank');
      });
      $uibModalInstance.close($scope.viewModel);
    };
    $scope.onCancel = function () {
      $uibModalInstance.close();
    };
    $scope.canEnableConfirmButton = function () {
      return !_.isNil($scope.viewModel.start) && !_.isNil($scope.viewModel.end);
    };
    $scope.init();
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
RangeModalController.$inject = ["$rootScope", "$scope", "$uibModalInstance", "$window", "coreConstant", "options", "coreMediator", "currentUserModel", "localization", "loadingBarHandler"];
angular.module('gw-um-submission-grid').controller('rangeModalController', RangeModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(108);
__webpack_require__(140);
__webpack_require__(141);
__webpack_require__(65);
__webpack_require__(66);
__webpack_require__(767);
__webpack_require__(78);
__webpack_require__(768);
var emailEditorModule = __webpack_require__(163);

/*@ngInject*/
angular.module('gw-um-submission', ['ngSanitize', 'ngIdle', 'ui.router', 'ui.bootstrap', 'ui.select', 'relativeDate', 'currencyFilter', 'isoCurrency', 'summernote', 'dibari.angular-ellipsis', 'umCore', 'ux', 'as.sortable', 'umConfig', 'gw-um-header', emailEditorModule]).config(["$stateProvider", "moduleConfigConstant", function ($stateProvider, moduleConfigConstant) {
  _.each(moduleConfigConstant.submission.routes, function (state, stateName) {
    $stateProvider.state(stateName, state);
  });
}]).run(["$rootScope", "moduleConfigConstant", function ($rootScope, moduleConfigConstant) {
  $rootScope.config = moduleConfigConstant.submission;
}]);
__webpack_require__(164);
__webpack_require__(165);
__webpack_require__(166);
__webpack_require__(167);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(80);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(228);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(252);
__webpack_require__(253);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(290);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(563);
module.exports = 'gw-um-submission';
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var emailTemplateModalLocale = __webpack_require__(79);

/*@ngInject*/
var SubmissionController = function SubmissionController($q, $scope, $rootScope, $state, $stateParams, $location, coreMediator, submissionConstant, submissionMediator, submissionStatus, accountMediator, submissionStateMediator, loadingBarHandler, alertHandler, preferenceModel, currentSubmissionModel, coreConstant, formViewerConstant, localization, modalUtil) {
  var translations;
  localization.getTranslations().then(function (result) {
    translations = result;
  });
  $scope.emailTemplateModalI18n = emailTemplateModalLocale;
  $scope.submissionViewModel = {
    showLongRequestWarning: true,
    hasSubmissionLoaded: false,
    isDrawerOpen: submissionStateMediator.getSubmissionDrawerState($stateParams.submissionId),
    environment: '',
    printPreview: $stateParams.print,
    isPrintingCollab: $state.current.name === 'submission.printCollaboration',
    isViewContentInitialized: false
  };
  $scope.upgradeProcessComplete = false;
  $scope.$on(submissionConstant.event.REDIRECT_TO_OVERVIEW, function (event, refreshFormId) {
    var params = {
      submissionId: $stateParams.submissionId
    };
    if (refreshFormId) {
      _.assignIn(params, {
        formId: null
      });
    }
    $state.go('submission.default', params, {
      reload: true
    });
  });
  $scope.$on(submissionConstant.event.RELOAD_SUBMISSION, function (event, submissionId) {
    if ($stateParams.submissionId === submissionId) {
      $state.go($state.current.name, $state.params, {
        reload: true
      });
    }
  });
  $scope.$on(submissionConstant.event.SHOW_LOADING_BAR, function (event, message, submissionId) {
    if ($stateParams.submissionId === submissionId) {
      loadingBarHandler.showLoadingBar(message);
    }
  });
  $scope.$on(submissionConstant.event.HIDE_LOADING_BAR, function (event, submissionId) {
    if ($stateParams.submissionId === submissionId) {
      loadingBarHandler.hideLoadingBar();
    }
  });
  $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_START, function () {
    $scope.submissionViewModel.showFormRenderingSpinner = true;
  });
  $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_END, function () {
    $scope.submissionViewModel.showFormRenderingSpinner = false;
  });
  $scope.isFormViewerPresent = function () {
    return $state.current.name === 'submission.form';
  };
  $scope.closeDrawer = function () {
    $scope.submissionViewModel.isDrawerOpen = false;
    submissionStateMediator.saveSubmissionDrawerState($stateParams.submissionId, $scope.submissionViewModel.isDrawerOpen);
  };
  $scope.onToggleDrawer = function () {
    $scope.submissionViewModel.isDrawerOpen = !$scope.submissionViewModel.isDrawerOpen;
    submissionStateMediator.saveSubmissionDrawerState($stateParams.submissionId, $scope.submissionViewModel.isDrawerOpen);
  };
  $scope.$on(coreConstant.event.SHOW_LONG_REQUEST_WARNING, function () {
    $scope.submissionViewModel.showLongRequestWarning = true;
  });
  $scope.$on(coreConstant.event.HIDE_LONG_REQUEST_WARNING, function () {
    $scope.submissionViewModel.showLongRequestWarning = false;
  });
  function handleStateChangeStart(toState, toParams) {
    var printPreview = toParams.print;
    var isSubmissionState = !_.isEmpty(toParams.submissionId),
      isSubmissionForm = toState.name === 'submission.form',
      isSubmissionDocument = toState.name === 'submission.document' && toParams.attachmentId > 0,
      isSubmissionFormSummaryGrid = toState.name === 'submission.formSummaryGridDetail' && _.parseInt(toParams.formSummaryInstanceId) > 0 && _.parseInt(toParams.ownerUriId) > 0;
    if (isSubmissionState) {
      // Make sure we have a valid submissionId, and only save Submission state for overview, forms and document viewers.
      if (isSubmissionForm || isSubmissionDocument || isSubmissionFormSummaryGrid) {
        submissionStateMediator.saveSubmissionStateUrl(toParams.submissionId, toState.name, toParams);
      }
      if (!isSubmissionForm) {
        $scope.submissionViewModel.isViewContentInitialized = true;
      }
      if (toState.name === 'submission.print') {
        printPreview = true;
      }
      $scope.submissionViewModel.printPreview = printPreview;
    } else {
      submissionMediator.clearCurrentSubmissionRegistrations();
    }
  }
  function loadSubmission() {
    function upgradeSubmissionAndAccountForms(submission) {
      var defer = $q.defer();
      submissionMediator.formNeedsUpgrade($stateParams.submissionId).then(function (submissionFormNeedsUpgrade) {
        accountMediator.formNeedsUpgrade(submission.accountId).then(function (accountFormNeedsUpgrade) {
          var promiseList = [],
            upgradedFormsCount = 0;
          if (submissionFormNeedsUpgrade || accountFormNeedsUpgrade) {
            loadingBarHandler.showLoadingBar('submission.upgradingForms');
            if (submissionFormNeedsUpgrade) {
              promiseList.push(submissionMediator.upgradeForms($stateParams.submissionId).then(function (numberOfFormsUpgraded) {
                if (numberOfFormsUpgraded > 0) {
                  upgradedFormsCount += numberOfFormsUpgraded;
                }
              }));
            }
            if (accountFormNeedsUpgrade) {
              promiseList.push(accountMediator.upgradeForms(submission.accountId).then(function (numberOfFormsUpgraded) {
                if (numberOfFormsUpgraded > 0) {
                  upgradedFormsCount += numberOfFormsUpgraded;
                }
              }));
            }
            $q.all(promiseList).then(function () {
              if (upgradedFormsCount > 0) {
                var upgradeNotificationContext = {
                  formsCount: upgradedFormsCount,
                  formsText: upgradedFormsCount === 1 ? _.get(translations, 'formsViewer.formUpgrade.singularMessage') : _.get(translations, 'formsViewer.formUpgrade.pluralMessage')
                };
                coreMediator.getNotificationPopupTemplate('notification.upgradeForms', upgradeNotificationContext).then(function (notificationPreference) {
                  loadingBarHandler.hideLoadingBar();
                  $scope.upgradeProcessComplete = true;
                  alertHandler.showAlert(notificationPreference);
                  defer.resolve();
                });
              } else {
                loadingBarHandler.hideLoadingBar();
                $scope.upgradeProcessComplete = true;
                defer.resolve();
              }
            });
          } else {
            $scope.upgradeProcessComplete = true;
            defer.resolve();
          }
        });
      });
      return defer.promise;
    }
    function synchronizeAccount(submission) {
      if (!_.isNil(submission.accountNumber) && submission.status >= submissionStatus.SUBMITTED) {
        accountMediator.synchronizeAccount(submission.accountId);
      }
    }
    submissionMediator.clearCurrentSubmissionRegistrations().finally(function () {
      submissionMediator.loadSubmission($stateParams.submissionId).then(function (submission) {
        upgradeSubmissionAndAccountForms(submission).then(function () {
          synchronizeAccount(submission);
          submissionMediator.setCurrentSubmission(submission);
          submissionMediator.setSubmissionOpenHistory(submission.id);
          $scope.submissionViewModel.hasSubmissionLoaded = true;
        });
      });
    });
  }
  $scope.$on(submissionConstant.event.TOGGLE_NAVIGATION_MENU, $scope.onToggleDrawer);
  $scope.$on('$stateChangeStart', function (event, toState, toParams) {
    handleStateChangeStart(toState, toParams);
    $scope.submissionViewModel.isPrintingCollab = toState.name === 'submission.printCollaboration';
    if (!$scope.isLargeScreen) {
      $scope.closeDrawer();
    }
    if (currentSubmissionModel.doCreateDraftEmail) {
      $rootScope.$broadcast(coreConstant.event.HANDLE_EMAIL_FROM_BUSINESS_CARD, $stateParams.submissionId, parseInt(currentSubmissionModel.sendMailUserId));
      /*
       * UMS-26310
       * Use the chatMessageId, emailMessageId, or notificationId property
       * as a query parameter in the "POST /Email/SendNotification" request.
       * This is step 2b of 6.
       * The next step is in the EmailResource.sendEmailNotification method.
       * The previous step is in the function handling SHOW_USER_BUSINESS_CARD below.
       */
      var options = undefined;
      if ($scope.chatMessageId) {
        options = {
          variables: {
            chatMessageId: $scope.chatMessageId
          }
        };
      } else if ($scope.emailMessageId) {
        options = {
          variables: {
            emailMessageId: $scope.emailMessageId
          }
        };
      } else if ($scope.notificationId) {
        options = {
          variables: {
            notificationId: $scope.notificationId
          }
        };
      }
      coreMediator.sendEmailNotification('notification.sendEmailFromEmailCollaborationTool', /*isCustom=*/true, $stateParams.submissionId, options);
      currentSubmissionModel.doCreateDraftEmail = false;
      currentSubmissionModel.sendMailUserId = null;
    }
  });
  $scope.$on(formViewerConstant.INITIAL_RENDERING_COMPLETE, function () {
    $scope.submissionViewModel.isViewContentInitialized = true;
  });
  $scope.$on(coreConstant.event.SHOW_CUSTOM_ALERT_MODAL_NOTIFICATION, function (event, options) {
    var currentSubmission = currentSubmissionModel.getCurrentSubmission();
    modalUtil.showCustomAlertModal(options, currentSubmission);
  });
  $scope.$on('$destroy', function () {
    submissionMediator.resetCurrentSubmission();
  });
  $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
    currentSubmissionModel.clearRegistrations();
  });
  handleStateChangeStart($state.current.name, $stateParams);
  loadSubmission();
  if (!$scope.isFormViewerPresent()) {
    $scope.submissionViewModel.isViewContentInitialized = true;
  }
};
SubmissionController.$inject = ["$q", "$scope", "$rootScope", "$state", "$stateParams", "$location", "coreMediator", "submissionConstant", "submissionMediator", "submissionStatus", "accountMediator", "submissionStateMediator", "loadingBarHandler", "alertHandler", "preferenceModel", "currentSubmissionModel", "coreConstant", "formViewerConstant", "localization", "modalUtil"];
angular.module('gw-um-submission').controller('submissionController', SubmissionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SubmissionMediator = function SubmissionMediator($rootScope, $q, navigationRepository, activityStreamRepository, modificationsRepository, persistentConnection, submissionRepository, formUpgradeRepository, openSubmissionRepository, formUpgradeCheckRepository, currentSubmissionModel, registrationRepository, accountSubmissionsGridRepository, policiesSummaryGridRepository, coreMediator, detailedHistoryRepository) {
  this.loadSubmission = function (submissionId) {
    return persistentConnection.connect().then(function () {
      return openSubmissionRepository.openSubmission(submissionId);
    });
  };
  this.setSubmissionOpenHistory = function (submissionId) {
    return coreMediator.loadUserProfile().then(function (userProfile) {
      return submissionRepository.setSubmissionOpenHistory(submissionId, userProfile.userId);
    });
  };
  this.loadChangeSet = function (changeSetId) {
    return modificationsRepository.loadChangeSet(changeSetId);
  };
  this.createSubmission = function () {
    return submissionRepository.createSubmission();
  };
  this.submitSubmission = function (submissionId) {
    return submissionRepository.submitSubmission(submissionId);
  };
  this.deleteSubmission = function (submissionId) {
    return this.clearCurrentSubmissionRegistrations().finally(function () {
      return submissionRepository.deleteSubmission(submissionId).finally(function () {
        currentSubmissionModel.closeSubmission(submissionId);
      });
    });
  };
  this.closeSubmission = function (submissionId) {
    return this.clearCurrentSubmissionRegistrations().finally(function () {
      currentSubmissionModel.closeSubmission(submissionId);
      return submissionRepository.closeSubmission(submissionId);
    });
  };
  this.openSubmission = function (submissionId) {
    var deferred = $q.defer(),
      existingSubmission = currentSubmissionModel.getSubmissionById(submissionId);
    if (!existingSubmission) {
      openSubmissionRepository.openSubmission(submissionId).then(function (result) {
        currentSubmissionModel.openSubmission(result);
        deferred.resolve(result);
      });
    }
    return deferred.promise;
  };
  this.updateOpenSubmission = function (submission) {
    currentSubmissionModel.updateOpenSubmission(submission);
  };
  this.setSelectedSubmission = function (submission) {
    currentSubmissionModel.setSelectedSubmission(submission);
  };
  this.getSelectedSubmission = function () {
    return currentSubmissionModel.getSelectedSubmission();
  };
  this.setCurrentSubmission = function (submission) {
    return currentSubmissionModel.setCurrentSubmission(submission);
  };
  this.getCurrentSubmission = function () {
    return currentSubmissionModel.getCurrentNewSubmission() || currentSubmissionModel.getCurrentSubmission();
  };
  this.resetCurrentSubmission = function (submission) {
    return currentSubmissionModel.resetCurrentSubmission(submission);
  };
  this.getSubmissionById = function (submissionId) {
    return currentSubmissionModel.getSubmissionById(submissionId);
  };
  this.getOpenSubmissionList = function () {
    return currentSubmissionModel.getOpenSubmissionList();
  };
  this.resetOpenSubmissionList = function () {
    currentSubmissionModel.resetOpenSubmissionList();
  };
  this.clearCurrentSubmissionRegistrations = function () {
    var promises = [];
    _.each(currentSubmissionModel.getRegistrationsClone(), function (url) {
      promises.push(registrationRepository.deleteRegistration(url));
    });
    _.each(currentSubmissionModel.getActionsRegistrationsClone(), function (url) {
      promises.push(registrationRepository.deleteRegistration(url));
    });
    currentSubmissionModel.clearRegistrations();
    return $q.all(promises);
  };
  this.clearCurrentActionRegistrations = function () {
    var promises = [];
    _.each(currentSubmissionModel.getActionsRegistrationsClone(), function (url) {
      promises.push(registrationRepository.deleteRegistration(url));
    });
    currentSubmissionModel.clearActionsRegistrations();
    return $q.all(promises);
  };
  this.loadAccountSubmissions = function (accountId, accountNumber, submissionParams) {
    return accountSubmissionsGridRepository.loadSubmissions(accountId, accountNumber, submissionParams);
  };
  this.loadPolicies = function (submissionId, submissionParams) {
    return policiesSummaryGridRepository.loadPolicies(submissionId, submissionParams);
  };
  this.loadPoliciesBySubmissionIds = function (submissionIds, submissionParams) {
    return policiesSummaryGridRepository.loadPoliciesBySubmissionIds(submissionIds, submissionParams);
  };
  this.processPolicyChangeStatus = function (policyChange) {
    return policiesSummaryGridRepository.processGetResponseData([policyChange])[0];
  };
  this.getSubmissionNavItems = function (submissionId) {
    return navigationRepository.getNavigationItems(submissionId);
  };
  this.formNeedsUpgrade = function (submissionId) {
    return formUpgradeCheckRepository.submissionFormsNeedsUpgrade(submissionId);
  };
  this.upgradeForms = function (submissionId) {
    return formUpgradeRepository.upgradeSubmissionForms(submissionId);
  };
  this.loadActivityStreamItems = function (submissionId) {
    return activityStreamRepository.loadActivityStreamItems(submissionId);
  };
  this.getDetailedHistory = function (requestParams) {
    return detailedHistoryRepository.getDetailedHistory(requestParams);
  };
  this.deleteActionRegistrations = function (registrations) {
    var promises = [];
    _.each(registrations, function (registration) {
      currentSubmissionModel.removeActionsRegistration(registration.contextUri);
      promises.push(registrationRepository.deleteRegistration(registration.url));
    });
    return $q.all(promises);
  };
  this.updateSubmission = function (submissionId, submissionPropertiesMap) {
    return submissionRepository.updateSubmission(submissionId, submissionPropertiesMap);
  };
  this.getSubmissionTransactions = function (submissionId) {
    return submissionRepository.getSubmissionTransactions(submissionId);
  };
  this.isUserAuthorizedForSubmissionProduct = function (submissionId) {
    return submissionRepository.isUserAuthorizedForSubmissionProduct(submissionId);
  };
};
SubmissionMediator.$inject = ["$rootScope", "$q", "navigationRepository", "activityStreamRepository", "modificationsRepository", "persistentConnection", "submissionRepository", "formUpgradeRepository", "openSubmissionRepository", "formUpgradeCheckRepository", "currentSubmissionModel", "registrationRepository", "accountSubmissionsGridRepository", "policiesSummaryGridRepository", "coreMediator", "detailedHistoryRepository"];
angular.module('gw-um-submission').service('submissionMediator', SubmissionMediator);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 166 */
/***/ (function(module, exports) {

/*@ngInject*/
var SubmissionStateMediator = function SubmissionStateMediator(submissionStateModel) {
  this.saveSubmissionStateUrl = function (submissionId, stateName, stateParams) {
    submissionStateModel.saveStateUrl(submissionId, stateName, stateParams);
  };
  this.getSubmissionStateUrl = function (submissionId) {
    return submissionStateModel.getStateUrl(submissionId);
  };
  this.getNewSubmissionState = function () {
    return submissionStateModel.getNewSubmission();
  };
  this.saveNewSubmissionState = function (submission) {
    submissionStateModel.saveNewSubmission(submission);
  };
  this.deleteNewSubmissionState = function () {
    submissionStateModel.deleteNewSubmission();
  };
  this.getSubmissionDrawerState = function (submissionId) {
    return submissionStateModel.getDrawerState(submissionId);
  };
  this.saveSubmissionDrawerState = function (submissionId, state) {
    submissionStateModel.saveDrawerState(submissionId, state);
  };
  this.saveChecklistState = function (submissionId, data) {
    return submissionStateModel.saveChecklist(submissionId, data);
  };
  this.getChecklistState = function (submissionId) {
    return submissionStateModel.getChecklist(submissionId);
  };
  this.saveCollaborationState = function (submissionId, data) {
    return submissionStateModel.saveCollaboration(submissionId, data);
  };
  this.getCollaborationState = function (submissionId) {
    return submissionStateModel.getCollaboration(submissionId);
  };
  this.saveActivityStreamState = function (submissionId, data) {
    return submissionStateModel.saveActivityStream(submissionId, data);
  };
  this.getActivityStreamState = function (submissionId) {
    return submissionStateModel.getActivityStream(submissionId);
  };
  this.saveSnippetsViewerPositionState = function (submissionId, x, y, isOpen, isAttached) {
    return submissionStateModel.saveSnippetsViewerPosition(submissionId, x, y, isOpen, isAttached);
  };
  this.getSnippetsViewerPositionState = function (submissionId) {
    return submissionStateModel.getSnippetsViewerPosition(submissionId);
  };
  this.openChatCollaboration = function (submissionId) {
    return submissionStateModel.openChatCollaboration(submissionId);
  };
};
SubmissionStateMediator.$inject = ["submissionStateModel"];
angular.module('gw-um-submission').service('submissionStateMediator', SubmissionStateMediator);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SubmissionStateModel = function SubmissionStateModel($rootScope, $window, appTypeConfigurationModel) {
  var viewModel = {},
    sessionStorageKey = 'submission.state';
  function loadFromStorage() {
    viewModel = JSON.parse($window.sessionStorage.getItem(appTypeConfigurationModel.appendConsoleType(sessionStorageKey))) || {};
  }
  function saveInStorage() {
    $window.sessionStorage.setItem(appTypeConfigurationModel.appendConsoleType(sessionStorageKey), JSON.stringify(viewModel));
  }
  function saveSession(submissionId, key, value) {
    if (_.isEmpty(viewModel[submissionId])) {
      viewModel[submissionId] = {};
    }
    viewModel[submissionId][key] = value;
    saveInStorage();
  }
  function getFromSession(submissionId, key, defaultValue) {
    if (_.has(viewModel, submissionId)) {
      return _.get(viewModel, [submissionId, key].join('.'), defaultValue);
    }
    return defaultValue;
  }
  function deleteSession(submissionId, key) {
    delete viewModel[submissionId][key];
    saveInStorage();
  }
  this.saveChecklist = function (submissionId, checklistViewModel) {
    saveSession(submissionId, 'checklist', checklistViewModel);
  };
  this.getChecklist = function (submissionId) {
    return getFromSession(submissionId, 'checklist');
  };
  this.saveCollaboration = function (submissionId, collaborationViewModel) {
    saveSession(submissionId, 'collaboration', collaborationViewModel);
  };
  this.getCollaboration = function (submissionId) {
    return getFromSession(submissionId, 'collaboration');
  };
  this.saveActivityStream = function (submissionId, activityStreamViewModel) {
    saveSession(submissionId, 'activityStream', activityStreamViewModel);
  };
  this.getActivityStream = function (submissionId) {
    return getFromSession(submissionId, 'activityStream');
  };
  this.getStateUrl = function (submissionId) {
    return getFromSession(submissionId, 'stateUrl');
  };
  this.saveStateUrl = function (submissionId, stateName, stateParams) {
    saveSession(submissionId, 'stateUrl', {
      name: stateName,
      params: stateParams
    });
  };
  this.saveDrawerState = function (submissionId, state) {
    saveSession(submissionId, 'drawer', state);
  };
  this.getDrawerState = function (submissionId) {
    return getFromSession(submissionId, 'drawer', true);
  };
  this.saveNewSubmission = function (submission) {
    saveSession('new', 'submission', submission);
  };
  this.deleteNewSubmission = function () {
    deleteSession('new', 'submission');
  };
  this.getNewSubmission = function () {
    return getFromSession('new', 'submission');
  };
  this.saveSnippetsViewerPosition = function (submissionId, params) {
    saveSession(submissionId, 'snippetsViewer', params);
  };
  this.getSnippetsViewerPosition = function (submissionId) {
    return getFromSession(submissionId, 'snippetsViewer');
  };
  this.openChatCollaboration = function (submissionId) {
    var collaborationViewModel = this.getCollaboration(submissionId);
    if (_.isNil(collaborationViewModel)) {
      collaborationViewModel = {
        isOpen: true,
        filterType: 'chat',
        chat: {
          isVisible: true
        }
      };
    } else {
      collaborationViewModel.isOpen = true;
      collaborationViewModel.filterType = 'chat';
      collaborationViewModel.chat.isVisible = true;
      collaborationViewModel.note.isVisible = false;
      collaborationViewModel.email.isVisible = false;
      collaborationViewModel.attachment.isVisible = false;
      collaborationViewModel.task.isVisible = false;
    }
    return this.saveCollaboration(submissionId, collaborationViewModel);
  };
  loadFromStorage();
};
SubmissionStateModel.$inject = ["$rootScope", "$window", "appTypeConfigurationModel"];
angular.module('gw-um-submission').service('submissionStateModel', SubmissionStateModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SubmissionUtil = function SubmissionUtil($rootScope, $uibModal, $q, submissionMediator, submissionStateMediator, wizardMediator, $timeout, $stateParams, $state, submissionConstant, loadingBarHandler, preferenceModel) {
  var showWaitingDialog = true,
    pushedWizardContext;
  function handleAfterCloseSubmission() {
    submissionStateMediator.deleteNewSubmissionState();
    $rootScope.$broadcast(submissionConstant.event.RELOAD_SUBMISSION, $stateParams.submissionId);
  }
  function openNewSubmissionModal(submission, _formId) {
    var hierarchicalContextList = [];
    pushedWizardContext = wizardMediator.getContext();
    wizardMediator.setContextType(submissionConstant.CONTEXT_SUBMISSION);
    wizardMediator.setContextId(submission.id);
    wizardMediator.setContextLabel(submission.submissionTabDisplayName || submission.insured.name || '');
    wizardMediator.setContextUri(submission.objectUri);
    hierarchicalContextList.push({
      contextId: submission.id,
      contextType: submissionConstant.CONTEXT_SUBMISSION,
      contextUri: submission.objectUri
    });
    wizardMediator.setHierarchicalContextList(hierarchicalContextList);
    submissionStateMediator.saveNewSubmissionState({
      submissionId: submission.id,
      formId: _formId,
      state: $state.current.name,
      stateParams: $stateParams
    });
    var modalInstance = $uibModal.open({
      templateUrl: '/create/createSubmissionModal.tpl.html',
      controller: 'createSubmissionModalController',
      windowClass: 'createSubmissionModal',
      resolve: {
        submissionId: function submissionId() {
          return submission.id;
        },
        formId: function formId() {
          return _formId;
        }
      },
      keyboard: false,
      backdrop: 'static'
    });
    function handleSuccess() {
      submissionStateMediator.deleteNewSubmissionState();
    }
    modalInstance.result.then(handleSuccess, handleAfterCloseSubmission).finally(function () {
      wizardMediator.setContext(pushedWizardContext);
    });
  }
  function showLoader() {
    $timeout(function () {
      if (showWaitingDialog) {
        loadingBarHandler.showLoadingBar('loadingBar.defaultMessage');
      }
    }, 500);
  }
  function hideLoader() {
    showWaitingDialog = false;
    loadingBarHandler.hideLoadingBar();
  }
  this.createNewSubmission = function () {
    var deferred = $q.defer();
    showLoader();
    function handleSuccess(newSubmissionPayload) {
      openNewSubmissionModal(newSubmissionPayload.submissionSummary, newSubmissionPayload.submissionFormId);
      hideLoader();
      deferred.resolve();
    }
    function handleError() {
      hideLoader();
      deferred.reject();
    }
    submissionMediator.createSubmission().then(handleSuccess, handleError);
    return deferred.promise;
  };
  this.restoreCreateSubmissionModal = function () {
    var newSubmission = submissionStateMediator.getNewSubmissionState(),
      isCurrentState,
      isStateParamsEqual;
    if (!newSubmission) {
      return;
    }
    isCurrentState = $state.current.name === newSubmission.state;
    isStateParamsEqual = _.isEqual($stateParams, newSubmission.stateParams);
    if (isCurrentState && isStateParamsEqual) {
      submissionMediator.openSubmission(newSubmission.submissionId).then(function (submission) {
        openNewSubmissionModal(submission, newSubmission.formId);
      });
    }
  };
  this.setLatestSubmissionAsCurrent = function () {
    handleAfterCloseSubmission();
  };
  this.getSubmissionTransactionExternalLink = function (uri) {
    var baseUrl = preferenceModel.get('system.baseURL');
    baseUrl = baseUrl.replace(/\/\s*$/, '');
    return baseUrl + "/submissionTransaction/external/?objectURI=".concat(uri);
  };
};
SubmissionUtil.$inject = ["$rootScope", "$uibModal", "$q", "submissionMediator", "submissionStateMediator", "wizardMediator", "$timeout", "$stateParams", "$state", "submissionConstant", "loadingBarHandler", "preferenceModel"];
angular.module('gw-um-submission').service('submissionUtil', SubmissionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/submission.tpl.html';
var html = "<div class=\"submission\"\n     ng-class=\"{\n        navigationColumnHidden: !isLargeScreen,\n        printCollab: submissionViewModel.isPrintingCollab\n     }\"\n     ui-drawer-slide>\n\n    <!--Standard Navigation-->\n    <div class=\"navigation\"\n         ng-if=\"submissionViewModel.hasSubmissionLoaded && !submissionViewModel.printPreview && isLargeScreen && upgradeProcessComplete\"\n         ng-include=\"'/navigation/navigation.tpl.html'\"\n         ng-controller=\"navigationController\"></div>\n\n    <!--Slide Out Navigation-->\n    <div class=\"navigation navigationMenu\"\n         ng-if=\"(isSmallScreen || isMediumScreen) && upgradeProcessComplete\"\n         ng-include=\"'/navigation/navigation.tpl.html'\"\n         ng-controller=\"navigationController\"></div>\n\n    <div class=\"rightSideContainer\"\n         ng-if=\"submissionViewModel.hasSubmissionLoaded\">\n\n        <!--Top Content Section-->\n        <div class=\"content\">\n\n            <!--Submission Wizard-->\n            <div class=\"submissionWizard\"\n                 ng-include=\"'/wizard/wizard.tpl.html'\"\n                 ng-controller=\"wizardController\"\n                 ng-if=\"!submissionViewModel.printPreview && config.showHeader\"></div>\n\n            <!--Main Submission Content-->\n            <div class=\"mainContent\"\n                 ng-class=\"{ 'mainContentFormViewer': isFormViewerPresent(), 'printPreview':submissionViewModel.printPreview }\"\n                 ui-view=\"mainContent\"></div>\n        </div>\n\n        <div ng-if=\"!submissionViewModel.hasSubmissionLoaded\">\n            <div class=\"icon-spinner\"></div>\n        </div>\n\n        <div class=\"longRequestWarningContainer\"\n             ng-if=\"submissionViewModel.showLongRequestWarning\">\n            <div class=\"longRequestWarning\">\n\n                <div class=\"icon-spinner\">\n                    <img src=\"" + __webpack_require__(37) + "\"/>\n                </div>\n\n                <div ui-translate class=\"warningLabel\">genericLabels.loading</div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"dockPanel collaboration checklist\"\n         ng-if=\"submissionViewModel.isViewContentInitialized && !submissionViewModel.isPrintingCollab\"\n         ui-watcher-manager\n         ui-watch-is-visible=\"{{viewModel.isOpen}}\"\n         ng-include=\"'/checklist/checklist.tpl.html'\"\n         ng-controller=\"checklistController\"\n         ng-class=\"{'is-open': viewModel.isOpen}\"></div>\n\n    <div class=\"dockPanel collaboration tools\"\n         ng-if=\"submissionViewModel.isViewContentInitialized\"\n         ui-watcher-manager\n         ui-watch-is-visible=\"{{ viewModel.isOpen || submissionViewModel.isPrintingCollab }}\"\n         ng-include=\"'/collaboration/collaboration.tpl.html'\"\n         ng-controller=\"collaborationController\"\n         ng-class=\"{'is-open': viewModel.isOpen}\"></div>\n\n    <div class=\"dockPanel collaboration activityStream\"\n         ng-if=\"submissionViewModel.isViewContentInitialized && !submissionViewModel.isPrintingCollab\"\n         ui-watcher-manager\n         ui-watch-is-visible=\"{{viewModel.isLoading === false && viewModel.isOpen}}\"\n         ng-include=\"'/content/overview/activity/activityStream.tpl.html'\"\n         ng-controller=\"activityStreamController\"\n         ng-class=\"{'is-open': viewModel.formIsLoaded && viewModel.isOpen }\"></div>\n\n    <ui-snippets-viewer\n        ng-if=\"submissionViewModel.isViewContentInitialized\"></ui-snippets-viewer>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

var path = '/account/assign/assignAccountModal.tpl.html';
var html = "<div class=\"assignAccountModalContent\" ui-browser-detection>\n\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{  i18n.title }}</h3>\n        <button class=\"close\" ng-click=\"$dismiss()\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <span class=\"helperText\">{{  i18n.searchText }}</span>\n\n        <ui-advanced-filter-list class=\"modalContent\"\n                                 filter-model=\"viewModel.filterModel\"\n                                 show-all-templates=\"true\"\n                                 submission=\"viewModel.submission\"\n                                 advanced-filter-type=\"viewModel.advancedFilterType\"\n                                 allow-clear-filter=\"true\">\n        </ui-advanced-filter-list>\n\n        <ui-account-grid class=\"modalContent grid accountSubmissionsContent\"\n                         is-column-filter-visible=\"false\"\n                         is-grid-filter-visible=\"false\"\n                         is-view-active-visible=\"false\"\n                         is-search-visible=\"false\"\n                         is-grid-paging-visible=\"false\"\n                         accounts=\"viewModel.accounts\"\n                         submission=\"viewModel.submission\">\n        </ui-account-grid>\n    </div>\n\n\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn cancelButton\"\n                ng-click=\"$dismiss()\">\n            <span>{{  i18n.cancelButton }}</span>\n        </button>\n        <button class=\"btn btn-primary assignExistingAccountButton\"\n                ng-if=\"isAssignExistingAccountEnabled()\"\n                ng-click=\"assignExistingAccount()\">\n            <span>{{  i18n.assignExistingButton }}</span>\n        </button>\n        <button class=\"btn btn-primary validateAccountButton\"\n                ng-if=\"isValidateAccountEnabled()\"\n                ng-click=\"validateAccount()\">\n            <span>{{  i18n.validateButton }}</span>\n        </button>\n        <button class=\"btn btn-primary createNewAccountButton\"\n                ng-if=\"isCreateNewAccountEnabled()\"\n                ng-click=\"createNewAccount()\">\n            <span>{{  i18n.createNewButton }}</span>\n        </button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(174);

/*@ngInject*/
var AssignAccountModalController = function AssignAccountModalController($rootScope, $scope, $timeout, $state, accountMediator, uiPerformanceLoggerConstant, advancedFilterMediator, advancedFilterModel, advancedFilterType, authorizationConstants, coreConstant, currentUserModel, loadingBarHandler, modalUtil, landingConstant, submission, submissionConstant, submissionGridConstant) {
  var timeoutList = [];
  $scope.i18n = locale;
  $scope.viewModel = {
    existingAccount: undefined,
    filterModel: undefined,
    hasAssignAccountPermission: false,
    selectedAccount: undefined,
    submission: submission,
    accounts: null,
    requestParams: {
      key: 'name',
      sortBy: 'desc'
    },
    advancedFilterType: advancedFilterType.ACCOUNT_GRID
  };
  function init() {
    loadFilter();
    $scope.viewModel.hasAssignAccountPermission = currentUserModel.hasAuthorization(authorizationConstants.ASSIGN_ACCOUNT);
    accountMediator.getAccountById(submission.accountId).then(function (account) {
      $scope.viewModel.existingAccount = account;
    });
  }
  function loadFilter() {
    var filters, filter;
    advancedFilterMediator.getFilters().then(function (returnedFilters) {
      filters = _.filter(returnedFilters, {
        'type': 2,
        'temporary': false
      });
      filter = _.first(filters);
      if (filter) {
        advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
          advancedFilterModel.buildFilter($scope.viewModel.advancedFilterType, filterTemplate, filter, true);
          $scope.viewModel.filterModel = advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType);
        });
      }
    });
  }
  function handleFilterSave(event, filter) {
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_SEARCH, $scope.viewModel.submission.id);
    advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType).filter = filter;
    $scope.viewModel.accounts = null;
    $scope.viewModel.selectedAccountId = null;
    $scope.viewModel.selectedAccountNumber = null;
    var onFailure = function onFailure() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_SEARCH, coreConstant.uiPeformanceLogger.FAIL);
    };
    accountMediator.getAccountsByFilterUri(filter.uri, $scope.viewModel.requestParams).then(function (accountsMap) {
      $scope.viewModel.accounts = accountsMap.accountSummaries;
      // Ensure accounts are updated before we update the grid
      timeoutList.push($timeout(function () {
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
      }, 500));
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_SEARCH, coreConstant.uiPeformanceLogger.SUCCESS);
    }, onFailure);
  }
  $scope.$on(coreConstant.event.FILTER_SAVED, handleFilterSave);
  $scope.$on(submissionConstant.event.UPDATE_ACCOUNT_GRID, function (event, params) {
    $scope.viewModel.requestParams = params;
    handleFilterSave(null, advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType).filter);
  }.bind(this));
  $scope.isAssignExistingAccountEnabled = function () {
    return (!_.isNil($scope.viewModel.selectedAccountId) || !_.isNil($scope.viewModel.selectedAccountNumber)) && $scope.viewModel.selectedAccountId !== submission.accountId && $scope.viewModel.hasAssignAccountPermission;
  };
  $scope.assignExistingAccount = function () {
    var translations = this.i18n.assignConfirmationModal;
    if ($scope.isAssignExistingAccountEnabled()) {
      if ($scope.viewModel.existingAccount.validated) {
        translations = this.i18n.assignExistingConfirmationModal;
      }
      var onFailure = function onFailure() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_EXISTING, coreConstant.uiPeformanceLogger.FAIL);
      };
      modalUtil.showGenericConfirm(translations).then(function () {
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_EXISTING, submission.id);
        loadingBarHandler.showLoadingBar(translations.loadingBar);
        accountMediator.assignAccount(submission.id, $scope.viewModel.selectedAccountId, $scope.viewModel.selectedAccountNumber).then(function (submission) {
          $state.go('submission.accountSubmissionsGrid', {
            submissionId: submission.id,
            accountId: submission.accountId
          }, {
            reload: true
          });
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_EXISTING, coreConstant.uiPeformanceLogger.SUCCESS);
        }, onFailure).finally(function () {
          loadingBarHandler.hideLoadingBar();
          $scope.$close();
        });
      });
    }
  };
  $scope.isValidateAccountEnabled = function () {
    var accountExists = !_.isNil($scope.viewModel.existingAccount);
    return $scope.viewModel.hasAssignAccountPermission && accountExists && !$scope.viewModel.existingAccount.validated;
  };
  $scope.validateAccount = function () {
    var translations = this.i18n.validateConfirmationModal;
    if ($scope.isValidateAccountEnabled()) {
      var onFailure = function onFailure() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, coreConstant.uiPeformanceLogger.FAIL);
      };
      modalUtil.showGenericConfirm(translations).then(function () {
        loadingBarHandler.showLoadingBar(translations.loadingBar);
        accountMediator.validateAccount($scope.viewModel.existingAccount.id).then(function (validAccount) {
          $state.go('submission.accountSubmissionsGrid', {
            submissionId: $scope.viewModel.submission.id,
            accountId: validAccount.id
          }, {
            reload: true
          });
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, coreConstant.uiPeformanceLogger.SUCCESS);
        }, onFailure).finally(function () {
          loadingBarHandler.hideLoadingBar();
          $scope.$close();
        });
      });
    }
  };
  $scope.isCreateNewAccountEnabled = function () {
    var accountExists = !_.isNil($scope.viewModel.existingAccount);
    return $scope.viewModel.hasAssignAccountPermission && accountExists && $scope.viewModel.existingAccount.validated;
  };
  $scope.createNewAccount = function () {
    var translations = this.i18n.createConfirmationModal;
    if ($scope.isCreateNewAccountEnabled()) {
      var onFailure = function onFailure() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, coreConstant.uiPeformanceLogger.FAIL);
      };
      modalUtil.showGenericConfirm(translations).then(function () {
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, $scope.viewModel.submission.id);
        loadingBarHandler.showLoadingBar(translations.loadingBar);
        accountMediator.createAccount($scope.viewModel.submission.id).then(function (newAccount) {
          $state.go('submission.accountSubmissionsGrid', {
            submissionId: $scope.viewModel.submission.id,
            accountId: newAccount.id
          }, {
            reload: true
          });
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, coreConstant.uiPeformanceLogger.SUCCESS);
        }, onFailure).finally(function () {
          loadingBarHandler.hideLoadingBar();
          $scope.$close();
        });
      });
    }
  };
  $scope.$on(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER, function (event, selectedAccountId, selectedAccountNumber) {
    $scope.viewModel.selectedAccountId = selectedAccountId;
    $scope.viewModel.selectedAccountNumber = selectedAccountNumber;
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  init();
};
AssignAccountModalController.$inject = ["$rootScope", "$scope", "$timeout", "$state", "accountMediator", "uiPerformanceLoggerConstant", "advancedFilterMediator", "advancedFilterModel", "advancedFilterType", "authorizationConstants", "coreConstant", "currentUserModel", "loadingBarHandler", "modalUtil", "landingConstant", "submission", "submissionConstant", "submissionGridConstant"];
angular.module('gw-um-submission').controller('assignAccountModalController', AssignAccountModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 174 */
/***/ (function(module) {

module.exports = JSON.parse("{\"assignExistingButton\":\"Assign Existing Account\",\"cancelButton\":\"Cancel\",\"createNewButton\":\"Create New Account\",\"searchText\":\"The search will match all criteria from the top\",\"title\":\"Assign Account\",\"validateButton\":\"Validate Account\",\"assignConfirmationModal\":{\"cancelButtonLabel\":\"Cancel\",\"confirmActionButtonLabel\":\"Assign Account\",\"summary\":\"Are you sure you want to assign this submission to the selected account?\",\"title\":\"Assign Account\",\"loadingBar\":\"Assigning Account...\"},\"assignExistingConfirmationModal\":{\"cancelButtonLabel\":\"Cancel\",\"confirmActionButtonLabel\":\"Assign Account\",\"summary\":\"This submission is already assigned to an account.  Are you sure you want to assign this submission to the selected account?\",\"title\":\"Assign Account\",\"loadingBar\":\"Assigning Account...\"},\"validateConfirmationModal\":{\"cancelButtonLabel\":\"Cancel\",\"confirmActionButtonLabel\":\"Validate Account\",\"summary\":\"Are you sure you want to validate the account for this submission?\",\"title\":\"Validate Account\",\"loadingBar\":\"Validating Account...\"},\"createConfirmationModal\":{\"cancelButtonLabel\":\"Cancel\",\"confirmActionButtonLabel\":\"Create Account\",\"summary\":\"This submission is already assigned to an account. Are you sure you want to create a new account for this submission?\",\"title\":\"Create Account\",\"loadingBar\":\"Creating Account...\"}}");

/***/ }),
/* 175 */
/***/ (function(module, exports) {

var AccountGridComponent = {
  templateUrl: '/account/grid/accountGrid.tpl.html',
  controller: 'accountGridController',
  bindings: {
    isColumnFilterVisible: '<?',
    isGridFilterVisible: '<?',
    isViewActiveVisible: '<?',
    isSearchVisible: '<?',
    isGridPagingVisible: '<?',
    accounts: '<',
    submission: '<'
  }
};
angular.module('gw-um-submission').component('uiAccountGrid', AccountGridComponent);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(177);

/*@ngInject*/
var AccountGridController = function AccountGridController($scope, $controller, $timeout, advancedFilterType, appTypeConfigurationModel, coreConstant, coreMediator, landingConstant, submissionGridConstant, gridColumnModel, persistentConnection, preferenceModel, submissionConstant, xmlUtil) {
  angular.extend(this, $controller('baseGridWidgetController', {
    $scope: $scope
  }));
  var timeoutList = [];
  this.i18n = locale;
  this.isColumnFilterVisible = true;
  this.isGridFilterVisible = true;
  this.isViewActiveVisible = true;
  this.isSearchVisible = true;
  this.isGridPagingVisible = true;
  this.filterParams = {};
  this.advancedFilterType = advancedFilterType.ACCOUNT_GRID;
  this.$onInit = function () {
    this.columnPreference = 'system.assignAccountSearchColumns';
    this.openDetailDrawerEvent = submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER;
    this.closeDetailDrawerEvent = submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER;
    this.requestParams = this.getFilterParams();
    this.onInitGridWidget();
  };
  this.updateFilterFromPreferences = function () {
    $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
  };
  this.loadRecords = function (onSuccess, onError) {
    if (!_.isNil(this.accounts)) {
      onSuccess(this.accounts);
      this.isLoading = false;
      this.isLoaded = true;
    }
  };
  this.generateColumns = function () {
    this.colViewModel = xmlUtil.parseString(preferenceModel.get(this.columnPreference));
    this.isGridPagingVisible = false;
  };
  this.resetParams = function (requestParams) {
    this.requestParams = requestParams;
  };
  this.getValue = function (item, column) {
    var value;
    if (column._accessor === 'identifiers') {
      value = _.findLast(item.identifiers, ['type', column.__text]);
      if (!_.isNil(value)) {
        return value.identifier;
      }
    } else if (column._accessor === 'aliases') {
      return _.join(_.map(item.aliases, 'name'), ', ');
    } else if (_.isNil(item[column._accessor])) {
      value = _.findLast(item.dynamaccountcDisplayData, ['name', column.__text]);
      if (!_.isNil(value)) {
        return value.identifier;
      }
    } else {
      return item[column._accessor];
    }
  };
  this.setFilterParams = function () {};
  this.getFilterParams = function () {
    return this.filterParams;
  };
  this.setSelectedItem = function (event, selectedItem) {
    if (selectedItem.selected) {
      selectedItem.selected = false;
      this.isDrawerOpen = false;
      $scope.$emit(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER, null);
      return;
    } else {
      this.isDrawerOpen = true;
    }
    _.forEach(this.records, function (item) {
      item.selected = item === selectedItem;
    });
    $scope.$emit(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER, selectedItem.id, selectedItem.accountNumber);
  };
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function () {
    this.updateColumnsFromPreferences();
    this.resetGridColumns();
  }.bind(this));
  $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, function () {
    this.loadListOnFilterChange();
  }.bind(this));
  $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, params) {
    this.resetParams(params);
    if (this.isLoaded) {
      this.loadGrid();
    }
  }.bind(this));
  $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
    persistentConnection.connect().then(function () {
      this.isUserTypeUpdated = true;
      this.isAgent = appTypeConfigurationModel.isAgentConsole();
      this.initLandingPage();
    }.bind(this));
  }.bind(this));
  $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
};
AccountGridController.$inject = ["$scope", "$controller", "$timeout", "advancedFilterType", "appTypeConfigurationModel", "coreConstant", "coreMediator", "landingConstant", "submissionGridConstant", "gridColumnModel", "persistentConnection", "preferenceModel", "submissionConstant", "xmlUtil"];
angular.module('gw-um-submission').controller('accountGridController', AccountGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 177 */
/***/ (function(module) {

module.exports = JSON.parse("{\"emptyMessage\":\"No matching accounts.\",\"accountSubmissionsTitle\":\"Submissions Assigned to the Selected Account\"}");

/***/ }),
/* 178 */
/***/ (function(module, exports) {

var path = '/account/grid/accountGrid.tpl.html';
var html = "<div class=\"accountGrid\">\n\n    <div class=\"accountGridContainer\">\n\n        <div class=\"landing gridWindow\" app-mode-configuration>\n            <!--Grid-->\n            <div class=\"content landingContent\"\n                 ui-widget-grid-scroll-manager\n                 ui-scroll-detection\n                 scroll-fixed-grid-arrow>\n\n                <!--Grid Header-->\n                <div class=\"columnHeader\">\n\n                    <div class=\"columnRow columnDisposition accountColumnRow\">\n                        <div ng-repeat=\"column in $ctrl.colViewModel.column\"\n                             class=\"col column {{column.__text}}\"\n                             item-name=\"{{column._accessor + '::' + column.__text}}\"\n                             item-label=\"{{column.__text}}\"\n                             request-params=\"$ctrl.requestParams\"\n                             ng-style=\"{'width': column._width + 'px'}\">\n                            <span class=\"columnLabel\" ui-translate>{{column.__text}}</span>\n                        </div>\n                        <div class=\"col scrollBar\"></div>\n                    </div>\n                </div>\n\n                <div class=\"scrollVerticalContainer\">\n                    <div class=\"datagrid table\"\n                         ux-datagrid=\"$ctrl.records\"\n                         ng-if=\"!$ctrl.isLoading\">\n\n                        <script type=\"template/html\"\n                                data-template-item=\"item\"\n                                data-template-name=\"default\">\n\n                            <div class=\"rowDrawerWrapper\"\n                                 ng-class=\"{ selected: item.selected && $ctrl.isDrawerOpen,\n                                             activeAccount: $ctrl.submission.accountId === item.id}\">\n                                <div class=\"toggleDrawer\"\n                                     ng-click=\"$ctrl.setSelectedItem($event, item)\">\n                                    <span class=\"glyphicon glyphicon-chevron-right\"></span>\n                                </div>\n\n                                <div class=\"columnRow accountColumnRow\"\n                                     ng-class=\"{ selected: item.selected }\"\n                                     ng-click=\"$ctrl.setSelectedItem($event, item)\">\n\n                                    <div ng-repeat=\"column in $ctrl.colViewModel.column\"\n                                         class=\"col {{column.__text}}\"\n                                         uib-tooltip=\"{{$ctrl.getValue(item,column)}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isInsuredTooltip}}\"\n                                         ng-style=\"{'width': column._width + 'px'}\">\n                                        {{ $ctrl.getValue(item,column) }}\n                                    </div>\n                                </div>\n\n                                <div class=\"modalContent\"\n                                     ng-if=\"item.selected\">\n                                    <span class=\"drawer helperText\">{{ $ctrl.i18n.accountSubmissionsTitle }}</span>\n                                    <ui-account-submissions-grid class=\"modalContent grid drawer\"\n                                                                 is-column-filter-visible=\"false\"\n                                                                 is-grid-filter-visible=\"false\"\n                                                                 is-view-active-visible=\"false\"\n                                                                 is-search-visible=\"false\"\n                                                                 is-grid-paging-visible=\"false\"\n                                                                 is-grid-interactable=\"false\"\n                                                                 account-id=\"item.id\"\n                                                                 account-number=\"item.accountNumber\">\n                                    </ui-account-submissions-grid>\n                                </div>\n\n                            </div>\n\n                        </script>\n                    </div>\n\n                    <div class=\"gridEmpty\"\n                         ng-if=\"$ctrl.isGridEmpty && !$ctrl.isLoading\">\n                        {{ $ctrl.i18n.emptyMessage }}\n                    </div>\n\n                </div>\n\n                <div class=\"icon-spinner\"\n                     ng-if=\"$ctrl.isLoading\"></div>\n            </div>\n\n            <div class=\"landingPagination\"\n                 ng-if=\"$ctrl.isGridPagingVisible\"\n                 ui-grid-paging></div>\n        </div>\n\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

/*@ngInject*/
var AssignAccountRepository = function AssignAccountRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.assignAccount = function (submissionId, accountId, accountNumber) {
    var url = '/rest/Account/assignSubmission',
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        params: {
          accountId: accountId,
          accountNumber: accountNumber,
          submissionId: submissionId
        }
      };
    return this.post(url, {}, config);
  };
};
AssignAccountRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('assignAccountRepository', AssignAccountRepository);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

/*@ngInject*/
var CreateAccountRepository = function CreateAccountRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createAccount = function (submissionId) {
    var url = '/rest/Account/createAccount?submissionId=' + submissionId,
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
CreateAccountRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('createAccountRepository', CreateAccountRepository);

/***/ }),
/* 182 */
/***/ (function(module, exports) {

/*@ngInject*/
var GetAccountRepository = function GetAccountRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getAccountById = function (accountId) {
    var url = "/rest/Account/".concat(accountId);
    return this.get(url);
  };
  this.synchronizeAccount = function (accountId) {
    var url = "/rest/Account/".concat(accountId, "/synchronize");
    return this.post(url);
  };
};
GetAccountRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('getAccountRepository', GetAccountRepository);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var GetAccountsByFilterUriRepository = function GetAccountsByFilterUriRepository(baseRepository, sortUtil) {
  angular.extend(this, baseRepository);
  this.getAccountsByFilterUri = function (filterUri, requestParams) {
    var url = '/rest/Account/filter',
      data = {
        filterUri: filterUri,
        sortBy: 'name',
        startIndex: 0,
        numberOfRows: -1,
        displayAllAccounts: true,
        includeSubmittedSubmissionAccounts: true,
        excludeCandidateAccounts: false,
        excludeInactiveAccounts: false,
        matchNameAndAddressOrAccountNumberOrIdentifier: true
      },
      sortColumn,
      accessors = _.split(requestParams.key, '::');
    if (accessors[0] !== 'identifiers' && accessors[0] !== 'aliases') {
      sortColumn = accessors[0];
    }
    return this.get(url, {
      params: data
    }).then(function (responseData) {
      if (!sortColumn) {
        _.each(responseData.accountSummaries, function (account) {
          if (accessors[0] === 'aliases') {
            sortColumn = 'aliasConcat';
            //Gets all the alias names and then concatenates them together
            account.aliasConcat = _.join(_.map(account.aliases, 'name'), ',');
          }
          if (accessors[0] === 'identifiers') {
            sortColumn = 'identifiersConcat';
            //Finds all the identifers of the right type, gets all of their values, and concatenates them together
            var typedIdentifiers = _.filter(account.identifiers, ['type', accessors[1]]),
              identifierValues = _.map(typedIdentifiers, 'identifier');
            account.identifiersConcat = _.join(identifierValues, ',');
          }
        });
      }
      var sortedRecords = responseData.accountSummaries.sort(sortUtil.naturalSortObject(sortColumn));
      if (requestParams.sortType === 'desc') {
        sortedRecords.reverse();
      }
      responseData.accountSummaries = sortedRecords;
      return responseData;
    });
  };
};
GetAccountsByFilterUriRepository.$inject = ["baseRepository", "sortUtil"];
angular.module('gw-um-submission').service('getAccountsByFilterUriRepository', GetAccountsByFilterUriRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 184 */
/***/ (function(module, exports) {

/*@ngInject*/
var ValidateAccountRepository = function ValidateAccountRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.validateAccount = function (accountId) {
    var url = '/rest/Account/' + accountId + '/validateAccount';
    return this.post(url);
  };
};
ValidateAccountRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('validateAccountRepository', ValidateAccountRepository);

/***/ }),
/* 185 */
/***/ (function(module, exports) {

/*@ngInject*/
var AccountMediator = function AccountMediator(assignAccountRepository, createAccountRepository, getAccountRepository, getAccountsByFilterUriRepository, validateAccountRepository, formUpgradeCheckRepository, formUpgradeRepository) {
  this.assignAccount = function (submissionId, accountId, accountNumber) {
    return assignAccountRepository.assignAccount(submissionId, accountId, accountNumber);
  };
  this.createAccount = function (submissionId) {
    return createAccountRepository.createAccount(submissionId);
  };
  this.getAccountById = function (accountId) {
    return getAccountRepository.getAccountById(accountId);
  };
  this.getAccountsByFilterUri = function (filterUri, requestParams) {
    return getAccountsByFilterUriRepository.getAccountsByFilterUri(filterUri, requestParams);
  };
  this.validateAccount = function (accountId) {
    return validateAccountRepository.validateAccount(accountId);
  };
  this.formNeedsUpgrade = function (accountId) {
    return formUpgradeCheckRepository.accountFormsNeedsUpgrade(accountId);
  };
  this.upgradeForms = function (accountId) {
    return formUpgradeRepository.upgradeAccountForms(accountId);
  };
  this.synchronizeAccount = function (accountId) {
    return getAccountRepository.synchronizeAccount(accountId);
  };
};
AccountMediator.$inject = ["assignAccountRepository", "createAccountRepository", "getAccountRepository", "getAccountsByFilterUriRepository", "validateAccountRepository", "formUpgradeCheckRepository", "formUpgradeRepository"];
angular.module('gw-um-submission').service('accountMediator', AccountMediator);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

var path = '/activeSubmissionDropdown/activeSubmissionDropdown.tpl.html';
var html = "<div class=\"navElement activeSubmissionDropdown\"\n     ng-if=\"$ctrl.shouldShowCloseButton() || $ctrl.activeSubmissionList.length > 1\"\n     ng-class=\"{ active: $ctrl.isActiveNavElement('submission') }\"\n     uib-dropdown\n     on-toggle=\"toggled(open)\">\n\n    <div class=\"navButton navOpenSubmission\">\n\n        <span class=\"selectedSubmissionName\"\n              uib-tooltip=\"{{ $ctrl.selectedSubmissionName }}\"\n              tooltip-append-to-body=\"true\"\n              tooltip-enable=\"{{ $ctrl.selectedSubmissionName.length > 30 }}\"\n              tooltip-popup-delay=\"500\"\n              tooltip-append-to-body=\"true\"\n              tooltip-placement=\"bottom\"\n              ng-click=\"$ctrl.switchToSelectedSubmission()\">{{ $ctrl.selectedSubmissionName }}</span>\n\n        <div uib-dropdown-toggle\n             class=\"navOpenSubmissionControl\"\n             uib-tooltip=\"{{ ::$ctrl.i18n.submissionListDownArrowTooltip }}\"\n             tooltip-enable=\"{{ $ctrl.activeSubmissionList.length > 1 }}\"\n             tooltip-popup-delay=\"500\"\n             tooltip-append-to-body=\"true\"\n             tooltip-placement=\"bottom\">\n\n            <span class=\"fa fa-remove closeOpenSubmission\"\n                  ng-if=\"$ctrl.shouldShowCloseButton()\"\n                  ng-click=\"$ctrl.onCloseSubmission($event, $ctrl.getSelectedSubmission())\"></span>\n\n            <span class=\"fa fa-chevron-down\"\n                  ng-if=\"$ctrl.activeSubmissionList.length > 1\">\n            </span>\n        </div>\n    </div>\n\n    <ul uib-dropdown-menu\n        ng-if=\"$ctrl.activeSubmissionList.length > 1\">\n\n        <li class=\"menuRow\" ng-repeat=\"submission in $ctrl.activeSubmissionList\">\n\n            <div class=\"activeSubmissionRow\"\n                 ng-class=\"{ selected: $ctrl.isSelected(submission) }\">\n\n                <span class=\"activeSubmissionTitle\"\n                      ng-click=\"$ctrl.onOpenSubmission(submission)\"\n                      ui-overflow-tooltip>{{ submission.submissionTabDisplayName || submission.insured.name || $ctrl.defaultSubmissionNameLabel }}</span>\n\n                <span class=\"glyphicon glyphicon-remove removeButton\"\n                      ng-click=\"$ctrl.onCloseSubmission($event, submission)\"></span>\n            </div>\n        </li>\n\n        <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n    </ul>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

var ActiveSubmissionDropdownComponent = {
  templateUrl: '/activeSubmissionDropdown/activeSubmissionDropdown.tpl.html',
  controller: 'activeSubmissionDropdownController',
  bindings: {}
};
angular.module('gw-um-submission').component('activeSubmissionDropdown', ActiveSubmissionDropdownComponent);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(80);

/*@ngInject*/
var ActiveSubmissionDropdownController = function ActiveSubmissionDropdownController($scope, $state, $stateParams, submissionStatus, headerUtil, submissionStateMediator, submissionMediator, submissionConstant, coreConstant) {
  var _this2 = this;
  this.i18n = locale;
  this.submissionId = parseInt($stateParams.submissionId);
  this.activeSubmissionList = [];
  this.selectedSubmissionName = '';
  this.hasOpenSubmissions = false;
  this.defaultSubmissionNameLabel = this.i18n.defaultSubmissionNameLabel;
  this.$onInit = function () {
    this.updateSubmissionDropdown();
  };
  this.shouldShowCloseButton = function () {
    var numberOfActiveSubmissions = _.size(this.activeSubmissionList);
    if (numberOfActiveSubmissions === 1) {
      var activeSubmission = _.first(this.activeSubmissionList);
      if (activeSubmission.status !== submissionStatus.CREATED_SUBMISSION && this.isSelected(activeSubmission)) {
        return true;
      }
    }
    return false;
  };
  this.isActiveNavElement = function (type) {
    return headerUtil.isActiveNavElement(type);
  };
  this.switchToSelectedSubmission = function () {
    if (!_.isNil(this.submissionId)) {
      // On the home screen, so switch to submission
      var submission = this.getSelectedSubmission();
      this.onOpenSubmission(submission);
    }
  };
  this.onOpenSubmission = function (submission) {
    var stateUrl = submissionStateMediator.getSubmissionStateUrl(submission.id);
    var params = {
        submissionId: submission.id
      },
      stateName = 'submission.form';
    if (_.isPlainObject(stateUrl)) {
      params = _.get(stateUrl, 'params', params);
      stateName = _.get(stateUrl, 'name', stateName);
    }
    $state.go(stateName, params);
  };
  function handleCloseSubmission(submissionId) {
    submissionMediator.closeSubmission(submissionId);
  }
  this.onCloseSubmission = function (event, submission) {
    handleCloseSubmission(submission.id);
    event.stopPropagation();
  };
  this.getSelectedSubmission = function () {
    var _this = this;
    return _.find(this.activeSubmissionList, function (submission) {
      return _this.isSelected(submission);
    });
  };
  this.isSelected = function (submission) {
    var selectedSubmission = submissionMediator.getSelectedSubmission();
    return selectedSubmission && submission.id === selectedSubmission.id;
  };
  this.updateSubmissionDropdown = function () {
    this.activeSubmissionList = _.sortBy(submissionMediator.getOpenSubmissionList(), function (item) {
      return item.lastModified;
    });
    this.hasOpenSubmissions = !_.isEmpty(submissionMediator.getOpenSubmissionList());
    this.selectedSubmissionName = this.getSelectedSubmissionName();
  };
  this.getSelectedSubmissionName = function () {
    var submission = this.getSelectedSubmission();
    var selectedSubmissionName = '';
    if (!_.isNil(submission)) {
      selectedSubmissionName = submission.submissionTabDisplayName || submission.insured.name || this.defaultSubmissionNameLabel;
    }
    return selectedSubmissionName;
  };
  $scope.$on(submissionConstant.event.OPEN_SUBMISSION_LIST_CHANGE, function () {
    _this2.updateSubmissionDropdown();
  });
  $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function (event, currentSubmission) {
    var hasSubmissionIdChange = currentSubmission ? _this2.submissionId !== currentSubmission.id : false;
    _this2.updateSubmissionDropdown();
    if (hasSubmissionIdChange) {
      $state.go('submission.default', {
        submissionId: currentSubmission.id
      });
    }
  });
  $scope.$on(submissionConstant.event.CLOSE_SUBMISSION_MODULE, function () {
    $state.go('landing');
  });
  $scope.$on(coreConstant.event.REFRESH_RECENT_SUBMISSION_DROPDOWN, function () {
    _this2.updateSubmissionDropdown();
  });
  $scope.$on(coreConstant.event.CLOSE_SUBMISSION_VIEW, function (event, submissionId) {
    if (submissionId === _this2.submissionId) {
      handleCloseSubmission(submissionId);
    }
  });
  $scope.$on(submissionConstant.event.OPEN_SUBMISSION_LIST_CHANGE, function () {
    _this2.updateSubmissionDropdown();
  });
};
ActiveSubmissionDropdownController.$inject = ["$scope", "$state", "$stateParams", "submissionStatus", "headerUtil", "submissionStateMediator", "submissionMediator", "submissionConstant", "coreConstant"];
angular.module('gw-um-submission').controller('activeSubmissionDropdownController', ActiveSubmissionDropdownController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

var path = '/checklist/checklist.tpl.html';
var html = "<div class=\"dockPanelContainer collaborationContainer checklist\"\n     ui-focus-manager=\"checklist\">\n\n    <section class=\"dockPanelSection collaborationPage\">\n\n        <!--Top Panel-->\n        <div class=\"dockPanelHeader collaborationHeader checklistHeader\">\n            <span class=\"glyphicon glyphicon-check\" ui-browser-detection></span>\n            <div class=\"checklistTitle\">{{ ::i18n.title }}</div>\n\n            <a class=\"dockPanelHeaderButton collaborationHeaderButton collaborationClose\"\n               ng-click=\"onToggleChecklist()\">\n                <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\n            </a>\n        </div>\n\n        <!--Search Form-->\n        <div class=\"dockPanelSearchForm has-feedback\"\n             ng-class=\"{ 'is-open': viewModel.isSearchOpen }\">\n            <span class=\"glyphicon glyphicon-search form-control-feedback\" aria-hidden=\"true\"></span>\n            <input type=\"search\"\n                   ng-model=\"viewModel.searchInput\"\n                   ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                   ng-change=\"onSearchInputChange()\"\n                   class=\"searchInput form-control\"\n                   placeholder=\"{{ viewModel.searchPlaceholder }}\"/>\n\n            <span ng-if=\"viewModel.searchInput != ''\"\n                  ng-click=\"onClearSearchInput()\"\n                  class=\"glyphicon glyphicon-remove form-control-feedback\"></span>\n        </div>\n\n        <div class=\"dockPanelContent collaborationContent checklistItemGroups\">\n            <div class=\"checklistItemGroup\"\n                 ng-repeat=\"checklistItemGroup in viewModel.checklistItemGroups\"\n                 ng-if=\"checklistItemGroup.showGroup\">\n                <div class=\"checklistItemGroupHeaderRow\"\n                     ng-click=\"toggleChecklistItemGroup(checklistItemGroup)\">\n                    <button class=\"btn-link checklistItemGroupHeader\"\n                            uib-tooltip=\"{{ ::checklistItemGroup.header }}\"\n                            tooltip-append-to-body=\"true\"\n                            tooltip-popup-delay=\"500\"\n                            tooltip-enable=\"{{ checklistItemGroup.headerTooltip }}\"\n                            ui-is-tooltip-enabled=\"checklistItemGroup.headerTooltip\">\n                        <span class=\"ng-binding\">{{checklistItemGroup.header}}</span>\n                    </button>\n                    <span ng-show=\"!checklistItemGroup.isOpen && checklistItemGroup.uncheckedCount > 0\"\n                          class=\"uncheckedItemBadge\"\n                          ui-browser-detection>{{ checklistItemGroup.uncheckedCount }}</span>\n                    <button class=\"checklistToggle btn-link glyphicon\"\n                            ng-class=\"{'glyphicon-chevron-right': !checklistItemGroup.isOpen, 'glyphicon-chevron-down': checklistItemGroup.isOpen}\">\n                    </button>\n\n                </div>\n                <div class=\"checklistItemSubGroup\"\n                     ng-if=\"checklistItemGroup.isOpen && checklistItemGroup.showGroup && checklistItemGroup.subGroups.length > 0\"\n                     ng-repeat=\"subGroup in checklistItemGroup.subGroups\">\n                    <div class=\"checklistItemGroupHeaderRow checklistItemSubGroupHeaderRow\">\n                        <span class=\"ng-binding checklistItemGroupHeader\"\n                              uib-tooltip=\"{{ ::subGroup.header }}\"\n                              tooltip-append-to-body=\"true\"\n                              tooltip-popup-delay=\"500\"\n                              tooltip-enable=\"{{ subGroup.headerTooltip }}\"\n                              ui-is-tooltip-enabled=\"subGroup.headerTooltip\">{{subGroup.header}}</span>\n                        <span ng-show=\"checklistItemGroup.isOpen && subGroup.uncheckedCount > 0\"\n                              class=\"uncheckedItemBadge\"\n                              ui-browser-detection>{{ subGroup.uncheckedCount }}</span>\n                    </div>\n                    <ul class=\"dockPanelCellList collaborationCellList checklistItemList\">\n                        <li class=\"dockPanelCell checklistCell\"\n                            ng-repeat=\"item in subGroup.items\">\n                            <div class=\"checklistItemContentRow\">\n                            <span class=\"glyphicon glyphicon-asterisk\"\n                                  ng-class=\"{spacer: item.checked}\"></span>\n\n                                <input type=\"checkbox\"\n                                       ng-model=\"item.checked\"\n                                       ng-change=\"handleUpdateChecklistItem(item)\"\n                                       ng-disabled=\"!canCheckItem(item)\"/>\n\n                                <div class=\"checklistDefinition\">\n                                <span ng-class=\"{'clickableDefinition': canCheckItem(item)}\"\n                                      ng-click=\"handleDefinitionClick(item)\"\n                                      ng-bind-html=\"getItemDescription(item)\"\n                                      ui-external-href-target-blank stop-propagation=\"true\">\n                                </span>\n                                </div>\n\n                                <div class=\"checklistItemIcons\">\n                                <span class=\"glyphicon\"\n                                      ng-class=\"{'glyphicon-exclamation-sign': isAuthorityItem(item)}\"></span>\n                                </div>\n                            </div>\n                            <div class=\"commentRow\">\n                                <span class=\"glyphicon glyphicon-pencil\"></span>\n                                <textarea maxlength=\"255\"\n                                          ng-model=\"item.comment\"\n                                          ng-attr-placeholder=\"{{::viewModel.commentPlaceholder}}\"\n                                          ng-blur=\"handleUpdateChecklistItem(item)\"\n                                          ui-auto-expand\n                                          ui-browser-detection></textarea>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n                <ul class=\"dockPanelCellList collaborationCellList checklistItemList\"\n                    ng-if=\"checklistItemGroup.isOpen && checklistItemGroup.showGroup\">\n                    <li class=\"dockPanelCell checklistCell\"\n                        ng-repeat=\"item in checklistItemGroup.items\">\n                        <div class=\"checklistItemContentRow\">\n                            <span class=\"glyphicon glyphicon-asterisk\"\n                                  ng-class=\"{spacer: item.checked}\"></span>\n\n                            <input type=\"checkbox\"\n                                   ng-model=\"item.checked\"\n                                   ng-change=\"handleUpdateChecklistItem(item)\"\n                                   ng-disabled=\"!canCheckItem(item)\"/>\n\n                            <div class=\"checklistDefinition\">\n                                <span ng-class=\"{'clickableDefinition': canCheckItem(item)}\"\n                                      ng-click=\"handleDefinitionClick(item)\"\n                                      ng-bind-html=\"getItemDescription(item)\"\n                                      ui-external-href-target-blank stop-propagation=\"true\">\n                                </span>\n                            </div>\n\n                            <div class=\"checklistItemIcons\">\n                                <span class=\"glyphicon\"\n                                      ng-class=\"{'glyphicon-exclamation-sign': isAuthorityItem(item)}\"></span>\n                            </div>\n                        </div>\n                        <div class=\"commentRow\">\n                            <span class=\"glyphicon glyphicon-pencil\"></span>\n                            <textarea maxlength=\"255\"\n                                      ng-model=\"item.comment\"\n                                      ng-attr-placeholder=\"{{viewModel.commentPlaceholder}}\"\n                                      ng-blur=\"handleUpdateChecklistItem(item)\"\n                                      ui-auto-expand\n                                      ui-browser-detection></textarea>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </section>\n\n    <div ng-if=\"viewModel.isLoading\">\n        <div class=\"icon-spinner\"></div>\n    </div>\n</div>\n\n<iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(193);

/*@ngInject*/
var ChecklistController = function ChecklistController($rootScope, $sce, $scope, $stateParams, authorizationConstants, checkListItemSubType, checkListItemType, coreConstant, quoteMediator, submissionConstant, wizardMediator, submissionStateMediator, checklistMediator, currentUserModel) {
  var wizardContextType = wizardMediator.getContextType(),
    wizardContextId = wizardMediator.getContextId();
  $scope.i18n = locale;
  $scope.viewModel = {
    checklistItemGroups: {},
    isOpen: false,
    isLoading: false,
    isSearchOpen: false,
    searchInput: '',
    searchDelayInMilliSeconds: submissionConstant.searchDelay,
    hasCheckLOAPermission: currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_CHECK_LOA_CHECKLIST_ITEM),
    openGroups: [],
    searchPlaceholder: $scope.i18n.searchPlaceholder,
    commentPlaceholder: $scope.i18n.commentPlaceholder,
    submissionGroupHeader: $scope.i18n.submissionGroupHeader
  };
  function saveState() {
    var toOmit = ['checklistItemList', 'isLoading'];
    submissionStateMediator.saveChecklistState($stateParams.submissionId, _.omit($scope.viewModel, toOmit));
  }
  function getObjectId(objectUri) {
    var uriSplits = _.split(objectUri, '/'),
      entityId = parseInt(uriSplits[2]);
    return entityId;
  }
  function processChecklistGroups(groups) {
    return _.forEach(groups, function (group) {
      var isGroupOpen = false,
        groupMatchesContext = false,
        proposalId;
      if (group.subGroups) {
        processChecklistGroups(group.subGroups);
      }
      if (_.includes(group.objectUri, 'Submission')) {
        group.header = $scope.viewModel.submissionGroupHeader;
        groupMatchesContext = true;
      } else if (_.includes(group.objectUri, 'Proposal')) {
        if (wizardContextType === submissionConstant.CONTEXT_PROPOSAL) {
          groupMatchesContext = parseInt(wizardContextId) === getObjectId(group.objectUri);
        } else if (wizardContextType === submissionConstant.CONTEXT_QUOTE) {
          proposalId = parseInt(_.split(wizardContextId, '::')[1]);
          groupMatchesContext = proposalId === getObjectId(group.objectUri);
        }
      }
      if ($scope.viewModel.searchInput) {
        group.items = _.filter(group.items, function (item) {
          return _.includes(_.lowerCase($scope.getItemDescription(item)), _.lowerCase($scope.viewModel.searchInput));
        });
      }
      group.showGroup = group.proposalGroup || group.items.length > 0;
      isGroupOpen = groupMatchesContext || group.isOpen || _.includes($scope.viewModel.openGroups, group.header);
      group.isOpen = isGroupOpen;
      _.forEach(group.items, function (item) {
        var checkListText;
        if (item.definition) {
          checkListText = _.replace(item.definition.name, 'href="event:', 'href="');
          item.definition.name = $sce.trustAsHtml(checkListText);
        } else {
          checkListText = _.replace(item.description, 'href="event:', 'href="');
          item.description = $sce.trustAsHtml(checkListText);
        }
        item.showCommentBox = item.comment;
      });
    });
  }
  function refreshChecklist(silentUpdate) {
    if ($scope.viewModel.isOpen) {
      if (!silentUpdate) {
        $scope.viewModel.isLoading = true;
      }
      checklistMediator.getChecklistItems($stateParams.submissionId).then(function (checklistResponse) {
        $scope.viewModel.checklistItemGroups = processChecklistGroups(checklistResponse.groups);
        $scope.viewModel.isLoading = false;
      }, function () {
        $scope.viewModel.isLoading = false;
      });
    }
  }
  function openDrawer() {
    $scope.viewModel.isOpen = true;
    refreshChecklist();
    saveState();
    $rootScope.$broadcast(submissionConstant.event.CHECKLIST_DID_OPEN);
  }
  function closeDrawer() {
    $scope.viewModel.isOpen = false;
    saveState();
    $rootScope.$broadcast(submissionConstant.event.CHECKLIST_DID_CLOSE);
  }
  function restoreState() {
    var savedViewModel = submissionStateMediator.getChecklistState($stateParams.submissionId);
    if (savedViewModel) {
      savedViewModel.hasCheckLOAPermission = $scope.viewModel.hasCheckLOAPermission;
      $scope.viewModel = _.extend($scope.viewModel, savedViewModel);
      if ($scope.viewModel.isOpen) {
        $rootScope.$broadcast(submissionConstant.event.CHECKLIST_DID_OPEN);
      }
    }
  }
  $scope.toggleCommentBox = function (checklistItem) {
    checklistItem.showCommentBox = !checklistItem.showCommentBox;
    if (!checklistItem.showCommentBox) {
      checklistItem.comment = null;
    }
  };
  $scope.toggleChecklistItemGroup = function (checklistItemGroup) {
    checklistItemGroup.isOpen = !checklistItemGroup.isOpen;
    if (checklistItemGroup.isOpen) {
      if (!_.includes($scope.viewModel.openGroups, checklistItemGroup.header)) {
        $scope.viewModel.openGroups.push(checklistItemGroup.header);
      }
    } else {
      _.remove($scope.viewModel.openGroups, function (openGroup) {
        return openGroup === checklistItemGroup.header;
      });
    }
    saveState();
  };
  $scope.isAuthorityItem = function (checklistItem) {
    return checklistItem.type !== checkListItemType.USER && checklistItem.subType !== checkListItemSubType.NONE;
  };
  $scope.isComplete = function (checklistItem) {
    return $scope.isAuthorityItem(checklistItem) && checklistItem.subType === checkListItemSubType.UNDERWRITING_AUTHORITY_APPROVED;
  };
  $scope.canCheckItem = function (checklistItem) {
    var isAuthorityItem = checklistItem.subType === checkListItemSubType.UNDERWRITING_AUTHORITY || checklistItem.subType === checkListItemSubType.UNDERWRITING_AUTHORITY_APPROVED;
    if (isAuthorityItem) {
      return $scope.viewModel.hasCheckLOAPermission;
    }
    return true;
  };
  $scope.handleUpdateChecklistItem = function (checklistItem) {
    checklistMediator.updateChecklistItem(checklistItem.id, checklistItem.checked, checklistItem.comment).then(function () {
      refreshChecklist(true);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST_ITEM_COUNT);
    });
  };
  $scope.handleDefinitionClick = function (checklistItem) {
    if ($scope.canCheckItem(checklistItem)) {
      checklistItem.checked = !checklistItem.checked;
      $scope.handleUpdateChecklistItem(checklistItem);
    }
  };
  $scope.onToggleChecklist = function () {
    return !$scope.viewModel.isOpen ? openDrawer() : closeDrawer();
  };
  $scope.onClearSearchInput = function () {
    $scope.viewModel.searchInput = '';
    refreshChecklist();
  };
  $scope.onSearchInputChange = function () {
    refreshChecklist();
  };
  $scope.getItemDescription = function (checklistItem) {
    if (checklistItem.definition) {
      return checklistItem.definition.name;
    } else {
      return checklistItem.description;
    }
  };
  $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
    if (parseInt($stateParams.submissionId) === submission.id) {
      refreshChecklist(true);
    }
  });
  $scope.$on(submissionConstant.event.REFRESH_CHECKLIST, function (event, submissionId) {
    if (parseInt($stateParams.submissionId) === submissionId) {
      refreshChecklist(true);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST_ITEM_COUNT);
    }
  });
  $scope.$on(submissionConstant.event.CLOSE_CHECKLIST, function (event) {
    closeDrawer();
  });
  $scope.$on(submissionConstant.event.TOGGLE_CHECKLIST, function (event) {
    $scope.onToggleChecklist();
  });
  $scope.$on(submissionConstant.event.CONTEXT_CHANGED, function (event) {
    $scope.viewModel.openGroups = [$scope.viewModel.submissionGroupHeader];
    saveState();
    refreshChecklist();
  });
  restoreState();
  refreshChecklist();
};
ChecklistController.$inject = ["$rootScope", "$sce", "$scope", "$stateParams", "authorizationConstants", "checkListItemSubType", "checkListItemType", "coreConstant", "quoteMediator", "submissionConstant", "wizardMediator", "submissionStateMediator", "checklistMediator", "currentUserModel"];
angular.module('gw-um-submission').controller('checklistController', ChecklistController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 193 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Underwriter Checklist\",\"searchPlaceholder\":\"Search Checklist Items\",\"commentPlaceholder\":\"Comment\",\"submissionGroupHeader\":\"Submission\"}");

/***/ }),
/* 194 */
/***/ (function(module, exports) {

/*@ngInject*/
var ChecklistMediator = function ChecklistMediator(getChecklistItemsRepository, updateChecklistItemRepository) {
  this.getChecklistItems = function (submissionId) {
    return getChecklistItemsRepository.getChecklistItems(submissionId);
  };
  this.updateChecklistItem = function (checklistItemId, checked, comment) {
    return updateChecklistItemRepository.updateChecklistItem(checklistItemId, checked, comment);
  };
};
ChecklistMediator.$inject = ["getChecklistItemsRepository", "updateChecklistItemRepository"];
angular.module('gw-um-submission').service('checklistMediator', ChecklistMediator);

/***/ }),
/* 195 */
/***/ (function(module, exports) {

/*@ngInject*/
var GetChecklistItemsRepository = function GetChecklistItemsRepository(baseSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.getChecklistItems = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/CheckListItems',
      cacheKey = submissionId;
    return this.get(cacheKey, url);
  };
};
GetChecklistItemsRepository.$inject = ["baseSharedPromiseRepository"];
angular.module('gw-um-submission').service('getChecklistItemsRepository', GetChecklistItemsRepository);

/***/ }),
/* 196 */
/***/ (function(module, exports) {

/*@ngInject*/
var UpdateChecklistItemRepository = function UpdateChecklistItemRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.updateChecklistItem = function (checklistItemId, checked, comment) {
    var url = '/rest/UnderwritingCheckListItem/' + checklistItemId,
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      },
      payload = 'checked=' + checked;
    if (!comment) {
      comment = '';
    }
    payload += '&comment=' + encodeURIComponent(comment);
    return this.post(url, payload, config);
  };
};
UpdateChecklistItemRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('updateChecklistItemRepository', UpdateChecklistItemRepository);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

var path = '/collaboration/attachment/fileTemplateModal/fileTemplateModal.tpl.html';
var html = "<base-modal modal-title=\"title\"\n            ok=\"previewButton\"\n            cancel=\"cancelButton\"\n            is-confirm-disabled=\"!canEnablePreviewButton()\"\n            third-button=\"saveButton\"\n            third-button-class=\"'btn-primary save'\"\n            ok-button-class=\"okButtonClass\"\n            is-third-button-disabled=\"!displayAttachmentViewer\"\n            on-third-button=\"onSave()\"\n            on-confirm=\"onPreviewClicked()\"\n            on-cancel=\"onCancel()\">\n\n    <div ng-if=\"!displayAttachmentViewer\" class=\"fileTemplateModal\" ui-browser-detection>\n        <!--Content-->\n        <div class=\"modal-body contentContainer\">\n            <ui-form-viewer submission-id=\"{{ ::submissionId }}\"\n                            form-id=\"{{ ::formId }}\"\n                            printable=\"false\">\n            </ui-form-viewer>\n        </div>\n    </div>\n\n    <div class=\"previewPane\"\n         ng-if=\"displayAttachmentViewer\">\n        <attachment-viewer class=\"attachmentViewerDirective pdfFrame\"\n                           attachment-id=\"{{viewModel.attachmentId}}\">\n        </attachment-viewer>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(200);

/*@ngInject*/
var FileTemplateModalController = function FileTemplateModalController($rootScope, $scope, coreConstant, submissionId, attachmentUtil, correspondenceFormId, collaborationMediator, currentSubmissionModel, loadingBarHandler, formViewerModel, attachmentMediator) {
  $scope.i18n = locale;
  $scope.title = $scope.i18n.title;
  $scope.previewButton = $scope.i18n.previewButton;
  $scope.cancelButton = $scope.i18n.cancelButton;
  $scope.formId = correspondenceFormId;
  $scope.submissionId = submissionId;
  $scope.attachment = null;
  $scope.displayAttachmentViewer = false;
  $scope.effectiveDate = currentSubmissionModel.getCurrentSubmission().effectiveDate;
  $scope.currencyCode = currentSubmissionModel.getCurrentSubmission().currencyCode;
  $scope.okButtonClass = 'previewButton';
  $scope.viewModel = {
    attachmentId: '',
    attachmentName: '',
    isHTMLDocument: false,
    attachmentLinkURL: ''
  };
  $scope.canEnablePreviewButton = function () {
    if ($scope.displayAttachmentViewer) {
      return true;
    } else {
      var formStructure = formViewerModel.getFormStructure($scope.formId);
      if (formStructure && formStructure.formModel && formStructure.formModel.totalRequiredFieldCount === 0) {
        return true;
      }
      return false;
    }
  };
  $scope.onPreviewClicked = function () {
    if ($scope.displayAttachmentViewer) {
      $scope.displayAttachmentViewer = false;
      $scope.previewButton = $scope.i18n.previewButton;
      $scope.saveButton = '';
      $scope.okButtonClass = 'previewButton';
    } else {
      loadingBarHandler.showLoadingBar($scope.i18n.loadingBar);
      collaborationMediator.generateLetter($scope.submissionId, $scope.formId).then(function (attachment) {
        loadingBarHandler.hideLoadingBar();
        $scope.displayAttachmentViewer = true;
        $scope.attachment = attachment;
        $scope.viewModel.attachmentName = attachment.name;
        $scope.viewModel.attachmentId = attachment.id;
        $scope.previewButton = $scope.i18n.backButton;
        $scope.saveButton = $scope.i18n.saveButton;
        $scope.okButtonClass = 'backButton';
      });
    }
  };
  $scope.onSave = function () {
    loadingBarHandler.showFadingNotificationLoadingBar($scope.i18n.saveLoadingBar);
    $scope.attachment.temporary = false;
    $scope.attachment.ownerUri = 'com.firstbest.underwriting.submission.Submission:' + $scope.submissionId;
    attachmentMediator.updateAttachment($scope.attachment.id, $scope.attachment).then(function () {
      loadingBarHandler.concludeNotificationLoadingBar($scope.i18n.saveSuccessLoadingBar);
      $scope.$dismiss();
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
FileTemplateModalController.$inject = ["$rootScope", "$scope", "coreConstant", "submissionId", "attachmentUtil", "correspondenceFormId", "collaborationMediator", "currentSubmissionModel", "loadingBarHandler", "formViewerModel", "attachmentMediator"];
angular.module('gw-um-submission').controller('fileTemplateModalController', FileTemplateModalController);

/***/ }),
/* 200 */
/***/ (function(module) {

module.exports = JSON.parse("{\"backButton\":\"Back\",\"cancelButton\":\"Cancel\",\"loadingBar\":\"Creating Preview...\",\"previewButton\":\"Preview\",\"saveButton\":\"Save\",\"saveLoadingBar\":\"Saving file to the collaboration file drawer...\",\"saveSuccessLoadingBar\":\"Successfully saved file to the collaboration file drawer\",\"title\":\"File Templates\"}");

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/collaboration/attachment/collaborationAttachment.tpl.html';
var html = "<div class=\"dockPanelHeader collaborationHeader\">\n    <h2 class=\"dockPanelHeaderTitle dockPanelHeaderButton collaborationHeaderTitle\" ng-click=\"hideSubPage()\">\n        <span class=\"glyphicon glyphicon-chevron-left attachmentCollabHeaderBackArrow\"></span>\n        <img class=\"icon-image icon-collaborationTypeFile\"\n             src=\"" + __webpack_require__(142) + "\" ></img>\n        {{getTitle()}}\n    </h2>\n</div>\n\n<!--Collaboration Content-->\n<div class=\"dockPanelContent collaborationContent collaborationAttachment\">\n    <div class=\"dockPanelInnerContent collaborationInnerContent\"\n         ng-if=\"!attachmentViewModel.attachment.id\">\n        <div class=\"dragDropBox\"\n             ui-drop-zone\n             file=\"{{attachmentViewModel.uploadedFile}}\">\n            <span>{{ i18n.dragAndDrop }}</span>\n            <span>{{ i18n.or }}</span>\n            <div>\n                <input type=\"file\"\n                       class=\"btn btn-primary btn-sm hiddenFileInput\"\n                       name=\"' + scope.valueName + '_file\"\n                       ui-custom-on-change=\"fileSelected(file)\"/>\n                <input type=\"button\"\n                       class=\"btn btn-primary btn-sm\"\n                       value=\"{{attachmentViewModel.chooseFileString}}\"/>\n            </div>\n\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"glyphicon glyphicon-file\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <input\n                type=\"text\"\n                ng-if=\"attachmentViewModel.nameEditMode && isUnderwriterUser() && isEditable()\"\n                ng-blur=\"onUpdateField()\"\n                ng-model=\"attachmentViewModel.editableName\"\n                ui-auto-focus=\"true\"\n                class=\"attachmentNameInput\">\n\n            <a ng-if=\"!attachmentViewModel.nameEditMode\"\n               ng-click=\"attachmentDownloadClick()\"\n               class=\"attachmentName\">\n                {{attachmentViewModel.attachment.name}} {{attachmentViewModel.attachment.byteCountToDisplaySize}}\n            </a>\n            <a ng-if=\"!attachmentViewModel.nameEditMode && isUnderwriterUser() && isEditable()\"\n               uib-tooltip=\"{{::attachmentViewModel.editNameIconText}}\"\n               tooltip-append-to-body=\"true\"\n               class=\"attachmentEditName glyphicon glyphicon-pencil\"\n               ng-click=\"activateEditFilename()\"></a>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"glyphicon glyphicon-list-alt\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n\n            <!--Email Type Selection-->\n            <ui-select class=\"dropdownFormComponent dropdownComponentSelect attachmentType collaborationAttachmentType\"\n                       theme=\"select2\"\n                       ng-model=\"attachmentViewModel.selectedAttachmentType\"\n                       ng-change=\"onUpdateSelectedType()\"\n                       ng-disabled=\"!isEditable()\">\n\n                <ui-select-match placeholder=\"{{ ::attachmentTypePlaceholder }}\"\n                                 allow-clear=\"true\">\n                    <span>{{ attachmentViewModel.selectedAttachmentType.name }}</span>\n                </ui-select-match>\n\n                <ui-select-choices\n                    repeat=\"item in (attachmentViewModel.typeDataItems | filter: $select.search) track by $index\">\n                    <span>{{ item.name }}</span>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"descriptionIcon glyphicon glyphicon-pencil\"></span>\n        </div>\n        <div class=\"dockPanelCellContent collaborationAttachmentTextareaWrapper\">\n           <textarea maxlength = \"255\"\n                     ng-blur=\"onUpdateField()\"\n                     ng-if=\"isEditable()\"\n                     ng-model=\"attachmentViewModel.attachment.description\"\n                     ng-attr-placeholder=\"{{::attachmentViewModel.fileDescPlaceholder}}\"></textarea>\n            <span ng-if=\"!isEditable()\"\n                  class=\"readOnlyText\">{{ attachmentViewModel.attachment.description }}</span>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent collaborationInnerContent narrow\"\n         ng-if=\"isUnderwriterUser()\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"glyphicon glyphicon-eye-open\"\n                  uib-tooltip=\"{{::i18n.visibleToAgent}}\"\n                  tooltip-append-to-body=\"true\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <label class=\"dockPanelCheckbox visibleToAgentWrapper\"\n                   ng-class=\"{ selected: attachmentViewModel.attachment.shared }\">\n                <span>{{ i18n.visibleToAgent }}</span>\n                <input type=\"checkbox\"\n                       ng-disabled=\"!isEditable()\"\n                       ng-model=\"attachmentViewModel.attachment.shared\"\n                       ng-change=\"onUpdateField()\">\n            </label>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow\"\n         ng-if=\"attachmentViewModel.attachment.id\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"glyphicon glyphicon-user\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <collaboration-user-avatar label=\"submission.collaboration.attachment.createdBy\"\n                                       sublabel=\"{{attachmentViewModel.attachment.timeCreated | date:'short'}}\"\n                                       text=\"{{getAttachmentUserName()}}\"\n                                       userid=\"{{attachmentViewModel.attachment.createdBy.id}}\">\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent collaborationInnerContent subsequentCollaborationInnerContent\"\n         ng-if=\"attachmentViewModel.attachment.attachedToEmail\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"glyphicon glyphicon-envelope\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <div class=\"dockPanelUserCell\" ng-repeat=\"email in attachmentViewModel.emails\">\n                <a class=\"emailLinkInFile\" ng-click=\"openEmail(email)\">{{getEmailLabel(email)}}</a>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent fullHeight\"></div>\n\n    <div class=\"dockPanelInnerContent\">\n        <button ng-if=\"attachmentViewModel.deletePermission\"\n                class=\"btn btn-footer componentNoteDelete\"\n                ng-click=\"onDeleteClick()\">\n            <span class=\"glyphicon glyphicon-trash\"></span>\n            <span>{{::i18n.delete }}</span>\n        </button>\n\n        <div class=\"cancelUploadContainer\" ng-if=\"!attachmentViewModel.attachment.id\">\n            <button class=\"btn btn-primary\" class=\"uploadButton\"\n                    ng-disabled=\"viewModel.attachment.isEditorSaving || !attachmentViewModel.uploadedFile\"\n                    ng-class=\"{'is-saving':viewModel.attachment.isEditorSaving}\"\n                    ng-click=\"onSave()\">\n                {{::i18n.uploadFile }}\n            </button>\n\n            <button class=\"btn btn-footer cancelButton\" ng-click=\"onCancelClick()\">\n                {{::i18n.cancel }}\n            </button>\n        </div>\n\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(204);

/*@ngInject*/
var CollaborationAttachmentController = function CollaborationAttachmentController($scope, $timeout, $uibModal, $window, collaborationMediator, submissionUtil, coreConstant, coreMediator, authorizationConstants, dateUtil, attachmentUtil, preferenceModel, currentSubmissionModel, loadingBarHandler, modalUtil, attachmentMediator, submissionConstant, collaborationUtil, emailMessage) {
  $scope.i18n = locale;
  function resetAttachmentViewModel() {
    $scope.attachmentViewModel = {
      attachment: {},
      uploadedFile: null,
      typeDataItems: [],
      modifyPermission: null,
      deletePermission: null,
      sharePermission: null,
      unacceptedTypes: preferenceModel.get('system.allowedFileTypes').split('::'),
      chooseFileString: $scope.i18n.chooseFile,
      pleaseChooseString: $scope.i18n.type,
      fileDescPlaceholder: $scope.i18n.fileDescription,
      nameEditMode: false,
      editNameIconText: $scope.i18n.editFilename,
      editableName: null,
      originalFileExtension: null,
      email: null
    };
    loadDataSets();
  }
  function retrieveAttachment(attachmentId) {
    resetAttachmentViewModel();
    $scope.viewModel.isLoading = true;
    attachmentMediator.retrieveAttachment(attachmentId).then(function (attachment) {
      $scope.viewModel.isLoading = false;
      $scope.attachmentViewModel.attachment = attachment.Attachment;
      $scope.attachmentViewModel.modifyPermission = attachment[authorizationConstants.AUTHORIZATION_MODIFY_ATTACHMENTS];
      $scope.attachmentViewModel.deletePermission = attachment[authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS];
      $scope.attachmentViewModel.sharePermission = attachment[authorizationConstants.AUTHORIZATION_SHARE_ATTACHMENTS];
      $scope.attachmentViewModel.editableName = getEditableName($scope.attachmentViewModel.attachment.name);
      $scope.viewModel.attachment.isVisible = true;
      if ($scope.attachmentViewModel.attachment.attachedToEmail) {
        attachmentMediator.retrieveAttachmentEmails(attachmentId).then(function (emails) {
          $scope.attachmentViewModel.emails = emails;
        });
      }
      loadDataSets();
    });
  }
  function loadDataSets() {
    attachmentUtil.getAttachmentTypes().then(function (result) {
      var attachment = $scope.attachmentViewModel.attachment || {},
        attachmentType = attachment.type || {};
      $scope.attachmentViewModel.typeDataItems = result;
      $scope.attachmentViewModel.selectedAttachmentType = _.find(result, {
        name: attachmentType
      });
    });
  }
  function storeUploadedFile(uploadedFile) {
    var allowFile = attachmentUtil.validateAttachment(uploadedFile, _.get($scope.i18n, 'unacceptableTypeAndSize'));
    if (allowFile) {
      $timeout(function () {
        $scope.attachmentViewModel.uploadedFile = uploadedFile;
        if (!$scope.attachmentViewModel.attachment) {
          $scope.attachmentViewModel.attachment = {};
        }
        $scope.attachmentViewModel.attachment.name = uploadedFile.name;
        $scope.attachmentViewModel.attachment.size = uploadedFile.size;
        $scope.attachmentViewModel.attachment.name = uploadedFile.name;
        var fileSize = attachmentUtil.convertAttachmentSize(uploadedFile.size);
        $scope.attachmentViewModel.attachment.byteCountToDisplaySize = "(".concat(fileSize, ")");
        $scope.attachmentViewModel.editableName = getEditableName($scope.attachmentViewModel.attachment.name);
      }, 0);
    }
  }
  function getEditableName(attachmentName) {
    var fileNameParts = _.split(attachmentName, '.');
    if (fileNameParts.length > 1) {
      var fileExtension = _.last(fileNameParts);
      $scope.attachmentViewModel.originalFileExtension = fileExtension;
      return _.join(_.pull(fileNameParts, fileExtension), '.');
    }
    return attachmentName;
  }
  function appendOriginalFileExtension(attachmentName) {
    if (!_.isNil(attachmentName) && !_.isNil($scope.attachmentViewModel.originalFileExtension)) {
      return _.join([attachmentName, $scope.attachmentViewModel.originalFileExtension], '.');
    }
    return attachmentName;
  }
  $scope.attachmentTypePlaceholder = $scope.i18n.type;
  $scope.isEditable = function () {
    return !($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id) || $scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id && $scope.attachmentViewModel.modifyPermission;
  };
  $scope.isCurrentUser = function () {
    return $scope.attachmentViewModel && $scope.attachmentViewModel.attachment && $scope.viewModel.currentUserId === $scope.attachmentViewModel.attachment.createdBy.id;
  };
  $scope.getTitle = function () {
    if ($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id) {
      return $scope.i18n.viewFile;
    } else {
      return $scope.i18n.addFile;
    }
  };
  $scope.getAttachmentUserName = function () {
    var username = $scope.attachmentViewModel.attachment.createdBy.name;
    if ($scope.attachmentViewModel.attachment.createdBy.name === 'AUTHENTICATION_SERVER') {
      username = 'System';
    }
    return username;
  };
  $scope.attachmentDownloadClick = function () {
    var attachment = $scope.attachmentViewModel.attachment;
    if (!_.isNil(attachment.id)) {
      attachmentUtil.getAttachmentLinkURL(attachment.id, attachment.name).then(function (url) {
        $window.open(url, '_blank');
      });
    }
  };
  $scope.$watch('viewModel.selectedItem', function (newItem) {
    if (newItem && newItem.type === 'attachment' && newItem.id) {
      retrieveAttachment(newItem.id);
    }
  });
  $scope.$watch('viewModel.attachment.isEditorOpen', function (isEditorOpen) {
    if (isEditorOpen) {
      $scope.viewModel.selectedItem = {
        type: 'attachment'
      };
    }
  });
  $scope.$watch('viewModel.attachment.isVisible', function (newItem) {
    if (!newItem && $scope.attachmentViewModel.attachment) {
      resetAttachmentViewModel();
    }
  });
  $scope.fileSelected = function (file) {
    if (file) {
      storeUploadedFile(file);
    }
  };
  $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
    if (file) {
      storeUploadedFile(file);
    }
  });
  $scope.$on(submissionConstant.event.ATTACHMENT_EDITOR_DID_OPEN, function () {
    $scope.attachmentViewModel.attachment.shared = preferenceModel.get('system.shareAttachmentDefault') === 'true' ? true : false;
  });
  $scope.onCancelClick = function () {
    $scope.closeAttachmentEditor();
    resetAttachmentViewModel();
  };
  $scope.onUpdateField = function () {
    if (_.isEmpty($scope.attachmentViewModel.editableName)) {
      $scope.attachmentViewModel.editableName = getEditableName($scope.attachmentViewModel.attachment.name);
    } else {
      $scope.attachmentViewModel.attachment.name = appendOriginalFileExtension($scope.attachmentViewModel.editableName);
    }
    if ($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id) {
      $scope.updateAttachment($scope.attachmentViewModel.attachment);
    }
    $scope.attachmentViewModel.nameEditMode = false;
  };
  $scope.onUpdateSelectedType = function () {
    var attachment = $scope.attachmentViewModel.attachment;
    if ($scope.attachmentViewModel.selectedAttachmentType) {
      attachment.type = $scope.attachmentViewModel.selectedAttachmentType.name;
    } else {
      attachment.type = '';
    }

    // Only update the attachment if it exists, otherwise the type will be saved on upload.
    if (!_.isNil(attachment.id)) {
      $scope.updateAttachment(attachment);
    }
  };
  $scope.getEmailLabel = function (email) {
    return $scope.i18n.email + ' ' + dateUtil.formatShortDateAndTime(email.sentDate);
  };
  $scope.openEmail = function (email) {
    $scope.attachmentViewModel.email = email;
    $scope.setToOrCcUsers(email, 'to');
    $scope.setToOrCcUsers(email, 'cc');
    modalUtil.showEmailViewer($scope.attachmentViewModel.email, $scope.forwardEmail, $scope.replyEmail, $scope.replyAllEmail);
  };
  $scope.setToOrCcUsers = function (email, type) {
    var userArray = _.split(type === 'to' ? email.to : email.cc, emailMessage.EMAIL_ADDRESS_SEPERATOR),
      recipientList = [];
    coreMediator.loadUsersList(email.submissionId).then(function (users) {
      _.each(userArray, function (toUser) {
        var addedUser = false;
        _.each(users, function (user) {
          var userString = collaborationUtil.getEmailIdentifierString(user.name, user.emailAddress);
          if (toUser === userString) {
            recipientList.push(user);
            addedUser = true;
          }
        });
        if (!addedUser) {
          recipientList.push(toUser);
        }
      });
      if (type === 'to') {
        $scope.attachmentViewModel.email.toUsers = recipientList;
      } else {
        $scope.attachmentViewModel.email.ccUsers = recipientList;
      }
    });
  };
  $scope.replyEmail = function (emailId) {
    loadingBarHandler.showLoadingBar('submission.collaboration.email.replyingToEmail');
    $scope.newEmailId = emailId;
    collaborationMediator.replyEmail(emailId);
  };
  $scope.replyAllEmail = function (emailId) {
    loadingBarHandler.showLoadingBar('submission.collaboration.email.replyingToEmail');
    $scope.newEmailId = emailId;
    collaborationMediator.replyAllEmail(emailId);
  };
  $scope.forwardEmail = function (emailId) {
    loadingBarHandler.showLoadingBar('submission.collaboration.email.creatingForward');
    $scope.newEmailId = emailId;
    collaborationMediator.forwardEmail(emailId);
  };
  $scope.$on(submissionConstant.event.CREATE_COLLABORATION_ITEM_MESSAGE, function (event, payload) {
    if (payload.type === 'email' && $scope.newEmailId) {
      $timeout(function () {
        var submissionId = currentSubmissionModel.getCurrentSubmission().id;
        loadingBarHandler.hideLoadingBar();
        $scope.$emit(coreConstant.event.SHOW_EMAIL_EDITOR, payload.id, submissionId, /*chatMessageId*/undefined, /*emailMessageId*/undefined, /*notificationId*/undefined, /*deleteNewEmailOnCancel*/true, /*isReplyOrForward*/true);
        $scope.newEmail = null;
      }, 50);
    }
  });
  $scope.onSave = function () {
    var submissionId = currentSubmissionModel.getCurrentSubmission().id,
      payload = attachmentUtil.getAttachmentPayload($scope.attachmentViewModel.attachment);
    payload = _.assign(payload, {
      'ownerUri': 'com.firstbest.underwriting.submission.Submission:' + submissionId,
      'submissionId': submissionId
    });
    $scope.saveAttachment(payload, $scope.attachmentViewModel.uploadedFile);
  };
  $scope.onDeleteClick = function () {
    var _options = {
      title: $scope.i18n.deleteAttachmentTitle,
      summary: $scope.i18n.deleteAttachmentConfirmationMessage,
      cancelButtonLabel: $scope.i18n.cancelActionButtonLabel,
      confirmActionButtonLabel: $scope.i18n.confirmActionButtonLabel
    };
    var modalInstance = $uibModal.open({
      templateUrl: '/ui/modal/modal.tpl.html',
      controller: 'modalController',
      windowClass: 'genericModal',
      backdrop: 'static',
      resolve: {
        options: function options() {
          return _options;
        }
      }
    });
    function handleClose() {
      deleteAttachment();
    }
    modalInstance.result.then(handleClose);
    function deleteAttachment() {
      if ($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id) {
        $scope.deleteAttachment($scope.attachmentViewModel.attachment.id);
      }
    }
  };
  $scope.activateEditFilename = function () {
    $scope.attachmentViewModel.nameEditMode = true;
  };
  resetAttachmentViewModel();
};
CollaborationAttachmentController.$inject = ["$scope", "$timeout", "$uibModal", "$window", "collaborationMediator", "submissionUtil", "coreConstant", "coreMediator", "authorizationConstants", "dateUtil", "attachmentUtil", "preferenceModel", "currentSubmissionModel", "loadingBarHandler", "modalUtil", "attachmentMediator", "submissionConstant", "collaborationUtil", "emailMessage"];
angular.module('gw-um-submission').controller('collaborationAttachmentController', CollaborationAttachmentController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 204 */
/***/ (function(module) {

module.exports = JSON.parse("{\"uploadFile\":\"Upload File\",\"dragAndDrop\":\"Drag and Drop File Here\",\"or\":\"or\",\"unacceptableTypeAndSize\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for upload.\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\",\"maxFileSizeTitle\":\"File Too Big\",\"maxFileSizeMessage\":\"The file you are trying to upload exceeds the maximum allowed file size of {maxSize} MB.\"},\"deleteAttachmentTitle\":\"Delete Attachment\",\"deleteAttachmentConfirmationMessage\":\"Are you sure you want to delete the selected attachment?\",\"chooseFile\":\"Choose File\",\"type\":\"Type\",\"fileDescription\":\"File Description\",\"fileNotPreviewed\":\"Document preview is not available for this type of document. Please click on the link below in order to open the document in a new browser window.\",\"editFilename\":\"Edit file name\",\"addFile\":\"New File\",\"viewFile\":\"File\",\"email\":\"Sent via email on\",\"confirmActionButtonLabel\":\"Yes\",\"cancelActionButtonLabel\":\"No\",\"cancel\":\"Cancel\",\"delete\":\"Delete\",\"visibleToAgent\":\"Visible to agent\"}");

/***/ }),
/* 205 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadSubmissionAttachmentsRepository = function LoadSubmissionAttachmentsRepository(baseRepository, attachmentUtil) {
  angular.extend(this, baseRepository);
  this.loadSubmissionAttachments = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/Attachments';
    return this.get(url);
  };
  this.loadSharedSubmissionAttachments = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/Attachments',
      config = {
        params: {
          shared: true
        }
      };
    return this.get(url, config);
  };
};
LoadSubmissionAttachmentsRepository.$inject = ["baseRepository", "attachmentUtil"];
angular.module('gw-um-submission').service('loadSubmissionAttachmentsRepository', LoadSubmissionAttachmentsRepository);

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/collaboration/chat/collaborationChat.tpl.html';
var html = "<div class=\"searchRow\">\n\n    <div class=\"dockPanelSearchForm\">\n\n        <img class=\"svgicon icon-collaboration_search\"\n             src=\"" + __webpack_require__(81) + "\"/>\n\n        <input type=\"search\"\n               ng-disabled=\"!chatViewModel.hasChatUsers\"\n               ng-model=\"chatViewModel.searchInput\"\n               ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n               class=\"searchInput form-control allCollaborationSearch\"\n               ng-change=\"onChatSearchInputChange()\"\n               placeholder=\"{{ chatViewModel.searchPlaceholder }}\"/>\n\n        <span ng-if=\"chatViewModel.searchInput !== ''\"\n              ng-click=\"onChatClearSearchInput()\"\n              class=\"glyphicon glyphicon-remove form-control-feedback\"></span>\n\n        <ui-chat-members chat-members=\"chatViewModel.chatMembers\"\n                         has-invite-permission=\"canInviteMembers()\"></ui-chat-members>\n\n    </div>\n</div>\n\n<div class=\"chatDisabledMessage\"\n     ng-if=\"chatViewModel.disabledByStatus\">\n    <i class=\"glyphicon glyphicon-info-sign\"></i>\n    <label>{{ ::i18n.chatDisabledMessage }}</label>\n</div>\n\n<div class=\"chatDisabledMessage\"\n     ng-if=\"!chatViewModel.disabledByStatus && chatViewModel.hasChatUsers && !chatViewModel.hasAvailableChatUsers\">\n    <i class=\"glyphicon glyphicon-info-sign\"></i>\n    <label>{{ ::i18n.noChatMembersAvailableMessage }}</label>\n</div>\n\n<ul class=\"dockPanelCellList collaborationCellList chatCellList\"\n    ui-scroll-to-bottom\n    ui-scroll-to-item\n    ng-class=\"{'invisible': chatViewModel.isLoading}\">\n\n    <li class=\"dockPanelCell collaborationCell chatCell item-id-{{chatMessage.id}}\"\n        ng-repeat=\"chatMessage in chatViewModel.filteredChatMessageList track by chatMessage.id\">\n\n        <div class=\"dateDivider\"\n             ng-if=\"shouldShowDateDivider(chatMessage)\">\n            <hr/>\n            {{getDateDividerText(chatMessage)}}\n            <hr/>\n        </div>\n\n        <div class=\"cellGroup\">\n            <div class=\"cellSide\"\n                 ng-class=\"{'yourCellSide': isCurrentUser(chatMessage)}\">\n                <ui-user-avatar userid={{chatMessage.authorId}}\n                                icon=\"message\"\n                                chat-message-id=\"{{chatMessage.id}}\"\n                                ng-if=\"shouldShowUserInfo(chatMessage)\"></ui-user-avatar>\n            </div>\n            <div class=\"cellContent\"\n                 ng-class=\"{'yourCellContent': isCurrentUser(chatMessage)}\">\n                <div class=\"cellContentLeft\">\n                    <h3>\n                        <span ng-if=\"shouldShowUserInfo(chatMessage)\">{{ getAuthorName(chatMessage) }}</span>\n                        <span ng-class=\"{'titleSubtextWithoutDot': !shouldShowUserInfo(chatMessage),\n                                         'titleSubtext': shouldShowUserInfo(chatMessage)}\"\n                              ng-if=\"chatMessage.dateTimeSent\">\n\n                            <ui-reload-relative-time\n                                ng-if=\"!chatViewModel.isPrintingCollab\"\n                                time=\"{{chatMessage.dateTimeSent}}\"\n                                interval=\"1\"></ui-reload-relative-time>\n\n                            <span nf-if=\"chatViewModel.isPrintingCollab\">\n                                {{ chatMessage.dateTimeSent | date : viewModel.preferenceDateFormat + ' hh:mm a' }}\n                            </span>\n                        </span>\n                        <span class=\"titleSubtext\" ng-if=\"isUnderwriterUser()\">\n                            <span class=\"glyphicon glyphicon-eye-open chatEyeIcon\"\n                                  uib-tooltip=\"{{::i18n.visibleToAgent}}\"\n                                  tooltip-append-to-body=\"true\"></span>\n                        </span>\n                        <span class=\"svgicon icon-collaborationChatAllIcon\"\n                              ng-if=\"chatMessage.published\"></span>\n                    </h3>\n\n                    <div class=\"chatSummary\">\n                        <p ng-bind=\"chatMessage.body\"></p>\n                    </div>\n                </div>\n\n                <div class=\"btn-group\"\n                     ng-if=\"isUnderwriterUser()\"\n                     uib-dropdown\n                     dropdown-append-to-body=\"true\">\n\n                    <button type=\"button\"\n                            class=\"btn btn-xs\"\n                            uib-dropdown-toggle>\n                        <span class=\"fa fa-angle-down\"></span>\n                    </button>\n\n                    <ul class=\"dropdown-menu dropdown-menu-right\"\n                        uib-dropdown-menu>\n\n                        <li ng-if=\"!chatMessage.published\">\n                            <button type=\"button\"\n                                    class=\"btn btn-link\"\n                                    ng-click=\"publish(chatMessage)\">\n                                {{ i18n.showInAllView }}\n                            </button>\n                        </li>\n                        <li ng-if=\"chatMessage.published\">\n                            <button type=\"button\"\n                                    class=\"btn btn-link\"\n                                    ng-click=\"unpublish(chatMessage)\">\n                                {{ i18n.removeFromAllView }}\n                            </button>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </li>\n</ul>\n\n<div class=\"sendMessage\">\n    <textarea class=\"textarea sendMessageTextArea\"\n              ng-attr-placeholder=\"{{ i18n.sendPlaceholder }}\"\n              ng-keypress=\"sendChatMessage($event)\"\n              ng-model=\"chatViewModel.chatMessageBody\"\n              maxlength=\"255\"\n              ng-disabled=\"chatViewModel.disabledByStatus || !chatViewModel.hasChatUsers || !chatViewModel.hasPermission\"\n              ui-auto-focus=\"true\"></textarea>\n</div>\n\n<div ng-if=\"chatViewModel.isLoading\">\n    <div class=\"icon-spinner\">\n        <img src=\"" + __webpack_require__(37) + "\"/>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {__webpack_require__(209);
var locale = __webpack_require__(215);

/*@ngInject*/
var CollaborationChatController = function CollaborationChatController($interval, $rootScope, $scope, $state, $stateParams, $location, $timeout, $uibModal, coreConstant, currentUserModel, currentSubmissionModel, submissionStatus, coreMediator, collaborationMediator, submissionConstant, appTypeConfigurationModel, authorizationConstants, preferenceModel) {
  var timeoutList = [];
  var chatMemberIntervalObject, chatMemberListPollingInterval;
  $scope.i18n = locale;
  $scope.chatViewModel = {
    submissionId: null,
    searchPlaceholder: '',
    sendPlaceholder: '',
    chatMessageList: [],
    filteredChatMessageList: [],
    chatMessageBody: '',
    isLoading: false,
    searchInput: '',
    disabledByStatus: false,
    hasChatUsers: true,
    hasAvailableChatUsers: true,
    you: '',
    isPrintingCollab: $state.current.name === 'submission.printCollaboration'
  };
  $scope.chatViewModel.searchPlaceholder = $scope.i18n.searchPlaceholder;
  $scope.chatViewModel.sendPlaceholder = $scope.i18n.sendPlaceholder;
  $scope.chatViewModel.you = $scope.i18n.you;
  $scope.chatViewModel.hasPermission = currentUserModel.hasAuthorization(authorizationConstants.LIVE_CHAT);
  $scope.getDateDividerText = function (chatMessage) {
    var dateTimeSent = moment(chatMessage.dateTimeSent),
      today = moment();
    var dateText;
    if (today.isSame(dateTimeSent, 'day')) {
      dateText = $scope.i18n.today;
    } else {
      if (!today.isSame(dateTimeSent, 'year')) {
        dateText = dateTimeSent.format('MMMM D, YYYY');
      } else {
        dateText = dateTimeSent.format('MMMM D');
      }
    }
    return dateText;
  };
  $scope.isCurrentUser = function (chatMessage) {
    return chatMessage.authorId === currentUserModel.getCurrentUser().userId;
  };
  $scope.getAuthorName = function (chatMessage) {
    var isCurrentUser = $scope.isCurrentUser(chatMessage);
    var isPrintingCollab = $scope.chatViewModel.isPrintingCollab;
    if (isCurrentUser && !isPrintingCollab) {
      return $scope.chatViewModel.you;
    }
    return chatMessage.authorName;
  };
  $scope.shouldShowDateDivider = function (chatMessage) {
    var dateTimeSent = moment(chatMessage.dateTimeSent),
      chatMessageIndex = _.findIndex($scope.chatViewModel.filteredChatMessageList, function (filteredChatMessage) {
        return chatMessage.id === filteredChatMessage.id;
      }),
      today = moment();
    if (chatMessageIndex > 0) {
      var previousChatMessage = $scope.chatViewModel.filteredChatMessageList[chatMessageIndex - 1];
      var previousDateTimeSent = moment(previousChatMessage.dateTimeSent);
      if (!dateTimeSent.isSame(previousDateTimeSent, 'day')) {
        return true;
      }
    } else if (chatMessageIndex === 0 && !today.isSame(dateTimeSent, 'day')) {
      return true;
    }
    return false;
  };
  $scope.shouldShowUserInfo = function (chatMessage) {
    var chatMessageIndex = _.findIndex($scope.chatViewModel.filteredChatMessageList, function (filteredChatMessage) {
      return chatMessage.id === filteredChatMessage.id;
    });
    if (chatMessageIndex > 0) {
      var previousChatMessage = $scope.chatViewModel.filteredChatMessageList[chatMessageIndex - 1];
      return previousChatMessage.authorId !== chatMessage.authorId;
    }
    return true;
  };
  $scope.publish = function (chatMessage) {
    collaborationMediator.publishChatMessage(chatMessage.id);
  };
  $scope.unpublish = function (chatMessage) {
    collaborationMediator.unpublishChatMessage(chatMessage.id);
  };
  $scope.onChatSearchInputChange = function () {
    var scrollToBottom = false;
    processChatMessageList(scrollToBottom);
  };
  $scope.onChatClearSearchInput = function () {
    $scope.chatViewModel.searchInput = '';
    $scope.onChatSearchInputChange();
  };
  $scope.sendChatMessage = function (event) {
    var chatMessage = {};
    if (event.keyCode === 13 && !_.isEmpty(_.trim($scope.chatViewModel.chatMessageBody))) {
      event.preventDefault();
      chatMessage.body = $scope.chatViewModel.chatMessageBody;
      $scope.chatViewModel.chatMessageBody = '';
      collaborationMediator.sendChatMessage($stateParams.submissionId, chatMessage);
    }
  };
  $scope.$on(submissionConstant.event.CREATE_CHAT_MESSAGE, function (event, chatMessage) {
    var scrollToBottom = true;
    $scope.chatViewModel.chatMessageList.push(chatMessage);
    processChatMessageList(scrollToBottom);
  });
  $scope.$on(submissionConstant.event.UPDATE_CHAT_MESSAGE, function (event, chatMessage) {
    var scrollToBottom = false,
      index = _.findIndex($scope.chatViewModel.chatMessageList, function (existingChatMessage) {
        return existingChatMessage.uri === chatMessage.uri;
      });
    if (index !== -1) {
      $scope.chatViewModel.chatMessageList.splice(index, 1, chatMessage);
    } else {
      $scope.chatViewModel.chatMessageList.push(chatMessage);
    }
    processChatMessageList(scrollToBottom);
  });
  $scope.$on(submissionConstant.event.DELETE_CHAT_MESSAGE, function (event, chatMessage) {
    var scrollToBottom = false;
    _.remove($scope.chatViewModel.chatMessageList, function (existingChatMessage) {
      return existingChatMessage.uri === chatMessage.uri;
    });
    processChatMessageList(scrollToBottom);
  });
  $scope.$on('$destroy', function () {
    coreMediator.leaveChat($scope.chatViewModel.submissionId);
    $scope.stopChatMembersPollInterval();
    _.each(timeoutList, function (item) {
      if (item) {
        $timeout.cancel(item);
      }
    });
  });
  $scope.$on(submissionConstant.event.COLLABORATION_DID_CLOSE, function () {
    coreMediator.leaveChat($scope.chatViewModel.submissionId);
    $scope.stopChatMembersPollInterval();
  });
  $scope.$on(submissionConstant.event.COLLABORATION_DID_OPEN, function () {
    coreMediator.enterChat($scope.chatViewModel.submissionId);
    updateChatNotificationRecipients();
    $scope.startChatMembersPollInterval();
  });
  $scope.startChatMembersPollInterval = function () {
    if (_.isNil(chatMemberIntervalObject)) {
      chatMemberIntervalObject = $interval(function () {
        updateChatNotificationRecipients();
      }, chatMemberListPollingInterval);
    }
  };
  $scope.stopChatMembersPollInterval = function () {
    if (!_.isNil(chatMemberIntervalObject)) {
      $interval.cancel(chatMemberIntervalObject);
      chatMemberIntervalObject = null;
    }
  };
  $scope.$on(coreConstant.event.UPDATE_SUBMISSION, function () {
    updateChatNotificationRecipients();
  });
  $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function () {
    updateChatNotificationRecipients();
  });
  function processChatMessageList(scrollToBottom, initialLoad) {
    function chatMessageListFilterFunction(chatMessage) {
      return _.includes(_.toUpper(chatMessage.body), _.toUpper($scope.chatViewModel.searchInput)) || _.includes(_.toUpper(chatMessage.authorName), _.toUpper($scope.chatViewModel.searchInput));
    }
    $scope.chatViewModel.filteredChatMessageList = _.isEmpty($scope.chatViewModel.searchInput) ? $scope.chatViewModel.chatMessageList : _.filter($scope.chatViewModel.chatMessageList, chatMessageListFilterFunction);
    if (initialLoad && $scope.viewModel.selectedItem && $scope.viewModel.selectedItem.id) {
      $scope.$broadcast(coreConstant.event.SCROLL_TO_ITEM, $scope.viewModel.selectedItem.id);
    } else if (scrollToBottom) {
      $scope.$broadcast(coreConstant.event.SCROLL_TO_BOTTOM);
    }
    timeoutList.push($timeout(function () {}, 0));
  }
  function loadChatMessageList() {
    var scrollToBottom = true,
      initialLoad = true;
    $scope.chatViewModel.isLoading = true;
    collaborationMediator.getChatMessageList($stateParams.submissionId).then(function (chatMessageList) {
      $scope.chatViewModel.chatMessageList = chatMessageList;
      processChatMessageList(scrollToBottom, initialLoad);
    }).finally(function () {
      timeoutList.push($timeout(function () {
        $scope.chatViewModel.isLoading = false;
      }, 400));
    });
  }
  function updateChatNotificationRecipients() {
    if (!$stateParams.submissionId) return;
    coreMediator.getChatNotificationRecipients($stateParams.submissionId).then(function (users) {
      var submission = currentSubmissionModel.getCurrentSubmission();
      if (submission && submission.status < submissionStatus.SUBMITTED) {
        $scope.chatViewModel.disabledByStatus = true;
      } else {
        $scope.chatViewModel.disabledByStatus = false;
      }
      $scope.chatViewModel.chatMembers = users;
      $scope.chatViewModel.hasChatUsers = users != null && users.length > 1;
      if (!_.isNil($scope.chatViewModel.chatMembers)) {
        var numberOfAvailableChatUsers = 0;
        _.each(users, function (user) {
          if (user.availableToChat && currentUserModel.getCurrentUser().userId !== user.id) {
            numberOfAvailableChatUsers++;
          }
        });
        $scope.chatViewModel.hasAvailableChatUsers = numberOfAvailableChatUsers > 0;
      }
    });
  }
  loadChatMessageList();
  updateChatNotificationRecipients();
  $scope.chatViewModel.submissionId = $stateParams.submissionId;
  coreMediator.enterChat($scope.chatViewModel.submissionId);
  chatMemberListPollingInterval = preferenceModel.get('system.chatMemberListPollingInterval') || submissionConstant.CHAT_MEMBER_LIST_FALLBACK_POLLING_INTERVAL;
  $scope.startChatMembersPollInterval();
};
CollaborationChatController.$inject = ["$interval", "$rootScope", "$scope", "$state", "$stateParams", "$location", "$timeout", "$uibModal", "coreConstant", "currentUserModel", "currentSubmissionModel", "submissionStatus", "coreMediator", "collaborationMediator", "submissionConstant", "appTypeConfigurationModel", "authorizationConstants", "preferenceModel"];
angular.module('gw-um-submission').controller('collaborationChatController', CollaborationChatController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
var ChatMembersComponent = {
  templateUrl: '/collaboration/chat/chatMembers/chatMembers.tpl.html',
  controller: 'chatMembersController',
  bindings: {
    chatMembers: '<',
    hasInvitePermission: '<'
  }
};
angular.module('gw-um-submission').component('uiChatMembers', ChatMembersComponent);

/***/ }),
/* 210 */
/***/ (function(module, exports) {

var path = '/collaboration/chat/chatMembers/chatMembers.tpl.html';
var html = "<div class=\"chatMembersContainer\">\n    <a class=\"btn btn-default chatMembersButton\"\n       ng-click=\"$ctrl.onChatMembersButtonClick()\"\n       uib-tooltip=\"{{ ::$ctrl.getChatMemberButtonTooltip() }}\"\n       tooltip-popup-delay=\"500\"\n       tooltip-append-to-body=\"true\"\n       tooltip-placement=\"left\"\n       tooltip-enable=\"!$ctrl.isOpen\">\n        <i class=\"fa fa-users\"\n           ng-class=\"{noMembersAvailable: !$ctrl.areAnyMembersAvailable()}\"></i>\n\n        <span ng-if=\"$ctrl.areAnyMembersAvailable()\"\n              class=\"glyphicon glyphicon-online\"></span>\n\n        <span ng-if=\"!$ctrl.areAnyMembersAvailable()\"\n              class=\"glyphicon glyphicon-offline\"></span>\n    </a>\n    <div ng-show=\"$ctrl.isOpen\"\n         ui-auto-close\n         on-close=\"$ctrl.onChatMembersButtonClick()\"\n         is-open=\"$ctrl.isOpen\">\n\n        <ui-chat-members-dropdown chat-members=\"$ctrl.chatMembers\"\n                                  has-invite-permission=\"$ctrl.hasInvitePermission\"/>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(82);

/*@ngInject*/
var ChatMembersController = function ChatMembersController($element, currentUserModel) {
  this.i18n = locale;
  this.isOpen = false;
  this.$onInit = function () {
    $element.addClass('chatMembers');
    this.currentUserId = currentUserModel.getCurrentUser().userId;
  };
  this.getChatMemberButtonTooltip = function () {
    if (this.hasInvitePermission) {
      return this.i18n.chatMembers.viewInviteChatMembersButtonTooltip;
    }
    return this.i18n.chatMembers.viewChatMembersButtonTooltip;
  };
  this.areAnyMembersAvailable = function () {
    var _this = this;
    var numberOfAvailableMembers = 0;
    if (!_.isNil(this.chatMembers)) {
      _.each(this.chatMembers, function (chatMember) {
        if (chatMember.availableToChat && chatMember.id !== _this.currentUserId) {
          numberOfAvailableMembers++;
        }
      });
    }
    return numberOfAvailableMembers > 0;
  };
  this.onChatMembersButtonClick = function () {
    this.isOpen = !this.isOpen;
  };
};
ChatMembersController.$inject = ["$element", "currentUserModel"];
angular.module('gw-um-submission').controller('chatMembersController', ChatMembersController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(83);
__webpack_require__(213);
__webpack_require__(214);
var ChatMembersDropdownComponent = {
  templateUrl: '/collaboration/chat/chatMembers/chatMembersDropdown/chatMembersDropdown.tpl.html',
  controller: 'chatMembersDropdownController',
  bindings: {
    chatMembers: '<',
    hasInvitePermission: '<'
  }
};
angular.module('gw-um-submission').component('uiChatMembersDropdown', ChatMembersDropdownComponent);

/***/ }),
/* 213 */
/***/ (function(module, exports) {

var path = '/collaboration/chat/chatMembers/chatMembersDropdown/chatMembersDropdown.tpl.html';
var html = "<div class=\"chatMembersDropdownContainer\">\n    <span class=\"submissionParticipants\">{{ ::$ctrl.i18n.chatMembersDropdown.submissionParticipants }}</span>\n\n    <ul>\n\n        <li ng-repeat=\"chatMember in $ctrl.chatMembers track by $index\"\n            class=\"chatMemberRow\">\n            <ui-user-avatar class=\"\"\n                userid=\"{{::chatMember.id}}\"></ui-user-avatar>\n\n            <span class=\"chatMemberName {{ ::$ctrl.getChatMemberNameSelector(chatMember) }}\">{{ ::chatMember.firstName }} {{ ::chatMember.lastName }}</span>\n\n            <span class=\"you\"\n                  ng-if=\"$ctrl.currentUserId === chatMember.id\">{{ ::$ctrl.i18n.chatMembersDropdown.you }}</span>\n\n            <span ng-if=\"chatMember.availableToChat\"\n                  class=\"glyphicon glyphicon-online\"></span>\n\n            <span ng-if=\"!chatMember.availableToChat\"\n                  class=\"glyphicon glyphicon-offline\"></span>\n        </li>\n\n        <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n    </ul>\n\n    <a class=\"menuItem\"\n       ng-click=\"$ctrl.inviteChatUser()\"\n       ng-if=\"::$ctrl.hasInvitePermission\">\n        <div class=\"inviteChatBox\">\n            <i class=\"fa fa-user\"></i>\n            <span>{{ ::$ctrl.i18n.chatMembersDropdown.inviteOthers }}</span>\n        </div>\n    </a>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(83);

/*@ngInject*/
var ChatMembersDropdownController = function ChatMembersDropdownController($element, $uibModal, currentUserModel, formatUtil) {
  this.$onInit = function () {
    $element.addClass('chatMembersDropdown');
    this.i18n = locale;
    this.currentUserId = currentUserModel.getCurrentUser().userId;
  };
  this.getChatMemberNameSelector = function (chatMember) {
    var chatMemberName = chatMember.firstName + chatMember.lastName;
    return formatUtil.formatAsSelector(chatMemberName);
  };
  this.inviteChatUser = function () {
    $uibModal.open({
      templateUrl: '/collaboration/chat/inviteChat/inviteChatModal.tpl.html',
      controller: 'inviteChatModalController',
      windowClass: 'inviteChatModal',
      keyboard: false,
      backdrop: 'static'
    });
  };
};
ChatMembersDropdownController.$inject = ["$element", "$uibModal", "currentUserModel", "formatUtil"];
angular.module('gw-um-submission').controller('chatMembersDropdownController', ChatMembersDropdownController);

/***/ }),
/* 215 */
/***/ (function(module) {

module.exports = JSON.parse("{\"removeFromAllView\":\"Remove from All View\",\"searchPlaceholder\":\"Search Chat\",\"sendPlaceholder\":\"Send a message\",\"showInAllView\":\"Show in All View\",\"title\":\"Chat\",\"today\":\"Today\",\"you\":\"You\",\"chatDisabledMessage\":\"Chat will be available once this application is Submitted\",\"visibleToAgent\":\"Visible to agent\",\"noChatMembersAvailableMessage\":\"None of the submission participants are available. They will be notified of your chat when they are online\"}");

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

var path = '/collaboration/chat/inviteChat/inviteChatModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    ok-button-class=\"viewModel.buttonClass\">\n\n    <div class=\"inviteChatModalContent\" ui-browser-detection>\n\n        <div class=\"warningRow\">\n            <i class=\"fa fa-info-circle\"></i>\n            <div class=\"warningText\">\n                {{::viewModel.warningText}}\n            </div>\n        </div>\n\n        <div class=\"peopleRow\" ng-if=\"!viewModel.isInvitationSent\">\n            <div class=\"peopleLabel\">\n                <span>{{::viewModel.peopleLabel}}</span>\n            </div>\n\n            <ui-multi-select class=\"multiSelect\"\n                             items-list=\"viewModel.userList\"\n                             prompt-value=\"viewModel.promptValue\"\n                             item-name=\"viewModel.itemName\"\n                             append-to-body=\"'true'\">\n            </ui-multi-select>\n        </div>\n\n        <div class=\"peopleRow comments\" ng-if=\"!viewModel.isInvitationSent\">\n            <textarea class=\"commentsTextArea\" ng-model=\"viewModel.defaultMessage\" maxlength=\"255\"></textarea>\n        </div>\n\n        <div class=\"peopleRow invited\" ng-if=\"viewModel.isInvitationSent\">\n            <span class=\"glyphicon glyphicon-ok greenCheck\"></span>\n            <span class=\"successMessage\">{{::viewModel.successMessage}}</span>\n            <span class=\"successUserMessage\">{{::viewModel.successUserMessage}}</span>\n        </div>\n\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(219);
/*@ngInject*/
var InviteChatModalController = function InviteChatModalController($rootScope, $scope, $stateParams, coreMediator, coreConstant, collaborationMediator) {
  $scope.i18n = locale;
  $scope.viewModel = {
    title: $scope.i18n.title,
    cancelButton: $scope.i18n.cancelButton,
    okButton: $scope.i18n.inviteButton,
    promptValue: $scope.i18n.promptValue,
    peopleLabel: $scope.i18n.people,
    defaultMessage: $scope.i18n.defaultMessage,
    successMessage: $scope.i18n.successMessage,
    successUserMessage: $scope.i18n.successUserMessage,
    warningText: $scope.i18n.warningText,
    userList: [],
    buttonClass: 'btn-success',
    itemName: 'chat',
    isInvitationSent: false,
    selectedUserIds: [],
    selectedUsers: []
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
    if (itemName === $scope.viewModel.itemName) {
      $scope.viewModel.selectedUsers = [];
      _.each($scope.viewModel.userList, function (user) {
        if (user.selected) {
          $scope.viewModel.selectedUsers.push(user);
        }
      });
    }
  });
  $scope.onConfirm = function () {
    var selectedUserNames = '',
      count = 0;
    _.each($scope.viewModel.selectedUsers, function (user) {
      count++;
      $scope.viewModel.selectedUserIds.push(user.id);
      if (selectedUserNames !== '') {
        if (count === $scope.viewModel.selectedUsers.length) {
          selectedUserNames += ' and ';
        } else {
          selectedUserNames += ', ';
        }
      }
      selectedUserNames += user.name;
    });
    collaborationMediator.sendChatInvitation($stateParams.submissionId, $scope.viewModel.selectedUserIds, $scope.viewModel.defaultMessage).then(function () {
      $scope.$dismiss();
      $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLEAR, $scope.viewModel.itemName);
      $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, $scope.i18n.notificationMessage);
    });
  };
  $scope.onCancel = function () {
    if ($scope.viewModel.selectedUsers.length > 0) {
      $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLEAR, $scope.viewModel.itemName);
    }
    $scope.$dismiss();
  };
  $scope.canEnableConfirmButton = function () {
    return $scope.viewModel.selectedUsers.length > 0;
  };
  $scope.init = function () {
    coreMediator.loadUsersList($stateParams.submissionId).then(function (users) {
      $scope.viewModel.userList = users;
    });
  };
  $scope.init();
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
InviteChatModalController.$inject = ["$rootScope", "$scope", "$stateParams", "coreMediator", "coreConstant", "collaborationMediator"];
angular.module('gw-um-submission').controller('inviteChatModalController', InviteChatModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 219 */
/***/ (function(module) {

module.exports = JSON.parse("{\"cancelButton\":\"Cancel\",\"defaultMessage\":\"I would like to chat with you about this submission.\",\"doneButton\":\"Done\",\"inviteButton\":\"Invite\",\"notificationMessage\":\"Your invitation to chat was successfully sent.\",\"people\":\"People\",\"promptValue\":\"Please Select People\",\"successMessage\":\"Successfully invited {0} people\",\"successUserMessage\":\"{0} will receive your invitation in their chat notification.\",\"title\":\"Invite People to Chat\",\"warningText\":\"Invitees are not permanent members of this chat and will only get an initial invite notification\"}");

/***/ }),
/* 220 */
/***/ (function(module, exports) {

/*@ngInject*/
var ChatMessageListRepository = function ChatMessageListRepository(baseRepository, currentSubmissionModel) {
  angular.extend(this, baseRepository);
  this.getChatMessageList = function (submissionId) {
    var url = '/rest/ChatMessage/List',
      params = {
        submissionId: submissionId,
        registrationIdentifier: '/Submission/' + submissionId
      };
    currentSubmissionModel.addRegistration({
      url: url,
      params: params
    });
    return this.get(url, {
      params: params
    });
  };
};
ChatMessageListRepository.$inject = ["baseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('chatMessageListRepository', ChatMessageListRepository);

/***/ }),
/* 221 */
/***/ (function(module, exports) {

/*@ngInject*/
var InviteChatRepository = function InviteChatRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.sendChatInvitation = function (submissionId, userIds, message) {
    var url = '/rest/ChatRoom/' + submissionId + '/invite',
      config = {
        params: {
          userIds: userIds,
          message: message
        }
      };
    return this.post(url, {}, config);
  };
};
InviteChatRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('inviteChatRepository', InviteChatRepository);

/***/ }),
/* 222 */
/***/ (function(module, exports) {

/*@ngInject*/
var PublishChatMessageRepository = function PublishChatMessageRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.publishChatMessage = function (chatMessageId) {
    var url = '/rest/ChatMessage/' + chatMessageId + '/publish';
    return this.post(url);
  };
};
PublishChatMessageRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('publishChatMessageRepository', PublishChatMessageRepository);

/***/ }),
/* 223 */
/***/ (function(module, exports) {

/*@ngInject*/
var SendChatMessageRepository = function SendChatMessageRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.sendChatMessage = function (submissionId, chatMessage) {
    var url = '/rest/ChatMessage?submissionId=' + submissionId;
    return this.post(url, chatMessage);
  };
};
SendChatMessageRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('sendChatMessageRepository', SendChatMessageRepository);

/***/ }),
/* 224 */
/***/ (function(module, exports) {

/*@ngInject*/
var UnpublishChatMessageRepository = function UnpublishChatMessageRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.unpublishChatMessage = function (chatMessageId) {
    var url = '/rest/ChatMessage/' + chatMessageId + '/unpublish';
    return this.post(url);
  };
};
UnpublishChatMessageRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('unpublishChatMessageRepository', UnpublishChatMessageRepository);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(227);

/*@ngInject*/
var CollaborationEmailController = function CollaborationEmailController($scope, $sce, $uibModal, $timeout, $window, emailMessageStatus, loadingBarHandler, collaborationMediator, modalUtil, currentSubmissionModel, coreConstant, coreMediator, attachmentUtil, submissionConstant, collaborationUtil, emailMessage) {
  $scope.i18n = locale;
  $scope.emailTypePlaceholder = $scope.i18n.emailTypePlaceholder;
  $scope.userList = [];
  function resetEmailViewModel() {
    $scope.emailViewModel = {
      email: null,
      emailBody: '',
      typeDataItems: '',
      selectedEmailType: null
    };
  }
  function resetBusinessCardEmailViewModel() {
    $scope.businessCardEmailViewModel = {
      emailTo: null
    };
  }
  function loadCollaborationEmail(emailId) {
    $scope.viewModel.isLoading = true;
    collaborationMediator.loadCollaborationEmail(emailId).then(function (emailItem) {
      $scope.viewModel.isLoading = false;
      if ($scope.viewModel.selectedItem.isReplyOrForward) {
        $scope.emailViewModel.replyOrForwardEmail = emailItem;
      } else {
        resetEmailViewModel();
        $scope.emailViewModel.email = emailItem;
        $scope.emailViewModel.emailBody = $sce.trustAsHtml(emailItem.body);
        $scope.viewModel.email.isVisible = emailItem.status !== emailMessageStatus.STATUS_DRAFT && emailItem.origin !== 'UPLOAD';
        attachmentUtil.getAttachmentTypes().then(function (result) {
          $scope.emailViewModel.typeDataItems = result;
          $scope.emailViewModel.selectedEmailType = _.find(result, {
            name: emailItem.type
          });
        });

        // need to load users first to avoid duplicate loading
        coreMediator.loadUsersList(emailItem.submissionId).then(function () {
          $scope.setToOrCcUsers($scope.emailViewModel.email, 'to');
          $scope.setToOrCcUsers($scope.emailViewModel.email, 'cc');
          if (emailItem.status === emailMessageStatus.STATUS_DRAFT && $scope.canCreateEmail()) {
            $scope.expandEmail();
          }
        });
      }
      if (emailItem.status === emailMessageStatus.STATUS_DRAFT && $scope.canCreateEmail()) {
        // Launch the pop-out editor for drafts.

        if ($scope.businessCardEmailViewModel.emailTo) {
          // set email's 'to' for Send E-mail action from business card
          $scope.emailViewModel.email.to = $scope.businessCardEmailViewModel.emailTo;
        }
        if ($scope.viewModel.selectedItem.isReplyOrForward) {
          $scope.expandEmail();
        }
      }
    });
  }
  $scope.deleteEmail = function (email) {
    delete $scope.viewModel.selectedItem.deleteNewEmailOnCancel;
    loadingBarHandler.showLoadingBar('submission.collaboration.email.deletingEmail');
    collaborationMediator.deleteCollaborationEmail(email.id).then(function () {
      loadingBarHandler.hideLoadingBar();
    });
  };
  $scope.saveEmail = function (email, savedFromViewer) {
    var loadingBarMessageKey = 'submission.collaboration.email.';
    if (savedFromViewer) {
      $scope.emailViewModel.email = email;
      $scope.emailViewModel.selectedEmailType = _.find($scope.emailViewModel.typeDataItems, {
        name: email.type
      });
    }
    delete $scope.viewModel.selectedItem.deleteNewEmailOnCancel;
    loadingBarMessageKey += email.status === emailMessageStatus.STATUS_SENT ? 'savingEmail' : 'savingDraft';
    loadingBarHandler.showLoadingBar(loadingBarMessageKey);
    collaborationMediator.updateCollaborationEmail(email).then(function () {
      loadingBarHandler.hideLoadingBar();
    });
  };
  $scope.sendEmail = function (email) {
    delete $scope.viewModel.selectedItem.deleteNewEmailOnCancel;
    loadingBarHandler.showLoadingBar('submission.collaboration.email.sendingEmail');
    collaborationMediator.updateCollaborationEmail(email).then(function () {
      collaborationMediator.sendCollaborationEmail(email).then(function () {
        loadingBarHandler.hideLoadingBar();
      });
    });
  };
  $scope.canDeleteTheEmail = function () {
    var email = $scope.emailViewModel.email;
    var canDeleteTheEmail = false;
    if (email) {
      canDeleteTheEmail = $scope.isUnderwriterUser() && $scope.canDeleteEmail() && (emailMessageStatus === emailMessageStatus.STATUS_DRAFT || email.origin === 'UPLOAD');
    }
    return canDeleteTheEmail;
  };
  $scope.onDeleteClick = function () {
    var config = {
      cancelButtonLabel: $scope.i18n.cancel,
      confirmActionButtonLabel: $scope.i18n.confirm,
      summary: $scope.i18n.deleteConfirmationMessage,
      title: $scope.i18n.deleteConfirmationTitle
    };
    modalUtil.showGenericConfirm(config).then(function () {
      var email = $scope.emailViewModel.email;
      $scope.deleteEmail(email);
      $scope.hideSubPage();
    });
  };
  $scope.onReplyClick = function () {
    var emailId = $scope.emailViewModel.email.id;
    $scope.replyEmail(emailId);
  };
  $scope.onReplyAllClick = function () {
    var emailId = $scope.emailViewModel.email.id;
    $scope.replyAllEmail(emailId);
  };
  $scope.onForwardClick = function () {
    var emailId = $scope.emailViewModel.email.id;
    $scope.forwardEmail(emailId);
  };
  $scope.replyEmail = function (emailId) {
    if (!emailId) {
      emailId = $scope.emailViewModel.email.id;
    }
    loadingBarHandler.showLoadingBar('submission.collaboration.email.replyingToEmail');
    $scope.newEmailId = emailId;
    collaborationMediator.replyEmail(emailId);
  };
  $scope.replyAllEmail = function (emailId) {
    if (!emailId) {
      emailId = $scope.emailViewModel.email.id;
    }
    loadingBarHandler.showLoadingBar('submission.collaboration.email.replyingToEmail');
    $scope.newEmailId = emailId;
    collaborationMediator.replyAllEmail(emailId);
  };
  $scope.forwardEmail = function (emailId) {
    if (!emailId) {
      emailId = $scope.emailViewModel.email.id;
    }
    loadingBarHandler.showLoadingBar('submission.collaboration.email.creatingForward');
    $scope.newEmailId = emailId;
    collaborationMediator.forwardEmail(emailId);
  };
  $scope.$on(submissionConstant.event.CREATE_COLLABORATION_ITEM_MESSAGE, function (event, payload) {
    if (payload.type === 'email' && $scope.newEmailId) {
      $timeout(function () {
        var submissionId = currentSubmissionModel.getCurrentSubmission().id;
        loadingBarHandler.hideLoadingBar();
        $scope.$emit(coreConstant.event.SHOW_EMAIL_EDITOR, payload.id, submissionId, /*chatMessageId*/undefined, /*emailMessageId*/undefined, /*notificationId*/undefined, /*deleteNewEmailOnCancel*/true, /*isReplyOrForward*/true);
        $scope.newEmail = null;
      }, 50);
    }
  });
  $scope.expandEmail = function () {
    var expandedEmailModal,
      email = $scope.viewModel.selectedItem.isReplyOrForward ? $scope.emailViewModel.replyOrForwardEmail : $scope.emailViewModel.email;
    if (email.status === emailMessageStatus.STATUS_DRAFT) {
      if (_.isNull(email.to)) {
        email.to = '';
      }
      if (_.isNull(email.cc)) {
        email.cc = '';
      }
      if (_.isNull(email.bcc)) {
        email.bcc = '';
      }
      coreMediator.loadUsersList($scope.emailViewModel.email.submissionId).then(function (users) {
        expandedEmailModal = $uibModal.open({
          templateUrl: '/collaboration/email/emailEditor/emailEditorModal.tpl.html',
          controller: 'emailEditorModalController',
          windowClass: 'emailEditorModal',
          backdrop: 'static',
          keyboard: 'false',
          resolve: {
            options: function options() {
              return {
                email: email,
                deleteEmail: $scope.deleteEmail,
                saveEmail: $scope.saveEmail,
                sendEmail: $scope.sendEmail,
                deleteNewEmailOnCancel: $scope.viewModel.selectedItem.deleteNewEmailOnCancel,
                canDeleteEmail: $scope.canDeleteEmail(),
                userList: _.cloneDeep(users)
              };
            },
            availableAttachments: function availableAttachments() {
              return collaborationMediator.loadSubmissionAttachments(email.submissionId).then(function (submissionAttachmentList) {
                return submissionAttachmentList;
              });
            }
          }
        });
        function handleClose() {
          if ($scope.viewModel.selectedItem.deleteNewEmailOnCancel) {
            delete $scope.viewModel.selectedItem.isReplyOrForward;
            delete $scope.emailViewModel.replyOrForwardEmail;
            $scope.deleteEmail(email);
            _.each($scope.viewModel.collabItemList, function (item) {
              if (item.id === $scope.emailViewModel.email.id && item.type === 'email') {
                $scope.selectItem(item);
              }
            });
          }
          if ($scope.emailViewModel.email.status === emailMessageStatus.STATUS_DRAFT || $scope.viewModel.selectedItem.isReplyOrForward) {
            delete $scope.viewModel.selectedItem.isReplyOrForward;
            delete $scope.emailViewModel.replyOrForwardEmail;
            $scope.hideSubPage();
          }
        }
        expandedEmailModal.result.finally(handleClose);
      });
    } else {
      email.toUsers = $scope.emailViewModel.toUsers;
      email.ccUsers = $scope.emailViewModel.ccUsers;
      expandedEmailModal = modalUtil.showEmailViewer(email, $scope.forwardEmail, $scope.replyEmail, $scope.replyAllEmail, $scope.saveEmail, $scope.deleteEmail, $scope.isUnderwriterUser(), $scope.canCreateEmail(), $scope.canDeleteEmail());
      function handleClose() {
        if ($scope.viewModel.selectedItem.deleteNewEmailOnCancel) {
          delete $scope.viewModel.selectedItem.isReplyOrForward;
          delete $scope.emailViewModel.replyOrForwardEmail;
          $scope.deleteEmail(email);
          _.each($scope.viewModel.collabItemList, function (item) {
            if (item.id === $scope.emailViewModel.email.id && item.type === 'email') {
              $scope.selectItem(item);
            }
          });
        }
        if ($scope.emailViewModel.email.status === emailMessageStatus.STATUS_DRAFT || $scope.viewModel.selectedItem.isReplyOrForward) {
          delete $scope.viewModel.selectedItem.isReplyOrForward;
          delete $scope.emailViewModel.replyOrForwardEmail;
          $scope.hideSubPage();
        }
      }
      expandedEmailModal.result.finally(handleClose);
    }
  };
  $scope.isCurrentUser = function () {
    if ($scope.viewModel.userProfile && $scope.emailViewModel.email) {
      if ($scope.viewModel.userProfile.id === $scope.emailViewModel.email.fromUserId) {
        return true;
      }
    }
    return false;
  };
  $scope.getTitle = function () {
    if (!$scope.emailViewModel.email) {
      return false;
    }
    return $scope.emailViewModel.email.subject;
  };
  $scope.setToOrCcUsers = function (email, type) {
    var userArray = _.split(type === 'to' ? email.to : email.cc, emailMessage.EMAIL_ADDRESS_SEPERATOR),
      recipientList = [];
    coreMediator.loadUsersList(email.submissionId).then(function (users) {
      _.each(userArray, function (toUser) {
        var addedUser = false;
        _.each(users, function (user) {
          var userString = collaborationUtil.getEmailIdentifierString(user.name, user.emailAddress);
          if (toUser === userString) {
            recipientList.push(user);
            addedUser = true;
          }
        });
        if (!addedUser) {
          recipientList.push(toUser);
        }
      });
      if (type === 'to') {
        $scope.emailViewModel.toUsers = recipientList;
      } else {
        $scope.emailViewModel.ccUsers = recipientList;
      }
    });
  };
  $scope.onUpdateSelectedType = function () {
    var email = $scope.emailViewModel.email;
    if ($scope.emailViewModel.selectedEmailType) {
      email.type = $scope.emailViewModel.selectedEmailType.name;
    } else {
      email.type = null;
    }
    $scope.saveEmail(email);
  };
  $scope.onAttachmentDownloadClick = function (attachment) {
    attachmentUtil.getAttachmentLinkURL(attachment.id, attachment.name).then(function (url) {
      $window.open(url, '_blank');
    });
  };
  $scope.$watch('viewModel.selectedItem', function (newItem) {
    if (newItem && newItem.isOpenedFromBusinessCard === true) {
      $scope.businessCardEmailViewModel.emailTo = newItem.summaryData.emailTo;
    }
    if (newItem && newItem.type === 'email') {
      loadCollaborationEmail(newItem.id);
    }
  });
  resetEmailViewModel();
  resetBusinessCardEmailViewModel();
};
CollaborationEmailController.$inject = ["$scope", "$sce", "$uibModal", "$timeout", "$window", "emailMessageStatus", "loadingBarHandler", "collaborationMediator", "modalUtil", "currentSubmissionModel", "coreConstant", "coreMediator", "attachmentUtil", "submissionConstant", "collaborationUtil", "emailMessage"];
angular.module('gw-um-submission').controller('collaborationEmailController', CollaborationEmailController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 227 */
/***/ (function(module) {

module.exports = JSON.parse("{\"emailTypePlaceholder\":\"Email\",\"emailHeaderTitle\":\"Email\",\"reply\":\"Reply\",\"replyAll\":\"Reply All\",\"forward\":\"Forward\",\"deleteConfirmationMessage\":\"Are you sure you want to delete this email?\",\"deleteConfirmationTitle\":\"Delete Email\",\"cancel\":\"No\",\"confirm\":\"Yes\"}");

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/collaboration/email/collaborationEmail.tpl.html';
var html = "<div class=\"dockPanelHeader collaborationHeader\">\n    <h2 class=\"dockPanelHeaderTitle dockPanelHeaderButton collaborationHeaderTitle\" ng-click=\"hideSubPage()\">\n        <span class=\"glyphicon glyphicon-chevron-left emailCollabHeaderBackArrow\"></span>\n        <span class=\"icon-image icon-collaborationTypeEmail\"></span>\n        <span class=\"emailHeaderTitle\">{{ i18n.emailHeaderTitle }}</span>\n    </h2>\n</div>\n\n<!--Collaboration Content-->\n<div class=\"dockPanelContent collaborationContent\">\n    <div class=\"dockPanelInnerContent narrow sendDateRow\">\n        <a class=\"expandButton\" ng-click=\"expandEmail()\">\n            <img class=\"svgicon icon-fullscreenEmail\" src=\"" + __webpack_require__(229) + "\" />\n        </a>\n        <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n            <span class=\"glyphicon glyphicon-time\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <time class=\"sendDate\">\n                {{emailViewModel.email.sentDate | date:'short'}}\n            </time>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow dockPanelFrom\"\n         ng-if=\"emailViewModel.email.id\">\n        <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n            <span class=\"glyphicon glyphicon-user\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <collaboration-user-avatar label=\"submission.collaboration.email.fromLabel\"\n                                       text=\"{{emailViewModel.email.from | emailRecipientsFilter}}\"\n                                       userid=\"{{emailViewModel.email.fromUserId}}\"\n                                       email-id=\"{{emailViewModel.email.id}}\">\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow dockPanelTo\"\n         ng-if=\"emailViewModel.email.id\">\n        <div class=\"dockPanelCellSide collaborationEmailRowIcon dockPanelToIcon\">\n            <span class=\"glyphicon glyphicon-user\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <collaboration-user-avatar label=\"submission.collaboration.email.toLabel\"\n                                       toorccusers=\"{{emailViewModel.toUsers}}\"\n                                       email-id=\"{{emailViewModel.email.id}}\">\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow dockPanelCC\"\n         ng-if=\"emailViewModel.email.id && emailViewModel.email.cc\">\n        <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n            <span class=\"glyphicon glyphicon-user\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <collaboration-user-avatar label=\"submission.collaboration.email.ccLabel\"\n                                       toorccusers=\"{{emailViewModel.ccUsers}}\"\n                                       email-id=\"{{emailViewModel.email.id}}\">\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow dockPanelAttachment\"\n         ng-if=\"emailViewModel.email.attachments.length > 0\">\n        <div class=\"dockPanelCellSide collaborationEmailRowIcon attachmentListIcon\">\n            <span class=\"glyphicon glyphicon-paperclip\"></span>\n        </div>\n        <div class=\"dockPanelCellContent attachmentList\">\n            <div ng-repeat=\"attachment in emailViewModel.email.attachments\">\n                <a ng-click=\"onAttachmentDownloadClick(attachment)\">{{ attachment.name }} ({{ attachment.byteCountToDisplaySize }})</a>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"getTitle()\"\n         class=\"dockPanelInnerContent narrow dockPanelEmailSubject\">\n        <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n            <span class=\"glyphicon glyphicon-envelope\"></span>\n        </div>\n        <div class=\"dockPanelCellContent emailSubject\">\n            {{getTitle()}}\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow dockPanelEmailTypeCombo\" ng-if=\"isUnderwriterUser()\">\n        <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n            <span class=\"glyphicon glyphicon-list-alt\"></span>\n        </div>\n\n        <!--Email Type Selection-->\n        <ui-select ng-if=\"isUnderwriterUser()\"\n                   class=\"dropdownFormComponent dropdownComponentSelect emailTypeCombo\"\n                   theme=\"select2\"\n                   ng-model=\"emailViewModel.selectedEmailType\"\n                   ng-change=\"onUpdateSelectedType()\">\n\n            <ui-select-match placeholder=\"{{ ::emailTypePlaceholder }}\"\n                             allow-clear=\"true\">\n                <span>{{ emailViewModel.selectedEmailType.name }}</span>\n            </ui-select-match>\n\n            <ui-select-choices\n                repeat=\"item in (emailViewModel.typeDataItems | filter: $select.search) track by $index\">\n                <span>{{ item.name }}</span>\n            </ui-select-choices>\n        </ui-select>\n\n    </div>\n\n    <div class=\"dockPanelInnerContent fullHeight dockPanelEmailBody\"\n         ui-external-href-target-blank>\n        <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n            <span class=\"glyphicon glyphicon-pencil\"></span>\n        </div>\n        <div class=\"dockPanelCellContent dockPanelScrollingContent\"\n             ng-bind-html=\"emailViewModel.emailBody\">\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent emailFooter\" ng-if=\"showEmail() && isUnderwriterUser() && canCreateEmail()\">\n        <div class=\"deleteContainer\"\n             ng-if=\"canDeleteTheEmail()\">\n            <a class=\"componentNoteDelete\"\n               ng-click=\"onDeleteClick()\">\n                <span class=\"glyphicon glyphicon-trash\"></span>\n            </a>\n        </div>\n        <div class=\"footerSpacer\"></div>\n        <button class=\"btn btn-primary replyButton\" ng-click=\"onReplyClick()\">\n            <img class=\"emailIcon icon-emailReply\" src=\"" + __webpack_require__(84) + "\" />\n            <span>{{ i18n.reply }}</span>\n        </button>\n        <button class=\"btn btn-primary replyAllButton\" ng-click=\"onReplyAllClick()\">\n            <img class=\"emailIcon icon-emailReplyAll\" src=\"" + __webpack_require__(85) + "\" />\n            <span>{{ i18n.replyAll }}</span>\n        </button>\n        <button class=\"btn btn-primary forwardButton\" ng-click=\"onForwardClick()\">\n            <img class=\"emailIcon icon-emailForward\" src=\"" + __webpack_require__(86) + "\" />\n            <span>{{ i18n.forward }}</span>\n        </button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "62293a8e323acab4f1d5f70329f50b9b.svg";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

var path = '/collaboration/email/emailEditor/emailEditorModal.tpl.html';
var html = "<div class=\"modal-view-wrapper emailEditorModal collaborationContainer dockPanel dockPanelSection collaborationEmail\"\n     ui-browser-detection\n     ui-drop-zone>\n    <div class=\"modal-header dockPanelHeader collaborationHeader\">\n        <span class=\"emailSubject\">{{::getTitle()}}</span>\n        <button class=\"close\" ng-click=\"onCloseClick()\"><span class=\"glyphicon glyphicon-remove\"></span></button>\n    </div>\n    <ui-email-editor class=\"editor\"\n                     selected-email-attachments=\"selectedAttachments\"\n                     available-email-attachments=\"availableAttachments\"\n                     is-email-attachment-dropdown-open=\"isAttachmentDropdownOpen\"\n                     options=\"options\"\n                     show-attachment=\"true\"\n                     close-popup=\"closePopup()\"\n                     show-footer=\"true\"\n                     is-mode-ums=\"true\"\n                     load-email-attachments=\"loadAttachments()\"\n                     user-list=\"userList\"\n                     handle-upload-attachment-email=\"handleUploadAttachment(optionsData,data,selectedAttachments)\">\n    </ui-email-editor>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(233);

/*@ngInject*/
var EmailEditorModalController = function EmailEditorModalController($rootScope, $scope, $timeout, coreConstant, availableAttachments, options, loadingBarHandler, collaborationMediator, attachmentUtil, coreMediator, emailEditorConstant) {
  $scope.testOptions = {
    height: 400,
    focus: false,
    airMode: false,
    toolbar: [['edit', ['undo', 'redo']], ['headline', ['style']], ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']], ['fontface', ['fontname']], ['textsize', ['fontsize']], ['fontclr', ['color']], ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']], ['height', ['height']], ['table', ['table']], ['insert', ['link', 'picture', 'video', 'hr']], ['view', ['fullscreen', 'codeview']]]
  };
  $scope.emailI18n = locale;
  $scope.availableAttachments = availableAttachments;
  $scope.selectedAttachments = _.clone(options.email.attachments);
  $scope.isAttachmentDropdownOpen = options.email.attachments.length > 0;
  $scope.options = options;
  $scope.draftTitle = $scope.emailI18n.draftTitle;
  $scope.addAnAttachmentText = $scope.emailI18n.attachmentTooltip, $scope.userList = options.userList;
  $scope.getTitle = function () {
    return $scope.draftTitle;
  };
  $scope.onCloseClick = function () {
    $rootScope.$broadcast(coreConstant.event.CLOSE_EMAIL_POPUP);
  };
  $scope.closePopup = function () {
    $scope.$close();
  };
  $scope.handleUploadAttachment = function (optionsData, data, selectedAttachments) {
    loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.uploading');
    var submissionId = optionsData.email.submissionId,
      payload = attachmentUtil.getAttachmentPayload(data.attachment);
    payload = _.assign(payload, {
      'ownerUri': 'com.firstbest.underwriting.submission.Submission:' + submissionId,
      'submissionId': submissionId
    });
    collaborationMediator.uploadAttachmentEmail(optionsData.email.id, payload, data.file).then(function (newAttachment) {
      $scope.loadAttachments().then(function () {
        // automaticly attach to the email the newly added attachment
        // use the availableAttachments reference to inject inside the selectedAttachments array
        var filteredAttachment = _.filter($scope.availableAttachments, function (attachment) {
          return newAttachment.id === attachment.id;
        });
        $scope.selectedAttachments = selectedAttachments;
        $scope.selectedAttachments.push(_.first(filteredAttachment));
        $scope.isAttachmentDropdownOpen = true;
        $rootScope.$broadcast(coreConstant.event.ATTACHMENT_UPDATED, $scope.availableAttachments, $scope.selectedAttachments, $scope.isAttachmentDropdownOpen);
      }).finally(function () {
        loadingBarHandler.hideLoadingBar();
      });
    });
  };
  $scope.loadAttachments = function () {
    return collaborationMediator.loadSubmissionAttachments(options.email.submissionId).then(function (submissionAttachmentList) {
      $scope.availableAttachments = submissionAttachmentList;
      if ($scope.availableAttachments.length > 0) {
        $scope.availableAttachments.push({
          name: $scope.addAnAttachmentText,
          addAttachment: true
        });
      }
    });
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
};
EmailEditorModalController.$inject = ["$rootScope", "$scope", "$timeout", "coreConstant", "availableAttachments", "options", "loadingBarHandler", "collaborationMediator", "attachmentUtil", "coreMediator", "emailEditorConstant"];
angular.module('gw-um-submission').controller('emailEditorModalController', EmailEditorModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 233 */
/***/ (function(module) {

module.exports = JSON.parse("{\"draftTitle\":\"Draft\",\"attachmentTooltip\":\"Add an attachment\"}");

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var PropertiesFilter = function PropertiesFilter() {
  return function (items, props) {
    var out = [];
    if (_.isArray(items)) {
      var keys = Object.keys(props);
      _.each(items, function (item) {
        var itemMatches = false,
          prop,
          text;
        for (var i = 0; i < keys.length; i++) {
          prop = keys[i];
          text = props[prop].toLowerCase();
          if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
            itemMatches = true;
            break;
          }
        }
        if (itemMatches) {
          out.push(item);
        }
      });
    } else {
      // Let the output be the input untouched
      out = items;
    }
    return out;
  };
};
angular.module('gw-um-submission').filter('propertiesFilter', PropertiesFilter);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

var path = '/collaboration/email/emailTemplateModal/emailTemplateModal.tpl.html';
var html = "<base-modal modal-title=\"title\"\n            ok=\"createEmailButton\"\n            cancel=\"cancelButton\"\n            is-confirm-disabled=\"!canEnableConfirmButton()\"\n            on-confirm=\"onConfirm()\"\n            on-cancel=\"onCancel()\">\n\n    <ui-form-viewer submission-id=\"{{ ::submissionId }}\"\n                    form-id=\"{{ ::formId }}\"\n                    printable=\"false\"\n                    effective-date=\"{{ ::effectiveDate }}\"\n                    currency-code=\"{{ ::currencyCode }}\">\n    </ui-form-viewer>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(79);

/*@ngInject*/
var EmailTemplateModalController = function EmailTemplateModalController($rootScope, $scope, coreConstant, submissionId, correspondenceFormId, collaborationMediator, currentSubmissionModel, loadingBarHandler, formViewerModel) {
  $scope.i18n = locale;
  $scope.title = $scope.i18n.title;
  $scope.createEmailButton = $scope.i18n.createEmailButton;
  $scope.cancelButton = $scope.i18n.cancelButton;
  $scope.formId = correspondenceFormId;
  $scope.submissionId = submissionId;
  $scope.effectiveDate = currentSubmissionModel.getCurrentSubmission().effectiveDate;
  $scope.currencyCode = currentSubmissionModel.getCurrentSubmission().currencyCode;
  $scope.canEnableConfirmButton = function () {
    var formStructure = formViewerModel.getFormStructure($scope.formId);
    if (formStructure && formStructure.formModel && formStructure.formModel.totalRequiredFieldCount === 0) {
      return true;
    }
    return false;
  };
  $scope.onConfirm = function () {
    loadingBarHandler.showLoadingBar($scope.i18n.loadingBar);
    collaborationMediator.createCorrespondenceEmail($scope.submissionId).then(function () {
      loadingBarHandler.hideLoadingBar();
      $scope.$close();
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
EmailTemplateModalController.$inject = ["$rootScope", "$scope", "coreConstant", "submissionId", "correspondenceFormId", "collaborationMediator", "currentSubmissionModel", "loadingBarHandler", "formViewerModel"];
angular.module('gw-um-submission').controller('emailTemplateModalController', EmailTemplateModalController);

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/collaboration/email/emailViewer/emailViewerModal.tpl.html';
var html = "<div class=\"modal-view-wrapper collaborationContainer dockPanel dockPanelSection\"\n     ui-browser-detection>\n    <div class=\"modal-header dockPanelHeader collaborationHeader\">\n        <span class=\"emailSubject\">{{::getTitle()}}</span>\n        <button class=\"close\" ng-click=\"$dismiss()\"><span class=\"glyphicon glyphicon-remove\"></span></button>\n    </div>\n\n    <!--Collaboration Content-->\n    <div class=\"modal-body\">\n        <div class=\"dockPanelInnerContent narrow sendDateRow\">\n            <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n                <span class=\"glyphicon glyphicon-time\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <time class=\"sendDate\">\n                    {{emailViewModel.email.sentDate | date:'short'}}\n                </time>\n            </div>\n        </div>\n        <div class=\"dockPanelInnerContent narrow\">\n            <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n                <span class=\"glyphicon glyphicon-user\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <collaboration-user-avatar label=\"submission.collaboration.email.fromLabel\"\n                                           text=\"{{emailViewModel.email.from | emailRecipientsFilter}}\"\n                                           userid=\"{{emailViewModel.email.fromUserId}}\"\n                                           email-id=\"{{emailViewModel.email.id}}\">\n            </div>\n        </div>\n        <div class=\"dockPanelInnerContent narrow\">\n            <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n                <span class=\"glyphicon glyphicon-user\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <collaboration-user-avatar label=\"submission.collaboration.email.toLabel\"\n                                           toorccusers=\"{{emailViewModel.email.toUsers}}\"\n                                           email-id=\"{{emailViewModel.email.id}}\">\n            </div>\n        </div>\n        <div ng-if=\"emailViewModel.email.cc\"\n             class=\"dockPanelInnerContent narrow\">\n            <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n                <span class=\"glyphicon glyphicon-user\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <collaboration-user-avatar label=\"submission.collaboration.email.ccLabel\"\n                                           toorccusers=\"{{emailViewModel.email.ccUsers}}\"\n                                           email-id=\"{{emailViewModel.email.id}}\">\n            </div>\n        </div>\n        <div class=\"dockPanelInnerContent narrow\"\n             ng-if=\"emailViewModel.email.attachments.length > 0\">\n            <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n                <span class=\"glyphicon glyphicon-paperclip\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <div ng-repeat=\"attachment in emailViewModel.email.attachments\">\n                    <a ng-click=\"onAttachmentDownloadClick(attachment)\">{{ attachment.name }} ({{ attachment.byteCountToDisplaySize }})</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"dockPanelInnerContent narrow\" ng-if=\"isUnderwriterUser()\">\n            <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n                <span class=\"glyphicon glyphicon-list-alt\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <!--Email Type Selection-->\n                <div ng-if=\"!isUnderwriterUser()\">{{ emailViewModel.selectedEmailType.name }}</div>\n\n                <ui-select ng-if=\"isUnderwriterUser()\"\n                           class=\"dropdownFormComponent dropdownComponentSelect emailTypeCombo\"\n                           theme=\"select2\"\n                           ng-model=\"emailViewModel.selectedEmailType\"\n                           ng-change=\"onUpdateSelectedType()\">\n\n                    <ui-select-match placeholder=\"{{ ::emailTypePlaceholder }}\"\n                                     allow-clear=\"true\">\n                        <span>{{ emailViewModel.selectedEmailType.name }}</span>\n                    </ui-select-match>\n\n                    <ui-select-choices\n                        repeat=\"item in (emailViewModel.typeDataItems | filter: $select.search) track by $index\">\n                        <span>{{ item.name }}</span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent fullHeight emailBody\"\n             ui-external-href-target-blank>\n             <div class=\"dockPanelCellSide collaborationEmailRowIcon\">\n                 <span class=\"glyphicon glyphicon-pencil\"></span>\n             </div>\n            <div class=\"dockPanelCellContent dockPanelScrollingContent\"\n                 ng-bind-html=\"emailViewModel.emailBody\">\n            </div>\n        </div>\n\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <div class=\"deleteContainer\"\n             ng-if=\"canDeleteEmail()\">\n\n            <a class=\"componentNoteDelete\"\n               ng-click=\"onDeleteClick()\">\n                <span class=\"glyphicon glyphicon-trash\"></span>\n            </a>\n        </div>\n\n        <div class=\"footerSpacer\"></div>\n\n        <div class=\"saveSendContainer\"\n             ng-if=\"isUnderwriterUser() && canCreateEmail()\">\n            <button class=\"btn btn-primary replyButton\" ng-click=\"onReplyClick()\">\n                <img class=\"emailIcon icon-emailReply\" src=\"" + __webpack_require__(84) + "\" />\n                <span>{{ i18n.reply }}</span>\n            </button>\n            <button class=\"btn btn-primary replyAllButton\" ng-click=\"onReplyAllClick()\">\n                <img class=\"emailIcon icon-emailReplyAll\" src=\"" + __webpack_require__(85) + "\" />\n                <span>{{ i18n.replyAll }}</span>\n            </button>\n            <button class=\"btn btn-primary forwardButton\" ng-click=\"onForwardClick()\">\n                <img class=\"emailIcon icon-emailForward\" src=\"" + __webpack_require__(86) + "\" />\n                <span>{{ i18n.forward }}</span>\n            </button>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(241);

/*@ngInject*/
var EmailViewerModalController = function EmailViewerModalController($rootScope, $scope, $sce, $window, modalUtil, attachmentUtil, coreConstant, options) {
  $scope.i18n = locale;
  $scope.emailViewModel = {
    email: options.email,
    emailBody: $sce.trustAsHtml(options.email.body)
  };
  $scope.emailTypePlaceholder = $scope.i18n.emailTypePlaceholder;
  $scope.getTitle = function () {
    var title = $scope.emailViewModel.email.subject.substr(0, 75);
    if ($scope.emailViewModel.email.subject.length > 75) {
      title += '...';
    }
    return title;
  };
  $scope.onReplyClick = function () {
    options.replyEmail(options.email.id);
    $scope.$close();
  };
  $scope.onReplyAllClick = function () {
    options.replyAllEmail(options.email.id);
    $scope.$close();
  };
  $scope.onForwardClick = function () {
    options.forwardEmail(options.email.id);
    $scope.$close();
  };
  $scope.isUnderwriterUser = function () {
    return options.isUnderwriterUser === true;
  };
  $scope.canCreateEmail = function () {
    return options.canCreateEmail === true;
  };
  $scope.canDeleteEmail = function () {
    return $scope.isUnderwriterUser() && options.canDeleteEmail && options.email.origin === 'UPLOAD';
  };
  $scope.onDeleteClick = function () {
    var config = {
      cancelButtonLabel: $scope.i18n.cancel,
      confirmActionButtonLabel: $scope.i18n.confirm,
      summary: $scope.i18n.deleteConfirmationMessage,
      title: $scope.i18n.deleteConfirmationTitle
    };
    modalUtil.showGenericConfirm(config).then(function () {
      options.deleteEmail(options.email);
      $scope.$close();
    });
  };
  $scope.onUpdateSelectedType = function () {
    var email = $scope.emailViewModel.email;
    if ($scope.emailViewModel.selectedEmailType) {
      email.type = $scope.emailViewModel.selectedEmailType.name;
    } else {
      email.type = null;
    }
    options.saveEmail(email, /*savedFromViewer*/true);
  };
  $scope.onAttachmentDownloadClick = function (attachment) {
    attachmentUtil.getAttachmentLinkURL(attachment.id, attachment.name).then(function (url) {
      $window.open(url, '_blank');
    });
  };
  attachmentUtil.getAttachmentTypes().then(function (result) {
    $scope.emailViewModel.typeDataItems = result;
    $scope.emailViewModel.selectedEmailType = _.find(result, {
      name: options.email.type
    });
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
EmailViewerModalController.$inject = ["$rootScope", "$scope", "$sce", "$window", "modalUtil", "attachmentUtil", "coreConstant", "options"];
angular.module('gw-um-submission').controller('emailViewerModalController', EmailViewerModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 241 */
/***/ (function(module) {

module.exports = JSON.parse("{\"emailTypePlaceholder\":\"Type\",\"reply\":\"Reply\",\"replyAll\":\"Reply All\",\"forward\":\"Forward\",\"deleteConfirmationMessage\":\"Are you sure you want to delete this email?\",\"deleteConfirmationTitle\":\"Delete Email\",\"cancel\":\"No\",\"confirm\":\"Yes\"}");

/***/ }),
/* 242 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationEmailRepository = function CollaborationEmailRepository(baseRepository, attachmentUtil) {
  angular.extend(this, baseRepository);
  this.loadCollaborationEmail = function (emailId) {
    var url = '/rest/Email/' + emailId;
    return this.get(url);
  };
};
CollaborationEmailRepository.$inject = ["baseRepository", "attachmentUtil"];
angular.module('gw-um-submission').service('collaborationEmailRepository', CollaborationEmailRepository);

/***/ }),
/* 243 */
/***/ (function(module, exports) {

/*@ngInject*/
var CreateCorrespondenceEmailRepository = function CreateCorrespondenceEmailRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createCorrespondenceEmail = function (submissionId) {
    var url = '/rest/Email/createCorrespondenceEmail',
      config = {
        params: {
          submissionId: submissionId
        }
      };
    return this.post(url, {}, config);
  };
};
CreateCorrespondenceEmailRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('createCorrespondenceEmailRepository', CreateCorrespondenceEmailRepository);

/***/ }),
/* 244 */
/***/ (function(module, exports) {

/*@ngInject*/
var CreateCorrespondenceFormRepository = function CreateCorrespondenceFormRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createCorrespondenceForm = function (submissionId) {
    var url = '/rest/DocumentGeneration/createCorrespondenceForm',
      config = {
        params: {
          submissionId: submissionId
        }
      };
    return this.post(url, {}, config);
  };
  this.createEmailCorrespondenceForm = function (submissionId) {
    var url = '/rest/Email/createCorrespondenceForm',
      config = {
        params: {
          submissionId: submissionId
        }
      };
    return this.post(url, {}, config);
  };
  this.generateLetter = function (submissionId, formId) {
    var url = '/rest/DocumentGeneration/generateLetter',
      config = {
        params: {
          submissionId: submissionId,
          formId: formId
        }
      };
    return this.post(url, {}, config);
  };
};
CreateCorrespondenceFormRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('createCorrespondenceFormRepository', CreateCorrespondenceFormRepository);

/***/ }),
/* 245 */
/***/ (function(module, exports) {

/*@ngInject*/
var DeleteCollaborationEmailRepository = function DeleteCollaborationEmailRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deleteCollaborationEmail = function (emailId) {
    var url = '/rest/Email/' + emailId;
    return this.delete(url);
  };
};
DeleteCollaborationEmailRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('deleteCollaborationEmailRepository', DeleteCollaborationEmailRepository);

/***/ }),
/* 246 */
/***/ (function(module, exports) {

/*@ngInject*/
var ForwardCollaborationEmailRepository = function ForwardCollaborationEmailRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.forward = function (emailId) {
    var url = '/rest/Email/' + emailId + '/forward';
    return this.post(url);
  };
};
ForwardCollaborationEmailRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('forwardCollaborationEmailRepository', ForwardCollaborationEmailRepository);

/***/ }),
/* 247 */
/***/ (function(module, exports) {

/*@ngInject*/
var HideSharedCollaborationRepository = function HideSharedCollaborationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.hideSharedCollaboration = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/hideSharedCollaboration';
    return this.post(url);
  };
};
HideSharedCollaborationRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('hideSharedCollaborationRepository', HideSharedCollaborationRepository);

/***/ }),
/* 248 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReplyAllCollaborationEmailRepository = function ReplyAllCollaborationEmailRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.replyAll = function (emailId) {
    var url = '/rest/Email/' + emailId + '/replyAll';
    return this.post(url);
  };
};
ReplyAllCollaborationEmailRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('replyAllCollaborationEmailRepository', ReplyAllCollaborationEmailRepository);

/***/ }),
/* 249 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReplyCollaborationEmailRepository = function ReplyCollaborationEmailRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.reply = function (emailId) {
    var url = '/rest/Email/' + emailId + '/reply';
    return this.post(url);
  };
};
ReplyCollaborationEmailRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('replyCollaborationEmailRepository', ReplyCollaborationEmailRepository);

/***/ }),
/* 250 */
/***/ (function(module, exports) {

/*@ngInject*/
var SendCollaborationEmailRepository = function SendCollaborationEmailRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.sendCollaborationEmail = function (email) {
    var url = '/rest/Email/Send?submissionId=' + email.submissionId;
    return this.post(url, email);
  };
};
SendCollaborationEmailRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('sendCollaborationEmailRepository', SendCollaborationEmailRepository);

/***/ }),
/* 251 */
/***/ (function(module, exports) {

/*@ngInject*/
var UpdateCollaborationEmailRepository = function UpdateCollaborationEmailRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.updateCollaborationEmail = function (email) {
    var url = '/rest/Email/' + email.id;
    return this.post(url, email);
  };
};
UpdateCollaborationEmailRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('updateCollaborationEmailRepository', UpdateCollaborationEmailRepository);

/***/ }),
/* 252 */
/***/ (function(module, exports) {

/*@ngInject*/
var UploadAttachmentCollaborationEmailRepository = function UploadAttachmentCollaborationEmailRepository(baseRepository, attachmentUtil) {
  angular.extend(this, baseRepository);
  this.uploadAttachment = function (emailId, data, file) {
    var url = '/rest/Email/' + emailId + '/uploadAttachment',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        },
        params: data
      };
    formData.append('file', file);
    return this.post(url, formData, config);
  };
};
UploadAttachmentCollaborationEmailRepository.$inject = ["baseRepository", "attachmentUtil"];
angular.module('gw-um-submission').service('uploadAttachmentCollaborationEmailRepository', UploadAttachmentCollaborationEmailRepository);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

var path = '/collaboration/note/collaborationNote.tpl.html';
var html = "<div class=\"dockPanelHeader collaborationHeader\">\n    <h2 class=\"dockPanelHeaderTitle dockPanelHeaderButton collaborationHeaderTitle\" ng-click=\"hideSubPage()\">\n        <span class=\"closeCollaborationEditor glyphicon glyphicon-chevron-left\"></span>\n        <span class=\"icon-image icon-collaborationTypeNote\"></span>\n        {{getTitle()}}\n    </h2>\n</div>\n\n<!-- A watcher is needed on is-author=\"isCurrentUser()\" to handle the following flow where the author can change:\n     - User views a note not authored by the user\n     - User navigates out of the note by clicking the left cheveron icon\n     - User proceeds to create a new note\n     The HTML generated from the directive is not regenerated until a different note is selected form the list of notes.\n     Creating a new note does not cause the directive to regenerate the HTML -->\n<ui-collaboration-note-editor\n    class=\"dockPanelContent collaborationNoteEditor\"\n    can-modify=\"canModify()\"\n    can-modify-other-user-options=\"canModifyOtherUserOptions()\"\n    can-delete=\"noteViewModel.deletePermission\"\n    can-edit-share=\"::canEditNoteShare()\"\n    is-author=\"isCurrentUser()\"\n    is-existing-note=\"!noteViewModel.isCreateNote\"\n    is-underwriter-user=\"::isUnderwriterUser()\"\n    note=\"noteViewModel.note\"\n    on-close-note-editor=\"closeNoteEditor()\"\n    on-create-note=\"createNote(data)\"\n    on-delete-note=\"deleteNote(noteId)\"\n    on-get-displayed-time=\"getDisplayedTime()\"\n    on-update-note=\"updateNote(noteId, data)\"\n    view-model=\"viewModel\">\n</ui-collaboration-note-editor>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(87);

/*@ngInject*/
var CollaborationNoteController = function CollaborationNoteController($scope, $rootScope, collaborationMediator, authorizationConstants, currentUserModel) {
  $scope.i18n = locale;
  function resetNoteViewModel() {
    $scope.noteViewModel = {
      note: null,
      editPermission: null,
      editOtherUsersPermission: null,
      deletePermission: null,
      sharePermission: null,
      editMode: false
    };
  }
  function loadCollaborationNote(noteId) {
    resetNoteViewModel();
    $scope.viewModel.isLoading = true;
    var permissions = [],
      handleSuccess = function handleSuccess(noteItem) {
        $scope.viewModel.isLoading = false;
        $scope.noteViewModel.note = noteItem.Note;
        $scope.noteViewModel.isCreateNote = _.isNil(noteItem.Note.id);
        $scope.viewModel.note.isVisible = true;
        var neededPermissions = [authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES, authorizationConstants.AUTHORIZATION_DELETE_NOTES, authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES, authorizationConstants.AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS];
        _.each(neededPermissions, function (neededPermission) {
          if (currentUserModel.hasAuthorization(neededPermission)) {
            permissions.push(neededPermission);
          }
        });
        $scope.noteViewModel.editPermission = _.includes(permissions, authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES);
        $scope.noteViewModel.editOtherUsersPermission = _.includes(permissions, authorizationConstants.AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS);
        $scope.noteViewModel.deletePermission = _.includes(permissions, authorizationConstants.AUTHORIZATION_DELETE_NOTES);
        $scope.noteViewModel.sharePermission = _.includes(permissions, authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES);
      };
    if (noteId) {
      collaborationMediator.loadCollaborationNote(noteId).then(handleSuccess);
    } else {
      $scope.viewModel.isLoading = false;
      // creating a new note
      var noteItem = {};
      noteItem[authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES] = true;
      noteItem[authorizationConstants.AUTHORIZATION_DELETE_NOTES] = true;
      noteItem[authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES] = false;
      noteItem.Note = {
        authorId: $scope.viewModel.currentUserId
      };
      handleSuccess(noteItem);
    }
  }
  $scope.isCurrentUser = function () {
    if ($scope.noteViewModel && _.isPlainObject($scope.noteViewModel.note)) {
      if ($scope.viewModel.currentUserId === $scope.noteViewModel.note.authorId) {
        return true;
      }
    }
    return false;
  };
  $scope.$watch('viewModel.selectedItem', function (newItem) {
    if (newItem && newItem.type === 'note') {
      loadCollaborationNote(newItem.id);
    } else {
      // empty the current form
      $scope.noteViewModel.note = {};
    }
  });
  $scope.canEdit = function () {
    return $scope.noteViewModel.editPermission;
  };
  $scope.canDelete = function () {
    return $scope.noteViewModel.deletePermission;
  };
  $scope.canEditShare = function () {
    return $scope.noteViewModel.sharePermission;
  };
  $scope.canModify = function () {
    return $scope.isCurrentUser() && $scope.noteViewModel.editPermission;
  };
  $scope.canModifyOtherUserOptions = function () {
    return !$scope.isCurrentUser() && $scope.noteViewModel.editOtherUsersPermission;
  };
  $scope.getDisplayedTime = function () {
    var roundedTimeCreated, roundedLastModified;
    if ($scope.noteViewModel.note) {
      if ($scope.noteViewModel.note && $scope.noteViewModel.note.timeCreated && $scope.noteViewModel.note.lastModified) {
        return $scope.noteViewModel.note.lastModified;
      }
      return $scope.noteViewModel.note.timeCreated;
    }
  };
  $scope.isMultipleDateDisplayed = function () {
    var roundedTimeCreated,
      roundedLastModified,
      coeff = 1000 * 60 * 5;
    if ($scope.noteViewModel.note && $scope.noteViewModel.note.timeCreated && $scope.noteViewModel.note.lastModified) {
      roundedTimeCreated = new Date(Math.round($scope.noteViewModel.note.timeCreated.getTime() / coeff) * coeff);
      roundedLastModified = new Date(Math.round($scope.noteViewModel.note.lastModified.getTime() / coeff) * coeff);
    } else {
      return false;
    }
    return $scope.noteViewModel.note && $scope.noteViewModel.note.lastModified && roundedTimeCreated !== roundedLastModified;
  };
  $scope.getTitle = function () {
    if (!$scope.noteViewModel || !_.isPlainObject($scope.noteViewModel.note)) {
      return '';
    }
    if ($scope.noteViewModel.note.id) {
      return $scope.i18n.title;
    } else {
      return $scope.i18n.newTitle;
    }
  };
  resetNoteViewModel();
};
CollaborationNoteController.$inject = ["$scope", "$rootScope", "collaborationMediator", "authorizationConstants", "currentUserModel"];
angular.module('gw-um-submission').controller('collaborationNoteController', CollaborationNoteController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 256 */
/***/ (function(module, exports) {

var path = '/collaboration/note/collaborationNoteEditor.tpl.html';
var html = "<div class=\"dockPanelContent collaborationContent\">\n\n    <div class=\"dockPanelInnerContent narrow\"\n         ng-if=\"$ctrl.isUnderwriterUser && $ctrl.canEditShare\">\n\n        <div class=\"dockPanelCellSide\">\n\n            <span class=\"glyphicon glyphicon-eye-open\"></span>\n        </div>\n\n        <div class=\"dockPanelCellContent\">\n\n            <label class=\"dockPanelCheckbox dockPanelCheckbox\"\n                   ng-class=\"{ selected: $ctrl.note.publicNote }\">\n\n                <span>{{ $ctrl.i18n.visible }}</span>\n\n                <input class=\"visibleToAgentCheckbox\"\n                       type=\"checkbox\"\n                       ng-model=\"$ctrl.note.publicNote\"\n                       ng-change=\"$ctrl.onChange()\"\n                       ng-disabled=\"!$ctrl.canModify && !$ctrl.canModifyOtherUserOptions\"\n                       class=\"visibleToAgentCheckbox\"/>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow\">\n\n        <div class=\"dockPanelCellSide\">\n\n            <span class=\"glyphicon glyphicon-list-alt\"></span>\n        </div>\n\n        <div class=\"dockPanelCellContent\">\n            <!--Email Type Selection-->\n            <ui-select class=\"dropdownFormComponent dropdownComponentSelect attachmentType attachmentTypeNotes\"\n                       theme=\"select2\"\n                       ng-model=\"$ctrl.selectedAttachmentType\"\n                       ng-change=\"$ctrl.onUpdateSelectedType()\"\n                       ng-disabled=\"!$ctrl.canModify && !$ctrl.canModifyOtherUserOptions\"\n                       append-to-body=\"true\">\n\n                <ui-select-match placeholder=\"{{ ::$ctrl.attachmentTypePlaceholder }}\"\n                                 allow-clear=\"true\">\n\n                    <span>{{ $ctrl.selectedAttachmentType.name }}</span>\n                </ui-select-match>\n\n                <ui-select-choices repeat=\"item in ($ctrl.typeDataItems | filter: $select.search) track by $index\">\n\n                    <span>{{ item.name }}</span>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent fullHeight\">\n\n        <div class=\"dockPanelCellSide\">\n\n            <span class=\"glyphicon glyphicon-pencil\"></span>\n        </div>\n\n        <div class=\"dockPanelCellContent noteContentTextArea\">\n\n            <textarea class=\"noteContentArea\"\n                      ui-auto-focus=\"true\"\n                      placeholder=\"{{ ::$ctrl.i18n.placeholder }}\"\n                      ng-model=\"$ctrl.note.text\"\n                      ng-change=\"$ctrl.onTextareaChange()\"\n                      ng-blur=\"$ctrl.onBlur()\"\n                      ng-if=\"$ctrl.canModify\"></textarea>\n\n            <div class=\"dockPanelScrollingContent\"\n                 ng-bind-html=\"$ctrl.note.text | nl2br\"\n                 ng-if=\"!$ctrl.canModify\"></div>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow\"\n         ng-if=\"!($ctrl.canModify || $ctrl.canModifyOtherUserOptions) && $ctrl.note.id\">\n\n        <div class=\"dockPanelCellSide\">\n\n            <span class=\"glyphicon glyphicon-user\"></span>\n        </div>\n\n        <div class=\"dockPanelCellContent\">\n\n            <collaboration-user-avatar label=\"submission.collaboration.note.createdBy\"\n                                       sublabel=\"{{getDisplayedTime() | date:'short'}}\"\n                                       text=\"{{$ctrl.note.authorName}}\"\n                                       userid=\"{{$ctrl.note.authorId}}\"\n                                       submissionid=\"{{$ctrl.submissionId}}\"/>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent\"\n         ng-if=\"!$ctrl.isExistingNote\">\n\n        <button class=\"btn btn-primary componentNoteSave\"\n                ng-disabled=\"$ctrl.viewModel.note.isEditorSaving || !$ctrl.isDirty\"\n                ng-class=\"{'is-saving':$ctrl.viewModel.note.isEditorSaving}\"\n                ng-click=\"$ctrl.onSaveClick()\">\n\n            <span class=\"icon icon-dotsSpinnerLight\"></span>\n\n            <span>{{ ::$ctrl.i18n.save }}</span>\n        </button>\n\n        <button class=\"btn btn-footer\"\n                ng-click=\"$ctrl.onCancelClick()\">\n            {{ ::$ctrl.i18n.cancel }}\n        </button>\n    </div>\n\n    <div class=\"dockPanelInnerContent dockerPanelFooter\"\n         ng-if=\"$ctrl.canDelete && $ctrl.note.id && ($ctrl.canModify || $ctrl.canModifyOtherUserOptions)\">\n\n        <button class=\"btn btn-footer componentNoteDelete\"\n                ng-click=\"$ctrl.onDeleteClick()\">\n\n            <span class=\"glyphicon glyphicon-trash\"></span>\n\n            <span>{{ ::$ctrl.i18n.delete }}</span>\n        </button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

var CollaborationNoteEditorComponent = {
  templateUrl: '/collaboration/note/collaborationNoteEditor.tpl.html',
  controller: 'collaborationNoteEditorController',
  bindings: {
    canDelete: '<',
    canModify: '<',
    canModifyOtherUserOptions: '<',
    canEditShare: '<',
    isAuthor: '<',
    isExistingNote: '<',
    isUnderwriterUser: '<',
    note: '<',
    onCloseNoteEditor: '&',
    onCreateNote: '&',
    onDeleteNote: '&',
    onGetDisplayedTime: '&',
    onUpdateNote: '&',
    viewModel: '<'
  }
};
angular.module('gw-um-submission').component('uiCollaborationNoteEditor', CollaborationNoteEditorComponent);

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(87);

/*@ngInject*/
var CollaborationNoteEditorController = function CollaborationNoteEditorController($scope, $uibModal, attachmentUtil) {
  var originalViewModel = {};
  this.i18n = locale;
  this.attachmentTypePlaceholder = this.i18n.type;
  this.$onInit = function () {
    this.initData();
  };
  this.resetViewModel = function () {
    this.isDirty = false;
    originalViewModel = _.clone(this.note);
    this.viewModel.note.isEditorSaving = false;
  };
  this.getDisplayedTime = function () {
    var roundedTimeCreated, roundedLastModified;
    if (this.note) {
      if (this.note && this.note.timeCreated && this.note.lastModified) {
        return this.note.lastModified;
      }
      return this.note.timeCreated;
    }
  };
  this.showDeleteConfirm = function () {
    var _options = {
      title: this.i18n.deleteNoteTitle,
      summary: this.i18n.deleteQuestion,
      cancelButtonLabel: this.i18n.cancelActionButtonLabel,
      confirmActionButtonLabel: this.i18n.confirmActionButtonLabel
    };
    var modalInstance = $uibModal.open({
      templateUrl: '/ui/modal/modal.tpl.html',
      controller: 'modalController',
      backdrop: 'static',
      windowClass: 'genericModal',
      resolve: {
        options: function options() {
          return _options;
        }
      }
    });
    modalInstance.result.then(deleteNote.bind(this));
    function deleteNote() {
      if (this.note && this.note.id) {
        this.onDeleteNote({
          noteId: this.note.id
        });
      }
    }
  };
  this.onDeleteClick = function () {
    if (this.note.id && this.canDelete) {
      this.showDeleteConfirm();
    }
  };
  this.initData = function () {
    var _this = this;
    this.resetViewModel();
    attachmentUtil.getAttachmentTypes().then(function (result) {
      var attachmentType = _this.note.type || {};
      _this.typeDataItems = result;
      _this.selectedAttachmentType = _.find(result, {
        name: attachmentType
      });
    });
    if (this.note && this.note.id) {
      originalViewModel = _.clone(this.note);
    }
  };
  this.resetAndClose = function () {
    this.resetViewModel();
    this.onCloseNoteEditor();
  };
  this.doDirtyCheck = function () {
    var isDirty = false;
    if (originalViewModel.text !== this.note.text) {
      isDirty = true;
    }
    if (originalViewModel.publicNote !== this.note.publicNote) {
      isDirty = true;
    }
    if (_.isEmpty(this.note.text)) {
      isDirty = false;
    }
    if (!_.isNil(this.selectedAttachmentType) && this.selectedAttachmentType.type !== this.note.type || _.isNil(this.selectedAttachmentType) && !_.isNil(this.note.type)) {
      isDirty = true;
    }
    this.isDirty = isDirty;
  };
  this.onUpdateSelectedType = function () {
    this.doDirtyCheck();
    this.onBlur();
  };
  this.onSaveClick = function () {
    this.note.type = !_.isNil(this.selectedAttachmentType) ? this.selectedAttachmentType.name : '';
    this.onCreateNote({
      data: this.note
    });
  };
  this.onCancelClick = function () {
    this.resetAndClose();
  };
  this.onChange = function () {
    this.doDirtyCheck();
    this.onBlur();
  };
  this.onTextareaChange = function () {
    this.doDirtyCheck();
  };
  this.onBlur = function () {
    if (this.isExistingNote && this.isDirty) {
      this.note.type = !_.isNil(this.selectedAttachmentType) ? this.selectedAttachmentType.name : '';
      this.onUpdateNote({
        noteId: this.note.id,
        data: this.note
      });
      this.initData();
    }
  };
  this.$onChanges = function (changes) {
    if (!_.isNil(changes.note.currentValue)) {
      this.initData();
    }
  };
};
CollaborationNoteEditorController.$inject = ["$scope", "$uibModal", "attachmentUtil"];
angular.module('gw-um-submission').controller('collaborationNoteEditorController', CollaborationNoteEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 259 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationNoteRepository = function CollaborationNoteRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadCollaborationNote = function (noteId) {
    var url = '/rest/Note/' + noteId;
    return this.get(url);
  };
};
CollaborationNoteRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('collaborationNoteRepository', CollaborationNoteRepository);

/***/ }),
/* 260 */
/***/ (function(module, exports) {

/*@ngInject*/
var CreateCollaborationNoteRepository = function CreateCollaborationNoteRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createCollaborationNote = function (data) {
    var url = '/rest/Note',
      config = {
        params: data
      };
    return this.post(url, {}, config);
  };
};
CreateCollaborationNoteRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('createCollaborationNoteRepository', CreateCollaborationNoteRepository);

/***/ }),
/* 261 */
/***/ (function(module, exports) {

/*@ngInject*/
var DeleteCollaborationNoteRepository = function DeleteCollaborationNoteRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deleteCollaborationNote = function (noteId) {
    var url = '/rest/Note/' + noteId;
    return this.delete(url);
  };
};
DeleteCollaborationNoteRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('deleteCollaborationNoteRepository', DeleteCollaborationNoteRepository);

/***/ }),
/* 262 */
/***/ (function(module, exports) {

/*@ngInject*/
var UpdateCollaborationNoteRepository = function UpdateCollaborationNoteRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.updateCollaborationNote = function (noteId, data) {
    var url = '/rest/Note/' + noteId,
      config = {
        params: data
      };
    return this.post(url, {}, config);
  };
};
UpdateCollaborationNoteRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('updateCollaborationNoteRepository', UpdateCollaborationNoteRepository);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

var path = '/collaboration/task/newTaskAttachmentModal/newTaskAttachmentModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.uploadButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    class=\"newTaskAttachmentModal\">\n\n    <div class=\"dockPanel taskAttachmentBox collaborationAttachment\">\n\n        <div class=\"dockPanelInnerContent collaborationInnerContent\">\n            <div class=\"dragDropBox\"\n                 ui-drop-zone\n                 file=\"{{viewModel.uploadedFile}}\">\n                <span>{{ ::i18n.dragAndDrop }}</span>\n                <span>{{ ::i18n.or }}</span>\n                <div>\n                    <input type=\"file\"\n                           class=\"btn btn-primary btn-sm hiddenFileInput\"\n                           name=\"' + scope.valueName + '_file\"\n                           ui-custom-on-change=\"fileSelected(file)\"/>\n                    <input type=\"button\"\n                           class=\"btn btn-primary btn-sm\"\n                           value=\"{{viewModel.chooseFileString}}\"/>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent narrow\"\n             ng-if=\"viewModel.attachment.name\">\n            <div class=\"dockPanelCellSide\">\n                <span class=\"glyphicon glyphicon-file\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <span class=\"attachmentLink\" ng-if=\"!viewModel.attachmentLink\">{{viewModel.attachment.name}} {{ viewModel.attachment.byteCountToDisplaySize }}</span>\n                <a ng-if=\"viewModel.attachmentLink\" ng-href=\"{{viewModel.attachmentLink}}\" target=\"_blank\">\n                    {{viewModel.attachment.name}} {{ viewModel.attachment.byteCountToDisplaySize }}\n                </a>\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent row\">\n            <div class=\"dockPanelCellSide\">\n                <span class=\"glyphicon glyphicon-list-alt\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <div class=\"dropdown\"\n                     ng-class=\"{'isPlaceholder': !viewModel.attachment.type}\"\n                     uib-dropdown\n                     dropdown-append-to-body=\"true\"\n                     appendToOpenClass>\n                    <a ng-class=\"{ type: !viewModel.attachment.type}\"\n                       uib-dropdown-toggle>\n                        {{getTypePrompt()}}\n                    </a>\n                    <ul class=\"dropdown-menu attachmentTypeList attachmentTypeList\" uib-dropdown-menu>\n                        <li class=\"dropdown-label\" ng-click=\"onUpdateField()\">\n                            <span ng-click=\"resetTypeDropdown()\">{{ ::i18n.type }}</span>\n                        </li>\n                        <li ng-repeat=\"dataItem in viewModel.typeDataItems\">\n                            <a ng-click=\"setTypeValue(dataItem.value)\">{{dataItem.name}}</a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent fileDescription row\">\n            <div class=\"dockPanelCellSide pencil\">\n                <span class=\"glyphicon glyphicon-pencil\"></span>\n            </div>\n            <div class=\"dockPanelCellContent collaborationAttachmentTextareaWrapper\">\n               <textarea ng-model=\"viewModel.attachment.description\"\n                         ng-attr-placeholder=\"{{::viewModel.fileDescPlaceholder}}\"></textarea>\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent collaborationInnerContent narrow\"\n             ng-if=\"viewModel.isUnderwriterUser\">\n            <div class=\"dockPanelCellSide\">\n                <span class=\"glyphicon glyphicon-eye-open\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <label class=\"dockPanelCheckbox visibleToAgentWrapper\"\n                       ng-class=\"{ selected: viewModel.attachment.shared }\">\n                    <span>{{ ::i18n.visibleToAgent }}</span>\n                    <input type=\"checkbox\" ng-model=\"viewModel.attachment.shared\">\n                </label>\n            </div>\n        </div>\n\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(266);

/*@ngInject*/
var NewTaskAttachmentModalController = function NewTaskAttachmentModalController($rootScope, $scope, $timeout, options, coreConstant, preferenceModel, attachmentUtil, isUnderwriterUser) {
  $scope.i18n = locale;
  $scope.viewModel = {
    attachment: {},
    typeDataItems: null,
    uploadedFile: null,
    isUnderwriterUser: isUnderwriterUser
  };
  $scope.onConfirm = function () {
    $scope.$close({
      attachment: $scope.viewModel.attachment,
      file: $scope.viewModel.uploadedFile
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.storeUploadedFile = function (uploadedFile) {
    if (uploadedFile && attachmentUtil.validateAttachment(uploadedFile, _.get($scope.i18n, 'unacceptableTypeAndSize'))) {
      $timeout(function () {
        $scope.viewModel.uploadedFile = uploadedFile;
        if (!$scope.viewModel.attachment) {
          $scope.viewModel.attachment = {};
        }
        $scope.viewModel.attachment.name = uploadedFile.name;
        $scope.viewModel.attachment.size = uploadedFile.size;
        var fileSize = attachmentUtil.convertAttachmentSize(uploadedFile.size);
        $scope.viewModel.attachment.byteCountToDisplaySize = "(".concat(fileSize, ")");
      }, 0);
    }
  };
  $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
    $scope.storeUploadedFile(file);
  });
  $scope.resetTypeDropdown = function () {
    $scope.viewModel.attachment.type = '';
  };
  $scope.setTypeValue = function (value) {
    $scope.viewModel.attachment.type = value;
  };
  $scope.canEnableConfirmButton = function () {
    return $scope.viewModel.attachment.name;
  };
  $scope.getTypePrompt = function () {
    return $scope.viewModel.attachment.type ? $scope.viewModel.attachment.type : $scope.viewModel.pleaseChooseString;
  };
  $scope.fileSelected = function (file) {
    if (file) {
      $scope.storeUploadedFile(file);
    }
  };
  function loadDataSets() {
    attachmentUtil.getAttachmentTypes().then(function (result) {
      $scope.viewModel.typeDataItems = result;
    });
  }
  function init() {
    $scope.viewModel = _.assign($scope.viewModel, {
      title: options.title ? options.title : $scope.i18n.title,
      cancelButton: options.cancelButtton ? options.cancelButton : $scope.i18n.cancelButton,
      uploadButton: options.uploadButton ? options.uploadButton : $scope.i18n.uploadFile,
      chooseFileString: options.chooseFileString ? options.chooseFileString : $scope.i18n.chooseFile,
      pleaseChooseString: options.pleaseChooseString ? options.pleaseChooseString : $scope.i18n.type,
      fileDescPlaceholder: options.fileDescPlaceholder ? options.fileDescPlaceholder : $scope.i18n.fileDescription
    });
    loadDataSets();
  }
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  init();
};
NewTaskAttachmentModalController.$inject = ["$rootScope", "$scope", "$timeout", "options", "coreConstant", "preferenceModel", "attachmentUtil", "isUnderwriterUser"];
angular.module('gw-um-submission').controller('newTaskAttachmentModalController', NewTaskAttachmentModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 266 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Upload a new file\",\"cancelButton\":\"Cancel\",\"uploadFile\":\"Upload File\",\"chooseFile\":\"Choose File\",\"type\":\"Type\",\"fileDescription\":\"File Description\",\"linkToTransaction\":\"Link to Transaction\",\"dragAndDrop\":\"Drag and Drop File Here\",\"or\":\"or\",\"visibleToAgent\":\"Visible to agent\",\"unacceptableTypeAndSize\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for upload.\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\",\"maxFileSizeMessage\":\"The file you are trying to upload exceeds the maximum allowed file size of {maxSize} MB.\",\"maxFileSizeTitle\":\"File Too Big\"}}");

/***/ }),
/* 267 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationCreateTaskRepository = function CollaborationCreateTaskRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createCollaborationTask = function (data) {
    var url = '/rest/SubmissionTask';
    return this.post(url, data);
  };
};
CollaborationCreateTaskRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('collaborationCreateTaskRepository', CollaborationCreateTaskRepository);

/***/ }),
/* 268 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationDeleteTaskRepository = function CollaborationDeleteTaskRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deleteCollaborationTask = function (taskId) {
    var url = '/rest/SubmissionTask/' + taskId;
    return this.delete(url);
  };
  this.deleteCollaborationTaskAttachment = function (taskId, attachmentId) {
    var url = '/rest/SubmissionTask/' + taskId + '/Attachment',
      config = {
        params: {
          attachmentId: attachmentId
        }
      };
    return this.delete(url, config);
  };
};
CollaborationDeleteTaskRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('collaborationDeleteTaskRepository', CollaborationDeleteTaskRepository);

/***/ }),
/* 269 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationLoadTaskRepository = function CollaborationLoadTaskRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadCollaborationTask = function (taskId) {
    var url = '/rest/SubmissionTask/' + taskId;
    return this.get(url);
  };
};
CollaborationLoadTaskRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('collaborationLoadTaskRepository', CollaborationLoadTaskRepository);

/***/ }),
/* 270 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationNotifyTaskRepository = function CollaborationNotifyTaskRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.notifyTaskAssignee = function (taskId) {
    var url = "/rest/SubmissionTask/".concat(taskId, "/notifyTaskAssignee");
    return this.post(url);
  };
};
CollaborationNotifyTaskRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('collaborationNotifyTaskRepository', CollaborationNotifyTaskRepository);

/***/ }),
/* 271 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationUpdateTaskRepository = function CollaborationUpdateTaskRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.updateCollaborationTask = function (taskId, data) {
    var url = '/rest/SubmissionTask/' + taskId;
    return this.post(url, data);
  };
  this.updateCollaborationTaskAttachment = function (taskId, data) {
    var url = '/rest/SubmissionTask/' + taskId + '/Attachment';
    return this.post(url, data);
  };
};
CollaborationUpdateTaskRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('collaborationUpdateTaskRepository', CollaborationUpdateTaskRepository);

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

var path = '/collaboration/task/taskCalendar/taskCalendar.tpl.html';
var html = "<div class=\"taskCalendarComponent\">\n\n    <input type=\"text\"\n           class=\"form-control calendarInput\"\n           placeholder=\"{{$ctrl.placeholderText}}\"\n           ng-model=\"$ctrl.textInputDate\"\n           ng-click=\"$ctrl.handleOpen()\"\n           ng-blur=\"$ctrl.handleBlur()\"\n    />\n\n    <div class=\"componentDatePickerPopup\"\n         ng-if=\"$ctrl.popupOpened\"\n         ui-click-outside=\"$ctrl.handleClose()\"\n         ng-keydown=\"$ctrl.handleKeydown($event)\"\n         is-element-open=\"$ctrl.popupOpened\"\n         toggle-button-class=\"calendarInput\"\n         toggle-focus=\"{{$ctrl.toggleFocus}}\"\n         task-calendar-focus>\n\n        <div class=\"dateTimePickerContainer\">\n            <div uib-datepicker\n                    ng-model=\"$ctrl.popupDate\"\n                    ng-change=\"$ctrl.handleChange()\"\n                    ng-keyup=\"$ctrl.handleKeyup($event)\"\n                    show-weeks=\"false\"\n                    min-date=\"$ctrl.minDate\"\n                    max-date=\"$ctrl.maximumDate\"\n                    datepicker-mode=\"'day'\"\n                    custom-class=\"$ctrl.isToday(date, mode)\"></div>\n\n            <div uib-timepicker\n                    ng-if=\"$ctrl.isTimeEnabled\"\n                    ng-model=\"$ctrl.popupDate\"\n                    ng-click=\"$ctrl.handleChange()\"\n                    ng-keyup=\"$ctrl.handleTimeKeyup()\"\n                    hour-step=\"$ctrl.hourStep\"\n                    minute-step=\"$ctrl.minuteStep\"\n                    mousewheel=\"false\"></div>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 274 */
/***/ (function(module, exports) {

var TaskCalendarComponent = {
  templateUrl: '/collaboration/task/taskCalendar/taskCalendar.tpl.html',
  controller: 'taskCalendarController',
  bindings: {
    selectedDate: '<ngModel',
    placeholderText: '<',
    maxDate: '<?',
    minDate: '<?',
    onChange: '&',
    isTimeEnabled: '<?',
    isUtc: '<?'
  }
};
angular.module('gw-um-submission').component('uiTaskCalendar', TaskCalendarComponent);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {/*@ngInject*/
var TaskCalendarController = function TaskCalendarController($scope, $rootScope, $timeout, coreMediator, formViewerConstant) {
  this.hourStep = 1;
  this.minuteStep = 1;
  this.minDate = new Date();
  this.$onInit = function () {
    var shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    this.format = this.isTimeEnabled ? shortDateFormat + ' hh:mm A' : shortDateFormat;
    this.popupOpened = false;
    this.toggleFocus = false;
    if (this.isUtc) {
      this.maximumDate = this.maxDate ? moment.utc(this.maxDate).format('MM/DD/YYYY') : undefined;
      this.textInputDate = this.selectedDate ? moment.utc(new Date(this.selectedDate)).format(this.format) : null;
    } else {
      this.maximumDate = this.maxDate ? moment(this.maxDate).format('MM/DD/YYYY') : undefined;
      this.textInputDate = this.selectedDate ? moment(new Date(this.selectedDate)).format(this.format) : null;
    }
    this.popupDate = this.textInputDate ? moment(this.textInputDate, this.format) : null;
    this.originalDate = this.textInputDate;
  };
  this.$onChanges = function () {
    if (this.isUtc) {
      this.maximumDate = this.maxDate ? moment.utc(this.maxDate).format('MM/DD/YYYY') : undefined;
      this.textInputDate = this.selectedDate ? moment.utc(new Date(this.selectedDate)).format(this.format) : null;
    } else {
      this.maximumDate = this.maxDate ? moment(this.maxDate).format('MM/DD/YYYY') : undefined;
      this.textInputDate = this.selectedDate ? moment(new Date(this.selectedDate)).format(this.format) : null;
    }
    this.popupDate = this.textInputDate ? moment(this.textInputDate, this.format) : null;
    this.originalDate = this.textInputDate;
  };
  this.handleOpen = function (event) {
    $rootScope.$broadcast(formViewerConstant.event.CLOSE_CALENDAR_POPUP);
    $timeout(function () {
      this.popupOpened = true;
    }.bind(this));
    $timeout(function () {
      this.toggleFocus = true;
    }.bind(this), 200);
  };
  this.handleClose = function () {
    this.popupOpened = false;
    this.toggleFocus = false;
    this.updateSelectedDate();
  };
  this.handleBlur = function () {
    this.validateInputDate(this.textInputDate, true);
    if (!this.popupOpened) {
      this.updateSelectedDate();
    }
  };
  this.handleChange = function () {
    this.validateInputDate(this.popupDate);
    if (!this.isTimeEnabled) {
      this.handleClose();
    }
  };
  this.handleKeydown = function (event) {
    if (event.which === 9) {
      this.handleClose();
    }
    return false;
  };
  this.handleKeyup = function (event) {
    if (event.which === 13) {
      this.handleClose();
    }
  };
  this.handleTimeKeyup = function () {
    _.debounce(function () {
      this.validateInputDate(this.popupDate);
    }, 300).bind(this);
  };
  this.validateInputDate = function (date, isString) {
    if (!_.isNil(date)) {
      var momentObj = isString ? moment(date, this.format) : moment(new Date(date)),
        dateLengthValid = isString ? date && date.length >= 8 : true,
        isValid = dateLengthValid && momentObj.isValid() && momentObj.isAfter(moment(this.minDate).subtract(1, 'days')),
        formatWith = this.isTimeEnabled ? 'MM/DD/YYYY hh:mm A' : 'MM/DD/YYYY';
      if (!isString && !this.originalDate && this.isTimeEnabled) {
        momentObj = moment(new Date(_.replace(date.toString(), '00:00:00', '08:00:00')));
      }
      if (isValid) {
        this.textInputDate = momentObj.format(this.format);
        this.popupDate = moment(this.textInputDate, this.format).format(formatWith);
        this.selectedDate = this.popupDate;
      } else if (date === '') {
        this.textInputDate = null;
        this.popupDate = null;
        this.selectedDate = this.popupDate;
      } else {
        this.textInputDate = this.originalDate ? this.originalDate : null;
        this.popupDate = this.originalDate ? moment(this.originalDate, this.format).format(formatWith) : null;
      }
    }
  };
  this.updateSelectedDate = function () {
    this.onChange({
      $value: this.selectedDate
    });
    this.originalDate = this.selectedDate ? moment(new Date(this.selectedDate)).format(this.format) : null;
  };
  this.isToday = function (date, mode) {
    var today = new Date(),
      year = today.getFullYear();
    today.setHours(12, 0, 0, 0);
    if (today.toDateString() === date.toDateString() || mode === 'year' && year === date.getFullYear()) {
      return 'today';
    }
  };
  $scope.$on(formViewerConstant.event.CLOSE_CALENDAR_POPUP, function () {
    this.popupOpened = false;
  }.bind(this));
};
TaskCalendarController.$inject = ["$scope", "$rootScope", "$timeout", "coreMediator", "formViewerConstant"];
angular.module('gw-um-submission').controller('taskCalendarController', TaskCalendarController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var TaskCalendarFocusDirective = function TaskCalendarFocusDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    if ($attrs.toggleFocus === 'false') {
      $timeout(function () {
        $scope.$broadcast('uib:datepicker.focus');
      });
    } else {
      $($elm).siblings()[0].focus();
    }
  };
  return {
    restrict: 'AC',
    link: linkFunction
  };
};
TaskCalendarFocusDirective.$inject = ["$timeout"];
angular.module('gw-um-submission').directive('taskCalendarFocus', TaskCalendarFocusDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/collaboration/task/collaborationTask.tpl.html';
var html = "<div class=\"dockPanelHeader collaborationHeader\">\n    <h2 class=\"dockPanelHeaderTitle dockPanelHeaderButton collaborationHeaderTitle\" ng-click=\"hideTasksSubPage()\">\n        <span class=\"glyphicon glyphicon-chevron-left closeCollaborationTaskEditor taskCollabHeaderBackArrow\"></span>\n\n        <img class=\"icon-image icon-collaborationTypeTasks\"\n             src=\"" + __webpack_require__(36) + "\"/>\n\n        <span class=\"taskSubject\"\n              ng-if=\"viewModel.task.isEditorOpen\">{{ taskI18n.createTaskTitle }}</span>\n        <span class=\"taskSubject\"\n              ng-if=\"!viewModel.task.isEditorOpen && !taskViewModel.isResolved\">{{ taskI18n.viewTaskTitle }}</span>\n        <span class=\"taskSubject\"\n              ng-if=\"!viewModel.task.isEditorOpen && taskViewModel.isResolved\">{{ taskI18n.completedTaskTitle }}</span>\n    </h2>\n</div>\n\n<!--Collaboration Content-->\n<div class=\"dockPanelContent collaborationContent\">\n\n    <div class=\"dockPanelInnerContent collaborationInnerContent taskContent\">\n\n        <div class=\"collaborationEditTask\" ng-if=\"!viewModel.task.isEditorOpen\">\n\n            <div class=\"taskItem taskSummary\"\n                 ng-class=\"{summaryOtherOpen: taskViewModel.definition.value === 'Other'}\">\n                <div class=\"labelTaskItem\"\n                     ng-if=\"taskViewModel.isResolved || !taskViewModel.editTaskPermission || !taskViewModel.canEditTask\">\n                    <span class=\"glyphicon taskSummaryIcon\">\n                        <img class=\"icon-image icon-collaborationTypeTasks\"\n                             src=\"" + __webpack_require__(36) + "\"/>\n                    </span>\n                    <span class=\"taskName\">{{ taskViewModel.definition.name }}</span>\n                </div>\n                <div class=\"editTaskItem\"\n                     ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\">\n                    <span class=\"glyphicon taskSummaryIcon\">\n                        <img class=\"icon-image icon-collaborationTypeTasks\"\n                             src=\"" + __webpack_require__(36) + "\"/>\n                    </span>\n                    <ui-select class=\"taskSelect collaborationTaskSelect editTaskSummary\"\n                               ng-model=\"taskViewModel.definition\"\n                               ng-change=\"handleSummaryChange()\"\n                               theme=\"select2\"\n                               append-to-body=\"true\"\n                               placeholder=\"{{ ::taskViewModel.placeholderSummary }}\"\n                               close-on-select=\"true\"\n                               required\n                               ui-hide-select-on-scroll\n                               ui-hide-select-on-scroll-selector=\".taskContent\">\n\n                        <ui-select-match placeholder=\"{{ ::taskViewModel.placeholderSummary }}\" allow-clear=\"false\">\n                            <span ng-bind=\"$select.selected.value\"></span>\n                        </ui-select-match>\n\n                        <ui-select-choices repeat=\"item in (taskViewModel.summaryOptions | filter: {name: $select.search})\">\n                            <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n            <div class=\"taskItem taskSummaryOther\"\n                 ng-if=\"taskViewModel.definition.value === 'Other'\">\n                <div class=\"labelTaskItem\"\n                     ng-if=\"taskViewModel.isResolved || !taskViewModel.editTaskPermission || !taskViewModel.canEditTask\">\n                    <span class=\"glyphicon\"></span>\n                    <span class=\"taskName\">{{ taskViewModel.otherSummary }}</span>\n                </div>\n                <div class=\"editTaskItem\"\n                     ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\">\n                    <span class=\"glyphicon\"></span>\n                    <input type=\"text\"\n                           ng-model=\"taskViewModel.otherSummary\"\n                           ng-blur=\"handleSummaryDescriptionChange()\"\n                           placeholder=\"{{taskViewModel.placeholderDescription}}\"\n                           required/>\n                </div>\n            </div>\n\n            <div class=\"taskItem taskDetails\">\n                <div class=\"labelTaskItem\">\n                    <span class=\"glyphicon glyphicon-pencil\"></span>\n                    <textarea ng-model=\"taskViewModel.task.details\"\n                              ng-blur=\"handleDetailsChange()\"\n                              ng-attr-placeholder=\"{{::taskViewModel.placeholderTaskDetails}}\"></textarea>\n                 </div>\n            </div>\n\n            <div class=\"taskItem taskAssignedTo\">\n                <div class=\"labelTaskItem\"\n                     ng-if=\"isAgent() || taskViewModel.isResolved || !taskViewModel.editTaskPermission\">\n                    <span class=\"glyphicon glyphicon-user\"></span>\n                    <span class=\"assignedLabel\">{{ taskI18n.assignedTo }}</span>\n                    <ui-user-avatar class=\"assignedAvatar\"\n                                    ng-if=\"taskViewModel.task.assignedToId\"\n                                    userid={{taskViewModel.task.assignedToId}}></ui-user-avatar>\n                    <ui-user-avatar class=\"assignedAvatar\"\n                                    ng-if=\"taskViewModel.task.assignedToGroupId\"\n                                    userid={{taskViewModel.task.assignedToGroupId}} is-group=true></ui-user-avatar>\n                    <span class=\"assignedName\">{{ taskViewModel.task.assignedToName || taskViewModel.task.assignedToGroupName }}</spanclass>\n                </div>\n                <div class=\"editTaskItem\"\n                     ng-if=\"!isAgent() && !taskViewModel.isResolved && taskViewModel.editTaskPermission\">\n                    <span class=\"glyphicon glyphicon-user\"></span>\n                    <ui-select class=\"taskSelect collaborationTaskSelect editTaskAssignTo\"\n                               ng-model=\"taskViewModel.assignedToUser\"\n                               ng-change=\"handleAssignToChange()\"\n                               theme=\"select2\"\n                               append-to-body=\"true\"\n                               placeholder=\"{{ ::taskViewModel.placeholderAssignTo }}\"\n                               close-on-select=\"true\"\n                               required\n                               ui-hide-select-on-scroll\n                               ui-hide-select-on-scroll-selector=\".taskContent\">\n\n                        <ui-select-match placeholder=\"{{ ::taskViewModel.placeholderAssignTo }}\"\n                                         allow-clear=\"false\">\n                            <span class=\"assignedLabel\">{{ taskI18n.assignedTo }}</span>\n                            <ui-user-avatar class=\"assignedAvatar\"\n                                            ng-if=\"$select.selected.group !== 'User Groups'\"\n                                            userid={{$select.selected.id}}></ui-user-avatar>\n                            <ui-user-avatar class=\"assignedAvatar\"\n                                            ng-if=\"$select.selected.group === 'User Groups'\"\n                                            userid={{$select.selected.id}}\n                                            is-group=\"true\"></ui-user-avatar>\n                            <span ng-bind=\"$select.selected.name\"></span>\n                            <span ng-if=\"$select.selected.roles\"> ({{ $select.selected.roles }})</span>\n                        </ui-select-match>\n\n                        <ui-select-choices group-by=\"'group'\"\n                                           refresh=\"filterItems($select.search)\"\n                                           refresh-delay=\"250\"\n                                           repeat=\"item in taskViewModel.filteredItemsList track by $index\"\n                                           ui-disable-choice=\"item.disabled === true\">\n                            <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                            <span ng-if=\"item.roles\"> ({{ item.roles }})</span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n\n            <div class=\"taskItem taskAssignedBy\">\n                <div class=\"labelTaskItem\">\n                    <span class=\"glyphicon glyphicon-user\"></span>\n                    <span class=\"assignedLabel\">{{ taskI18n.assignedBy }}</span>\n                    <ui-user-avatar class=\"assignedAvatar\"\n                                    userid={{taskViewModel.task.assignedById}}></ui-user-avatar>\n                    <span class=\"assignedName\">{{ taskViewModel.task.assignedByName }}</span>\n                    <span class=\"assignedDatetime\">{{ taskViewModel.task.createdDate | date : viewModel.preferenceDateFormat + ' hh:mm a' }}</span>\n                </div>\n            </div>\n\n            <div class=\"taskItem taskReceivedDate\" ng-if=\"viewModel.isTaskReceivedDateEnabled\">\n                <div class=\"labelTaskItem\"\n                     ng-if=\"taskViewModel.isResolved || !taskViewModel.editTaskPermission || !taskViewModel.canEditTask\">\n                    <i class=\"fa fa-calendar-check-o\" aria-hidden=\"true\"></i>\n                    <span class=\"receivedDateLabel\">{{ taskI18n.received }}</span>\n                    <time ng-if=\"taskViewModel.task.receivedDate\">{{ taskViewModel.task.receivedDate | utcDateFilter:viewModel.preferenceDateFormat.toUpperCase() + ' hh:mm A' }}\n                    </time>\n                    <span ng-if=\"!taskViewModel.task.receivedDate\">{{ taskI18n.receivedDate }}</span>\n                </div>\n                <div class=\"editTaskItem\"\n                     ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\">\n                    <i class=\"fa fa-calendar-check-o\" aria-hidden=\"true\"></i>\n                    <span class=\"receivedDateLabel\">{{ taskI18n.received }}</span>\n                    <ui-task-calendar class=\"uiTaskCalendar\"\n                                      ng-model=\"taskViewModel.receivedDate\"\n                                      on-change=\"handleReceivedDateChange($value)\"\n                                      placeholder-text=\"taskViewModel.placeholderReceivedDate\"\n                                      min-date=\"taskViewModel.receivedDateMin\"\n                                      is-time-enabled=\"true\"></ui-task-calendar>\n                </div>\n            </div>\n\n            <div class=\"taskItem taskDueDate\">\n                <div class=\"labelTaskItem\"\n                     ng-if=\"taskViewModel.isResolved || !taskViewModel.editTaskPermission || !taskViewModel.canEditTask\">\n                    <span class=\"glyphicon glyphicon-time\"></span>\n                    <span class=\"dueDateLabel\">{{ taskI18n.due }}</span>\n                    <time ng-if=\"taskViewModel.task.dueDate\">{{ taskViewModel.task.dueDate | utcDateFilter: viewModel.preferenceDateFormat.toUpperCase() + ' hh:mm A':true }}\n                    </time>\n                    <span ng-if=\"!taskViewModel.task.dueDate\">{{ taskI18n.setDueDate }}</span>\n                </div>\n                <div class=\"editTaskItem\"\n                     ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\">\n                    <span class=\"glyphicon glyphicon-time\"></span>\n                    <span class=\"dueDateLabel\">{{ taskI18n.due }}</span>\n                    <ui-task-calendar class=\"uiTaskCalendar\"\n                                      ng-model=\"taskViewModel.dueDate\"\n                                      on-change=\"handleDueDateChange($value)\"\n                                      placeholder-text=\"taskViewModel.placeholderSetDueDate\"\n                                      is-time-enabled=\"true\"></ui-task-calendar>\n                </div>\n            </div>\n            <div class=\"taskItem taskPriority\">\n                <div class=\"labelTaskItem\"\n                     ng-if=\"taskViewModel.isResolved || !taskViewModel.editTaskPermission || !taskViewModel.canEditTask\">\n                    <span class=\"glyphicon\"\n                          ng-class=\"{'glyphicon-sort': !taskViewModel.task.priority,\n                                    'glyphicon-arrow-up': taskViewModel.task.priority === 3,\n                                    'glyphicon-minus': taskViewModel.task.priority === 2,\n                                    'glyphicon-arrow-down': taskViewModel.task.priority === 1}\"></span>\n                    <span class=\"taskName\"\n                          ng-if=\"taskViewModel.task.priority\"\n                          ng-bind=\"getPriorityName(taskViewModel.task.priority)\"></span>\n                    <span class=\"taskPriorityPlaceholder\" ng-if=\"!taskViewModel.task.priority\">{{ taskI18n.priority }}</span>\n                </div>\n                <div class=\"editTaskItem\"\n                     ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\">\n                    <span class=\"glyphicon\"\n                          ng-class=\"{'glyphicon-sort': !taskViewModel.task.priority,\n                                    'glyphicon-arrow-up': taskViewModel.task.priority === 3,\n                                    'glyphicon-minus': taskViewModel.task.priority === 2,\n                                    'glyphicon-arrow-down': taskViewModel.task.priority === 1}\"></span>\n                    <ui-select class=\"taskSelect collaborationTaskSelect\"\n                               ng-model=\"taskViewModel.priority\"\n                               ng-change=\"handlePriorityChange()\"\n                               theme=\"select2\"\n                               append-to-body=\"true\"\n                               placeholder=\"{{ ::taskViewModel.placeholderPriority }}\"\n                               close-on-select=\"true\"\n                               ui-hide-select-on-scroll\n                               ui-hide-select-on-scroll-selector=\".taskContent\">\n\n                        <ui-select-match placeholder=\"{{ ::taskViewModel.placeholderPriority }}\" allow-clear=\"false\">\n                            <span ng-bind=\"$select.selected.name\"></span>\n                        </ui-select-match>\n\n                        <ui-select-choices repeat=\"item in (taskViewModel.priorityOptions | filter: {name: $select.search})\">\n                            <span class=\"glyphicon taskPriorityIcon\"\n                                  ng-class=\"{'glyphicon-arrow-up': item.value === 3,\n                                            'glyphicon-minus': item.value === 2,\n                                            'glyphicon-arrow-down': item.value === 1}\"></span>\n                            <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n\n            <div class=\"taskNextAction taskItem\">\n                <div class=\"labelTaskItem isResolved\"\n                     ng-if=\"isAgent() || taskViewModel.isResolved || !taskViewModel.editTaskPermission || !taskViewModel.canEditTask\">\n                    <span class=\"glyphicon glyphicon-home\"></span>\n                    <span>{{ taskI18n.nextAction }}</span>\n                    <input type=\"checkbox\"\n                           ng-model=\"taskViewModel.task.nextTask\"\n                           disabled=\"disabled\"/>\n                </div>\n                <div class=\"labelTaskItem\"\n                     ng-if=\"!isAgent() && !taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\">\n                    <span class=\"glyphicon glyphicon-home\"></span>\n                    <span ng-click=\"handleNextTaskClick()\"\n                          class=\"taskInputLabel\"\n                          ng-class=\"{ selected: taskViewModel.task.nextTask }\">{{ taskI18n.nextAction }}</span>\n                    <input type=\"checkbox\"\n                           ng-model=\"taskViewModel.task.nextTask\"\n                           ng-change=\"handleUpdateTask()\"/>\n                </div>\n            </div>\n\n            <div class=\"taskAttachFile taskItem\"\n                 ng-if=\"canDisplayAttachmentSection()\">\n                <div class=\"editTaskItem\">\n                    <span class=\"glyphicon glyphicon-paperclip\"></span>\n                    <span class=\"taskInputLabel\"\n                          ng-click=\"openAttachmentList()\"\n                          ng-class=\"{ selected: taskViewModel.task.nextTask }\"\n                          ng-if=\"taskViewModel.attachmentTagItems.length === 0\"\n                          ui-translate>submission.collaboration.task.attachFile</span>\n\n                    <div class=\"tagLayout\"\n                         ng-if=\"taskViewModel.attachmentTagItems.length > 0\">\n                        <div class=\"tagContainer\" ng-repeat=\"attachmentTag in taskViewModel.attachmentTagItems track by $index\">\n                            <div class=\"attachmentTag\"\n                                 uib-tooltip=\"{{ attachmentTag.name }}\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-popup-delay=\"500\">\n                                <span class=\"glyphicon glyphicon-file btn-sm\"></span>\n                                <span class=\"tagLabel\">\n                                    <a ng-click=\"handleAttachmentDownloadClick(attachmentTag)\">{{ attachmentTag.name }} ({{attachmentTag.byteCountToDisplaySize}})</a>\n                                </span>\n                                <button class=\"close\"\n                                        ng-if=\"canDeleteAttachment()\"\n                                        ng-click=\"onDeleteAttachment(attachmentTag)\">\n                                    <span class=\"glyphicon glyphicon-remove btn-sm\"></span>\n                                </button>\n                            </div>\n                        </div>\n                        <span class=\"addFile\"\n                              ng-click=\"openAttachmentList($event)\"\n                              ng-if=\"taskViewModel.attachmentTagItems.length > 0 && canAddAttachment()\"\n                              ui-translate>submission.collaboration.task.addFile</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"taskItem\"\n                 ng-if=\"canAddAttachment() && taskViewModel.showAttachmentList\"\n                 ng-click=\"onAttachmentListClick($event)\">\n                <div class=\"attachmentList\">\n                    <label class=\"heading\" ui-translate>submission.collaboration.task.chooseFromExistingFiles</label>\n                    <div class=\"attachmentListBox\">\n                        <div class=\"multiSelectItem\"\n                             ng-mouseleave=\"removeFocusStyle( tabIndex );\"\n                             ng-repeat=\"attachment in taskViewModel.submissionAttachments\">\n                            <div class=\"attachmentItem\">\n                                <label ng-click=\"$event.stopPropagation()\">\n                                    <input class=\"checkbox focusable\"\n                                           type=\"checkbox\"\n                                           ng-change=\"onAttachmentItemClick($event, attachment)\"\n                                           ng-checked=\"attachment.checked\"\n                                           ng-model=\"attachment.checked\">\n                                    <span class=\"taskAttachmentName\">{{attachment.name}} ({{attachment.byteCountToDisplaySize}})</span>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                    <button class=\"btn btn-primary newFileButton\"\n                            ng-click=\"handleAttachmentClick()\"\n                            ng-blur=\"onUploadNewFileBlur()\"\n                            ui-translate>submission.collaboration.task.uploadNewFile</button>\n                </div>\n            </div>\n\n            <div class=\"taskRemindMeDate taskItem\">\n                <div class=\"labelTaskItem\"\n                     ng-if=\"taskViewModel.isResolved || !taskViewModel.editTaskPermission || !taskViewModel.canEditTask\">\n                    <span class=\"glyphicon glyphicon-time\"></span>\n                    <span class=\"reminderDateLabel\">{{ taskI18n.reminder }}</span>\n                    <time ng-if=\"taskViewModel.task.reminderDueDate\">{{ taskViewModel.task.reminderDueDate | utcDateFilter:viewModel.preferenceDateFormat.toUpperCase() + ' hh:mm A' }}\n                    </time>\n                    <span ng-if=\"!taskViewModel.task.reminderDueDate\">{{ taskI18n.remindMe }}</span>\n                </div>\n                <div class=\"editTaskItem\"\n                     ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\">\n                    <span class=\"glyphicon glyphicon-time\"></span>\n                    <span class=\"reminderDateLabel\">{{ taskI18n.reminder }}</span>\n                    <ui-task-calendar class=\"uiTaskCalendar\"\n                                      ng-model=\"taskViewModel.reminderDueDate\"\n                                      on-change=\"handleReminderDateChange($value)\"\n                                      placeholder-text=\"taskViewModel.placeholderRemindMe\"\n                                      max-date=\"taskViewModel.task.dueDate\"\n                                      is-time-enabled=\"true\"></ui-task-calendar>\n                </div>\n            </div>\n\n            <div class=\"taskReminderEmail taskItem\"\n                 ng-if=\"taskViewModel.task.reminderDueDate\">\n                <div class=\"labelTaskItem isResolved\"\n                     ng-if=\"taskViewModel.isResolved || !taskViewModel.editTaskPermission || !taskViewModel.canEditTask\">\n                    <span class=\"glyphicon glyphicon-envelope\"></span>\n                    <span>{{ taskI18n.reminderEmail }}</span>\n                    <input type=\"checkbox\"\n                           ng-model=\"taskViewModel.task.notifyWhenPastDue\"\n                           disabled=\"disabled\"/>\n                </div>\n                <div class=\"labelTaskItem\"\n                     ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\">\n                    <span class=\"glyphicon glyphicon-envelope\"></span>\n                    <span ng-click=\"handleReminderEmailClick()\"\n                          class=\"taskInputLabel\"\n                          ng-class=\"{ selected: taskViewModel.task.notifyWhenPastDue }\">{{ taskI18n.reminderEmail }}</span>\n                    <input type=\"checkbox\"\n                           ng-model=\"taskViewModel.task.notifyWhenPastDue\"\n                           ng-change=\"handleUpdateTask()\"/>\n                </div>\n            </div>\n\n            <div ng-class=\"{'taskResolutionGroup': viewModel.isTaskResolutionReasonEnabled}\">\n                <div class=\"taskResolutionReason taskItem\"\n                     ng-if=\"viewModel.isTaskResolutionReasonEnabled\">\n                    <span class=\"glyphicon glyphicon-flag\"></span>\n                    <ui-select class=\"taskSelect collaborationTaskSelect editTaskResolution\"\n                               ng-model=\"taskViewModel.resolutionReason\"\n                               ng-change=\"handleResolutionReasonChange()\"\n                               theme=\"select2\"\n                               append-to-body=\"true\"\n                               placeholder=\"{{ ::taskViewModel.placeholderTaskResolution }}\"\n                               close-on-select=\"true\"\n                               required\n                               ui-hide-select-on-scroll\n                               ui-hide-select-on-scroll-selector=\".taskContent\">\n\n                        <ui-select-match placeholder=\"{{ ::taskViewModel.placeholderTaskResolution }}\" allow-clear=\"false\">\n                            <span ng-bind=\"$select.selected.value\"></span>\n                        </ui-select-match>\n\n                        <ui-select-choices repeat=\"item in (taskViewModel.resolutionReasonOptions | filter: {name: $select.search})\">\n                            <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n\n                <div class=\"taskNotes taskItem\">\n                    <div class=\"labelTaskItem\">\n                        <span class=\"glyphicon glyphicon-pencil\"></span>\n                        <textarea ng-model=\"taskViewModel.task.comments\"\n                                  ng-blur=\"handleCommentsChange()\"\n                                  ng-disabled=\"!taskViewModel.editTaskPermission || !taskViewModel.canEditTask\"\n                                  ng-attr-placeholder=\"{{taskViewModel.placeholderNotes}}\"></textarea>\n                    </div>\n                </div>\n\n                <div class=\"taskItem taskResolvedBy\"\n                     ng-if=\"taskViewModel.isResolved\">\n                    <div class=\"labelTaskItem\">\n                        <span class=\"glyphicon glyphicon-user\"></span>\n                        <span class=\"assignedLabel\">{{ taskI18n.resolvedBy }}</span>\n                        <ui-user-avatar class=\"assignedAvatar\"\n                                        userid={{taskViewModel.task.resolvedById}}></ui-user-avatar>\n                        <span class=\"assignedName\">{{ taskViewModel.task.resolvedByName }}</span>\n                        <span class=\"assignedDatetime\">{{ taskViewModel.task.resolutionDate | date : viewModel.preferenceDateFormat + ' hh:mm a' }}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"taskFooter\">\n                <div class=\"taskFooterButtons\">\n                    <span class=\"labelTaskItem visibleToAgent\">\n                        <!--<input type=\"checkbox\"\n                                ng-model=\"taskViewModel.task.shared\"\n                                ng-if=\"!taskViewModel.isResolved\"\n                                disabled=\"disabled\"/>\n                        <span ng-if=\"!taskViewModel.isResolved\">{{ taskI18n.visibleToAgent }}</span>-->\n                    </span>\n\n                    <span class=\"taskTrash glyphicon glyphicon-trash\"\n                          ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask && canDeleteTask()\"\n                          ng-click=\"handleDeleteTask()\">\n                    </span>\n\n                    <button class=\"btn btn-primary taskNotify\"\n                            ng-if=\"!isAgent() && taskViewModel.task.assignedToId !== viewModel.currentUserId && !taskViewModel.isResolved\"\n                            ng-click=\"handleNotify()\"\n                            uib-tooltip=\"{{ ::taskI18n.taskNotifyTooltip }}\"\n                            tooltip-append-to-body=\"true\"\n                            tooltip-popup-delay=\"500\">\n                        <i class=\"fa fa-bell-o\" aria-hidden=\"true\"></i>\n                        {{ ::taskI18n.notify }}\n                    </button>\n\n                    <button class=\"btn btn-primary resolveTask\"\n                            ng-if=\"!taskViewModel.isResolved && taskViewModel.editTaskPermission && taskViewModel.canEditTask\"\n                            ng-click=\"handleResolveTask()\">{{ ::taskI18n.resolveTask }}\n                    </button>\n                </div>\n            </div>\n\n        </div>\n\n        <div ng-if=\"viewModel.task.isEditorOpen\"\n             class=\"collaborationEditTask\"\n             ng-controller=\"collaborationTaskEditorController\"\n             ng-include=\"'/collaboration/task/collaborationTaskEditor.tpl.html'\">\n        </div>\n\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {var locale = __webpack_require__(88);

/*@ngInject*/
var CollaborationTaskController = function CollaborationTaskController($rootScope, $scope, $stateParams, $uibModal, $document, $window, $filter, $timeout, coreConstant, coreMediator, userRepository, collaborationMediator, modalUtil, localization, authorizationConstants, submissionTaskStatus, submissionConstant, attachmentUtil, attachmentMediator, currentUserModel) {
  var _this = this;
  $scope.taskI18n = locale;
  function resetTaskViewModel() {
    $scope.taskViewModel = {
      task: null,
      editTaskPermission: null,
      placeholderSummary: $scope.taskI18n.summary,
      placeholderDescription: $scope.taskI18n.description,
      placeholderAssignTo: $scope.taskI18n.assignTo,
      placeholderPriority: $scope.taskI18n.priority,
      placeholderRemindMe: $scope.taskI18n.remindMe,
      placeholderSetDueDate: $scope.taskI18n.setDueDate,
      placeholderReceivedDate: $scope.taskI18n.receivedDate,
      placeholderTaskDetails: $scope.taskI18n.taskDetails,
      placeholderNotes: $scope.taskI18n.notes,
      placeholderTaskResolution: $scope.taskI18n.resolutionReason,
      isResolved: false,
      canEditTask: false,
      reminderDueDate: null,
      itemsList: [],
      submissionParticipantsList: [],
      assignedToUser: null,
      dueDate: null,
      receivedDate: null,
      receivedDateMin: moment().add(-3, 'months').toDate(),
      definition: {
        name: '',
        value: ''
      },
      priority: null,
      details: null,
      otherSummary: null,
      originalValues: null,
      summaryOptions: [],
      attachmentTagItems: [],
      showAttachmentList: false,
      submissionAttachments: [],
      filteredItemsList: [],
      priorityOptions: [{
        name: '3- High',
        value: 3
      }, {
        name: '2- Medium',
        value: 2
      }, {
        name: '1- Low',
        value: 1
      }],
      resolutionReasonOptions: [],
      resolutionReason: null
    };
    $scope.canCloseAttachmentList = true;
    $scope.canDisplayList = false;
    var permissions = [];
    var neededPermissions = [authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS, authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS];
    _.each(neededPermissions, function (neededPermission) {
      if (currentUserModel.hasAuthorization(neededPermission)) {
        permissions.push(neededPermission);
      }
    });
    $scope.taskViewModel.permissions = permissions;
    loadSummaryDropdown();
    $scope.taskViewModel.itemsList = [];
    loadTaskPriorityOptions();
  }
  $scope.canAddAttachment = function () {
    return _.includes($scope.taskViewModel.permissions, authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS);
  };
  $scope.canDeleteAttachment = function () {
    return _.includes($scope.taskViewModel.permissions, authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS);
  };
  function loadCollaborationTask(taskId) {
    resetTaskViewModel();
    $scope.viewModel.isLoading = true;
    collaborationMediator.loadCollaborationTask(taskId).then(function (taskWrapper) {
      var taskItem = taskWrapper.Task,
        definition = taskItem.definition && taskItem.definition.indexOf('Other') !== -1 ? 'Other' : taskItem.definition;
      $scope.taskViewModel.task = taskItem;
      $scope.taskViewModel.attachmentTagItems = _.isNil($scope.taskViewModel.task.attachmentSummaries) ? [] : $scope.taskViewModel.task.attachmentSummaries;
      _.each($scope.taskViewModel.attachmentTagItems, function (attachmentTagItem) {
        attachmentTagItem.byteCountToDisplaySize = attachmentUtil.convertAttachmentSize(attachmentTagItem.size);
      });
      $scope.taskViewModel.assignedToUser = {
        id: taskItem.assignedToGroupId ? taskItem.assignedToGroupId : taskItem.assignedToId,
        name: taskItem.assignedToGroupName ? taskItem.assignedToGroupName : taskItem.assignedToName,
        group: taskItem.assignedToGroupId ? 'User Groups' : null
      };
      if (!$scope.taskViewModel.assignedToUser.roles) {
        $scope.getUserRoles($scope.taskViewModel.assignedToUser);
      }
      $scope.taskViewModel.originalValues = _.clone(taskItem);
      $scope.taskViewModel.dueDate = taskItem.dueDate ? moment(taskItem.dueDate) : null;
      $scope.taskViewModel.receivedDate = taskItem.receivedDate ? moment(taskItem.receivedDate) : null;
      $scope.taskViewModel.reminderDueDate = taskItem.reminderDueDate ? moment(taskItem.reminderDueDate) : null;
      $scope.taskViewModel.otherSummary = definition === 'Other' ? _.replace(_.replace(taskItem.definition, 'Other::', ''), 'Other - ', '') : null;
      $scope.taskViewModel.details = taskItem.details;
      $scope.taskViewModel.definition = {
        name: definition,
        value: definition
      };
      $scope.taskViewModel.priority = taskItem.priority ? _.find($scope.taskViewModel.priorityOptions, ['value', taskItem.priority]) : null;
      $scope.taskViewModel.resolutionReason = {
        name: taskItem.resolutionReason,
        value: taskItem.resolutionReason
      };
      $scope.taskViewModel.editTaskPermission = $scope.canAssignTask();
      $scope.taskViewModel.isResolved = taskItem.status === submissionTaskStatus.RESOLVED;
      $scope.taskViewModel.canEditTask = !$scope.isAgent() || $scope.isAgent() && taskItem.assignedToId === $scope.viewModel.currentUserId;
      $scope.viewModel.isLoading = false;
      $scope.viewModel.task.isVisible = true;
      loadSubmissionAttachment();
      loadTaskResolutionReasonsDropdown();
    });
  }
  function loadTaskPriorityOptions() {
    var ownerUri = $scope.taskViewModel.task ? 'com.firstbest.underwriting.submission.task.SubmissionTask:' + $scope.taskViewModel.task.id : null;
    var taskPriorityParams = {
      name: 'Task Priority',
      submissionUri: 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId,
      ownerUri: ownerUri
    };
    coreMediator.getDynamicDataSetItems(taskPriorityParams).then(function (result) {
      if (result) {
        _.each(result, function (option) {
          option.value = parseInt(option.value);
        });
        $scope.taskViewModel.priorityOptions = result;
      }
    });
  }
  ;
  function loadSummaryDropdown() {
    var taskSummaryParams = {
      name: 'Dynamic Task Summary for UW Advanced Filter',
      submissionUri: 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId
    };
    coreMediator.getDynamicDataSetItems(taskSummaryParams).then(function (result) {
      $scope.taskViewModel.summaryOptions = result;
    });
  }
  function loadPeoplePicker() {
    var submissionParticipantsListLength = 0;
    coreMediator.loadUsersList($stateParams.submissionId).then(function (users) {
      $scope.taskViewModel.itemsList = users;
      var submissionParticipants = users.filter(function (user) {
        return user.group === 'Submission Participants';
      });
      $scope.taskViewModel.submissionParticipantsList = submissionParticipants;
      submissionParticipantsListLength = $scope.taskViewModel.submissionParticipantsList.length;
      $scope.taskViewModel.submissionParticipantsList.push({
        id: submissionParticipantsListLength,
        name: $scope.taskI18n.longListMessage,
        disabled: true
      });
    });
  }
  $scope.getUserRoles = function (item) {
    if (item.group !== "User Groups") {
      userRepository.getUserRolesById(item.id).then(function (roles) {
        item.roles = roles;
      });
    } else {
      item.roles = "User Group";
    }
  };
  function loadTaskResolutionReasonsDropdown() {
    var taskResolutionReasonsParams = {
      name: 'Task Resolution Reasons',
      submissionUri: 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId,
      ownerUri: 'com.firstbest.underwriting.submission.task.SubmissionTask:' + $scope.taskViewModel.task.id
    };
    coreMediator.getDynamicDataSetItems(taskResolutionReasonsParams).then(function (result) {
      $scope.taskViewModel.resolutionReasonOptions = result;
      // if the currently set taskResolution is not in the list of returned Task Resolution Reasons, then clear it out and update the task
      if ($scope.taskViewModel.resolutionReason != null && !result.find(function (resolutionReasonOption) {
        return resolutionReasonOption.name === $scope.taskViewModel.resolutionReason.name;
      })) {
        $scope.taskViewModel.resolutionReason = null;
        $scope.handleUpdateTask();
      }
    });
  }
  $scope.filterItems = function (searchText) {
    var filteredItemsList = [],
      listItemsLength = $scope.taskViewModel.itemsList.length;
    var maxItems = 150;
    if (!_.isEmpty(searchText)) {
      filteredItemsList = _.filter($scope.taskViewModel.itemsList, function (item) {
        return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
      });
      //if after searching there are over 150 participants - still only display submissionParticipants
      if (filteredItemsList.length > maxItems) {
        filteredItemsList = $scope.taskViewModel.submissionParticipantsList;
      }
    } else {
      if (listItemsLength > maxItems) {
        filteredItemsList = $scope.taskViewModel.submissionParticipantsList;
      } else {
        filteredItemsList = $scope.taskViewModel.itemsList;
      }
    }
    $scope.taskViewModel.filteredItemsList = filteredItemsList;
  };
  function loadSubmissionAttachment() {
    if ($scope.isAgent()) {
      collaborationMediator.loadSharedSubmissionAttachments($stateParams.submissionId).then(function (submissionAttachmentList) {
        loadSubmissionAttachmentContinue(submissionAttachmentList);
      });
    } else {
      collaborationMediator.loadSubmissionAttachments($stateParams.submissionId).then(function (submissionAttachmentList) {
        loadSubmissionAttachmentContinue(submissionAttachmentList);
      });
    }
  }
  function loadSubmissionAttachmentContinue(submissionAttachmentList) {
    _.each(submissionAttachmentList, function (attachment) {
      _.each($scope.taskViewModel.attachmentTagItems, function (att) {
        if (att.name === attachment.name) {
          attachment.checked = true;
          $scope.taskViewModel.submissionAttachments.push(attachment);
        }
      });
      if (!attachment.checked) {
        $scope.taskViewModel.submissionAttachments.push(attachment);
      }
    });
  }
  $scope.isCurrentUser = function () {
    if ($scope.viewModel.userProfile && $scope.taskViewModel.task) {
      if ($scope.viewModel.currentUserId === $scope.taskViewModel.task.userId) {
        return true;
      }
    }
    return false;
  };
  $scope.isAgent = function () {
    var currentUser;
    if ($scope.getCurrentUser) {
      currentUser = $scope.getCurrentUser();
    }
    return currentUser && currentUser.userType === 'Agent';
  };
  $scope.canEditTask = function () {
    return $scope.taskViewModel.editTaskPermission;
  };
  $scope.canResolve = function () {
    return $scope.taskViewModel.editTaskPermission;
  };
  $scope.getUserId = function (item) {
    return _.isNumber(item.id) ? item.id : 0;
  };
  $scope.hideTasksSubPage = function () {
    $scope.hideSubPage();
    $timeout(function () {
      resetTaskViewModel();
    }, 500);
  };
  $scope.getPriorityName = function (priority) {
    var priorityObject = _.find($scope.taskViewModel.priorityOptions, ['value', priority]);
    return priorityObject.name;
  };
  $scope.handleAssignToChange = function () {
    if ($scope.taskViewModel.assignedToUser) {
      if ($scope.taskViewModel.assignedToUser.group === 'User Groups') {
        $scope.taskViewModel.task.assignedToId = null;
        $scope.taskViewModel.task.assignedToName = null;
        $scope.taskViewModel.task.assignedToGroupId = $scope.taskViewModel.assignedToUser.id;
        $scope.taskViewModel.task.assignedToGroupName = $scope.taskViewModel.assignedToUser.name;
      } else {
        $scope.taskViewModel.task.assignedToId = $scope.taskViewModel.assignedToUser.id;
        $scope.taskViewModel.task.assignedToName = $scope.taskViewModel.assignedToUser.name;
        $scope.taskViewModel.task.assignedToGroupId = null;
        $scope.taskViewModel.task.assignedToGroupName = null;
      }
    } else {
      $scope.taskViewModel.task.assignedToId = null;
      $scope.taskViewModel.task.assignedToName = null;
      $scope.taskViewModel.task.assignedToGroupId = null;
      $scope.taskViewModel.task.assignedToGroupName = null;
    }
    if (!$scope.taskViewModel.assignedToUser.roles) {
      $scope.getUserRoles($scope.taskViewModel.assignedToUser);
    }
    $scope.handleUpdateTask();
  };
  $scope.handleSummaryChange = function () {
    if ($scope.taskViewModel.definition.value !== $scope.taskViewModel.originalValues.definition) {
      if ($scope.taskViewModel.definition.value !== 'Other') {
        $scope.taskViewModel.task.definition = $scope.taskViewModel.definition.value;
        $scope.taskViewModel.otherSummary = null;
        $scope.handleUpdateTask().then(function () {
          // reload task resolution reason as it is dynamic drop down based on the task definition
          loadTaskResolutionReasonsDropdown();
        });
        $scope.taskViewModel.originalValues.definition = $scope.taskViewModel.task.definition;
      } else {
        $scope.taskViewModel.task.definition = null;
        $scope.taskViewModel.otherSummary = null;
      }
    }
  };
  $scope.handlePriorityChange = function () {
    if ($scope.taskViewModel.priority.value !== $scope.taskViewModel.originalValues.priority) {
      $scope.taskViewModel.task.priority = $scope.taskViewModel.priority.value;
      $scope.handleUpdateTask();
      $scope.taskViewModel.originalValues.priority = $scope.taskViewModel.task.priority;
    }
  };
  $scope.handleSummaryDescriptionChange = function () {
    if ($scope.taskViewModel.definition.value === 'Other' && $scope.taskViewModel.otherSummary) {
      $scope.taskViewModel.task.definition = 'Other::' + $scope.taskViewModel.otherSummary;
      $scope.handleUpdateTask();
      $scope.taskViewModel.originalValues.definition = $scope.taskViewModel.task.definition;
    } else {
      $scope.taskViewModel.task.definition = null;
    }
  };
  $scope.handleDetailsChange = function () {
    if ($scope.taskViewModel.task.details !== $scope.taskViewModel.originalValues.details) {
      $scope.handleUpdateTask();
      $scope.taskViewModel.originalValues.details = $scope.taskViewModel.task.details;
    }
  };
  $scope.handleCommentsChange = function () {
    if ($scope.taskViewModel.task.comments !== $scope.taskViewModel.originalValues.comments) {
      $scope.handleUpdateTask();
      $scope.taskViewModel.originalValues.comments = $scope.taskViewModel.task.comments;
    }
  };
  $scope.handleReceivedDateChange = function (selectedDate) {
    var receivedDate = selectedDate ? moment(new Date(selectedDate)).startOf('minute') : null;
    $scope.taskViewModel.task.receivedDate = receivedDate ? moment(receivedDate).unix() * 1000 : null;
    $scope.handleUpdateTask();
  };
  $scope.handleDueDateChange = function (selectedDate) {
    var dueDate = selectedDate ? moment(new Date(selectedDate)).startOf('minute') : null,
      eightAM = selectedDate ? moment(selectedDate).startOf('day').add(8, 'hours') : null;
    $scope.taskViewModel.task.dueDate = dueDate ? moment(dueDate).unix() * 1000 : null;
    $scope.taskViewModel.task.reminderDueDate = eightAM ? moment(eightAM).unix() * 1000 : null;
    $scope.taskViewModel.reminderDueDate = eightAM;
    $scope.handleUpdateTask();
  };
  $scope.handleReminderDateChange = function (selectedDate) {
    var reminderDate = selectedDate ? moment(new Date(selectedDate)).startOf('minute') : null;
    $scope.taskViewModel.task.reminderDueDate = reminderDate ? moment(reminderDate).unix() * 1000 : null;
    if (!reminderDate) {
      $scope.taskViewModel.task.notifyWhenPastDue = false;
    }
    $scope.handleUpdateTask();
  };
  $scope.handleResolutionReasonChange = function () {
    if ($scope.taskViewModel.resolutionReason.value !== $scope.taskViewModel.originalValues.resolutionReason) {
      $scope.taskViewModel.task.resolutionReason = $scope.taskViewModel.resolutionReason.value;
      $scope.handleUpdateTask();
      $scope.taskViewModel.originalValues.resolutionReason = $scope.taskViewModel.task.resolutionReason;
    }
  };
  $scope.handleReminderEmailClick = function () {
    $scope.taskViewModel.task.notifyWhenPastDue = !$scope.taskViewModel.task.notifyWhenPastDue;
    $scope.handleUpdateTask();
  };
  $scope.handleNextTaskClick = function () {
    $scope.taskViewModel.task.nextTask = !$scope.taskViewModel.task.nextTask;
    $scope.handleUpdateTask();
  };
  $scope.handleUpdateTask = function () {
    return $scope.updateTask($scope.taskViewModel.task.id, $scope.taskViewModel.task);
  };
  $scope.handleDeleteTask = function () {
    var taskId = $scope.taskViewModel.task.id,
      message = $scope.taskI18n.confirmationTaskDelete,
      title = $scope.taskI18n.deleteTask,
      cancelButtonLabel = $scope.taskI18n.cancelActionButtonLabel,
      confirmButtonLabel = $scope.taskI18n.confirmActionButtonLabel;
    function handleClose() {
      $scope.deleteTask(taskId);
      $scope.hideTasksSubPage();
    }
    modalUtil.showGenericConfirm({
      cancelButtonLabel: cancelButtonLabel,
      confirmActionButtonLabel: confirmButtonLabel,
      summary: message,
      title: title
    }).then(handleClose);
  };
  $scope.handleNotify = function () {
    collaborationMediator.notifyTaskAssignee($scope.taskViewModel.task.id).then(function () {
      $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, $scope.taskI18n.taskNotifyFadingNotification);
    });
  };
  $scope.handleResolveTask = function () {
    $scope.taskViewModel.task.status = submissionTaskStatus.RESOLVED;
    $scope.updateTask($scope.taskViewModel.task.id, $scope.taskViewModel.task);
    $scope.hideTasksSubPage();
  };
  $scope.handleAttachmentDownloadClick = function (attachmentItem) {
    attachmentUtil.getAttachmentLinkURL(attachmentItem.id, attachmentItem.name).then(function (url) {
      $window.open(url, '_blank');
    });
  };
  $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function () {
    if ($scope.viewModel.task.isVisible) {
      loadPeoplePicker();
      _this.filterItems();
    }
  });
  $scope.$watch('viewModel.task.isVisible', function (newValue) {
    if (newValue) {
      loadPeoplePicker();
    }
  });
  $scope.$watch('viewModel.selectedItem', function (newValue) {
    if (newValue && newValue.type === 'task') {
      loadCollaborationTask(newValue.id);
    }
  });
  $scope.openAttachmentList = function (event) {
    if ($scope.taskViewModel.submissionAttachments.length > 0) {
      $scope.canDisplayList = !$scope.canDisplayList;
      addListeners();
    } else {
      $scope.handleAttachmentClick();
    }
  };
  $scope.handleAttachmentClick = function () {
    var instance = $uibModal.open({
      templateUrl: '/collaboration/task/newTaskAttachmentModal/newTaskAttachmentModal.tpl.html',
      controller: 'newTaskAttachmentModalController',
      backdrop: 'static',
      windowClass: 'newTaskAttachmentModal',
      resolve: {
        options: function options() {
          return {};
        },
        isUnderwriterUser: !$scope.isAgent()
      }
    });
    instance.result.then(function (data) {
      var payload = attachmentUtil.getAttachmentPayload(data.attachment);
      payload = _.assign(payload, {
        'ownerUri': 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId,
        'submissionId': $stateParams.submissionId
      });
      attachmentMediator.saveAttachment(payload, data.file).then(function (payload) {
        $scope.taskViewModel.submissionAttachments.push(payload.attachment);
        payload.attachment.checked = true;
        $scope.taskViewModel.attachmentTagItems.push(payload.attachment);
        $scope.taskViewModel.task.attachmentSummaries = $scope.taskViewModel.attachmentTagItems;
        collaborationMediator.updateCollaborationTaskAttachment($scope.taskViewModel.task.id, payload.attachment).then(function () {
          $scope.handleUpdateTask();
        });
      });
    });
  };
  $scope.onAttachmentListClick = function (event) {
    $scope.canCloseAttachmentList = false;
  };
  $scope.isAttachmentSelected = function (attachment) {
    _.each($scope.taskViewModel.attachmentTagItems, function (tag) {
      if (tag.id === attachment.id) {
        return true;
      }
    });
    return false;
  };
  $scope.canDisplayAttachmentSection = function (attachment) {
    return $scope.taskViewModel.attachmentTagItems.length !== 0 || !($scope.taskViewModel.attachmentTagItems.length === 0 && !$scope.canAddAttachment());
  };
  $scope.onAttachmentItemClick = function (event, attachment) {
    var targetAttachment;
    _.each($scope.taskViewModel.attachmentTagItems, function (tag) {
      if (tag.id === attachment.id) {
        targetAttachment = tag;
      }
    });
    if (attachment.checked) {
      $scope.taskViewModel.attachmentTagItems.push(attachment);
      collaborationMediator.updateCollaborationTaskAttachment($scope.taskViewModel.task.id, attachment).then(function () {
        $scope.handleUpdateTask();
      });
    } else {
      if ($scope.canDeleteAttachment()) {
        _.pull($scope.taskViewModel.attachmentTagItems, targetAttachment);
        collaborationMediator.deleteCollaborationTaskAttachment($scope.taskViewModel.task.id, attachment.id).then(function () {
          $scope.handleUpdateTask();
        });
      } else {
        attachment.checked = true;
      }
    }
  };
  $scope.onDeleteAttachment = function (tag) {
    _.each($scope.taskViewModel.submissionAttachments, function (attachment) {
      if (tag.id === attachment.id) {
        attachment.checked = false;
      }
    });
    collaborationMediator.deleteCollaborationTaskAttachment($scope.taskViewModel.task.id, tag.id).then(function () {
      $scope.handleUpdateTask();
    });
  };
  $scope.onUploadNewFileBlur = function () {
    handleDocumentInteraction();
  };
  function handleDocumentInteraction() {
    $timeout(function () {
      if ($scope.canCloseAttachmentList) {
        if ($scope.canDisplayList) {
          $scope.taskViewModel.showAttachmentList = !$scope.taskViewModel.showAttachmentList;
        } else {
          $scope.taskViewModel.showAttachmentList = false;
          removeListeners();
        }
        $scope.canDisplayList = false;
      }
      $scope.canCloseAttachmentList = true;
    }, 0);
  }
  function addListeners() {
    $document.on('click', handleDocumentInteraction);
  }
  function removeListeners() {
    $document.off('click', handleDocumentInteraction);
  }
  resetTaskViewModel();
};
CollaborationTaskController.$inject = ["$rootScope", "$scope", "$stateParams", "$uibModal", "$document", "$window", "$filter", "$timeout", "coreConstant", "coreMediator", "userRepository", "collaborationMediator", "modalUtil", "localization", "authorizationConstants", "submissionTaskStatus", "submissionConstant", "attachmentUtil", "attachmentMediator", "currentUserModel"];
angular.module('gw-um-submission').controller('collaborationTaskController', CollaborationTaskController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/collaboration/task/collaborationTaskEditor.tpl.html';
var html = "<form name=\"taskForm\">\n\n    <div class=\"taskItem taskSummary\"\n         ng-class=\"{summaryOtherOpen: taskEditorViewModel.definition.value === 'Other'}\">\n        <div class=\"editTaskItem\">\n            <ui-required-indicator class=\"requiredIndicator\"\n                                   value=\"{{taskEditorViewModel.task.definition}}\">\n            </ui-required-indicator>\n            <span class=\"glyphicon taskSummaryIcon\">\n                <img class=\"icon-image icon-collaborationTypeTasks\"\n                     src=\"" + __webpack_require__(36) + "\"/>\n            </span>\n            <ui-select class=\"taskSelect collaborationTaskSelect taskSummary\"\n                       ng-model=\"taskEditorViewModel.definition\"\n                       ng-change=\"handleSummaryChange()\"\n                       theme=\"select2\"\n                       append-to-body=\"true\"\n                       placeholder=\"{{ ::taskViewModel.placeholderSummary }}\"\n                       close-on-select=\"true\"\n                       required\n                       ui-hide-select-on-scroll\n                       ui-hide-select-on-scroll-selector=\".taskContent\">\n\n                <ui-select-match placeholder=\"{{ ::taskViewModel.placeholderSummary }}\" allow-clear=\"false\">\n                    <span ng-bind=\"$select.selected.value\"></span>\n                </ui-select-match>\n\n                <ui-select-choices repeat=\"item in (taskViewModel.summaryOptions | filter: {name: $select.search})\">\n                    <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n    <div class=\"taskItem taskSummaryOther\"\n         ng-if=\"taskEditorViewModel.definition.value === 'Other'\">\n        <div class=\"editTaskItem\">\n            <span class=\"glyphicon indentGlyphicon\"></span>\n            <input type=\"text\"\n                   ng-model=\"taskEditorViewModel.otherSummary\"\n                   ng-blur=\"handleSummaryDescriptionChange()\"\n                   placeholder=\"{{taskViewModel.placeholderDescription}}\"\n                   required/>\n        </div>\n    </div>\n\n    <div class=\"taskItem taskDetails\">\n        <div class=\"labelTaskItem\">\n            <span class=\"glyphicon glyphicon-pencil indentGlyphicon\"></span>\n            <textarea ng-model=\"taskEditorViewModel.task.details\"\n                      ng-blur=\"handleDetailsChange()\"\n                      ng-attr-placeholder=\"{{::taskViewModel.placeholderTaskDetails}}\"></textarea>\n        </div>\n    </div>\n\n    <div class=\"taskItem taskAssignTo\">\n        <div class=\"editTaskItem\" ng-if=\"!isAgent()\">\n            <ui-required-indicator class=\"requiredIndicator\"\n                                   value=\"{{taskEditorViewModel.assignedToUser}}\">\n            </ui-required-indicator>\n            <span class=\"glyphicon glyphicon-user\"></span>\n            <ui-select class=\"taskSelect collaborationTaskSelect taskAssignTo\"\n                       ng-model=\"taskEditorViewModel.assignedToUser\"\n                       ng-change=\"handleAssignToChange()\"\n                       theme=\"select2\"\n                       append-to-body=\"true\"\n                       placeholder=\"{{ ::taskViewModel.placeholderAssignTo }}\"\n                       close-on-select=\"true\"\n                       required\n                       ui-hide-select-on-scroll\n                       ui-hide-select-on-scroll-selector=\".taskContent\">\n\n                <ui-select-match placeholder=\"{{ ::taskViewModel.placeholderAssignTo }}\"\n                                 allow-clear=\"false\">\n                    <span class=\"assignedLabel\">{{ taskI18n.assignedTo }}</span>\n                    <ui-user-avatar class=\"assignedAvatar\"\n                                    ng-if=\"$select.selected.group !== 'User Groups'\"\n                                    userid={{$select.selected.id}}></ui-user-avatar>\n                    <ui-user-avatar class=\"assignedAvatar\"\n                                    ng-if=\"$select.selected.group === 'User Groups'\"\n                                    userid={{$select.selected.id}}\n                                    is-group=true></ui-user-avatar>\n                    <span ng-bind=\"$select.selected.name\"></span>\n                    <span ng-if=\"$select.selected.roles\"> ({{ $select.selected.roles }})</span>\n                </ui-select-match>\n\n                <ui-select-choices group-by=\"'group'\"\n                                   refresh=\"filterItems($select.search)\"\n                                   refresh-delay=\"250\"\n                                   repeat=\"item in taskViewModel.filteredItemsList track by $index\"\n                                   ui-disable-choice=\"item.disabled === true\">\n                    <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                    <span ng-if=\"item.roles\"> ({{ item.roles }})</span>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n        <div class=\"labelTaskItem\" ng-if=\"isAgent()\">\n            <span class=\"glyphicon glyphicon-user indentGlyphicon\"></span>\n            <span class=\"assignedLabel\">{{ taskI18n.assignedTo }}</span>\n            <ui-user-avatar class=\"assignedAvatar\"\n                            ng-if=\"taskEditorViewModel.task.assignedToId\"\n                            userid={{taskEditorViewModel.task.assignedToId}}></ui-user-avatar>\n            <ui-user-avatar class=\"assignedAvatar\"\n                            ng-if=\"taskEditorViewModel.task.assignedToGroupId\"\n                            userid={{taskEditorViewModel.task.assignedToId}} is-group=true></ui-user-avatar>\n            {{ taskEditorViewModel.task.assignedToFullName }}\n        </div>\n    </div>\n    <div class=\"taskItem taskReceivedDate\" ng-if=\"viewModel.isTaskReceivedDateEnabled\">\n        <div class=\"editTaskItem\">\n            <i class=\"fa fa-calendar-check-o indentFa\"  aria-hidden=\"true\"></i>\n            <span class=\"receivedDateLabel\">{{ taskI18n.received }}</span>\n            <ui-task-calendar class=\"uiTaskCalendar\"\n                              ng-model=\"taskEditorViewModel.task.receivedDate\"\n                              on-change=\"handleReceivedDateChange($value)\"\n                              placeholder-text=\"taskViewModel.placeholderReceivedDate\"\n                              min-date=\"taskViewModel.receivedDateMin\"\n                              is-time-enabled=\"true\"></ui-task-calendar>\n        </div>\n    </div>\n    <div class=\"taskItem taskDueDate\">\n        <div class=\"editTaskItem\">\n            <span class=\"glyphicon glyphicon-time indentGlyphicon\"></span>\n            <span class=\"dueDateLabel\">{{ taskI18n.due }}</span>\n            <ui-task-calendar class=\"uiTaskCalendar\"\n                              ng-model=\"taskEditorViewModel.task.dueDate\"\n                              on-change=\"handleDueDateChange($value)\"\n                              placeholder-text=\"taskViewModel.placeholderSetDueDate\"\n                              is-time-enabled=\"true\"></ui-task-calendar>\n        </div>\n    </div>\n    <div class=\"taskItem taskPriority\">\n        <div class=\"editTaskItem\">\n            <span class=\"glyphicon indentGlyphicon\"\n                  ng-class=\"{'glyphicon-sort': !taskEditorViewModel.task.priority,\n                            'glyphicon-arrow-up': taskEditorViewModel.task.priority === 3,\n                            'glyphicon-minus': taskEditorViewModel.task.priority === 2,\n                            'glyphicon-arrow-down': taskEditorViewModel.task.priority === 1}\"></span>\n            <ui-select class=\"taskSelect collaborationTaskSelect\"\n                       ng-model=\"taskEditorViewModel.priority\"\n                       ng-change=\"handlePriorityChange()\"\n                       theme=\"select2\"\n                       append-to-body=\"true\"\n                       placeholder=\"{{ ::taskViewModel.placeholderPriority }}\"\n                       close-on-select=\"true\"\n                       ui-hide-select-on-scroll\n                       ui-hide-select-on-scroll-selector=\".taskContent\">\n\n                <ui-select-match placeholder=\"{{ ::taskViewModel.placeholderPriority }}\" allow-clear=\"false\">\n                    <span ng-bind=\"$select.selected.name\"></span>\n                </ui-select-match>\n\n                <ui-select-choices repeat=\"item in (taskViewModel.priorityOptions | filter: {name: $select.search})\">\n                    <span class=\"glyphicon taskPriorityIcon\"\n                          ng-class=\"{'glyphicon-arrow-up': item.value === 3,\n                                    'glyphicon-minus': item.value === 2,\n                                    'glyphicon-arrow-down': item.value === 1}\"></span>\n                    <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n    <div class=\"taskNextAction taskItem\"\n         ng-if=\"!isAgent()\">\n        <div class=\"editTaskItem\">\n            <span class=\"glyphicon glyphicon-home indentGlyphicon\"></span>\n            <span class=\"taskInputLabel\"\n                  ng-click=\"handleNextTaskClick()\"\n                  ng-class=\"{ selected: taskEditorViewModel.task.nextTask }\">{{ taskI18n.nextAction }}</span>\n            <input type=\"checkbox\"\n                   ng-model=\"taskEditorViewModel.task.nextTask\"/>\n        </div>\n    </div>\n\n    <div class=\"taskAttachFile taskItem\"\n         ng-if=\"canAddAttachment()\">\n        <div class=\"editTaskItem\">\n            <span class=\"glyphicon glyphicon-paperclip indentGlyphicon\"></span>\n            <span class=\"taskInputLabel\"\n                  ng-click=\"openAttachmentList($event)\"\n                  ng-class=\"{ selected: taskEditorViewModel.task.nextTask }\"\n                  ng-if=\"taskEditorViewModel.attachmentTagItems.length === 0\"\n                  ui-translate>submission.collaboration.task.attachFile</span>\n\n            <div class=\"tagLayout\"\n                 ng-if=\"taskEditorViewModel.attachmentTagItems.length > 0\">\n                <div class=\"tagContainer\"\n                     ng-repeat=\"attachmentTag in taskEditorViewModel.attachmentTagItems track by $index\"\n                     row-id=\"{{$index}}\">\n                    <div class=\"attachmentTag\"\n                         uib-tooltip=\"{{ attachmentTag.name }}\"\n                         tooltip-append-to-body=\"true\"\n                         tooltip-popup-delay=\"500\">\n                        <span class=\"glyphicon glyphicon-file btn-sm\"></span>\n                        <span class=\"tagLabel\">{{ attachmentTag.name }} ({{attachmentTag.byteCountToDisplaySize}})</span>\n                        <button class=\"close\"\n                                ng-click=\"onDeleteTag(attachmentTag)\">\n                            <span class=\"glyphicon glyphicon-remove btn-sm\"></span>\n                        </button>\n                    </div>\n                </div>\n                <span class=\"addFile\"\n                      ng-click=\"openAttachmentList($event)\"\n                      ng-if=\"taskEditorViewModel.attachmentTagItems.length > 0\"\n                      ui-translate>submission.collaboration.task.addFile</span>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"taskItem\"\n         ng-if=\"taskEditorViewModel.showAttachmentList\"\n         ng-click=\"onAttachmentListClick($event)\">\n        <div class=\"attachmentList\">\n            <label class=\"heading\" ui-translate>submission.collaboration.task.chooseFromExistingFiles</label>\n            <div class=\"attachmentListBox\">\n                <div class=\"multiSelectItem\"\n                     ng-mouseleave=\"removeFocusStyle( tabIndex );\"\n                     ng-repeat=\"attachment in taskEditorViewModel.attachmentSummaries track by $index\"\n                     row-id=\"{{$index}}\">\n                    <div class=\"attachmentItem\">\n                        <label ng-click=\"$event.stopPropagation()\">\n                            <input class=\"checkbox focusable\"\n                                   type=\"checkbox\"\n                                   ng-change=\"onAttachmentItemClick($event, attachment)\"\n                                   ng-checked=\"attachment.checked\"\n                                   ng-model=\"attachment.checked\">\n                            <span class=\"taskAttachmentName\">{{attachment.name}} ({{attachment.byteCountToDisplaySize}})</span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <button class=\"btn btn-primary newFileButton\"\n                    ng-click=\"handleAttachmentClick()\"\n                    ng-blur=\"onUploadNewFileBlur()\"\n                    ui-translate>submission.collaboration.task.uploadNewFile\n            </button>\n        </div>\n    </div>\n\n    <div class=\"taskRemindMeDate taskItem\">\n        <div class=\"editTaskItem\">\n            <span class=\"glyphicon glyphicon-time indentGlyphicon\"></span>\n            <span class=\"reminderDateLabel\">{{ taskI18n.reminder }}</span>\n            <ui-task-calendar class=\"uiTaskCalendar\"\n                              ng-model=\"taskEditorViewModel.task.reminderDueDate\"\n                              placeholder-text=\"taskViewModel.placeholderRemindMe\"\n                              on-change=\"handleReminderDateChange($value)\"\n                              max-date=\"taskEditorViewModel.task.dueDate\"\n                              is-time-enabled=\"true\"></ui-task-calendar>\n        </div>\n    </div>\n    <div class=\"taskReminderEmail taskItem\"\n         ng-if=\"taskEditorViewModel.task.reminderDueDate\">\n        <div class=\"editTaskItem\">\n            <span class=\"glyphicon glyphicon-envelope indentGlyphicon\"></span>\n            <span class=\"taskInputLabel\"\n                  ng-click=\"handleReminderEmailClick()\"\n                  ng-class=\"{ selected: taskEditorViewModel.task.notifyWhenPastDue }\">\n                {{ taskI18n.reminderEmail }}\n            </span>\n            <input type=\"checkbox\"\n                   class=\"taskEmailReminderCheckbox\"\n                   ng-model=\"taskEditorViewModel.task.notifyWhenPastDue\"/>\n        </div>\n    </div>\n    <div class=\"taskNotes taskItem\">\n        <div class=\"editTaskItem\">\n            <span class=\"glyphicon glyphicon-pencil indentGlyphicon\"></span>\n            <textarea ng-model=\"taskEditorViewModel.task.comments\"\n                      ui-max-chars=\"8192\"\n                      ng-attr-placeholder=\"{{taskViewModel.placeholderNotes}}\"></textarea>\n        </div>\n    </div>\n\n    <div class=\"taskFooter\">\n\n        <div class=\"dockPanelInnerContent taskFooterButtons\">\n            <button class=\"btn btn-primary componentTaskAssign\"\n                    ng-if=\"viewModel.task.isEditorOpen\"\n                    ng-click=\"handleAssignTask()\"\n                    ng-disabled=\"taskForm.$invalid\">{{ taskI18n.assignTask }}\n            </button>\n            <button class=\"btn btn-footer componentTaskCancel\"\n                    ng-click=\"hideTasksSubPage()\">{{ taskI18n.cancel }}\n            </button>\n        </div>\n\n    </div>\n\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {var locale = __webpack_require__(88);

/*@ngInject*/
var CollaborationTaskEditorController = function CollaborationTaskEditorController($scope, $rootScope, $uibModal, $stateParams, $document, $window, $timeout, currentUserModel, modalUtil, attachmentMediator, submissionTaskStatus, collaborationMediator, attachmentUtil, loadingBarHandler, authorizationConstants) {
  $scope.taskI18n = locale;
  function resetTaskViewModel() {
    var currentUser = $scope.getCurrentUser(),
      permissions = [],
      neededPermissions = [authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS, authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS];
    $scope.taskEditorViewModel = {
      task: {
        id: null,
        definition: null,
        assignedToId: null,
        assignedToFullName: '',
        assignedById: null,
        assignedByFullName: '',
        nextTask: false,
        priority: null,
        dueDate: null,
        reminderDueDate: null,
        receivedDate: moment(),
        notifyWhenPastDue: false,
        comments: null,
        status: null,
        shared: false,
        attachmentSummaries: null
      },
      originalValues: {},
      assignedToUser: null,
      assignedByUser: null,
      definition: null,
      priority: null,
      details: null,
      otherSummary: null,
      attachmentTagItems: [],
      showAttachmentList: false
    };
    $scope.taskEditorViewModel.isAgent = currentUser.userType === 'Agent';
    $scope.taskEditorViewModel.task.assignedById = currentUser.userId;
    $scope.taskEditorViewModel.task.assignedByFullName = currentUser.firstName + ' ' + currentUser.lastName;
    $scope.canDisplayList = false;
    $scope.canCloseAttachmentList = true;
    if ($scope.taskEditorViewModel.isAgent) {
      $scope.taskEditorViewModel.task.assignedToId = currentUser.userId;
      $scope.taskEditorViewModel.task.assignedToFullName = currentUser.firstName + ' ' + currentUser.lastName;
      $scope.taskEditorViewModel.task.shared = true;
    }
    _.each(neededPermissions, function (neededPermission) {
      if (currentUserModel.hasAuthorization(neededPermission)) {
        permissions.push(neededPermission);
      }
    });
    $scope.taskEditorViewModel.permissions = permissions;
  }
  $scope.canAddAttachment = function () {
    return _.includes($scope.taskEditorViewModel.permissions, authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS);
  };
  $scope.canDeleteAttachment = function () {
    return _.includes($scope.taskEditorViewModel.permissions, authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS);
  };
  function setAssignedTo(result) {
    if (_.isEmpty(result)) {
      return;
    }
    $scope.taskEditorViewModel.assignedToUser = result;
    $scope.taskEditorViewModel.task.assignedToFullName = result.name;
    $scope.taskEditorViewModel.task.assignedToId = result.id;
  }
  function setAssignedBy(result) {
    if (_.isEmpty(result)) {
      return;
    }
    $scope.taskEditorViewModel.assignedByUser = result;
    $scope.taskEditorViewModel.task.assignedByFullName = result.name;
    $scope.taskEditorViewModel.task.assignedById = result.id;
  }
  $scope.handleVisibleToAgentToggle = function () {
    $scope.taskEditorViewModel.task.shared = !$scope.taskEditorViewModel.task.shared;
  };
  $scope.handleSummaryChange = function () {
    if ($scope.taskEditorViewModel.definition.value !== 'Other') {
      $scope.taskEditorViewModel.task.definition = $scope.taskEditorViewModel.definition.value;
    } else {
      $scope.taskEditorViewModel.task.definition = null;
    }
    $scope.taskEditorViewModel.otherSummary = null;
  };
  $scope.handleSummaryDescriptionChange = function () {
    if ($scope.taskEditorViewModel.definition.value === 'Other' && $scope.taskEditorViewModel.otherSummary) {
      $scope.taskEditorViewModel.task.definition = 'Other::' + $scope.taskEditorViewModel.otherSummary;
    } else {
      $scope.taskEditorViewModel.task.definition = null;
    }
  };
  $scope.handleDetailsChange = function () {
    var taskDetails = _.get($scope.taskEditorViewModel, 'task.details'),
      originalTaskDetails = _.get($scope.taskEditorViewModel, 'originalValues.details');
    if (taskDetails !== originalTaskDetails) {
      $scope.taskEditorViewModel.originalValues.details = taskDetails;
    }
  };
  $scope.handlePriorityChange = function () {
    $scope.taskEditorViewModel.task.priority = $scope.taskEditorViewModel.priority.value;
  };
  $scope.handleDueDateChange = function (selectedDate) {
    var dueDate = selectedDate ? moment(new Date(selectedDate)).startOf('minute').unix() * 1000 : null;
    eightAM = selectedDate ? moment(selectedDate).startOf('day').add(8, 'hours') : null;
    $scope.taskEditorViewModel.task.dueDate = dueDate;
    $scope.taskEditorViewModel.task.reminderDueDate = eightAM ? moment(eightAM).unix() * 1000 : 0;
  };
  $scope.handleReminderDateChange = function (selectedDate) {
    var reminderDate = selectedDate ? moment(new Date(selectedDate)).startOf('minute').unix() * 1000 : null;
    $scope.taskEditorViewModel.task.reminderDueDate = reminderDate;
  };
  $scope.handleReceivedDateChange = function (selectedDate) {
    var receivedDate = selectedDate ? moment(new Date(selectedDate)).startOf('minute').unix() * 1000 : null;
    $scope.taskEditorViewModel.task.receivedDate = receivedDate;
  };
  $scope.handleReminderEmailClick = function () {
    $scope.taskEditorViewModel.task.notifyWhenPastDue = !$scope.taskEditorViewModel.task.notifyWhenPastDue;
  };
  $scope.handleNextTaskClick = function () {
    $scope.taskEditorViewModel.task.nextTask = !$scope.taskEditorViewModel.task.nextTask;
  };
  $scope.handleAssignToChange = function () {
    if ($scope.taskEditorViewModel.assignedToUser) {
      if ($scope.taskEditorViewModel.assignedToUser.group === 'User Groups') {
        $scope.taskEditorViewModel.task.assignedToId = null;
        $scope.taskEditorViewModel.task.assignedToFullName = null;
        $scope.taskEditorViewModel.task.assignedToGroupId = $scope.taskEditorViewModel.assignedToUser.id;
        $scope.taskEditorViewModel.task.assignedToGroupName = $scope.taskEditorViewModel.assignedToUser.name;
      } else {
        $scope.taskEditorViewModel.task.assignedToId = $scope.taskEditorViewModel.assignedToUser.id;
        $scope.taskEditorViewModel.task.assignedToFullName = $scope.taskEditorViewModel.assignedToUser.name;
        $scope.taskEditorViewModel.task.assignedToGroupId = null;
        $scope.taskEditorViewModel.task.assignedToGroupName = null;
      }
    } else {
      $scope.taskEditorViewModel.task.assignedToId = null;
      $scope.taskEditorViewModel.task.assignedToFullName = null;
      $scope.taskEditorViewModel.task.assignedToGroupId = null;
      $scope.taskEditorViewModel.task.assignedToGroupName = null;
    }
    if (!$scope.taskEditorViewModel.assignedToUser.roles) {
      $scope.getUserRoles($scope.taskEditorViewModel.assignedToUser);
    }
  };
  $scope.handleAssignTask = function () {
    var task = {
      definition: $scope.taskEditorViewModel.task.definition,
      assignedToId: $scope.taskEditorViewModel.task.assignedToId,
      assignedToGroupId: $scope.taskEditorViewModel.task.assignedToGroupId,
      assignedById: $scope.taskEditorViewModel.task.assignedById,
      dueDate: $scope.taskEditorViewModel.task.dueDate,
      reminderDueDate: $scope.taskEditorViewModel.task.reminderDueDate,
      notifyWhenPastDue: $scope.taskEditorViewModel.task.notifyWhenPastDue,
      receivedDate: $scope.taskEditorViewModel.task.receivedDate,
      nextTask: $scope.taskEditorViewModel.task.nextTask,
      priority: $scope.taskEditorViewModel.task.priority,
      comments: $scope.taskEditorViewModel.task.comments,
      shared: $scope.taskEditorViewModel.task.shared,
      status: submissionTaskStatus.ASSIGNED,
      attachments: $scope.taskEditorViewModel.attachmentTagItems,
      details: $scope.taskEditorViewModel.task.details
    };
    $scope.createTask(task);
    $scope.hideTasksSubPage();
  };
  $scope.onAttachmentListClick = function (event) {
    $scope.canCloseAttachmentList = false;
  };
  $scope.openAttachmentList = function (event) {
    if ($scope.taskEditorViewModel.attachmentSummaries.length > 0) {
      $scope.canDisplayList = !$scope.canDisplayList;
      addListeners();
    } else {
      $scope.handleAttachmentClick();
    }
  };
  $scope.handleAttachmentClick = function () {
    var instance = $uibModal.open({
      templateUrl: '/collaboration/task/newTaskAttachmentModal/newTaskAttachmentModal.tpl.html',
      controller: 'newTaskAttachmentModalController',
      backdrop: 'static',
      windowClass: 'newTaskAttachmentModal',
      resolve: {
        options: function options() {
          return {};
        },
        isUnderwriterUser: !$scope.taskEditorViewModel.isAgent
      }
    });
    instance.result.then(function (data) {
      var payload = attachmentUtil.getAttachmentPayload(data.attachment);
      payload = _.assign(payload, {
        'ownerUri': 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId,
        'submissionId': $stateParams.submissionId
      });
      attachmentMediator.saveAttachment(payload, data.file).then(function (payload) {
        payload.attachment.checked = true;
        $scope.taskEditorViewModel.attachmentSummaries.push(payload.attachment);
        $scope.taskEditorViewModel.attachmentTagItems.push(payload.attachment);
      }.bind(this));
    });
  };
  $scope.onAttachmentItemClick = function (event, attachment) {
    if (attachment.checked) {
      $scope.taskEditorViewModel.attachmentTagItems.push(attachment);
    } else {
      _.pull($scope.taskEditorViewModel.attachmentTagItems, attachment);
    }
  };
  $scope.onDeleteTag = function (attachmentTag) {
    _.each($scope.taskEditorViewModel.attachmentSummaries, function (attachment) {
      if (attachmentTag.id === attachment.id) {
        attachment.checked = false;
      }
    });
    _.remove($scope.taskEditorViewModel.attachmentTagItems, function (attm) {
      return attachmentTag.id === attm.id;
    });
  };
  $scope.onUploadNewFileBlur = function () {
    handleDocumentInteraction();
  };
  function handleDocumentInteraction() {
    $timeout(function () {
      if ($scope.canCloseAttachmentList) {
        if ($scope.canDisplayList) {
          $scope.taskEditorViewModel.showAttachmentList = !$scope.taskEditorViewModel.showAttachmentList;
        } else {
          $scope.taskEditorViewModel.showAttachmentList = false;
          removeListeners();
        }
        $scope.canDisplayList = false;
      }
      $scope.canCloseAttachmentList = true;
    }, 0);
  }
  function addListeners() {
    $document.on('click', handleDocumentInteraction);
  }
  function removeListeners() {
    $document.off('click', handleDocumentInteraction);
  }
  function loadSubmissionAttachmentList() {
    if ($scope.isAgent()) {
      collaborationMediator.loadSharedSubmissionAttachments($stateParams.submissionId).then(function (submissionAttachmentList) {
        $scope.taskEditorViewModel.attachmentSummaries = submissionAttachmentList;
      });
    } else {
      collaborationMediator.loadSubmissionAttachments($stateParams.submissionId).then(function (submissionAttachmentList) {
        $scope.taskEditorViewModel.attachmentSummaries = submissionAttachmentList;
      });
    }
  }
  loadSubmissionAttachmentList();
  resetTaskViewModel();
};
CollaborationTaskEditorController.$inject = ["$scope", "$rootScope", "$uibModal", "$stateParams", "$document", "$window", "$timeout", "currentUserModel", "modalUtil", "attachmentMediator", "submissionTaskStatus", "collaborationMediator", "attachmentUtil", "loadingBarHandler", "authorizationConstants"];
angular.module('gw-um-submission').controller('collaborationTaskEditorController', CollaborationTaskEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/collaboration/collaboration.tpl.html';
var html = "<div class=\"dockPanelContainer collaborationContainer\"\n     ui-focus-manager=\"collaborationContainer\"\n     ng-class=\"{'page-transition-in-note':(viewModel.note.isVisible), 'page-transition-in-email':(viewModel.email.isVisible), 'page-transition-in-attachment':(viewModel.attachment.isVisible), 'page-transition-in-task':(viewModel.task.isVisible)}\">\n\n    <section class=\"dockPanelSection collaborationPage\">\n\n        <!--Top Panel-->\n        <div class=\"dockPanelHeader\">\n            <div class=\"title\">\n                <span>{{ ::viewModel.title }}</span>\n            </div>\n\n            <div class=\"printButtonContainer\">\n                <a class=\"printButton\"\n                   ng-click=\"onPrintCollab()\">\n                    <span class=\"glyphicon glyphicon-print\"></span>\n                </a>\n            </div>\n\n            <div class=\"refreshAttachmentButtonContainer\" ng-if=\"viewModel.isRefreshCollaborationAttachmentsEnabled\">\n                <a class=\"refreshAttachmentButton\"\n                   ng-click=\"onRefreshCollabAttachments()\"\n                   uib-tooltip=\"{{ ::i18n.refreshAttachmentsTooltip }}\"\n                   tooltip-popup-delay=\"500\"\n                   tooltip-append-to-body=\"true\"\n                   tooltip-placement=\"auto left\">\n                    <span class=\"glyphicon glyphicon-refresh\"></span>\n                </a>\n            </div>\n\n            <div class=\"actionButtonList\" ng-if=\"viewModel.showGearIcon\">\n\n                <div uib-dropdown\n                     dropdown-append-to-body=\"true\">\n\n                    <a class=\"btn-xs dockPanelGearButton\"\n                       uib-dropdown-toggle\n                       uib-tooltip=\"{{ ::i18n.hideAllSharedTooltip }}\"\n                       tooltip-popup-delay=\"500\"\n                       tooltip-append-to-body=\"true\"\n                       tooltip-placement=\"auto left\">\n                        <span class=\"glyphicon glyphicon-cog\"></span>\n                    </a>\n\n                    <ul class=\"dropdown-menu-right\"\n                        uib-dropdown-menu>\n                        <!--Hide Icon-->\n                        <li role=\"menuitem\">\n                            <a uib-dropdown\n                               class=\"btn-xs\"\n                               target=\"_blank\"\n                               ng-click=\"hideAllSharedItem()\">\n                               <span>{{ ::i18n.hideAllShared }}</span>\n                            </a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n\n            <a class=\"dockPanelHeaderButton collaborationHeaderButton dockPanelHeaderCloseButton\"\n               ng-click=\"onToggleCollaboration()\">\n                <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\n            </a>\n        </div>\n\n        <!--Icons Panel-->\n        <div class=\"dockPanelIconsHeader collaborationHeader\">\n\n            <a class=\"dockPanelIconsHeaderButton\"\n               ng-click=\"onCollaborationFilterClick('all')\"\n               ng-class=\"{'active': viewModel.filterType === 'all'}\">\n                <img class=\"svgicon icon-collaboration_all\"\n                     src=\"" + __webpack_require__(284) + "\" />\n                <label>{{ ::i18n.filter.all }}</label>\n            </a>\n\n            <a class=\"dockPanelIconsHeaderButton\"\n               ng-click=\"openChat()\"\n               ng-class=\"{'active': viewModel.filterType === 'chat'}\">\n                <img class=\"svgicon icon-collaboration_chat\"\n                     src=\"" + __webpack_require__(285) + "\" />\n                <label>{{ ::i18n.filter.chat }}</label>\n            </a>\n\n            <a class=\"dockPanelIconsHeaderButton\"\n               ng-click=\"onCollaborationFilterClick('email')\"\n               ng-if=\"showEmail('email')\"\n               ng-class=\"{'active': viewModel.filterType === 'email'}\">\n                <img class=\"svgicon icon-collaboration_email\"\n                     src=\"" + __webpack_require__(286) + "\" />\n                <label>{{ ::i18n.filter.email }}</label>\n            </a>\n\n            <a class=\"dockPanelIconsHeaderButton\"\n               ng-click=\"onCollaborationFilterClick('attachment')\"\n               ng-class=\"{'active': viewModel.filterType === 'attachment'}\">\n                <img class=\"svgicon icon-collaboration_files\"\n                     src=\"" + __webpack_require__(287) + "\" />\n                <label>{{ ::i18n.filter.attachment }}</label>\n            </a>\n\n            <a class=\"dockPanelIconsHeaderButton\"\n               ng-click=\"onCollaborationFilterClick('task')\"\n               ng-class=\"{'active': viewModel.filterType === 'task'}\">\n                <img class=\"svgicon icon-collaboration_tasks\"\n                     src=\"" + __webpack_require__(288) + "\" />\n                <label>{{ ::i18n.filter.task }}</label>\n            </a>\n\n            <a class=\"dockPanelIconsHeaderButton\"\n               ng-click=\"onCollaborationFilterClick('note')\"\n               ng-class=\"{'active': viewModel.filterType === 'note'}\">\n                <img class=\"svgicon icon-collaboration_notes\"\n                     src=\"" + __webpack_require__(289) + "\" />\n                <label>{{ ::i18n.filter.note }}</label>\n            </a>\n\n        </div>\n\n\n        <!--Collaboration Content-->\n        <div class=\"dockPanelContent collaborationContent\"\n             ng-if=\"viewModel.filterType !== 'chat'\">\n\n            <div class=\"searchRow\">\n\n                <div class=\"dockPanelSearchForm\">\n                    <img class=\"svgicon icon-collaboration_search\"\n                         src=\"" + __webpack_require__(81) + "\"/>\n                    <input type=\"search\"\n                           ng-model=\"viewModel.searchInput\"\n                           ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                           class=\"searchInput form-control allCollaborationSearch\"\n                           ng-change=\"onSearchInputChange()\"\n                           placeholder=\"{{ getSearchPlaceholder() }}\"/>\n\n                    <span ng-if=\"viewModel.searchInput != ''\"\n                          ng-click=\"onClearSearchInput()\"\n                          class=\"glyphicon glyphicon-remove form-control-feedback\"></span>\n                </div>\n\n                 <div class=\"filterTab\" ng-if = \"viewModel.filterType !== 'task'\">\n                     <div class =\"filterBox\"\n                          uib-tooltip=\"{{ viewModel.isFilterOn === true ? i18n.filter.icon.changeFilterByType : i18n.filter.icon.filterByType}}\"\n                          tooltip-append-to-body=\"true\">\n                         <i class=\"fa fa-filter filterIcon\"\n                            ng-class=\"{'filterRecordSelected':viewModel.isFilterOn===true}\"\n                            >\n                         </i>\n                         <ui-multi-select items-list=\"viewModel.filterList\"\n                                          class=\"multiSelectDropdown\"\n                                          item-name=\"viewModel.filterListItemName\"\n                                          append-to-body=\"true\"\n                                          selected-value=\"viewModel.initialSelectedFilter\">\n                         </ui-multi-select>\n                     </div>\n                 </div>\n                    <ul class=\"collaborationTabs\" ng-switch on=\"viewModel.filterType\">\n                        <li ng-switch-when=\"note\" class=\"create\" ng-if=\"::canCreateNote()\">\n                            <a ng-click=\"openCreateNoteEditor()\">{{ ::i18n.create }}</a>\n                        </li>\n\n                        <li ng-switch-when=\"attachment\"\n                            class=\"create\"\n                            ng-if=\"::canUserCreateAttachment()\">\n                            <a ng-click=\"openAttachmentEditor()\">{{ ::i18n.create }}</a>\n                        </li>\n\n                        <li ng-switch-when=\"attachment\"\n                            class=\"create\"\n                            ng-if=\"canCreateAttachmentFromTemplate()\"\n                            uib-dropdown>\n\n                            <a uib-dropdown-toggle>\n                                <span class=\"createNewCollaborationItem\">{{ ::i18n.create }}</span>\n                                <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                            </a>\n\n                            <ul class=\"dropdown-menu-right\" uib-dropdown-menu>\n                                <li>\n                                    <a ng-click=\"openAttachmentEditor()\" class=\"createAttachment\">\n                                        {{ ::i18n.createItem.attachment }}\n                                    </a>\n                                </li>\n                                <li>\n                                    <a ng-click=\"openAttachmentFromTemplate()\" class=\"createAttachmentFromTemplate\">\n                                        {{ ::i18n.createItem.attachmentFromTemplate }}\n                                    </a>\n                                </li>\n                            </ul>\n                        </li>\n\n                        <li ng-switch-when=\"chat\" class=\"create\" ng-if=\"::canCreateChat()\">\n                            <a ng-click=\"openChat()\">{{ ::i18n.create }}<span></span></a>\n                        </li>\n\n                        <li ng-switch-when=\"email\" class=\"create\" ng-if=\"showEmail('email') && canCreateEmail() && !viewModel.enableEmailFromTemplate\">\n                            <a ng-click=\"createGenericCorrespondenceEmail()\">{{ ::i18n.create }}<span></span></a>\n                        </li>\n\n                        <li ng-switch-when=\"email\" class=\"create\" ng-if=\"showEmail('email') && canCreateEmail() && viewModel.enableEmailFromTemplate\"\n                            uib-dropdown>\n\n                            <a uib-dropdown-toggle><span class=\"createNewCollaborationItem\">{{ ::i18n.create }}</span>\n                                <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                            </a>\n\n                            <ul class=\"dropdown-menu-right\" uib-dropdown-menu>\n                                <li>\n                                    <a ng-click=\"createGenericCorrespondenceEmail()\" class=\"createEmail\">{{ ::i18n.createItem.email }}</a>\n                                </li>\n                                <li>\n                                    <a ng-click=\"createEmail()\" class=\"createEmailFromTemplate\">{{ ::i18n.createItem.emailFromTemplate }}</a>\n                                </li>\n                            </ul>\n                        </li>\n                        <li ng-switch-when=\"task\" class=\"create\" ng-if=\"::canAssignTask()\">\n                            <a ng-click=\"openTaskEditor()\">{{ ::i18n.create }}<span></span></a>\n                        </li>\n\n                        <li ng-switch-when=\"all\"\n                            class=\"create\"\n                            uib-dropdown>\n\n                            <a uib-dropdown-toggle>\n                                <span class=\"createNewCollaborationItem\">{{ ::i18n.create }}</span>\n                                <span class=\"glyphicon glyphicon-chevron-down\"></span></a>\n\n                            <ul class=\"dropdown-menu-right\" uib-dropdown-menu>\n                                <li ng-if=\"::canCreateChat()\">\n                                    <a ng-click=\"openChat()\"\n                                       class=\"createChat\">\n                                        {{ ::i18n.createItem.chat }}\n                                    </a>\n                                </li>\n                                <li ng-if=\"::canAssignTask()\">\n                                    <a ng-click=\"openTaskEditor()\"\n                                       class=\"createTask\">\n                                        {{ ::i18n.createItem.task }}\n                                    </a>\n                                </li>\n                                <li ng-if=\"::canCreateNote()\">\n                                    <a ng-click=\"openCreateNoteEditor()\"\n                                       class=\"createNote\">\n                                        {{ ::i18n.createItem.note }}\n                                    </a>\n                                </li>\n                                <li class=\"emailAll\"\n                                    ng-if=\"showEmail('email') && canCreateEmail()\">\n                                    <a ng-click=\"createGenericCorrespondenceEmail()\"\n                                       class=\"createEmail\">\n                                        {{ ::i18n.createItem.email }}\n                                    </a>\n                                </li>\n                                <li ng-if=\"showEmail('email') && canCreateEmail() && viewModel.enableEmailFromTemplate\">\n                                    <a ng-click=\"createEmail()\"\n                                       class=\"createEmailFromTemplate\">\n                                        {{ ::i18n.createItem.emailFromTemplate }}\n                                    </a>\n                                </li>\n                                <li class=\"fileAll\"\n                                    ng-if=\"::canCreateAttachment()\">\n                                    <a ng-click=\"openAttachmentEditor()\"\n                                       class=\"createAttachment\">\n                                        {{ ::i18n.createItem.attachment }}\n                                    </a>\n                                </li>\n                                <li ng-if=\"canCreateAttachmentFromTemplate()\">\n                                    <a ng-click=\"openAttachmentFromTemplate()\"\n                                       class=\"createAttachmentFromTemplate\">\n                                        {{ ::i18n.createItem.attachmentFromTemplate }}\n                                    </a>\n                                </li>\n                            </ul>\n                        </li>\n                    </ul>\n                </div>\n\n\n\n\n\n\n\n            <!--Collab Item Row Container-->\n            <ul class=\"dockPanelCellList collaborationCellList\"\n                ng-if=\"viewModel.collabItemList.length\">\n\n                <!--Item Row-->\n                <li class=\"dockPanelCell collaborationCell\"\n                    ng-if=\"showEmail(collabItem.type)\"\n                    ng-repeat=\"collabItem in viewModel.collabItemList\"\n                    ng-show=\"isVisible(collabItem)\"\n                    ng-click=\"onSelectItem($event, collabItem)\"\n                    ng-class=\"{'completedTaskHeader': collabItem.type === 'header'}\">\n\n                    <span ng-if=\"collabItem.type === 'header'\">{{ ::i18n.task.header }}</span>\n\n                    <div class=\"cellSide\"\n                         ng-if=\"collabItem.type !== 'header'\">\n                        <ui-user-avatar userid=\"{{collabItem.userId}}\"\n                                        email-message-id=\"{{collabItem.type=='email'?collabItem.id:null}}\"\n                                        ng-if=\"viewModel.filterType !== 'attachment'\"\n                                        icon=\"{{collabItem.type | lowercase}}\"\n                                        is-group=\"{{isUserGroup(collabItem)}}\"></ui-user-avatar>\n                            <div ng-if=\"viewModel.filterType ==='attachment'\" ng-switch on=\"collabItem.fileType\" ng-show=\"true\">\n                                <i ng-switch-when=\"pdf\" class=\"fa fa-file-pdf-o fileTypeIcon pdfIcon\"></i>\n                                <i ng-switch-when=\"xls\" class=\"fa fa-file-excel-o fileTypeIcon excelIcon\"></i>\n                                <i ng-switch-when=\"xlsx\" class=\"fa fa-file-excel-o fileTypeIcon excelIcon\"></i>\n                                <i ng-switch-when=\"doc\" class=\"fa fa-file-word-o fileTypeIcon wordIcon\"></i>\n                                <i ng-switch-when=\"docx\" class=\"fa fa-file-word-o fileTypeIcon wordIcon\"></i>\n                                <div ng-switch-default>\n                                    <i class=\"fa fa-file fileTypeIcon fileIcon\"></i>\n                                </div>\n                            </div>\n                    </div>\n\n                    <div class=\"cellContent\" ng-switch on=\"collabItem.type\" ng-show=\"true\"\n                         ng-if=\"collabItem.type !== 'header'\">\n\n                        <div ng-switch-when=\"message\" class=\"chatSummary\">\n                            <p ng-bind-html=\"collabItem.summaryData.body | linky:'_blank' | nl2br\" data-ellipsis></p>\n                        </div>\n\n                        <div ng-switch-when=\"attachment\" ng-if=\"viewModel.filterType !== 'all'\">\n                            <div class=\"fileNameContent\">\n                                <p class=\"fileName\">\n                                    <a class=\"fileLink\" ng-click=\"attachmentDownloadClick($event, collabItem)\">{{ collabItem.summaryData.name }} {{ collabItem.summaryData.byteCountToDisplaySize }}</a>\n                                </p>\n                                <span class=\"date\">{{collabItem.date}}</span>\n                            </div>\n                            <div class=\"fileNameContent\">\n                                <div class=\"fileName\">\n                                    <span class=\"attachmentSubText\">{{ getUserFullName(collabItem) }}</span>\n                                    <span ng-class=\"{'titleSubtext':collabItem.summaryData.collaborationType!=''}\">{{collabItem.summaryData.collaborationType}}</span>\n                                    <span class=\"titleSubtext\" ng-if=\"isShared(collabItem)\">\n                                        <span class=\"glyphicon glyphicon-eye-open eyeIcon\"\n                                              uib-tooltip=\"{{::i18n.visibleToAgent}}\"\n                                              tooltip-append-to-body=\"true\"></span>\n                                    </span>\n                                </div>\n                                <span class=\"time\">{{collabItem.time}}</span>\n                            </div>\n                            <p class=\"attachmentDescription\" uib-tooltip=\"{{ collabItem.summaryData.description}}\"\n                               tooltip-append-to-body=\"true\"\n                               tooltip-placement=\"bottom auto\">\n                                <span>{{collabItem.summaryData.description}}</span>\n                            </p>\n                        </div>\n\n                        <div ng-switch-when=\"attachment\" ng-if=\"viewModel.filterType === 'all'\">\n                            <div class=\"fileNameContent\">\n                                <h3 class=\"fileName\">\n                                    <span class=\"userFullName\">{{ getUserFullName(collabItem) }}</span>\n                                    <span ng-class=\"{'titleSubtext':collabItem.summaryData.collaborationType!=''}\">{{collabItem.summaryData.collaborationType}}</span>\n\n                                    <span class=\"titleSubtext\" ng-if=\"isShared(collabItem)\">\n                                        <span class=\"glyphicon glyphicon-eye-open eyeIcon\"\n                                              uib-tooltip=\"{{::i18n.visibleToAgent}}\"\n                                              tooltip-append-to-body=\"true\"></span>\n                                    </span>\n                                </h3>\n\n                                <div class=\"fileUploadDate\">\n                                    <span class=\"date\">{{collabItem.date}}</span>\n                                    <span class=\"time\">{{collabItem.time}}</span>\n                                </div>\n                            </div>\n\n                            <div class=\"fileNameContent\">\n                                <p class=\"fileName\">\n                                    <a class=\"fileLink\" ng-click=\"attachmentDownloadClick($event, collabItem)\">{{ collabItem.summaryData.name }} {{ collabItem.summaryData.byteCountToDisplaySize }}</a>\n                                </p>\n\n                            </div>\n\n                            <p class=\"attachmentDescription\" uib-tooltip=\"{{ collabItem.summaryData.description}}\"\n                               tooltip-append-to-body=\"true\"\n                               tooltip-placement=\"bottom auto\">\n                                <span>{{collabItem.summaryData.description}}</span>\n                            </p>\n                        </div>\n\n                        <div ng-switch-when=\"email\" class=\"email\">\n\n                            <div class=\"userFullName\">\n                                <h3 ng-if=\"collabItem.type == 'email'\">\n                                    <span>{{ getUserFullName(collabItem) }}</span>\n\n                                    <span class=\"titleSubtext\" ng-if=\"isShared(collabItem)\">\n                                        <span class=\"glyphicon glyphicon-eye-open collaborationEyeIcon\"\n                                              uib-tooltip=\"{{::i18n.visibleToAgent}}\"\n                                              tooltip-append-to-body=\"true\"></span>\n                                    </span>\n\n                                    <span ng-if=\"isEmailDraft(collabItem)\"\n                                          class=\"titleSubtext emailDraft\">{{ ::i18n.email.draft }}</span>\n                                </h3>\n                                <span class=\"date\" ng-if=\"!isEmailDraft(collabItem)\">{{collabItem.date}}</span>\n                            </div>\n\n                            <div class=\"emailRecipient\">\n                                <p ui-browser-detection >\n                                    <span class=\"emailToLabel\"\n                                            ng-class=\"{collabLabel: isPrintingCollab()}\">{{ ::i18n.email.toLabel }} </span> {{\n                                    collabItem.summaryData.to | emailRecipientsFilter }}\n                                </p>\n                                <span class=\"time\" ng-if=\"!isEmailDraft(collabItem)\">{{collabItem.time}}</span>\n                            </div>\n\n                            <div class=\"emailRecipient\" ng-if=\"isPrintingCollab() && collabItem.summaryData.cc\">\n                                <div class=\"collabLabel\">{{ ::i18n.email.ccLabel }} </div>\n                                <div>{{ collabItem.summaryData.cc | emailRecipientsFilter }}</div>\n                            </div>\n\n                            <div class=\"emailRecipient\" ng-if=\"isPrintingCollab() && collabItem.summaryData.bcc\">\n                                <div class=\"collabLabel\">{{ ::i18n.email.bccLabel }} </div>\n                                <div>{{ collabItem.summaryData.bcc | emailRecipientsFilter }}</div>\n                            </div>\n\n                            <div class=\"emailSubjectRow\">\n                                <p class=\"emailSubjectBox\"\n                                   ui-browser-detection uib-tooltip=\"{{ collabItem.summaryData.subject}}\"\n                                   tooltip-append-to-body=\"true\"\n                                   tooltip-placement=\"bottom auto\">\n                                    <span class=\"collabLabel emailSubjectLabel\">{{ ::i18n.email.subjectLabel }}</span>\n                                    <span class=\"emailSubject\">{{collabItem.summaryData.subject}}</span>\n                                    <span ng-if=\"isEmailWithAttachment(collabItem)\"\n                                          class=\"collaborationCellAttachment glyphicon glyphicon-paperclip\"></span>\n                                </p>\n                            </div>\n\n                            <div ng-if=\"isPrintingCollab()\">\n                                <p class=\"emailSubjectBox\">\n                                    <span class=\"collabLabel emailSubjectLabel\">{{ ::i18n.email.type }}</span>\n                                    <span> {{ collabItem.summaryData.collaborationType }}</span>\n                                </p>\n                            </div>\n\n                            <p ui-browser-detection>{{ collabItem.summaryData.snippet }}</p>\n\n                            <div class=\"emailBodyRow\"\n                                 ng-if=\"isPrintingCollab()\"\n                                 ng-bind-html=\"collabItem.summaryData.body\">\n                            </div>\n\n                            <div class=\"gutterTop emailAttachmentList\"\n                                 ng-if=\"isPrintingCollab() && collabItem.summaryData.attachmentNames.length > 0\">\n\n                                <span class=\"glyphicon glyphicon-paperclip\"></span>\n\n                                <div ng-repeat=\"attachment in collabItem.summaryData.attachmentNames\">\n                                    {{attachment}}\n                                </div>\n                            </div>\n\n\n                        </div>\n\n                        <div ng-switch-when=\"note\" class=\"noteSummary\">\n                            <div class=\"userFullName\">\n                                <h3>\n                                    <span class=\"user\">{{ collabItem.userFullName }}</span>\n                                    <span class=\"titleSubtext\" ng-if=\"isShared(collabItem)\">\n\n\n                                        <span class=\"glyphicon glyphicon-eye-open collaborationEyeIcon eyeIcon\"\n                                              uib-tooltip=\"{{::i18n.visibleToAgent}}\"\n                                              tooltip-append-to-body=\"true\"></span>\n\n\n                                    </span>\n\n                                </h3>\n                                <span class=\"date\"><span>{{collabItem.date}}</span></span>\n                            </div>\n\n\n                            <div class=\"noteSummaryData\"\n                                 ng-if=\"isPrintingCollab()\">\n\n                                <span class=\"collabLabel\">{{::i18n.note.collaborationTypeLabel}} </span>\n                                <span>{{::collabItem.summaryData.collaborationType}}</span>\n                                <span class=\"time\">{{collabItem.time}}</span>\n                            </div>\n\n                            <div class=\"noteSummaryData\"\n                                 ng-if=\"isPrintingCollab() && isUnderwriterUser(collabItem)\">\n\n                                <span class=\"collabLabel\">{{::i18n.note.visibleToAgent}} </span>\n                                <span>{{::collabItem.summaryData.publicNote ? i18n.yes : i18n.no }}</span>\n                            </div>\n\n                            <div class=\"gutterTop noteSummaryData\">\n                                <p ng-if=\"!isPrintingCollab()\"ng-click=\"onSelectItem($event, collabItem)\"\n                                   ng-bind-html=\"collabItem.summaryData.snippet | linky:'_blank' | nl2br\" data-ellipsis></p>\n\n                                <p ng-if=\"isPrintingCollab()\"\n                                   ng-bind=\"collabItem.summaryData.note\"></p>\n\n                                <span ng-if=\"!isPrintingCollab()\" class=\"time\">{{collabItem.time}}</span>\n                            </div>\n                        </div>\n\n                        <div ng-switch-when=\"task\" class=\"taskSummary\">\n                            <div class=\"userFullName\">\n                                <h3>\n                                    <span class=\"taskAssigneeName\">{{ collabItem.userFullName }}</span>\n                                    <span class=\"titleSubtext\" ng-if=\"isShared(collabItem)\">\n                                        <span class=\"glyphicon glyphicon-eye-open\"></span>\n                                    </span>\n                                </h3>\n                                <span class=\"date\">{{collabItem.date}}</span>\n                            </div>\n                            <div class=\"taskDefinition\">\n                                <div>\n                                    <span ng-bind=\"getTaskDefinition(collabItem.summaryData.definition)\"></span>\n                                    <span ng-if=\"isTaskWithAttachment(collabItem)\"\n                                           class=\"collaborationCellAttachment glyphicon glyphicon-paperclip\"></span>\n                                </div>\n                                <span class=\"time\">{{collabItem.time}}</span>\n                            </div>\n                            <p class=\"taskDetails\"\n                                ng-class=\"{ gutterBottom: isPrintingCollab() }\">\n                                  <span\n                                      uib-tooltip=\"{{ collabItem.summaryData.description}}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-enable=\"{{ item.descriptionTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.descriptionTooltip\"\n                                      ui-is-tooltip-enabled-check-parent-height=\"true\"\n                                      tooltip-placement=\"left-top\">\n                                      {{collabItem.summaryData.description}}</span>\n                            </p>\n\n                            <p ng-if=\"!collabItem.summaryData.resolutionDate && collabItem.summaryData.dueDate\"\n                               ng-class=\"{'taskPastDue': isTaskPastDue(collabItem)}\"\n                               class=\"taskDueDate\">\n                                <span ng-class=\"{ collabLabel: isPrintingCollab()}\">{{ ::i18n.task.due }}</span>:\n                                {{ collabItem.summaryData.dueDate | date :\n                                    viewModel.preferenceDateFormat + ' hh:mm a' }}\n                            </p>\n                            <p ng-if=\"collabItem.summaryData.resolutionDate\"\n                               ng-class=\"{\n                                'taskPastDue': isTaskPastDue(collabItem),\n                                 collabLabel: isPrintingCollab()\n                                }\"\n                               class=\"taskResolvedDate\">\n                                <span>{{ ::i18n.task.completed }}</span>:\n                                {{ collabItem.summaryData.resolutionDate | date :\n                                viewModel.preferenceDateFormat + ' hh:mm a' }}\n                            </p>\n\n                            <div ng-if=\"isPrintingCollab()\">\n                                <p>\n                                    <span class=\"collabLabel\">{{ ::i18n.task.reminderLabel }}</span>\n                                    {{ collabItem.summaryData.reminderDate | date }}\n                                </p>\n\n                                <p>\n                                    <span class=\"collabLabel\">{{ ::i18n.task.priorityLabel }}</span>\n                                    {{ getPriorityLabel(collabItem.summaryData.priority) }}\n                                </p>\n\n                                <p>\n                                    <span class=\"collabLabel\">{{ ::i18n.task.showOnHomepageLabel }}</span>\n                                    {{ collabItem.summaryData.shared }}\n                                </p>\n\n                                <p class=\"gutterBottom\">\n                                    <span class=\"collabLabel\">{{ ::i18n.task.emailReminderLabel }}</span>\n                                    {{ collabItem.summaryData.emailReminder }}\n                                </p>\n\n                                <p class=\"gutterTop\">\n                                    <span class=\"collabLabel\">{{ ::i18n.task.resolutionNotesLabel }}</span>\n                                    {{ collabItem.summaryData.resolutionNotes }}\n                                </p>\n\n                                <div ng-if=\"collabItem.summaryData.attachmentNames.length\"\n                                     class=\"gutterTop\">\n                                    <span class=\"glyphicon glyphicon-paperclip\"></span>\n                                    <span class=\"collabLabel\">{{::i18n.task.attachmentLabel}}</span>\n                                    <p ng-repeat=\"attachmentName in collabItem.summaryData.attachmentNames\">\n                                        {{ attachmentName }}\n                                    </p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n\n        <div class=\"dockPanelContent collaborationContent collaborationChat\"\n             ng-if=\"viewModel.filterType === 'chat'\"\n             ng-controller=\"collaborationChatController\"\n             ng-include=\"'/collaboration/chat/collaborationChat.tpl.html'\">\n        </div>\n    </section>\n\n    <section class=\"dockPanelSection collaborationPage collaborationPage-pushed collaborationNote\"\n             ng-controller=\"collaborationNoteController\"\n             ng-include=\"'/collaboration/note/collaborationNote.tpl.html'\">\n    </section>\n\n    <section class=\"dockPanelSection collaborationPage collaborationPage-pushed collaborationEmail\"\n             ng-controller=\"collaborationEmailController\"\n             ng-include=\"'/collaboration/email/collaborationEmail.tpl.html'\">\n    </section>\n\n    <section class=\"dockPanelSection collaborationPage collaborationPage-pushed collaborationAttachment\"\n             ng-controller=\"collaborationAttachmentController\"\n             ng-include=\"'/collaboration/attachment/collaborationAttachment.tpl.html'\">\n    </section>\n\n    <section class=\"dockPanelSection collaborationPage collaborationPage-pushed collaborationTask\"\n             ng-controller=\"collaborationTaskController\"\n             ng-include=\"'/collaboration/task/collaborationTask.tpl.html'\">\n    </section>\n\n    <div ng-if=\"viewModel.isLoading\">\n        <div class=\"icon-spinner\">\n            <img src=\"" + __webpack_require__(37) + "\" />\n        </div>\n    </div>\n</div>\n\n<iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cbf5d0325768aac552b0db2b2c6e21ec.svg";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6bafabc88676267e538f8c9d0db2b233.svg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c6263afa377537c90ab4290abc9fbb6f.svg";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1bc357fb1d319d8bc4ac777fd9a77a4b.svg";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d632750a584980ac9fa360df7ceb5d25.svg";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "88a5b041c0b26cfa2badafc780f219f8.svg";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(291);

/*@ngInject*/
var CollaborationController = function CollaborationController($scope, $rootScope, $timeout, $state, $stateParams, $location, $uibModal, $window, coreConstant, uiPerformanceLoggerConstant, submissionConstant, submissionStateMediator, coreMediator, dateUtil, authorizationConstants, emailMessageStatus, submissionTaskStatus, attachmentUtil, collaborationMediator, attachmentMediator, modalUtil, currentUserModel, collaborationUtil, preferenceModel) {
  var timeoutList = [];
  $scope.i18n = locale;
  $scope.viewModel = {
    isOpen: false,
    isLoading: false,
    filterType: 'all',
    isSearchOpen: false,
    searchInput: '',
    searchDelayInMilliSeconds: submissionConstant.searchDelay,
    collabItemList: [],
    currentUserId: 0,
    selectedItem: null,
    chat: {
      isVisible: false
    },
    note: {
      isVisible: false,
      isEditorSaving: false
    },
    email: {
      isVisible: false,
      isEditorOpen: false,
      isEditorSaving: false
    },
    attachment: {
      isVisible: false,
      isEditorOpen: false,
      isEditorSaving: false
    },
    task: {
      isVisible: false,
      isEditorOpen: false,
      isEditorSaving: false
    },
    permissions: [],
    preferenceDateFormat: null,
    userType: null,
    showGearIcon: false,
    hasSharedPermission: false,
    enableEmailFromTemplate: false,
    enableFileFromTemplate: false,
    filterList: [],
    filterListItemName: 'name',
    collabItemsCopy: [],
    isFilterOn: false,
    selectedFilterList: [],
    initialSelectedFilter: [],
    currentSelectedTab: '',
    isTaskResolutionReasonEnabled: false,
    isTaskReceivedDateEnabled: false,
    isRefreshCollaborationAttachmentsEnabled: false
  };
  this.$onInit = function () {
    attachmentUtil.getAttachmentTypes().then(function (result) {
      $scope.viewModel.filterList = result;
    });
    $scope.viewModel.isPrintingCollab = $state.current.name === 'submission.printCollaboration';
    if ($stateParams.collabType) {
      $scope.viewModel.title = $scope.i18n.printTitle[$stateParams.collabType];
      $scope.onCollaborationFilterClick($stateParams.collabType);
      openDrawer();
      if ($stateParams.collabId) {
        $scope.selectItem({
          type: $stateParams.collabType,
          id: $stateParams.collabId
        });
      }
    } else {
      $scope.viewModel.title = $scope.i18n.title;
    }
    $scope.viewModel.isTaskResolutionReasonEnabled = preferenceModel.get('system.enableTaskResolutionReason') === 'true';
    $scope.viewModel.isTaskReceivedDateEnabled = preferenceModel.get('system.enableTaskReceivedDate') === 'true';
    $scope.viewModel.isRefreshCollaborationAttachmentsEnabled = preferenceModel.get('system.enableRefreshCollaborationAttachments') === 'true';
  };
  $scope.onCollaborationFilterClick = function (type) {
    $scope.viewModel.filterType = type;
    if ($scope.viewModel.currentSelectedTab === '' || $scope.viewModel.currentSelectedTab !== type) {
      loadCollaboration();
      setSelectedItem();
    }
    $scope.viewModel.currentSelectedTab = type;
  };
  $scope.getUserFullName = function (collabItem) {
    return collabItem.userFullName === 'AUTHENTICATION_SERVER' ? 'System' : collabItem.userFullName;
  };
  function filterItem() {
    var filterList = [];
    if ($scope.viewModel.selectedFilterList.length > 0) {
      _.each($scope.viewModel.collabItemsCopy, function (collabItem) {
        _.each($scope.viewModel.selectedFilterList, function (selectedItem) {
          if (collabItem.summaryData.collaborationType === selectedItem.name) {
            filterList.push(collabItem);
          }
        });
      });
      $scope.viewModel.collabItemList = filterList;
    } else {
      $scope.viewModel.collabItemList = $scope.viewModel.collabItemsCopy;
    }
  }
  function setSelectedItem() {
    var initialSelectedItems = [];
    _.each($scope.viewModel.filterList, function (item) {
      _.each($scope.viewModel.selectedFilterList, function (selectedItem) {
        if (item.name === selectedItem.name) {
          initialSelectedItems.push(item.name);
        }
      });
    });
    $scope.viewModel.initialSelectedFilter = _.join(initialSelectedItems, '::');
  }
  function loadCollaboration() {
    var collabType = $stateParams.collabType,
      collabId = $stateParams.collabId;
    loadCollaborationItems().then(function () {
      $rootScope.$broadcast(submissionConstant.event.COLLABORATION_FILTER_CHANGE, $scope.viewModel.filterType);
      $scope.closeNoteEditor();
      if (collabType && collabId) {
        $scope.selectItem({
          type: collabType,
          id: collabId
        });
      }
      saveState();
      if ($scope.viewModel.filterType.toLowerCase() === 'task') {
        sortCollabTaskList();
      } else {
        sortCollabItemList();
      }
      if ($scope.viewModel.filterType !== 'chat' && $scope.viewModel.filterType !== 'task') {
        filterItem();
      }
    });
  }
  $scope.getSearchPlaceholder = function () {
    return $scope.i18n.searchPlaceholder;
  };
  function resetSearch() {
    if ($scope.viewModel.searchInput && $scope.viewModel.searchInput !== '') {
      $scope.viewModel.searchInput = '';
      loadCollaborationItems();
    }
    $scope.viewModel.isSearchOpen = false;
  }
  function saveState() {
    var toOmit = ['collabItemList', 'isLoading', 'permissions', 'note.isEditorSaving', 'attachment.isEditorSaving', 'task.isEditorSaving', 'userType'];
    submissionStateMediator.saveCollaborationState($stateParams.submissionId, _.omit($scope.viewModel, toOmit));
  }
  function loadCollaborationItems() {
    var index;
    if (!_.isNil($stateParams.submissionId)) {
      $scope.viewModel.collabItemList = [];
      $scope.viewModel.isLoading = true;
      return collaborationMediator.loadCollaborationItems($stateParams.submissionId, $scope.viewModel.searchInput).then(function (collabItems) {
        _.each(collabItems, function (collabItem) {
          if (collabItem.type === $scope.viewModel.filterType || $scope.viewModel.filterType === 'all') {
            index = _.findIndex($scope.viewModel.collabItemList, function (collaborationItem) {
              return collabItem.uri === collaborationItem.uri;
            });
            if (index === -1) {
              $scope.viewModel.collabItemList.push(collabItem);
            }
          }
        });
        processCollaborationItems();
        if ($scope.viewModel.filterType !== 'chat' && $scope.viewModel.filterType !== 'task') {
          filterItem();
        }
      }).finally(function () {
        $scope.viewModel.isLoading = false;
      });
    }
  }
  function getFileTemplates() {
    coreMediator.getRemoteDataSetByName('File Templates').then(function (dataSet) {
      $scope.viewModel.enableFileFromTemplate = dataSet.items.length > 0;
    });
  }
  function getEmailTemplates() {
    coreMediator.getRemoteDataSetByName('Email Templates').then(function (dataSet) {
      $scope.viewModel.enableEmailFromTemplate = dataSet.items.length > 0;
    });
  }
  function generateNoteSnippet(collabItem) {
    var snippet = '';

    // only run it if string might be too long
    if (!_.isNil(collabItem.summaryData.note)) {
      if (collabItem.summaryData.note.length > 200) {
        if (_.indexOf(collabItem.summaryData.note, ' ') === -1) {
          //make sure we have at least one space to cut of the text
          snippet = collabItem.summaryData.note.substring(0, 200) + ' ' + collabItem.summaryData.note.substring(200, collabItem.summaryData.note.length);
        }
      }
      if (!snippet) {
        snippet = collabItem.summaryData.note;
      }
    }
    return snippet;
  }
  function processCollaborationItems() {
    var showGearIcon = false;
    _.map($scope.viewModel.collabItemList, function (collabItem) {
      collabItem.type = collabItem.type.toLowerCase();
      var fullDate = dateUtil.formatShortDate(collabItem.lastModified);
      var fullDateArr = _.split(fullDate, ' ');
      collabItem.date = fullDateArr[0];
      collabItem.time = dateUtil.formatTime(collabItem.lastModified).toUpperCase();
      if (collabItem.type === 'note') {
        collabItem.summaryData.snippet = generateNoteSnippet(collabItem);
        collabItem.summaryData.note = collabItem.summaryData.note;
      } else if (collabItem.type === 'attachment') {
        var fileType = collabItem.summaryData.name.split('.');
        if (fileType.length > 1) {
          collabItem.fileType = fileType.pop();
        }
      }
      if ($scope.viewModel.hasSharedPermission && !_.isNil(collabItem.summaryData)) {
        if (collabItem.summaryData.publicNote || collabItem.summaryData.shared) {
          showGearIcon = true;
        }
      }
      return collabItem;
    });
    $scope.viewModel.showGearIcon = showGearIcon;
    if (_.toLower($scope.viewModel.filterType) === 'task') {
      sortCollabTaskList();
    } else {
      sortCollabItemList();
    }
    $scope.viewModel.collabItemsCopy = _.map($scope.viewModel.collabItemList, _.clone);
  }
  function loadProfileInfo() {
    coreMediator.loadUserProfile().then(function (userProfile) {
      $scope.viewModel.currentUserId = userProfile.userId;
      $scope.viewModel.userProfile = userProfile;
      $scope.viewModel.userType = userProfile.userType;
      var permissions = [],
        neededPermissions = [authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES, authorizationConstants.AUTHORIZATION_DELETE_NOTES, authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES, authorizationConstants.AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS, authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS, authorizationConstants.TASK_ADD_MODIFY, authorizationConstants.TASK_DELETE, authorizationConstants.SEND_EMAIL, authorizationConstants.AUTHORIZATION_EMAIL_DELETE_EMAIL, authorizationConstants.AUTHORIZATION_EMAIL_VIEW_PRIVATE_EMAIL, authorizationConstants.AUTHORIZATION_HIDE_SHARED_EMAIL, authorizationConstants.AUTHORIZATION_MODIFY_ATTACHMENTS, authorizationConstants.LIVE_CHAT];
      _.each(neededPermissions, function (neededPermission) {
        if (currentUserModel.hasAuthorization(neededPermission)) {
          permissions.push(neededPermission);
        }
      });
      $scope.viewModel.permissions = permissions;
      if ($scope.canHideEmail() && $scope.canEditNoteShare() && $scope.canEditAttachment()) {
        $scope.viewModel.hasSharedPermission = true;
      }
    });
    if (coreMediator.getPreferenceByName('view.shortDateFormat')) {
      $scope.viewModel.preferenceDateFormat = updateFormatForDatepicker(coreMediator.getPreferenceByName('view.shortDateFormat'));
    }
  }
  function sortCollabItemList() {
    $scope.viewModel.collabItemList = _.sortBy($scope.viewModel.collabItemList, function (item) {
      return item.lastModified;
    }).reverse();
    _.remove($scope.viewModel.collabItemList, function (item) {
      return item.type === 'header';
    });
  }
  function sortCollabTaskList() {
    var resolutionDateFirstIndex;
    $scope.viewModel.collabItemList = _.orderBy($scope.viewModel.collabItemList, ['summaryData.status', 'lastModified'], ['asc', 'desc']);
    _.remove($scope.viewModel.collabItemList, function (item) {
      return item.type.toLowerCase() === 'header';
    });
    resolutionDateFirstIndex = _.findIndex($scope.viewModel.collabItemList, function (item) {
      return item.type.toLowerCase() === 'task' && item.summaryData.status === submissionTaskStatus.RESOLVED;
    });
    if (resolutionDateFirstIndex > -1) {
      $scope.viewModel.collabItemList.splice(resolutionDateFirstIndex, 0, {
        type: 'header'
      });
    }
  }
  function openDrawer() {
    $scope.viewModel.isOpen = true;
    saveState();
    $rootScope.$broadcast(submissionConstant.event.COLLABORATION_DID_OPEN);
  }
  function closeDrawer() {
    $scope.viewModel.isOpen = false;
    saveState();
    $rootScope.$broadcast(submissionConstant.event.COLLABORATION_DID_CLOSE);
  }
  function restoreState() {
    var savedViewModel = submissionStateMediator.getCollaborationState($stateParams.submissionId);
    if (savedViewModel) {
      $scope.viewModel = _.extend($scope.viewModel, savedViewModel);
      if ($scope.viewModel.isOpen) {
        $rootScope.$broadcast(submissionConstant.event.COLLABORATION_DID_OPEN);
      }
    }
  }
  function updateFormatForDatepicker(dateFormat) {
    return _.replace(dateFormat.toLowerCase(), 'mm', 'MM');
  }
  $scope.attachmentDownloadClick = function ($event, collabItem) {
    $event.stopPropagation();
    attachmentUtil.getAttachmentLinkURL(collabItem.id, collabItem.summaryData.name).then(function (url) {
      $window.open(url, '_blank');
    });
  };
  $scope.showEmail = function (collabType) {
    if (collabType === 'email') {
      if ($scope.viewModel.userType === 'Underwriter' || $scope.viewModel.userType === 'ServiceUser') {
        return preferenceModel.get('system.enableEmailCollaborationForUnderwriterWorkstation') === 'true';
      } else if ($scope.viewModel.userType === 'Agent') {
        return preferenceModel.get('system.enableEmailCollaborationForAgentWorkspace') === 'true';
      }
    } else {
      return true;
    }
  };
  $scope.isPrintingCollab = function () {
    return $state.current.name === 'submission.printCollaboration';
  };
  $scope.onToggleCollaboration = function () {
    return !$scope.viewModel.isOpen ? openDrawer() : closeDrawer();
  };
  $scope.hasAvatar = function (index) {
    return typeof $scope.viewModel.collabItemList[index].userAvatar !== 'undefined';
  };
  $scope.isVisible = function (item) {
    return $scope.viewModel.filterType === 'all' || $scope.viewModel.filterType === item.type || $scope.viewModel.filterType === 'task' && item.type === 'header';
  };
  $scope.openCreateNoteEditor = function () {
    $scope.viewModel.selectedItem = {
      type: 'note'
    };
    saveState();
  };
  $scope.openTaskEditor = function () {
    $scope.viewModel.task.isVisible = true;
    $scope.viewModel.task.isEditorOpen = true;
    saveState();
  };
  $scope.openAttachmentEditor = function () {
    $scope.viewModel.attachment.isVisible = true;
    $scope.viewModel.attachment.isEditorOpen = true;
    saveState();
    $rootScope.$broadcast(submissionConstant.event.ATTACHMENT_EDITOR_DID_OPEN);
  };
  $scope.openAttachmentFromTemplate = function () {
    collaborationMediator.createCorrespondenceForm($stateParams.submissionId).then(function (_correspondenceFormId) {
      if (!_.isNil(_correspondenceFormId) && _correspondenceFormId !== -1) {
        $uibModal.open({
          templateUrl: '/collaboration/attachment/fileTemplateModal/fileTemplateModal.tpl.html',
          controller: 'fileTemplateModalController',
          windowClass: 'fileTemplateModal',
          resolve: {
            submissionId: function submissionId() {
              return $stateParams.submissionId;
            },
            correspondenceFormId: function correspondenceFormId() {
              return _correspondenceFormId;
            }
          },
          keyboard: false,
          backdrop: 'static'
        });
      }
    });
  };
  $scope.openChat = function () {
    $scope.viewModel.collabItemList = [];
    $scope.viewModel.filterType = 'chat';
    $scope.viewModel.chat.isVisible = true;
    $scope.viewModel.currentSelectedTab = $scope.viewModel.filterType;
    saveState();
  };
  $scope.openEmailEditor = function () {
    $scope.viewModel.email.isVisible = $scope.selectedItem.status !== emailMessageStatus.STATUS_DRAFT;
    $scope.viewModel.email.isEditorOpen = true;
    saveState();
  };
  $scope.closeAttachmentEditor = function () {
    $scope.hideSubPage();
  };
  $scope.saveAttachment = function (data, file) {
    $scope.viewModel.attachment.isEditorSaving = true;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPLOAD_ATTACHMENT, $stateParams.submissionId);
    attachmentMediator.saveAttachment(data, file).then(function () {
      $scope.viewModel.attachment.isEditorSaving = false;
      $scope.viewModel.attachment.isEditorOpen = false;
      $scope.viewModel.attachment.isVisible = false;
      resetSearch();
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPLOAD_ATTACHMENT, coreConstant.uiPeformanceLogger.SUCCESS);
    }, function () {
      $scope.viewModel.attachment.isEditorSaving = false;
      $scope.viewModel.attachment.isEditorOpen = true;
      $scope.viewModel.attachment.isVisible = true;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPLOAD_ATTACHMENT, coreConstant.uiPeformanceLogger.FAIL);
    }).finally(function () {
      saveState();
    });
  };
  $scope.deleteAttachment = function (attachmentId) {
    attachmentMediator.deleteAttachment(attachmentId).then(function () {
      $scope.hideSubPage();
      resetSearch();
    });
  };
  $scope.updateAttachment = function (attachment) {
    attachmentMediator.updateAttachment(attachment.id, attachment).then(resetSearch);
  };
  $scope.closeNoteEditor = function () {
    $scope.hideSubPage();
    saveState();
  };
  $scope.getTaskDefinition = function (definition) {
    return _.replace(_.replace(definition, 'Other::', ''), 'Other - ', '');
  };
  $scope.createNote = function (data) {
    $scope.viewModel.note.isEditorSaving = true;
    data = _.extend(data, {
      submissionId: $stateParams.submissionId
    });
    collaborationMediator.createCollaborationNote(data).then(function () {
      $scope.viewModel.note.isEditorSaving = false;
      $scope.closeNoteEditor();
      resetSearch();
      loadCollaborationItems();
    });
  };
  $scope.updateNote = function (noteId, data) {
    $scope.viewModel.note.isEditorSaving = true;
    data = _.extend(data, {
      submissionId: $stateParams.submissionId
    });

    // make sure change is apply until we received the refresh data from the server
    $scope.collabItemList = _.map($scope.collabItemList, function (item) {
      if (item.id === data.id && item.type === 'note') {
        item.text = data.text;
        item.lastModified = new Date();
      }
      return item;
    });
    sortCollabItemList();
    collaborationMediator.updateCollaborationNote(noteId, data).then(function () {
      $scope.viewModel.note.isEditorSaving = false;
      resetSearch();
    });
  };
  $scope.deleteNote = function (noteId) {
    collaborationMediator.deleteCollaborationNote(noteId).then(function () {
      $scope.hideSubPage();
      resetSearch();
    });
  };
  $scope.$on(coreConstant.event.HANDLE_EMAIL_FROM_BUSINESS_CARD, function (event, submissionId, sendMailUserId) {
    $scope.viewModel.sendMailUserId = sendMailUserId;
  });
  $scope.$on(coreConstant.event.SHOW_EMAIL_EDITOR, function (event, draftEmailId, submissionId, chatMessageId, emailMessageId, notificationId, deleteNewEmailOnCancel, isReplyOrForward) {
    if ($stateParams.submissionId === submissionId.toString()) {
      collaborationMediator.loadCollaborationEmail(draftEmailId).then(function (email) {
        email.type = 'email';
        email.deleteNewEmailOnCancel = deleteNewEmailOnCancel;
        email.isReplyOrForward = isReplyOrForward;
        if ($scope.viewModel.sendMailUserId) {
          email.isOpenedFromBusinessCard = true;
          /*
           * UMS-26310
           * Use the chat-message, email-message, and notification ids in the "GET /User/id" request.
           * This is step 6 of 6.
           * The previous step is in the persistentConnection.js:alert function.
           */
          coreMediator.loadUserById($scope.viewModel.sendMailUserId, submissionId, notificationId, chatMessageId, emailMessageId).then(function (userProfile) {
            email.summaryData = {
              emailTo: collaborationUtil.getEmailIdentifierString(userProfile.name, userProfile.emailAddress)
            };
            openDrawer();
            $scope.selectItem(email);
          });
        } else {
          timeoutList.push($timeout(function () {
            openDrawer();
            $scope.selectItem(email);
          }, 0));
        }
      });
    }
  });
  $scope.createGenericCorrespondenceEmail = function () {
    var isCustomEmailNotification = true;
    coreMediator.sendEmailNotification('notification.sendEmailFromEmailCollaborationTool', isCustomEmailNotification, $stateParams.submissionId);
  };
  $scope.createEmail = function () {
    collaborationMediator.createEmailCorrespondenceForm($stateParams.submissionId).then(function (_correspondenceFormId2) {
      if (!_.isNil(_correspondenceFormId2) && _correspondenceFormId2 !== -1) {
        $uibModal.open({
          templateUrl: '/collaboration/email/emailTemplateModal/emailTemplateModal.tpl.html',
          controller: 'emailTemplateModalController',
          windowClass: 'emailTemplateModal',
          resolve: {
            submissionId: function submissionId() {
              return $stateParams.submissionId;
            },
            correspondenceFormId: function correspondenceFormId() {
              return _correspondenceFormId2;
            }
          },
          keyboard: false,
          backdrop: 'static'
        }).result.then(resetSearch);
      } else {
        coreMediator.sendEmailNotification('notification.sendEmailFromEmailCollaborationTool', /*isCustom=*/true, $stateParams.submissionId).then(resetSearch);
      }
    });
  };
  $scope.closeTaskEditor = function () {
    $scope.viewModel.task.isEditorOpen = false;
    saveState();
  };
  $scope.createTask = function (data) {
    $scope.viewModel.task.isEditorSaving = true;
    data = _.extend(data, {
      submissionId: $stateParams.submissionId
    });
    collaborationMediator.createCollaborationTask(data).then(function () {
      $scope.viewModel.task.isEditorSaving = false;
      $scope.closeTaskEditor();
      resetSearch();
    });
  };
  $scope.updateTask = function (taskId, data) {
    $scope.viewModel.task.isEditorSaving = true;
    data = _.extend(data, {
      submissionId: $stateParams.submissionId
    });
    return collaborationMediator.updateCollaborationTask(taskId, data).then(function () {
      $scope.viewModel.task.isEditorSaving = false;
      loadCollaborationItems();
    });
  };
  $scope.deleteTask = function (taskId) {
    collaborationMediator.deleteCollaborationTask(taskId).then(function () {
      $scope.hideSubPage();
      resetSearch();
    });
  };
  $scope.getTotalSeconds = function (date) {
    return dateUtil.getSeconds(date);
  };
  $scope.showCreateDropdown = function () {
    return $scope.viewModel.filterType === 'all';
  };
  $scope.onSelectItem = function (event, item) {
    if (event.target.tagName !== 'A') {
      $scope.selectItem(item);
    }
  };
  $scope.selectItem = function (item) {
    // if we try to open the same item
    if ($scope.viewModel.selectedItem && $scope.viewModel.selectedItem.id === item.id && $scope.viewModel.selectedItem.type === item.type) {
      $scope.viewModel[item.type].isVisible = true;
    } else {
      $scope.viewModel.selectedItem = item;
      if (item.type.toLocaleLowerCase() === 'message') {
        $scope.openChat();
      }
    }
    saveState();
  };
  $scope.hideSubPage = function () {
    $scope.viewModel.chat.isVisible = false;
    $scope.viewModel.email.isVisible = false;
    $scope.viewModel.note.isVisible = false;
    $scope.viewModel.task.isVisible = false;
    $scope.viewModel.attachment.isVisible = false;
    $scope.viewModel.selectedItem = null;
    $scope.viewModel.attachment.isEditorOpen = false;
    $scope.viewModel.email.isEditorOpen = false;
    $scope.viewModel.task.isEditorOpen = false;
    saveState();
  };
  $scope.isTaskPastDue = function (item) {
    if (item && item.summaryData && item.summaryData.dueDate) {
      return dateUtil.isBefore(item.summaryData.dueDate, new Date()) && !item.summaryData.resolutionDate;
    }
  };
  $scope.isUserGroup = function (item) {
    return item && item.summaryData && item.summaryData.assignedToGroup ? true : undefined;
  };
  $scope.isEmailDraft = function (item) {
    return item.type === 'email' && item.summaryData.status === emailMessageStatus.STATUS_DRAFT;
  };
  $scope.isEmailWithAttachment = function (item) {
    return item.type === 'email' && parseInt(item.summaryData.numAttachments) > 0;
  };
  $scope.isTaskWithAttachment = function (item) {
    return item.type === 'task' && parseInt(item.summaryData.numAttachments) > 0;
  };
  $scope.getCurrentUser = function () {
    return $scope.viewModel.userProfile;
  };
  $scope.canAssignTask = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.TASK_ADD_MODIFY);
  };
  $scope.canDeleteTask = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.TASK_DELETE);
  };
  $scope.canCreateNote = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES);
  };
  $scope.canEditNoteShare = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES);
  };
  $scope.canEditAttachment = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_MODIFY_ATTACHMENTS);
  };
  $scope.canCreateChat = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.LIVE_CHAT);
  };
  $scope.canCreateEmail = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.SEND_EMAIL);
  };
  $scope.canDeleteEmail = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_EMAIL_DELETE_EMAIL);
  };
  $scope.canCreateAttachment = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS);
  };
  $scope.canUserCreateAttachment = function () {
    if ($scope.isUnderwriterUser()) {
      return $scope.canCreateAttachment() && !$scope.viewModel.enableFileFromTemplate;
    } else {
      return $scope.canCreateAttachment();
    }
  };
  $scope.isShared = function (item) {
    return !_.isNil(item) && !$scope.isEmailDraft(item) && $scope.isUnderwriterUser() && (item.summaryData.shared || item.summaryData.publicNote);
  };
  $scope.getPriorityLabel = function (key) {
    return $scope.i18n.task.priority[key];
  };
  $scope.onPrintCollab = function () {
    $state.go('submission.printCollaboration', {
      submissionId: $stateParams.submissionId,
      formId: $stateParams.formId,
      collabType: $scope.viewModel.filterType
    }, {
      reload: true
    });
  };
  $scope.onRefreshCollabAttachments = function () {
    $scope.viewModel.isLoading = true;
    collaborationMediator.refreshCollaborationAttachments($stateParams.submissionId).finally(function () {
      $scope.viewModel.isLoading = false;
    });
  };
  $scope.canCreateAttachmentFromTemplate = function () {
    return $scope.canCreateAttachment() && $scope.isUnderwriterUser() && $scope.viewModel.enableFileFromTemplate;
  };
  $scope.isUnderwriterUser = function () {
    return $scope.viewModel.userType === 'Underwriter' || $scope.viewModel.userType === 'ServiceUser';
  };
  $scope.canInviteMembers = function () {
    return $scope.isUnderwriterUser() && $scope.canCreateChat();
  };
  $scope.canHideEmail = function () {
    return _.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_HIDE_SHARED_EMAIL);
  };
  $scope.onClearSearchInput = function () {
    $scope.viewModel.searchInput = '';
    $scope.onSearchInputChange();
  };
  $scope.hideAllSharedItem = function () {
    modalUtil.showConfirmationModal(null, null /*quoteId*/, null /*notificationName*/, 'submission.collaboration.hideCollaborationModal', '', /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      return collaborationMediator.hideAllSharedCollaborationItem($stateParams.submissionId).then(function () {
        $scope.viewModel.showGearIcon = false;
      });
    }
  };

  // When this is invoked via the ng-change, it has already bee automatically debounced via ng-model-options.
  $scope.onSearchInputChange = function () {
    loadCollaborationItems();
  };
  $scope.$on(submissionConstant.event.CLOSE_COLLABORATION, function () {
    closeDrawer();
  });
  $scope.$on(submissionConstant.event.TOGGLE_COLLABORATION, function () {
    $scope.onToggleCollaboration();
  });
  $scope.$on(submissionConstant.event.CREATE_COLLABORATION_ITEM_MESSAGE, function (event, collaborationItem) {
    timeoutList.push($timeout(function () {
      $scope.viewModel.collabItemList.push(collaborationItem);
      processCollaborationItems();
    }, 0));
  });
  $scope.$on(submissionConstant.event.UPDATE_COLLABORATION_ITEM_MESSAGE, function (event, collaborationItem) {
    var removed = false,
      index;

    // Remove this item if we get an update about unsharing.
    if (!$scope.viewModel.hasSharedPermission && !_.isNil(collaborationItem.summaryData)) {
      if (!collaborationItem.summaryData.publicNote && !collaborationItem.summaryData.shared || collaborationItem.summaryData.published === false) {
        removed = true;
        timeoutList.push($timeout(function () {
          _.remove($scope.viewModel.collabItemList, function (collabItem) {
            return collabItem.uri === collaborationItem.uri;
          });
        }, 0));
      }
    }

    // Remove this item if it was a chat message update with the 'published' bit set to false.
    if (collaborationItem.type === 'message' && !_.isNil(collaborationItem.summaryData)) {
      if (collaborationItem.summaryData.published === false) {
        removed = true;
        timeoutList.push($timeout(function () {
          _.remove($scope.viewModel.collabItemList, function (collabItem) {
            return collabItem.uri === collaborationItem.uri;
          });
        }, 0));
      }
    }
    if (!removed) {
      timeoutList.push($timeout(function () {
        if (collaborationItem.type === 'note') {
          collaborationItem.summaryData.snippet = generateNoteSnippet(collaborationItem);
          collaborationItem.summaryData.note = collaborationItem.summaryData.note;
        }

        // The index of the collaboration item needs to be defined within this function as the $scope.viewModel.collabItemList can update by the time this function is invoked
        // e.g. when a new attachment is added to a draft email, two collaboration items are created; one for the updated email and the second for the new attachment
        index = _.findIndex($scope.viewModel.collabItemList, function (collabItem) {
          return collabItem.uri === collaborationItem.uri;
        });
        if (index !== -1) {
          $scope.viewModel.collabItemList.splice(index, 1, collaborationItem);
        } else {
          $scope.viewModel.collabItemList.push(collaborationItem);
        }
      }, 0));
    }
    timeoutList.push($timeout(function () {
      processCollaborationItems();
    }, 0));
  });
  $scope.$on(submissionConstant.event.DELETE_COLLABORATION_ITEM_MESSAGE, function (event, collaborationItem) {
    timeoutList.push($timeout(function () {
      _.remove($scope.viewModel.collabItemList, function (collabItem) {
        return collabItem.uri === collaborationItem.uri;
      });
      processCollaborationItems();
    }, 0));
  });
  $scope.$on(submissionConstant.event.OPEN_CHAT_COLLABORATION, function () {
    openDrawer();
    $scope.openChat();
  });
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
    if (itemName === $scope.viewModel.filterListItemName) {
      $scope.viewModel.selectedFilterList = [];
      _.each($scope.viewModel.filterList, function (item) {
        if (item.selected) {
          $scope.viewModel.selectedFilterList.push(item);
        }
      });
      $scope.viewModel.isFilterOn = $scope.viewModel.selectedFilterList.length > 0;
      filterItem();
    }
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  restoreState();
  loadProfileInfo();
  loadCollaborationItems();
  getFileTemplates();
  getEmailTemplates();
};
CollaborationController.$inject = ["$scope", "$rootScope", "$timeout", "$state", "$stateParams", "$location", "$uibModal", "$window", "coreConstant", "uiPerformanceLoggerConstant", "submissionConstant", "submissionStateMediator", "coreMediator", "dateUtil", "authorizationConstants", "emailMessageStatus", "submissionTaskStatus", "attachmentUtil", "collaborationMediator", "attachmentMediator", "modalUtil", "currentUserModel", "collaborationUtil", "preferenceModel"];
angular.module('gw-um-submission').controller('collaborationController', CollaborationController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 291 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Collaboration\",\"yes\":\"Yes\",\"no\":\"No\",\"printTitle\":{\"email\":\"Email\",\"task\":\"Task\",\"chat\":\"Chat\",\"note\":\"Notes\"},\"create\":\"New\",\"print\":\"Print\",\"searchPlaceholder\":\"Search\",\"hideAllShared\":\"Hide All Shared\",\"hideAllSharedTooltip\":\"Hide all shared.\",\"refreshAttachmentsTooltip\":\"Refresh Files.\",\"visibleToAgent\":\"Visible to agent\",\"email\":{\"draft\":\"Draft\",\"type\":\"Type:\",\"toLabel\":\"To:\",\"ccLabel\":\"Cc:\",\"bccLabel\":\"Bcc:\",\"subjectLabel\":\"Subject:\"},\"task\":{\"due\":\"Due\",\"completed\":\"Completed\",\"header\":\"Completed Tasks\",\"reminderLabel\":\"Reminder:\",\"priorityLabel\":\"Priority:\",\"showOnHomepageLabel\":\"Show on Homepage:\",\"emailReminderLabel\":\"Email Reminder:\",\"resolutionNotesLabel\":\"Resolution Notes:\",\"attachmentLabel\":\"Attachments:\",\"priority\":{\"1\":\"Low\",\"2\":\"Medium\",\"3\":\"High\"}},\"note\":{\"collaborationTypeLabel\":\"Type: \",\"visibleToAgent\":\"Visible To Agent: \"},\"filter\":{\"all\":\"All\",\"attachment\":\"Files\",\"chat\":\"Chat\",\"email\":\"Emails\",\"note\":\"Notes\",\"task\":\"Tasks\",\"icon\":{\"filterByType\":\"Filter by Type\",\"changeFilterByType\":\"Change Filter by Type\"}},\"createItem\":{\"all\":\"All\",\"attachment\":\"File\",\"attachmentFromTemplate\":\"File from Template\",\"chat\":\"Chat\",\"email\":\"Email\",\"emailFromTemplate\":\"Email from Template\",\"note\":\"Note\",\"task\":\"Task\"}}");

/***/ }),
/* 292 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationMediator = function CollaborationMediator(collaborationRepository, collaborationNoteRepository, collaborationLoadTaskRepository, collaborationCreateTaskRepository, collaborationUpdateTaskRepository, collaborationDeleteTaskRepository, collaborationNotifyTaskRepository, loadSubmissionAttachmentsRepository, collaborationEmailRepository, deleteCollaborationNoteRepository, updateCollaborationNoteRepository, createCollaborationNoteRepository, deleteCollaborationEmailRepository, forwardCollaborationEmailRepository, replyAllCollaborationEmailRepository, replyCollaborationEmailRepository, sendCollaborationEmailRepository, updateCollaborationEmailRepository, uploadAttachmentCollaborationEmailRepository, createCorrespondenceFormRepository, createCorrespondenceEmailRepository, hideSharedCollaborationRepository, chatMessageListRepository, sendChatMessageRepository, publishChatMessageRepository, unpublishChatMessageRepository, inviteChatRepository) {
  this.loadCollaborationItems = function (submissionId, searchInput) {
    return collaborationRepository.loadCollaborationItems(submissionId, searchInput);
  };
  this.loadCollaborationNote = function (noteId) {
    return collaborationNoteRepository.loadCollaborationNote(noteId);
  };
  this.refreshCollaborationAttachments = function (submissionId) {
    return collaborationRepository.refreshCollaborationAttachments(submissionId);
  };
  this.createCollaborationNote = function (data) {
    return createCollaborationNoteRepository.createCollaborationNote(data);
  };
  this.updateCollaborationNote = function (noteId, data) {
    return updateCollaborationNoteRepository.updateCollaborationNote(noteId, data);
  };
  this.deleteCollaborationNote = function (noteId) {
    return deleteCollaborationNoteRepository.deleteCollaborationNote(noteId);
  };
  this.loadCollaborationTask = function (taskId) {
    return collaborationLoadTaskRepository.loadCollaborationTask(taskId);
  };
  this.createCollaborationTask = function (data) {
    return collaborationCreateTaskRepository.createCollaborationTask(data);
  };
  this.updateCollaborationTask = function (taskId, data) {
    return collaborationUpdateTaskRepository.updateCollaborationTask(taskId, data);
  };
  this.updateCollaborationTaskAttachment = function (taskId, data) {
    return collaborationUpdateTaskRepository.updateCollaborationTaskAttachment(taskId, data);
  };
  this.deleteCollaborationTaskAttachment = function (taskId, attachmentId) {
    return collaborationDeleteTaskRepository.deleteCollaborationTaskAttachment(taskId, attachmentId);
  };
  this.deleteCollaborationTask = function (taskId) {
    return collaborationDeleteTaskRepository.deleteCollaborationTask(taskId);
  };
  this.notifyTaskAssignee = function (taskId) {
    return collaborationNotifyTaskRepository.notifyTaskAssignee(taskId);
  };
  this.loadSubmissionAttachments = function (submissionId) {
    return loadSubmissionAttachmentsRepository.loadSubmissionAttachments(submissionId);
  };
  this.loadSharedSubmissionAttachments = function (submissionId) {
    return loadSubmissionAttachmentsRepository.loadSharedSubmissionAttachments(submissionId);
  };
  this.loadCollaborationEmail = function (emailId) {
    return collaborationEmailRepository.loadCollaborationEmail(emailId);
  };
  this.createCollaborationEmail = function () {
    return collaborationEmailRepository.createCollaborationEmail();
  };
  this.updateCollaborationEmail = function (email) {
    return updateCollaborationEmailRepository.updateCollaborationEmail(email);
  };
  this.deleteCollaborationEmail = function (emailId) {
    return deleteCollaborationEmailRepository.deleteCollaborationEmail(emailId);
  };
  this.sendCollaborationEmail = function (email) {
    return sendCollaborationEmailRepository.sendCollaborationEmail(email);
  };
  this.forwardEmail = function (emailId) {
    return forwardCollaborationEmailRepository.forward(emailId);
  };
  this.replyEmail = function (emailId) {
    return replyCollaborationEmailRepository.reply(emailId);
  };
  this.replyAllEmail = function (emailId) {
    return replyAllCollaborationEmailRepository.replyAll(emailId);
  };
  this.uploadAttachmentEmail = function (emailId, data, file) {
    return uploadAttachmentCollaborationEmailRepository.uploadAttachment(emailId, data, file);
  };
  this.createEmailCorrespondenceForm = function (submissionId) {
    return createCorrespondenceFormRepository.createEmailCorrespondenceForm(submissionId);
  };
  this.createCorrespondenceForm = function (submissionId) {
    return createCorrespondenceFormRepository.createCorrespondenceForm(submissionId);
  };
  this.generateLetter = function (submissionId, formId) {
    return createCorrespondenceFormRepository.generateLetter(submissionId, formId);
  };
  this.createCorrespondenceEmail = function (submissionId) {
    return createCorrespondenceEmailRepository.createCorrespondenceEmail(submissionId);
  };
  this.hideAllSharedCollaborationItem = function (submissionId) {
    return hideSharedCollaborationRepository.hideSharedCollaboration(submissionId);
  };
  this.getChatMessageList = function (submissionId) {
    return chatMessageListRepository.getChatMessageList(submissionId);
  };
  this.sendChatMessage = function (submissionId, chatMessage) {
    return sendChatMessageRepository.sendChatMessage(submissionId, chatMessage);
  };
  this.publishChatMessage = function (chatMessageId) {
    return publishChatMessageRepository.publishChatMessage(chatMessageId);
  };
  this.unpublishChatMessage = function (chatMessageId) {
    return unpublishChatMessageRepository.unpublishChatMessage(chatMessageId);
  };
  this.sendChatInvitation = function (submissionId, userIds, message) {
    return inviteChatRepository.sendChatInvitation(submissionId, userIds, message);
  };
};
CollaborationMediator.$inject = ["collaborationRepository", "collaborationNoteRepository", "collaborationLoadTaskRepository", "collaborationCreateTaskRepository", "collaborationUpdateTaskRepository", "collaborationDeleteTaskRepository", "collaborationNotifyTaskRepository", "loadSubmissionAttachmentsRepository", "collaborationEmailRepository", "deleteCollaborationNoteRepository", "updateCollaborationNoteRepository", "createCollaborationNoteRepository", "deleteCollaborationEmailRepository", "forwardCollaborationEmailRepository", "replyAllCollaborationEmailRepository", "replyCollaborationEmailRepository", "sendCollaborationEmailRepository", "updateCollaborationEmailRepository", "uploadAttachmentCollaborationEmailRepository", "createCorrespondenceFormRepository", "createCorrespondenceEmailRepository", "hideSharedCollaborationRepository", "chatMessageListRepository", "sendChatMessageRepository", "publishChatMessageRepository", "unpublishChatMessageRepository", "inviteChatRepository"];
angular.module('gw-um-submission').service('collaborationMediator', CollaborationMediator);

/***/ }),
/* 293 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationRepository = function CollaborationRepository(baseRepository, currentSubmissionModel) {
  angular.extend(this, baseRepository);
  this.loadCollaborationItems = function (submissionId, searchInput) {
    var url = '/rest/Submission/' + submissionId + '/CollaborationItem';
    if (searchInput) {
      url += '?search=' + encodeURIComponent(searchInput);
    } else {
      url += '?registrationIdentifier=/SubmissionCollaborationItem/' + submissionId;
    }
    if (!searchInput) {
      currentSubmissionModel.addRegistration(url);
    }
    return this.get(url);
  };
  this.refreshCollaborationAttachments = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/CollaborationItem/external';
    return this.get(url);
  };
};
CollaborationRepository.$inject = ["baseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('collaborationRepository', CollaborationRepository);

/***/ }),
/* 294 */
/***/ (function(module, exports) {

var path = '/collaboration/collaborationUserAvatar.tpl.html';
var html = "<div class=\"dockPanelUserCell\" ng-if=\"text\">\n    <span ui-translate>{{label}}</span>\n    <ui-user-avatar userid=\"{{userid}}\"\n                    email-message-id=\"{{emailId}}\"\n                    class=\"dockPanelUserAvatar\">\n    </ui-user-avatar>\n    <span class=\"dockPanelUserCellText\">{{text}}</span>\n    <span class=\"dockPanelUserCellSubText\" ng-if=\"sublabel\">{{sublabel}}</span>\n</div>\n\n<div class=\"toOrCcUserCell\" ng-if=\"toorccusers\">\n    <div>\n        <span ui-translate>{{label}}</span>\n    </div>\n    <div class=\"toOrCcUserList\" >\n        <div ng-repeat=\"user in toOrCcUserList\">\n            <div class=\"dockPanelUserCell\">\n                <ui-user-avatar userid=\"{{user.id}}\"\n                                email-message-id=\"{{emailId}}\"\n                                class=\"dockPanelUserAvatar\">\n                </ui-user-avatar>\n                <span class=\"dockPanelUserCellText\">{{getRecipientString(user)}}</span>\n\n            </div>\n        </div>\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 295 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationUserAvatarDirective = function CollaborationUserAvatarDirective(collaborationUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.$watch('toorccusers', function (newValue) {
      if (newValue) {
        $scope.toOrCcUserList = JSON.parse(newValue);
      }
    });
    $scope.getRecipientString = function (user) {
      if (user.emailAddress) {
        return collaborationUtil.getEmailIdentifierString(user.name, user.emailAddress);
      } else {
        return user;
      }
    };
  };
  return {
    restrict: 'E',
    scope: {
      label: '@',
      text: '@',
      userid: '@',
      toorccusers: '@',
      sublabel: '@',
      emailId: '@'
    },
    link: linkFunction,
    templateUrl: '/collaboration/collaborationUserAvatar.tpl.html'
  };
};
CollaborationUserAvatarDirective.$inject = ["collaborationUtil"];
angular.module('gw-um-submission').directive('collaborationUserAvatar', CollaborationUserAvatarDirective);

/***/ }),
/* 296 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollaborationUtil = function CollaborationUtil() {
  this.getEmailIdentifierString = function (name, emailAddress) {
    return "\"".concat(name, "\" <").concat(emailAddress, ">");
  };
};
angular.module('gw-um-submission').service('collaborationUtil', CollaborationUtil);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

var path = '/component/status/submissionStatus.tpl.html';
var html = "<div class=\"submissionStatusComponent\">\n\n    <div class=\"submissionNameContainer\">\n        <span class=\"submissionName\"\n                uib-tooltip=\"{{ $ctrl.submissionName}}\"\n                tooltip-append-to-body=\"true\"\n                tooltip-popup-delay=\"500\"\n                tooltip-placement=\"bottom\">{{ $ctrl.submissionName }}</span>\n    </div>\n\n    <!--Status-->\n    <div class=\"statusRow\">\n        <span class=\"statusLabel\">{{ $ctrl.i18n.customerSummary.status }}</span>\n        <span class=\"submissionStatusColumn\" >{{ $ctrl.submissionStatus }}</span>\n\n        <div class=\"customIcons\">\n            <ui-icon-viewer\n                item=\"$ctrl.submission\"></ui-icon-viewer>\n        </div>\n\n    </div>\n\n    <!--Reason-->\n    <div class=\"statusRow reasonContainer\"\n         ng-if=\"($ctrl.reason || $ctrl.renewalStatusReason) && $ctrl.isUnderwriter\"\n         uib-tooltip=\"{{ $ctrl.reason || $ctrl.renewalStatusReason}}\"\n         tooltip-append-to-body=\"true\"\n         tooltip-enable=\"{{ $ctrl.displayReasonStatus }}\"\n         tooltip-placement=\"bottom\">\n\n        <span class=\"statusLabel\">{{ $ctrl.i18n.customerSummary.reason }}</span>\n        <span class=\"statusReasonLabel\" >{{ $ctrl.reasonLabel }}</span>\n    </div>\n\n    <!--Detail-->\n    <div class=\"statusRow detailContainer\"\n         ng-if=\"($ctrl.detail || $ctrl.renewalStatusDetail) && $ctrl.isUnderwriter\"\n         uib-tooltip=\"{{ $ctrl.detail || $ctrl.renewalStatusDetail}}\"\n         tooltip-append-to-body=\"true\"\n         tooltip-enable=\"{{ $ctrl.displayDetailTooltip }}\"\n         tooltip-placement=\"bottom\">\n\n        <span class=\"statusLabel\">{{ $ctrl.i18n.customerSummary.detail }}</span>\n        <span class =\"statusDetail\">{{ $ctrl.detailLabel }}</span>\n\n        <span class =\"statusDetailFull\">{{ $ctrl.detail || $ctrl.renewalStatusDetail}}</span>\n    </div>\n\n    <!--Referral-->\n    <div class=\"statusRow referred\"\n         ng-if=\"$ctrl.showReferral()\">\n\n        <span class=\"statusLabel\">{{ $ctrl.i18n.customerSummary.referred }}</span>\n        <span>{{ $ctrl.referral }}</span>\n\n    </div>\n\n    <!--Modification Details-->\n    <div class=\"customerElement\"\n         ng-include=\"'/modification/detail/modificationDetail.tpl.html'\"\n         ng-controller=\"modificationDetailController\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

var SubmissionStatusComponent = {
  templateUrl: '/component/status/submissionStatus.tpl.html',
  controller: 'submissionStatusController',
  bindings: {}
};
angular.module('gw-um-submission').component('submissionStatus', SubmissionStatusComponent);

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(301);

/*@ngInject*/
var SubmissionStatusController = function SubmissionStatusController($scope, submissionConstant, appTypeConfigurationModel, submissionStatus, renewalStatus, submissionReferralStatus, currentSubmissionModel, agentQuoteStatus, submissionUploadStatus) {
  var _this = this;
  this.i18n = locale;
  this.submission = currentSubmissionModel.getCurrentSubmission();
  this.submissionName = '';
  this.isUnderwriter = appTypeConfigurationModel.isUnderwriterWorkstation();
  this.displayReasonStatus = false;
  this.reason = '';
  this.reasonLabel = '';
  this.renewalStatusReason = '';
  this.displayDetailTooltip = false;
  this.detail = '';
  this.detailLabel = '';
  this.renewalStatusDetail = '';
  this.referral = null;
  this.submission = currentSubmissionModel.getCurrentSubmission();
  this.$onInit = function () {
    if (!_.isNil(this.submission)) {
      this.configureSubmissionStatus();
    }
  };
  this.getStatusLabel = function () {
    var statusCode,
      status,
      statusLabelKey,
      subStatusLabel,
      isUploadStatus = this.submission.uploadStatus === submissionUploadStatus.UPLOAD_IN_PROGRESS || this.submission.uploadStatus === submissionUploadStatus.UPLOAD_PENDING || this.submission.uploadStatus === submissionUploadStatus.UPLOAD_SUCCEEDED;
    if (!_.isNil(this.submission)) {
      statusCode = this.submission.status ? this.submission.status : -1;
      statusLabelKey = this.isUnderwriter ? 'status.' : 'agentStatus.';
      status = _.get(this.i18n, statusLabelKey + statusCode);
      if (this.submission.renewalStatus > 0 || this.submission.cancellationPending || this.submission.endorsementPending) {
        subStatusLabel = this.getSubStatusLabel();
        if (!_.isNil(subStatusLabel)) {
          status += ' (' + this.getSubStatusLabel() + ')';
        }
      } else if (isUploadStatus && statusCode === submissionStatus.CREATED) {
        status = _.get(this.i18n, statusLabelKey + 'uploadStatus.' + this.submission.uploadStatus);
      }
    }
    return status;
  };
  this.getSubStatusLabel = function () {
    var status = this.submission.status,
      subStatusLabel;
    switch (status) {
      case submissionStatus.BOUND:
      case submissionStatus.PENDING_ISSUANCE:
      case submissionStatus.ISSUED:
      case submissionStatus.EXPIRED:
        if (this.submission.renewalStatus) {
          switch (this.submission.renewalStatus) {
            case renewalStatus.RENEWAL_PENDING:
            case renewalStatus.NON_RENEWAL_PENDING:
            case renewalStatus.FLAGGED_FOR_NON_RENEWAL:
              subStatusLabel = _.get(this.i18n, 'renewalStatus.' + this.submission.renewalStatus);
              if (this.submission.endorsementPending) {
                subStatusLabel += ', ' + _.get(this.i18n, 'subStatus.endorsementPending');
              }
              if (this.submission.cancellationPending) {
                subStatusLabel += ', ' + _.get(this.i18n, 'subStatus.cancellationPending');
              }
              break;
          }
        } else if (this.submission.endorsementPending && this.submission.cancellationPending) {
          subStatusLabel = _.get(this.i18n, 'subStatus.endorsementPending') + ', ' + _.get(this.i18n, 'subStatus.cancellationPending');
        } else if (this.submission.cancellationPending) {
          subStatusLabel = _.get(this.i18n, 'subStatus.cancellationPending');
        } else if (this.submission.endorsementPending) {
          subStatusLabel = _.get(this.i18n, 'subStatus.endorsementPending');
        }
    }
    return subStatusLabel;
  };
  this.configureSubmissionStatus = function () {
    this.submissionName = _.get(this.submission, 'insured.name');
    this.submissionStatus = this.getStatusLabel();
    this.reason = this.submission.statusReason;
    this.renewalStatusReason = this.submission.renewalStatusReason;
    this.reasonLabel = _.truncate(this.reason || this.renewalStatusReason, {
      'length': 45,
      'separator': ' '
    });
    this.displayReasonStatus = (this.reason || this.renewalStatusReason) !== this.reasonLabel;
    this.detail = this.submission.statusDetail;
    this.renewalStatusDetail = this.submission.renewalStatusDetail;
    this.detailLabel = _.truncate(this.detail || this.renewalStatusDetail, {
      'length': 45,
      'separator': ' '
    });
    this.displayDetailTooltip = this.detailLabel.slice(this.detailLabel.length - 3, this.detailLabel.length) === '...';
    if (submissionReferralStatus.REFER === this.submission.referralStatus) {
      this.referral = _.get(this.submission, 'referredUnderwriterSummary.name');
    } else {
      this.referral = null;
    }
  };
  $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function (event, currentSubmission) {
    _this.submission = currentSubmission;
    if (!_.isNil(_this.submission)) {
      _this.configureSubmissionStatus();
    }
  });
  $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
    if (_.isNil(_this.submission) || _this.submission.id === submission.id) {
      _this.submission = submission;
    }
    if (!_.isNil(_this.submission)) {
      _this.configureSubmissionStatus();
    }
  });
  this.showReferral = function () {
    var isNotAgentConsole = !appTypeConfigurationModel.isAgentConsole(),
      agentQuotingEnabled = this.submission.agentQuoteStatus === agentQuoteStatus.ENABLED,
      notAgentConsoleOrSTP = isNotAgentConsole || agentQuotingEnabled;
    return !_.isNil(this.referral) && notAgentConsoleOrSTP;
  };
};
SubmissionStatusController.$inject = ["$scope", "submissionConstant", "appTypeConfigurationModel", "submissionStatus", "renewalStatus", "submissionReferralStatus", "currentSubmissionModel", "agentQuoteStatus", "submissionUploadStatus"];
angular.module('gw-um-submission').controller('submissionStatusController', SubmissionStatusController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 301 */
/***/ (function(module) {

module.exports = JSON.parse("{\"status\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Not Clear\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Rejected\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}},\"agentStatus\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Clearance Review\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Incomplete\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}},\"renewalStatus\":{\"1\":\"Renewal Pending\",\"3\":\"Non-Renewal Pending\",\"4\":\"Flagged for Non-Renewal\"},\"subStatus\":{\"cancellationPending\":\"Cancellation Pending\",\"endorsementPending\":\"Endorsement Pending\"},\"customerSummary\":{\"detail\":\"Detail: \",\"reason\":\"Reason: \",\"referred\":\"Referred to: \",\"status\":\"Status: \"}}");

/***/ }),
/* 302 */
/***/ (function(module, exports) {

var path = '/content/accountSubmissionsGrid/accountSubmissions.tpl.html';
var html = "<div class=\"accountSubmissionsContent\">\n\n    <div class=\"gridTypeLabelContainer\">\n        <span class=\"gridTypeLabel\">{{ i18n.submissions }}</span>\n    </div>\n\n    <ui-account-submissions-grid class=\"uiAccountSubmissionsGrid\"\n                                 is-column-filter-visible=\"true\"\n                                 is-grid-filter-visible=\"false\"\n                                 is-view-active-visible=\"false\"\n                                 is-search-visible=\"false\"\n                                 is-grid-paging-visible=\"false\"\n                                 is-show-checkboxes=\"true\"\n                                 grid-columns-preference=\"'system.accountSubmissionsGridColumns'\"\n                                 on-selected-submissions-changed=\"onSelectedSubmissionsChanged(items)\"\n                                 do-policies-exist-on-submissions=\"doPoliciesExistOnSubmissions(doPoliciesExist)\">\n    </ui-account-submissions-grid>\n\n    <div class=\"gridTypeLabelContainer\"\n         ng-if=\"doPoliciesExist\">\n        <span class=\"gridTypeLabel\">{{ i18n.policies }}</span>\n        <span class=\"gridTypeSubLabel\">{{getSelectedSubmissionText()}}</span>\n    </div>\n\n\n    <div class=\"policiesSummaryContent\"\n        ng-if=\"doPoliciesExist\">\n        <ui-policies-summary-grid class=\"uiPoliciesSummaryGrid\"\n                                  is-column-filter-visible=\"false\"\n                                  is-grid-filter-visible=\"false\"\n                                  is-view-active-visible=\"false\"\n                                  is-search-visible=\"false\"\n                                  is-grid-paging-visible=\"false\"\n                                  selected-submission-ids=\"selectedSubmissionIds\"\n                                  grid-columns-preference=\"'system.submissionPolicyGridColumns'\"></ui-policies-summary-grid>\n        <grid-totals class=\"policyTotalsGrid\"\n                     ng-if=\"showTotals()\"\n                     total-data=\"totalData\"\n                     col-view-model=\"colViewModel\"></grid-totals>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(89);

/*@ngInject*/
var AccountSubmissionsController = function AccountSubmissionsController($scope, $filter, $timeout, currencyUtil, gridColumnModel, submissionMediator) {
  $scope.i18n = locale;
  $scope.selectedSubmissionIds = [];
  $scope.totalData = {};
  var none = _.get($scope.i18n, 'none'),
    submissionsSelected = _.get($scope.i18n, 'submissionsSelected');
  $scope.getSelectedSubmissionText = function () {
    var prefix = none;
    if ($scope.selectedSubmissionIds.length > 0) {
      prefix = $scope.selectedSubmissionIds.length;
    }
    if ($scope.selectedSubmissionIds.length === 1) {
      submissionsSelected = _.get($scope.i18n, 'submissionSelected');
    } else {
      submissionsSelected = _.get($scope.i18n, 'submissionsSelected');
    }
    return prefix + ' ' + submissionsSelected;
  };
  $scope.onSelectedSubmissionsChanged = _.debounce(function (selectedSubmissionIds) {
    var added = _.difference($scope.selectedSubmissionIds, selectedSubmissionIds),
      removed = _.difference(selectedSubmissionIds, $scope.selectedSubmissionIds);
    if (added.length > 0 || removed.length > 0) {
      $scope.selectedSubmissionIds = selectedSubmissionIds;
      populateTotalData();
    }
  }, 500);
  $scope.doPoliciesExistOnSubmissions = function (doPoliciesExist) {
    $scope.doPoliciesExist = doPoliciesExist;
  };
  $scope.showTotals = function () {
    return !_.isEmpty($scope.totalData);
  };
  function populateTotalData() {
    var unroundedEarnedPremiumTotal = 0;
    $scope.colViewModel = {};
    submissionMediator.loadPoliciesBySubmissionIds($scope.selectedSubmissionIds).then(function (policySummaries) {
      $scope.totalData = {};
      if (policySummaries.length > 0) {
        $scope.totalData = {
          'totalPremium.total': 0,
          'earnedPremium.total': 0,
          numberOfClaims: 0,
          incurredLosses: 0,
          lossRatio: 0
        };
        _.each(policySummaries, function (policySummary) {
          $scope.totalData['totalPremium.total'] += _.round(policySummary.totalPremium.roundedTotal);
          $scope.totalData['earnedPremium.total'] += _.round(policySummary.earnedPremium.roundedTotal);
          unroundedEarnedPremiumTotal += policySummary.earnedPremium.total;
          if (policySummary.numberOfClaims) {
            $scope.totalData.numberOfClaims += policySummary.numberOfClaims;
          }
          if (policySummary.incurredLosses) {
            $scope.totalData.incurredLosses += policySummary.incurredLosses.amount;
          }
        });
        var format = currencyUtil.getCurrencyFormat(policySummaries[0].totalPremium.currencyCode);
        if (unroundedEarnedPremiumTotal > 0) {
          $scope.totalData.lossRatio = _.round($scope.totalData.incurredLosses / unroundedEarnedPremiumTotal * 100, 2) + '%';
        }
        $scope.totalData['totalPremium.total'] = $filter('currency')($scope.totalData['totalPremium.total'], format.symbol, 0, format.suffixSymbol, format.customFormat);
        $scope.totalData['earnedPremium.total'] = $filter('currency')($scope.totalData['earnedPremium.total'], format.symbol, 0, format.suffixSymbol, format.customFormat);
        $scope.totalData.incurredLosses = $filter('currency')($scope.totalData.incurredLosses, format.symbol, 0, format.suffixSymbol, format.customFormat);
        gridColumnModel.setColumnPreference('system.submissionPolicyGridColumns');
        $scope.totalData.numberOfClaims = '' + $scope.totalData.numberOfClaims;
        $scope.colViewModel = gridColumnModel.getPoliciesGridColumns();
      }
    });
  }
};
AccountSubmissionsController.$inject = ["$scope", "$filter", "$timeout", "currencyUtil", "gridColumnModel", "submissionMediator"];
angular.module('gw-um-submission').controller('accountSubmissionsController', AccountSubmissionsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

var path = '/content/accountSubmissionsGrid/accountSubmissionsGrid.tpl.html';
var html = "<div class=\"col columnFilterCol myfilter\"\n     ng-if=\"$ctrl.isColumnFilterVisible\">\n    <div class=\"columnFilter\"\n         uib-dropdown\n         dropdown-append-to-body>\n\n        <a uib-dropdown-toggle\n           ng-click=\"$ctrl.isColSelectDropdownOpen = !$ctrl.isColSelectDropdownOpen\">\n                                    <span class=\"icon columnFilterIcon glyphicon glyphicon-plus-sign\"\n                                          uib-tooltip=\"{{ $ctrl.i18n.columnFilterIconTooltip }}\"\n                                          tooltip-popup-delay=\"500\"\n                                          tooltip-append-to-body=\"true\"\n                                          tooltip-placement=\"left\"></span>\n        </a>\n        <ul class=\"dropdown-menu-right accountSubmissionsDropDown\"\n            uib-dropdown-menu>\n            <li ng-repeat=\"col in $ctrl.dropdownColumns\"\n                ng-click='$ctrl.onColumnCheckboxClick($event, col)'>\n\n                <input type=\"checkbox\"\n                       ng-model=\"col.visible\"\n                       ng-change='$ctrl.onColumnCheckboxClick($event, col)'\n                       ng-disabled=\"col.disabled\"/>&nbsp; {{ col.displayName }}\n            </li>\n        </ul>\n    </div>\n</div>\n<div class=\"accountSubmissionsGrid\">\n\n    <div class=\"submissionGridContainer\">\n\n        <div class=\"landing gridWindow\" app-mode-configuration>\n            <div class=\"landingHeader\">\n\n                <div class=\"landingTitle\"\n                     ng-if=\"$ctrl.isGridFilterVisible\"\n                     uib-dropdown>\n\n                    <button class=\"btn-link activeFilter\"\n                            uib-dropdown-toggle>\n                        <span>{{ $ctrl.selectedFilterName }}</span>\n                        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                    </button>\n                    <ul uib-dropdown-menu>\n                        <li ng-repeat=\"filter in $ctrl.filters\"\n                            ng-click='$ctrl.onFilterChange(filter)'><a>{{filter.name}}</a></li>\n                    </ul>\n                </div>\n\n                <div class=\"submissionFilter\"\n                     ng-if=\"$ctrl.isViewActiveVisible\">\n                    <label>\n                        <input type=\"checkbox\"\n                               ng-checked=\"viewModel.viewActiveOnlyCheckBox\"\n                               ng-model=\"viewModel.viewActiveOnlyCheckBox\"\n                               ng-change=\"onViewAciveOnlyCheckboxChange()\"\n                               ng-disabled=\"!viewModel.viewActiveOnlyCheckBoxEnabled\">\n                        <span>{{ $ctrl.i18n.viewActiveOnly }}</span>\n                    </label>\n                </div>\n\n                <div class=\"submissionSearch has-feedback\"\n                     ng-if=\"$ctrl.isSearchVisible\">\n                    <input type=\"search\"\n                           ng-model=\"viewModel.requestParams.searchString\"\n                           ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                           class=\"form-control\"\n                           ng-change=\"onSearchInputChange()\"\n                           placeholder=\"{{ viewModel.searchPlaceholder }}\"/>\n                    <span ng-if=\"viewModel.requestParams.searchString === ''\"\n                          class=\"glyphicon glyphicon-search form-control-feedback\"></span>\n\n                    <span ng-if=\"viewModel.requestParams.searchString !== ''\"\n                          ng-click='onClearSearchText()'\n                          class=\"glyphicon glyphicon-remove form-control-feedback \"></span>\n                </div>\n            </div>\n\n            <!--Grid-->\n            <div class=\"content landingContent\"\n                 ui-widget-grid-scroll-manager\n                 ui-scroll-detection\n                 scroll-fixed-grid-arrow>\n\n                <!--Grid Header-->\n                <div class=\"columnHeader\">\n                    <div class=\"columnRow columnDisposition\">\n\n                        <div ng-if=\"$ctrl.isShowCheckboxes && $ctrl.showCheckboxes()\"\n                             class=\"checkBoxContainer col\">\n                            <input type=\"checkbox\"\n                                   ng-change=\"$ctrl.selectAllCheckBoxes()\"\n                                   ng-model=\"$ctrl.allCheckBoxesSelected\">\n                        </div>\n\n                        <div class=\"colInsuredName insuredName\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"insured.name\"\n                             item-label=\"homePage.grid.header.insured\"\n                             ng-if=\"$ctrl.colViewModel.colInsuredName\"></div>\n\n                        <div class=\"colNumber submissionNumber\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"submissionNumber\"\n                             item-label=\"homePage.grid.header.submission\"\n                             ng-if=\"$ctrl.colViewModel.colSubmissionNumber\"></div>\n\n                        <div class=\"colStatus status\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"status\"\n                             item-label=\"homePage.grid.header.status\"\n                             ng-if=\"$ctrl.colViewModel.colStatus\"></div>\n\n                        <div class=\"colStatusReason statusReason\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"statusReason\"\n                             item-label=\"homePage.grid.header.statusReason\"\n                             ng-if=\"$ctrl.colViewModel.colStatusReason\"></div>\n\n                        <div class=\"colDate effectiveDate\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"effectiveDate\"\n                             item-label=\"homePage.grid.header.effective\"\n                             ng-if=\"$ctrl.colViewModel.colEffectiveDate\"></div>\n\n                        <div class=\"colDate expirationDate\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"expirationDate\"\n                             item-label=\"homePage.grid.header.expiration\"\n                             ng-if=\"$ctrl.colViewModel.colExpirationDate\"></div>\n\n                        <div class=\"colPremium premium\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"totalPremium.total\"\n                             item-label=\"homePage.grid.header.premium\"\n                             ng-if=\"$ctrl.colViewModel.colPremium\"></div>\n\n                        <div class=\"colDefault nextAction\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"nextTask.definition\"\n                             item-label=\"homePage.grid.header.nextAction\"\n                             ng-if=\"$ctrl.colViewModel.colNextAction\"></div>\n\n                        <div class=\"colDefault actionDate\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"nextTask.dueDate\"\n                             item-label=\"homePage.grid.header.actionDate\"\n                             ng-if=\"$ctrl.colViewModel.colActionDate\"></div>\n\n                        <div class=\"colDefault assignedTo\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"assignedUnderwriter.name\"\n                             item-label=\"homePage.grid.header.assignedTo\"\n                             ng-if=\"$ctrl.colViewModel.colAssignedTo\"></div>\n\n                        <div class=\"colDefault underwriter\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"responsibleUnderwriter.name\"\n                             item-label=\"homePage.grid.header.underwriter\"\n                             ng-if=\"$ctrl.colViewModel.colUnderwriter\"></div>\n\n                        <div class=\"colDefault coverage\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"productShortNames\"\n                             item-label=\"homePage.grid.header.coverage\"\n                             ng-if=\"$ctrl.colViewModel.colCoverage\"></div>\n\n                        <div class=\"colDefault agency\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"agency\"\n                             item-label=\"homePage.grid.header.agency\"\n                             ng-if=\"$ctrl.colViewModel.colAgency\"></div>\n\n                        <div class=\"colDefault receivedDate\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"receivedDate\"\n                             item-label=\"homePage.grid.header.receivedDate\"\n                             ng-if=\"$ctrl.colViewModel.colReceivedDate\"></div>\n\n                        <div class=\"colDefault priority\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"priority\"\n                             item-label=\"homePage.grid.header.priority\"\n                             ng-if=\"$ctrl.colViewModel.colPriority\"></div>\n\n                        <div class=\"colDefault riskState\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"riskState\"\n                             item-label=\"homePage.grid.header.riskState\"\n                             ng-if=\"$ctrl.colViewModel.colRiskState\"></div>\n\n                        <div class=\"colDefault totalLimit\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"totalLimit\"\n                             item-label=\"homePage.grid.header.totalLimit\"\n                             ng-if=\"$ctrl.colViewModel.colTotalLimit\"></div>\n\n                        <div class=\"colNameOfObligation nameOfObligation\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"obligationName\"\n                             item-label=\"homePage.grid.header.nameOfObligation\"\n                             ng-if=\"$ctrl.colViewModel.colNameOfObligation\"></div>\n\n                        <div class=\"colNeededByDate quoteNeededByDate\"\n                             ui-grid-sortable-header\n                             request-params=\"$ctrl.requestParams\"\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"quoteNeededByDate\"\n                             item-label=\"homePage.grid.header.quoteNeededByDate\"\n                             ng-if=\"$ctrl.colViewModel.colQuoteNeededByDate\"></div>\n\n\n\n                        <div class=\"col scrollBar\"></div>\n                    </div>\n                </div>\n\n\n                <div class=\"scrollVerticalContainer\">\n                    <div class=\"datagrid table\"\n                         ux-datagrid=\"$ctrl.records\"\n                         ng-if=\"!$ctrl.isLoading\">\n\n                        <script type=\"template/html\"\n                                data-template-item=\"item\"\n                                data-template-name=\"default\">\n\n                            <div class=\"rowDrawerWrapper\"\n                                 ng-class=\"{\n                                    selected: item.selected && $ctrl.isDrawerOpen,\n                                    activeSubmission: $ctrl.selectedSubmissionId === item.id\n                                    }\">\n\n                                <div class=\"columnRow\"\n                                     ng-class=\"{ selected: item.selected }\"\n                                     ng-click=\"$ctrl.setSelectedItem($event, item)\">\n\n                                    <div ng-if=\"$ctrl.isShowCheckboxes && $ctrl.showCheckboxes()\"\n                                         class=\"checkBoxContainer col\">\n                                        <input type=\"checkbox\"\n                                               ng-if=\"$ctrl.isShowCheckBox(item)\"\n                                               ng-model=\"item.checkboxSelected\"\n                                               ng-change=\"$ctrl.setSelectedCheckboxItem($event, item)\">\n                                    </div>\n\n                                    <div class=\"col colInsuredName InsuredName\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         uib-tooltip=\"{{item.insured.name}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isInsuredTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isInsuredTooltip\"\n                                         ng-if=\"$ctrl.colViewModel.colInsuredName\">\n                                        {{ item.insured.name }}\n                                        <ui-icon-viewer\n                                            item=\"item\"\n                                            user-id=\"$ctrl.userId\"></ui-icon-viewer>\n                                    </div>\n                                    <div class=\"col colNumber SubmissionNumber\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colSubmissionNumber\"\n                                         uib-tooltip=\"{{item.policyNumber || item.submissionNumber}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isSubmissionNumberTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isSubmissionNumberTooltip\">\n                                        {{ item.policyNumber || item.submissionNumber }}\n                                    </div>\n                                    <div class=\"col colStatus Status\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colStatus\"\n                                         uib-tooltip=\"{{$ctrl.getStatus(item)}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isStatusTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isStatusTooltip\">\n                                        {{$ctrl.getStatus(item)}}\n                                    </div>\n                                    <div class=\"col colStatusReason StatusReason\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colStatusReason\"\n                                         uib-tooltip=\"{{item.statusReason}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isStatusReasonTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isStatusReasonTooltip\">\n                                        {{item.statusReason}}\n                                    </div>\n                                    <div class=\"col colDate EffectiveDate\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colEffectiveDate\">\n                                        {{ item.effectiveDate | utcDateFilter: $ctrl.shortDateFormat }}\n                                    </div>\n                                    <div class=\"col colDate ExpirationDate\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colExpirationDate\">\n                                        {{ item.expirationDate | utcDateFilter: $ctrl.shortDateFormat }}\n                                    </div>\n                                    <div class=\"col colPremium Premium\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colPremium\">\n                                    <span ng-if=\"item.totalPremium.total\">\n                                        {{ item.totalPremium.total | currency:item.currencyFormat.symbol:0:item.currencyFormat.suffixSymbol:item.currencyFormat.customFormat }}\n                                    </span>\n                                    </div>\n                                    <div class=\"col colDefault NextAction\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colNextAction\"\n                                         uib-tooltip=\"{{item.nextTaskSummary.definition}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isNextActionTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isNextActionTooltip\">\n                                        {{ item.nextTaskSummary.definition }}\n                                    </div>\n                                    <div class=\"col colDefault ActionDate\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colActionDate\">\n                                        {{ item.nextTaskSummary.dueDate | utcDateFilter: $ctrl.shortDateFormat }}\n                                    </div>\n                                    <div class=\"col colDefault AssignedTo\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colAssignedTo\"\n                                         uib-tooltip=\"{{item.assignedUnderwriterSummary.name}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isAssignedToTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isAssignedToTooltip\">\n                                        {{ item.assignedUnderwriterSummary.name }}\n                                    </div>\n                                    <div class=\"col colDefault Underwriter\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colUnderwriter\"\n                                         uib-tooltip=\"{{item.responsibleUnderwriterSummary.name}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isUnderwriterTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isUnderwriterTooltip\">\n                                        {{ item.responsibleUnderwriterSummary.name }}\n                                    </div>\n                                    <div class=\"col colDefault ProductShortNames\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         uib-tooltip=\"{{item.productShortNames}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isProductTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isProductTooltip\"\n                                         ng-if=\"$ctrl.colViewModel.colCoverage\">\n                                        {{ item.productShortNames }}\n                                    </div>\n                                    <div class=\"col colDefault Agency\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         uib-tooltip=\"{{item.agencyName}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{item.isAgencyTooltip}}\"\n                                         ui-is-tooltip-enabled=\"item.isAgencyTooltip\"\n                                         ng-if=\"$ctrl.colViewModel.colAgency\">\n                                        {{ item.agencyName }}\n                                    </div>\n                                    <div class=\"col colDefault ReceivedDate\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colReceivedDate\">\n                                        {{ item.receivedDate | utcDateFilter: $ctrl.shortDateFormat }}\n                                    </div>\n                                    <div class=\"col colDefault priority\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colPriority\">\n                                          <span class=\"glyphicon\"\n                                                ng-class=\"{'glyphicon-arrow-down' : item.priority===1,\n                                                            'glyphicon-minus' : item.priority===2,\n                                                            'glyphicon-arrow-up' : item.priority===3\n                                                        }\"></span>\n                                    </div>\n                                    <div class=\"col colDefault\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colRiskState\">\n                                        {{ item.riskState }}\n                                    </div>\n                                    <div class=\"col colDefault\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colTotalLimit\">\n                                        {{ item.totalLimit }}\n                                    </div>\n                                    <div class=\"col colNameOfObligation\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colNameOfObligation\">\n                                        {{ item.obligationName }}\n                                    </div>\n                                    <div class=\"col colNeededByDate\"\n                                         ng-click=\"$ctrl.openSubmission(item)\"\n                                         ng-if=\"$ctrl.colViewModel.colQuoteNeededByDate\">\n                                        {{ item.quoteNeededByDate | utcDateFilter: $ctrl.shortDateFormat }}\n                                    </div>\n\n                                    <div class=\"col columnFilterCol\"\n                                         ng-if=\"$ctrl.isColumnFilterVisible\"></div>\n                                </div>\n\n                                <div class=\"toggleDrawer\"\n                                     ng-click=\"$ctrl.setSelectedItem($event, item)\">\n                                    <span class=\"glyphicon glyphicon-chevron-right\"></span>\n                                </div>\n\n                                <submission-details-drawer-directive\n                                    item-model=\"item\"\n                                    col-view-model=\"$ctrl.colViewModel\"\n                                    is-agent=\"$ctrl.isAgent\"></submission-details-drawer-directive>\n\n                            </div>\n\n                        </script>\n                    </div>\n\n                    <div class=\"gridEmpty\"\n                         ng-if=\"$ctrl.isGridEmpty && !$ctrl.isLoading\">{{ $ctrl.i18n.emptyMessage }}\n                    </div>\n\n                </div>\n\n                <div class=\"icon-spinner\"\n                     ng-if=\"$ctrl.isLoading\"></div>\n            </div>\n\n            <ui-grid-paging-component\n                ng-hide=\"$ctrl.totalRecords === 0\"\n                class=\"landingPagination\"\n                start-index=\"$ctrl.requestParams.startIndex\"\n                page-size=\"$ctrl.requestParams.pageSize\"\n                total-records=\"$ctrl.totalRecords\"\n                record-count-text=\"$ctrl.recordCountText\"\n                records-count-text=\"$ctrl.recordsCountText\"\n                on-change=\"$ctrl.onPagingChange($event, params)\"></ui-grid-paging-component>\n        </div>\n\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 306 */
/***/ (function(module, exports) {

var AccountSubmissionsGridComponent = {
  templateUrl: '/content/accountSubmissionsGrid/accountSubmissionsGrid.tpl.html',
  controller: 'accountSubmissionsGridController',
  bindings: {
    isColumnFilterVisible: '<?',
    isGridFilterVisible: '<?',
    isViewActiveVisible: '<?',
    isSearchVisible: '<?',
    isGridPagingVisible: '<?',
    isGridInteractable: '<?',
    accountId: '<',
    accountNumber: '<',
    isShowCheckboxes: '<?',
    gridColumnsPreference: '<?',
    onSelectedSubmissionsChanged: '&',
    doPoliciesExistOnSubmissions: '&'
  }
};
angular.module('gw-um-submission').component('uiAccountSubmissionsGrid', AccountSubmissionsGridComponent);

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {var locale = __webpack_require__(89);

/*@ngInject*/
var AccountSubmissionsGridController = function AccountSubmissionsGridController($scope, $controller, $stateParams, $state, $rootScope, advancedFilterType, appTypeConfigurationModel, coreConstant, landingConstant, submissionGridConstant, gridColumnModel, persistentConnection, submissionMediator) {
  angular.extend(this, $controller('baseSubmissionGridController', {
    $scope: $scope
  }));
  var accountSubmissionParams = {
    key: 'effectiveDate',
    startIndex: 0,
    pageSize: 25,
    sortType: 'asc',
    searchString: '',
    filterUri: ''
  };
  this.i18n = locale;
  this.isColumnFilterVisible = true;
  this.isGridFilterVisible = false;
  this.isViewActiveVisible = true;
  this.isSearchVisible = true;
  this.isGridPagingVisible = true;
  this.isGridInteractable = true;
  this.selectedSubmissionId = parseInt($stateParams.submissionId);
  this.advancedFilterType = advancedFilterType.ACCOUNT_SUBMISSIONS_GRID;
  this.$onInit = function () {
    if (this.gridColumnsPreference) {
      this.columnPreference = this.gridColumnsPreference;
    } else {
      this.columnPreference = this.isAgent ? 'system.accountOverviewSubmissionColumnsForAgent' : 'system.accountOverviewSubmissionColumnsForUnderwriter';
    }
    this.initSubmissionGrid();
  };
  this.updateFilterFromPreferences = function () {
    $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
  };
  this.onPagingChange = function ($event, params) {
    this.requestParams.pageSize = params.pageSize;
    this.requestParams.startIndex = params.startIndex;
    this.loadGrid();
  };
  this.loadRecords = function (onSuccess, onError) {
    this.accountId = this.accountId || $stateParams.accountId;
    submissionMediator.loadAccountSubmissions(this.accountId, this.accountNumber, this.requestParams).then(function (records) {
      onSuccess(records);
      this.selectAllCheckBoxes();
    }.bind(this), onError);
  };
  this.areAllRecordsSelected = function () {
    var allSelected = true;
    _.each(this.records, function (record) {
      if (this.isShowCheckBox(record) && !record.checkboxSelected) {
        allSelected = false;
      }
    }.bind(this));
    return allSelected;
  };
  this.selectAllCheckBoxes = function () {
    var allSelected = this.areAllRecordsSelected();
    _.each(this.records, function (record) {
      if (this.isShowCheckBox(record)) {
        this.doPoliciesExistOnSubmissions({
          doPoliciesExist: true
        });
        record.checkboxSelected = !allSelected;
        this.setSelectedCheckboxItem(null, record);
      }
    }.bind(this));
  };
  this.setFilterParams = function (filterParams) {
    accountSubmissionParams = filterParams;
    $rootScope.$broadcast(coreConstant.event.SUBMISSION_FILTER_CHANGED, filterParams);
  };
  this.getFilterParams = function () {
    return accountSubmissionParams;
  };
  this.resetParams = function (params) {
    accountSubmissionParams = params;
  };
  this.openSubmission = _.debounce(function (submission) {
    if (this.isGridInteractable) {
      if (!_.isNil(submission.id) && submission.id > 0) {
        if (submission.id === parseInt($stateParams.submissionId)) {
          return;
        }
        if (this.isColSelectDropdownOpen) {
          $scope.updateDropdownClosed();
          return;
        }
        if (!this.isSearchOpen) {
          gridColumnModel.setOpenFilterUri(null);
        }
        var submissionId = submission.id,
          params = {
            submissionId: submissionId
          },
          stateName = 'submission.form';
        this.isLoading = true;
        $state.go(stateName, params);
      }
    }
  }.bind(this), 200, {
    leading: true
  });
  this.setSelectedCheckboxItem = function (event) {
    if (this.isGridInteractable) {
      this.selectedSubmissionIds = [];
      _.forEach(this.records, function (item) {
        if (item.checkboxSelected) {
          this.selectedSubmissionIds.push(item.id);
        }
      }.bind(this));
      if (event) {
        event.stopPropagation();
      }
      this.allCheckBoxesSelected = this.areAllRecordsSelected();
      this.onSelectedSubmissionsChanged({
        items: this.selectedSubmissionIds
      });
    }
  }.bind(this);
  this.setSelectedItem = function (event, selectedItem) {
    if (this.isGridInteractable) {
      $scope.$broadcast(submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER);
      if (selectedItem.selected) {
        selectedItem.selected = false;
        this.isDrawerOpen = false;
        return;
      }
      if ($(event.currentTarget).hasClass('toggleDrawer')) {
        this.isDrawerOpen = true;
      }
      _.forEach(this.records, function (item) {
        item.selected = item === selectedItem;
      });
      if (!_.isNil(selectedItem.id) && selectedItem.id > 0) {
        $scope.$broadcast(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER);
      }
    }
  }.bind(this);
  this.showCheckboxes = function () {
    var showCheckboxes = false;
    _.each(this.records, function (record) {
      if (this.isShowCheckBox(record)) {
        showCheckboxes = true;
      }
    }.bind(this));
    return showCheckboxes;
  };
  this.isShowCheckBox = function (submission) {
    return this.isShowCheckboxes && submission.policyNumber && submission.id;
  };
  this.getStatus = function (item) {
    return _.get(this.i18n, 'status.' + item.status);
  };
  $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function () {
    this.updateColumnsFromPreferences();
    this.resetGridColumns();
  }.bind(this));
  $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, params) {
    this.resetParams(params);
    if (this.isLoaded) {
      this.loadGrid();
    }
  }.bind(this));
  $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
    persistentConnection.connect().then(function () {
      this.isUserTypeUpdated = true;
      this.isAgent = appTypeConfigurationModel.isAgentConsole();
      this.initLandingPage();
    }.bind(this));
  }.bind(this));
  $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
};
AccountSubmissionsGridController.$inject = ["$scope", "$controller", "$stateParams", "$state", "$rootScope", "advancedFilterType", "appTypeConfigurationModel", "coreConstant", "landingConstant", "submissionGridConstant", "gridColumnModel", "persistentConnection", "submissionMediator"];
angular.module('gw-um-submission').controller('accountSubmissionsGridController', AccountSubmissionsGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 308 */
/***/ (function(module, exports) {

/*@ngInject*/
var AccountSubmissionsGridRepository = function AccountSubmissionsGridRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadSubmissions = function (accountId, accountNumber, submissionParams) {
    var url = '/rest/Account/submissions',
      config = {
        params: {
          accountId: accountId,
          accountNumber: accountNumber,
          sortBy: submissionParams.key,
          sortDirection: submissionParams.sortType,
          startIndex: submissionParams.startIndex,
          numberOfRows: submissionParams.pageSize
        }
      };
    return this.get(url, config);
  };
};
AccountSubmissionsGridRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('accountSubmissionsGridRepository', AccountSubmissionsGridRepository);

/***/ }),
/* 309 */
/***/ (function(module, exports) {

var path = '/content/document/document.tpl.html';
var html = "<div class=\"attachmentViewer\"\n     ng-if=\"viewModel.isHTMLDocument\">\n    <content-iframe iframe-src=\"viewModel.attachmentLinkURL\"\n                    display-controls=\"false\">\n</div>\n\n<div class=\"attachmentViewer\"\n     ng-if=\"!viewModel.isHTMLDocument\">\n    <attachment-viewer class=\"attachmentViewerDirective\"\n                       attachment-id=\"{{ viewModel.attachmentId }}\">\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DocumentController = function DocumentController($scope, $stateParams, $rootScope, coreConstant, attachmentMediator, uiPerformanceLoggerConstant, attachmentUtil, formViewerConstant) {
  $scope.viewModel = {
    attachmentId: '',
    attachmentName: '',
    isHTMLDocument: false,
    attachmentLinkURL: ''
  };
  attachmentMediator.retrieveAttachment($stateParams.attachmentId).then(function (attachment) {
    var att = attachment.Attachment;
    $scope.viewModel.attachmentName = att.name;
    $scope.viewModel.attachmentId = att.id;
    $scope.viewModel.isHTMLDocument = _.endsWith(att.name, '.html') || _.endsWith(att.name, '.htm');
    attachmentUtil.getAttachmentLinkURL(att.id, att.name).then(function (url) {
      $scope.viewModel.attachmentLinkURL = url;
    });
    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SHOW_DOCUMENT, coreConstant.uiPeformanceLogger.SUCCESS);
    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GET_RATE, coreConstant.uiPeformanceLogger.SUCCESS);
    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.REQUEST_BINDING, coreConstant.uiPeformanceLogger.SUCCESS);
    $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED);
    $rootScope.$broadcast(formViewerConstant.event.FORM_LAZY_RENDERING_END);
  });
};
DocumentController.$inject = ["$scope", "$stateParams", "$rootScope", "coreConstant", "attachmentMediator", "uiPerformanceLoggerConstant", "attachmentUtil", "formViewerConstant"];
angular.module('gw-um-submission').controller('documentController', DocumentController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var ContentIframeDirective = function ContentIframeDirective($sce, $window) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var iframe = $('.iframe'),
      iframeElem = $('.iframe')[0],
      contentIframe = $('.contentIframe');
    $scope.viewModel = {
      iframeSrc: $sce.trustAsResourceUrl($scope.iframeSrc),
      popoutUrl: $sce.trustAsResourceUrl($scope.popoutUrl),
      displayControls: !_.isUndefined($scope.displayControls) ? $scope.displayControls : true
    };
    $scope.refreshIframe = function () {
      iframeElem.src = $scope.viewModel.iframeSrc;
    };
    $scope.openExternal = function () {
      $window.open($scope.viewModel.popoutUrl, '_blank');
    };
    if ($scope.iframeSrc) {
      // For Internet Explorer, we need to manipulate the attribute
      // of the iframe directly to get it to display nicely.
      if (contentIframe.hasClass('ie')) {
        iframe.attr('height', '100%');
      }
    } else {
      // There is nothing to display in the iframe, so popout.
      $scope.openExternal();
      $scope.viewModel.displayControls = false;
    }
  };
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/content/externalContent/directives/contentIframe.tpl.html',
    link: linkFunction,
    scope: {
      iframeSrc: '<',
      popoutUrl: '<',
      displayControls: '<'
    }
  };
};
ContentIframeDirective.$inject = ["$sce", "$window"];
angular.module('gw-um-submission').directive('contentIframe', ContentIframeDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

var path = '/content/externalContent/directives/contentIframe.tpl.html';
var html = "<div class=\"contentIframeContainer\">\n    <div class=\"contentIframeButtons\"\n         ng-if=\"viewModel.displayControls\">\n        <button type=\"button\"\n                class=\"btn btn-default contentIframeButton\"\n                ng-click=\"refreshIframe()\">\n            <span class=\"glyphicon glyphicon-home\"></span>\n        </button>\n        <button type=\"button\"\n                class=\"btn btn-default contentIframeButton\"\n                ng-click=\"openExternal()\">\n            <span class=\"glyphicon glyphicon-new-window\"></span>\n        </button>\n    </div>\n    <div class=\"contentIframe\" ui-browser-detection>\n        <iframe class=\"iframe\"\n                ng-src=\"{{ viewModel.iframeSrc }}\"\n                width=\"100%\"\n                frameborder=\"0\"\n                scrolling=\"auto\"></iframe>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

var path = '/content/externalContent/externalContent.tpl.html';
var html = "<content-iframe iframe-src=\"viewModel.externalContentUrl\"\n                popout-url=\"viewModel.externalContentPopoutUrl\" />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 316 */
/***/ (function(module, exports) {

/*@ngInject*/
var ExternalContentController = function ExternalContentController($scope, $stateParams) {
  $scope.viewModel = {
    externalContentUrl: $stateParams.externalContentUrl,
    externalContentPopoutUrl: $stateParams.externalContentPopoutUrl
  };
};
ExternalContentController.$inject = ["$scope", "$stateParams"];
angular.module('gw-um-submission').controller('externalContentController', ExternalContentController);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

var path = '/content/gridTotals/gridTotals.tpl.html';
var html = "<div class=\"gridTotals\">\n    <div class=\"columnHeader\">\n        <div class=\"columnRow columnDisposition\">\n            <div class=\"column {{::column.__text}}\"\n                 ng-if=\"::(column._visible==='true')\"\n                 ng-repeat=\"column in $ctrl.colViewModel.columns\"\n                 ng-style=\"{'width': column._width + 'px'}\">\n                <div class=\"col sortable sideBar\">\n                    <div class=\"columnLabel\">\n                        <span class=\"totalHeader\" ng-if=\"!$first && $ctrl.getValue(column) || $ctrl.getValue(column) === 0\">{{::column.__text}}</span>\n                        <span class=\"totalHeaderValue\" ng-if=\"!$first\">{{$ctrl.getValue(column)}}</span>\n                        <span class=\"totalLabel\" ng-if=\"$first\">{{ $ctrl.i18n.totals }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col scrollBar\"></div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

var GridTotalsComponent = {
  templateUrl: '/content/gridTotals/gridTotals.tpl.html',
  controller: 'gridTotalsController',
  bindings: {
    totalData: '<',
    colViewModel: '<'
  }
};
angular.module('gw-um-submission').component('gridTotals', GridTotalsComponent);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(321);

/*@ngInject*/
var GridTotalsController = function GridTotalsController() {
  this.$onInit = function () {
    this.i18n = locale;
  };
  this.getValue = function (column) {
    return this.totalData[column._accessor];
  };
};
angular.module('gw-um-submission').controller('gridTotalsController', GridTotalsController);

/***/ }),
/* 321 */
/***/ (function(module) {

module.exports = JSON.parse("{\"totals\":\"Totals\"}");

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

var path = '/content/overview/activity/activityStream.tpl.html';
var html = "<div class=\"dockPanelContainer activityStreamContainer\"\n     ui-focus-manager=\"activityStreamContainer\">\n\n    <section class=\"dockPanelSection activityStreamSection\">\n\n        <!--Top Panel-->\n        <div class=\"dockPanelHeader activityStreamHeader\">\n            <h2 class=\"dockPanelHeaderTitle\">\n                <span class=\"svgicon icon-activityStreamWhite\"></span>\n                <span>{{ ::viewModel.filterTypeLabel }}</span>\n            </h2>\n            \n            <div class=\"sectionSwitcher\"\n                 ng-if=\"notImplemented\"\n                 uib-dropdown>\n\n                <a class=\"dockPanelHeaderButton activityStreamHeaderButton\"\n                   uib-dropdown-toggle>\n                    <span>{{ ::viewModel.filterTypeLabel }}</span>\n                    <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                </a>\n                <ul uib-dropdown-menu>\n                    <li><a ng-click=\"onFilterClick('all')\">\n                        {{ i18n.filter.all }}</a>\n                    </li>\n                </ul>\n            </div>\n\n            <a class=\"dockPanelHeaderButton activityStreamHeaderButton dockPanelHeaderCloseButton\"\n               ng-click=\"onToggleActivityStream()\">\n                <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\n            </a>\n        </div>\n\n        <!--Search Form-->\n        <div class=\"dockPanelSearchForm activityStreamSearchForm has-feedback\"\n             ng-class=\"{ 'is-open': viewModel.isSearchOpen }\">\n            <span class=\"glyphicon glyphicon-search form-control-feedback\" aria-hidden=\"true\"></span>\n            <input type=\"search\"\n                   ng-model=\"viewModel.searchInput\"\n                   ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                   class=\"searchInput form-control\"\n                   ng-change=\"onSearchInputChange()\"\n                   placeholder=\"{{ getSearchPlaceholder() }}\" />\n\n            <span ng-if=\"viewModel.searchInput != ''\"\n                  ng-click=\"onClearSearchInput()\"\n                  class=\"glyphicon glyphicon-remove form-control-feedback\"></span>\n        </div>\n\n        <!--Activity Stream List-->\n        <div class=\"dockPanelContent activityStreamContent\">\n            <ul class=\"dockPanelCellList activityStreamCellList\">\n                <li class=\"dockPanelCell activityStreamCell\"\n                    ng-repeat=\"streamItem in viewModel.streamItemList\">\n                    <div class=\"cellSide\">\n                        <ui-user-avatar\n                                userid=\"{{::streamItem.actorId}}\"></ui-user-avatar>\n                    </div>\n\n                    <div class=\"cellContent\">\n                        <h3>\n                            <span ng-if=\"streamItem.type < 66\">{{ ::streamItem.actorDisplayName }}</span>\n                            <span ng-if=\"streamItem.type >= 66\">{{ ::streamItem.note.from }}</span>\n\n                            <span class=\"titleSubtext\">\n                                <ui-reload-relative-time time=\"{{ ::streamItem.triggerTime }}\" interval=\"1\"></ui-reload-relative-time>\n                            </span>\n                        </h3>\n\n                        <div>\n                            <p>{{ ::getActivityStreamMessage(streamItem.note) }}</p>\n                        </div>\n                    </div>\n\n                </li>\n            </ul>\n\n            <div ng-if=\"viewModel.isLoading\">\n                <div class=\"icon-spinner\"></div>\n            </div>\n\n        </div>\n\n    </section>\n\n</div>\n\n<iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(325);

/*@ngInject*/
var ActivityStreamController = function ActivityStreamController($scope, $rootScope, $stateParams, submissionConstant, coreConstant, submissionMediator, submissionStateMediator, formViewerConstant, appTypeConfigurationModel) {
  $scope.i18n = locale;
  $scope.viewModel = {
    formIsLoaded: false,
    isOpen: false,
    filterType: 'all',
    filterTypeLabel: _.get($scope.i18n, 'filter.all'),
    isSearchOpen: false,
    searchInput: '',
    streamItemList: [],
    mustRefreshActivityItems: true
  };
  $scope.getSearchPlaceholder = function () {
    return _.get($scope.i18n, 'searchPlaceholder') + ' ' + _.get($scope.i18n, 'filter.all');
  };
  $scope.onFilterClick = function (type) {
    $scope.viewModel.filterType = type;
    $scope.viewModel.filterTypeLabel = _.get($scope.i18n, 'filter.' + type);
  };
  function refreshActivityStreamItems() {
    if ($scope.viewModel.isOpen) {
      $scope.viewModel.isLoading = true;
      submissionMediator.loadActivityStreamItems($stateParams.submissionId).then(function (streamItems) {
        $scope.viewModel.streamItemList = streamItems;
      }).finally(function () {
        $scope.viewModel.isLoading = false;
        $scope.viewModel.mustRefreshActivityItems = false;
      });
    }
  }
  function saveState() {
    var toOmit = ['formIsLoaded', 'streamItemList'];
    submissionStateMediator.saveActivityStreamState($stateParams.submissionId, _.omit($scope.viewModel, toOmit));
  }
  function restoreState() {
    var savedViewModel = submissionStateMediator.getActivityStreamState($stateParams.submissionId);
    if (savedViewModel) {
      $scope.viewModel = _.extend($scope.viewModel, savedViewModel);
      if ($scope.viewModel.isOpen) {
        $rootScope.$broadcast(submissionConstant.event.ACTIVITY_STREAM_DID_OPEN);
      }
    }
  }
  function openDrawer() {
    $scope.viewModel.isOpen = true;
    if ($scope.viewModel.mustRefreshActivityItems) {
      refreshActivityStreamItems();
    }
    saveState();
    $rootScope.$broadcast(submissionConstant.event.ACTIVITY_STREAM_DID_OPEN);
  }
  function closeDrawer() {
    $scope.viewModel.isOpen = false;
    saveState();
    $rootScope.$broadcast(submissionConstant.event.ACTIVITY_STREAM_DID_CLOSE);
  }
  $scope.getActivityStreamMessage = function (activityStreamNote) {
    var message = activityStreamNote.simpleMessage;
    if (appTypeConfigurationModel.isUnderwriterWorkstation()) {
      if (activityStreamNote.statusReason) {
        message += ': ' + activityStreamNote.statusReason;
      }
      if (activityStreamNote.statusDetail) {
        message += ': ' + activityStreamNote.statusDetail;
      }
    }
    return message;
  };
  $scope.onToggleActivityStream = function () {
    return !$scope.viewModel.isOpen ? openDrawer() : closeDrawer();
  };
  $scope.onToggleSearch = function () {
    $scope.viewModel.isSearchOpen = !$scope.viewModel.isSearchOpen;
    if ($scope.viewModel.isSearchOpen) {
      $scope.$broadcast(coreConstant.event.ADVANCE_FOCUS, '.searchInput');
    }
    saveState();
  };
  $scope.onClearSearchInput = function () {
    $scope.viewModel.searchInput = '';
    $scope.onSearchInputChange();
  };

  // When this is invoked via the ng-change, it has already bee automatically debounced via ng-model-options.
  $scope.onSearchInputChange = function () {
    refreshActivityStreamItems();
    saveState();
  };
  $scope.$on(formViewerConstant.event.FORM_STRUCTURE_CHANGED, function () {
    $scope.viewModel.formIsLoaded = true;
  });
  $scope.$on(submissionConstant.event.CLOSE_ACTIVITY_STREAM, function (event) {
    closeDrawer();
  });
  $scope.$on(submissionConstant.event.TOGGLE_ACTIVITY_STREAM, function (event) {
    $scope.onToggleActivityStream();
  });
  $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
    if (parseInt($stateParams.submissionId) === submission.id) {
      $scope.viewModel.mustRefreshActivityItems = true;
    }
  });
  restoreState();
  refreshActivityStreamItems();
};
ActivityStreamController.$inject = ["$scope", "$rootScope", "$stateParams", "submissionConstant", "coreConstant", "submissionMediator", "submissionStateMediator", "formViewerConstant", "appTypeConfigurationModel"];
angular.module('gw-um-submission').controller('activityStreamController', ActivityStreamController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 325 */
/***/ (function(module) {

module.exports = JSON.parse("{\"all\":\"Activity Stream\",\"searchPlaceholder\":\"Search\",\"filter\":{\"all\":\"Activity Stream\",\"attachment\":\"Files\",\"email\":\"Email\",\"note\":\"Notes\",\"task\":\"Tasks\"}}");

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ActivityStreamRepository = function ActivityStreamRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActivityStreamItems = function (submissionId) {
    var url = '/rest/ActivityEvent',
      config = {
        params: {
          submissionId: submissionId,
          showViewed: true,
          startIndex: 0,
          numberOfRows: -1
        }
      };
    return this.get(url, config);
  };
  this.processGetResponseData = function (responseData) {
    _.each(responseData, function (streamItem) {
      streamItem.actorAvatar = streamItem.actorAvatar || '';
      streamItem.note = xmlUtil.parseString(streamItem.note);
    });
    return responseData;
  };
};
ActivityStreamRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('activityStreamRepository', ActivityStreamRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 327 */
/***/ (function(module, exports) {

var path = '/content/policiesSummaryGrid/policiesSummary.tpl.html';
var html = "<div class=\"policiesSummaryContent\">\n\n    <ui-policies-summary-grid class=\"uiPoliciesSummaryGrid\"\n                              is-column-filter-visible=\"false\"\n                              is-grid-filter-visible=\"isGridFilterVisible\"\n                              is-view-active-visible=\"false\"\n                              is-search-visible=\"false\"\n                              is-grid-paging-visible=\"false\"></ui-policies-summary-grid>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var PoliciesSummaryController = function PoliciesSummaryController($scope, $stateParams) {
  $scope.isGridFilterVisible = _.isNil($stateParams.policyId);
};
PoliciesSummaryController.$inject = ["$scope", "$stateParams"];
angular.module('gw-um-submission').controller('policiesSummaryController', PoliciesSummaryController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

var path = '/content/policiesSummaryGrid/policiesSummaryGrid.tpl.html';
var html = "<div class=\"policiesSummaryGrid\">\n\n    <div class=\"submissionGridContainer\">\n\n        <div class=\"landing gridWindow\" app-mode-configuration>\n            <div class=\"landingHeader\">\n                <div class=\"landingTitle\"\n                     ng-if=\"$ctrl.isGridFilterVisible\"\n                     uib-dropdown>\n                    <button class=\"btn-link activeFilter\"\n                            uib-dropdown-toggle>\n                        <span>{{ $ctrl.getSelectedFilterName() }}</span>\n                        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                    </button>\n                    <ul uib-dropdown-menu>\n                        <li ng-repeat=\"filter in $ctrl.filters\"\n                            ng-click='$ctrl.onFilterChange(filter)'><a>{{filter.name}}</a></li>\n                    </ul>\n                </div>\n            </div>\n\n            <!-- Grid -->\n            <div class=\"content landingContent\"\n                 ui-scroll-detection\n                 scroll-fixed-grid-arrow>\n\n                <!--Grid Header-->\n                <div class=\"columnHeader\">\n                    <div class=\"columnRow columnDisposition\">\n\n                        <div class=\"column {{::column.__text}} {{::(column._sort || column._accessor)}}Header\"\n                             ng-if=\"::(column._visible==='true')\"\n                             ng-repeat=\"column in $ctrl.colViewModel.columns\"\n                             ui-grid-sortable-header\n                             reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                             item-name=\"{{::(column._sort || column._accessor)}}\"\n                             item-label=\"{{::column.__text}}\"\n                             request-params=\"$ctrl.requestParams\"\n                             ng-style=\"{'width': column._width + 'px'}\"></div>\n\n                        <div class=\"col scrollBar\"></div>\n                    </div>\n                </div>\n\n\n                <div>\n                    <div class=\"datagrid table\"\n                         ux-datagrid=\"$ctrl.records\"\n                         ng-if=\"!$ctrl.isLoading\">\n\n                        <script type=\"template/html\"\n                                data-template-item=\"item\"\n                                data-template-name=\"default\">\n\n                            <div class=\"rowDrawerWrapper\">\n\n                                <div class=\"columnRow\" ng-click=\"$ctrl.navigateToItem($event, item)\">\n\n                                    <div ng-repeat=\"column in $ctrl.colViewModel.columns\"\n                                         class=\"col {{::column.__text}} {{::(column._sort || column._accessor)}}Column\"\n                                         ng-if=\"::(column._visible==='true')\"\n                                         ng-class=\"{{$ctrl.getClass(item,column)}}\"\n                                         ng-style=\"{'width': column._width + 'px'}\"\n                                         uib-tooltip=\"{{$ctrl.getValue(item,column)}}\"\n                                         tooltip-append-to-body=\"true\"\n                                         tooltip-placement=\"top-left\"\n                                         tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                         tooltip-enable=\"{{ item['enableTooltip.' + column.__text] }}\"\n                                         ui-is-tooltip-enabled=\"item['enableTooltip.' + column.__text]\">\n                                        {{$ctrl.getValue(item,column)}}\n                                    </div>\n                                </div>\n                            </div>\n\n                        </script>\n                    </div>\n\n                    <div class=\"gridEmpty\"\n                         ng-if=\"$ctrl.isGridEmpty && !$ctrl.isLoading\">{{ $ctrl.i18n.emptyMessage }}</div>\n\n                </div>\n\n                <div class=\"icon-spinner\"\n                     ng-if=\"$ctrl.isLoading\"></div>\n            </div>\n\n            <div class=\"landingPagination\"\n                 ng-if=\"this.isGridPagingVisible\"\n                 ui-grid-paging></div>\n        </div>\n\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 331 */
/***/ (function(module, exports) {

var PoliciesSummaryGridComponent = {
  templateUrl: '/content/policiesSummaryGrid/policiesSummaryGrid.tpl.html',
  controller: 'policiesSummaryGridController',
  bindings: {
    isColumnFilterVisible: '<?',
    isGridFilterVisible: '<?',
    isViewActiveVisible: '<?',
    isSearchVisible: '<?',
    isGridPagingVisible: '<?',
    selectedSubmissionIds: '<',
    gridColumnsPreference: '<?'
  }
};
angular.module('gw-um-submission').component('uiPoliciesSummaryGrid', PoliciesSummaryGridComponent);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(90);

/*@ngInject*/
var PoliciesSummaryGridController = function PoliciesSummaryGridController($filter, $controller, $rootScope, $scope, $state, $stateParams, $timeout, advancedFilterType, appTypeConfigurationModel, coreConstant, currencyUtil, submissionGridConstant, gridColumnModel, persistentConnection, submissionConstant, submissionMediator, uiPerformanceLoggerConstant, sortUtil) {
  var _this3 = this;
  angular.extend(this, $controller('baseGridWidgetController', {
    $scope: $scope
  }));
  this.i18n = locale;
  var allPoliciesString = _.get(this.i18n, 'all'),
    timeoutList = [],
    policyParams = {
      key: 'policyEffectiveDate',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc',
      searchString: '',
      filterUri: ''
    };
  this.defaultFilter = {
    name: allPoliciesString
  };
  this.filterParams = {};
  this.tooltipDelay = 1000;
  this.advancedFilterType = advancedFilterType.POLICY_GRID;
  this.$onInit = function () {
    if (this.gridColumnsPreference) {
      this.columnPreference = this.gridColumnsPreference;
      policyParams.key = 'effectiveDate';
      policyParams.sortType = 'desc';
    } else {
      this.columnPreference = 'system.policyGridColumns';
    }
    this.selectedFilterName = this.getSelectedFilterName();
    this.uiPerformanceLogAction = uiPerformanceLoggerConstant.POLICY_SUMMARY_GRID;
    this.hasFilterPermission = true;
    this.openDetailDrawerEvent = submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER;
    this.closeDetailDrawerEvent = submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER;
    this.requestParams = this.getFilterParams();
    this.onInitGridWidget();
  };
  this.loadRecords = function (onSuccess, onError) {
    if (this.requestParams.filterUri !== '') {
      this.submissionId = $stateParams.submissionId;
      if (_.isNil(this.selectedSubmissionIds)) {
        submissionMediator.loadPolicies(this.submissionId, this.requestParams).then(this.extractFilterFromRecords.bind(this)).then(this.applyFilterOnRecords.bind(this)).then(this.updateTransactionDescriptions.bind(this)).then(this.findCurrencyCode.bind(this)).then(onSuccess, onError);
      } else if (this.selectedSubmissionIds.length > 0) {
        submissionMediator.loadPoliciesBySubmissionIds(this.selectedSubmissionIds, this.requestParams).then(this.extractFilterFromRecords.bind(this)).then(this.applyFilterOnRecords.bind(this)).then(this.updateTransactionDescriptions.bind(this)).then(this.findCurrencyCode.bind(this)).then(onSuccess, onError);
      } else {
        onSuccess([]);
      }
    }
  };
  this.generateColumns = function () {
    this.colViewModel = gridColumnModel.getPoliciesGridColumns();
  };
  this.extractFilterFromRecords = function (records) {
    var _this = this;
    this.filters = [this.defaultFilter];
    var policyNumbers = _.uniq(_.map(records, function (i) {
      return i.policyNumber;
    }));
    _.each(policyNumbers.sort(), function (policyNumber) {
      _this.filters.push({
        name: policyNumber
      });
    });
    this.setFilterParams();
    return records;
  };
  this.applyFilterOnRecords = function (records) {
    if ($stateParams.policyId) {
      records = _.filter(records, {
        owningPolicyId: _.parseInt($stateParams.policyId)
      });
    }
    if (_.has(this.requestParams, 'filter.name')) {
      records = _.filter(records, {
        policyNumber: _.get(this.requestParams, 'filter.name')
      });
    }
    return records;
  };
  this.updateTransactionDescriptions = function (records) {
    var _this2 = this;
    _.each(records, function (record) {
      if (record.transactionDescription) {
        if (_.includes(record.uri, 'EndorsementSummary')) {
          record.transactionDescription = _this2.i18n.defaultEndorsementDescription + ' - ' + _.join(record.reasonList, ', ') + ' - ' + record.transactionDescription;
        }
      } else {
        if (_.includes(record.uri, 'PolicyIssuanceSummary')) {
          record.transactionDescription = _this2.i18n.defaultIssuanceDescription;
        } else if (_.includes(record.uri, 'PolicyRewriteSummary')) {
          if (record.reissue) {
            record.transactionDescription = _this2.i18n.defaultReissueDescription;
          } else {
            record.transactionDescription = _this2.i18n.defaultRewriteDescription;
          }
        } else if (_.includes(record.uri, 'PolicyCancellationSummary')) {
          record.transactionDescription = _this2.i18n.defaultCancellationDescription;
        }
      }
    });
    var shouldReSortRecords = this.requestParams.key === 'transactionDescription';
    if (shouldReSortRecords) {
      this.sortUpdatedTransactionDescriptions(records);
    }
    return records;
  };

  /*
   * Set record.currencyCode so that baseGridWidgetController.loadGrid.onSuccess can find it.
   * This is necessary because PremiumChange does not have a currencyCode property.
   */
  this.findCurrencyCode = function (records) {
    _.each(records, function (record) {
      if (record.premiumChange) {
        record.currencyCode = record.premiumChange.currencyCode;
      } else if (record.annualPremium) {
        record.currencyCode = record.annualPremium.currencyCode;
      } else if (record.estimatedEarnedPremium) {
        record.currencyCode = record.estimatedEarnedPremium.currencyCode;
      }
    });
    return records;
  };
  this.sortUpdatedTransactionDescriptions = function (records) {
    records.sort(sortUtil.naturalSortObject(this.requestParams.key));
    if (this.requestParams.sortType === 'desc') {
      records.reverse();
    }
  };
  this.setFilterParams = function () {
    var selectedFilterName = gridColumnModel.getSelectedSubmissionFilterName(),
      filter = _.find(this.filters, ['name', selectedFilterName]);
    if (!_.isNil(filter) && _.get(filter, 'name') !== allPoliciesString) {
      policyParams.filter = filter;
    } else {
      policyParams.filter = null;
    }
  };
  this.getFilterParams = function () {
    return policyParams;
  };
  this.setSelectedFilterName = function (filterName) {
    gridColumnModel.setSelectedSubmissionFilterName(filterName);
  };
  this.getSelectedFilterName = function () {
    return gridColumnModel.getSelectedSubmissionFilterName();
  };
  this.calculateFilterParams = function () {};
  this.setDefaultGridValue = function () {
    allPoliciesString = _.get(this.i18n, 'all');
    this.defaultFilter = {
      name: allPoliciesString
    };
  };
  this.updateFilterFromPreferences = function () {
    this.setDefaultGridValue();
    this.filters = [this.defaultFilter];
    this.selectedFilterName = _.get(_.first(this.filters), 'name');
    this.setSelectedFilterName(this.selectedFilterName);
    policyParams.filterUri = 'com.firstbest.underwriting.filter.DefaultFilter:1';
    $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
  };
  this.navigateToItem = function (e, item) {
    var ownerUri = item.ownerUri;
    if (_.isNil(ownerUri)) {
      var ownerUriText = _.last(item.uri.split('.'));
      ownerUriText = _.replace(ownerUriText, ':', '/');
      ownerUriText = _.replace(ownerUriText, 'Summary', '');
      ownerUri = '/' + ownerUriText;
      if (_.startsWith(ownerUri, '/Policy') && parseInt($stateParams.submissionId) !== item.submissionId) {
        $state.go('submission.policy', {
          submissionId: item.submissionId,
          policyId: _.split(ownerUri, '/')[2]
        });
        return;
      }
    }
    $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, ownerUri);
  };
  function getCurrencyCode(policyChange, accessor) {
    var premiumObject, currencyCode;
    if (!_.isNil(policyChange.totalPremium)) {
      return currencyUtil.getCurrencyFormat(policyChange.totalPremium.currencyCode);
    }
    premiumObject = policyChange[accessor];
    if (!_.isNil(premiumObject) && premiumObject.currencyCode) {
      currencyCode = premiumObject.currencyCode;
    } else {
      premiumObject = policyChange[_.split(accessor, '.')[0]];
      if (!_.isNil(premiumObject) && premiumObject.currencyCode) {
        currencyCode = premiumObject.currencyCode;
      } else {
        return currencyUtil.getCurrencyFormat();
      }
    }
    return currencyUtil.getCurrencyFormat(currencyCode);
  }
  this.getValue = function (item, column) {
    var value, props, filter;
    props = [];
    if (column._accessor && column._accessor.indexOf('.' > 0)) {
      props = column._accessor.split('.');
    } else {
      props.push(column._accessor);
    }
    value = item;
    _.each(props, function (property) {
      if (!_.isNil(value)) {
        value = value[property];
      }
    });
    if (column._type && column._type.indexOf('shortDate') >= 0 || column._accessor === 'paymentReceivedDate') {
      filter = $filter('utcDateFilter');
      value = filter(value, this.shortDateFormat, true);
    }
    if (column._type && column._type.indexOf('utcShortDate') >= 0 || column._accessor === 'effectiveDate' || column._accessor === 'expirationDate' || column._accessor === 'nextTaskSummary.dueDate' || column._accessor === 'receivedDate' || column._accessor === 'quoteNeededByDate') {
      filter = $filter('utcDateFilter');
      value = filter(value, this.shortDateFormat);
    }
    var isPremium = column._type && column._type.indexOf('premium') >= 0;
    var isCurrency = column._type && column._type.indexOf('currency') >= 0;
    if (isPremium || isCurrency) {
      filter = $filter('currency');
      if (item.uri && item.uri.indexOf('PolicyIssuance') >= 0 && column._accessor === 'premiumChange') {
        value = '-';
      } else {
        var total,
          symbol,
          fractionSize = 0,
          suffixSymbol = item.currencyFormat.suffixSymbol,
          customFormat = item.currencyFormat.customFormat;
        if (isPremium) {
          total = item[column._accessor] ? item[column._accessor].total : null;
          symbol = item.currencyFormat.symbol;
        } else if (isCurrency) {
          var currencyCode = getCurrencyCode(item, column._accessor);
          total = value && value.amount ? value.amount : value && value.total ? value.total : value;
          symbol = currencyCode.symbol;
        }
        if (total) {
          value = filter(total, symbol, fractionSize, suffixSymbol, customFormat);
        } else {
          value = '-';
        }
      }
    }
    if (column._type && column._type.indexOf('percent') >= 0) {
      value = _.round(value, 2) + '%';
    }
    if (column._accessor === 'numberOfClaims' && _.isNil(value)) {
      value = '0';
    }
    return value;
  };
  $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function () {
    _this3.updateColumnsFromPreferences();
    _this3.resetGridColumns();
  });
  $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, function () {
    _this3.loadListOnFilterChange();
  });
  $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, params) {
    _this3.resetParams(params);
    if (_this3.isLoaded) {
      _this3.loadGrid();
    }
  });
  $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
    persistentConnection.connect().then(function () {
      _this3.isUserTypeUpdated = true;
      _this3.isAgent = appTypeConfigurationModel.isAgentConsole();
      _this3.initLandingPage();
    });
  });
  $scope.$on(coreConstant.event.REFRESH_POLICY_CHANGE, function (event, policyChange) {
    var index = _.indexOf(_this3.records, _.find(_this3.records, {
      id: policyChange.id
    }));
    var isPremiumChange = !_.isNull(policyChange.premiumChange);
    policyChange = submissionMediator.processPolicyChangeStatus(policyChange);
    if (isPremiumChange) {
      policyChange.currencyFormat = currencyUtil.getCurrencyFormat(policyChange.premiumChange.currencyCode);
    }
    timeoutList.push($timeout(function () {
      if (index >= 0) {
        _this3.records.splice(index, 1, policyChange);
      } else if (policyChange.owningPolicyId === parseInt($stateParams.policyId)) {
        _this3.records.push(policyChange);
      }
    }, 0));
  });
  $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
  $scope.$watch('$ctrl.selectedSubmissionIds', function (newValue, oldValue) {
    if (!_.isEqual(newValue, oldValue)) {
      _this3.loadGrid();
    }
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
PoliciesSummaryGridController.$inject = ["$filter", "$controller", "$rootScope", "$scope", "$state", "$stateParams", "$timeout", "advancedFilterType", "appTypeConfigurationModel", "coreConstant", "currencyUtil", "submissionGridConstant", "gridColumnModel", "persistentConnection", "submissionConstant", "submissionMediator", "uiPerformanceLoggerConstant", "sortUtil"];
angular.module('gw-um-submission').controller('policiesSummaryGridController', PoliciesSummaryGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(90);

/*@ngInject*/
var PoliciesSummaryGridRepository = function PoliciesSummaryGridRepository(baseRepository, sortUtil, policyStatus, endorsementStatus, policyRewriteStatus, policyCancellationStatus, policyReinstatementStatus, currentSubmissionModel) {
  angular.extend(this, baseRepository);
  this.i18n = locale;
  var translationTable = {
      insuredName: ['insured', 'name'],
      assignedUnderwriter: ['assignedUnderwriterSummary', 'name'],
      responsibleUnderwriter: ['responsibleUnderwriterSummary', 'name'],
      number: 'submissionNumber',
      premium: ['totalPremium', 'total'],
      nextAction: ['nextTaskSummary', 'definition'],
      actionDate: ['nextTaskSummary', 'dueDate'],
      quoteNeededByDate: 'quoteNeededByDate'
    },
    sortColumn;
  this.loadPolicies = function (submissionId, submissionParams) {
    var url = '/rest/PolicyChange/List',
      config = {
        params: {
          submissionId: submissionId,
          registrationIdentifier: '/SubmissionPolicyChanges/' + submissionId
        }
      };
    currentSubmissionModel.addRegistration({
      url: url,
      params: config.params
    });
    sortColumn = translationTable[submissionParams.key] || submissionParams.key;
    return this.get(url, config).then(function (responseData) {
      var sortedRecords = responseData.sort(sortUtil.naturalSortObject(sortColumn));
      if (submissionParams.sortType === 'desc') {
        sortedRecords.reverse();
      }
      return sortedRecords;
    });
  };
  this.loadPoliciesBySubmissionIds = function (submissionIds, submissionParams) {
    var url = '/rest/Policy/bySubmissionIds',
      config = {
        params: {
          submissionIds: submissionIds
        }
      };
    if (submissionParams) {
      sortColumn = translationTable[submissionParams.key] || submissionParams.key;
    }
    return this.get(url, config).then(function (responseData) {
      var sortedRecords = responseData;
      if (submissionParams) {
        sortedRecords = responseData.sort(sortUtil.naturalSortObject(sortColumn));
        if (submissionParams.sortType === 'desc') {
          sortedRecords.reverse();
        }
      }
      return sortedRecords;
    });
  };
  this.processGetResponseData = function (responseData) {
    var _this = this;
    _.each(responseData, function (record) {
      if (_.includes(record.uri, 'PolicyIssuanceSummary')) {
        switch (record.status) {
          case policyStatus.BOUND:
            record.status = _this.i18n.policyStatuses.bound;
            break;
          case policyStatus.BEGIN_ISSUANCE:
            record.status = _this.i18n.policyStatuses.beginIssuance;
            break;
          case policyStatus.PENDING_ISSUANCE:
            record.status = _this.i18n.policyStatuses.pendingIssuance;
            break;
          case policyStatus.ISSUED:
            record.status = _this.i18n.policyStatuses.issued;
            break;
        }
      } else if (_.includes(record.uri, 'EndorsementSummary')) {
        switch (record.status) {
          case endorsementStatus.INVALID:
            record.status = _this.i18n.endorsementStatuses.invalid;
            break;
          case endorsementStatus.DRAFT:
            record.status = _this.i18n.endorsementStatuses.draft;
            break;
          case endorsementStatus.SUBMITTED:
            record.status = _this.i18n.endorsementStatuses.submitted;
            break;
          case endorsementStatus.DECLINED:
            record.status = _this.i18n.endorsementStatuses.declined;
            break;
          case endorsementStatus.PENDING_ISSUANCE:
            record.status = _this.i18n.endorsementStatuses.pendingIssuance;
            break;
          case endorsementStatus.ISSUED:
            record.status = _this.i18n.endorsementStatuses.issued;
            break;
        }
      } else if (_.includes(record.uri, 'PolicyRewriteSummary')) {
        switch (record.status) {
          case policyRewriteStatus.INVALID:
            record.status = _this.i18n.policyRewriteStatuses.invalid;
            break;
          case policyRewriteStatus.DRAFT:
            record.status = _this.i18n.policyRewriteStatuses.draft;
            break;
          case policyRewriteStatus.SUBMITTED:
          case policyRewriteStatus.INVALID_RATING:
          case policyRewriteStatus.VALID_RATING:
          case policyRewriteStatus.VALID_PRICING:
            record.status = _this.i18n.policyRewriteStatuses.submitted;
            break;
          case policyRewriteStatus.PENDING_ISSUANCE:
            record.status = _this.i18n.policyRewriteStatuses.pendingIssuance;
            break;
          case policyRewriteStatus.ISSUED:
            record.status = _this.i18n.policyRewriteStatuses.issued;
            break;
        }
      } else if (_.includes(record.uri, 'PolicyCancellationSummary')) {
        switch (record.status) {
          case policyCancellationStatus.REQUESTED:
            record.status = _this.i18n.policyCancellationStatuses.requested;
            break;
          case policyCancellationStatus.PENDING:
            record.status = _this.i18n.policyCancellationStatuses.pending;
            break;
          case policyCancellationStatus.CANCELLED:
            record.status = _this.i18n.policyCancellationStatuses.cancelled;
            break;
          case policyCancellationStatus.RETRACTED:
            record.status = _this.i18n.policyCancellationStatuses.retracted;
            break;
          case policyCancellationStatus.RESCINDED:
            record.status = _this.i18n.policyCancellationStatuses.rescinded;
            break;
          case policyCancellationStatus.INVALID:
            record.status = _this.i18n.policyCancellationStatuses.invalid;
            break;
        }
      } else if (_.includes(record.uri, 'PolicyReinstatementSummary')) {
        switch (record.status) {
          case policyReinstatementStatus.REINSTATED:
            record.status = _this.i18n.policyReinstatementStatuses.reinstated;
            break;
          case policyReinstatementStatus.INVALID:
            record.status = _this.i18n.policyReinstatementStatuses.invalid;
            break;
        }
      } else {
        record.status = '--';
      }
    });
    return responseData;
  };
};
PoliciesSummaryGridRepository.$inject = ["baseRepository", "sortUtil", "policyStatus", "endorsementStatus", "policyRewriteStatus", "policyCancellationStatus", "policyReinstatementStatus", "currentSubmissionModel"];
angular.module('gw-um-submission').service('policiesSummaryGridRepository', PoliciesSummaryGridRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

var path = '/content/print/printHeader.tpl.html';
var html = "<div class=\"printHeaderContent\">\n    <div class=\"customerSummary\">\n        <div class=\"customerElement customerName customerFormName\">{{ printViewModel.formName }}</div>\n        <div class=\"customerElement customerStatus customerStatusTitle\" ng-if=\"printViewModel.customerName\">\n            <span class=\"customerStatusLabel\">{{ ::i18n.customerSummary.insuredName }}</span>\n            <span class=\"submissionStatus\">{{ printViewModel.customerName }}</span>\n        </div>\n        <div class=\"customerElement customerStatus\" ng-if=\"printViewModel.status\">\n            <span class=\"customerStatusLabel\">{{ ::i18n.customerSummary.status }}</span>\n            <span class=\"submissionStatus\">{{printViewModel.statusLabel}}</span>\n        </div>\n    </div>\n\n    <div class=\"printHeaderAction\">\n        <button class=\"btn btn-default\" ng-click=\"backToForm()\">{{::i18n.closePreview}}</button>\n        <button class=\"btn btn-primary\" onclick=\"window.print()\">{{::i18n.print}}</button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 336 */
/***/ (function(module, exports) {

var path = '/content/print/printOverview.tpl.html';
var html = "<div class=\"formViewer printPreview\"\n     ng-class=\"{ loading: printViewModel.isLoading }\">\n\n    <div class=\"formViewerContainer\" ui-browser-detection>\n        <ui-form-viewer submission-id=\"{{ ::printViewModel.submissionId }}\"\n                        form-id=\"{{ ::printViewModel.formId }}\"\n                        print-preview=\"true\"\n                        effective-date=\"{{ ::printViewModel.effectiveDate }}\"\n                        currency-code=\"{{ ::printViewModel.currencyCode }}\">\n\n                <div class=\"printHeader\"\n                     ng-include=\"'/content/print/printHeader.tpl.html'\"></div>\n        </ui-form-viewer>\n    </div>\n\n    <div ng-if=\"printViewModel.isLoading\">\n        <div class=\"icon-spinner\"></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 337 */
/***/ (function(module, exports) {

var path = '/content/print/printCollaboration.tpl.html';
var html = "<div class=\"formViewer printPreview\"\n     ng-class=\"{ loading: printViewModel.isLoading }\">\n\n    <div class=\"formViewerContainer\" ui-browser-detection>\n        <div class=\"printHeader\"\n             ng-include=\"'/content/print/printHeader.tpl.html'\"></div>\n    </div>\n\n    <div ng-if=\"printViewModel.isLoading\">\n        <div class=\"icon-spinner\"></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(339);

/*@ngInject*/
var PrintOverviewController = function PrintOverviewController($scope, $controller, $stateParams, $state, currentSubmissionModel, submissionMediator, submissionStateMediator, formViewerConstant, $timeout, watchManagerUtil) {
  angular.extend(this, $controller('submissionFormViewerController', {
    $scope: $scope
  }));
  $scope.i18n = locale;
  $scope.printViewModel = {
    formId: _.parseInt($stateParams.formSummaryInstanceId || $stateParams.formId),
    effectiveDate: currentSubmissionModel.getCurrentSubmission().effectiveDate,
    currencyCode: currentSubmissionModel.getCurrentSubmission().currencyCode
  };
  function loadSubmission() {
    var submission = submissionMediator.getCurrentSubmission();
    $scope.printViewModel.customerName = submission.insured.name;
    $scope.printViewModel.status = submission.status;
    $scope.printViewModel.statusLabel = $scope.i18n.status[submission.status];
    $scope.printViewModel.reason = submission.statusReason;
    $scope.printViewModel.detail = submission.statusDetail;
  }
  $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (event, formData) {
    $scope.printViewModel.formName = _.get(formData, 'formModel.formTemplateDisplayName', null);
  });
  $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_END, function (event, formData) {
    $timeout(function () {
      watchManagerUtil.clearWatcherList($scope);
    }, 1000);
  });
  $scope.backToForm = function () {
    var params = {
        submissionId: $stateParams.submissionId
      },
      stateUrl = submissionStateMediator.getSubmissionStateUrl($stateParams.submissionId),
      stateName = 'submission.form';
    if (_.isPlainObject(stateUrl)) {
      params = _.get(stateUrl, 'params', params);
      stateName = _.get(stateUrl, 'name', stateName);
    }
    $state.go(stateName, params, {
      reload: $state.current.name === 'submission.printCollaboration'
    });
  };
  loadSubmission();
};
PrintOverviewController.$inject = ["$scope", "$controller", "$stateParams", "$state", "currentSubmissionModel", "submissionMediator", "submissionStateMediator", "formViewerConstant", "$timeout", "watchManagerUtil"];
angular.module('gw-um-submission').controller('printOverviewController', PrintOverviewController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 339 */
/***/ (function(module) {

module.exports = JSON.parse("{\"print\":\"Print\",\"closePreview\":\"Close Preview\",\"customerSummary\":{\"insuredName\":\"Insured Name:\",\"status\":\"Status: \"},\"status\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Not Clear\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Rejected\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}}}");

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

var path = '/content/proposalSummaries/proposalSummaries.tpl.html';
var html = "<div class=\"proposalSummariesContent\">\n    <div class=\"table proposalSummariesGrid\"\n         ng-if=\"!viewModel.isLoading && viewModel.proposalSummaries.length > 0\">\n\n        <!--Header-->\n        <div class=\"tableRow header\">\n            <div class=\"toggleDrawer\"></div>\n            <div class=\"tableCol colProposals\">{{ i18n.proposals }}</div>\n            <div class=\"tableCol colStatus colStatusHeader\"></div>\n            <div class=\"tableCol colPremium\">{{ i18n.premium }}</div>\n        </div>\n\n        <!--Proposal Summary Grid-->\n        <div class=\"proposalSummariesRows\">\n            <div class=\"proposalSummariesRow\"\n                 ng-repeat=\"proposalSummary in viewModel.proposalSummaries\">\n\n                <!--Proposal Row-->\n                <div class=\"tableRow proposalRow\"\n                     ng-class=\"{ isOpen: proposalSummary.isOpen }\">\n\n                    <div class=\"toggleDrawer\"\n                         ng-click=\"toggleDrawer(proposalSummary)\">\n\n                        <span class=\"glyphicon glyphicon-chevron-right\"\n                          ng-show=\"proposalSummary.quoteSummaries.length > 0\"></span>\n                    </div>\n\n                    <div class=\"tableCol colProposal\"\n                         ng-click=\"openItem(proposalSummary)\">\n                        <h3>{{ getProposalDescription(proposalSummary) }}</h3>\n                        <p class=\"createdAt\"\n                           ng-show=\"proposalSummary.sentDate && !proposalSummary.isOpen\">\n                            <time>\n                                <span ng-if=\"viewModel.isUnderwriter\">{{ i18n.sentAt }}</span>\n\n                                <span ng-if=\"!viewModel.isUnderwriter\">{{ i18n.receivedAt }}</span>\n                                {{proposalSummary.sentDate | utcDateFilter: viewModel.shortDateFormat + ' hh:mm A' : true}}\n                            </time>\n                        </p>\n                    </div>\n\n                    <div class=\"tableCol colStatus\"\n                         ng-click=\"openItem(proposalSummary)\"></div>\n\n                    <div class=\"tableCol colPremium\"\n                         ng-click=\"openItem(proposalSummary)\">\n\n                        <p ng-if=\"proposalSummary.totalPremium.total > 0\">\n                            {{proposalSummary.totalPremium.total | currency:proposalSummary.totalPremium.currencyFormat.symbol:0:proposalSummary.totalPremium.currencyFormat.suffixSymbol:proposalSummary.totalPremium.currencyFormat.customFormat}}</p>\n                        <p ng-if=\"!proposalSummary.totalPremium.total\">-</p>\n                    </div>\n\n                </div>\n\n                <!--Quote List-->\n                <div class=\"quoteSummariesContent\"\n                     ng-if=\"proposalSummary.isOpen && proposalSummary.quoteSummaries.length > 0\">\n\n\n                    <!--Quote Header-->\n                    <div class=\"table quoteSummariesGrid\">\n                        <div class=\"tableRow header\">\n                            <div class=\"tableCol colQuoteOrdinalNumber\">{{ i18n.quoteOrdinalNumber }}</div>\n                            <div class=\"tableCol colQuotes\">{{ i18n.quotes }}</div>\n                            <div class=\"tableCol colStatus colStatusHeader\">{{ i18n.status }}\n                            </div>\n                            <div class=\"tableCol colStatusReason\" ng-if=\"viewModel.isUnderwriter\">{{ i18n.statusReason }}</div>\n                            <div class=\"tableCol colPremium\"></div>\n                        </div>\n\n                        <!--Quote Row-->\n                        <div class=\"tableRow quoteRow\" ng-click=\"openItem(quote)\"\n                             ng-repeat=\"quote in proposalSummary.quoteSummaries\">\n                            <div class=\"tableCol colQuoteOrdinalNumber\">{{ quote.ordinalNumber }}</div>\n                            <div class=\"tableCol colQuotes\">\n                                <h3>{{quote.summary}}</h3>\n                                <p class=\"createdAt\" ng-if=\"quote.sentDate\">\n                                    <time>\n                                    <span ng-if=\"viewModel.isUnderwriter\">{{ i18n.sentAt }}</span>\n                                        <span ng-if=\"!viewModel.isUnderwriter\">{{ i18n.receivedAt }}</span>\n                                        {{quote.sentDate | utcDateFilter: viewModel.shortDateFormat + ' hh:mm A' :\n                                        true}}\n                                    </time>\n                                </p>\n                            </div>\n\n                            <div class=\"tableCol colStatus\">\n                                <wizard-breadcrumbs\n                                    quote-id=\"quote.id\"\n                                    progress-status=\"quote.status\">\n                                </wizard-breadcrumbs>\n                            </div>\n\n                            <div class=\"tableCol colStatusReason\"\n                                 ng-if=\"viewModel.isUnderwriter\">\n                                <span>\n                                    {{quote.statusReason}}\n                                </span>\n                            </div>\n\n                            <div class=\"tableCol colPremium\">\n                                <p ng-if=\"quote.totalPremium.total > 0\">\n                                    {{quote.totalPremium.total | currency:quote.totalPremium.currencyFormat.symbol:0:quote.totalPremium.currencyFormat.suffixSymbol:quote.totalPremium.currencyFormat.customFormat}}\n                                </p>\n                                <p ng-if=\"!quote.totalPremium.total\">-</p>\n                            </div>\n                        </div>\n\n                        <div ng-if=\"viewModel.isLoading && viewModel.quotes.length > 0\">\n                            <div class=\"icon-spinner\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"viewModel.isLoading && viewModel.proposalSummaries.length > 0\">\n            <div class=\"icon-spinner\"></div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(343);

/*@ngInject*/
var ProposalSummariesController = function ProposalSummariesController($scope, $rootScope, $timeout, $stateParams, appTypeConfigurationModel, coreConstant, coreMediator, dateUtil, proposalMediator, submissionConstant, currencyUtil) {
  $scope.i18n = locale;
  $scope.viewModel = {
    shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
    isLoading: true,
    proposalSummaries: [],
    isUnderwriter: appTypeConfigurationModel.isUnderwriterWorkstation()
  };
  function loadProposalSummaries() {
    var submissionId = $stateParams.submissionId;
    $scope.viewModel.isLoading = true;
    proposalMediator.getProposalList(submissionId).then(function (proposalSummaries) {
      $scope.viewModel.proposalSummaries = filterProposalSummaries(proposalSummaries);
      $scope.viewModel.isLoading = false;
    });
  }
  function filterProposalSummaries(proposalSummaries) {
    return _.map(_.filter(proposalSummaries, function (proposalSummary) {
      return proposalSummary.quoteSummaries.length > 0;
    }), function (proposalSummary) {
      if (!_.isNil(proposalSummary.totalPremium)) {
        proposalSummary.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(proposalSummary.totalPremium.currencyCode);
      }
      proposalSummary.isOpen = true;
      _.map(proposalSummary.quoteSummaries, function (quote) {
        quote.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(quote.totalPremium.currencyCode);
        return quote;
      });
      return proposalSummary;
    });
  }
  $scope.getProposalDescription = function (proposalSummary) {
    var description = proposalSummary.description;
    if (proposalSummary.quoteSummaries.length > 0) {
      description += ' (';
      _.each(proposalSummary.quoteSummaries, function (quoteSummary, index) {
        if (index > 0) {
          description += ', ';
        }
        description += quoteSummary.productShortName;
        quoteSummary.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(quoteSummary.totalPremium.currencyCode);
      });
      description += ')';
    }
    return description;
  };
  $scope.openItem = function (item) {
    $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, item.objectUri);
  };
  $scope.toggleDrawer = function (proposalSummary) {
    proposalSummary.isOpen = !proposalSummary.isOpen;
  };
  $scope.$on(coreConstant.event.REFRESH_PROPOSAL, function (event, proposalSummary, submissionId) {
    var index = _.indexOf($scope.viewModel.proposalSummaries, _.find($scope.viewModel.proposalSummaries, {
        id: proposalSummary.id
      })),
      oldProposalSummary = _.find($scope.viewModel.proposalSummaries, {
        id: proposalSummary.id
      });
    proposalSummary.isOpen = oldProposalSummary ? oldProposalSummary.isOpen : true;
    $timeout(function () {
      if (index >= 0) {
        $scope.viewModel.proposalSummaries.splice(index, 1, proposalSummary);
      } else if (submissionId === parseInt($stateParams.submissionId)) {
        $scope.viewModel.proposalSummaries.push(proposalSummary);
      }
    }, 0);
    $scope.viewModel.proposalSummaries = filterProposalSummaries($scope.viewModel.proposalSummaries);
  });
  $scope.$on(coreConstant.event.PROPOSAL_DELETED, function (event, proposalSummary) {
    $timeout(function () {
      _.remove($scope.viewModel.proposalSummaries, {
        id: proposalSummary.id
      });
    }, 0);
  });
  loadProposalSummaries();
};
ProposalSummariesController.$inject = ["$scope", "$rootScope", "$timeout", "$stateParams", "appTypeConfigurationModel", "coreConstant", "coreMediator", "dateUtil", "proposalMediator", "submissionConstant", "currencyUtil"];
angular.module('gw-um-submission').controller('proposalSummariesController', ProposalSummariesController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 343 */
/***/ (function(module) {

module.exports = JSON.parse("{\"proposals\":\"Proposals\",\"premium\":\"Premium\",\"sentAt\":\"Sent at\",\"receivedAt\":\"Received at\",\"quoteOrdinalNumber\":\"#\",\"quotes\":\"Quotes\",\"status\":\"Status\",\"statusReason\":\"Status Reason\"}");

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

var path = '/content/proposalSummary/proposalSummary.tpl.html';
var html = "<div class=\"proposalSummaryContent\">\n\n    <div class=\"proposalHeader\">\n        <div class=\"proposalNameCol\" >{{ i18n.proposal }}</div>\n        <div class=\"premiumCol\">{{ i18n.premium }}</div>\n    </div>\n\n    <div class=\"proposalPremium\">\n\n        <!--Proposal Name-->\n        <div class=\"proposalName\">{{ viewModel.proposalName }}</div>\n\n        <!--Total Premium-->\n        <div class=\"totalPremium\">\n            <span ng-if=\"viewModel.proposalPremium.total > 0\">{{ viewModel.proposalPremium.total |\n                currency:viewModel.proposalPremium.currencyFormat.symbol:0:viewModel.proposalPremium.currencyFormat.suffixSymbol:viewModel.proposalPremium.currencyFormat.customFormat\n                }}</span>\n            <p ng-if=\"!viewModel.proposalPremium.total\">-</p>\n        </div>\n    </div>\n\n    <div class=\"table quoteSummariesGrid\" ng-if=\"!viewModel.isLoading && viewModel.quotes.length > 0\">\n        <div class=\"tableRow header\">\n            <div class=\"tableCol colQuoteOrdinalNumber\">{{ i18n.quoteOrdinalNumber }}</div>\n            <div class=\"tableCol colQuotes\">{{ i18n.quotes }}</div>\n            <div class=\"tableCol colStatus colStatusHeader\">{{ i18n.status }}</div>\n            <div class=\"tableCol colStatusReason\" ng-if=\"viewModel.isUnderwriter\">{{ i18n.statusReason }}</div>\n            <div class=\"tableCol colPremium\"></div>\n        </div>\n        <div class=\"tableRowBox\">\n            <div class=\"tableRow quoteRow\" ng-click=\"openQuote(quote)\" ng-repeat=\"quote in viewModel.quotes\">\n                <div class=\"tableCol colQuoteOrdinalNumber\">{{ quote.ordinalNumber }}</div>\n                <div class=\"tableCol colQuotes\">\n                    <h3>{{quote.summary}}</h3>\n                    <p class=\"createdAt\" ng-if=\"quote.sentDate\">\n                        <time>\n                            <span ng-if=\"viewModel.isUnderwriter\">{{ i18n.sentAt }}</span>\n                            <span ng-if=\"!viewModel.isUnderwriter\">{{ i18n.receivedAt }}</span>\n                            {{quote.sentDate | utcDateFilter: viewModel.shortDateFormat + ' hh:mm A' : true}}\n                        </time>\n                    </p>\n                </div>\n                <div class=\"tableCol colStatus\">\n                    <wizard-breadcrumbs\n                        quote-id=\"quote.id\"\n                        progress-status=\"quote.status\">\n                    </wizard-breadcrumbs>\n                </div>\n                <div class=\"tableCol colStatusReason\"\n                     ng-if=\"viewModel.isUnderwriter\">\n                    <span>\n                        {{quote.statusReason}}\n                    </span>\n                </div>\n                <div class=\"tableCol colPremium\">\n                    <p ng-if=\"quote.totalPremium.total > 0\">{{quote.totalPremium.total |\n                        currency:quote.totalPremium.currencyFormat.symbol:0:quote.totalPremium.currencyFormat.suffixSymbol:quote.totalPremium.currencyFormat.customFormat\n                        }}</p>\n                    <p ng-if=\"!quote.totalPremium.total\">-</p>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"viewModel.isLoading && viewModel.quotes.length > 0\">\n            <div class=\"icon-spinner\"></div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(347);

/*@ngInject*/
var ProposalSummaryController = function ProposalSummaryController($scope, $rootScope, $timeout, $stateParams, quoteMediator, submissionConstant, currencyUtil, coreConstant, coreMediator, dateUtil, appTypeConfigurationModel, proposalMediator) {
  $scope.i18n = locale;
  $scope.viewModel = {
    shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
    isLoading: true,
    quotes: [],
    isUnderwriter: appTypeConfigurationModel.isUnderwriterWorkstation(),
    proposal: {},
    proposalPremium: {}
  };
  function loadProposalPremium() {
    proposalMediator.findById($stateParams.proposalId).then(function (result) {
      result.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(result.totalPremium.currencyCode);
      $scope.viewModel.proposal = result;
      $scope.viewModel.proposalPremium = result.totalPremium;
      buildProposalName();
    });
  }
  function loadQuotes() {
    var submissionId = $stateParams.submissionId,
      proposalId = $stateParams.proposalId;
    $scope.viewModel.isLoading = true;
    quoteMediator.getQuoteList(submissionId, proposalId).then(function (quotes) {
      $scope.viewModel.quotes = _.map(quotes, function (quote) {
        quote.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(quote.totalPremium.currencyCode);
        return quote;
      });
      $scope.viewModel.isLoading = false;
    });
  }
  function buildProposalName() {
    var description = $scope.viewModel.proposal.description;
    if ($scope.viewModel.proposal.quoteSummaries.length > 0) {
      description += ' (';
      _.each($scope.viewModel.proposal.quoteSummaries, function (quoteSummary, index) {
        if (index > 0) {
          description += ', ';
        }
        description += quoteSummary.productShortName;
      });
      description += ')';
    }
    $scope.viewModel.proposalName = description;
  }
  $scope.openQuote = function (quote) {
    $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, quote.objectUri);
  };
  $scope.$on(coreConstant.event.REFRESH_QUOTE, function (event, quoteSummary) {
    var index = _.indexOf($scope.viewModel.quotes, _.find($scope.viewModel.quotes, {
      id: quoteSummary.id
    }));
    $timeout(function () {
      if (index >= 0) {
        $scope.viewModel.quotes.splice(index, 1, quoteSummary);
      } else if (quoteSummary.proposalId === parseInt($stateParams.proposalId)) {
        $scope.viewModel.quotes.push(quoteSummary);
      }
    }, 0);
  });
  $scope.$on(coreConstant.event.QUOTE_DELETED, function (event, quoteSummary) {
    $timeout(function () {
      _.remove($scope.viewModel.quotes, {
        id: quoteSummary.id
      });
    }, 0);
  });
  loadQuotes();
  loadProposalPremium();
};
ProposalSummaryController.$inject = ["$scope", "$rootScope", "$timeout", "$stateParams", "quoteMediator", "submissionConstant", "currencyUtil", "coreConstant", "coreMediator", "dateUtil", "appTypeConfigurationModel", "proposalMediator"];
angular.module('gw-um-submission').controller('proposalSummaryController', ProposalSummaryController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 347 */
/***/ (function(module) {

module.exports = JSON.parse("{\"proposal\":\"Proposal\",\"premium\":\"Premium\",\"quoteOrdinalNumber\":\"#\",\"quotes\":\"Quotes\",\"status\":\"Status\",\"statusReason\":\"Status Reason\",\"sentAt\":\"Sent at\",\"receivedAt\":\"Received at\"}");

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

var path = '/content/quoteSummaries/quoteSummaries.tpl.html';
var html = "<div class=\"quoteSummariesContent\">\n\n    <div class=\"table quoteSummariesGrid\" ng-if=\"!viewModel.isLoading && viewModel.quotes.length > 0\">\n        <div class=\"tableRow header\">\n            <div class=\"tableCol colQuoteOrdinalNumber\">{{ i18n.quoteOrdinalNumber }}</div>\n            <div class=\"tableCol colQuotes\">{{ i18n.quotes }}</div>\n            <div class=\"tableCol colStatus colStatusHeader\"\n                 ng-class=\"{'colStatusAgent' : viewModel.isUnderwriter !== true}\">{{ i18n.status }}</div>\n            <div class=\"tableCol colStatusReason\" ng-if=\"viewModel.isUnderwriter\">{{ i18n.statusReason }}</div>\n            <div class=\"tableCol colPremium\">{{ i18n.premium }}</div>\n        </div>\n        <div class=\"tableRowBox\">\n            <div class=\"tableRow quoteRow\" ng-click=\"openQuote(quote)\" ng-repeat=\"quote in viewModel.quotes\">\n                <div class=\"tableCol colQuoteOrdinalNumber\">{{ quote.ordinalNumber }}</div>\n                <div class=\"tableCol colQuotes\">\n                    <h3>{{ quote.summary }}</h3>\n                    <p class=\"createdAt\" ng-if=\"quote.sentDate\">\n                        <time>\n                            <span ng-if=\"viewModel.isUnderwriter\">{{ i18n.sentAt }}</span>\n                            <span ng-if=\"!viewModel.isUnderwriter\">{{ i18n.receivedAt }}</span>\n                            {{quote.sentDate | utcDateFilter: viewModel.shortDateFormat + ' hh:mm A' : true}}\n                        </time>\n                    </p>\n                </div>\n                <div class=\"tableCol colStatus\"\n                    ng-class=\"{'colStatusAgent' : viewModel.isUnderwriter !== true}\">\n                    <wizard-breadcrumbs\n                        quote-id=\"quote.id\"\n                        progress-status=\"quote.status\">\n                    </wizard-breadcrumbs>\n                </div>\n                <div class=\"tableCol colStatusReason\"\n                     ng-if=\"viewModel.isUnderwriter\">\n                    <span>\n                        {{quote.statusReason}}\n                    </span>\n                </div>\n                <div class=\"tableCol colPremium\">\n                    <p ng-if=\"quote.totalPremium.total > 0\">{{quote.totalPremium.total |\n                        currency:quote.currencyFormat.symbol:0:quote.currencyFormat.suffixSymbol:quote.currencyFormat.customFormat\n                        }}</p>\n                    <p ng-if=\"!quote.totalPremium.total\">-</p>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"viewModel.isLoading && viewModel.quotes.length > 0\">\n            <div class=\"icon-spinner\"></div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(351);

/*@ngInject*/
var QuoteSummariesController = function QuoteSummariesController($scope, $rootScope, $timeout, $stateParams, quoteMediator, submissionConstant, currencyUtil, coreConstant, coreMediator, dateUtil, appTypeConfigurationModel) {
  $scope.i18n = locale;
  $scope.viewModel = {
    shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
    isLoading: true,
    quotes: [],
    isUnderwriter: appTypeConfigurationModel.isUnderwriterWorkstation()
  };
  function loadQuotes() {
    var submissionId = $stateParams.submissionId,
      proposalId = $stateParams.proposalId;
    $scope.viewModel.isLoading = true;
    quoteMediator.getQuoteList(submissionId, proposalId).then(function (quotes) {
      $scope.viewModel.quotes = _.map(quotes, function (quote) {
        quote.currencyFormat = currencyUtil.getCurrencyFormat(quote.currencyCode);
        return quote;
      });
      $scope.viewModel.isLoading = false;
    });
  }
  $scope.openQuote = function (quote) {
    $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, quote.objectUri);
  };
  $scope.$on(coreConstant.event.REFRESH_QUOTE, function (event, quoteSummary) {
    var index = _.indexOf($scope.viewModel.quotes, _.find($scope.viewModel.quotes, {
      id: quoteSummary.id
    }));
    $timeout(function () {
      if (index >= 0) {
        $scope.viewModel.quotes.splice(index, 1, quoteSummary);
      } else if (quoteSummary.proposalId === parseInt($stateParams.proposalId)) {
        $scope.viewModel.quotes.push(quoteSummary);
      }
    }, 0);
  });
  $scope.$on(coreConstant.event.QUOTE_DELETED, function (event, quoteSummary) {
    $timeout(function () {
      _.remove($scope.viewModel.quotes, {
        id: quoteSummary.id
      });
    }, 0);
  });
  loadQuotes();
};
QuoteSummariesController.$inject = ["$scope", "$rootScope", "$timeout", "$stateParams", "quoteMediator", "submissionConstant", "currencyUtil", "coreConstant", "coreMediator", "dateUtil", "appTypeConfigurationModel"];
angular.module('gw-um-submission').controller('quoteSummariesController', QuoteSummariesController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 351 */
/***/ (function(module) {

module.exports = JSON.parse("{\"quoteOrdinalNumber\":\"#\",\"quotes\":\"Quotes\",\"status\":\"Status\",\"statusReason\":\"Status Reason\",\"premium\":\"Premium\",\"sentAt\":\"Sent at\",\"receivedAt\":\"Received at\"}");

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

var path = '/content/reportsSummary/reportsSummary.tpl.html';
var html = "<div class=\"reportsSummaryContent\">\n  \n    <div class=\"table reportsSummaryGrid\" ng-if=\"!viewModel.isLoading && viewModel.reports.length > 0\">\n      <div class=\"tableRow header\">\n        <div class=\"tableCol colReports\">{{ i18n.reportsType }}</div>\n        <div class=\"tableCol colReports\">{{ i18n.reportsDescription }}</div>\n        <div class=\"tableCol colStatus colStatusHeader\">{{ i18n.status }}</div>\n      </div>\n      <div class=\"tableRow reportRow {{ getIdentifier(report) }}\" ng-click=\"openReport(report)\" ng-repeat=\"report in viewModel.reports\">\n            <div class=\"tableCol colType\">\n              <h3>{{report.name}}</h3>\n            </div>\n            <div class=\"tableCol colReports\">\n              <h3>{{report.description}}</h3>\n            </div>\n            <div class=\"tableCol colStatus\">\n                <wizard-breadcrumbs\n                    report-id=\"report.id\"\n                    progress-status=\"report.status\">\n                </wizard-breadcrumbs>\n            </div>\n    </div>\n\n  <div ng-if=\"viewModel.isLoading && viewModel.reports.length > 0\">\n      <div class=\"icon-spinner\"></div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(355);

/*@ngInject*/
var ReportsSummaryController = function ReportsSummaryController($scope, $rootScope, $timeout, $stateParams, reportMediator, submissionConstant, submissionUtil, coreConstant, coreMediator, dateUtil, appTypeConfigurationModel) {
  $scope.i18n = locale;
  $scope.viewModel = {
    isLoading: true,
    reports: []
  };
  function loadReports() {
    $scope.viewModel.isLoading = true;
    reportMediator.getReportList($stateParams.submissionId).then(function (reports) {
      $scope.viewModel.reports = reports;
      $scope.viewModel.isLoading = false;
    });
  }
  $scope.openReport = function (report) {
    $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, report.objectUri);
  };
  $scope.getIdentifier = function (report) {
    return _.camelCase(report.name);
  };
  loadReports();
};
ReportsSummaryController.$inject = ["$scope", "$rootScope", "$timeout", "$stateParams", "reportMediator", "submissionConstant", "submissionUtil", "coreConstant", "coreMediator", "dateUtil", "appTypeConfigurationModel"];
angular.module('gw-um-submission').controller('reportsSummaryController', ReportsSummaryController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 355 */
/***/ (function(module) {

module.exports = JSON.parse("{\"reportsType\":\"Report Type\",\"reportsDescription\":\"Description\",\"status\":\"Status\"}");

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/create/createSubmissionModal.tpl.html';
var html = "<div class=\"modal-view-wrapper\">\n    <!--Header-->\n    <div class=\"modal-header header\">\n        <h4 class=\"modal-title\">{{ i18n.modalTitle }}</h4>\n        <button ng-click=\"onClose()\" class=\"close btn btn-link\"><span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <!--Content-->\n    <div class=\"modal-body contentContainer\"\n         ui-browser-detection>\n        <ui-form-viewer submission-id=\"{{ ::submissionId }}\"\n                        form-id=\"{{ formId }}\"\n                        printable=\"false\"\n                        currency-code=\"{{ ::currencyCode }}\">\n        </ui-form-viewer>\n\n        <div class=\"prequalifiedLoading\" ng-if=\"isPrequalificationLoading\">\n            <div class=\"icon-spinner\">\n                <img src=\"" + __webpack_require__(37) + "\" />\n            </div>\n        </div>\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <action-buttons-bar context=\"context\"\n                            actions=\"actions\"\n                            notify-action-clicked=\"handleAction(action, file)\"\n                            hide-dropdown=\"true\"\n                            time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {var locale = __webpack_require__(359);

/*@ngInject*/
var CreateSubmissionModalController = function CreateSubmissionModalController($rootScope, $scope, $stateParams, $timeout, coreMediator, submissionId, formId, coreConstant, submissionConstant, submissionTransition, currentSubmissionModel, submissionMediator, submissionAction, submissionStateMediator, wizardMediator, wizardActionUtil, wizardActionHandlerUtil, formViewerConstant, browserUtil) {
  var originalFormId = formId;
  var timeoutList = [];
  $scope.i18n = locale;
  $scope.submissionId = submissionId;
  $scope.formId = originalFormId;
  $scope.isPrequalificationLoading = false;
  $scope.actions = [];
  $scope.context = {
    identifier: 'submission',
    actions: {},
    fallthrough: submissionConstant.CONTEXT_SUBMISSION,
    model: wizardMediator.getContext()
  };
  $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_END, function () {
    if (browserUtil.isIE11() || browserUtil.isEdge()) {
      $timeout(function () {
        $('.modal-content').width($('.formViewerContainer')[0].offsetWidth + 100);
      }, 500);
    }
  });
  $scope.$on(formViewerConstant.event.SUPPLEMENTAL_FORM_ADDED, function () {
    timeoutList.push($timeout(function () {
      $rootScope.$broadcast(formViewerConstant.event.OPTIMIZE_FORM_WATCHERS);
    }, 500));
  });
  function loadActions() {
    var actionIds = wizardActionUtil.getActionIds($scope.context.model.hierarchicalContextList);
    function loadActionsInternal() {
      wizardActionUtil.resetActions();
      wizardActionUtil.getAllActions(actionIds).then(function (allActions) {
        $scope.actions = allActions;
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    if (!_.isNil(currentSubmissionModel.getCurrentNewSubmission())) {
      loadActionsInternal();
    } else {
      submissionMediator.clearCurrentActionRegistrations().finally(function () {
        loadActionsInternal();
      });
    }
  }
  $scope.onClose = function () {
    var action = null;
    _.each($scope.actions, function (subAction) {
      action = _.find(subAction.actions, {
        name: submissionAction.DELETE_PRE_DRAFT
      });
      if (!_.isNil(action)) {
        return false;
      }
    });
    if (!_.isNil(action)) {
      $scope.handleAction(action);
    }
  };
  $scope.isConfirmButtonDisabled = function () {
    return false;
  };
  $scope.$on('$stateChangeStart', function () {
    $scope.$close();
    currentSubmissionModel.setCurrentNewSubmission(null);
  });
  $scope.$on(coreConstant.event.CLOSE_SUBMISSION_VIEW, function (event, submissionId) {
    if (submissionId === $scope.submissionId) {
      $scope.$dismiss();
      currentSubmissionModel.setCurrentNewSubmission(null);
    }
  });
  $scope.$on(coreConstant.event.START_MAKING_APPLICATION, function () {
    $scope.$close();
    currentSubmissionModel.setCurrentNewSubmission(null);
  });
  $scope.$on(submissionConstant.event.PREQUALIFICATION_STOP_LOADING, function () {
    $scope.isPrequalificationLoading = false;
  });
  $scope.$on(submissionConstant.event.PREQUALIFICATION_START_LOADING, function () {
    $scope.isPrequalificationLoading = true;
  });
  $scope.$on(submissionConstant.event.PREQUALIFICATION_CHANGE_FORM_ID, function (event, submission) {
    var newSubmission = submissionStateMediator.getNewSubmissionState();
    $scope.formId = submission.formId;
    newSubmission.formId = $scope.formId;
    submissionStateMediator.saveNewSubmissionState(newSubmission);
  });
  $scope.handleAction = function (action, file) {
    wizardActionHandlerUtil.handleAction(action, file);
  };
  $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function (event, updateActionsMessage, entityType, entityId) {
    var contextActions;
    if (entityType === 'submission' && parseInt($scope.submissionId) === entityId) {
      contextActions = _.find($scope.actions, {
        'contextType': submissionConstant.CONTEXT_SUBMISSION
      });
      if (contextActions) {
        contextActions.actions = updateActionsMessage.actions.actions;
      }
      $scope.actionsTimeLastModified = new Date().getTime();
      timeoutList.push($timeout(function () {}, 0));
    }
  });
  $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
    submissionMediator.clearCurrentActionRegistrations().finally(function () {
      loadActions();
    });
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (timeout) {
      $timeout.cancel(timeout);
    });
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  submissionMediator.loadSubmission(submissionId).then(function (submission) {
    currentSubmissionModel.setCurrentNewSubmission(submission);
    $scope.currencyCode = currentSubmissionModel.getCurrentNewSubmission().currencyCode;
  });
  loadActions();
};
CreateSubmissionModalController.$inject = ["$rootScope", "$scope", "$stateParams", "$timeout", "coreMediator", "submissionId", "formId", "coreConstant", "submissionConstant", "submissionTransition", "currentSubmissionModel", "submissionMediator", "submissionAction", "submissionStateMediator", "wizardMediator", "wizardActionUtil", "wizardActionHandlerUtil", "formViewerConstant", "browserUtil"];
angular.module('gw-um-submission').controller('createSubmissionModalController', CreateSubmissionModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 359 */
/***/ (function(module) {

module.exports = JSON.parse("{\"modalTitle\":\"Submission Details\"}");

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(51);

/*@ngInject*/
var DetailedHistoryGridColumnModel = function DetailedHistoryGridColumnModel($http, $q, $rootScope, xmlUtil, preferenceModel, gridColumnConstant) {
  var viewActiveOnlyCheckBoxChecked = true,
    columnPreference,
    selectedSubmissionFilterName,
    selectedTaskFilterName,
    openFilterUri;
  var detailedHistoryParams = {
    key: 'status',
    startIndex: 0,
    pageSize: 25,
    sortType: 'asc',
    searchString: '',
    filterUri: ''
  };
  this.setColumnPreference = function (preference) {
    columnPreference = preference;
  };
  this.getDetailedHistoryParams = function () {
    return submissionParams;
  };
  this.setDetailedHistoryParams = function (_submissionParams) {
    submissionParams = _submissionParams;
  };
  this.getGridColumnXML = function (col) {
    var count = 0;
    var xml = '<columns>';
    var columns = this.getDropdownColumns();
    angular.forEach(columns, function (item) {
      if (item.name === col.name) {
        columns[count].visible = col.visible;
        xml += '<column visible="' + col.visible + '" width="' + item.width + '">' + item.name + '</column>';
      } else {
        xml += '<column visible="' + item.visible + '" width="' + item.width + '">' + item.name + '</column>';
      }
      count++;
    });
    xml += '</columns>';
    return xml;
  };
  this.reset = function () {
    viewActiveOnlyCheckBoxChecked = true;
    selectedSubmissionFilterName = _.get(locale, 'myAgencySubmissions');
    selectedTaskFilterName = _.get(locale, 'myTasks');
    submissionParams = {
      key: 'status',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc',
      searchString: '',
      filterUri: ''
    };
    taskParams = {
      key: 'insuredName',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc',
      searchString: '',
      criteriaName: ''
    };
  };
  this.getDropdownColumns = function () {
    var columns = xmlUtil.parseString(preferenceModel.get(columnPreference));
    if (!columns) {
      return;
    }
    var dropDownArray = [];
    _.each(columns.column, function (item) {
      var visibleProp = item._visible === 'true';
      var columnName = item.__text;
      dropDownArray.push({
        displayName: _.get(locale, 'grid.header.' + columnName),
        name: columnName,
        width: item._width,
        visible: visibleProp,
        disabled: columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_INSURED
      });
    });
    return dropDownArray;
  };
  this.getGridColumns = function () {
    var colViewModel = {};
    var columns = xmlUtil.parseString(preferenceModel.get(columnPreference));
    if (!columns) {
      return;
    }
    _.each(columns.column, function (item) {
      var visibleProp = item._visible === 'true';
      colViewModel[item.__text] = visibleProp;
    });
    return colViewModel;
  };
};
DetailedHistoryGridColumnModel.$inject = ["$http", "$q", "$rootScope", "xmlUtil", "preferenceModel", "gridColumnConstant"];
angular.module('gw-um-submission').service('detailedHistoryGridColumnModel', DetailedHistoryGridColumnModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

var path = '/detailedHistory/detailedHistoryModal.tpl.html';
var html = "<div class=\"detailedHistoryModal\" >\n\n    <div class=\"titlebarWidget\">\n\t    <div class=\"modal-header\">\n\t        <h3 class=\"modal-title\">{{ i18n.title }}</h3>\n\t        <span class=\"insuredNameTitle\">: {{ viewModel.submission.insured.name }}</span>\n\t        <button class=\"close\" ng-click=\"$dismiss()\">\n\t            <span class=\"glyphicon glyphicon-remove\"></span>\n\t        </button>\n\t    </div>\n    </div>\n\n\n    <div class=\"modal-body landing gridWindow\" app-mode-configuration>\n        <div class=\"landingHeader\">\n            <div class=\"search has-feedback\">\n                <input type=\"search\"\n                       ng-model=\"viewModel.requestParams.searchString\"\n                       ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                       class=\"form-control\"\n                       ng-change=\"onFilterChange()\"\n                       placeholder=\"{{ viewModel.searchPlaceholder }}\" />\n\t            <span ng-if=\"viewModel.requestParams.searchString === ''\"\n\t                  class=\"glyphicon glyphicon-search form-control-feedback\"></span>\n\t            <span ng-if=\"viewModel.requestParams.searchString !== ''\"\n\t                  ng-click='onClearSearch()' class=\"glyphicon glyphicon-remove form-control-feedback \"></span>\n            </div>\n\n            <div class=\"filter\"\n                 uib-dropdown>\n                Filter:\n                <button class=\"btn-link activeFilter\" uib-dropdown-toggle>\n                    <span>{{ viewModel.selectedFieldFilter.name }}</span>\n                    <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                </button>\n                <ul uib-dropdown-menu>\n                    <li ng-repeat=\"filter in viewModel.searchFieldsFilters\"\n                        ng-click='onFieldFilterChange(filter)'><a>{{filter.name}}</a></li>\n                </ul>\n            </div>\n\n            <div class=\"filter dropdown\">\n\t            <ui-date-filter\n\t                criterion-template=\"viewModel.timeRangeCriterionTemplate\"\n\t                submission=\"viewModel.submission\"\n\t                advanced-filter-type=\"viewModel.advancedFilterType\">\n\t            </ui-date-filter>\n            </div>\n\n            <div class=\"actionButtonList\" uib-dropdown>\n\n                <button type=\"button\"\n                        class=\"btn btn-xs\"\n                        uib-dropdown-toggle>\n                    <span class=\"glyphicon glyphicon-cog\"></span>\n                </button>\n\n                <ul class=\"dropdown-menu-right\" uib-dropdown-menu>\n                    <!--Download Links-->\n                    <li role=\"menuitem\">\n                        <a uib-dropdown\n                           auto-close=\"outsideClick\"\n                           ng-click=\"onDownloadUrlClick('csv')\">\n                            <span>{{ i18n.downloadCsv }}</span>\n                        </a>\n                    </li>\n                    <li role=\"menuitem\">\n                        <a uib-dropdown\n                           auto-close=\"outsideClick\"\n                           ng-click=\"onDownloadUrlClick('xls')\">\n                            <span>{{ i18n.downloadExcel }}</span>\n                        </a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <!--Grid-->\n        <ui-history-grid grid-model=\"viewModel.gridModel\" parent=\"viewModel.controller\"/>\n\n    </div>\n\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(51);

/*@ngInject*/
var detailedHistoryModalController = function detailedHistoryModalController($rootScope, $scope, $controller, $timeout, $window, coreMediator, submission, submissionConstant, submissionGridConstant, submissionMediator, coreConstant, landingConstant, detailedHistoryGridColumnModel, detailedHistoryRepository) {
  var searchFieldsFilters = [{
    name: 'By User',
    value: 1
  }, {
    name: 'By Type',
    value: 4
  }, {
    name: 'By Message',
    value: 2
  }];
  var columnPreference = 'view.detailedHistoryColumnsForUnderwriter';
  detailedHistoryGridColumnModel.setColumnPreference(columnPreference);
  $scope.i18n = locale;
  $scope.viewModel = {
    controller: this,
    submission: submission,
    searchFieldsFilters: searchFieldsFilters,
    selectedFieldFilter: searchFieldsFilters[0],
    timeRangeCriterionTemplate: {
      'type': 1,
      'name': 'Date Range',
      'description': null,
      'required': false,
      'dataSetName': 'Date Range',
      'isDynamicDataSet': false,
      'variableName': 'tmeRange',
      'uiType': 8,
      'defaultShow': false,
      'allowedRolesConcat': ''
    },
    dropdownColumns: null,
    gridModel: detailedHistoryGridColumnModel,
    searchDelayInMilliSeconds: submissionConstant.searchDelay,
    requestParams: {
      submissionId: submission.id,
      searchString: '',
      filterFields: 1,
      startIndex: 0,
      numberOfRows: 20,
      key: 'timeCreated',
      sortType: 'desc'
    }
  };
  this.setStartIndex = function (startIndex) {
    $scope.viewModel.requestParams.startIndex = startIndex;
  };
  this.loadRecords = function (onSuccess, onError) {
    submissionMediator.getDetailedHistory($scope.viewModel.requestParams).then(onSuccess, onError);
    $scope.viewModel.dropdownColumns = detailedHistoryGridColumnModel.getDropdownColumns();
  };
  this.resetGridHeaders = function (requestParams) {
    $scope.viewModel.requestParams.key = requestParams.key;
    $scope.viewModel.requestParams.sortType = requestParams.sortType;
    $scope.onFilterChange();
  };
  $scope.onFilterChange = function () {
    $scope.$broadcast(submissionConstant.event.HISTORY_FILTER_CHANGE);
  };
  $scope.onClearSearch = function () {
    $scope.viewModel.requestParams.searchString = '';
    $scope.onFilterChange();
  };
  $scope.onFieldFilterChange = function (filter) {
    $scope.viewModel.selectedFieldFilter = filter;
    $scope.viewModel.requestParams.filterFields = filter.value;
    $scope.onFilterChange();
  };
  $scope.onDownloadUrlClick = function (downloadType) {
    if (downloadType === 'csv') {
      detailedHistoryRepository.getDownloadUrl($scope.viewModel.requestParams, 'csv').then(function (url) {
        $window.open(url, '_blank');
      });
    } else if (downloadType === 'xls') {
      detailedHistoryRepository.getDownloadUrl($scope.viewModel.requestParams, 'xls').then(function (url) {
        $window.open(url, '_blank');
      });
    }
  };
  $scope.$on(coreConstant.event.FILTER_UPDATED, function (event) {
    $scope.viewModel.requestParams.timeRange = $scope.viewModel.timeRangeCriterionTemplate.value;
    $scope.onFilterChange();
  });
  $scope.onColumnCheckboxClick = function (event, column) {
    var isRowClick = event.target.tagName !== 'INPUT',
      value;
    if (!column.disabled) {
      if (isRowClick) {
        column.visible = !column.visible;
      }
      value = detailedHistoryGridColumnModel.getGridColumnXML(column);
      coreMediator.updateUserPreferences(columnPreference, value).then(function () {
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_COLUMNS);
      });
    }
    event.preventDefault();
    event.stopPropagation();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
detailedHistoryModalController.$inject = ["$rootScope", "$scope", "$controller", "$timeout", "$window", "coreMediator", "submission", "submissionConstant", "submissionGridConstant", "submissionMediator", "coreConstant", "landingConstant", "detailedHistoryGridColumnModel", "detailedHistoryRepository"];
angular.module('gw-um-submission').controller('detailedHistoryModalController', detailedHistoryModalController);

/***/ }),
/* 364 */
/***/ (function(module, exports) {

/*@ngInject*/
var DetailedHistoryRepository = function DetailedHistoryRepository(baseRepository, sortUtil, coreMediator) {
  angular.extend(this, baseRepository);
  this.getParams = function (requestParams) {
    var params = {
      submissionId: requestParams.submissionId,
      accountId: requestParams.accountId,
      filterText: requestParams.searchString,
      filterFields: requestParams.filterFields,
      timeRange: requestParams.timeRange,
      startIndex: requestParams.startIndex,
      numberOfRows: requestParams.numberOfRows
    };
    return params;
  };
  this.getDetailedHistory = function (requestParams) {
    var params = this.getParams(requestParams);
    var url = '/rest/Audit',
      config = {
        params: params
      };
    return this.get(url, config).then(function (responseData) {
      var sortedRecords = responseData.records.sort(sortUtil.naturalSortObject(requestParams.key));
      if (requestParams.sortType === 'desc') {
        sortedRecords.reverse();
      }
      responseData.records = sortedRecords;
      return responseData;
    });
  };
  this.getDownloadUrl = function (requestParams, type) {
    var paramsString = "&currentState=submission",
      params = this.getParams(requestParams);
    for (var key in params) {
      var value = params[key];
      if (value && value != '') {
        paramsString += "&" + key + "=" + encodeURIComponent(value);
      }
    }
    return coreMediator.getSingleUseToken().then(function (token) {
      paramsString += "&t=" + encodeURIComponent(token);
      return "/auditLogData/DetailedHistory." + type + "?exportType=" + type + paramsString;
    });
  };
};
DetailedHistoryRepository.$inject = ["baseRepository", "sortUtil", "coreMediator"];
angular.module('gw-um-submission').service('detailedHistoryRepository', DetailedHistoryRepository);

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

var path = '/detailedHistory/historyGrid.tpl.html';
var html = "<div class=\"historyGrid\">\n\n    <!--Grid-->\n    <div class=\"content landingContent\"\n         ui-widget-grid-scroll-manager\n         ui-scroll-detection\n         scroll-fixed-grid-arrow>\n\n        <!--Grid Header-->\n        <div class=\"columnHeader\">\n            <div class=\"columnRow columnDisposition\">\n\n                <div class=\"colDate\"\n                     ui-grid-sortable-header\n                     request-params=\"$ctrl.requestParams\"\n                     reset-grid-headers=\"resetGridHeaders($value)\"\n                     item-name=\"timeCreated\"\n                     item-label=\"detailedHistory.grid.header.colDate\"\n                     ng-if=\"$ctrl.colViewModel.colDate\"></div>\n\n                <div class=\"colUser\"\n                     ui-grid-sortable-header\n                     request-params=\"$ctrl.requestParams\"\n                     reset-grid-headers=\"resetGridHeaders($value)\"\n                     item-name=\"actorName\"\n                     item-label=\"detailedHistory.grid.header.colUser\"\n                     ng-if=\"$ctrl.colViewModel.colUser\"></div>\n\n                <div class=\"colType\"\n                     ui-grid-sortable-header\n                     request-params=\"$ctrl.requestParams\"\n                     reset-grid-headers=\"resetGridHeaders($value)\"\n                     item-name=\"eventType\"\n                     item-label=\"detailedHistory.grid.header.colType\"\n                     ng-if=\"$ctrl.colViewModel.colType\"></div>\n\n                <div class=\"colAction\"\n                     ui-grid-sortable-header\n                     request-params=\"$ctrl.requestParams\"\n                     reset-grid-headers=\"resetGridHeaders($value)\"\n                     item-name=\"eventAction\"\n                     item-label=\"detailedHistory.grid.header.colAction\"\n                     ng-if=\"$ctrl.colViewModel.colAction\"></div>\n\n                <div class=\"colDefault colMessage\"\n                     ui-grid-sortable-header\n                     request-params=\"$ctrl.requestParams\"\n                     reset-grid-headers=\"resetGridHeaders($value)\"\n                     item-name=\"message\"\n                     item-label=\"detailedHistory.grid.header.colMessage\"\n                     ng-if=\"$ctrl.colViewModel.colMessage\"></div>\n\n                <div class=\"colDefault colDetails\"\n                     ui-grid-sortable-header\n                     request-params=\"$ctrl.requestParams\"\n                     reset-grid-headers=\"resetGridHeaders($value)\"\n                     item-name=\"details\"\n                     item-label=\"detailedHistory.grid.header.colDetails\"\n                     ng-if=\"$ctrl.colViewModel.colDetails\"></div>\n\n                <div class=\"col scrollBar\"></div>\n            </div>\n        </div>\n\n\n        <div class=\"scrollVerticalContainer\">\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"$ctrl.records\"\n                 ng-if=\"!$ctrl.isLoading\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                        <div class=\"rowDrawerWrapper\"\n                             ng-class=\"{ selected: item.selected && $ctrl.isDrawerOpen }\">\n\n                            <div class=\"columnRow\"\n                                 ng-class=\"{ selected: item.selected }\"\n                                 ng-click=\"setSelectedItem($event, item)\">\n\n                                <div class=\"col colDate date\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{ item.timeCreated | utcDateFilter: $ctrl.shortDateFormat + ' hh:mm A' : true}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isDateToolTip}}\"\n                                     ui-is-tooltip-enabled=\"item.isDateToolTip\"\n                                     ng-if=\"$ctrl.colViewModel.colDate\">{{ item.timeCreated | utcDateFilter: $ctrl.shortDateFormat + ' hh:mm A' : true }}\n                                </div>\n\n                                <div class=\"col colUser\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.actorName}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isActorNameToolTip}}\"\n                                     ui-is-tooltip-enabled=\"item.isActorNameToolTip\"\n                                     ng-if=\"$ctrl.colViewModel.colUser\">{{ item.actorName }}\n                                </div>\n                                <div class=\"col colType\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.eventType}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isEventTypeToolTip}}\"\n                                     ui-is-tooltip-enabled=\"item.isEventTypeToolTip\"\n                                     ng-if=\"$ctrl.colViewModel.colType\">{{ item.eventType }}\n                                </div>\n                                <div class=\"col colAction\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.eventAction}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isEventActionToolTip}}\"\n                                     ui-is-tooltip-enabled=\"item.isEventActionToolTip\"\n                                     ng-if=\"$ctrl.colViewModel.colAction\">{{ item.eventAction }}\n                                </div>\n                                <div class=\"col colDefault colMessage\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.message}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isMessageToolTip}}\"\n                                     ui-is-tooltip-enabled=\"item.isMessageToolTip\"\n                                     ng-if=\"$ctrl.colViewModel.colMessage\"><span class=\"longText\">{{ item.message }}</span>\n                                </div>\n                                <div class=\"col colDefault colDetails\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.details}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isDetailsToolTip}}\"\n                                     ui-is-tooltip-enabled=\"item.isDetailsToolTip\"\n                                     ng-if=\"$ctrl.colViewModel.colDetails\"><span class=\"longText\">{{ item.details }}</span>\n                                </div>\n                            </div>\n\n                        </div>\n\n                    </script>\n            </div>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"$ctrl.isGridEmpty && !$ctrl.isLoading\">\n                {{ $ctrl.i18n.grid.emptyMessage }}\n            </div>\n\n        </div>\n\n        <div class=\"icon-spinner\" ng-if=\"$ctrl.isLoading\"></div>\n    </div>\n\n    <ui-grid-paging-component\n        ng-hide=\"$ctrl.totalRecords === 0\"\n        class=\"landingPagination\"\n        start-index=\"$ctrl.requestParams.startIndex\"\n        page-size=\"$ctrl.requestParams.pageSize\"\n        total-records=\"$ctrl.totalRecords\"\n        record-count-text=\"$ctrl.recordCountText\"\n        records-count-text=\"$ctrl.recordsCountText\"\n        translation-key=\"$ctrl.translationKey\"\n        on-change=\"$ctrl.onPagingChange($event, params)\"></ui-grid-paging-component>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 367 */
/***/ (function(module, exports) {

var HistoryGridComponent = {
  templateUrl: '/detailedHistory/historyGrid.tpl.html',
  controller: 'historyGridController',
  bindings: {
    parent: '<',
    gridModel: '<',
    widgetConfig: '<'
  }
};
angular.module('gw-um-submission').component('uiHistoryGrid', HistoryGridComponent);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(51);

/*@ngInject*/
var historyGridController = function historyGridController($controller, $rootScope, $scope, coreMediator, coreConstant, landingConstant, submissionGridConstant, submissionConstant) {
  angular.extend(this, $controller('baseGridWidgetController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    this.onInit();
    this.i18n = locale;
    $scope.viewModel = {
      showPaging: true
    };
    $scope.recordCountText = _.get(locale, 'historyCount');
    this.isGenericItem = true;
    this.isUserTypeUpdated = true;
    this.requestParams = {
      key: 'type',
      pageSize: 20,
      startIndex: 0,
      sortType: 'asc',
      criteriaName: 'default'
    };
    this.initLandingPage();
  };
  this.onPagingChange = function ($event, params) {
    this.startIndex = params.startIndex;
    $scope.$parent.viewModel.requestParams.startIndex = params.startIndex;
    this.loadGrid();
  };
  this.updateFilterFromPreferences = function () {
    $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
  };
  this.loadRecords = function (onSuccess, onError) {
    this.parent.loadRecords(onSuccess, onError);
  };
  this.generateColumns = function () {
    this.colViewModel = this.gridModel.getGridColumns();
    this.dropdownColumns = this.gridModel.getDropdownColumns();
  };
  $scope.$on(submissionConstant.event.HISTORY_FILTER_CHANGE, function (event) {
    this.resetGridPaging();
  }.bind(this));
  $scope.resetGridHeaders = function (requestParams) {
    this.parent.resetGridHeaders(requestParams);
  }.bind(this);
  $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function () {
    this.resetGridColumns();
  }.bind(this));
};
historyGridController.$inject = ["$controller", "$rootScope", "$scope", "coreMediator", "coreConstant", "landingConstant", "submissionGridConstant", "submissionConstant"];
angular.module('gw-um-submission').controller('historyGridController', historyGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

var path = '/form/submissionFormViewer.tpl.html';
var html = "<ui-form-viewer submission-id=\"{{ ::viewModel.submissionId }}\"\n                form-id=\"{{ ::viewModel.formId }}\"\n                display-form-name=\"true\"\n                effective-date=\"{{ ::viewModel.effectiveDate }}\"\n                currency-code=\"{{ ::viewModel.currencyCode }}\">\n</ui-form-viewer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 371 */
/***/ (function(module, exports) {

/*@ngInject*/
var SubmissionFormViewerController = function SubmissionFormViewerController($scope, $stateParams, currentSubmissionModel) {
  $scope.submissionId = parseInt($stateParams.submissionId);
  $scope.viewModel = {
    formIsLoaded: false,
    formId: $stateParams.formId,
    effectiveDate: currentSubmissionModel.getCurrentSubmission().effectiveDate,
    currencyCode: currentSubmissionModel.getCurrentSubmission().currencyCode
  };
};
SubmissionFormViewerController.$inject = ["$scope", "$stateParams", "currentSubmissionModel"];
angular.module('gw-um-submission').controller('submissionFormViewerController', SubmissionFormViewerController);

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var CurrentSubmissionModel = function CurrentSubmissionModel($rootScope, coreConstant, submissionConstant) {
  var openSubmissionList = [],
    selectedSubmission = null,
    currentSubmission = null,
    currentNewSubmission = null,
    registrations = [],
    actionsRegistrations = {},
    doCreateDraftEmail = false,
    sendMailUserId;
  function findSubmission(submissionId) {
    return _.find(openSubmissionList, {
      id: submissionId
    });
  }
  this.getSelectedSubmission = function () {
    return selectedSubmission;
  };
  this.setSelectedSubmission = function (submission) {
    selectedSubmission = submission;
  };
  this.getCurrentSubmission = function () {
    return currentSubmission || currentNewSubmission;
  };
  this.getCurrentNewSubmission = function () {
    return currentNewSubmission;
  };
  this.getSubmissionById = function (submissionId) {
    return findSubmission(submissionId);
  };
  this.setCurrentSubmission = function (submission) {
    var existingSubmission = findSubmission(submission.id);
    currentSubmission = submission;
    selectedSubmission = currentSubmission;
    if (!existingSubmission) {
      openSubmissionList.push(submission);
    } else {
      this.updateOpenSubmission(submission);
    }
    $rootScope.$broadcast(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, currentSubmission);
  };
  this.setCurrentNewSubmission = function (newSubmission) {
    currentNewSubmission = newSubmission;
  };
  this.openSubmission = function (submission) {
    openSubmissionList.push(submission);
  };
  this.getOpenSubmissionList = function () {
    return openSubmissionList;
  };
  this.resetOpenSubmissionList = function () {
    openSubmissionList = [];
  };
  this.closeSubmission = function (submissionId) {
    var openSubmissionIndex = _.indexOf(openSubmissionList, findSubmission(submissionId)),
      isCurrentSubmission = currentSubmission ? submissionId === currentSubmission.id : false,
      isSelectedSubmission = selectedSubmission ? submissionId === selectedSubmission.id : false,
      isCurrentNewSubmission = currentNewSubmission ? submissionId === currentNewSubmission.id : false,
      hasOpenSubmissions;
    if (openSubmissionIndex >= 0) {
      openSubmissionList.splice(openSubmissionIndex, 1);
      hasOpenSubmissions = openSubmissionList.length > 0;
      if (isCurrentNewSubmission) {
        $rootScope.$broadcast(coreConstant.event.CLOSE_SUBMISSION_VIEW, currentNewSubmission.id);
      } else if (isCurrentSubmission) {
        if (hasOpenSubmissions) {
          currentSubmission = openSubmissionList[0];
          selectedSubmission = currentSubmission;
          $rootScope.$broadcast(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, currentSubmission);
        } else {
          currentSubmission = null;
          selectedSubmission = null;
          $rootScope.$broadcast(submissionConstant.event.CLOSE_SUBMISSION_MODULE, currentSubmission);
        }
      } else if (isSelectedSubmission) {
        if (hasOpenSubmissions) {
          selectedSubmission = openSubmissionList[0];
        }
      }
      $rootScope.$broadcast(submissionConstant.event.OPEN_SUBMISSION_LIST_CHANGE);
    }
  };
  this.updateOpenSubmission = function (submission) {
    var openSubmissionIndex = _.indexOf(openSubmissionList, findSubmission(submission.id)),
      isCurrentSubmission = currentSubmission ? submission.id === currentSubmission.id : false,
      submissionExists = openSubmissionIndex !== -1;
    if (submissionExists) {
      openSubmissionList[openSubmissionIndex] = submission;
      if (isCurrentSubmission) {
        currentSubmission = submission;
        selectedSubmission = currentSubmission;
      }
      $rootScope.$broadcast(submissionConstant.event.OPEN_SUBMISSION_LIST_CHANGE);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_SUBMISSION, submission);
    }
  };
  this.resetCurrentSubmission = function () {
    // @todo: remove the submission from the submissionList
    currentSubmission = null;
    $rootScope.$broadcast(submissionConstant.event.CURRENT_SUBMISSION_CHANGE);
  };
  this.addRegistration = function (url) {
    var doAdd = true;
    _.each(registrations, function (registration) {
      if (JSON.stringify(url) === JSON.stringify(registration)) {
        doAdd = false;
      }
    });
    if (doAdd) {
      registrations.push(url);
    }
  };
  this.addActionsRegistration = function (key, url) {
    actionsRegistrations[key] = url;
  };
  this.hasActionsRegistration = function (key) {
    return !_.isNil(actionsRegistrations[key]);
  };
  this.getActionsRegistration = function (key) {
    return actionsRegistrations[key];
  };
  this.removeActionsRegistration = function (key) {
    var url = actionsRegistrations[key];
    delete actionsRegistrations[key];
    return url;
  };
  this.clearActionsRegistrations = function () {
    actionsRegistrations = {};
  };
  this.clearRegistrations = function () {
    registrations = [];
    actionsRegistrations = {};
  };
  this.getRegistrationsClone = function () {
    return _.clone(registrations);
  };
  this.getActionsRegistrationsClone = function () {
    return _.cloneDeep(actionsRegistrations);
  };
  $rootScope.$on(coreConstant.event.UPDATE_SUBMISSION, function (event, submission) {
    this.updateOpenSubmission(submission);
  }.bind(this));
};
CurrentSubmissionModel.$inject = ["$rootScope", "coreConstant", "submissionConstant"];
angular.module('gw-um-submission').service('currentSubmissionModel', CurrentSubmissionModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

var path = '/modification/detail/modificationDetail.tpl.html';
var html = "<div class=\"modificationDetail\" ng-if=\"shouldShowModificationDetails()\">\n      <a class=\"modificationStatus btn-link modificationLink\"\n          ng-click=\"onOpenRecentChanges()\">\n        {{viewModel.modificationStatusText}}\n      </a>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(376);

/*@ngInject*/
var ModificationDetailController = function ModificationDetailController($scope, $stateParams, currentSubmissionModel, submissionMediator, submissionActionUtil, submissionConstant, formViewerConstant, formMediator) {
  $scope.i18n = locale;
  $scope.viewModel = {
    submission: null,
    showModificationDetail: false,
    currentFormData: null
  };
  function loadModifications(submission) {
    if (submission.changeSetId) {
      submissionMediator.loadChangeSet(submission.changeSetId, true).then(onChangeSetLoaded);
      $scope.viewModel.showModificationDetails = true;
    } else {
      $scope.viewModel.showModificationDetails = false;
    }
    function onChangeSetLoaded(changeSet) {
      if (changeSet.endTime) {
        $scope.viewModel.modificationStatusText = _.get($scope.i18n, 'modificationsSubmitted');
      } else {
        $scope.viewModel.modificationStatusText = _.get($scope.i18n, 'modificationsInProgress');
      }
    }
  }
  $scope.onOpenRecentChanges = function () {
    var submission = submissionMediator.getCurrentSubmission();
    submissionActionUtil.handleReviewModifications(submission);
  };
  $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (e, formData) {
    $scope.viewModel.currentFormData = formData;
    loadModifications(submissionMediator.getCurrentSubmission());
  });
  $scope.shouldShowModificationDetails = function () {
    if (_.isNil($scope.viewModel.currentFormData) || !$scope.viewModel.currentFormData.uiFormTemplate) {
      return false;
    }
    return $scope.viewModel.showModificationDetails;
  };
  $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
    loadModifications(submission);
  });
  loadModifications(submissionMediator.getCurrentSubmission());
  $scope.viewModel.currentFormData = formMediator.getFormStructure(parseInt($stateParams.formId));
};
ModificationDetailController.$inject = ["$scope", "$stateParams", "currentSubmissionModel", "submissionMediator", "submissionActionUtil", "submissionConstant", "formViewerConstant", "formMediator"];
angular.module('gw-um-submission').controller('modificationDetailController', ModificationDetailController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 376 */
/***/ (function(module) {

module.exports = JSON.parse("{\"modificationsInProgress\":\"Modifications in Progress\",\"modificationsSubmitted\":\"Modifications Submitted\"}");

/***/ }),
/* 377 */
/***/ (function(module, exports) {

/*@ngInject*/
var AcknowledgeModificationsRepository = function AcknowledgeModificationsRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.acknowledgeModifications = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/acknowlegeModifications';
    return this.post(url);
  };
};
AcknowledgeModificationsRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('acknowledgeModificationsRepository', AcknowledgeModificationsRepository);

/***/ }),
/* 378 */
/***/ (function(module, exports) {

/*@ngInject*/
var DiscardModificationsRepository = function DiscardModificationsRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.discardModifications = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/discardModifications';
    return this.post(url);
  };
};
DiscardModificationsRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('discardModificationsRepository', DiscardModificationsRepository);

/***/ }),
/* 379 */
/***/ (function(module, exports) {

/*@ngInject*/
var ModificationsRepository = function ModificationsRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadChangeSet = function (changeSetId) {
    var url = '/rest/ChangeSet/' + changeSetId;
    return this.get(url);
  };
};
ModificationsRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('modificationsRepository', ModificationsRepository);

/***/ }),
/* 380 */
/***/ (function(module, exports) {

/*@ngInject*/
var SubmitModificationsRepository = function SubmitModificationsRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.submitModifications = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/submitModifications';
    return this.post(url);
  };
};
SubmitModificationsRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('submitModificationsRepository', SubmitModificationsRepository);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

var path = '/modification/reviewChanges/reviewChangesModal.tpl.html';
var html = "<div class=\"genericModalContent\" ng-if=\"!viewModel.isLoading\"  ng-class=\"{'noChanges': viewModel.recentChangeList.length==0}\">\n\n    <!--Header-->\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title reviewChangesModalTitle\">{{ viewModel.title }}</h3>\n        <button ng-click=\"$dismiss()\" class=\"close\"><span class=\"glyphicon glyphicon-remove\"></span></button>\n    </div>\n    <div ng-if=\"viewModel.showMessage && viewModel.recentChangeList.length>0\" class=\"endorseMessage\">\n        <span>{{ i18n.afterSubmitting }}</span>\n    </div>\n    <div class=\"modal-body\" ng-class=\"{'noChanges': viewModel.recentChangeList.length==0}\">\n        <div ng-if=\"viewModel.recentChangeList.length==0 && !viewModel.isLoading\"\n            class=\"noChangesText\">\n            <span>{{ i18n.noChanges }}</span>\n        </div>\n        <!--Grid Header-->\n        <div class=\"gridHeader\"\n             ng-if=\"viewModel.recentChangeList.length && !viewModel.isLoading\">\n\n            <div class=\"fieldName\">{{ i18n.fieldName }}</div>\n            <div class=\"action\">{{ i18n.action }}</div>\n            <div class=\"oldValue\">{{ i18n.oldValue }}</div>\n            <div class=\"newValue\">{{ i18n.newValue }}</div>\n            <div class=\"modifiedBy\">{{ i18n.modifiedBy}}</div>\n            <div class=\"dateModified\">{{ i18n.dateModified }}</div>\n\n        </div>\n\n        <!--Grid Row Container-->\n        <div class=\"gridRowContainer\"\n             ng-if=\"viewModel.recentChangeList.length && !viewModel.isLoading\"\n             ui-scroll-detection\n             ui-scroll-detection-target=\".gridHeader\">\n\n            <!--Grid Row-->\n            <div class=\"gridRow\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ng-repeat=\"item in viewModel.recentChangeList\">\n\n                <div class=\"fieldName\"\n                     uib-tooltip=\"{{ item.fieldName }}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\">{{ item.fieldName }}</div>\n                <div class=\"action\"\n                     uib-tooltip=\"{{ item.action }}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\">{{ item.action }}</div>\n                <div class=\"oldValue\"\n                     uib-tooltip=\"{{ item.oldValue }}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\">{{ item.oldValue }}</div>\n                <div class=\"newValue\"\n                     uib-tooltip=\"{{ item.newValue }}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\">{{ item.newValue }}</div>\n                <div class=\"modifiedBy\"\n                     uib-tooltip=\"{{ item.actorName }}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\">{{ item.actorName }}</div>\n                <div class=\"dateModified\"\n                     uib-tooltip=\"{{ item.timeCreated | utcDateFilter: viewModel.shortDateFormat + ' hh:mm A' : true }}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\">{{ item.timeCreated | utcDateFilter: viewModel.shortDateFormat + ' hh:mm A' : true }}</div>\n\n            </div>\n\n        </div>\n\n        <div ng-if=\"viewModel.isLoading\" class=\"icon-spinner\"></div>\n    </div>\n\n    <!--Modal Footer-->\n    <div class=\"modal-footer\"\n         ng-if=\"!viewModel.isReadOnly\">\n\n        <button class=\"btn btn-success submitChanges\"\n                ng-click=\"onSubmitChanges()\"\n                ng-disabled=\"isButtonDisabled()\">{{ viewModel.continueButtonLabel\n            }}\n        </button>\n        <button class=\"btn btn-link cancel\"\n                ng-if=\"viewModel.showCancel\"\n                ng-click=\"$dismiss()\"\n                ng-disabled=\"viewModel.isLoading\">{{ i18n.cancel }}\n        </button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(384);

/*@ngInject*/
var ReviewChangesModalController = function ReviewChangesModalController($rootScope, $scope, options, submissionConstant, submissionMediator, formViewerConstant, coreMediator, coreConstant, loadingBarHandler) {
  $scope.i18n = locale;
  $scope.viewModel = {
    isLoading: true,
    isReadOnly: options.isReadOnly === true,
    title: options.title,
    continueButtonLabel: options.continueButtonLabel,
    continueButtonAction: options.continueButtonAction,
    navigateToOverviewBeforeContinue: options.navigateToOverviewBeforeContinue,
    showCancel: options.showCancel !== false,
    showMessage: options.showMessage,
    recentChangeList: [],
    loadingBarMessage: options.loadingBarMessage,
    shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat')
  };
  function loadRecentChanges() {
    function handleSuccess(result) {
      $scope.viewModel.recentChangeList = result.changeList;
      $scope.viewModel.isLoading = false;
    }
    $scope.viewModel.isLoading = true;
    submissionMediator.loadChangeSet(options.changeSetId).then(handleSuccess);
  }
  $scope.onSubmitChanges = function () {
    function onSuccess() {
      $scope.viewModel.isLoading = false;
      loadingBarHandler.hideLoadingBar();
      $scope.$close();
    }
    function onError(error) {
      $scope.viewModel.isLoading = false;
    }
    $scope.viewModel.isLoading = true;
    if ($scope.viewModel.navigateToOverviewBeforeContinue) {
      // we send them to the overview screen before we submit the modifications because
      // the forms are going to be different and will result in errors if we try to load them in
      // their current state, making sure to refresh the form id, since the
      // Submission form on the overview is now deleted and recreated as well.
      $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW, true /*refreshFormId*/);
    }
    if (_.isNil($scope.viewModel.continueButtonAction)) {
      $scope.viewModel.isLoading = false;
      $scope.$close();
    } else {
      loadingBarHandler.showLoadingBar($scope.viewModel.loadingBarMessage);
      $scope.viewModel.continueButtonAction(options.entityId).then(onSuccess, onError);
    }
  };
  $scope.isButtonDisabled = function () {
    return $scope.viewModel.isLoading || !$scope.viewModel.recentChangeList.length && !_.isNil($scope.viewModel.continueButtonAction);
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  loadRecentChanges();
};
ReviewChangesModalController.$inject = ["$rootScope", "$scope", "options", "submissionConstant", "submissionMediator", "formViewerConstant", "coreMediator", "coreConstant", "loadingBarHandler"];
angular.module('gw-um-submission').controller('reviewChangesModalController', ReviewChangesModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 384 */
/***/ (function(module) {

module.exports = JSON.parse("{\"fieldName\":\"Field Name\",\"action\":\"Action\",\"oldValue\":\"Old Value\",\"newValue\":\"New Value\",\"modifiedBy\":\"Modified By\",\"dateModified\":\"Date Modified\",\"cancel\":\"Cancel\",\"noChanges\":\"No changes have been made to the application.\",\"afterSubmitting\":\"After submitting, these changes can always be viewed from the Actions menu\",\"loadingBar\":\"Submitting modifications...\"}");

/***/ }),
/* 385 */
/***/ (function(module, exports) {

var path = '/modification/modification.tpl.html';
var html = "<div ng-class=\"{'modificationsStripeInProgress': viewModel.changeSetExists}\">\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 386 */
/***/ (function(module, exports) {

/*@ngInject*/
var ModificationDetailController = function ModificationDetailController($scope, $rootScope, $stateParams, submissionMediator, submissionConstant, coreMediator, currentSubmissionModel) {
  $scope.viewModel = {
    shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
    changeSetExists: false,
    changeSetSubmitted: false
  };
  function refreshSubmissionModificationInfo(submission) {
    if (submission.changeSetId) {
      $scope.viewModel.changeSetExists = true;
      submissionMediator.loadChangeSet(submission.changeSetId).then(onChangeSetLoaded);
    } else {
      $scope.viewModel.changeSetExists = false;
      $scope.viewModel.changeSetSubmitted = false;
    }
    function onChangeSetLoaded(changeSet) {
      if (changeSet.endTime) {
        $scope.viewModel.changeSetSubmitted = true;
      }
    }
  }
  $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
    if (parseInt($stateParams.submissionId) === submission.id) {
      refreshSubmissionModificationInfo(submission);
    }
  });
  refreshSubmissionModificationInfo(currentSubmissionModel.getCurrentSubmission());
};
ModificationDetailController.$inject = ["$scope", "$rootScope", "$stateParams", "submissionMediator", "submissionConstant", "coreMediator", "currentSubmissionModel"];
angular.module('gw-um-submission').controller('modificationController', ModificationDetailController);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIDrawerSlideDirective = function UIDrawerSlideDirective($rootScope, $window, coreConstant, $timeout) {
  var linkFunction = function linkFunction($scope, $elm) {
    var window = $($window),
      element = $($elm),
      updateNavigationBasedOnWindowSize;
    function openDrawer() {
      element.addClass('open is-animated');
      element.removeClass('closed');
    }
    function closeDrawer() {
      element.addClass('closed is-animated');
      element.removeClass('open');
    }
    function removeAnimationClass(event) {
      var target;
      if (element.hasClass('is-animated')) {
        element.removeClass('is-animated');
        target = $(event.target);
        if (target.hasClass('navigation')) {
          $rootScope.$broadcast(coreConstant.NAVIGATION_DRAWER_TOGGLED);
        }
      }
    }
    function updateDrawerState() {
      if ($scope.submissionViewModel.isDrawerOpen) {
        openDrawer();
      } else {
        closeDrawer();
      }
    }
    updateNavigationBasedOnWindowSize = _.debounce(function () {
      if ($scope.isLargeScreen) {
        if (window.width() < 1200) {
          // 992, 768, 1200
          $scope.submissionViewModel.isDrawerOpen = false;
          closeDrawer();
        } else {
          $scope.submissionViewModel.isDrawerOpen = true;
          openDrawer();
        }
        $timeout(function () {}, 0);
      } else {
        $scope.submissionViewModel.isDrawerOpen = false;
      }
    }, 10);
    $scope.$watch('submissionViewModel.isDrawerOpen', updateDrawerState);
    element.on('transitionend webkitTransitionEnd oTransitionEnd', removeAnimationClass);
    window.on('resize.uiDrawerSlide', updateNavigationBasedOnWindowSize);
    $scope.$on('$destroy', function () {
      element.off('transitionend webkitTransitionEnd oTransitionEnd', removeAnimationClass);
      window.off('resize.uiDrawerSlide', updateNavigationBasedOnWindowSize);
    });
    updateNavigationBasedOnWindowSize();
    updateDrawerState();
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIDrawerSlideDirective.$inject = ["$rootScope", "$window", "coreConstant", "$timeout"];
angular.module('gw-um-submission').directive('uiDrawerSlide', UIDrawerSlideDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

var path = '/navigation/navigation.tpl.html';
var html = "<div class=\"navigationContainer\"\n     ui-focus-manager=\"navigationContainer\">\n\n    <!--Navigation Content Container-->\n    <div class=\"navContent\">\n\n        <!--Submission Status-->\n        <submission-status class=\"submissionStatus\"\n                           ng-if=\"submissionViewModel.isDrawerOpen && config.showHeader\"></submission-status>\n\n        <div class=\"navigationListContainer\"\n             ui-scroll-detection>\n\n            <div class=\"closedDrawerBackgroundToggle\"\n                 ng-if=\"!submissionViewModel.isDrawerOpen\"\n                 ng-click=\"onToggleDrawer()\"></div>\n\n            <!--Navigation List-->\n            <div class=\"navigationList\"\n                 ng-if=\"submissionViewModel.isDrawerOpen\">\n\n                <!--First Level-->\n                <div class=\"parentItem firstLevel\"\n                     ng-repeat=\"parentItem in viewModel.navigationList\">\n\n                    <div class=\"navigationRow {{ getIdentifier(parentItem) }}\"\n                         ng-class=\"{ selected: parentItem.selected }\">\n\n                        <div class=\"icon-spinner\" ng-if=\"submissionViewModel.showFormRenderingSpinner\"></div>\n\n                        <button class=\"btn-link navigationLabel {{ parentItem.id }}\"\n                                ng-click=\"onNavItemClicked($event, parentItem)\"\n                                ui-enter=\"onNavItemClicked($event, parentItem)\"\n                                ng-disabled=\"!parentItem.enabled\"\n                                tabindex=\"1\">\n                            <span ng-class=\"{ shimmer: submissionViewModel.showFormRenderingSpinner}\">{{ parentItem.displayName }}</span>\n                        </button>\n\n                        <div class=\"requiredFieldContainer\" ng-click=\"onRequiredIndicatorClicked($event, parentItem)\">\n                            <!-- Note that 2 is the value of navigationItemType.FORM -->\n                            <div class=\"label label-warning\"\n                                 ng-if=\"(!parentItem.isOpen || parentItem.type === 2) && parentItem.requiredFieldCount > 0\" ng-bind=\"parentItem.requiredFieldCount\"></div>\n                        </div>\n\n                        <div class=\"treeControlArrow\">\n                            <button class=\"btn-link glyphicon glyphicon-chevron-right\"\n                                    ng-if=\"parentItem.children.length\"\n                                    ng-click=\"openNavItem($event, parentItem)\"\n                                    ng-class=\"{ isOpen: parentItem.isOpen, enableTransition: viewModel.enableTreeArrowTransition }\"\n                                    ng-disabled=\"!parentItem.enabled\"\n                                    tabindex=\"1\">\n                            </button>\n                        </div>\n                    </div>\n\n                    <!--Second Level-->\n                    <div class=\"childItem secondLevel\"\n                         ng-repeat=\"secondLevelItem in parentItem.children\"\n                         ng-if=\"parentItem.isOpen\">\n\n                        <div class=\"navigationRow {{ getIdentifier(secondLevelItem) }}\"\n                             ng-class=\"{ selected: secondLevelItem.selected }\">\n\n                            <div class=\"icon-spinner\"\n                                 ng-if=\"submissionViewModel.showFormRenderingSpinner\"></div>\n\n                            <button class=\"btn-link navigationLabel {{ secondLevelItem.id }}\"\n                                    ng-disabled=\"!secondLevelItem.enabled\"\n                                    ng-click=\"onNavItemClicked($event, secondLevelItem)\"\n                                    ui-enter=\"onNavItemClicked($event, secondLevelItem)\"\n                                    tabindex=\"1\">\n                                <span ng-class=\"{ shimmer: submissionViewModel.showFormRenderingSpinner}\">{{ secondLevelItem.displayName }}</span>\n                            </button>\n\n                            <div class=\"requiredFieldContainer\" ng-click=\"onRequiredIndicatorClicked($event, secondLevelItem)\">\n                                <div class=\"label label-warning\"\n                                     ng-if=\"(!secondLevelItem.isOpen || secondLevelItem.type === 2) && secondLevelItem.requiredFieldCount > 0\" ng-bind=\"secondLevelItem.requiredFieldCount\"></div>\n                            </div>\n\n                            <div class=\"treeControlArrow\">\n                                <button class=\"btn-link glyphicon glyphicon-chevron-right\"\n                                        ng-if=\"secondLevelItem.children.length\"\n                                        ng-click=\"openNavItem($event, secondLevelItem)\"\n                                        ng-class=\"{ isOpen: secondLevelItem.isOpen, enableTransition: viewModel.enableTreeArrowTransition }\"\n                                        ng-disabled=\"!secondLevelItem.enabled\"\n                                        tabindex=\"1\">\n                                </button>\n                            </div>\n                        </div>\n\n                        <!--Third Level-->\n                        <div class=\"childItem thirdLevel\"\n                             ng-if=\"secondLevelItem.isOpen\"\n                             ng-repeat=\"thirdLevelItem in secondLevelItem.children\">\n\n                            <div class=\"navigationRow {{ getIdentifier(thirdLevelItem) }}\"\n                                 ng-class=\"{ selected: thirdLevelItem.selected }\">\n\n                                <button class=\"btn-link navigationLabel {{ thirdLevelItem.id }}\"\n                                        ng-click=\"onNavItemClicked($event, thirdLevelItem)\"\n                                        ui-enter=\"onNavItemClicked($event, thirdLevelItem)\"\n                                        ng-disabled=\"!thirdLevelItem.enabled\"\n                                        tabindex=\"1\">\n                                    <span>{{ thirdLevelItem.displayName }}</span>\n                                </button>\n\n                                <div class=\"requiredFieldContainer\" ng-click=\"onRequiredIndicatorClicked($event, thirdLevelItem)\">\n                                    <div class=\"label label-warning\"\n                                         ng-if=\"(!thirdLevelItem.isOpen || thirdLevelItem.type === 2) && thirdLevelItem.requiredFieldCount > 0\" ng-bind=\"thirdLevelItem.requiredFieldCount\"></div>\n                                </div>\n\n                                <div class=\"treeControlArrow\">\n                                    <button class=\"btn-link glyphicon glyphicon-chevron-right\"\n                                            ng-if=\"thirdLevelItem.children.length\"\n                                            ng-click=\"openNavItem($event, thirdLevelItem)\"\n                                            ng-class=\"{ isOpen: thirdLevelItem.isOpen, enableTransition: viewModel.enableTreeArrowTransition }\"\n                                            ng-disabled=\"!thirdLevelItem.enabled\"\n                                            tabindex=\"1\">\n                                    </button>\n                                </div>\n                            </div>\n\n\n                            <!--Fourth Level-->\n                            <div class=\"childItem fourthLevel\"\n                                 ng-if=\"thirdLevelItem.isOpen\"\n                                 ng-repeat=\"fourthLevelItem in thirdLevelItem.children\">\n\n                                <div class=\"navigationRow {{ getIdentifier(fourthLevelItem) }}\"\n                                     ng-class=\"{ selected: fourthLevelItem.selected }\">\n\n                                    <button class=\"btn-link navigationLabel {{ fourthLevelItem.id }}\"\n                                            ng-click=\"onNavItemClicked($event, fourthLevelItem)\"\n                                            ui-enter=\"onNavItemClicked($event, fourthLevelItem)\"\n                                            ng-disabled=\"!fourthLevelItem.enabled\"\n                                            tabindex=\"1\">\n                                        <span>{{ fourthLevelItem.displayName }}</span>\n                                    </button>\n\n                                    <div class=\"requiredFieldContainer\" ng-click=\"onRequiredIndicatorClicked($event, fourthLevelItem)\">\n                                        <div class=\"label label-warning\"\n                                             ng-if=\"(!fourthLevelItem.isOpen || fourthLevelItem.type === 2) && fourthLevelItem.requiredFieldCount > 0\" ng-bind=\"fourthLevelItem.requiredFieldCount\"></div>\n                                    </div>\n\n                                    <div class=\"treeControlArrow\">\n                                        <button class=\"btn-link glyphicon glyphicon-chevron-right\"\n                                                ng-if=\"fourthLevelItem.children.length\"\n                                                ng-click=\"openNavItem($event, fourthLevelItem)\"\n                                                ng-class=\"{ isOpen: fourthLevelItem.isOpen, enableTransition: viewModel.enableTreeArrowTransition }\"\n                                                ng-disabled=\"!fourthLevelItem.enabled\"\n                                                tabindex=\"1\">\n                                        </button>\n                                    </div>\n                                </div>\n\n                                <!--Fifth Level-->\n                                <div class=\"childItem fifthLevel\"\n                                     ng-if=\"fourthLevelItem.isOpen\"\n                                     ng-repeat=\"fifthLevelItem in fourthLevelItem.children\">\n\n                                    <div class=\"navigationRow {{ getIdentifier(fifthLevelItem) }}\"\n                                         ng-class=\"{ selected: fifthLevelItem.selected }\">\n\n                                        <button class=\"btn-link navigationLabel {{ fifthLevelItem.id }}\"\n                                                ng-disabled=\"!fifthLevelItem.enabled\"\n                                                ng-click=\"onNavItemClicked($event, fifthLevelItem)\"\n                                                ui-enter=\"onNavItemClicked($event, fifthLevelItem)\"\n                                                tabindex=\"1\">\n                                            <span>{{ fifthLevelItem.displayName }}</span>\n                                        </button>\n\n                                        <div class=\"requiredFieldContainer\" ng-click=\"onRequiredIndicatorClicked($event, fifthLevelItem)\">\n                                            <div class=\"label label-warning\"\n                                                 ng-if=\"fifthLevelItem.requiredFieldCount > 0\">\n                                                    {{ fifthLevelItem.requiredFieldCount }}\n                                            </div>\n                                        </div>\n\n                                        <div class=\"treeControlArrow\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n            </div>\n\n            <div ng-if=\"viewModel.isLoading\">\n                <div class=\"icon-spinner\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isLargeScreen\"\n        class=\"drawerControl\"\n         ng-click=\"onToggleDrawer()\">\n\n        <span class=\"glyphicon\"\n              ng-class=\"{\n                'glyphicon-arrow-left': submissionViewModel.isDrawerOpen,\n                'glyphicon-arrow-right': !submissionViewModel.isDrawerOpen\n              }\"></span>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(391);

/*@ngInject*/
var NavigationController = function NavigationController($scope, $rootScope, $timeout, $sce, $state, $stateParams, $q, $window, coreConstant, currentSubmissionModel, formViewerConstant, submissionConstant, submissionMediator, wizardMediator, navigationItemType, currentUserModel, navigationUtil, quoteMediator, uiPerformanceLoggerConstant, appTypeConfigurationModel, formTemplateType) {
  var shouldUpdateSelectedNavigationItem = false;
  $scope.i18n = locale;
  $scope.viewModel = {
    showFormRenderingSpinner: false,
    selectedNavItem: null,
    isLoading: true
  };
  $scope.$on(coreConstant.event.HANDLE_ERROR, function (event, payload, logInfo) {
    shouldUpdateSelectedNavigationItem = false;
  });
  function init() {
    // Use the default child indexing to select the current nav item if we are loading into the submission without a saved state.
    loadNavItems($state.current.name === 'submission.default');
    quoteMediator.getQuoteList($stateParams.submissionId, $stateParams.proposalId);
  }
  function resetLongRequestTimer() {
    if ($scope.longRequestTimer) {
      $timeout.cancel($scope.longRequestTimer);
      $rootScope.$broadcast(coreConstant.event.HIDE_LONG_REQUEST_WARNING);
    }
  }
  function loadNavItems(updateSelectedNavigationItem) {
    resetLongRequestTimer();
    $scope.longRequestTimer = $timeout(function () {
      $rootScope.$broadcast(coreConstant.event.SHOW_LONG_REQUEST_WARNING);
    }, 500);
    submissionMediator.getSubmissionNavItems($stateParams.submissionId).then(function (rootNavigationItem) {
      processNavItems(rootNavigationItem, updateSelectedNavigationItem);
      $scope.viewModel.isLoading = false;
      resetLongRequestTimer();
      $rootScope.$broadcast(coreConstant.event.HIDE_LONG_REQUEST_WARNING);
    });
  }
  function processNavItems(rootNavigationItem, updateSelectedNavigationItem) {
    function updateOverviewRouteIfNecessary() {
      var selectedItem = $scope.viewModel.selectedNavItem,
        isOverview = selectedItem.formTemplateType === formTemplateType.SUBMISSION,
        hasFormId = $stateParams.formId && parseInt($stateParams.formId) === selectedItem.ownerId;
      if (isOverview && !hasFormId) {
        $state.go('submission.form', {
          submissionId: $stateParams.submissionId,
          formId: selectedItem.ownerId
        });
      }
    }
    var currentState = $state.current.name,
      selectedNavItemType,
      subSelectionId,
      hasSubSelection,
      selectedNavItemId,
      updateState = false,
      currentlySelectedNavigationItem = $scope.viewModel.selectedNavItem;
    switch (currentState) {
      case 'submission.accountSubmissionsGrid':
        selectedNavItemType = navigationItemType.ACCOUNT_SUBMISSIONS;
        hasSubSelection = false;
        break;
      case 'submission.document':
        selectedNavItemType = navigationItemType.DOCUMENT;
        subSelectionId = parseInt($stateParams.attachmentId);
        hasSubSelection = true;
        break;
      case 'submission.quote':
        selectedNavItemType = navigationItemType.QUOTE;
        updateState = true;
        subSelectionId = parseInt($stateParams.quoteId);
        hasSubSelection = true;
        break;
      case 'submission.quotes':
        selectedNavItemType = navigationItemType.QUOTES;
        hasSubSelection = false;
        break;
      case 'submission.proposals':
        selectedNavItemType = navigationItemType.PROPOSALS;
        hasSubSelection = false;
        break;
      case 'submission.reports':
        selectedNavItemType = navigationItemType.REPORTS;
        hasSubSelection = false;
        break;
      case 'submission.policies':
        selectedNavItemType = navigationItemType.POLICIES;
        hasSubSelection = false;
        break;
      case 'submission.policy':
        selectedNavItemType = navigationItemType.POLICY;
        updateState = true;
        subSelectionId = parseInt($stateParams.policyId);
        hasSubSelection = true;
        break;
      case 'submission.form':
      case 'submission.formSummaryGridDetail':
        selectedNavItemType = navigationItemType.FORM;
        subSelectionId = parseInt($stateParams.formId);
        hasSubSelection = true;
        break;
      case 'submission.externalContent':
        selectedNavItemType = navigationItemType.URL;
        subSelectionId = parseInt($stateParams.externalContentId);
        hasSubSelection = true;
        updateState = true; // Because the externalContent view uses a stateParam that isn't
        // explicit in the url (externalContentUrl and
        // externalContentPopoutUrl), we must 'refresh' the view to
        // make sure the externalContent view has all the parameters it
        // needs to render itself.
        break;
    }
    if (navigationUtil.getForcedServerSelectedNavItem(rootNavigationItem)) {
      // Needed to ensure that when an entity with no actual display is selected, it's child is selected instead.
      updateState = true;
    }
    navigationUtil.generateIdForHierarchyLevel(rootNavigationItem.children, $scope.i18n);
    $scope.viewModel.selectedNavItem = navigationUtil.getSelectedNavItem(rootNavigationItem, currentState, selectedNavItemType, subSelectionId, hasSubSelection, updateSelectedNavigationItem, currentlySelectedNavigationItem);
    selectedNavItemId = _.clone($scope.viewModel.selectedNavItem.id);
    navigationUtil.openSelectedListToSelectedItem(rootNavigationItem.children, selectedNavItemId);
    if (updateSelectedNavigationItem || !navigationUtil.areNavigationItemsEqual(currentlySelectedNavigationItem, $scope.viewModel.selectedNavItem)) {
      var maintainFormSummaryGridDetail = currentState === 'submission.formSummaryGridDetail';
      changeRouteToSelectedNavItem($stateParams.submissionId, $scope.viewModel.selectedNavItem, maintainFormSummaryGridDetail);
    }
    updateOverviewRouteIfNecessary();
    $scope.viewModel.navigationList = rootNavigationItem.children;
    if (updateState) {
      $scope.onNavItemClicked(null, $scope.viewModel.selectedNavItem);
    }
    $scope.$broadcast(coreConstant.event.ADVANCE_FOCUS, '.' + $scope.viewModel.selectedNavItem.id, 200);
    if (!$scope.viewModel.selectedNavItem.enabled) {
      $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
    }
  }
  function resetSelectedNavItem() {
    $scope.viewModel.selectedNavItem.selected = false;
  }
  function getContextType(contextType) {
    if (contextType === 'Submission') {
      contextType = submissionConstant.CONTEXT_SUBMISSION;
    } else if (contextType === 'Quote') {
      contextType = submissionConstant.CONTEXT_QUOTE;
    } else if (contextType === 'ExternalReport') {
      contextType = submissionConstant.CONTEXT_REPORT;
    } else if (contextType === 'PolicyIssuance') {
      contextType = submissionConstant.CONTEXT_POLICY_ISSUANCE;
    } else if (contextType === 'Policy') {
      contextType = submissionConstant.CONTEXT_POLICY;
    } else if (contextType === 'Proposal') {
      contextType = submissionConstant.CONTEXT_PROPOSAL;
    } else if (contextType === 'PolicyCancellation') {
      contextType = submissionConstant.CONTEXT_POLICY_CANCELLATION;
    } else if (contextType === 'Endorsement') {
      contextType = submissionConstant.CONTEXT_ENDORSEMENT;
    } else if (contextType === 'PolicyRewrite') {
      contextType = submissionConstant.CONTEXT_POLICY_REWRITE;
    }
    return contextType;
  }
  function getSelectedNavItemContext() {
    var contextType = '',
      contextId = 0,
      contextUri = '',
      context = {},
      hierarchicalContextList = [],
      contextLabel,
      selectedNavItem = $scope.viewModel.selectedNavItem;
    if (selectedNavItem && selectedNavItem.contextUri) {
      context = getContext(selectedNavItem.contextUri);
      contextId = context.contextId;
      contextType = context.contextType;
      contextUri = selectedNavItem.contextUri;
      contextType = getContextType(contextType);
      hierarchicalContextList = getHierarchicalContextList(selectedNavItem, contextId, contextType);
      contextLabel = getContextLabel(selectedNavItem);
    }
    return {
      contextId: contextId,
      contextType: contextType,
      contextLabel: contextLabel,
      contextUri: contextUri,
      hierarchicalContextList: hierarchicalContextList
    };
  }
  function getContext(contextUri) {
    var context = {},
      contextUriArray = _.remove(contextUri.split('/'), function (n) {
        return !_.isEmpty(n);
      });
    context.contextId = _.last(contextUriArray);
    context.contextType = _.first(contextUriArray);
    return context;
  }
  function getHierarchicalContextList(selectedNavItem) {
    var hierarchicalContextList = [],
      selectedNavItemIdArray = _.split(selectedNavItem.id, '-'),
      currentContextUri = '',
      currentContext = {},
      currentNavItem = {},
      duplicateContext = null;
    currentContext = getContext(selectedNavItem.contextUri);
    if (getContextType(currentContext.contextType) !== submissionConstant.CONTEXT_SUBMISSION) {
      hierarchicalContextList.unshift({
        contextType: submissionConstant.CONTEXT_SUBMISSION,
        contextId: $state.params.submissionId,
        contextUri: currentSubmissionModel.getCurrentSubmission().objectUri
      });
    }
    currentNavItem.children = $scope.viewModel.navigationList;
    _.each(selectedNavItemIdArray, function (selectedNavItemId) {
      currentNavItem = currentNavItem.children[selectedNavItemId];
      if (currentNavItem.contextUri !== currentContextUri) {
        currentContext = getContext(currentNavItem.contextUri);
        currentContextUri = currentNavItem.contextUri;
        duplicateContext = _.find(hierarchicalContextList, function (hierarchicalContext) {
          return hierarchicalContext.contextId === currentContext.contextId && hierarchicalContext.contextType === getContextType(currentContext.contextType);
        });
        if (_.isNil(duplicateContext)) {
          hierarchicalContextList.unshift({
            contextId: currentContext.contextId,
            contextType: getContextType(currentContext.contextType),
            contextUri: currentNavItem.contextUri
          });
        }
        duplicateContext = null;
      }
    });
    return hierarchicalContextList;
  }
  function getContextLabel(selectedNavItem) {
    var contextNavItem = navigationUtil.findOwnerUri($scope.viewModel.navigationList, selectedNavItem.contextUri);
    return contextNavItem ? contextNavItem.displayName : '';
  }
  function navigateToItem(navItem) {
    var submissionId = $stateParams.submissionId,
      hasChildren = navItem.children.length > 0,
      isPopoutUrlOnly = !_.isNil(navItem.popoutUrl) && _.isNil(navItem.url),
      isChangingState,
      trustedUrl,
      selectedNavItemId;
    if (isPopoutUrlOnly) {
      trustedUrl = $sce.trustAsResourceUrl(navItem.popoutUrl);
      $window.open(trustedUrl, '_blank');
    } else {
      isChangingState = changeRouteToSelectedNavItem(submissionId, navItem);
      $scope.viewModel.enableTreeArrowTransition = true;
      if (isChangingState) {
        resetSelectedNavItem();
        $scope.viewModel.selectedNavItem = navItem;
        $scope.viewModel.selectedNavItem.selected = true;
        selectedNavItemId = _.clone($scope.viewModel.selectedNavItem.id);
        navigationUtil.openSelectedListToSelectedItem($scope.viewModel.navigationList, selectedNavItemId);
      } else if (hasChildren) {
        $scope.openNavItemAndSelectDefault(null, navItem);
      }
    }
    return isChangingState;
  }
  $scope.openNavItemAndSelectDefault = function (event, navItem) {
    var selectedNavItemId;
    resetSelectedNavItem();
    $scope.viewModel.selectedNavItem = navigationUtil.getDefaultSelectedNavItem(navItem);
    selectedNavItemId = _.clone($scope.viewModel.selectedNavItem.id);
    navigationUtil.openSelectedListToSelectedItem($scope.viewModel.navigationList, selectedNavItemId);
    navItem.isOpen = true;
    changeRouteToSelectedNavItem($stateParams.submissionId, $scope.viewModel.selectedNavItem);
  };
  $scope.openNavItem = function (event, navItem) {
    $scope.viewModel.enableTreeArrowTransition = true;
    navItem.isOpen = !navItem.isOpen;
    if (event) {
      event.stopPropagation();
    }
  };
  $scope.onRequiredIndicatorClicked = function (event, navItem) {
    var isChangingState = navigateToItem(navItem);
    if (isChangingState) {
      $rootScope.$broadcast('showNextRequiredFieldAfterFormLoad');
      $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD);
    } else {
      $rootScope.$broadcast('showNextRequiredField');
      $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, navItem.ownerId.toString());
    }
  };
  $scope.onNavItemClicked = function (event, navItem) {
    var isChangingState = navigateToItem(navItem);
    if (event) {
      event.stopPropagation();
    }
    return isChangingState;
  };
  $scope.getIdentifier = function (navItem) {
    return _.camelCase(navItem.displayName);
  };
  function changeRouteToSelectedNavItem(submissionId, selectedNavItem, maintainFormSummaryGridDetail) {
    var isChangingState,
      logAction,
      message,
      accountId,
      isNotCurrentSubmission = _.toInteger($state.params.submissionId) !== selectedNavItem.submissionId,
      isNotCurrentForm = _.toInteger($state.params.formId) !== selectedNavItem.ownerId;
    switch (selectedNavItem.type) {
      case navigationItemType.ACCOUNT_SUBMISSIONS:
        accountId = selectedNavItem.ownerUri ? _.split(selectedNavItem.ownerUri, ':', 2)[1] : null;
        if (isNotCurrentForm) {
          isChangingState = true;
        }
        $state.go('submission.accountSubmissionsGrid', {
          submissionId: submissionId,
          accountId: accountId
        });
        break;
      case navigationItemType.DOCUMENT:
        message = 'Submission:' + submissionId + ',Attachment:' + selectedNavItem.ownerId;
        if (isNotCurrentSubmission || isNotCurrentForm) {
          isChangingState = true;
        }
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SHOW_DOCUMENT, message);
        $state.go('submission.document', {
          submissionId: submissionId,
          attachmentId: selectedNavItem.ownerId
        });
        break;
      case navigationItemType.FORM:
        logAction = uiPerformanceLoggerConstant.SHOW_FORM;
        message = 'formId:' + selectedNavItem.ownerId + ',watcherCount:' + getWatchersCount() + ',displayName:' + selectedNavItem.displayName;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        if (isNotCurrentForm) {
          isChangingState = true;
        }

        // If the state is actually changing, or if we don't care about maintaining the form summary grid detail
        // state...
        // We need this check in order to maintain the form summary grid detail route when reloading the application
        // when navigated to a form summary grid detail, because otherwise the navigation logic thinks that the
        // route is incorrect and we need to select the root form (since there are no sub-nav items for form
        // summary grid details)
        if (isChangingState || !maintainFormSummaryGridDetail) {
          $state.go('submission.form', {
            submissionId: submissionId,
            formId: selectedNavItem.ownerId
          });
        }
        break;
      case navigationItemType.QUOTES:
        if (isNotCurrentForm) {
          isChangingState = true;
        }
        $state.go('submission.quotes', {
          submissionId: submissionId
        });
        break;
      case navigationItemType.PROPOSAL:
        if (isNotCurrentForm) {
          isChangingState = true;
        }
        $state.go('submission.proposal', {
          submissionId: submissionId,
          proposalId: selectedNavItem.ownerId
        });
        break;
      case navigationItemType.PROPOSALS:
        if (isNotCurrentForm) {
          isChangingState = true;
        }
        $state.go('submission.proposals', {
          submissionId: submissionId
        });
        break;
      case navigationItemType.REPORTS:
        if (isNotCurrentForm) {
          isChangingState = true;
        }
        $state.go('submission.reports', {
          submissionId: submissionId
        });
        break;
      case navigationItemType.POLICIES:
        if (isNotCurrentForm) {
          isChangingState = true;
        }
        $state.go('submission.policies', {
          submissionId: submissionId
        });
        break;
      case navigationItemType.POLICY:
        if (isNotCurrentForm) {
          isChangingState = true;
        }
        $state.go('submission.policy', {
          submissionId: submissionId,
          policyId: selectedNavItem.ownerId
        });
        break;
      case navigationItemType.URL:
        if ($state.params.externalContentId !== selectedNavItem.ownerId) {
          isChangingState = true;
        }
        $state.go('submission.externalContent', {
          submissionId: submissionId,
          externalContentId: selectedNavItem.ownerId,
          externalContentUrl: selectedNavItem.url,
          externalContentPopoutUrl: selectedNavItem.popoutUrl
        });
        break;
    }
    return isChangingState;
  }
  $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    var updateSelectedNavigationItem = !_.isNil(toParams.submissionId) && toParams.submissionId === fromParams.submissionId && toState.name === 'submission.default';
    if (updateSelectedNavigationItem) {
      loadNavItems(updateSelectedNavigationItem);
    }
  });
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    $rootScope.$broadcast(coreConstant.event.HIDE_LONG_REQUEST_WARNING);
  });
  $scope.$on(submissionConstant.event.OPEN_OWNER_URI, function (event, ownerUri) {
    var selectedNavItem = navigationUtil.findOwnerUri($scope.viewModel.navigationList, ownerUri);
    if (selectedNavItem) {
      navigateToItem(selectedNavItem);
    }
  });
  $scope.$on(coreConstant.event.UPDATE_NAVIGATION_ITEM_MESSAGE, function (event, submissionUri, updatedNavigationItem, navigationItemActorPrincipalName) {
    var navigationItemMessageActorIsCurrentUser = currentUserModel.getCurrentUserSimplePrincipalId() === navigationItemActorPrincipalName,
      updateSelectedNavigationItem;
    $scope.viewModel.enableTreeArrowTransition = false;
    if ('/Submission/' + $stateParams.submissionId === submissionUri) {
      updateSelectedNavigationItem = navigationItemMessageActorIsCurrentUser && (shouldUpdateSelectedNavigationItem || navigationUtil.isForceSelectionInNavigationTree(updatedNavigationItem));
      processNavItems(updatedNavigationItem, updateSelectedNavigationItem);
      if (navigationItemMessageActorIsCurrentUser) {
        shouldUpdateSelectedNavigationItem = false;
      }
    }
  });
  $scope.$on(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM, function (event, ownerUri) {
    shouldUpdateSelectedNavigationItem = true;
  });
  $scope.$watch('viewModel.selectedNavItem', function (newValue, oldValue) {
    var selectedNavItemContext;
    if (newValue || oldValue) {
      selectedNavItemContext = getSelectedNavItemContext();
      wizardMediator.setContext(selectedNavItemContext);
      $rootScope.$broadcast(submissionConstant.event.CONTEXT_CHANGED, selectedNavItemContext);
    }
  });
  init();
};
NavigationController.$inject = ["$scope", "$rootScope", "$timeout", "$sce", "$state", "$stateParams", "$q", "$window", "coreConstant", "currentSubmissionModel", "formViewerConstant", "submissionConstant", "submissionMediator", "wizardMediator", "navigationItemType", "currentUserModel", "navigationUtil", "quoteMediator", "uiPerformanceLoggerConstant", "appTypeConfigurationModel", "formTemplateType"];
angular.module('gw-um-submission').controller('navigationController', NavigationController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 391 */
/***/ (function(module) {

module.exports = JSON.parse("{\"submission\":{\"leftNav\":{\"accountOverview\":\"Account Overview\",\"accountSubmissions\":\"Account History\",\"application\":\"Application\",\"binderDocument\":\"Binder Document\",\"binderDocuments\":\"Binder Documents\",\"binderSections\":\"Binder Sections\",\"cancellationDocument\":\"Cancellation Document\",\"cancellationDocuments\":\"Cancellation Documents\",\"issuanceDocument\":\"Issuance Document\",\"issuanceDocuments\":\"Issuance Documents\",\"overview\":\"Submission Overview\",\"policies\":\"Policies\",\"policy\":\"Policy\",\"policyIssuance\":\"Policy Issuance\",\"prequalification\":\"Prequalification\",\"proposalDocument\":\"Sent Proposal\",\"proposalDocuments\":\"Sent Proposal\",\"proposals\":\"Proposals\",\"proposalSections\":\"Proposal Sections\",\"quoteDocument\":\"Quote Document\",\"quoteDocuments\":\"Quote Documents\",\"quotes\":\"Quotes\",\"ratingDocument\":\"Rating Attachment\",\"ratingDocuments\":\"Rating Attachments\",\"reportDocument\":\"Report Document\",\"reportDocuments\":\"Report Documents\",\"reports\":\"Reports\",\"worksheets\":\"Worksheets\"}}}");

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

/*@ngInject*/
var NavigationRepository = function NavigationRepository(baseRepository, currentSubmissionModel) {
  angular.extend(this, baseRepository);
  this.getNavigationItems = function (submissionId) {
    var url = '/rest/NavigationItem/?submissionId=' + submissionId + '&registrationIdentifier=/Submission/' + submissionId;
    currentSubmissionModel.addRegistration(url);
    return this.get(url);
  };
};
NavigationRepository.$inject = ["baseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('navigationRepository', NavigationRepository);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var NavigationUtil = function NavigationUtil(umsLog, navigationItemType, formTemplateType) {
  function inspectNavigationItems(navigationItems, parentNavigationItem, shouldProcessFn, processNavigationItemFn, shouldContinueInspectingFn) {
    var result;
    _.each(navigationItems, function (navigationItem, index) {
      if (shouldProcessFn(navigationItem, parentNavigationItem, index, result)) {
        result = processNavigationItemFn(navigationItem, parentNavigationItem, index);
        if (shouldContinueInspectingFn(navigationItem, parentNavigationItem, index, result)) {
          if (!_.isEmpty(navigationItem.children)) {
            result = inspectNavigationItems(navigationItem.children, navigationItem, shouldProcessFn, processNavigationItemFn, shouldContinueInspectingFn);
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
    return result;
  }
  function buildId(navItem, id, parentId) {
    if (parentId) {
      navItem.id = parentId + '-' + id;
    } else {
      navItem.id = id;
    }
  }
  function buildOwnerId(navItem) {
    var ownerUri = navItem.ownerUri || '',
      ownerId = ownerUri.substr(ownerUri.lastIndexOf('/') + 1, ownerUri.length);
    navItem.ownerId = parseInt(ownerId);
  }
  function localizeDisplayName(navItem, translations) {
    if (navItem.translateDisplayName) {
      navItem.displayName = _.get(translations, navItem.displayName);
      navItem.translateDisplayName = false;
    }
  }
  this.openSelectedListToSelectedItem = function (navigationList, selectedNavItemId) {
    if (selectedNavItemId) {
      var selectedHierarchyIndexList = selectedNavItemId.split('-'),
        selectedItem;

      // remove the last item as it will not open
      selectedHierarchyIndexList.pop();
      _.forEach(selectedHierarchyIndexList, function (item, index) {
        if (index === 0) {
          selectedItem = navigationList[item];
        } else {
          selectedItem = selectedItem.children[item];
        }
        selectedItem.isOpen = true;
      });
    }
  };
  this.getSelectedNavItem = function (rootNavigationItem, currentState, selectedNavItemType, subSelectionId, hasSubSelection, updateSelectedNavigationItem, currentlySelectedNavItem) {
    var selectedNavItem;
    if (updateSelectedNavigationItem) {
      selectedNavItem = this.getForcedServerSelectedNavItem(rootNavigationItem);
      if (selectedNavItem) {
        //Clear property to avoid this being re-selected later
        selectedNavItem.forceSelection = false;
        //Ensure it is marked selected for it is highlighted in the left nav
        selectedNavItem.selected = true;
      }
    }
    if (!selectedNavItem && updateSelectedNavigationItem) {
      selectedNavItem = this.getServerSelectedNavItem(rootNavigationItem);
    }
    if (!selectedNavItem) {
      if (updateSelectedNavigationItem) {
        if (currentlySelectedNavItem) {
          selectedNavItem = this.getDefaultSelectedNavItem(this.getRootContextNavItem(rootNavigationItem, currentlySelectedNavItem.contextUri));

          // If we fell back to the root navigation item, we need to reset the selected item and handle it in the logic below.
          if (selectedNavItem === rootNavigationItem) {
            selectedNavItem = null;
          }
        } else {
          // Otherwise select the default based on the root.
          selectedNavItem = this.getDefaultSelectedNavItem(rootNavigationItem);
        }
      } else if (!currentlySelectedNavItem) {
        // We only want to get the selected nav item based on the state if there is no current
        // selected nav item
        selectedNavItem = this.getStateSelectedNavItem(rootNavigationItem.children, currentState, selectedNavItemType, subSelectionId, hasSubSelection);
      }
      if (!selectedNavItem && currentlySelectedNavItem) {
        selectedNavItem = this.getCurrentlySelectedNavItem(rootNavigationItem.children, currentlySelectedNavItem);
      }
      if (!selectedNavItem) {
        // Fall back to state-selected item if we can't find the currently selected nav item above, and log an error
        selectedNavItem = this.getStateSelectedNavItem(rootNavigationItem.children, currentState, selectedNavItemType, subSelectionId, hasSubSelection);
        if (currentlySelectedNavItem) {
          umsLog.warn('Unable to determine the selected nav item event though there is a nav item currently selected!');
        }
      }

      //Fall back processing if selectedNavItem cannot be determined
      if (!selectedNavItem) {
        selectedNavItem = this.getServerSelectedNavItem(rootNavigationItem);
        if (!selectedNavItem) {
          selectedNavItem = this.getDefaultSelectedNavItem(rootNavigationItem);
        }
        if (!selectedNavItem) {
          //Fallback to the submission navigation item
          selectedNavItem = _.find(rootNavigationItem.children, function (item) {
            return item.formTemplateType === formTemplateType.SUBMISSION;
          });
        }
        if (!selectedNavItem) {
          selectedNavItem = _.first(rootNavigationItem.children);
        }
        selectedNavItem.selected = true;
      }
    }
    return selectedNavItem;
  };
  this.getForcedServerSelectedNavItem = function (navigationItem) {
    function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
      return !result;
    }
    function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
      var selectedNavItem = null;
      if (navigationItem.forceSelection) {
        selectedNavItem = navigationItem;
      }
      return selectedNavItem;
    }
    return inspectNavigationItems([navigationItem], null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
  };
  this.getServerSelectedNavItem = function (navigationItem) {
    function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
      return !result;
    }
    function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
      var selectedNavItem = null;
      if (navigationItem.selected) {
        selectedNavItem = navigationItem;
      }
      return selectedNavItem;
    }
    return inspectNavigationItems([navigationItem], null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
  };
  this.getDefaultSelectedNavItem = function (navigationItem) {
    var selectedNavigationItem = navigationItem,
      hasChildren = !_.isNil(navigationItem) && !_.isEmpty(navigationItem.children),
      defaultChildIndex = !_.isNil(navigationItem) ? navigationItem.defaultChildIndex : null;
    if (_.isNil(navigationItem)) {
      return null;
    }
    if (hasChildren) {
      if (defaultChildIndex >= 0) {
        selectedNavigationItem = navigationItem.children[defaultChildIndex];
        return this.getDefaultSelectedNavItem(selectedNavigationItem);
      } else if (navigationItem.type === navigationItemType.NONE) {
        selectedNavigationItem = navigationItem.children[0];
        return this.getDefaultSelectedNavItem(selectedNavigationItem);
      }
    }
    selectedNavigationItem.selected = true;
    return selectedNavigationItem;
  };
  this.getRootContextNavItem = function (navigationItem, contextUri) {
    function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
      return !result;
    }
    function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
      var rootContextNavItem = null;
      if (navigationItem.contextUri === contextUri) {
        rootContextNavItem = navigationItem;
      }
      return rootContextNavItem;
    }
    return inspectNavigationItems([navigationItem], null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
  };
  this.getStateSelectedNavItem = function (navigationList, currentState, selectedNavItemType, subSelectionId, hasSubSelection) {
    function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
      return !result;
    }
    function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
      var isSelectedNavType = _.isEqual(navigationItem.type, selectedNavItemType),
        isSelectedNavSubType = _.isEqual(navigationItem.ownerId, subSelectionId),
        selectedNavItem = null;
      if (isSelectedNavType) {
        if (hasSubSelection) {
          if (isSelectedNavSubType) {
            selectedNavItem = navigationItem;
            selectedNavItem.selected = true;
          }
        } else {
          selectedNavItem = navigationItem;
          selectedNavItem.selected = true;
        }
      }
      return selectedNavItem;
    }
    return inspectNavigationItems(navigationList, null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
  };
  this.getCurrentlySelectedNavItem = function (navigationList, currentlySelectedNavItem) {
    var _this = this;
    function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
      return !result;
    }
    var processNavigationItemFn = function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
      var selectedNavItem = null;
      if (_this.areNavigationItemsEqual(navigationItem, currentlySelectedNavItem)) {
        selectedNavItem = navigationItem;
        selectedNavItem.selected = true;
      }
      return selectedNavItem;
    };
    if (currentlySelectedNavItem) {
      return inspectNavigationItems(navigationList, null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
    }
    return null;
  };
  this.areNavigationItemsEqual = function (navigationItem, navigationItem2) {
    return _.isNil(navigationItem) && _.isNil(navigationItem2) || !_.isNil(navigationItem) && !_.isNil(navigationItem2) && _.isEqual(navigationItem.type, navigationItem2.type) && _.isEqual(navigationItem.ownerId, navigationItem2.ownerId) && _.isEqual(navigationItem.contextUri, navigationItem2.contextUri);
  };
  this.isForceSelectionInNavigationTree = function (navigationItem) {
    var _this2 = this;
    var result = false;
    if (navigationItem.forceSelection) {
      return true;
    } else {
      _.each(navigationItem.children, function (navigationItem) {
        if (_this2.isForceSelectionInNavigationTree(navigationItem)) {
          result = true;
          return false;
        }
      });
    }
    return result;
  };
  this.generateIdForHierarchyLevel = function (hierarchyLevel, translations, parentNavigationItem) {
    function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
      return true;
    }
    function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
      buildId(navigationItem, index.toString(), parentNavigationItem ? parentNavigationItem.id : null);
      buildOwnerId(navigationItem);
      localizeDisplayName(navigationItem, translations);
    }
    ;
    return inspectNavigationItems(hierarchyLevel, parentNavigationItem, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
  };
  this.findOwnerUri = function (navigationList, ownerUri) {
    function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
      return !result;
    }
    function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
      if (navigationItem.ownerUri === ownerUri) {
        return navigationItem;
      }
      return null;
    }
    return inspectNavigationItems(navigationList, null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
  };
};
NavigationUtil.$inject = ["umsLog", "navigationItemType", "formTemplateType"];
angular.module('gw-um-submission').service('navigationUtil', NavigationUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

var path = '/newAttachmentModal/newAttachmentModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.uploadButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    class=\"newAttachmentModal\">\n\n    <div class=\"dockPanel emailAttachmentModal collaborationAttachment\">\n\n        <div class=\"dockPanelInnerContent collaborationInnerContent\">\n            <div class=\"dragDropBox\"\n                 ui-drop-zone\n                 file=\"{{viewModel.uploadedFile}}\">\n                <span>{{ i18n.dragAndDrop }}</span>\n                <span>{{ i18n.or }}</span>\n                <div>\n                    <input type=\"file\"\n                           class=\"btn btn-primary btn-sm hiddenFileInput\"\n                           name=\"' + scope.valueName + '_file\"\n                           ui-custom-on-change=\"fileSelected(file)\"/>\n                    <input type=\"button\"\n                           class=\"btn btn-primary btn-sm\"\n                           value=\"{{viewModel.chooseFileString}}\"/>\n                </div>\n\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent narrow\"\n             ng-if=\"viewModel.attachment.name\">\n            <div class=\"dockPanelCellSide\">\n                <span class=\"glyphicon glyphicon-file\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <span ng-if=\"!viewModel.attachmentLink\">{{viewModel.attachment.name}} ({{ viewModel.attachment.byteCountToDisplaySize }})</span>\n                <a ng-if=\"viewModel.attachmentLink\" ng-href=\"{{viewModel.attachmentLink}}\" target=\"_blank\">\n                    {{viewModel.attachment.name}} ({{ viewModel.attachment.byteCountToDisplaySize }})\n                </a>\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent row\" ng-if=\"viewModel.fullOptionsForm\">\n            <div class=\"dockPanelCellSide\">\n                <span class=\"glyphicon glyphicon-list-alt\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <div class=\"dropdown\"\n                     ng-class=\"{'isPlaceholder': !viewModel.attachment.type}\"\n                     uib-dropdown\n                     dropdown-append-to-body=\"true\"\n                     appendToOpenClass>\n                    <a class=\"type\"\n                       uib-dropdown-toggle>\n                        {{viewModel.attachment.type\n                        ? getTypeLabel(viewModel.attachment.type) : viewModel.pleaseChooseString}}\n                    </a>\n                    <ul class=\"dropdown-menu attachmentTypeList attachmentEmailTypeList\" uib-dropdown-menu>\n                        <li class=\"dropdown-label\" ng-click=\"onUpdateField()\">\n                          <span ng-click=\"resetTypeDropdown()\">{{ i18n.type }}</span>\n                        </li>\n                        <li ng-repeat=\"dataItem in viewModel.typeDataItems\">\n                            <a ng-click=\"setTypeValue(dataItem.value)\">{{dataItem.name}}</a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent fileDescription row\">\n            <div class=\"dockPanelCellSide pencil\">\n                <span class=\"glyphicon glyphicon-pencil\"></span>\n            </div>\n            <div class=\"dockPanelCellContent collaborationAttachmentTextareaWrapper\">\n               <textarea\n                   ng-model=\"viewModel.attachment.description\"\n                   ng-attr-placeholder=\"{{::viewModel.fileDescPlaceholder}}\"></textarea>\n            </div>\n        </div>\n\n        <div class=\"dockPanelInnerContent collaborationInnerContent narrow\"\n             ng-if=\"viewModel.isUnderwriterUser && viewModel.fullOptionsForm\">\n            <div class=\"dockPanelCellSide\">\n                <span class=\"glyphicon glyphicon-eye-open\"></span>\n            </div>\n            <div class=\"dockPanelCellContent\">\n                <label class=\"dockPanelCheckbox visibleToAgentWrapper\"\n                       ng-class=\"{ selected: viewModel.attachment.shared }\">\n                    <span>{{ i18n.visibleToAgent }}</span>\n                    <input type=\"checkbox\" ng-model=\"viewModel.attachment.shared\">\n                </label>\n            </div>\n        </div>\n\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(398);

/*@ngInject*/
var NewAttachmentModalController = function NewAttachmentModalController($rootScope, $scope, $timeout, options, coreMediator, coreConstant, preferenceModel, attachmentUtil, isUnderwriterUser, fullOptionsForm, existingFile) {
  $scope.i18n = locale;
  $scope.viewModel = {
    attachment: {},
    typeDataItems: null,
    uploadedFile: null,
    isUnderwriterUser: isUnderwriterUser,
    fullOptionsForm: fullOptionsForm
  };
  $scope.onConfirm = function () {
    $scope.$close({
      attachment: $scope.viewModel.attachment,
      file: $scope.viewModel.uploadedFile
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.storeUploadedFile = function (uploadedFile) {
    if (uploadedFile && attachmentUtil.validateAttachment(uploadedFile, _.get($scope.i18n, 'unacceptableTypeAndSize'))) {
      $timeout(function () {
        $scope.viewModel.uploadedFile = uploadedFile;
        if (!$scope.viewModel.attachment) {
          $scope.viewModel.attachment = {};
        }
        $scope.viewModel.attachment.name = uploadedFile.name;
        $scope.viewModel.attachment.size = uploadedFile.size;
        $scope.viewModel.attachment.byteCountToDisplaySize = attachmentUtil.convertAttachmentSize(uploadedFile.size);
      }, 0);
    }
  };
  $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
    $scope.storeUploadedFile(file);
  });
  $scope.resetTypeDropdown = function () {
    $scope.viewModel.attachment.type = '';
  };
  $scope.setTypeValue = function (value) {
    $scope.viewModel.attachment.type = value;
  };
  $scope.getTypeLabel = function (type) {
    var item = _.find($scope.viewModel.typeDataItems, function (item) {
      return item.value == type;
    });
    return item.name;
  };
  $scope.canEnableConfirmButton = function () {
    return $scope.viewModel.attachment.name;
  };
  function loadDataSets() {
    attachmentUtil.getAttachmentTypes().then(function (result) {
      $scope.viewModel.typeDataItems = result;
    });
  }
  function init() {
    $scope.viewModel = _.assign($scope.viewModel, {
      title: options.title ? options.title : $scope.i18n.title,
      cancelButton: options.cancelButtton ? options.cancelButton : $scope.i18n.cancelButton,
      uploadButton: options.uploadButton ? options.uploadButton : $scope.i18n.uploadFile,
      chooseFileString: options.chooseFileString ? options.chooseFileString : $scope.i18n.chooseFile,
      pleaseChooseString: options.pleaseChooseString ? options.pleaseChooseString : $scope.i18n.type,
      fileDescPlaceholder: options.fileDescPlaceholder ? options.fileDescPlaceholder : $scope.i18n.fileDescription
    });
    if (existingFile) {
      $scope.storeUploadedFile(existingFile);
    }
    loadDataSets();
  }
  $scope.fileSelected = function (file) {
    if (file) {
      $scope.storeUploadedFile(file);
    }
  };
  init();
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
NewAttachmentModalController.$inject = ["$rootScope", "$scope", "$timeout", "options", "coreMediator", "coreConstant", "preferenceModel", "attachmentUtil", "isUnderwriterUser", "fullOptionsForm", "existingFile"];
angular.module('gw-um-submission').controller('newAttachmentModalController', NewAttachmentModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 398 */
/***/ (function(module) {

module.exports = JSON.parse("{\"unacceptableTypeAndSize\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for upload.\",\"unacceptableTypeTitle\":\"Alert\",\"maxFileSizeMessage\":\"The file you are trying to upload exceeds the maximum allowed file size of {maxSize} MB.\",\"maxFileSizeTitle\":\"File Too Big\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\"},\"unacceptableTypeTitle\":\"Alert\",\"maxFileSizeTitle\":\"File Too Big\",\"dragAndDrop\":\"Drag and Drop File Here\",\"or\":\"or\",\"type\":\"Type\",\"visibleToAgent\":\"Visible to agent\",\"title\":\"Upload a new attachment\",\"uploadFile\":\"Upload File\",\"chooseFile\":\"Choose File\",\"cancelButton\":\"Cancel\",\"fileDescription\":\"File Description\"}");

/***/ }),
/* 399 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormUpgradeCheckRepository = function FormUpgradeCheckRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.submissionFormsNeedsUpgrade = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/upgradeFormsRequired';
    return this.get(url);
  };
  this.accountFormsNeedsUpgrade = function (accountId) {
    var url = '/rest/Account/' + accountId + '/upgradeFormsRequired';
    return this.get(url);
  };
};
FormUpgradeCheckRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('formUpgradeCheckRepository', FormUpgradeCheckRepository);

/***/ }),
/* 400 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormUpgradeRepository = function FormUpgradeRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.upgradeSubmissionForms = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/upgradeForms';
    return this.post(url);
  };
  this.upgradeAccountForms = function (accountId) {
    var url = '/rest/Account/' + accountId + '/upgradeForms';
    return this.post(url);
  };
};
FormUpgradeRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('formUpgradeRepository', FormUpgradeRepository);

/***/ }),
/* 401 */
/***/ (function(module, exports) {

/*@ngInject*/
var OpenSubmissionRepository = function OpenSubmissionRepository(baseSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.openSubmission = function (submissionId) {
    var url = '/rest/Submission/' + submissionId,
      config = {
        params: {
          registrationIdentifier: '/Submission/' + submissionId
        }
      },
      cacheKey = submissionId;
    return this.get(cacheKey, url, config);
  };
};
OpenSubmissionRepository.$inject = ["baseSharedPromiseRepository"];
angular.module('gw-um-submission').service('openSubmissionRepository', OpenSubmissionRepository);

/***/ }),
/* 402 */
/***/ (function(module, exports) {

/*@ngInject*/
var ProposalAttachmentRepository = function ProposalAttachmentRepository(baseRepository, sectionType) {
  angular.extend(this, baseRepository);
  this.saveAttachment = function (proposalId, data, file) {
    var url = '/rest/Proposal/' + proposalId + '/uploadSectionFromFile',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        },
        params: {
          displayLabel: data.description,
          filename: data.name,
          length: data.fileExpectedSize
        }
      };
    formData.append('file', file);
    return this.post(url, formData, config);
  };
};
ProposalAttachmentRepository.$inject = ["baseRepository", "sectionType"];
angular.module('gw-um-submission').service('proposalAttachmentRepository', ProposalAttachmentRepository);

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ProposalListRepository = function ProposalListRepository(baseRepository, currentSubmissionModel) {
  angular.extend(this, baseRepository);
  this.getProposalList = function (submissionId, accountId) {
    var url = '/rest/Proposal/List',
      params = {
        submissionId: submissionId,
        accountId: accountId,
        registrationIdentifier: submissionId ? '/SubmissionProposals/' + submissionId : '/AccountProposals/' + accountId
      };
    currentSubmissionModel.addRegistration({
      url: url,
      params: params
    });
    return this.get(url, {
      params: params
    });
  };
  this.processGetResponseData = function (responseData) {
    return _.each(responseData, function (proposal) {
      return _.map(proposal.quoteSummaries, function (quoteSummary) {
        quoteSummary.summary = quoteSummary.summary.replace(/\\n/g, '<br/>');
        return quoteSummary;
      });
    });
  };
};
ProposalListRepository.$inject = ["baseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('proposalListRepository', ProposalListRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 404 */
/***/ (function(module, exports) {

/*@ngInject*/
var ProposalMediator = function ProposalMediator(proposalRepository, proposalListRepository) {
  this.sendProposal = function (proposalId) {
    return proposalRepository.sendProposal(proposalId);
  };
  this.getProposalList = function (submissionId, accountId) {
    return proposalListRepository.getProposalList(submissionId, accountId);
  };
  this.findById = function (proposalId) {
    return proposalRepository.findById(proposalId);
  };
  this.getSections = function (proposalId) {
    return proposalRepository.getSections(proposalId);
  };
  this.stitchSections = function (proposalId, sectionType) {
    return proposalRepository.stitchSections(proposalId, sectionType);
  };
  this.updateSection = function (sectionId, stitchable) {
    return proposalRepository.updateSection(sectionId, stitchable);
  };
  this.moveSection = function (sectionId, proposalOrdinalNumber) {
    return proposalRepository.moveSection(sectionId, proposalOrdinalNumber);
  };
};
ProposalMediator.$inject = ["proposalRepository", "proposalListRepository"];
angular.module('gw-um-submission').service('proposalMediator', ProposalMediator);

/***/ }),
/* 405 */
/***/ (function(module, exports) {

/*@ngInject*/
var ProposalRepository = function ProposalRepository(baseRepository, proposalSendType, currentSubmissionModel) {
  angular.extend(this, baseRepository);
  this.sendProposal = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/send?proposalSendType=' + proposalSendType.SEND_PROPOSAL;
    return this.post(url);
  };
  this.findById = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId;
    return this.get(url);
  };
  this.getSections = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/ProposalSections';
    return this.get(url);
  };
  this.stitchSections = function (proposalId, sectionType) {
    var url = '/rest/Proposal/' + proposalId + '/previewStichedDocuments',
      config = {
        params: {
          sectionType: sectionType
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.updateSection = function (sectionId, stitchable) {
    var url = '/rest/ProposalSection/' + sectionId,
      config = {
        params: {
          stitchable: stitchable
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.moveSection = function (sectionId, proposalOrdinalNumber) {
    var url = '/rest/ProposalSection/' + sectionId + '/moveSection',
      config = {
        params: {
          proposalOrdinalNumber: proposalOrdinalNumber
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.uploadSectionFromFile = function (proposalId, data, file) {
    var url = '/rest/Proposal/' + proposalId + '/uploadSectionFromFile',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        },
        params: {
          displayLabel: data.description,
          filename: data.name,
          length: data.fileExpectedSize
        }
      };
    formData.append('file', file);
    return this.post(url, formData, config);
  };
};
ProposalRepository.$inject = ["baseRepository", "proposalSendType", "currentSubmissionModel"];
angular.module('gw-um-submission').service('proposalRepository', ProposalRepository);

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var QuoteListRepository = function QuoteListRepository(baseRepository, currentSubmissionModel) {
  angular.extend(this, baseRepository);
  this.getQuoteList = function (submissionId, proposalId) {
    var url = '/rest/Quote/List',
      params = {
        submissionId: submissionId,
        proposalId: proposalId,
        registrationIdentifier: proposalId ? '/ProposalQuotes/' + proposalId : '/SubmissionQuotes/' + submissionId
      };
    currentSubmissionModel.addRegistration({
      url: url,
      params: params
    });
    return this.get(url, {
      params: params
    });
  };
  this.processGetResponseData = function (responseData) {
    return _.map(responseData, function (o) {
      o.summary = o.summary.replace(/\\n/g, '<br/>');
      return o;
    });
  };
};
QuoteListRepository.$inject = ["baseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('quoteListRepository', QuoteListRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 407 */
/***/ (function(module, exports) {

/*@ngInject*/
var QuoteMediator = function QuoteMediator(quoteRepository, quoteListRepository) {
  this.getQuote = function (quoteId) {
    return quoteRepository.getQuote(quoteId);
  };
  this.getQuoteList = function (submissionId, proposalId) {
    return quoteListRepository.getQuoteList(submissionId, proposalId);
  };
  this.deleteQuoteListRegistration = function (submissionId) {
    return quoteRepository.deleteQuoteListRegistration(submissionId);
  };
};
QuoteMediator.$inject = ["quoteRepository", "quoteListRepository"];
angular.module('gw-um-submission').service('quoteMediator', QuoteMediator);

/***/ }),
/* 408 */
/***/ (function(module, exports) {

/*@ngInject*/
var QuoteRepository = function QuoteRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getQuote = function (quoteId) {
    var url = '/rest/Quote/' + quoteId;
    return this.get(url);
  };
  this.deleteQuoteListRegistration = function (submissionId) {
    var url = '/rest/Quote/List?registrationIdentifier=/SubmissionQuotes/' + submissionId;
    return this.delete(url);
  };
};
QuoteRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('quoteRepository', QuoteRepository);

/***/ }),
/* 409 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReportMediator = function ReportMediator($q, reportRepository) {
  this.getReportList = function (submissionId) {
    return reportRepository.getReportList(submissionId);
  };
};
ReportMediator.$inject = ["$q", "reportRepository"];
angular.module('gw-um-submission').service('reportMediator', ReportMediator);

/***/ }),
/* 410 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReportRepository = function ReportRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getReportList = function (submissionId) {
    var url = '/rest/ExternalReport/List?submissionId=' + submissionId;
    return this.get(url);
  };
};
ReportRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('reportRepository', ReportRepository);

/***/ }),
/* 411 */
/***/ (function(module, exports) {

/*@ngInject*/
var SubmissionRepository = function SubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.closeSubmission = function (submissionId) {
    var url = "/rest/Submission/".concat(submissionId, "/List?registrationIdentifier=/Submission/").concat(submissionId);
    return this.delete(url);
  };
  this.createSubmission = function () {
    var url = '/rest/Submission/create';
    return this.post(url);
  };
  this.deleteSubmission = function (submissionId) {
    var url = '/rest/Submission/' + submissionId;
    return this.delete(url);
  };
  this.submitSubmission = function (submissionId) {
    var url = "/rest/Submission/".concat(submissionId, "/submit"),
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.setSubmissionOpenHistory = function (submissionId, userId) {
    var url = '/rest/SubmissionOpenHistory',
      config = {
        params: {
          submissionId: submissionId,
          userId: userId
        }
      };
    return this.post(url, {}, config);
  };
  this.updateSubmission = function (submissionId, submissionPropertiesMap) {
    var url = "/rest/Submission/".concat(submissionId),
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, submissionPropertiesMap, config);
  };
  this.getSubmissionTransactions = function (submissionId) {
    var url = "/rest/Submission/".concat(submissionId, "/SubmissionTransactions/");
    return this.get(url);
  };
  this.isUserAuthorizedForSubmissionProduct = function (submissionId) {
    var url = "/rest/Submission/".concat(submissionId, "/productAuthorization");
    return this.get(url);
  };
};
SubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('submissionRepository', SubmissionRepository);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

var path = '/snippets/snippetsViewer.tpl.html';
var html = "<div class=\"dockPanel snippetsViewer\"\n     ng-class=\"{'isDetached': $ctrl.isDetached, 'isOpen': $ctrl.isOpen, 'isReady': $ctrl.isReady}\"\n     ng-if=\"$ctrl.isActive\"\n     ui-snippets-viewer-resizable\n     ui-snippets-viewer-draggable>\n\n    <div class=\"dockPanelContainer snippetsViewerContainer\">\n        <div class=\"dockPanelSection\">\n            <div class=\"dockPanelHeader snippetsViewerHeader\">\n                <h2 class=\"dockPanelHeaderTitle snippetsViewerTitle\">\n                    <span class=\"glyphicon glyphicon-scissors scissorsIcon\"></span>\n                    <span>{{ $ctrl.i18n.title }}</span>\n                </h2>\n                <a class=\"dockPanelHeaderButton dockPanelHeaderCloseButton\"\n                   ng-click=\"$ctrl.detachViewer()\"\n                   ng-if=\"!$ctrl.isDetached\">\n                    <span class=\"glyphicon glyphicon-new-window detachedIcon\"></span>\n                </a>\n                <a class=\"dockPanelHeaderButton dockPanelHeaderCloseButton\"\n                   ng-click=\"$ctrl.attachViewer()\"\n                   ng-if=\"$ctrl.isDetached\">\n                    <span class=\"glyphicon glyphicon-new-window down\"></span>\n                </a>\n                <a class=\"dockPanelHeaderButton dockPanelHeaderCloseButton\"\n                   ng-click=\"$ctrl.closeViewer()\">\n                    <span class=\"glyphicon glyphicon-remove closeButton\"></span>\n                </a>\n            </div>\n            <div class=\"dockPanelContent snippetsViewerContent\">\n                <div ng-repeat=\"snippet in $ctrl.currentSnippets\"\n                     ng-if=\"$ctrl.currentSnippets.length > 0\"\n                     class=\"snippetImage\"\n                     ng-class=\"{'isLoading':snippet.loading}\">\n                    <div ng-if=\"snippet.loading\"\n                         class=\"loader\">\n                        <div class=\"icon-spinner\"></div>\n                    </div>\n                    <img ng-src=\"{{snippet.imageBlob}}\" ng-if=\"snippet.imageBlob\">\n                </div>\n\n                <div ng-if=\"$ctrl.currentField && $ctrl.currentSnippets.length === 0\"\n                     class=\"snippetsViewerEmptyMessage\">{{ $ctrl.i18n.noSnippets }}\n                </div>\n\n                <div ng-if=\"!$ctrl.currentField && !$ctrl.isFormLevelSnippet()\"\n                     class=\"snippetsViewerEmptyMessage\">{{ $ctrl.i18n.noFieldSelected }}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

var SnippetsViewerComponent = {
  templateUrl: '/snippets/snippetsViewer.tpl.html',
  controller: 'snippetsViewerController',
  bindings: {}
};
angular.module('gw-um-submission').component('uiSnippetsViewer', SnippetsViewerComponent);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(416);

/*@ngInject*/
var SnippetsViewerController = function SnippetsViewerController($rootScope, $scope, $stateParams, $timeout, formMediator, formViewerConstant, submissionConstant, submissionStatus, submissionMediator, submissionStateMediator, formatUtil) {
  var timeoutList = [];
  this.$onInit = function () {
    this.i18n = locale;
    this.currentSnippets = [];
    this.fieldsSnippets = [];
    this.isDetached = false;
    this.isOpen = false;
    this.isActive = true;
    this.currentField = false;
    this.isReady = false;
    this.currentSnippetSignature = null;
    this.snippetsBlobCache = {};
    $scope.$on(formViewerConstant.event.FOCUSED_FIELD_CHANGED, this.updateCurrentField.bind(this));
    $scope.$on(formViewerConstant.event.FORM_DATA_READY, this.updateCurrentForm.bind(this));
    $scope.$watch('$ctrl.isActive', this.resetViewer.bind(this));
    $scope.$on(submissionConstant.event.TOGGLE_SNIPPETS, this.toggleViewer.bind(this));
    $scope.$on(submissionConstant.event.CLOSE_SNIPPETS, this.closeViewer.bind(this));
    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toState.url.indexOf(':formId') === -1) {
        this.resetViewer();
      } else {
        this.emptyViewer();
        this.reloadViewerState(true);
      }
    }.bind(this));
    this.reloadViewerState();
  };
  this.updateCurrentForm = function (event, formData, rootFormId) {
    var submission = submissionMediator.getCurrentSubmission();
    if (!_.isNil(submission)) {
      this.isReady = true;
      this.currentSnippets = [];
      if (submission.status !== submissionStatus.CREATED_SUBMISSION) {
        this.fieldsSnippets = formData.snippetList;
        if (this.fieldsSnippets.length <= 0) {
          this.closeViewer();
        } else if (this.isFormLevelSnippet()) {
          this.loadAllFormLevelSnippetBlobs();
        }
        $rootScope.$broadcast(submissionConstant.event.REFRESH_SNIPPETS_TOGGLER, this.fieldsSnippets);
        this.isActive = true;
      } else {
        this.isActive = false;
        this.fieldsSnippets = [];
        this.closeViewer();
        $rootScope.$broadcast(submissionConstant.event.REFRESH_SNIPPETS_TOGGLER, this.fieldsSnippets);
      }
    }
  };
  this.updateCurrentField = function (e, fieldData) {
    if (!this.isActive) {
      return;
    }
    var fieldName = _.get(fieldData, 'uiField.fieldTemplate.variableName');
    var snippets = _.filter(this.fieldsSnippets, function (fieldSnippet) {
      return fieldSnippet.fieldName === fieldName || fieldSnippet.fieldName === '*';
    });
    this.currentField = fieldData;
    this.currentSnippets = [];
    if (snippets) {
      this.currentSnippets = _.flatten([snippets]);
      this.loadAllCurrentSnippetBlobs();
    }
    this.setCurrentSnippetField();
  };
  this.toggleViewer = function () {
    return this.isOpen ? this.closeViewer() : this.showViewer();
  };
  this.emptyViewer = function () {
    this.currentField = false;
    this.currentSnippets = [];
    this.setCurrentSnippetField();
  };
  this.resetViewer = function () {
    this.closeViewer();
    this.emptyViewer();
    this.fieldsSnippets = [];
    $rootScope.$broadcast(submissionConstant.event.REFRESH_SNIPPETS_TOGGLER, this.fieldsSnippets);
    if ($stateParams.formId) {
      var rootFormId = $stateParams.formId;
      var formData = formMediator.getFormStructure(rootFormId);
      if (formData) {
        this.updateCurrentForm(null, formData, rootFormId);
      }
    }
  };
  this.closeViewer = function () {
    this.isOpen = false;
    this.attachViewer();
    $rootScope.$broadcast(submissionConstant.event.SNIPPETS_DID_CLOSE);
    this.setCurrentSnippetField();
    this.saveState();
  };
  this.showViewer = function () {
    this.isOpen = true;
    $rootScope.$broadcast(submissionConstant.event.SNIPPETS_DID_OPEN);
    if (this.currentField) {
      this.setCurrentSnippetField();
      this.loadAllCurrentSnippetBlobs();
    } else if (this.isFormLevelSnippet()) {
      this.loadAllFormLevelSnippetBlobs();
    }
    this.saveState();
  };
  this.isFormLevelSnippet = function () {
    var isFormLevel = false;
    _.each(this.fieldsSnippets, function (snippet) {
      if (snippet.fieldName === '*') {
        isFormLevel = true;
      }
    });
    return isFormLevel;
  };
  this.detachViewer = function () {
    this.isDetached = true;
    this.showViewer();
    this.saveState();
  };
  this.attachViewer = function () {
    this.isDetached = false;
    this.saveState();
  };
  this.loadAllCurrentSnippetBlobs = function () {
    this.loadAllCurrentSnippetBlobContinue(this.currentSnippets, false);
  };
  this.loadAllFormLevelSnippetBlobs = function () {
    this.currentSnippets = [];
    this.loadAllCurrentSnippetBlobContinue(this.fieldsSnippets, true);
  };
  this.loadAllCurrentSnippetBlobContinue = function (snippets, isFormLevel) {
    _.each(snippets, function (snippet) {
      if (isFormLevel && snippet.fieldName !== '*') {
        return;
      }
      if (this.currentSnippets.indexOf(snippet) < 0 && !_.isNil(snippet.imageBlob)) {
        this.currentSnippets.push(snippet);
        return;
      }
      var currentBlob = _.get(this.snippetsBlobCache, snippet.magicEyeImageBlobFileId);
      if (!currentBlob) {
        snippet.loading = true;
        formMediator.getSnippetBlob(snippet.id).then(function (blob) {
          snippet.imageBlob = false;
          if (blob) {
            snippet.imageBlob = 'data:image/png;base64,' + blob;
            this.snippetsBlobCache[snippet.magicEyeImageBlobFileId] = snippet.imageBlob;
          }
        }.bind(this)).finally(function () {
          timeoutList.push($timeout(function () {
            snippet.loading = false;
          }, 0));
        });
      } else {
        snippet.imageBlob = currentBlob;
      }
      if (this.currentSnippets.indexOf(snippet) < 0 && isFormLevel) {
        this.currentSnippets.push(snippet);
      }
    }.bind(this));
  };
  this.getSnippetsSignature = function () {
    return _.map(this.currentSnippets, 'blobFileId').join('-');
  };
  this.saveState = function () {
    var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};
    currentState = _.extend(currentState, {
      isOpen: this.isOpen,
      isDetached: this.isDetached
    });
    submissionStateMediator.saveSnippetsViewerPositionState($stateParams.submissionId, currentState);
  };
  this.reloadViewerState = function (sendEvent) {
    var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};
    this.isOpen = _.get(currentState, 'isOpen', false);
    this.isDetached = _.get(currentState, 'isDetached', false);
    if (!sendEvent) {
      return;
    }
    if (this.isOpen) {
      this.showViewer();
    }
    if (this.isDetached) {
      this.detachViewer();
    }
  };
  this.setCurrentSnippetField = function () {
    var fieldName, hasSnippets, fieldNameClass;
    if (this.isActive) {
      fieldName = _.get(this.currentField, 'uiField.fieldTemplate.variableName', null);
      hasSnippets = this.currentSnippets.length > 0;
      fieldNameClass = "formFieldComponent-".concat(formatUtil.formatAsSelector(fieldName));
    }
    $rootScope.$broadcast(submissionConstant.event.SET_CURRENT_SNIPPET_FIELD, fieldNameClass, hasSnippets, this.isOpen);
  };
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
SnippetsViewerController.$inject = ["$rootScope", "$scope", "$stateParams", "$timeout", "formMediator", "formViewerConstant", "submissionConstant", "submissionStatus", "submissionMediator", "submissionStateMediator", "formatUtil"];
angular.module('gw-um-submission').controller('snippetsViewerController', SnippetsViewerController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 416 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Snippets\",\"noFieldSelected\":\"Select a field to see the snippets attached to it\",\"noSnippets\":\"No snippets attached to the selected field\"}");

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var UISnippetsViewerDraggableDirective = function UISnippetsViewerDraggableDirective($document, $window, $timeout, $stateParams, submissionStateMediator) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var opt = {
      handle: '.snippetsViewerHeader',
      draggableClass: 'draggable',
      activeHandleClass: 'active-handle'
    };
    var lastPosition = {};
    var $selected = null;
    var $handle = $elm.find(opt.handle);
    var elementSize = {
      width: null,
      height: null
    };
    var saveState = function saveState() {
      var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};
      currentState = _.extend(currentState, lastPosition);
      submissionStateMediator.saveSnippetsViewerPositionState($stateParams.submissionId, currentState);
    };
    var restoreState = function restoreState() {
      var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};
      lastPosition = {
        top: _.get(currentState, 'top', ''),
        left: _.get(currentState, 'left', '')
      };
    };
    var setElementPosition = function setElementPosition(top, left) {
      var offset = 200;
      if (top < -offset) {
        top = -offset;
      }
      if (left < -offset) {
        left = -offset;
      }
      var maxTop = $window.innerHeight - elementSize.height + offset;
      var maxLeft = $window.innerWidth - elementSize.width + offset;
      if (top > maxTop) {
        top = maxTop;
      }
      if (left > maxLeft) {
        left = maxLeft;
      }
      $elm.offset({
        top: top,
        left: left
      });
      lastPosition.top = top;
      lastPosition.left = left;
    };
    var centerElement = function centerElement() {
      $elm.removeClass('isDetached');
      $timeout(function () {
        var left = $($window).width() / 2 - $elm.width() / 2;
        var top = $($window).height() / 2 - $elm.height() / 2;
        setElementPosition(top, left);
      }, 1); //delay so the dom has time to update the height/width
    };
    var handleMousedown = function handleMousedown(e) {
      if (!$scope.$ctrl.isDetached) {
        return;
      }
      $elm.addClass(opt.draggableClass);
      $handle.addClass(opt.activeHandleClass);
      elementSize.width = $elm.width();
      elementSize.height = $elm.height();
      var drgH = $elm.outerHeight(),
        drgW = $elm.outerWidth(),
        posY = $elm.offset().top + drgH - e.pageY,
        posX = $elm.offset().left + drgW - e.pageX;
      var top = e.pageY + posY - drgH,
        left = e.pageX + posX - drgW;
      $document.on('mousemove', function (e) {
        var top = e.pageY + posY - drgH < 0 ? 0 : e.pageY + posY - drgH,
          left = e.pageX + posX - drgW < 0 ? 0 : e.pageX + posX - drgW;
        setElementPosition(top, left);
      });
      $document.on('mouseup', function () {
        $document.off('mousemove'); // Unbind events from document
        $elm.removeClass(opt.draggableClass);
      });
      e.preventDefault(); // disable selection
    };
    var handleMouseup = function handleMouseup() {
      if (!$scope.$ctrl.isDetached) {
        return;
      }
      $elm.removeClass(opt.draggableClass);
      $handle.removeClass(opt.activeHandleClass);
      $selected = null;
      saveState();
    };
    $handle.on('mousedown', handleMousedown);
    $handle.on('mouseup', handleMouseup);
    $scope.$watch('$ctrl.isDetached', function (newValue) {
      if (newValue) {
        if (!_.isEmpty(lastPosition)) {
          $elm.offset(lastPosition);
        } else {
          centerElement();
        }
      } else {
        $elm.css({
          'top': '',
          'left': ''
        });
      }
      saveState();
    });
    $scope.$on('$destroy', function () {
      $handle.off('mousedown', handleMousedown);
      $handle.off('mouseup', handleMouseup);
    });
    restoreState();
  };
  return {
    restrict: 'A',
    replace: false,
    link: linkFunction
  };
};
UISnippetsViewerDraggableDirective.$inject = ["$document", "$window", "$timeout", "$stateParams", "submissionStateMediator"];
angular.module('gw-um-submission').directive('uiSnippetsViewerDraggable', UISnippetsViewerDraggableDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UISnippetsViewerResizableDirective = function UISnippetsViewerResizableDirective($document, $window, $timeout, $stateParams, submissionStateMediator) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var opt = {
      handle: '.snippetsViewerHeader',
      draggableClass: 'resizable'
    };
    var $resizer = $('<div class="resizer" />').appendTo($elm),
      startX,
      startY,
      startWidth,
      startHeight,
      lastSavedSize = {};
    var saveState = function saveState() {
      var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};
      currentState = _.extend(currentState, lastSavedSize);
      submissionStateMediator.saveSnippetsViewerPositionState($stateParams.submissionId, currentState);
    };
    var restoreState = function restoreState() {
      var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};
      lastSavedSize = {
        width: _.get(currentState, 'width', ''),
        height: _.get(currentState, 'height', '')
      };
    };
    var startDrag = function startDrag(e) {
      startX = e.clientX;
      startY = e.clientY;
      startWidth = $($elm).width();
      startHeight = $($elm).height();
      if (!$scope.$ctrl.isDetached) {
        return; // do nothing
      }
      $document.on('mousemove', doDrag);
      $document.on('mouseup', _endDrag);
    };
    var _endDrag = function endDrag(e) {
      $document.off('mousemove', doDrag);
      $document.off('mouseup', _endDrag);
      saveState();
    };
    var doDrag = function doDrag(e) {
      var newWidth = startWidth + e.clientX - startX + 'px';
      var newHeight = startHeight + e.clientY - startY + 'px';
      $elm.css({
        width: newWidth,
        height: newHeight
      });
      lastSavedSize.width = newWidth;
      lastSavedSize.height = newHeight;
    };
    $resizer.on('mousedown', startDrag);
    $scope.$watch('$ctrl.isDetached', function (newValue) {
      if (newValue) {
        if (!_.isEmpty(lastSavedSize)) {
          $elm.css({
            'width': lastSavedSize.width,
            'height': lastSavedSize.height
          });
        }
      } else {
        $elm.css({
          'width': '',
          'height': ''
        });
      }
    });
    $scope.$on('$destroy', function () {
      $resizer.off('mousedown', startDrag);
    });
    restoreState();
  };
  return {
    restrict: 'A',
    replace: false,
    link: linkFunction
  };
};
UISnippetsViewerResizableDirective.$inject = ["$document", "$window", "$timeout", "$stateParams", "submissionStateMediator"];
angular.module('gw-um-submission').directive('uiSnippetsViewerResizable', UISnippetsViewerResizableDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

var path = '/wizard/actions/approveEndorsement/approveEndorsementModal.tpl.html';
var html = "<div class=\"modal-view-wrapper approveEndorsementModalContent\">\n\n    <!--Header-->\n    <div class=\"modal-header header\">\n        <h4 class=\"modal-title\">{{ ::i18n.title }}</h4>\n        <button ng-click=\"$dismiss()\" class=\"close btn btn-link\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <!--Content-->\n    <div class=\"modal-body contentContainer\">\n\n        <div class=\"summaryText\">{{ ::i18n.summary }}</div>\n\n        <div class=\"processingInstructions\">\n            <textarea ng-model=\"processingInstructions\"></textarea>\n        </div>\n\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n\n        <button class=\"btn btn-default\"\n                ng-click=\"$dismiss()\">{{ ::i18n.cancelButton }}\n        </button>\n\n        <button class=\"btn btn-primary\"\n                ng-click=\"onConfirm()\">\n            {{ ::i18n.okayButton }}\n        </button>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(91);

/*@ngInject*/
var ApproveEndorsementModalController = function ApproveEndorsementModalController($rootScope, $scope, $state, coreConstant) {
  $scope.i18n = locale;
  $scope.processingInstructions = '';
  $scope.onConfirm = function () {
    $scope.$close({
      processingInstructions: $scope.processingInstructions
    });
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ApproveEndorsementModalController.$inject = ["$rootScope", "$scope", "$state", "coreConstant"];
angular.module('gw-um-submission').controller('approveEndorsementModalController', ApproveEndorsementModalController);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

var path = '/wizard/actions/bindActions/bindActionModal.tpl.html';
var html = "<base-modal modal-title=\"titleText\"\n            ok=\"confirmButton\"\n            cancel=\"cancelButton\"\n            is-confirm-disabled=\"!canEnableConfirmButton()\"\n            on-confirm=\"onConfirm()\"\n            on-cancel=\"onCancel()\">\n\n    <!--Content-->\n    <div class=\"modal-body drawer\" >\n        <div class=\"drawerRow\" ng-if=\"summary !== null\">\n            <div class=\"drawerCol group\">\n                <label class=\"notificationMessage\">\n                    {{ summary }}\n                </label>\n            </div>\n        </div>\n\n        <div ng-repeat=\"(key, value) in quoteList\">\n            <div class=\"drawerRow\"\n                 ng-if=\"key !== '' && value.length > 1\">\n                <div class=\"drawerCol group\">\n                    <label class=\"groupHeading\">\n                        {{ key }}\n                    </label>\n                </div>\n            </div>\n            <div class=\"drawerRow\" ng-if=\"value.length === 1\"\n                 ng-repeat=\"item in value\">\n                <div class=\"drawerCol\"\n                     ng-class=\"{noGroupItem: key === ''}\" >\n                    <label>\n                        <input class=\"quoteCheckBox\"\n                               type=\"checkbox\"\n                               ng-change=\"handleClick(item, false)\"\n                               ng-model=\"item.checked\"\n                               ng-checked=\"item.checked\">\n                        {{ item.name }}\n                    </label>\n                </div>\n            </div>\n\n            <div ng-class=\"{groupRow: key !== ''}\">\n                <div class=\"drawerRow\" ng-if=\"value.length > 1\"\n                     ng-repeat=\"item in value\">\n\n                    <div class=\"drawerCol quoteNames\"  ng-if=\"key !== ''\"\n                         ng-class=\"{noGroupItem: key === ''}\" >\n                        <label>\n                            <input class=\"quoteRadioGroup\"\n                                   type=\"radio\"\n                                   name=\"{{key}}\"\n                                   ng-click=\"handleClick(item, true)\"\n                                   ng-checked=\"item.checked\">\n                            {{ item.name }}\n                        </label>\n                    </div>\n                    <div class=\"drawerCol quoteList\"\n                         ng-if=\"key === ''\"\n                         ng-class=\"{noGroupItem: key === ''}\" >\n                        <label>\n                            <input class=\"quoteCheckBoxGroup\"\n                                   type=\"checkbox\"\n                                   ng-change=\"handleClick(item, false)\"\n                                   ng-model=\"item.checked\"\n                                   ng-checked=\"item.checked\">\n                            {{ item.name }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(425);

/*@ngInject*/
var BindActionModalController = function BindActionModalController($rootScope, $scope, options, localization, coreConstant) {
  $scope.i18n = _.get(locale, options.translationRoot);
  $scope.titleText = '';
  $scope.titleText = options.notificationPreference ? options.notificationPreference.title : _.get($scope.i18n, 'title');
  $scope.summary = _.get($scope.i18n, 'summary');
  $scope.cancelButton = _.get($scope.i18n, 'cancel');
  $scope.confirmButton = _.get($scope.i18n, 'confirm');
  $scope.quotes = _.map(options.quoteList, function (quote) {
    var matches = 0;
    if (_.isNil(quote.grouping)) {
      quote.grouping = '';
    } else {
      _.each(options.quoteList, function (tempQuote) {
        if (tempQuote.grouping === quote.grouping) {
          matches++;
        }
      });
      if (matches <= 1) {
        quote.grouping = '';
      }
    }
    return quote;
  });
  $scope.quotes = _.sortBy($scope.quotes, ['grouping', 'value']);
  $scope.quoteList = _.groupBy($scope.quotes, 'grouping');
  _.each($scope.quoteList, function (quoteArrayObject) {
    quoteArrayObject = _.sortBy(quoteArrayObject, ['value']);
  });
  $scope.selectedQuotes = [];
  if ($scope.quotes.length === 1) {
    $scope.selectedQuotes.push($scope.quotes[0]);
    $scope.quotes[0].checked = true;
  } else {
    _.each($scope.quotes, function (quote) {
      if (_.endsWith(quote.value, 'true')) {
        $scope.selectedQuotes.push(quote);
        quote.checked = true;
      }
    });
  }
  $scope.handleClick = function (item, group) {
    if (group) {
      if (_.some($scope.selectedQuotes, ['grouping', item.grouping])) {
        _.remove($scope.selectedQuotes, function (currentObject) {
          return currentObject.grouping === item.grouping;
        });
      }
      $scope.selectedQuotes.push(item);
    } else {
      if (item.checked) {
        $scope.selectedQuotes.push(item);
      } else {
        _.pull($scope.selectedQuotes, item);
      }
    }
  };
  $scope.canEnableConfirmButton = function () {
    return $scope.selectedQuotes.length !== 0;
  };
  $scope.onConfirm = function () {
    var quoteIds = [];
    _.each($scope.selectedQuotes, function (quote) {
      quoteIds.push(parseInt(_.split(quote.value, '::')[0]));
    });
    $scope.$close({
      selectedQuoteIds: quoteIds
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
BindActionModalController.$inject = ["$rootScope", "$scope", "options", "localization", "coreConstant"];
angular.module('gw-um-submission').controller('bindActionModalController', BindActionModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 425 */
/***/ (function(module) {

module.exports = JSON.parse("{\"submission\":{\"wizard\":{\"beginBinding\":{\"cancel\":\"Cancel\",\"confirm\":\"Begin Binding\",\"dataSet\":\"Sent Quotes Eligible for Begin Binding\",\"loadingBar\":\"Beginning Binding...\",\"title\":\"Begin Binding\"},\"declineToBindFromSent\":{\"cancel\":\"Cancel\",\"confirm\":\"Decline to Bind\",\"dataSet\":\"Sent Quotes Eligible for Decline to Bind\",\"title\":\"Decline to Bind\"},\"requestToBind\":{\"cancel\":\"Cancel\",\"confirm\":\"Request to Bind\",\"dataSet\":\"Sent Quotes Eligible for Request to Bind\",\"loadingBar\":\"Request Binding...\",\"title\":\"Request to Bind\"},\"bindProposal\":{\"cancel\":\"Cancel\",\"confirm\":\"Bind\",\"dataSet\":\"Sent Quotes Eligible for Bind\",\"loadingBar\":\"Binding Proposal...\",\"title\":\"Bind\"}}}}");

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

var path = '/wizard/actions/copyProposal/copyProposalModal.tpl.html';
var html = "<div class=\"modal-view-wrapper copyPolicyModalContent\">\n\n    <!--Header-->\n    <div class=\"modal-header header\">\n        <h4 class=\"modal-title\">{{ ::i18n.title }}</h4>\n        <button ng-click=\"$dismiss()\" class=\"close btn btn-link\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <!--Content-->\n    <div class=\"modal-body contentContainer\">\n\n        <div class=\"proposalList\">\n\n            <div ng-repeat=\"proposal in proposalList\"\n                 class=\"proposalOption\"\n                 ng-class=\"{ selected: proposal.selected }\">\n                <label>\n                    <input type=\"checkbox\"\n                           ng-change=\"onSelectQuote($event, proposal)\"\n                           ng-model=\"proposal.selected\"\n                           ng-checked=\"proposal.selected\">\n                    {{ ::proposal.name }}\n                </label>\n            </div>\n        </div>\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\"\n                ng-disabled=\"isOkayDisabled\"\n                ng-click=\"onCopyProposal()\">\n            {{ ::i18n.okayButton }}\n        </button>\n        <button class=\"btn btn-default\"\n                ng-click=\"$dismiss()\">{{ ::i18n.cancelButton }}\n        </button>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(92);

/*@ngInject*/
var CopyProposalModalController = function CopyProposalModalController($rootScope, $scope, $state, $stateParams, submissionConstant, coreMediator, submissionId, proposalId, proposalActionsMediator, coreConstant) {
  var dynamicDataSetParams = {
    name: 'Proposal Quotes',
    submissionUri: "com.firstbest.underwriting.submission.Submission:".concat(submissionId),
    ownerUri: "com.firstbest.underwriting.proposal.Proposal:".concat(proposalId)
  };
  $scope.i18n = locale;
  $scope.isOkayDisabled = false;
  function init() {
    coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(function (result) {
      $scope.proposalList = _.map(result, function (item) {
        item.selected = true;
        return item;
      });
      if ($scope.proposalList.length === 1) {
        $scope.onCopyProposal();
      }
    });
  }
  $scope.onSelectQuote = function (event, proposal) {
    var selectedQuoteList = _.filter($scope.proposalList, function (quote) {
      return quote.selected;
    });
    $scope.isOkayDisabled = _.isEmpty(selectedQuoteList);
  };
  $scope.onCopyProposal = function () {
    var quotes = _.filter($scope.proposalList, function (proposal) {
      return proposal.selected;
    });
    quotes = _.map(quotes, function (quote) {
      return quote.value;
    });
    $scope.$close({
      quotes: quotes
    });
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  init();
};
CopyProposalModalController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "submissionConstant", "coreMediator", "submissionId", "proposalId", "proposalActionsMediator", "coreConstant"];
angular.module('gw-um-submission').controller('copyProposalModalController', CopyProposalModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

var path = '/wizard/actions/documentBuilder/documentBuilderModal.tpl.html';
var html = "<base-modal modal-title=\"viewModel.proposal.description\"\n            ok=\"viewModel.sendButton\"\n            cancel=\"viewModel.closeButton\"\n            is-confirm-disabled=\"!canEnableConfirmButton()\"\n            on-confirm=\"onConfirm()\"\n            on-cancel=\"onCancel()\">\n\n    <!--Content-->\n    <div class=\"contentContainer\">\n        <div class=\"sectionsPane\">\n            <div class=\"stitchableSectionsContainer\" id=\"sortContainer\">\n                <div class=\"proposalHeader\">\n                    <h4 class=\"headerText\">{{::viewModel.sectionHeaderText}}</h4>\n                    <button class=\"btn btn-default btn-sm\"\n                            ng-class=\"{'active': viewModel.previewActive}\"\n                            ng-click=\"onPreviewClick()\">{{ i18n.preview }}\n                    </button>\n                </div>\n                <ul class=\"stitchableSectionsList\"\n                    as-sortable=\"sortOptions\"\n                    data-ng-model=\"viewModel.stitchableSections\">\n                    <li class=\"as-sortable-item\"\n                        ng-class=\"{'selected' : section.selected}\"\n                        ng-repeat=\"section in viewModel.stitchableSections\"\n                        as-sortable-item>\n                        <div as-sortable-item-handle\n                             class=\"sortableHandle\">\n                            <a class=\"sectionName\"\n                               ng-click=\"onSectionPreview(section)\"\n                               uib-tooltip=\"{{section.description}}\"\n                               tooltip-append-to-body=\"true\"\n                               tooltip-popup-delay=\"500\"\n                               tooltip-enable=\"{{section.isTooltip}}\"\n                               ui-is-tooltip-enabled=\"section.isTooltip\">{{section.description}}</a>\n                            <div class=\"spacer\"></div>\n                            <div class=\"fa fa-object-ungroup clickable\"\n                                 ng-click=\"updateSection(section, false)\"\n                                 uib-tooltip=\"{{ ::i18n.ungroupIconTooltip }}\"\n                                 tooltip-popup-delay=\"500\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-placement=\"bottom\">\n                            </div>\n                            <div class=\"fa fa-arrows-v draggable\"\n                                 uib-tooltip=\"{{ ::i18n.reorderIconTooltip }}\"\n                                 tooltip-popup-delay=\"500\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-placement=\"bottom\">\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"additionalSectionsContainer\">\n                <h4>{{ i18n.documents }}</h4>\n                <ul class=\"additionalSectionsList\">\n                    <li class=\"as-sortable-item\"\n                        ng-class=\"{'selected' : section.selected}\"\n                        ng-repeat=\"section in viewModel.additionalSections\">\n                        <div class=\"sortableHandle\">\n                            <a class=\"sectionName\"\n                               ng-click=\"onSectionPreview(section)\"\n                               uib-tooltip=\"{{section.description}}\"\n                               tooltip-append-to-body=\"true\"\n                               tooltip-popup-delay=\"500\"\n                               tooltip-enable=\"{{section.isTooltip}}\"\n                               ui-is-tooltip-enabled=\"section.isTooltip\">{{section.description}}</a>\n                            <div class=\"spacer\"></div>\n                            <div class=\"fa fa-object-group clickable\"\n                                 ng-if=\"allowStitch(section)\"\n                                 ng-click=\"updateSection(section, true)\"\n                                 uib-tooltip=\"{{ ::i18n.groupIconTooltip }}\"\n                                 tooltip-popup-delay=\"500\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-placement=\"bottom\"></div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class=\"previewPane\">\n            <div class=\"previewHeader\">\n                <h4 class=\"previewText\">{{ i18n.preview }}</h4>\n            </div>\n            <attachment-viewer class=\"attachmentViewerDirective pdfFrame\"\n                               attachment-id=\"{{viewModel.previewAttachmentId}}\">\n            </attachment-viewer>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(432);

/*@ngInject*/
var DocumentBuilderModalController = function DocumentBuilderModalController($rootScope, $scope, $window, attachmentUtil, proposal, currentSectionType, sectionType, proposalMediator, attachmentMediator, mimeType, coreConstant) {
  $scope.i18n = locale;
  $scope.viewModel = {
    stitchableSections: [],
    additionalSections: [],
    attachmentName: null,
    proposal: proposal,
    sectionHeaderText: null,
    previewActive: true,
    sendButton: _.get($scope.i18n, 'send'),
    closeButton: _.get($scope.i18n, 'close')
  };
  $scope.sortOptions = {
    orderChanged: function orderChanged(event) {
      var destinationSection = $scope.viewModel.stitchableSections[event.dest.index],
        sourceSection,
        dropIndex = event.dest.index;
      if (event.dest.index < event.source.index) {
        dropIndex++;
      } else {
        dropIndex--;
      }
      sourceSection = $scope.viewModel.stitchableSections[dropIndex];
      proposalMediator.moveSection(destinationSection.id, sourceSection.proposalOrdinalNumber).then(getSections);
    },
    containment: '#sortContainer',
    containerPositioning: 'relative'
  };
  $scope.updateSection = function (section, stitchable) {
    _.remove($scope.viewModel.stitchableSections, {
      'id': section.id
    });
    _.remove($scope.viewModel.additionalSections, {
      'id': section.id
    });
    proposalMediator.updateSection(section.id, stitchable).then(getSections);
  };
  $scope.onPreviewClick = function () {
    $scope.viewModel.previewActive = true;
    clearSelectedSections();
    proposalMediator.stitchSections(proposal.id, currentSectionType).then(function (result) {
      $scope.viewModel.attachmentName = result[0].name;
      $scope.viewModel.previewAttachmentId = result[0].id;
    });
  };
  $scope.displayPreview = function () {
    $scope.viewModel.previewActive = true;
    proposalMediator.stitchSections(proposal.id, currentSectionType).then(function (result) {
      $scope.viewModel.attachmentName = result[0].name;
      $scope.viewModel.previewAttachmentId = result[0].id;
      getSections();
    });
  };
  $scope.onSectionPreview = function (section) {
    var isPdf = section.attachmentMimeType === mimeType.PDF;
    if (isPdf) {
      clearSelectedSections();
      $scope.viewModel.attachmentMimeType = section.attachmentMimeType;
      $scope.viewModel.attachmentName = section.description;
      section.selected = true;
      $scope.viewModel.previewAttachmentId = section.attachmentId;
      $scope.viewModel.previewActive = false;
    } else {
      attachmentMediator.retrieveAttachment(section.attachmentId).then(function (result) {
        var attachmentName = result.Attachment.name;
        attachmentUtil.getAttachmentLinkURL(section.attachmentId, attachmentName).then(function (url) {
          $window.open(url, '_blank');
        });
      });
    }
  };
  $scope.allowStitch = function (section) {
    var attachmentMimeType = section.attachmentMimeType;
    return _.isNil(attachmentMimeType) || attachmentMimeType === mimeType.PDF;
  };
  function clearSelectedSections() {
    _.each($scope.viewModel.stitchableSections, function (section) {
      section.selected = false;
    });
    _.each($scope.viewModel.additionalSections, function (section) {
      section.selected = false;
    });
  }
  function getSections() {
    proposalMediator.getSections(proposal.id).then(function (result) {
      $scope.viewModel.stitchableSections = _.filter(result, function (section) {
        return section.stitchable && section.type === currentSectionType;
      });
      $scope.viewModel.additionalSections = _.filter(result, function (section) {
        return !section.stitchable && section.type === currentSectionType;
      });
    });
  }
  function init() {
    $scope.isInModal = true;
    var sectionTextKey;
    if (currentSectionType === sectionType.BINDER) {
      sectionTextKey = 'binderSection';
    } else {
      sectionTextKey = 'proposalSection';
    }
    $scope.displayPreview();
    $scope.viewModel.sectionHeaderText = _.get($scope.i18n, sectionTextKey);
  }
  $scope.canEnableConfirmButton = function () {
    return true;
  };
  $scope.onConfirm = function () {
    $scope.$close();
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  init();
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
DocumentBuilderModalController.$inject = ["$rootScope", "$scope", "$window", "attachmentUtil", "proposal", "currentSectionType", "sectionType", "proposalMediator", "attachmentMediator", "mimeType", "coreConstant"];
angular.module('gw-um-submission').controller('documentBuilderModalController', DocumentBuilderModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 432 */
/***/ (function(module) {

module.exports = JSON.parse("{\"send\":\"Send\",\"close\":\"Close\",\"binderSection\":\"Binder\",\"proposalSection\":\"Proposal\",\"preview\":\"Preview\",\"documents\":\"Additional Documents\",\"ungroupIconTooltip\":\"Ungroup item.\",\"groupIconTooltip\":\"Group  item.\",\"reorderIconTooltip\":\"Reorder item.\"}");

/***/ }),
/* 433 */
/***/ (function(module, exports) {

/*@ngInject*/
var ChangeProductsRepository = function ChangeProductsRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.changeProduct = function (submissionId, productShortNames) {
    var url = '/rest/Submission/' + submissionId + '/changeProduct?productShortNames=' + productShortNames;
    return this.post(url);
  };
};
ChangeProductsRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('changeProductsRepository', ChangeProductsRepository);

/***/ }),
/* 434 */
/***/ (function(module, exports) {

/*@ngInject*/
var CheckClearanceRepository = function CheckClearanceRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.checkClearance = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/checkClearance';
    return this.get(url);
  };
};
CheckClearanceRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('checkClearanceRepository', CheckClearanceRepository);

/***/ }),
/* 435 */
/***/ (function(module, exports) {

/*@ngInject*/
var ClearReadySubmissionRepository = function ClearReadySubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.markSubmissionClearReady = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/markClearReady',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
ClearReadySubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('clearReadySubmissionRepository', ClearReadySubmissionRepository);

/***/ }),
/* 436 */
/***/ (function(module, exports) {

/*@ngInject*/
var ClearSubmissionRepository = function ClearSubmissionRepository(baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.markSubmissionClear = function (submissionId, isClear, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/markClearance',
      config = {
        params: {
          isRiskClear: isClear,
          reason: reason,
          detail: detail,
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.revertToClear = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/revertToClear',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
ClearSubmissionRepository.$inject = ["baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('clearSubmissionRepository', ClearSubmissionRepository);

/***/ }),
/* 437 */
/***/ (function(module, exports) {

/*@ngInject*/
var CopySubmissionRepository = function CopySubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.copySubmission = function (submissionId, copyOptions) {
    var url = "/rest/Submission/".concat(submissionId, "/copySubmission"),
      config = {
        params: {
          copyOptions: copyOptions
        }
      };
    return this.post(url, {}, config);
  };
};
CopySubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('copySubmissionRepository', CopySubmissionRepository);

/***/ }),
/* 438 */
/***/ (function(module, exports) {

/*@ngInject*/
var CreateProposalRepository = function CreateProposalRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createProposal = function (submissionId, productTemplateIds) {
    var templateIds = '';
    angular.forEach(productTemplateIds, function (productTemplateId) {
      var str = templateIds !== '' ? '&' : '';
      templateIds += str + 'productTemplateId=' + productTemplateId;
    });
    var url = '/rest/Submission/' + submissionId + '/createProposal?' + templateIds;
    return this.post(url);
  };
};
CreateProposalRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('createProposalRepository', CreateProposalRepository);

/***/ }),
/* 439 */
/***/ (function(module, exports) {

/*@ngInject*/
var DeclineSubmissionRepository = function DeclineSubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.decline = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/declineWithForm',
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.createDeclinationForm = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/declinationForm',
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.deleteDeclinationForm = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/declinationForm';
    return this.delete(url);
  };
};
DeclineSubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('declineSubmissionRepository', DeclineSubmissionRepository);

/***/ }),
/* 440 */
/***/ (function(module, exports) {

/*@ngInject*/
var DisableAutomationRepository = function DisableAutomationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.disableAutomation = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/disableAutomation';
    return this.post(url);
  };
};
DisableAutomationRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('disableAutomationRepository', DisableAutomationRepository);

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var GetQuotableProductTemplatesRepository = function GetQuotableProductTemplatesRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getQuotableProductTemplates = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/quotableProductTemplates';
    return this.get(url);
  };
  this.processGetResponseData = function (responseData) {
    return _.sortBy(responseData, 'name');
  };
};
GetQuotableProductTemplatesRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('getQuotableProductTemplatesRepository', GetQuotableProductTemplatesRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 442 */
/***/ (function(module, exports) {

/*@ngInject*/
var MakeApplicationRepository = function MakeApplicationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.makeApplication = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/makeApplication',
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
};
MakeApplicationRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('makeApplicationRepository', MakeApplicationRepository);

/***/ }),
/* 443 */
/***/ (function(module, exports) {

/*@ngInject*/
var MarkSubmissionLostRepository = function MarkSubmissionLostRepository(baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.markAsLost = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/markAsLostWithForm',
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.createMarkAsLostForm = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/markAsLostForm',
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.deleteMarkAsLostForm = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/markAsLostForm';
    return this.delete(url);
  };
};
MarkSubmissionLostRepository.$inject = ["baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('markSubmissionLostRepository', MarkSubmissionLostRepository);

/***/ }),
/* 444 */
/***/ (function(module, exports) {

/*@ngInject*/
var ModifySubmissionRepository = function ModifySubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.modifySubmission = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/modify';
    return this.post(url);
  };
};
ModifySubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('modifySubmissionRepository', ModifySubmissionRepository);

/***/ }),
/* 445 */
/***/ (function(module, exports) {

/*@ngInject*/
var PrequalificationRepository = function PrequalificationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.cancelPrequalification = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/cancelPreQualification';
    return this.post(url);
  };
  this.startPrequalification = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/startPreQualification';
    return this.post(url);
  };
  this.submitPrequalification = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/submitPreQualification';
    return this.post(url);
  };
  this.checkPrequalification = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/checkPreQualification';
    return this.post(url);
  };
};
PrequalificationRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('prequalificationRepository', PrequalificationRepository);

/***/ }),
/* 446 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReactivateSubmissionRepository = function ReactivateSubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.reactivate = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/reactivate',
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
};
ReactivateSubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('reactivateSubmissionRepository', ReactivateSubmissionRepository);

/***/ }),
/* 447 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReferralRepository = function ReferralRepository(baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.declineReferral = function (submissionId, comments, doDecline) {
    var url = '/rest/Submission/' + submissionId + '/Referral',
      body = {
        detail: comments,
        doDecline: doDecline,
        notification: notificationConstant.email.NONE
      };
    return this.post(url, body);
  };
  this.clearReferral = function (submissionId, detail, doDecline) {
    var url = '/rest/Submission/' + submissionId + '/Referral',
      body = {
        detail: detail,
        doDecline: doDecline,
        notification: notificationConstant.email.NONE
      };
    return this.post(url, body);
  };
  this.retractReferral = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/retractReferral',
      body = {
        reason: reason,
        detail: detail,
        notification: notificationConstant.email.NONE
      };
    return this.post(url, body);
  };
  this.getReferralClearanceType = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/referralClearanceType';
    return this.get(url);
  };
};
ReferralRepository.$inject = ["baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('referralRepository', ReferralRepository);

/***/ }),
/* 448 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReferSubmissionRepository = function ReferSubmissionRepository(baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.referSubmission = function (submissionId, reason, underwriterId, detail) {
    var url = '/rest/Submission/' + submissionId + '/Referral',
      body = {
        reason: reason,
        detail: detail,
        referredUnderwriterId: underwriterId,
        notification: notificationConstant.email.NONE
      };
    return this.post(url, body);
  };
};
ReferSubmissionRepository.$inject = ["baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('referSubmissionRepository', ReferSubmissionRepository);

/***/ }),
/* 449 */
/***/ (function(module, exports) {

/*@ngInject*/
var RejectSubmissionRepository = function RejectSubmissionRepository(baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.reject = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/reject',
      config = {
        params: {
          reason: reason,
          detail: detail,
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
RejectSubmissionRepository.$inject = ["baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('rejectSubmissionRepository', RejectSubmissionRepository);

/***/ }),
/* 450 */
/***/ (function(module, exports) {

/*@ngInject*/
var RenewalRepository = function RenewalRepository(baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.submitRenewal = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/submitRenewal',
      config = {
        params: {
          disableAutomation: true
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.submitNonRenewal = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/submitNonRenewal',
      config = {
        params: {
          reason: reason,
          detail: detail,
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.retractNonRenewal = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/retractNonRenewal';
    return this.post(url);
  };
  this.markNonRenewed = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/markNonRenewed',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.markRenewed = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/markRenewed',
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.markExpired = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/markExpired',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.flagForNonRenewal = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/flagForNonRenewal',
      config = {
        params: {
          reason: reason,
          detail: detail,
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.clearNonRenewalFlag = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/clearNonRenewalFlag',
      config = {
        params: {
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
RenewalRepository.$inject = ["baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('renewalRepository', RenewalRepository);

/***/ }),
/* 451 */
/***/ (function(module, exports) {

/*@ngInject*/
var ResubmitSubmissionRepository = function ResubmitSubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.resubmit = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/resubmit';
    return this.post(url);
  };
};
ResubmitSubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('resubmitSubmissionRepository', ResubmitSubmissionRepository);

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment) {/*@ngInject*/
var RewriteSubmissionRepository = function RewriteSubmissionRepository(baseRepository, submissionCopyOptions, notificationConstant) {
  angular.extend(this, baseRepository);
  this.rewriteSubmission = function (submissionId, reason, detail, effectiveDate, expirationDate, copyOptions) {
    var url = '/rest/Submission/' + submissionId + '/rewrite',
      config = {
        params: {
          reason: reason,
          detail: detail,
          rewriteEffectiveDate: moment.utc(effectiveDate).format('YYYY-MM-DD'),
          rewriteExpirationDate: moment.utc(expirationDate).format('YYYY-MM-DD'),
          rewriteOptions: copyOptions,
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
RewriteSubmissionRepository.$inject = ["baseRepository", "submissionCopyOptions", "notificationConstant"];
angular.module('gw-um-submission').service('rewriteSubmissionRepository', RewriteSubmissionRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SplitSubmissionRepository = function SplitSubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.splitSubmission = function (submissionId, productShortNames) {
    var productShortNameString = '',
      url = '',
      str = '',
      config;
    _.each(productShortNames, function (productShortName) {
      str = productShortNameString !== '' ? '&' : '';
      productShortNameString += str + 'productShortName=' + productShortName;
    });
    url = '/rest/Submission/' + submissionId + '/splitSubmission?' + productShortNameString, config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return this.post(url, {}, config);
  };
};
SplitSubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('splitSubmissionRepository', SplitSubmissionRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 454 */
/***/ (function(module, exports) {

/*@ngInject*/
var UpdateStatusReasonRepository = function UpdateStatusReasonRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.updateStatusReason = function (submissionId, reason, detail) {
    var url = '/rest/Submission/' + submissionId + '/UpdateStatusReason',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
UpdateStatusReasonRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('updateStatusReasonRepository', UpdateStatusReasonRepository);

/***/ }),
/* 455 */
/***/ (function(module, exports) {

/*@ngInject*/
var CreateQuoteRepository = function CreateQuoteRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createQuote = function (submissionId, productTemplateId) {
    var url = '/rest/Submission/' + submissionId + '/createQuote?productTemplateId=' + productTemplateId;
    return this.post(url);
  };
};
CreateQuoteRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('createQuoteRepository', CreateQuoteRepository);

/***/ }),
/* 456 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReevaluateSubmissionRepository = function ReevaluateSubmissionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.reevaluate = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/reevaluateSubmission',
      config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
};
ReevaluateSubmissionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('reevaluateSubmissionRepository', ReevaluateSubmissionRepository);

/***/ }),
/* 457 */
/***/ (function(module, exports) {

/*@ngInject*/
var ActionsMediator = function ActionsMediator(makeApplicationRepository, modificationsRepository, modifySubmissionRepository, markSubmissionLostRepository, clearSubmissionRepository, declineSubmissionRepository, rejectSubmissionRepository, reactivateSubmissionRepository, reevaluateSubmissionRepository, createQuoteRepository, getQuotableProductTemplatesRepository, changeProductsRepository, updateStatusReasonRepository, submitModificationsRepository, discardModificationsRepository, referSubmissionRepository, clearReadySubmissionRepository, createProposalRepository, checkClearanceRepository, copySubmissionRepository, referralRepository, splitSubmissionRepository, acknowledgeModificationsRepository, rewriteSubmissionRepository, resubmitSubmissionRepository, renewalRepository, disableAutomationRepository) {
  this.makeApplication = function (submissionId) {
    return makeApplicationRepository.makeApplication(submissionId);
  };
  this.submitModifications = function (submissionId) {
    return submitModificationsRepository.submitModifications(submissionId);
  };
  this.markAsLost = function (submissionId, reason, detail) {
    return markSubmissionLostRepository.markAsLost(submissionId, reason, detail);
  };
  this.discardModifications = function (submissionId) {
    return discardModificationsRepository.discardModifications(submissionId);
  };
  this.markSubmissionClear = function (submissionId) {
    return clearSubmissionRepository.markSubmissionClear(submissionId, true);
  };
  this.acknowledgeModifications = function (submissionId) {
    return acknowledgeModificationsRepository.acknowledgeModifications(submissionId);
  };
  this.markSubmissionNotClear = function (submissionId, reason, detail) {
    return clearSubmissionRepository.markSubmissionClear(submissionId, false, reason, detail);
  };
  this.markSubmissionClearReady = function (submissionId, reason, detail) {
    return clearReadySubmissionRepository.markSubmissionClearReady(submissionId, reason, detail);
  };
  this.revertToClear = function (submissionId, reason, detail) {
    return clearSubmissionRepository.revertToClear(submissionId, reason, detail);
  };
  this.copySubmission = function (submissionId, copyOptions) {
    return copySubmissionRepository.copySubmission(submissionId, copyOptions);
  };
  this.handleCheckClearance = function (submissionId) {
    return checkClearanceRepository.checkClearance(submissionId);
  };
  this.decline = function (submissionId, primaryReason, comments) {
    return declineSubmissionRepository.decline(submissionId, primaryReason, comments);
  };
  this.reject = function (submissionId, primaryReason, comments) {
    return rejectSubmissionRepository.reject(submissionId, primaryReason, comments);
  };
  this.reactivate = function (submissionId) {
    return reactivateSubmissionRepository.reactivate(submissionId);
  };
  this.reevaluate = function (submissionId) {
    return reevaluateSubmissionRepository.reevaluate(submissionId);
  };
  this.createQuote = function (submissionId, productId) {
    return createQuoteRepository.createQuote(submissionId, productId);
  };
  this.getQuotableProductTemplates = function (quoteId) {
    return getQuotableProductTemplatesRepository.getQuotableProductTemplates(quoteId);
  };
  this.changeProducts = function (submissionId, productShortNames) {
    return changeProductsRepository.changeProduct(submissionId, productShortNames);
  };
  this.updateStatusReason = function (submissionId, reason, detail) {
    return updateStatusReasonRepository.updateStatusReason(submissionId, reason, detail);
  };
  this.modifySubmission = function (submissionId) {
    return modifySubmissionRepository.modifySubmission(submissionId);
  };
  this.referSubmission = function (submissionId, primaryReason, underwriterId, comments) {
    return referSubmissionRepository.referSubmission(submissionId, primaryReason, underwriterId, comments);
  };
  this.retractReferral = function (submissionId, primaryReason, comments) {
    return referralRepository.retractReferral(submissionId, primaryReason, comments);
  };
  this.getReferralClearanceType = function (submissionId) {
    return referralRepository.getReferralClearanceType(submissionId);
  };
  this.clearReferral = function (submissionId, detail, doDecline) {
    return referralRepository.clearReferral(submissionId, detail, doDecline);
  };
  this.splitSubmission = function (submissionId, productShortNames) {
    return splitSubmissionRepository.splitSubmission(submissionId, productShortNames);
  };
  this.rewriteSubmission = function (submissionId, reason, detail, effectiveDate, expirationDate, copyOptions) {
    return rewriteSubmissionRepository.rewriteSubmission(submissionId, reason, detail, effectiveDate, expirationDate, copyOptions);
  };
  this.resubmitSubmission = function (submissionId) {
    return resubmitSubmissionRepository.resubmit(submissionId);
  };
  this.submitRenewal = function (submissionId) {
    return renewalRepository.submitRenewal(submissionId);
  };
  this.submitNonRenewal = function (submissionId, primaryReason, comments) {
    return renewalRepository.submitNonRenewal(submissionId, primaryReason, comments);
  };
  this.retractNonRenewal = function (submissionId) {
    return renewalRepository.retractNonRenewal(submissionId);
  };
  this.flagForNonRenewal = function (submissionId, primaryReason, comments) {
    return renewalRepository.flagForNonRenewal(submissionId, primaryReason, comments);
  };
  this.clearNonRenewalFlag = function (submissionId) {
    return renewalRepository.clearNonRenewalFlag(submissionId);
  };
  this.disableAutomation = function (submissionId) {
    return disableAutomationRepository.disableAutomation(submissionId);
  };
  this.markExpired = function (submissionId, reason, detail) {
    return renewalRepository.markExpired(submissionId, reason, detail);
  };
  this.markRenewed = function (submissionId) {
    return renewalRepository.markRenewed(submissionId);
  };
  this.markNonRenewed = function (submissionId, reason, detail) {
    return renewalRepository.markNonRenewed(submissionId, reason, detail);
  };
  this.declineReferral = function (submissionId, comments) {
    return referralRepository.declineReferral(submissionId, comments, true);
  };
};
ActionsMediator.$inject = ["makeApplicationRepository", "modificationsRepository", "modifySubmissionRepository", "markSubmissionLostRepository", "clearSubmissionRepository", "declineSubmissionRepository", "rejectSubmissionRepository", "reactivateSubmissionRepository", "reevaluateSubmissionRepository", "createQuoteRepository", "getQuotableProductTemplatesRepository", "changeProductsRepository", "updateStatusReasonRepository", "submitModificationsRepository", "discardModificationsRepository", "referSubmissionRepository", "clearReadySubmissionRepository", "createProposalRepository", "checkClearanceRepository", "copySubmissionRepository", "referralRepository", "splitSubmissionRepository", "acknowledgeModificationsRepository", "rewriteSubmissionRepository", "resubmitSubmissionRepository", "renewalRepository", "disableAutomationRepository"];
angular.module('gw-um-submission').service('actionsMediator', ActionsMediator);

/***/ }),
/* 458 */
/***/ (function(module, exports) {

/*@ngInject*/
var DeclineMediator = function DeclineMediator(declineSubmissionRepository) {
  this.createDeclinationForm = function (submissionId) {
    return declineSubmissionRepository.createDeclinationForm(submissionId);
  };
  this.deleteDeclinationForm = function (submissionId) {
    return declineSubmissionRepository.deleteDeclinationForm(submissionId);
  };
};
DeclineMediator.$inject = ["declineSubmissionRepository"];
angular.module('gw-um-submission').service('declineMediator', DeclineMediator);

/***/ }),
/* 459 */
/***/ (function(module, exports) {

/*@ngInject*/
var MarkAsLostMediator = function MarkAsLostMediator(markSubmissionLostRepository) {
  this.createMarkAsLostForm = function (submissionId) {
    return markSubmissionLostRepository.createMarkAsLostForm(submissionId);
  };
  this.deleteMarkAsLostForm = function (submissionId) {
    return markSubmissionLostRepository.deleteMarkAsLostForm(submissionId);
  };
};
MarkAsLostMediator.$inject = ["markSubmissionLostRepository"];
angular.module('gw-um-submission').service('markAsLostMediator', MarkAsLostMediator);

/***/ }),
/* 460 */
/***/ (function(module, exports) {

/*@ngInject*/
var EndorsementActionRepository = function EndorsementActionRepository($q, baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.getEndorsementSummary = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId;
    return this.get(url);
  };
  this.deleteEndorsement = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId;
    return this.delete(url);
  };
  this.start = function (policyId) {
    var url = '/rest/Policy/' + policyId + '/startEndorsement';
    return this.post(url);
  };
  this.create = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/createEndorsement';
    return this.post(url);
  };
  this.submit = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/submit',
      config = {
        params: {
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.startRating = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/startRating';
    return this.post(url);
  };
  this.refreshQuote = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/refreshQuote';
    return this.post(url);
  };
  this.submitForIssuance = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/submitForIssuance',
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.markIssued = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/markAsIssued',
      config = {
        params: {
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.revertToSubmitted = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/revertToSubmitted';
    return this.post(url);
  };
  this.revertToPendingIssuance = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/revertToPendingIssuance';
    return this.post(url);
  };
  this.approve = function (endorsementId, processingInstructions) {
    var url = "/rest/Endorsement/".concat(endorsementId, "/approve");
    return this.post(url, processingInstructions);
  };
  this.decline = function (endorsementId, reason, detail) {
    var url = '/rest/Endorsement/' + endorsementId + '/decline',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.generateRating = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/generateRating';
    return this.post(url);
  };
  this.startPricing = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/startPricing';
    return this.post(url);
  };
  this.modifyPricing = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/modifyPricing';
    return this.post(url);
  };
  this.modifyRating = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/modifyRating';
    return this.post(url);
  };
  this.generateRatingAttachments = function (endorsementId, attachmentsToGenerate) {
    var url = '/rest/Endorsement/' + endorsementId + '/generateRatingAttachments',
      config = {
        params: {
          attachmentsToGenerate: attachmentsToGenerate
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
EndorsementActionRepository.$inject = ["$q", "baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('endorsementActionRepository', EndorsementActionRepository);

/***/ }),
/* 461 */
/***/ (function(module, exports) {

/*@ngInject*/
var EndorsementActionsMediator = function EndorsementActionsMediator(endorsementActionRepository) {
  this.getEndorsementSummary = function (endorsementId) {
    return endorsementActionRepository.getEndorsementSummary(endorsementId);
  };
  this.delete = function (endorsementId) {
    return endorsementActionRepository.deleteEndorsement(endorsementId);
  };
  this.create = function (endorsementId) {
    return endorsementActionRepository.create(endorsementId);
  };
  this.submit = function (endorsementId) {
    return endorsementActionRepository.submit(endorsementId);
  };
  this.startRating = function (endorsementId) {
    return endorsementActionRepository.startRating(endorsementId);
  };
  this.refreshQuote = function (endorsementId) {
    return endorsementActionRepository.refreshQuote(endorsementId);
  };
  this.submitForIssuance = function (endorsementId) {
    return endorsementActionRepository.submitForIssuance(endorsementId);
  };
  this.markIssued = function (endorsementId) {
    return endorsementActionRepository.markIssued(endorsementId);
  };
  this.revertToSubmitted = function (endorsementId) {
    return endorsementActionRepository.revertToSubmitted(endorsementId);
  };
  this.approve = function (endorsementId, processingInstructions) {
    return endorsementActionRepository.approve(endorsementId, processingInstructions);
  };
  this.decline = function (endorsementId, reason, detail) {
    return endorsementActionRepository.decline(endorsementId, reason, detail);
  };
  this.generateRating = function (endorsementId) {
    return endorsementActionRepository.generateRating(endorsementId);
  };
  this.generateRatingAttachments = function (endorsementId, attachmentsToGenerate) {
    return endorsementActionRepository.generateRatingAttachments(endorsementId, attachmentsToGenerate);
  };
  this.startPricing = function (endorsementId) {
    return endorsementActionRepository.startPricing(endorsementId);
  };
  this.modifyPricing = function (endorsementId) {
    return endorsementActionRepository.modifyPricing(endorsementId);
  };
  this.modifyRating = function (endorsementId) {
    return endorsementActionRepository.modifyRating(endorsementId);
  };
  this.revertToPendingIssuance = function (endorsementId) {
    return endorsementActionRepository.revertToPendingIssuance(endorsementId);
  };
};
EndorsementActionsMediator.$inject = ["endorsementActionRepository"];
angular.module('gw-um-submission').service('endorsementActionsMediator', EndorsementActionsMediator);

/***/ }),
/* 462 */
/***/ (function(module, exports) {

/*@ngInject*/
var EndorsementActionsRepository = function EndorsementActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadEndorsementActions = function (endorsementId) {
    var url = '/rest/Actions?uri=com.firstbest.underwriting.policy.endorsement.Endorsement:' + endorsementId + '&registrationIdentifier=/Endorsement/' + endorsementId,
      cacheKey = 'endorsementActions:' + endorsementId;
    if (currentSubmissionModel.hasActionsRegistration('/Endorsement/' + endorsementId)) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration('/Endorsement/' + endorsementId, url);
        return responseData;
      });
    }
  };
};
EndorsementActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('endorsementActionsRepository', EndorsementActionsRepository);

/***/ }),
/* 463 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyActionRepository = function PolicyActionRepository(baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.reinstatePolicy = function (policyId, reason, detail) {
    var url = '/rest/Policy/' + policyId + '/reinstateById',
      config = {
        params: {
          reason: reason,
          detail: detail,
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.startPolicyCancellation = function (policyId) {
    var url = '/rest/Policy/' + policyId + '/startCancellation';
    return this.post(url);
  };
  this.deleteDraftCancellation = function (policyCancellationId) {
    var url = '/rest/PolicyCancellation/' + policyCancellationId;
    return this.delete(url);
  };
  this.markAsCancelled = function (policyCancellationId) {
    var url = '/rest/PolicyCancellation/' + policyCancellationId + '/markAsCancelled',
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.requestCancellation = function (policyCancellationId) {
    var url = '/rest/PolicyCancellation/' + policyCancellationId + '/request',
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.rescindCancellation = function (policyCancellationId, reason, detail) {
    var url = '/rest/PolicyCancellation/' + policyCancellationId + '/rescind',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.retractCancellationRequest = function (policyCancellationId, reason, detail) {
    var url = '/rest/PolicyCancellation/' + policyCancellationId + '/retractRequest',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.revertToCancellationPending = function (policyCancellationId, reason, detail) {
    var url = '/rest/PolicyCancellation/' + policyCancellationId + '/revertToCancellationPending',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.submitForCancellation = function (policyCancellationId) {
    var url = '/rest/PolicyCancellation/' + policyCancellationId + '/submit',
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.beginIssuance = function (policyIssuanceId) {
    var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/startIssuance';
    return this.post(url);
  };
  this.markAsIssued = function (policyIssuanceId) {
    var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/markAsIssued';
    return this.post(url);
  };
  this.modifyIssuance = function (policyIssuanceId) {
    var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/modifyIssuance';
    return this.post(url);
  };
  this.revertToBound = function (policyIssuanceId, reason, detail) {
    var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/revertToBound',
      config = {
        params: {
          reason: reason,
          detail: detail
        }
      };
    return this.post(url, {}, config);
  };
  this.revertToPendingIssuance = function (policyIssuanceId, reason, detail) {
    var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/revertToPendingIssuance',
      config = {
        params: {
          reason: reason,
          detail: detail
        }
      };
    return this.post(url, {}, config);
  };
  this.submitForIssuance = function (policyIssuanceId) {
    var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/submitForIssuance';
    return this.post(url);
  };
};
PolicyActionRepository.$inject = ["baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('policyActionRepository', PolicyActionRepository);

/***/ }),
/* 464 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyActionsMediator = function PolicyActionsMediator(policyActionRepository, endorsementActionRepository, policyRewriteActionRepository) {
  this.startPolicyCancellation = function (policyId) {
    return policyActionRepository.startPolicyCancellation(policyId);
  };
  this.reinstatePolicy = function (policyCancellationId, reason, detail) {
    return policyActionRepository.reinstatePolicy(policyCancellationId, reason, detail);
  };
  this.startEndorsement = function (policyId) {
    return endorsementActionRepository.start(policyId);
  };
  this.startPolicyRewrite = function (policyId, isReissue) {
    return policyRewriteActionRepository.start(policyId, isReissue);
  };
};
PolicyActionsMediator.$inject = ["policyActionRepository", "endorsementActionRepository", "policyRewriteActionRepository"];
angular.module('gw-um-submission').service('policyActionsMediator', PolicyActionsMediator);

/***/ }),
/* 465 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyActionsRepository = function PolicyActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadPolicyActions = function (policyId) {
    var url = '/rest/Actions?uri=com.firstbest.underwriting.policy.Policy:' + policyId + '&registrationIdentifier=/Policy/' + policyId,
      cacheKey = 'policyActions:' + policyId;
    if (currentSubmissionModel.hasActionsRegistration('/Policy/' + policyId)) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration('/Policy/' + policyId, url);
        return responseData;
      });
    }
  };
};
PolicyActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('policyActionsRepository', PolicyActionsRepository);

/***/ }),
/* 466 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyCancellationActionsMediator = function PolicyCancellationActionsMediator(policyActionRepository) {
  this.deleteDraftCancellation = function (policyCancellationId) {
    return policyActionRepository.deleteDraftCancellation(policyCancellationId);
  };
  this.submitForCancellation = function (policyCancellationId) {
    return policyActionRepository.submitForCancellation(policyCancellationId);
  };
  this.markAsCancelled = function (policyCancellationId) {
    return policyActionRepository.markAsCancelled(policyCancellationId);
  };
  this.revertToCancellationPending = function (policyCancellationId, reason, detail) {
    return policyActionRepository.revertToCancellationPending(policyCancellationId, reason, detail);
  };
  this.rescindCancellation = function (policyCancellationId, reason, detail) {
    return policyActionRepository.rescindCancellation(policyCancellationId, reason, detail);
  };
  this.requestCancellation = function (policyCancellationId) {
    return policyActionRepository.requestCancellation(policyCancellationId);
  };
  this.retractCancellationRequest = function (policyCancellationId, reason, detail) {
    return policyActionRepository.retractCancellationRequest(policyCancellationId, reason, detail);
  };
};
PolicyCancellationActionsMediator.$inject = ["policyActionRepository"];
angular.module('gw-um-submission').service('policyCancellationActionsMediator', PolicyCancellationActionsMediator);

/***/ }),
/* 467 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyCancellationActionsRepository = function PolicyCancellationActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadPolicyCancellationActions = function (policyCancellationId) {
    var url = '/rest/Actions?uri=com.firstbest.underwriting.policy.cancellation.PolicyCancellation:' + policyCancellationId + '&registrationIdentifier=/PolicyCancellation/' + policyCancellationId,
      cacheKey = 'policyCancellationActions:' + policyCancellationId;
    if (currentSubmissionModel.hasActionsRegistration('/PolicyCancellation/' + policyCancellationId)) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration('/PolicyCancellation/' + policyCancellationId, url);
        return responseData;
      });
    }
  };
};
PolicyCancellationActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('policyCancellationActionsRepository', PolicyCancellationActionsRepository);

/***/ }),
/* 468 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyIssuanceActionsMediator = function PolicyIssuanceActionsMediator(policyActionRepository) {
  this.beginIssuance = function (policyIssuanceId) {
    return policyActionRepository.beginIssuance(policyIssuanceId);
  };
  this.revertToBound = function (policyIssuanceId, reason, detail) {
    return policyActionRepository.revertToBound(policyIssuanceId, reason, detail);
  };
  this.submitForIssuance = function (policyIssuanceId) {
    return policyActionRepository.submitForIssuance(policyIssuanceId);
  };
  this.modifyIssuance = function (policyIssuanceId) {
    return policyActionRepository.modifyIssuance(policyIssuanceId);
  };
  this.markAsIssued = function (policyIssuanceId) {
    return policyActionRepository.markAsIssued(policyIssuanceId);
  };
  this.revertToPendingIssuance = function (policyIssuanceId, reason, detail) {
    return policyActionRepository.revertToPendingIssuance(policyIssuanceId, reason, detail);
  };
};
PolicyIssuanceActionsMediator.$inject = ["policyActionRepository"];
angular.module('gw-um-submission').service('policyIssuanceActionsMediator', PolicyIssuanceActionsMediator);

/***/ }),
/* 469 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyIssuanceActionsRepository = function PolicyIssuanceActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadPolicyIssuanceActions = function (policyIssuanceId) {
    var url = '/rest/Actions?uri=com.firstbest.underwriting.policy.issuance.PolicyIssuance:' + policyIssuanceId + '&registrationIdentifier=/PolicyIssuance/' + policyIssuanceId,
      cacheKey = 'policyIssuanceActions:' + policyIssuanceId;
    if (currentSubmissionModel.hasActionsRegistration('/PolicyIssuance/' + policyIssuanceId)) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration('/PolicyIssuance/' + policyIssuanceId, url);
        return responseData;
      });
    }
  };
};
PolicyIssuanceActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('policyIssuanceActionsRepository', PolicyIssuanceActionsRepository);

/***/ }),
/* 470 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyRewriteActionRepository = function PolicyRewriteActionRepository($q, baseRepository, notificationConstant) {
  angular.extend(this, baseRepository);
  this.getPolicyRewriteSummary = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId);
    return this.get(url);
  };
  this.deletePolicyRewrite = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId);
    return this.delete(url);
  };
  this.start = function (policyId, isReissue) {
    var url = "/rest/Policy/".concat(policyId, "/startRewrite"),
      config = {
        params: {
          reissue: isReissue
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.create = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/createPolicyRewrite");
    return this.post(url);
  };
  this.submit = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/submit"),
      config = {
        params: {
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.startRating = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/startRating");
    return this.post(url);
  };
  this.refreshQuote = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/refreshQuote");
    return this.post(url);
  };
  this.submitForIssuance = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/submitForIssuance"),
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.markIssued = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/markAsIssued"),
      config = {
        params: {
          notification: notificationConstant.email.NONE
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.revertToSubmitted = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/revertToSubmitted");
    return this.post(url);
  };
  this.generateRating = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/generateRating");
    return this.post(url);
  };
  this.startPricing = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/startPricing");
    return this.post(url);
  };
  this.modifyPricing = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/modifyPricing");
    return this.post(url);
  };
  this.modifyRating = function (policyRewriteId) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/modifyRating");
    return this.post(url);
  };
  this.generateRatingAttachments = function (policyRewriteId, attachmentsToGenerate) {
    var url = "/rest/PolicyRewrite/".concat(policyRewriteId, "/generateRatingAttachments"),
      config = {
        params: {
          attachmentsToGenerate: attachmentsToGenerate
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
};
PolicyRewriteActionRepository.$inject = ["$q", "baseRepository", "notificationConstant"];
angular.module('gw-um-submission').service('policyRewriteActionRepository', PolicyRewriteActionRepository);

/***/ }),
/* 471 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyRewriteActionsMediator = function PolicyRewriteActionsMediator(policyRewriteActionRepository) {
  this.getPolicyRewriteSummary = function (policyRewriteId) {
    return policyRewriteActionRepository.getPolicyRewriteSummary(policyRewriteId);
  };
  this.delete = function (policyRewriteId) {
    return policyRewriteActionRepository.deletePolicyRewrite(policyRewriteId);
  };
  this.create = function (policyRewriteId) {
    return policyRewriteActionRepository.create(policyRewriteId);
  };
  this.submit = function (policyRewriteId) {
    return policyRewriteActionRepository.submit(policyRewriteId);
  };
  this.startRating = function (policyRewriteId) {
    return policyRewriteActionRepository.startRating(policyRewriteId);
  };
  this.refreshQuote = function (policyRewriteId) {
    return policyRewriteActionRepository.refreshQuote(policyRewriteId);
  };
  this.submitForIssuance = function (policyRewriteId) {
    return policyRewriteActionRepository.submitForIssuance(policyRewriteId);
  };
  this.markIssued = function (policyRewriteId) {
    return policyRewriteActionRepository.markIssued(policyRewriteId);
  };
  this.revertToSubmitted = function (policyRewriteId) {
    return policyRewriteActionRepository.revertToSubmitted(policyRewriteId);
  };
  this.generateRating = function (policyRewriteId) {
    return policyRewriteActionRepository.generateRating(policyRewriteId);
  };
  this.generateRatingAttachments = function (policyRewriteId, attachmentsToGenerate) {
    return policyRewriteActionRepository.generateRatingAttachments(policyRewriteId, attachmentsToGenerate);
  };
  this.startPricing = function (policyRewriteId) {
    return policyRewriteActionRepository.startPricing(policyRewriteId);
  };
  this.modifyPricing = function (policyRewriteId) {
    return policyRewriteActionRepository.modifyPricing(policyRewriteId);
  };
  this.modifyRating = function (policyRewriteId) {
    return policyRewriteActionRepository.modifyRating(policyRewriteId);
  };
};
PolicyRewriteActionsMediator.$inject = ["policyRewriteActionRepository"];
angular.module('gw-um-submission').service('policyRewriteActionsMediator', PolicyRewriteActionsMediator);

/***/ }),
/* 472 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyRewriteActionsRepository = function PolicyRewriteActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadPolicyRewriteActions = function (policyRewriteId) {
    var url = "/rest/Actions?uri=com.firstbest.underwriting.policy.rewrite.PolicyRewrite:".concat(policyRewriteId, "&registrationIdentifier=/PolicyRewrite/").concat(policyRewriteId),
      cacheKey = "policyRewriteActions:".concat(policyRewriteId);
    if (currentSubmissionModel.hasActionsRegistration("/PolicyRewrite/".concat(policyRewriteId))) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration("/PolicyRewrite/".concat(policyRewriteId), url);
        return responseData;
      });
    }
  };
};
PolicyRewriteActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('policyRewriteActionsRepository', PolicyRewriteActionsRepository);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ProposalActionRepository = function ProposalActionRepository(baseRepository, currentSubmissionModel) {
  angular.extend(this, baseRepository);
  this.addSection = function (proposalId, sectionTemplateId, type) {
    var url = '/rest/Proposal/' + proposalId + '/addSection',
      config = {
        params: {
          sectionTemplateIds: sectionTemplateId,
          sectionType: type
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.modifyProposal = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/ModifyProposal';
    return this.post(url);
  };
  this.addSectionFromDocument = function (proposalId, attachmentId, displayLabel, sectionType) {
    var url = '/rest/Proposal/' + proposalId + '/addSectionFromDocument',
      config = {
        params: {
          attachmentId: attachmentId,
          displayLabel: displayLabel
        }
      };
    if (sectionType) {
      config.params.sectionType = sectionType;
    }
    return this.post(url, {}, config);
  };
  this.beginBinding = function (proposalId, quoteIds) {
    var url = '/rest/Proposal/beginBinding?',
      config = {
        params: {
          quoteIds: quoteIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.bindProposal = function (proposalId, quoteIds) {
    var url = '/rest/Proposal/' + proposalId + '/bind?',
      config = {
        params: {
          quoteIds: quoteIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.copyProposal = function (proposalId, quoteList) {
    var url = '/rest/Proposal/' + proposalId + '/copy?';
    _.each(quoteList, function (quoteId, index) {
      var prepend = index === 0 ? '' : '&';
      url += prepend + 'quoteId=' + quoteId;
    });
    return this.post(url);
  };
  this.createQuote = function (submissionId, proposalId, productTemplateId) {
    var url = '/rest/Proposal/' + proposalId + '/createQuote',
      config = {
        params: {
          submissionId: submissionId,
          productTemplateId: productTemplateId,
          proposalOrdinalNumber: -1
        }
      };
    return this.post(url, {}, config);
  };
  this.deleteProposal = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/delete';
    return this.delete(url);
  };
  this.deleteSection = function (sectionTemplateId, invalidateProposalDocument) {
    var url = '/rest/ProposalSection/' + sectionTemplateId + '/deleteSection',
      config = {
        params: {
          invalidateProposalDocument: invalidateProposalDocument
        }
      };
    return this.delete(url, config);
  };
  this.generateQuotes = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/generateQuotes';
    return this.post(url);
  };
  this.generateBinder = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/generateBinder';
    return this.post(url);
  };
  this.requestBinding = function (quoteIds) {
    var url = '/rest/Proposal/requestBindingByQuotes?',
      config = {
        params: {
          quoteIds: quoteIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.requestBindingByProposalId = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/requestBinding';
    return this.post(url);
  };
  this.createProposal = function (submissionId, productTemplateIds) {
    var templateIds = '';
    angular.forEach(productTemplateIds, function (productTemplateId) {
      var str = templateIds !== '' ? '&' : '';
      templateIds += str + 'productTemplateId=' + productTemplateId;
    });
    var url = '/rest/Submission/' + submissionId + '/createProposal?' + templateIds;
    return this.post(url);
  };
  this.uploadSectionFromFile = function (proposalId, data, file) {
    var url = '/rest/Proposal/' + proposalId + '/uploadSectionFromFile',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        },
        params: {
          displayLabel: data.description,
          filename: data.name,
          length: data.fileExpectedSize
        }
      };
    formData.append('file', file);
    return this.post(url, formData, config);
  };
  this.declineToBind = function (proposalId, reason, detail) {
    var url = '/rest/Proposal/' + proposalId + '/declineToBind',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.declineToBindFromSent = function (quoteIds, reason, detail) {
    var url = '/rest/Proposal/declineToBind',
      config = {
        params: {
          quoteIds: quoteIds,
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
};
ProposalActionRepository.$inject = ["baseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('proposalActionRepository', ProposalActionRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 474 */
/***/ (function(module, exports) {

/*@ngInject*/
var ProposalActionsMediator = function ProposalActionsMediator(proposalActionRepository) {
  this.copyProposal = function (proposalId, quotesList) {
    return proposalActionRepository.copyProposal(proposalId, quotesList);
  };
  this.modifyProposal = function (quoteId) {
    return proposalActionRepository.modifyProposal(quoteId);
  };
  this.deleteProposal = function (proposalId) {
    return proposalActionRepository.deleteProposal(proposalId);
  };
  this.createProposal = function (submissionId, productId) {
    return proposalActionRepository.createProposal(submissionId, productId);
  };
  this.createQuote = function (submissionId, productId, productTemplateId) {
    return proposalActionRepository.createQuote(submissionId, productId, productTemplateId);
  };
  this.addSectionFromDocument = function (proposalId, attachmentId, displayLabel, sectionType) {
    return proposalActionRepository.addSectionFromDocument(proposalId, attachmentId, displayLabel, sectionType);
  };
  this.addSectionFromFile = function (proposalId, data, file) {
    return proposalActionRepository.uploadSectionFromFile(proposalId, data, file);
  };
  this.bindProposal = function (proposalId, quoteId) {
    return proposalActionRepository.bindProposal(proposalId, quoteId);
  };
  this.addSection = function (proposalId, sectionTemplateId, sectionType) {
    return proposalActionRepository.addSection(proposalId, sectionTemplateId, sectionType);
  };
  this.beginBinding = function (proposalId, quoteIds) {
    return proposalActionRepository.beginBinding(proposalId, quoteIds);
  };
  this.requestBinding = function (proposalId) {
    return proposalActionRepository.requestBindingByProposalId(proposalId);
  };
  this.requestToBindFromSent = function (quoteIds) {
    return proposalActionRepository.requestBinding(quoteIds);
  };
  this.bindProposalFromSent = function (proposalId, quoteIds) {
    return proposalActionRepository.bindProposal(proposalId, quoteIds);
  };
  this.deleteSection = function (sectionTemplateId, invalidateProposalDocument) {
    return proposalActionRepository.deleteSection(sectionTemplateId, invalidateProposalDocument);
  };
  this.generateQuotes = function (proposalId) {
    return proposalActionRepository.generateQuotes(proposalId);
  };
  this.generateBinder = function (proposalId) {
    return proposalActionRepository.generateBinder(proposalId);
  };
  this.declineToBind = function (proposalId, reason, detail) {
    return proposalActionRepository.declineToBind(proposalId, reason, detail);
  };
  this.declineToBindFromSent = function (quoteIds, reason, detail) {
    return proposalActionRepository.declineToBindFromSent(quoteIds, reason, detail);
  };
};
ProposalActionsMediator.$inject = ["proposalActionRepository"];
angular.module('gw-um-submission').service('proposalActionsMediator', ProposalActionsMediator);

/***/ }),
/* 475 */
/***/ (function(module, exports) {

/*@ngInject*/
var ProposalActionsRepository = function ProposalActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadProposalActions = function (proposalId) {
    var url = '/rest/Actions?uri=com.firstbest.underwriting.proposal.Proposal:' + proposalId + '&registrationIdentifier=/Proposal/' + proposalId,
      cacheKey = 'proposalActions:' + proposalId;
    if (currentSubmissionModel.hasActionsRegistration('/Proposal/' + proposalId)) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration('/Proposal/' + proposalId, url);
        return responseData;
      });
    }
  };
};
ProposalActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('proposalActionsRepository', ProposalActionsRepository);

/***/ }),
/* 476 */
/***/ (function(module, exports) {

/*@ngInject*/
var QuoteActionRepository = function QuoteActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getQuotesWithEnabledAction = function (quoteId, action) {
    var url = '/rest/Quote/' + quoteId + '/QuotesWithEnabledAction',
      config = {
        params: {
          transition: action
        }
      };
    return this.get(url, config);
  };
  this.addSection = function (quoteId, sectionTemplateId, type) {
    var url = '/rest/Quote/' + quoteId + '/addSection',
      config = {
        params: {
          sectionTemplateIds: sectionTemplateId,
          sectionType: type
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.beginBinding = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/BeginBinding';
    return this.post(url);
  };
  this.bind = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/bind';
    return this.post(url);
  };
  this.copyQuote = function (quoteId, proposalId) {
    var url = '/rest/Quote/' + quoteId + '/copy',
      config = {
        params: {
          proposalId: proposalId
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.declineToBind = function (quoteId, reason, details) {
    var url = '/rest/Quote/' + quoteId + '/Decline',
      config = {
        params: {
          reason: reason,
          detail: details
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.deleteQuote = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/Delete';
    return this.delete(url);
  };
  this.deleteSection = function (sectionId, invalidateProposalDocument) {
    var url = '/rest/ProposalSection/' + sectionId + '/deleteSection',
      config = {
        params: {
          invalidateProposalDocument: invalidateProposalDocument
        }
      };
    return this.delete(url, config);
  };
  this.generateBinder = function (quoteIds) {
    var url = '/rest/Proposal/generateBinder',
      config = {
        params: {
          quoteId: quoteIds
        }
      };
    return this.post(url, {}, config);
  };
  this.generateQuote = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/GenerateQuote';
    return this.post(url);
  };
  this.generateRatingAttachments = function (quoteId, attachmentsToGenerate) {
    var url = '/rest/Quote/' + quoteId + '/generateRatingAttachments',
      config = {
        params: {
          attachmentsToGenerate: attachmentsToGenerate
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.getQuote = function (quoteId) {
    var url = '/rest/Quote/' + quoteId;
    return this.get(url);
  };
  this.generateRating = function (quoteIds) {
    var url = '/rest/Quote/RateQuotes',
      config = {
        params: {
          quoteIds: quoteIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.modifyBinder = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/ModifyBinder';
    return this.post(url);
  };
  this.modifyPricing = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/ModifyPricing';
    return this.post(url);
  };
  this.modifyQuote = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/ModifyQuote';
    return this.post(url);
  };
  this.modifyRating = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/modifyRating';
    return this.post(url);
  };
  this.refreshQuoteByIds = function (quoteIds) {
    var url = '/rest/Quote/RefreshQuoteByIds',
      config = {
        params: {
          quoteIds: quoteIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.requestBinding = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/RequestBinding';
    return this.post(url);
  };
  this.startPricing = function (quoteIds) {
    var url = '/rest/Quote/PriceQuotes',
      config = {
        params: {
          quoteIds: quoteIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.startQuote = function (quoteIds) {
    var url = '/rest/Quote/StartQuotes',
      config = {
        params: {
          quoteIds: quoteIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.unbind = function (quoteId, reason, detail) {
    var url = '/rest/Quote/' + quoteId + '/unbind',
      config = {
        params: {
          reason: reason,
          detail: detail
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
  this.uploadSectionFromFile = function (proposalId, data, file) {
    var url = '/rest/Quote/' + proposalId + '/uploadSectionFromFile',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        },
        params: {
          displayLabel: data.description,
          filename: data.name,
          length: data.fileExpectedSize
        }
      };
    formData.append('file', file);
    return this.post(url, formData, config);
  };
  this.addSectionFromDocument = function (quoteId, attachmentId, displayLabel, sectionType) {
    var url = '/rest/Quote/' + quoteId + '/addSectionFromDocument',
      config = {
        params: {
          attachmentId: attachmentId,
          displayLabel: displayLabel
        }
      };
    if (sectionType) {
      config.params.sectionType = sectionType;
    }
    return this.post(url, {}, config);
  };
  this.revertToSent = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/revertToSent';
    return this.post(url);
  };
  this.withdrawQuote = function (quoteId, reason, detail) {
    var url = '/rest/Quote/' + quoteId + '/withdraw',
      config = {
        params: {
          reason: reason,
          detail: detail,
          notification: null
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, {}, config);
  };
  this.withdrawRequest = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/withdrawRequest';
    return this.post(url);
  };
};
QuoteActionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('quoteActionRepository', QuoteActionRepository);

/***/ }),
/* 477 */
/***/ (function(module, exports) {

/*@ngInject*/
var QuoteActionsMediator = function QuoteActionsMediator($rootScope, submissionConstant, quoteActionRepository) {
  this.getQuotesWithEnabledAction = function (quoteId, action) {
    return quoteActionRepository.getQuotesWithEnabledAction(quoteId, action);
  };
  this.declineToBind = function (quoteId, primaryReason, comments) {
    return quoteActionRepository.declineToBind(quoteId, primaryReason, comments);
  };
  this.deleteQuote = function (quoteId) {
    return quoteActionRepository.deleteQuote(quoteId);
  };
  this.copyQuote = function (quoteId, proposalId) {
    return quoteActionRepository.copyQuote(quoteId, proposalId);
  };
  this.generateQuote = function (quoteId) {
    return quoteActionRepository.generateQuote(quoteId);
  };
  this.modifyQuote = function (quoteId) {
    return quoteActionRepository.modifyQuote(quoteId);
  };
  this.startQuote = function (quoteId) {
    return quoteActionRepository.startQuote(quoteId);
  };
  this.generateRating = function (quoteIds) {
    return quoteActionRepository.generateRating(quoteIds);
  };
  this.startPricing = function (quoteIds) {
    return quoteActionRepository.startPricing(quoteIds);
  };
  this.modifyPricing = function (quoteId) {
    return quoteActionRepository.modifyPricing(quoteId);
  };
  this.modifyRating = function (quoteId) {
    return quoteActionRepository.modifyRating(quoteId);
  };
  this.beginBinding = function (quoteId) {
    return quoteActionRepository.beginBinding(quoteId);
  };
  this.requestBinding = function (quoteId) {
    return quoteActionRepository.requestBinding(quoteId);
  };
  this.bindQuote = function (proposalId) {
    return quoteActionRepository.bind(proposalId);
  };
  this.generateBinder = function (quoteIds) {
    return quoteActionRepository.generateBinder(quoteIds);
  };
  this.addSectionFromDocument = function (quoteId, attachmentId, displayLabel, sectionType) {
    return quoteActionRepository.addSectionFromDocument(quoteId, attachmentId, displayLabel, sectionType);
  };
  this.addSectionFromFile = function (quoteId, data, file) {
    return quoteActionRepository.uploadSectionFromFile(quoteId, data, file);
  };
  this.unbind = function (quoteId, reason, detail) {
    return quoteActionRepository.unbind(quoteId, reason, detail);
  };
  this.refreshQuoteByIds = function (quoteIds) {
    return quoteActionRepository.refreshQuoteByIds(quoteIds);
  };
  this.modifyBinder = function (quoteId) {
    return quoteActionRepository.modifyBinder(quoteId);
  };
  this.addSection = function (quoteId, sectionTemplateId, sectionType) {
    return quoteActionRepository.addSection(quoteId, sectionTemplateId, sectionType);
  };
  this.deleteSection = function (sectionTemplateId, invalidateProposalDocument) {
    return quoteActionRepository.deleteSection(sectionTemplateId, invalidateProposalDocument);
  };
  this.generateRatingAttachments = function (quoteId, attachmentsToGenerate) {
    return quoteActionRepository.generateRatingAttachments(quoteId, attachmentsToGenerate);
  };
  this.revertToSent = function (quoteId) {
    return quoteActionRepository.revertToSent(quoteId);
  };
  this.withdrawQuote = function (quoteId, reason, detail) {
    return quoteActionRepository.withdrawQuote(quoteId, reason, detail);
  };
  this.withdrawRequest = function (quoteId) {
    return quoteActionRepository.withdrawRequest(quoteId);
  };
};
QuoteActionsMediator.$inject = ["$rootScope", "submissionConstant", "quoteActionRepository"];
angular.module('gw-um-submission').service('quoteActionsMediator', QuoteActionsMediator);

/***/ }),
/* 478 */
/***/ (function(module, exports) {

/*@ngInject*/
var QuoteActionsRepository = function QuoteActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadQuoteActions = function (quoteId) {
    var url = '/rest/Actions?uri=com.firstbest.underwriting.quote.Quote:' + quoteId + '&registrationIdentifier=/Quote/' + quoteId,
      cacheKey = 'quoteActions:' + quoteId;
    if (currentSubmissionModel.hasActionsRegistration('/Quote/' + quoteId)) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration('/Quote/' + quoteId, url);
        return responseData;
      });
    }
  };
};
QuoteActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('quoteActionsRepository', QuoteActionsRepository);

/***/ }),
/* 479 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReportActionRepository = function ReportActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createReport = function (submissionId, reportName) {
    var url = "/rest/ExternalReport/".concat(submissionId, "/create?reportName=").concat(encodeURIComponent(reportName));
    return this.post(url);
  };
  this.deleteReport = function (reportId) {
    var url = "/rest/ExternalReport/".concat(reportId, "/delete");
    return this.delete(url);
  };
  this.editReport = function (reportId) {
    var url = "/rest/ExternalReport/".concat(reportId, "/edit");
    return this.post(url);
  };
  this.generateReport = function (reportId) {
    var url = "/rest/ExternalReport/".concat(reportId, "/generate");
    return this.post(url);
  };
};
ReportActionRepository.$inject = ["baseRepository"];
angular.module('gw-um-submission').service('reportActionRepository', ReportActionRepository);

/***/ }),
/* 480 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReportActionsRepository = function ReportActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadReportActions = function (reportId) {
    var url = '/rest/Actions?uri=com.firstbest.underwriting.externaldata.ExternalReport:' + reportId + '&registrationIdentifier=/ExternalReport/' + reportId,
      cacheKey = 'reportActions:' + reportId;
    if (currentSubmissionModel.hasActionsRegistration('/ExternalReport/' + reportId)) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration('/ExternalReport/' + reportId, url);
        return responseData;
      });
    }
  };
};
ReportActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('reportActionsRepository', ReportActionsRepository);

/***/ }),
/* 481 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReportActionsMediator = function ReportActionsMediator(reportActionRepository) {
  this.generateReport = function (reportId) {
    return reportActionRepository.generateReport(reportId);
  };
  this.createReport = function (submissionId, reportName) {
    return reportActionRepository.createReport(submissionId, reportName);
  };
  this.editReport = function (reportId) {
    return reportActionRepository.editReport(reportId);
  };
  this.deleteReport = function (reportId) {
    return reportActionRepository.deleteReport(reportId);
  };
};
ReportActionsMediator.$inject = ["reportActionRepository"];
angular.module('gw-um-submission').service('reportActionsMediator', ReportActionsMediator);

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SubmissionActionsRepository = function SubmissionActionsRepository($q, baseSharedPromiseRepository, currentSubmissionModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadSubmissionActions = function (submissionId) {
    var url = '/rest/Actions?uri=com.firstbest.underwriting.submission.Submission:' + submissionId + '&registrationIdentifier=/Submission/' + submissionId,
      cacheKey = 'submissionActions:' + submissionId;
    if (currentSubmissionModel.hasActionsRegistration('/Submission/' + submissionId)) {
      return $q.resolve(null);
    } else {
      return this.get(cacheKey, url).then(function (responseData) {
        currentSubmissionModel.addActionsRegistration('/Submission/' + submissionId, url);
        _.each(responseData.actions, function (action) {
          action.name = _.replace(action.name, 'Create Report: ', '');
        });
        return responseData;
      });
    }
  };
};
SubmissionActionsRepository.$inject = ["$q", "baseSharedPromiseRepository", "currentSubmissionModel"];
angular.module('gw-um-submission').service('submissionActionsRepository', SubmissionActionsRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 483 */
/***/ (function(module, exports) {

/*@ngInject*/
var SubmissionPrequalificationMediator = function SubmissionPrequalificationMediator(prequalificationRepository) {
  this.startPrequalification = function (submissionId) {
    return prequalificationRepository.startPrequalification(submissionId);
  };
  this.cancelPrequalification = function (submissionId) {
    return prequalificationRepository.cancelPrequalification(submissionId);
  };
  this.submitPrequalification = function (submissionId) {
    return prequalificationRepository.submitPrequalification(submissionId);
  };
  this.checkPrequalification = function (submissionId) {
    return prequalificationRepository.checkPrequalification(submissionId);
  };
};
SubmissionPrequalificationMediator.$inject = ["prequalificationRepository"];
angular.module('gw-um-submission').service('submissionPrequalificationMediator', SubmissionPrequalificationMediator);

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var approveEndorsementLocale = __webpack_require__(91);
var reviewEndorsementLocale = __webpack_require__(485);
var EndorsementActionUtil = function EndorsementActionUtil($rootScope, appTypeConfigurationModel, coreConstant, submissionConstant, uiPerformanceLoggerConstant, loadingBarHandler, modalUtil, umModalUtil, endorsementActionsMediator, coreMediator, $uibModal) {
  this.i18n = {
    approveEndorsement: approveEndorsementLocale,
    reviewEndorsement: reviewEndorsementLocale
  };
  this.reviewChanges = function (endorsementId) {
    var _this = this;
    endorsementActionsMediator.getEndorsementSummary(endorsementId).then(function (endorsementSummary) {
      $uibModal.open({
        templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
        controller: 'reviewChangesModalController',
        backdrop: 'static',
        windowClass: 'reviewChangesModal',
        resolve: {
          options: function options() {
            return {
              title: _.get(_this.i18n, 'reviewEndorsement.reviewChangesTitle'),
              isReadOnly: false,
              continueButtonLabel: _.get(_this.i18n, 'reviewEndorsement.reviewClose'),
              changeSetId: endorsementSummary.changeSetId,
              showCancel: false,
              entityId: endorsementId
            };
          }
        }
      });
    });
  };
  this.createEndorsement = function (endorsementId) {
    var promise;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_ENDORSEMENT, "Endorsement: ".concat(endorsementId));
    loadingBarHandler.showLoadingBar('submission.endorsement.creatingEndorsementLoadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var onSuccess = function onSuccess() {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_ENDORSEMENT, coreConstant.uiPeformanceLogger.SUCCESS);
    };
    var onFailure = function onFailure() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_ENDORSEMENT, coreConstant.uiPeformanceLogger.FAIL);
    };
    promise = endorsementActionsMediator.create(endorsementId).then(onSuccess, onFailure);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.deleteEndorsement = function (endorsementId, submissionId) {
    function handleClose() {
      var promise = endorsementActionsMediator.delete(endorsementId).finally(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.deleteEndorsement', uiPerformanceLoggerConstant.DELETE_ENDORSEMENT, /*hideLoadingBar*/false, handleClose);
  };
  this.submitEndorsement = function (endorsementId) {
    var _this2 = this;
    endorsementActionsMediator.getEndorsementSummary(endorsementId).then(function (endorsementSummary) {
      if (!_.isNil(endorsementSummary.changeSetId)) {
        var modalInstance = $uibModal.open({
          templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
          controller: 'reviewChangesModalController',
          backdrop: 'static',
          windowClass: 'reviewChangesModal',
          resolve: {
            options: function options() {
              return {
                title: _.get(_this2.i18n, 'reviewEndorsement.reviewSubmitTitle'),
                isReadOnly: false,
                continueButtonLabel: _.get(_this2.i18n, 'reviewEndorsement.submitChanges'),
                changeSetId: endorsementSummary.changeSetId,
                showCancel: true,
                entityId: endorsementId,
                showMessage: appTypeConfigurationModel.isUnderwriterWorkstation()
              };
            }
          }
        });
        modalInstance.result.then(function () {
          loadingBarHandler.showLoadingBar('submission.endorsement.submittingEndorsementLoadingBar');
          var promise = endorsementActionsMediator.submit(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
          return promise;
        });
      } else {
        loadingBarHandler.showLoadingBar(_.get(_this2.i18n, 'reviewEndorsement.loadingBar'));
        var promise = endorsementActionsMediator.submit(endorsementId).finally(function () {
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      }
    });
  };
  this.startRating = function (endorsementId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.endorsement.startRating');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = endorsementActionsMediator.startRating(endorsementId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.refreshQuote = function (endorsementId) {
    loadingBarHandler.showLoadingBar('submission.endorsement.refreshQuote');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = endorsementActionsMediator.refreshQuote(endorsementId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.generateRating = function (endorsementId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.ratingEngineProcessing');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = endorsementActionsMediator.generateRating(endorsementId).finally(function (response) {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.generateRatingAttachments = function (endorsementId, submissionId) {
    var dynamicDataSetParams = {
      name: 'Rating Attachment Groups',
      submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
      ownerUri: 'com.firstbest.underwriting.policy.endorsement.Endorsement:' + endorsementId
    };
    function onSuccess(response) {
      var ratingAttachmentGroups = {};

      // Format the response into a mapping of the separate attachment groups, for easier processing in the modal.
      _.each(response, function (dataItem) {
        if (!ratingAttachmentGroups[dataItem.grouping]) {
          ratingAttachmentGroups[dataItem.grouping] = {
            name: dataItem.grouping,
            ratingAttachments: []
          };
        }
        ratingAttachmentGroups[dataItem.grouping].ratingAttachments.push(dataItem);
      });
      $uibModal.open({
        templateUrl: '/wizard/generateRatingAttachments/generateRatingAttachmentsModal.tpl.html',
        controller: 'generateRatingAttachmentsModalController',
        windowClass: 'generateRatingAttachmentsModalContainer',
        backdrop: 'static',
        resolve: {
          options: function options() {
            return {
              ratingAttachmentGroups: ratingAttachmentGroups
            };
          }
        }
      }).result.then(function (options) {
        var action = uiPerformanceLoggerConstant.GENERATE_RATING_ATTACHMENTS,
          message = endorsementId.toString(),
          promise;
        function onSuccess() {
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }
        function onFinally() {
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          loadingBarHandler.hideLoadingBar();
        }
        loadingBarHandler.showLoadingBar('submission.wizard.generateRatingAttachments.loadingBar');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = endorsementActionsMediator.generateRatingAttachments(endorsementId, options.selectedRatingAttachments).then(onSuccess, onError).finally(onFinally);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
    }
    coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(onSuccess);
  };
  this.startPricing = function (endorsementId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.startPricing');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = endorsementActionsMediator.startPricing(endorsementId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.modifyPricing = function (endorsementId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.modifyPricing');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = endorsementActionsMediator.modifyPricing(endorsementId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.modifyRating = function (endorsementId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.modifyingRating');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = endorsementActionsMediator.modifyRating(endorsementId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.submitEndorsementForIssuance = function (endorsementId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.endorsement.submittingEndorsementForIssuanceLoadingBar');
    promise = endorsementActionsMediator.submitForIssuance(endorsementId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.markEndorsementAsIssued = function (endorsementId, submissionId) {
    function handleClose() {
      var promise = endorsementActionsMediator.markIssued(endorsementId).finally(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.markEndorsementAsIssued', uiPerformanceLoggerConstant.MARK_ENDORSEMENT_AS_ISSUED, /*hideLoadingBar*/false, handleClose);
  };
  this.revertEndorsementToSubmitted = function (endorsementId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.endorsement.revertingEndorsementToSubmittedLoadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = endorsementActionsMediator.revertToSubmitted(endorsementId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.revertToPendingIssuance = function (endorsementId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.endorsement.revertingEndorsementToPendingIssuanceLoadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = endorsementActionsMediator.revertToPendingIssuance(endorsementId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.declineEndorsement = function (endorsementId, submissionId) {
    function handleClose(result) {
      var promise = endorsementActionsMediator.decline(endorsementId, result.reason, result.details).finally(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null, null /*reason*/, 'submission.wizard.reasonModal.declineEndorsementModal', false /*isReasonOptional*/, uiPerformanceLoggerConstant.DECLINE_ENDORSEMENT, handleClose);
  };
  this.approveEndorsement = function (endorsementId, submissionId) {
    var _this3 = this;
    var modalInstance = $uibModal.open({
      templateUrl: '/wizard/actions/approveEndorsement/approveEndorsementModal.tpl.html',
      controller: 'approveEndorsementModalController',
      windowClass: 'approveEndorsementModal',
      resolve: {},
      keyboard: false,
      backdrop: 'static'
    });
    modalInstance.result.then(function (options) {
      var promise;
      loadingBarHandler.showLoadingBar(_this3.i18n.approveEndorsement.loading);
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.APPROVE_ENDORSEMENT, submissionId);
      promise = endorsementActionsMediator.approve(endorsementId, options.processingInstructions).finally(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    });
  };
};
EndorsementActionUtil.$inject = ["$rootScope", "appTypeConfigurationModel", "coreConstant", "submissionConstant", "uiPerformanceLoggerConstant", "loadingBarHandler", "modalUtil", "umModalUtil", "endorsementActionsMediator", "coreMediator", "$uibModal"];
angular.module('gw-um-submission').service('endorsementActionUtil', EndorsementActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 485 */
/***/ (function(module) {

module.exports = JSON.parse("{\"reviewChangesTitle\":\"Application Changes\",\"reviewSubmitTitle\":\"Submit Endorsement\",\"submitChanges\":\"Submit Endorsement\",\"reviewCancel\":\"Cancel\",\"reviewClose\":\"Close\",\"loadingBar\":\"Submitting Endorsement...\"}");

/***/ }),
/* 486 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyActionUtil = function PolicyActionUtil($rootScope, coreConstant, submissionConstant, uiPerformanceLoggerConstant, loadingBarHandler, policyActionsMediator, umModalUtil) {
  this.cancel = function (policyId) {
    var action = uiPerformanceLoggerConstant.START_POLICY_CANCELLATION,
      message = policyId.toString(),
      promise;
    function onSuccess() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
    }
    loadingBarHandler.showLoadingBar('submission.policy.cancel');
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = policyActionsMediator.startPolicyCancellation(policyId).then(onSuccess, onError).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.reinstatePolicy = function (submissionId, policyId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'Reinstatement Reasons', 'submission.reinstateModal', false, uiPerformanceLoggerConstant.REINSTATE_POLICY, handleClose);
    function handleClose(result) {
      var promise = policyActionsMediator.reinstatePolicy(policyId, result.reason, result.details).finally(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.startEndorsement = function (policyId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.endorsement.creatingEndorsementLoadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = policyActionsMediator.startEndorsement(policyId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.startPolicyRewrite = function (policyId) {
    loadingBarHandler.showLoadingBar('submission.policyRewrite.creatingPolicyRewriteLoadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyActionsMediator.startPolicyRewrite(policyId, false /* isReissue */).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.startPolicyReissue = function (policyId) {
    loadingBarHandler.showLoadingBar('submission.policyReissue.creatingPolicyRewriteLoadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyActionsMediator.startPolicyRewrite(policyId, true /* isReissue */).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
};
PolicyActionUtil.$inject = ["$rootScope", "coreConstant", "submissionConstant", "uiPerformanceLoggerConstant", "loadingBarHandler", "policyActionsMediator", "umModalUtil"];
angular.module('gw-um-submission').service('policyActionUtil', PolicyActionUtil);

/***/ }),
/* 487 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyCancellationActionUtil = function PolicyCancellationActionUtil($rootScope, coreConstant, submissionConstant, uiPerformanceLoggerConstant, loadingBarHandler, modalUtil, umModalUtil, policyCancellationActionsMediator) {
  this.deleteDraftCancellation = function (submissionId, policyCancellationId) {
    function handleClose() {
      var promise = policyCancellationActionsMediator.deleteDraftCancellation(policyCancellationId).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.deleteDraftCancellation', uiPerformanceLoggerConstant.DELETE_DRAFT_CANCELLATION, /*hideLoadingBar*/false, handleClose);
  };
  this.submitForCancellation = function (policyCancellationId) {
    var action = uiPerformanceLoggerConstant.SUBMIT_FOR_CANCELLATION,
      message = policyCancellationId.toString(),
      promise;
    function onSuccess() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
    }
    loadingBarHandler.showLoadingBar('submission.policy.submitForCancellation');
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = policyCancellationActionsMediator.submitForCancellation(policyCancellationId).then(onSuccess, onError).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.markAsCancelled = function (policyCancellationId) {
    var action = uiPerformanceLoggerConstant.MARK_AS_CANCELLED,
      message = policyCancellationId.toString(),
      promise;
    function onSuccess() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
    }
    loadingBarHandler.showLoadingBar('submission.policy.markAsCancelled');
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = policyCancellationActionsMediator.markAsCancelled(policyCancellationId).then(onSuccess, onError).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.revertToCancellationPending = function (submissionId, policyCancellationId) {
    function handleClose(result) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = policyCancellationActionsMediator.revertToCancellationPending(policyCancellationId, result.reason, result.details).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.revertToCancellationPendingModal', false /*isReasonOptional*/, uiPerformanceLoggerConstant.REVERT_TO_CANCELLATION_PENDING, handleClose);
  };
  this.rescindCancellation = function (submissionId, policyCancellationId) {
    function handleClose(result) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = policyCancellationActionsMediator.rescindCancellation(policyCancellationId, result.reason, result.details).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.rescindCancellationModal', false /*isReasonOptional*/, uiPerformanceLoggerConstant.RESCIND_CANCELLATION, handleClose);
  };
  this.requestCancellation = function (policyCancellationId) {
    var action = uiPerformanceLoggerConstant.REQUEST_CANCELLATION,
      message = policyCancellationId.toString(),
      promise;
    function onSuccess() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
    }
    loadingBarHandler.showLoadingBar('submission.policy.requestCancellation');
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = policyCancellationActionsMediator.requestCancellation(policyCancellationId).then(onSuccess, onError).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.retractCancellationRequest = function (submissionId, policyCancellationId) {
    function handleClose(result) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = policyCancellationActionsMediator.retractCancellationRequest(policyCancellationId, result.reason, result.details).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null, null /*reason*/, 'submission.wizard.reasonModal.retractCancellationRequestModal', false /*isReasonOptional*/, uiPerformanceLoggerConstant.RETRACT_CANCELLATION_REQUEST, handleClose);
  };
};
PolicyCancellationActionUtil.$inject = ["$rootScope", "coreConstant", "submissionConstant", "uiPerformanceLoggerConstant", "loadingBarHandler", "modalUtil", "umModalUtil", "policyCancellationActionsMediator"];
angular.module('gw-um-submission').service('policyCancellationActionUtil', PolicyCancellationActionUtil);

/***/ }),
/* 488 */
/***/ (function(module, exports) {

/*@ngInject*/
var PolicyIssuanceActionUtil = function PolicyIssuanceActionUtil($rootScope, coreConstant, submissionConstant, modalUtil, umModalUtil, uiPerformanceLoggerConstant, loadingBarHandler, policyIssuanceActionsMediator) {
  this.beginIssuance = function (policyIssuanceId) {
    var action = uiPerformanceLoggerConstant.BEGIN_ISSUANCE,
      message = policyIssuanceId.toString(),
      promise;
    function onSuccess() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
    }
    loadingBarHandler.showLoadingBar('submission.policyIssuance.beginIssuance');
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = policyIssuanceActionsMediator.beginIssuance(policyIssuanceId).then(onSuccess, onError).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.revertToBound = function (submissionId, policyIssuanceId) {
    function handleClose(result) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = policyIssuanceActionsMediator.revertToBound(policyIssuanceId, result.reason, result.details).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.revertToBoundModal', false /*isReasonOptional*/, uiPerformanceLoggerConstant.REVERT_TO_BOUND, handleClose);
  };
  this.submitForIssuance = function (submissionId, policyIssuanceId) {
    function handleClose() {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = policyIssuanceActionsMediator.submitForIssuance(policyIssuanceId).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, 'notification.submitForIssuance', 'submission.wizard.submitForIssuanceModal', uiPerformanceLoggerConstant.SUBMIT_FOR_ISSUANCE, /*hideLoadingBar*/false, handleClose);
  };
  this.modifyIssuance = function (policyIssuanceId) {
    var action = uiPerformanceLoggerConstant.MODIFY_ISSUANCE,
      message = policyIssuanceId.toString(),
      promise;
    function onSuccess() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
    }
    loadingBarHandler.showLoadingBar('submission.policyIssuance.modifyIssuance');
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = policyIssuanceActionsMediator.modifyIssuance(policyIssuanceId).then(onSuccess, onError).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.markAsIssued = function (submissionId, policyIssuanceId) {
    function handleClose() {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = policyIssuanceActionsMediator.markAsIssued(policyIssuanceId).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, 'notification.markAsIssued', 'submission.wizard.markAsIssuedModal', uiPerformanceLoggerConstant.MARK_AS_ISSUED, /*hideLoadingBar*/false, handleClose);
  };
  this.revertToPendingIssuance = function (submissionId, policyIssuanceId) {
    function handleClose(result) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = policyIssuanceActionsMediator.revertToPendingIssuance(policyIssuanceId, result.reason, result.details).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.revertToPendingIssuanceModal', false /*isReasonOptional*/, uiPerformanceLoggerConstant.REVERT_TO_PENDING_ISSUANCE, handleClose);
  };
};
PolicyIssuanceActionUtil.$inject = ["$rootScope", "coreConstant", "submissionConstant", "modalUtil", "umModalUtil", "uiPerformanceLoggerConstant", "loadingBarHandler", "policyIssuanceActionsMediator"];
angular.module('gw-um-submission').service('policyIssuanceActionUtil', PolicyIssuanceActionUtil);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var reviewPolicyRewriteLocale = __webpack_require__(490);
var PolicyRewriteActionUtil = function PolicyRewriteActionUtil($rootScope, $uibModal, appTypeConfigurationModel, coreConstant, submissionConstant, uiPerformanceLoggerConstant, loadingBarHandler, modalUtil, umModalUtil, policyRewriteActionsMediator, coreMediator) {
  this.i18n = {
    reviewPolicyRewrite: reviewPolicyRewriteLocale
  };
  this.reviewChanges = function (policyRewriteId, isReissue) {
    var _this = this;
    var context = isReissue ? 'policyReissue' : 'policyRewrite';
    policyRewriteActionsMediator.getPolicyRewriteSummary(policyRewriteId).then(function (policyRewriteSummary) {
      $uibModal.open({
        templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
        controller: 'reviewChangesModalController',
        backdrop: 'static',
        windowClass: 'reviewChangesModal',
        resolve: {
          options: function options() {
            return {
              title: _.get(_this.i18n, "reviewPolicyRewrite.".concat(context, ".reviewChangesTitle")),
              isReadOnly: false,
              continueButtonLabel: _.get(_this.i18n, "reviewPolicyRewrite.".concat(context, ".reviewClose")),
              changeSetId: policyRewriteSummary.changeSetId,
              showCancel: false,
              entityId: policyRewriteId
            };
          }
        }
      });
    });
  };
  this.createPolicyRewrite = function (policyRewriteId, isReissue) {
    var context = isReissue ? 'policyReissue' : 'policyRewrite';
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_POLICY_REWRITE, "PolicyRewrite: ".concat(policyRewriteId));
    loadingBarHandler.showLoadingBar("submission.".concat(context, ".creatingPolicyRewriteLoadingBar"));
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var onSuccess = function onSuccess() {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_POLICY_REWRITE, coreConstant.uiPeformanceLogger.SUCCESS);
    };
    var onFailure = function onFailure() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_POLICY_REWRITE, coreConstant.uiPeformanceLogger.FAIL);
    };
    var promise = policyRewriteActionsMediator.create(policyRewriteId).then(onSuccess, onFailure);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.deletePolicyRewrite = function (policyRewriteId, submissionId, isReissue) {
    var context = isReissue ? 'PolicyReissue' : 'PolicyRewrite';
    function handleClose() {
      var promise = policyRewriteActionsMediator.delete(policyRewriteId).finally(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, "submission.wizard.delete".concat(context), uiPerformanceLoggerConstant.DELETE_POLICY_REWRITE, /*hideLoadingBar*/false, handleClose);
  };
  this.submitPolicyRewrite = function (policyRewriteId, isReissue) {
    var _this2 = this;
    var context = isReissue ? 'policyReissue' : 'policyRewrite';
    policyRewriteActionsMediator.getPolicyRewriteSummary(policyRewriteId).then(function (policyRewriteSummary) {
      if (!_.isNil(policyRewriteSummary.changeSetId)) {
        var modalInstance = $uibModal.open({
          templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
          controller: 'reviewChangesModalController',
          backdrop: 'static',
          windowClass: 'reviewChangesModal',
          resolve: {
            options: function options() {
              return {
                title: _.get(_this2.i18n, "reviewPolicyRewrite.".concat(context, ".reviewSubmitTitle")),
                isReadOnly: false,
                continueButtonLabel: _.get(_this2.i18n, "reviewPolicyRewrite.".concat(context, ".submitChanges")),
                changeSetId: policyRewriteSummary.changeSetId,
                showCancel: true,
                entityId: policyRewriteId,
                showMessage: appTypeConfigurationModel.isUnderwriterWorkstation()
              };
            }
          }
        });
        modalInstance.result.then(function () {
          loadingBarHandler.showLoadingBar("submission.".concat(context, ".submittingPolicyRewriteLoadingBar"));
          var promise = policyRewriteActionsMediator.submit(policyRewriteId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
          return promise;
        });
      } else {
        loadingBarHandler.showLoadingBar(_.get(_this2.i18n, "reviewPolicyRewrite.".concat(context, ".loadingBar")));
        var promise = policyRewriteActionsMediator.submit(policyRewriteId).finally(function () {
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      }
    });
  };
  this.startRating = function (policyRewriteId, isReissue) {
    var context = isReissue ? 'policyReissue' : 'policyRewrite';
    loadingBarHandler.showLoadingBar("submission.".concat(context, ".startRating"));
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyRewriteActionsMediator.startRating(policyRewriteId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.refreshQuote = function (policyRewriteId, isReissue) {
    var context = isReissue ? 'policyReissue' : 'policyRewrite';
    loadingBarHandler.showLoadingBar("submission.".concat(context, ".refreshQuote"));
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyRewriteActionsMediator.refreshQuote(policyRewriteId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.generateRating = function (policyRewriteId) {
    loadingBarHandler.showLoadingBar('submission.ratingEngineProcessing');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyRewriteActionsMediator.generateRating(policyRewriteId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.generateRatingAttachments = function (policyRewriteId, submissionId) {
    var dynamicDataSetParams = {
      name: 'Rating Attachment Groups',
      submissionUri: "com.firstbest.underwriting.submission.Submission:".concat(submissionId),
      ownerUri: "com.firstbest.underwriting.policy.rewrite.PolicyRewrite:".concat(policyRewriteId)
    };
    function onSuccess(response) {
      var ratingAttachmentGroups = {};

      // Format the response into a mapping of the separate attachment groups, for easier processing in the modal.
      _.each(response, function (dataItem) {
        if (!ratingAttachmentGroups[dataItem.grouping]) {
          ratingAttachmentGroups[dataItem.grouping] = {
            name: dataItem.grouping,
            ratingAttachments: []
          };
        }
        ratingAttachmentGroups[dataItem.grouping].ratingAttachments.push(dataItem);
      });
      $uibModal.open({
        templateUrl: '/wizard/generateRatingAttachments/generateRatingAttachmentsModal.tpl.html',
        controller: 'generateRatingAttachmentsModalController',
        windowClass: 'generateRatingAttachmentsModalContainer',
        backdrop: 'static',
        resolve: {
          options: function options() {
            return {
              ratingAttachmentGroups: ratingAttachmentGroups
            };
          }
        }
      }).result.then(function (options) {
        var action = uiPerformanceLoggerConstant.GENERATE_RATING_ATTACHMENTS,
          message = policyRewriteId.toString();
        function onSuccess() {
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }
        function onFinally() {
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          loadingBarHandler.hideLoadingBar();
        }
        loadingBarHandler.showLoadingBar('submission.wizard.generateRatingAttachments.loadingBar');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        var promise = policyRewriteActionsMediator.generateRatingAttachments(policyRewriteId, options.selectedRatingAttachments).then(onSuccess, onError).finally(onFinally);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
    }
    coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(onSuccess);
  };
  this.startPricing = function (policyRewriteId) {
    loadingBarHandler.showLoadingBar('submission.startPricing');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyRewriteActionsMediator.startPricing(policyRewriteId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.modifyPricing = function (policyRewriteId) {
    loadingBarHandler.showLoadingBar('submission.modifyPricing');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyRewriteActionsMediator.modifyPricing(policyRewriteId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.modifyRating = function (policyRewriteId) {
    loadingBarHandler.showLoadingBar('submission.modifyingRating');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyRewriteActionsMediator.modifyRating(policyRewriteId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.submitPolicyRewriteForIssuance = function (policyRewriteId, isReissue) {
    var context = isReissue ? 'policyReissue' : 'policyRewrite';
    loadingBarHandler.showLoadingBar("submission.".concat(context, ".submittingPolicyRewriteForIssuanceLoadingBar"));
    var promise = policyRewriteActionsMediator.submitForIssuance(policyRewriteId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.markPolicyRewriteAsIssued = function (policyRewriteId, submissionId, isReissue) {
    var context = isReissue ? 'PolicyReissue' : 'PolicyRewrite';
    function handleClose() {
      var promise = policyRewriteActionsMediator.markIssued(policyRewriteId).finally(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, "submission.wizard.mark".concat(context, "AsIssued"), uiPerformanceLoggerConstant.MARK_POLICY_REWRITE_AS_ISSUED, /*hideLoadingBar*/false, handleClose);
  };
  this.revertPolicyRewriteToSubmitted = function (policyRewriteId, isReissue) {
    var context = isReissue ? 'policyReissue' : 'policyRewrite';
    loadingBarHandler.showLoadingBar("submission.".concat(context, ".revertingPolicyRewriteToSubmittedLoadingBar"));
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = policyRewriteActionsMediator.revertToSubmitted(policyRewriteId).finally(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
};
PolicyRewriteActionUtil.$inject = ["$rootScope", "$uibModal", "appTypeConfigurationModel", "coreConstant", "submissionConstant", "uiPerformanceLoggerConstant", "loadingBarHandler", "modalUtil", "umModalUtil", "policyRewriteActionsMediator", "coreMediator"];
angular.module('gw-um-submission').service('policyRewriteActionUtil', PolicyRewriteActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 490 */
/***/ (function(module) {

module.exports = JSON.parse("{\"policyReissue\":{\"reviewChangesTitle\":\"Application Changes\",\"reviewSubmitTitle\":\"Submit Policy Reissue\",\"submitChanges\":\"Submit Policy Reissue\",\"reviewCancel\":\"Cancel\",\"reviewClose\":\"Close\",\"loadingBar\":\"Submitting Policy Reissue...\"},\"policyRewrite\":{\"reviewChangesTitle\":\"Application Changes\",\"reviewSubmitTitle\":\"Submit Policy Rewrite\",\"submitChanges\":\"Submit Policy Rewrite\",\"reviewCancel\":\"Cancel\",\"reviewClose\":\"Close\",\"loadingBar\":\"Submitting Policy Rewrite...\"}}");

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var copyProposalLocale = __webpack_require__(92);

/*@ngInject*/
var ProposalActionUtil = function ProposalActionUtil($rootScope, $uibModal, modalUtil, loadingBarHandler, submissionConstant, actionsMediator, proposalActionsMediator, coreConstant, uiPerformanceLoggerConstant, proposalMediator, sectionType, attachmentUtil, collaborationMediator, coreMediator, umModalUtil) {
  this.i18n = {
    copyProposal: copyProposalLocale
  };
  this.copyProposal = function (_submissionId, _proposalId) {
    var _this = this;
    function onSuccess() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.COPY_PROPOSAL, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.COPY_PROPOSAL, coreConstant.uiPeformanceLogger.FAIL);
    }
    var modalInstance = $uibModal.open({
      templateUrl: '/wizard/actions/copyProposal/copyProposalModal.tpl.html',
      controller: 'copyProposalModalController',
      windowClass: 'copyProposalModal',
      resolve: {
        submissionId: function submissionId() {
          return _submissionId;
        },
        proposalId: function proposalId() {
          return _proposalId;
        }
      },
      keyboard: false,
      backdrop: 'static'
    });
    modalInstance.result.then(function (options) {
      var promise;
      loadingBarHandler.showLoadingBar(_this.i18n.copyProposal.loading);
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.COPY_PROPOSAL, "proposalId=".concat(_proposalId, ",quotes=").concat(options.quotes));
      promise = proposalActionsMediator.copyProposal(_proposalId, options.quotes).then(onSuccess, onError).finally(function () {
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    });
  };
  this.modifyProposal = function (proposalId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.modifyingProposal');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = proposalActionsMediator.modifyProposal(proposalId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.deleteProposal = function (submissionId, proposalId) {
    modalUtil.showConfirmationModal(submissionId, null, null /*notificationName*/, 'submission.wizard.deleteProposal', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = proposalActionsMediator.deleteProposal(proposalId).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.beginBinding = function (submissionId, proposalId) {
    modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.beginBinding', null /*notificationName*/, uiPerformanceLoggerConstant.BEGIN_BINDING, handleClose);
    function handleClose(proposalId, quoteIds) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = proposalActionsMediator.beginBinding(proposalId, quoteIds);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.declineToBindFromSent = function (submissionId, proposalId) {
    modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.declineToBindFromSent', /*notificationName*/null, uiPerformanceLoggerConstant.DECLINE_TO_BIND, handleClose);
    function handleClose(proposalId, quoteIds) {
      loadingBarHandler.hideLoadingBar();
      umModalUtil.showReasonModal(submissionId, /*quoteId*/null, /*notificationName*/null, /*reasonObject*/null, 'submission.wizard.reasonModal.declineToBindModal', /*isReasonOptional*/true, uiPerformanceLoggerConstant.DECLINE_TO_BIND, handleClose);
      function handleClose(result) {
        var promise = proposalActionsMediator.declineToBindFromSent(quoteIds, result.reason, result.details);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      }
    }
  };
  this.declineToBind = function (submissionId, proposalId) {
    umModalUtil.showReasonModal(submissionId, /*quoteId*/null, /*notificationName*/null, /*reasonObject*/null, 'submission.wizard.reasonModal.declineToBindModal', /*isReasonOptional*/true, uiPerformanceLoggerConstant.DECLINE_TO_BIND, handleClose);
    function handleClose(result) {
      var promise = proposalActionsMediator.declineToBind(proposalId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.requestToBindFromSent = function (submissionId, proposalId) {
    modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.requestToBind', null /*notificationName*/, uiPerformanceLoggerConstant.REQUEST_BINDING, handleClose);
    function handleClose(proposalId, quoteIds) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = proposalActionsMediator.requestToBindFromSent(quoteIds);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.bindProposalFromSent = function (submissionId, proposalId) {
    modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.bindProposal', null /*notificationName*/, uiPerformanceLoggerConstant.BIND, handleClose);
    function handleClose(proposalId, quoteIds) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = proposalActionsMediator.bindProposal(proposalId, quoteIds);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.requestBinding = function (submissionId, proposalId) {
    modalUtil.showConfirmationModal(submissionId, null, null /*notificationName*/, 'submission.wizard.requestBindingModal', uiPerformanceLoggerConstant.REQUEST_BINDING, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise;
      function onSuccess() {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      }
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = proposalActionsMediator.requestBinding(proposalId).then(onSuccess);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.getQuotableProductTemplates = function (submissionId, proposalId) {
    var dynamicDataSetParams = {
      name: 'Quotable Products for Proposal',
      submissionUri: "com.firstbest.underwriting.submission.Submission:".concat(submissionId),
      ownerUri: "com.firstbest.underwriting.proposal.Proposal:".concat(proposalId)
    };
    coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(function (response) {
      if (response.length === 1) {
        createQuote(_.split(response[0].value, '::')[0] /*submission Id*/, proposalId, _.split(response[0].value, '::')[1] /*product Id*/);
      } else if (response.length > 1) {
        var modalInstance = $uibModal.open({
          templateUrl: '/wizard/proposalQuotableProduct/proposalQuotableProductModal.tpl.html',
          controller: 'proposalQuotableProductController',
          backdrop: 'static',
          windowClass: 'proposalQuotableProductModal',
          resolve: {
            options: function options() {
              return {
                quotableProducts: response
              };
            }
          }
        });
        modalInstance.result.then(function (options) {
          var promise = createQuote(options.submissionId, proposalId, options.selectedQuotableProductId);
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
          return promise;
        });
      }
    });
  };
  this.sendProposal = function (submissionId, proposalId) {
    proposalMediator.getSections(proposalId).then(function (result) {
      var proposalSections = _.filter(result, {
        'type': sectionType.PROPOSAL
      });
      if (proposalSections.length > 1) {
        proposalMediator.findById(proposalId).then(function (_proposal) {
          var sendProposalModal = $uibModal.open({
            templateUrl: '/wizard/actions/documentBuilder/documentBuilderModal.tpl.html',
            controller: 'documentBuilderModalController',
            windowClass: 'documentBuilderModalContent',
            keyboard: false,
            backdrop: 'static',
            resolve: {
              proposal: function proposal() {
                return _proposal;
              },
              currentSectionType: function currentSectionType() {
                return sectionType.PROPOSAL;
              }
            }
          });
          sendProposalModal.result.then(handleClose);
        });
      } else {
        modalUtil.showConfirmationModal(null /*submissionId*/, null /*quoteId*/, 'notification.sendProposal', 'submission.wizard.sendProposalModal', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
      }
    });
    function handleClose() {
      var promise;
      function onSuccess() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SEND_PROPOSAL, coreConstant.uiPeformanceLogger.SUCCESS);
      }
      function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SEND_PROPOSAL, coreConstant.uiPeformanceLogger.FAIL);
      }
      function onFinally() {
        loadingBarHandler.hideLoadingBar();
      }
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SEND_PROPOSAL, proposalId.toString());
      loadingBarHandler.showLoadingBar('submission.wizard.sendProposalModal.loadingBar');
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = proposalMediator.sendProposal(proposalId).then(onSuccess, onError).finally(onFinally);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.sendBinder = function (submissionId, proposalId) {
    proposalMediator.findById(proposalId).then(function (_proposal2) {
      var sendDocumentModal = $uibModal.open({
        templateUrl: '/wizard/actions/documentBuilder/documentBuilderModal.tpl.html',
        controller: 'documentBuilderModalController',
        windowClass: 'documentBuilderModalContent',
        keyboard: false,
        backdrop: 'static',
        resolve: {
          proposal: function proposal() {
            return _proposal2;
          },
          currentSectionType: function currentSectionType() {
            return sectionType.BINDER;
          },
          proposalSections: function proposalSections() {
            return null;
          }
        }
      });
      sendDocumentModal.result.then(handleClose);
    });
    function handleClose() {
      var promise;
      function onSuccess() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BIND, coreConstant.uiPeformanceLogger.SUCCESS);
        $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST, submissionId);
      }
      function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BIND, coreConstant.uiPeformanceLogger.FAIL);
      }
      function onFinally() {
        loadingBarHandler.hideLoadingBar();
      }
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BIND, proposalId.toString());
      loadingBarHandler.showLoadingBar('submission.wizard.bindModal.loadingBar');
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = proposalActionsMediator.bindProposal(proposalId).then(onSuccess, onError).finally(onFinally);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.bindProposal = function (submissionId, proposalId) {
    modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.bindProposal', null /*notificationName*/, uiPerformanceLoggerConstant.BIND, handleClose);
    function handleClose(proposalId, quoteIds) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = proposalActionsMediator.bindProposal(proposalId, quoteIds);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.addProposalDocument = function (submissionId, proposalId) {
    loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.loadingAttachments');
    collaborationMediator.loadSubmissionAttachments(submissionId).then(function (submissionAttachmentList) {
      loadingBarHandler.hideLoadingBar();
      submissionAttachmentList = _.toArray(submissionAttachmentList);
      var modalInstance;
      if (submissionAttachmentList.length > 0) {
        modalInstance = modalUtil.showAttachmentsListModal(submissionAttachmentList);
      } else {
        modalInstance = modalUtil.showNewAttachmentModal();
      }
      modalInstance.then(function (data) {
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        if (attachmentUtil.isNewAttachmentObject(data)) {
          addSectionFromFile(data, proposalId);
        } else {
          addSectionFromDocument(data, proposalId);
        }
      });
    }).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
  };
  function addSectionFromFile(data, proposalId) {
    var attachment = data.attachment,
      file = data.file,
      payload = attachmentUtil.getAttachmentPayload(attachment);
    var promise;

    //save attachment
    loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.uploading');
    promise = proposalActionsMediator.addSectionFromFile(proposalId, payload, file).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  }
  function addSectionFromDocument(attachment, proposalId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.loadingBar');
    promise = proposalActionsMediator.addSectionFromDocument(proposalId, attachment.id, attachment.description).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  }
  function createQuote(submissionId, proposalId, selectedQuotableProductId) {
    var onSuccess = function onSuccess() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_QUOTE, coreConstant.uiPeformanceLogger.SUCCESS);
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      },
      onError = function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_QUOTE, coreConstant.uiPeformanceLogger.FAIL);
      };
    var promise;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_QUOTE, proposalId.toString());
    loadingBarHandler.showLoadingBar('submission.wizard.quotableProductModal.loadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = proposalActionsMediator.createQuote(submissionId, proposalId, selectedQuotableProductId).then(onSuccess, onError).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  }
  this.addSection = function (submissionId, proposalId) {
    modalUtil.showSelectionModal(submissionId, null /*quoteId*/, proposalId, 'submission.wizard.selectionModal.addSectionModal', uiPerformanceLoggerConstant.ADD_SECTION, handleClose);
    function handleClose(sectionTemplateId) {
      var promise = proposalActionsMediator.addSection(proposalId, sectionTemplateId, sectionType.PROPOSAL);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.deleteSection = function (submissionId, proposalId) {
    modalUtil.showSelectionModal(submissionId, null /*quoteId*/, proposalId, 'submission.wizard.selectionModal.deleteSectionModal', uiPerformanceLoggerConstant.DELETE_SECTION, handleClose);
    function handleClose(sectionTemplateId) {
      var promise = proposalActionsMediator.deleteSection(sectionTemplateId, /*invalidateProposalDocument*/true);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.generateQuotes = function (submissionId, proposalId) {
    var promise;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GENERATE_QUOTE, submissionId);
    loadingBarHandler.showLoadingBar('submission.wizard.generateQuotes.loadingBar');
    function onSuccess() {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST, submissionId);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GENERATE_QUOTE, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GENERATE_QUOTE, coreConstant.uiPeformanceLogger.FAIL);
    }
    function onFinally() {
      loadingBarHandler.hideLoadingBar();
    }
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = proposalActionsMediator.generateQuotes(proposalId).then(onSuccess, onError).finally(onFinally);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.generateBinder = function (submissionId, proposalId) {
    var promise;
    var logAction = uiPerformanceLoggerConstant.GENERATE_BINDER,
      message = proposalId.toString();
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
    loadingBarHandler.showLoadingBar('submission.wizard.generateBinder.loadingBar');
    function onSuccess(response) {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
    }
    function onFinally() {
      loadingBarHandler.hideLoadingBar();
    }
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = proposalActionsMediator.generateBinder(proposalId).then(onSuccess, onError).finally(onFinally);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
};
ProposalActionUtil.$inject = ["$rootScope", "$uibModal", "modalUtil", "loadingBarHandler", "submissionConstant", "actionsMediator", "proposalActionsMediator", "coreConstant", "uiPerformanceLoggerConstant", "proposalMediator", "sectionType", "attachmentUtil", "collaborationMediator", "coreMediator", "umModalUtil"];
angular.module('gw-um-submission').service('proposalActionUtil', ProposalActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var QuoteActionUtil = function QuoteActionUtil($rootScope, $state, $uibModal, $q, coreConstant, breadcrumbsMediator, quoteTransition, submissionConstant, submissionMediator, coreMediator, modalUtil, umModalUtil, uiPerformanceLoggerConstant, currentSubmissionModel, agentQuoteStatus, loadingBarHandler, quoteMediator, proposalMediator, quoteActionsMediator, actionsMediator, attachmentUtil, collaborationMediator, sectionType, quoteStatus) {
  this.deleteQuote = function (quoteId, submissionId) {
    modalUtil.showConfirmationModal(submissionId, quoteId, null /*notificationName*/, 'submission.wizard.deleteQuoteModal', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      function onSuccess() {
        var deleteQuoteAction = uiPerformanceLoggerConstant.DELETE_QUOTE,
          deleteQuoteStatus = coreConstant.uiPeformanceLogger.SUCCESS;
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, deleteQuoteAction, deleteQuoteStatus);
        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
      }
      function onError() {
        var action = uiPerformanceLoggerConstant.DELETE_QUOTE,
          status = coreConstant.uiPeformanceLogger.FAIL;
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
      }
      var logAction = uiPerformanceLoggerConstant.DELETE_QUOTE,
        message = quoteId.toString(),
        promise;
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
      promise = quoteActionsMediator.deleteQuote(quoteId).then(onSuccess, onError);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.copyQuoteForMultiQuoteProposal = function (quoteId, submissionId) {
    function onSuccess() {
      var copyQuoteAction = uiPerformanceLoggerConstant.COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL,
        copyQuoteStatus = coreConstant.uiPeformanceLogger.SUCCESS;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, copyQuoteAction, copyQuoteStatus);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    }
    function onError() {
      var action = uiPerformanceLoggerConstant.COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL,
        status = coreConstant.uiPeformanceLogger.FAIL;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
    }
    loadingBarHandler.showLoadingBar('submission.wizard.copyQuote.loadingBar');
    return quoteMediator.getQuote(quoteId).then(function (quote) {
      var proposalId = quote.proposalId,
        promise;
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL, proposalId.toString());
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = quoteActionsMediator.copyQuote(quoteId, proposalId).then(onSuccess, onError);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    });
  };
  this.copyQuote = function (quoteId, submissionId) {
    function onSuccess() {
      var copyQuoteAction = uiPerformanceLoggerConstant.COPY_QUOTE,
        copyQuoteStatus = coreConstant.uiPeformanceLogger.SUCCESS;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, copyQuoteAction, copyQuoteStatus);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    }
    function onError() {
      var action = uiPerformanceLoggerConstant.COPY_QUOTE,
        status = coreConstant.uiPeformanceLogger.FAIL;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
    }
    loadingBarHandler.showLoadingBar('submission.wizard.copyQuote.loadingBar');
    var logAction = uiPerformanceLoggerConstant.COPY_QUOTE,
      message = quoteId.toString(),
      promise;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = quoteActionsMediator.copyQuote(quoteId).then(onSuccess, onError);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.handleDeclineToBind = function (quoteId, submissionId) {
    umModalUtil.showReasonModal(submissionId, quoteId, null /*notificationName*/, null /*reasonObject*/, 'submission.wizard.reasonModal.declineToBindModal', true /*isReasonOptional*/, uiPerformanceLoggerConstant.DECLINE_TO_BIND, handleClose);
    function handleClose(result) {
      var promise = quoteActionsMediator.declineToBind(quoteId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.requestBinding = function (quoteId, submissionId) {
    modalUtil.showConfirmationModal(submissionId, quoteId, null /*notificationName*/, 'submission.wizard.requestBindingModal', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      function onSuccess(response) {
        if (currentSubmissionModel.getCurrentSubmission().agentQuoteStatus === agentQuoteStatus.DISABLED) {
          var requestBindingAction = uiPerformanceLoggerConstant.REQUEST_BINDING,
            requestBindingStatus = coreConstant.uiPeformanceLogger.SUCCESS;
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, requestBindingAction, requestBindingStatus);
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        }
      }
      function onError() {
        var action = uiPerformanceLoggerConstant.REQUEST_BINDING,
          status = coreConstant.uiPeformanceLogger.FAIL;
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
      }
      var logAction = uiPerformanceLoggerConstant.REQUEST_BINDING,
        message = quoteId.toString(),
        promise;
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = quoteActionsMediator.requestBinding(quoteId).then(onSuccess, onError);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.generateQuote = function (quoteId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.generatingQuote');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = quoteActionsMediator.generateQuote(quoteId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST, submissionId);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.modifyQuote = function (quoteId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.modifyingQuote');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = quoteActionsMediator.modifyQuote(quoteId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  function populateBreadcrumb(quoteSummary) {
    return breadcrumbsMediator.loadQuoteBreadcrumbs(quoteSummary.id).then(function (breadcrumbs) {
      quoteSummary.breadcrumb = breadcrumbs;
    });
  }
  function openQuoteSelectionModal(quoteId, transition) {
    var quoteSummaries = [],
      promises = [];
    return quoteActionsMediator.getQuotesWithEnabledAction(quoteId, transition).then(function (quotesMap) {
      var quoteStatus;
      _.each(quotesMap.enabled, function (quoteSummary) {
        quoteSummary.actionEnabled = true;
        quoteSummary.isSelected = true;
        quoteSummaries.push(quoteSummary);
        quoteStatus = quoteSummary.status;
      });
      _.each(quotesMap.valid, function (quoteSummary) {
        quoteSummary.incomplete = true;
        quoteSummary.isSelected = false;
        quoteSummaries.push(quoteSummary);
      });
      _.each(quotesMap.invalid, function (quoteSummary) {
        quoteSummary.isSelected = false;
        quoteSummaries.push(quoteSummary);
      });
      quoteSummaries = _.orderBy(quoteSummaries, ['status', 'incomplete', 'summary'], ['asc', 'desc', 'asc']);
      if (quotesMap.enabled.length + quotesMap.valid.length + quotesMap.invalid.length === 1) {
        return $q.resolve({
          result: $q.resolve({
            quoteIds: quoteId
          })
        });
      }
      _.each(quoteSummaries, function (quoteSummary) {
        promises.push(populateBreadcrumb(quoteSummary));
      });
      return $q.all(promises).then(function () {
        loadingBarHandler.hideLoadingBar();
        return $uibModal.open({
          templateUrl: '/wizard/quoteSelection/quoteSelectionModal.tpl.html',
          controller: 'quoteSelectionModalController',
          backdrop: 'static',
          windowClass: 'quoteSelectionModal',
          resolve: {
            options: function options() {
              return {
                quoteSummaries: quoteSummaries,
                transition: transition
              };
            }
          }
        });
      });
    });
  }
  this.startQuote = function (quoteId, submissionId) {
    var promise;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.START_QUOTE, submissionId);
    loadingBarHandler.showLoadingBar('submission.startingQuote');
    return openQuoteSelectionModal(quoteId, quoteTransition.START_QUOTE).then(function (modalInstance) {
      return modalInstance.result.then(function (result) {
        loadingBarHandler.showLoadingBar('submission.startingQuote');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        var onSuccess = function onSuccess() {
          $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST, submissionId);
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          loadingBarHandler.hideLoadingBar();
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.START_QUOTE, coreConstant.uiPeformanceLogger.SUCCESS);
        };
        var onFailure = function onFailure() {
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.START_QUOTE, coreConstant.uiPeformanceLogger.FAIL);
        };
        promise = quoteActionsMediator.startQuote(result.quoteIds).then(onSuccess, onFailure);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
    });
  };
  this.generateRating = function (quoteId) {
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GET_RATE, quoteId);
    loadingBarHandler.showLoadingBar('submission.ratingEngineProcessing');
    return openQuoteSelectionModal(quoteId, quoteTransition.GENERATE_RATING).then(function (modalInstance) {
      return modalInstance.result.then(function (result) {
        loadingBarHandler.showLoadingBar('submission.ratingEngineProcessing');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        var onSuccess = function onSuccess() {
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          loadingBarHandler.hideLoadingBar();
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GET_RATE, coreConstant.uiPeformanceLogger.SUCCESS);
        };
        var onFailure = function onFailure() {
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GET_RATE, coreConstant.uiPeformanceLogger.FAIL);
        };
        var promise = quoteActionsMediator.generateRating(result.quoteIds).then(onSuccess, onFailure);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
    });
  };
  this.startPricing = function (quoteId) {
    loadingBarHandler.showLoadingBar('submission.startPricing');
    return openQuoteSelectionModal(quoteId, quoteTransition.START_PRICING).then(function (modalInstance) {
      return modalInstance.result.then(function (result) {
        var promise;
        loadingBarHandler.showLoadingBar('submission.startPricing');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = quoteActionsMediator.startPricing(result.quoteIds).then(function () {
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
    });
  };
  this.refreshQuoteByIds = function (quoteIds) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.refreshQuote');
    promise = quoteActionsMediator.refreshQuoteByIds(quoteIds).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.modifyPricing = function (quoteId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.modifyPricing');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = quoteActionsMediator.modifyPricing(quoteId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.modifyRating = function (quoteId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.modifyingRating');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = quoteActionsMediator.modifyRating(quoteId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.sendProposal = function (quoteId, submissionId) {
    modalUtil.showConfirmationModal(null /*submissionId*/, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.sendProposalModal', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      function onSuccess(response) {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SEND_PROPOSAL, coreConstant.uiPeformanceLogger.SUCCESS);
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      }
      function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SEND_PROPOSAL, coreConstant.uiPeformanceLogger.FAIL);
      }
      return quoteMediator.getQuote(quoteId).then(function (quote) {
        var proposalId = quote.proposalId,
          promise;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SEND_PROPOSAL, proposalId.toString());
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = proposalMediator.sendProposal(proposalId).then(onSuccess, onError);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
    }
  };
  this.bindQuote = function (quoteId, submissionId) {
    modalUtil.showConfirmationModal(submissionId, quoteId, null /*notificationName*/, 'submission.wizard.bindModal', null, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      function onSuccess(response) {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BIND, coreConstant.uiPeformanceLogger.SUCCESS);
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      }
      function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BIND, coreConstant.uiPeformanceLogger.FAIL);
      }
      return quoteMediator.getQuote(quoteId).then(function (quote) {
        var proposalId = quote.proposalId,
          promise;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BIND, proposalId.toString());
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = quoteActionsMediator.bindQuote(proposalId).then(onSuccess, onError);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
    }
  };
  this.generateBinder = function (quoteId, submissionId) {
    function onSuccess(response) {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GENERATE_BINDER, coreConstant.uiPeformanceLogger.SUCCESS);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
    }
    function onError() {
      var action = uiPerformanceLoggerConstant.GENERATE_BINDER,
        status = coreConstant.uiPeformanceLogger.FAIL;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
    }
    var logAction = uiPerformanceLoggerConstant.GENERATE_BINDER,
      message = quoteId.toString(),
      quoteIds = [quoteId],
      promise;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = quoteActionsMediator.generateBinder(quoteIds).then(onSuccess, onError);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.beginBinding = function (quoteId, submissionId) {
    loadingBarHandler.showLoadingBar('submission.beginBinding');
    function onSuccess(response) {
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BEGIN_BINDING, coreConstant.uiPeformanceLogger.SUCCESS);
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BEGIN_BINDING, coreConstant.uiPeformanceLogger.FAIL);
    }
    function onFinally() {
      loadingBarHandler.hideLoadingBar();
    }
    var promise;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BEGIN_BINDING, submissionId);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = quoteActionsMediator.beginBinding(quoteId).then(onSuccess, onError).finally(onFinally);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.getQuotableProductTemplates = function (submissionId) {
    var promise;
    function onSuccess(response) {
      if (response.length === 1) {
        createQuote(submissionId, [response[0].id]);
      } else if (response.length > 1) {
        var modalInstance = $uibModal.open({
          templateUrl: '/wizard/quotableProductTemplates/quotableProductTemplatesModal.tpl.html',
          controller: 'quotableProductTemplatesModalController',
          backdrop: 'static',
          windowClass: 'quotableProductModal',
          resolve: {
            options: function options() {
              return {
                quotableProducts: response,
                isProposalAction: false
              };
            }
          }
        });
        modalInstance.result.then(function (options) {
          createQuote(submissionId, options.selectedQuotableProductId);
        });
      }
    }
    promise = actionsMediator.getQuotableProductTemplates(submissionId).then(onSuccess);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.addQuoteDocument = function (submissionId, quoteId) {
    var modalInstance;
    loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.loadingAttachments');
    collaborationMediator.loadSubmissionAttachments(submissionId).then(function (submissionAttachmentList) {
      loadingBarHandler.hideLoadingBar();
      submissionAttachmentList = _.toArray(submissionAttachmentList);
      if (submissionAttachmentList.length > 0) {
        modalInstance = modalUtil.showAttachmentsListModal(submissionAttachmentList);
      } else {
        modalInstance = modalUtil.showNewAttachmentModal();
      }
      modalInstance.then(function (data) {
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        if (attachmentUtil.isNewAttachmentObject(data)) {
          addSectionFromFile(data, quoteId);
        } else {
          addSectionFromDocument(data, quoteId);
        }
      });
    }).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
  };
  function addSectionFromFile(data, quoteId) {
    var attachment = data.attachment,
      file = data.file,
      payload = attachmentUtil.getAttachmentPayload(attachment),
      promise;

    //save attachment
    loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.uploading');
    promise = quoteActionsMediator.addSectionFromFile(quoteId, payload, file).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  }
  function addSectionFromDocument(attachment, quoteId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.loadingBar');
    promise = quoteActionsMediator.addSectionFromDocument(quoteId, attachment.id, attachment.description).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  }
  function createQuote(submissionId, selectedQuotableProductId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.wizard.quotableProductModal.loadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = actionsMediator.createQuote(submissionId, selectedQuotableProductId).then(function (response) {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  }
  this.unbind = function (quoteId, submissionId) {
    function handleClose(result) {
      var promise;
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = quoteActionsMediator.unbind(quoteId, result.reason, result.details).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      }).finally(function () {
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    umModalUtil.showReasonModal(submissionId, quoteId, null /*removed'notification.unbind'*/, null /*reason*/, 'submission.wizard.reasonModal.unbindModal', false /*isReasonOptional*/, uiPerformanceLoggerConstant.UNBIND, handleClose);
  };
  this.modifyBinder = function (quoteId, submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.wizard.modifyBinder.loadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    function onSuccess(response) {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
    }
    function onFinally() {
      loadingBarHandler.hideLoadingBar();
    }
    promise = quoteActionsMediator.modifyBinder(quoteId).then(onSuccess).finally(onFinally);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.addSection = function (quoteId, submissionId) {
    modalUtil.showSelectionModal(submissionId, quoteId, null, 'submission.wizard.selectionModal.addSectionModal', uiPerformanceLoggerConstant.ADD_SECTION, handleClose);
    function handleClose(sectionTemplateId) {
      var promise = quoteActionsMediator.addSection(quoteId, sectionTemplateId, sectionType.PROPOSAL);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.deleteSection = function (quoteId, submissionId) {
    modalUtil.showSelectionModal(submissionId, quoteId, null, 'submission.wizard.selectionModal.deleteSectionModal', uiPerformanceLoggerConstant.DELETE_SECTION, handleClose);
    function handleClose(sectionTemplateId) {
      var promise = quoteActionsMediator.deleteSection(sectionTemplateId, /*invalidateProposalDocument*/true);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.generateRatingAttachments = function (quoteId, submissionId) {
    var dynamicDataSetParams = {
      name: 'Rating Attachment Groups',
      submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
      ownerUri: 'com.firstbest.underwriting.quote.Quote:' + quoteId
    };
    function onSuccess(response) {
      var ratingAttachmentGroups = {};

      // Format the response into a mapping of the separate attachment groups, for easier processing in the modal.
      _.each(response, function (dataItem) {
        if (!ratingAttachmentGroups[dataItem.grouping]) {
          ratingAttachmentGroups[dataItem.grouping] = {
            name: dataItem.grouping,
            ratingAttachments: []
          };
        }
        ratingAttachmentGroups[dataItem.grouping].ratingAttachments.push(dataItem);
      });
      $uibModal.open({
        templateUrl: '/wizard/generateRatingAttachments/generateRatingAttachmentsModal.tpl.html',
        controller: 'generateRatingAttachmentsModalController',
        backdrop: 'static',
        windowClass: 'generateRatingAttachmentsModalContainer',
        resolve: {
          options: function options() {
            return {
              ratingAttachmentGroups: ratingAttachmentGroups
            };
          }
        }
      }).result.then(function (options) {
        var action = uiPerformanceLoggerConstant.GENERATE_RATING_ATTACHMENTS,
          message = quoteId.toString(),
          promise;
        function onSuccess() {
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
        }
        function onFinally() {
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          loadingBarHandler.hideLoadingBar();
        }
        loadingBarHandler.showLoadingBar('submission.wizard.generateRatingAttachments.loadingBar');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = quoteActionsMediator.generateRatingAttachments(quoteId, options.selectedRatingAttachments).then(onSuccess, onError).finally(onFinally);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
    }
    coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(onSuccess);
  };
  this.revertToSent = function (quoteId, submissionId) {
    modalUtil.showConfirmationModal(submissionId, quoteId, null /* notificationName */, 'submission.wizard.revertToSentModal', uiPerformanceLoggerConstant.REVERT_TO_SENT, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = quoteActionsMediator.revertToSent(quoteId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.withdrawQuote = function (quoteId, submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.withdrawQuoteModal', false, uiPerformanceLoggerConstant.WITHDRAW_QUOTE, handleClose);
    function handleClose(result) {
      var promise = quoteActionsMediator.withdrawQuote(quoteId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.withdrawRequest = function (quoteId, submissionId) {
    modalUtil.showConfirmationModal(submissionId, quoteId, /*notificationName*/null, 'submission.wizard.withdrawRequestModal', uiPerformanceLoggerConstant.WITHDRAW_REQUEST, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = quoteActionsMediator.withdrawRequest(quoteId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
};
QuoteActionUtil.$inject = ["$rootScope", "$state", "$uibModal", "$q", "coreConstant", "breadcrumbsMediator", "quoteTransition", "submissionConstant", "submissionMediator", "coreMediator", "modalUtil", "umModalUtil", "uiPerformanceLoggerConstant", "currentSubmissionModel", "agentQuoteStatus", "loadingBarHandler", "quoteMediator", "proposalMediator", "quoteActionsMediator", "actionsMediator", "attachmentUtil", "collaborationMediator", "sectionType", "quoteStatus"];
angular.module('gw-um-submission').service('quoteActionUtil', QuoteActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 493 */
/***/ (function(module, exports) {

/*@ngInject*/
var ReportActionUtil = function ReportActionUtil($rootScope, $state, $uibModal, coreConstant, submissionConstant, reportActionsMediator, coreMediator, modalUtil, uiPerformanceLoggerConstant, currentSubmissionModel, agentQuoteStatus, loadingBarHandler) {
  this.createReport = function (submissionId, reportName) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.report.createReport');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = reportActionsMediator.createReport(submissionId, reportName).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.generateReport = function (reportId) {
    var promise;
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    loadingBarHandler.showLoadingBar('submission.report.generateReport');
    promise = reportActionsMediator.generateReport(reportId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.editReport = function (reportId) {
    var promise;
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    promise = reportActionsMediator.editReport(reportId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.deleteReport = function (submissionId, reportId) {
    modalUtil.showConfirmationModal(submissionId, null, null /*notificationName*/, 'submission.wizard.deleteReport', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = reportActionsMediator.deleteReport(reportId).then(function () {
        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
        loadingBarHandler.hideLoadingBar();
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
};
ReportActionUtil.$inject = ["$rootScope", "$state", "$uibModal", "coreConstant", "submissionConstant", "reportActionsMediator", "coreMediator", "modalUtil", "uiPerformanceLoggerConstant", "currentSubmissionModel", "agentQuoteStatus", "loadingBarHandler"];
angular.module('gw-um-submission').service('reportActionUtil', ReportActionUtil);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(495);

/*@ngInject*/
var SubmissionActionUtil = function SubmissionActionUtil($rootScope, $state, $uibModal, formViewerConstant, submissionConstant, actionsMediator, submissionMediator, coreMediator, coreConstant, declineMediator, markAsLostMediator, uiPerformanceLoggerConstant, modalUtil, umModalUtil, loadingBarHandler, submissionStateMediator, submissionCopyOptions, reportMediator, proposalActionsMediator, submissionPrequalificationMediator, currentSubmissionModel, agentQuoteStatus, appTypeConfigurationModel) {
  this.i18n = locale;
  this.handleReviewModifications = function (_submission) {
    var _this = this;
    $uibModal.open({
      templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
      controller: 'reviewChangesModalController',
      backdrop: 'static',
      windowClass: 'reviewChangesModal',
      resolve: {
        submission: function submission() {
          return _submission;
        },
        options: function options() {
          return {
            title: _this.i18n.reviewTitle,
            isReadOnly: true,
            changeSetId: _submission.changeSetId
          };
        }
      }
    });
  };
  this.handleSubmitModifications = function (submission) {
    var _this2 = this;
    $uibModal.open({
      templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
      controller: 'reviewChangesModalController',
      backdrop: 'static',
      windowClass: 'reviewChangesModal',
      resolve: {
        options: function options() {
          return {
            title: _.get(_this2.i18n, 'reviewSubmitTitle'),
            isReadOnly: false,
            continueButtonLabel: _.get(_this2.i18n, 'submitChanges'),
            continueButtonAction: actionsMediator.submitModifications,
            changeSetId: submission.changeSetId,
            loadingBarMessage: _.get(_this2.i18n, 'submitChangesLoadingBarMessage'),
            entityId: submission.id
          };
        }
      }
    });
  };
  this.handleDiscardModifications = function (_submission2) {
    var title = _.get(this.i18n, 'reviewDiscardTitle'),
      buttonLabel = _.get(this.i18n, 'discardChanges'),
      loadingBarMessageDiscard = _.get(this.i18n, 'discardChangesLoadingBarMessage');
    function getActiveChanges() {
      submissionMediator.loadChangeSet(_submission2.changeSetId, true).then(function (result) {
        var changeSetList = result.changeList,
          hasChanges = changeSetList.length > 0;
        if (hasChanges) {
          showModal();
        } else {
          actionsMediator.discardModifications(_submission2.id).then(function () {
            // we send them to the overview screen after we cancel the submission because
            // the forms are still the same, making sure to refresh the form id, since the
            // Submission form on the overview is now deleted and recreated as well.
            $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW, true /*refreshFormId*/);
          });
        }
      });
    }
    function showModal(hasChanges) {
      $uibModal.open({
        templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
        controller: 'reviewChangesModalController',
        backdrop: 'static',
        windowClass: 'reviewChangesModal',
        resolve: {
          submission: function submission() {
            return _submission2;
          },
          options: function options() {
            return {
              title: title,
              isReadOnly: false,
              continueButtonLabel: buttonLabel,
              continueButtonAction: actionsMediator.discardModifications,
              changeSetId: _submission2.changeSetId,
              loadingBarMessage: loadingBarMessageDiscard,
              entityId: _submission2.id,
              hasChanges: hasChanges
            };
          }
        }
      });
    }
    getActiveChanges();
  };
  this.handleAcknowledgeModifications = function (_submission3) {
    var title = _.get(this.i18n, 'reviewAcknowledgeTitle'),
      buttonLabel = _.get(this.i18n, 'acknowledgeChanges');
    function getActiveChanges() {
      submissionMediator.loadChangeSet(_submission3.changeSetId, true).then(function (result) {
        var changeSetList = result.changeList,
          hasChanges = changeSetList.length > 0;
        if (hasChanges) {
          showModal();
        } else {
          actionsMediator.acknowledgeModifications(_submission3.id).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW, true /*refreshFormId*/);
          });
        }
      });
    }
    function showModal(hasChanges) {
      $uibModal.open({
        templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
        controller: 'reviewChangesModalController',
        backdrop: 'static',
        windowClass: 'reviewChangesModal',
        resolve: {
          submission: function submission() {
            return _submission3;
          },
          options: function options() {
            return {
              title: title,
              isReadOnly: false,
              continueButtonLabel: buttonLabel,
              continueButtonAction: actionsMediator.acknowledgeModifications,
              changeSetId: _submission3.changeSetId,
              entityId: _submission3.id,
              hasChanges: hasChanges,
              navigateToOverviewBeforeContinue: true
            };
          }
        }
      });
    }
    getActiveChanges();
  };
  this.getQuotableProductTemplates = function (submissionId) {
    function onSuccess(response) {
      if (response.length === 1) {
        createProposal(submissionId, [response[0].id]);
      } else if (response.length > 1) {
        var isProposalAction = currentSubmissionModel.getCurrentSubmission().agentQuoteStatus !== agentQuoteStatus.ENABLED,
          modalInstance = $uibModal.open({
            templateUrl: '/wizard/quotableProductTemplates/quotableProductTemplatesModal.tpl.html',
            controller: 'quotableProductTemplatesModalController',
            backdrop: 'static',
            windowClass: 'quotableProductModal',
            resolve: {
              options: function options() {
                return {
                  quotableProducts: response,
                  isProposalAction: isProposalAction
                };
              }
            }
          });
        modalInstance.result.then(function (options) {
          if (isProposalAction) {
            createProposal(submissionId, options.selectedQuotableProductIds);
          } else {
            createQuote(submissionId, options.selectedQuotableProductId);
          }
        });
      }
    }
    var promise = actionsMediator.getQuotableProductTemplates(submissionId).then(onSuccess);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
  };
  this.splitSubmission = function (submissionId) {
    var submission = submissionMediator.getSubmissionById(submissionId),
      productShortNames = submission.productShortNames,
      modalInstance = $uibModal.open({
        templateUrl: '/wizard/splitSubmission/splitSubmissionModal.tpl.html',
        controller: 'splitSubmissionModalController',
        backdrop: 'static',
        windowClass: 'splitSubmissionModal',
        resolve: {
          options: function options() {
            return {
              productShortNames: productShortNames,
              submissionId: submissionId
            };
          }
        }
      });
    modalInstance.result.then(function (response) {
      var logAction = uiPerformanceLoggerConstant.SPLIT_SUBMISSION,
        message = submissionId.toString();
      function onSuccess(response) {
        submissionMediator.loadSubmission(response.id).then(function (submission) {
          loadingBarHandler.hideLoadingBar();
          submissionMediator.setCurrentSubmission(submission);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
          $state.go('submission.form', {
            submissionId: submission.id
          });
        });
      }
      function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
      }
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
      loadingBarHandler.showLoadingBar('submission.wizard.splitSubmissionModal.loadingBar');
      actionsMediator.splitSubmission(submissionId, response.productShortNames).then(onSuccess, onError);
    });
  };
  function createProposal(submissionId, selectedQuotableProductId) {
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_PROPOSAL, submissionId);
    loadingBarHandler.showLoadingBar('submission.wizard.quotableProductModal.loadingBarForProposal');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var onSuccess = function onSuccess() {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_PROPOSAL, coreConstant.uiPeformanceLogger.SUCCESS);
    };
    var onFailure = function onFailure() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_PROPOSAL, coreConstant.uiPeformanceLogger.FAIL);
    };
    var promise = proposalActionsMediator.createProposal(submissionId, selectedQuotableProductId).then(onSuccess, onFailure);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
  }
  function createQuote(submissionId, selectedQuotableProductId) {
    loadingBarHandler.showLoadingBar('submission.wizard.quotableProductModal.loadingBar');
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = actionsMediator.createQuote(submissionId, selectedQuotableProductId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
  }
  this.handleCopySubmission = function (submissionId) {
    var _this3 = this;
    var modalInstance = $uibModal.open({
      templateUrl: '/wizard/copySubmission/copySubmissionModal.tpl.html',
      controller: 'copySubmissionModalController',
      backdrop: 'static',
      windowClass: 'copySubmissionModal'
    });
    modalInstance.result.then(function (response) {
      var logAction = uiPerformanceLoggerConstant.COPY_SUBMISSION,
        message = "".concat(submissionId, " - ").concat(response.copyOptions);
      function onSuccess(response) {
        submissionMediator.loadSubmission(response.id).then(function (submission) {
          loadingBarHandler.hideLoadingBar();
          submissionMediator.setCurrentSubmission(submission);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        });
      }
      function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
      }
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
      loadingBarHandler.showLoadingBar(_this3.i18n.copySubmission.loadingBar);
      actionsMediator.copySubmission(submissionId, response.copyOptions).then(onSuccess, onError);
    });
  };
  this.handleReactivate = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.reactivateModal', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = actionsMediator.reactivate(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.handleReevaluate = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.reevaluateModal', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = actionsMediator.reevaluate(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.handleMarkSubmissionAsLost = function (submission) {
    function confirmActionCallback(submissionId) {
      var promise = actionsMediator.markAsLost(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    function cancelActionCallback(submissionId) {
      return markAsLostMediator.deleteMarkAsLostForm(submissionId);
    }
    markAsLostMediator.createMarkAsLostForm(submission.id).then(function (markAsLostFormId) {
      umModalUtil.showReasonFormModal(submission, markAsLostFormId, confirmActionCallback, cancelActionCallback, 'markAsLost', uiPerformanceLoggerConstant.MARK_AS_LOST);
    });
  };
  this.handleReject = function (submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, 'notification.reject', null /*reason*/, 'submission.wizard.reasonModal.rejectModal', false, null /*performanceLoggerName*/, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.reject(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.handleDecline = function (submission) {
    function confirmActionCallback(submissionId) {
      var promise = actionsMediator.decline(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
    function cancelActionCallback(submissionId) {
      return declineMediator.deleteDeclinationForm(submissionId);
    }
    declineMediator.createDeclinationForm(submission.id).then(function (declinationFormId) {
      umModalUtil.showReasonFormModal(submission, declinationFormId, confirmActionCallback, cancelActionCallback, 'decline', uiPerformanceLoggerConstant.DECLINE_SUBMISSION);
    });
  };
  this.handleNotClear = function (submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.notClearModal', false, null /*performanceLoggerName*/, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.markSubmissionNotClear(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.handleClearReady = function (submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null, null /*reason*/, 'submission.wizard.reasonModal.clearReadyModal', true, uiPerformanceLoggerConstant.CLEAR_READY_SUBMISSION, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.markSubmissionClearReady(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.handleRevertToClear = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.revertToClear', uiPerformanceLoggerConstant.REVERT_TO_CLEAR, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = actionsMediator.revertToClear(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.handleCheckClearance = function (submissionId) {
    var _this4 = this;
    var promise,
      onSuccess = function onSuccess(response) {
        var _options = {};
        if (response.value === 3 /*unknown*/) {
          _options.title = response.reason;
          _options.summary = response.detail;
        } else if (response.value === 2 /*Not Clear*/) {
          _options.title = _.get(_this4.i18n, 'checkClearance.notClear.title');
          _options.summary = _.get(_this4.i18n, 'checkClearance.notClear.summary');
        } else if (response.value === 1 /*Clear*/) {
          _options.title = _.get(_this4.i18n, 'checkClearance.clear.title');
          _options.summary = _.get(_this4.i18n, 'checkClearance.clear.summary');
        }
        _options.cancelButtonLabel = _.get(_this4.i18n, 'alert.okButtonLabel');
        $uibModal.open({
          templateUrl: '/ui/modal/modal.tpl.html',
          controller: 'modalController',
          backdrop: 'static',
          windowClass: 'genericModal',
          resolve: {
            options: function options() {
              return _options;
            }
          }
        });
      };
    promise = actionsMediator.handleCheckClearance(submissionId).then(onSuccess);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
  };
  this.handleClear = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.clearModal', uiPerformanceLoggerConstant.CLEAR_SUBMISSION, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = actionsMediator.markSubmissionClear(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.changeProducts = function (submissionId) {
    var submission = submissionMediator.getSubmissionById(submissionId),
      logAction = uiPerformanceLoggerConstant.CHANGE_PRODUCTS,
      message = submissionId.toString(),
      productShortNames = submission.productShortNames,
      modalInstance = $uibModal.open({
        templateUrl: '/wizard/changeProducts/changeProductsModal.tpl.html',
        controller: 'changeProductsModalController',
        backdrop: 'static',
        windowClass: 'changeProductsModal',
        resolve: {
          options: function options() {
            return {
              selectedProducts: productShortNames,
              submissionId: submissionId
            };
          }
        }
      });
    modalInstance.result.then(function (response) {
      if (response.isProductRemoved) {
        modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.changeProductsWarningModal', null, /*hideLoadingBar*/false, handleClose);
        function handleClose() {
          handleResults(response.productShortNames);
        }
      } else {
        handleResults(response.productShortNames);
      }
    });
    function handleResults(productShortNames) {
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
      loadingBarHandler.showLoadingBar('submission.wizard.changeProductsModal.loadingBar');
      var promise = actionsMediator.changeProducts(submissionId, productShortNames).then(onSuccess, onError);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      function onSuccess() {
        loadingBarHandler.hideLoadingBar();
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
      }
      function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
      }
    }
  };
  this.updateStatusReason = function (submissionId) {
    var submission = submissionMediator.getCurrentSubmission(),
      reason = {
        reason: submission.statusReason,
        details: submission.statusDetail
      };
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notification.decline*/, reason, 'submission.wizard.reasonModal.updateStatusReasonModal', false, uiPerformanceLoggerConstant.UPDATE_STATUS_REASON, handleClose);
    function handleClose(result) {
      loadingBarHandler.showLoadingBar('submission.wizard.reasonModal.updateStatusReasonModal.loadingBar');
      var promise = actionsMediator.updateStatusReason(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.submitApplication = function (submissionId) {
    var _this5 = this;
    var doSubmit = function doSubmit() {
      var onSuccess = function onSuccess() {
        loadingBarHandler.hideLoadingBar();
        var logAction = uiPerformanceLoggerConstant.SUBMIT_SUBMISSION,
          status = coreConstant.uiPeformanceLogger.SUCCESS;
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
      };
      var onError = function onError() {
        var logAction = uiPerformanceLoggerConstant.SUBMIT_SUBMISSION,
          status = coreConstant.uiPeformanceLogger.FAIL;
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
      };
      var promise;
      loadingBarHandler.showLoadingBar('submission.submittingApplication');
      $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
      promise = submissionMediator.submitSubmission(submissionId).then(onSuccess, onError);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
    var showSubmitModal = function showSubmitModal(notificationPopupTemplate) {
      var _options2 = {};
      _options2.title = notificationPopupTemplate.title;
      _options2.summary = notificationPopupTemplate.body;
      _options2.cancelButtonLabel = _.get(_this5.i18n, 'submit.cancelActionButtonLabel');
      _options2.confirmActionButtonLabel = _.get(_this5.i18n, 'submit.confirmActionButtonLabel');
      var modalInstance = $uibModal.open({
        templateUrl: '/ui/modal/modal.tpl.html',
        controller: 'modalController',
        backdrop: 'static',
        windowClass: 'genericModal',
        resolve: {
          options: function options() {
            return _options2;
          }
        }
      });
      var handleClose = function handleClose() {
        var logAction = uiPerformanceLoggerConstant.SUBMIT_SUBMISSION,
          message = submissionId.toString();
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        doSubmit();
      };
      modalInstance.result.then(handleClose);
    };
    coreMediator.getNotificationPopupTemplate('notification.submitApplication', {
      submissionId: submissionId
    }).then(function (notificationPopupTemplate) {
      if (!isNotificationHidden(notificationPopupTemplate) && notificationPopupTemplate.enabled) {
        showSubmitModal(notificationPopupTemplate);
      } else {
        var logAction = uiPerformanceLoggerConstant.SUBMIT_SUBMISSION,
          message = submissionId.toString();
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        doSubmit();
      }
    });
    function isNotificationHidden(notification) {
      return notification.excludeConsole === 'Producer' && appTypeConfigurationModel.isAgentConsole() || notification.excludeConsole === 'Underwriter' && appTypeConfigurationModel.isUnderwriterWorkstation();
    }
  };
  this.makeApplication = function (submissionId) {
    var logAction = uiPerformanceLoggerConstant.MAKE_SUBMISSION,
      message = submissionId.toString();
    var promise;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
    $rootScope.$broadcast(coreConstant.event.START_MAKING_APPLICATION);
    loadingBarHandler.showLoadingBar('submission.creatingSubmission');
    function onSuccess(response) {
      loadingBarHandler.hideLoadingBar();
      if (response.originator !== submissionConstant.originator.UPLOAD_ACORD_PDF) {
        submissionMediator.updateOpenSubmission(response);
        $state.go('submission.default', {
          submissionId: submissionId
        }, {
          reload: true
        });
      } else {
        $rootScope.$broadcast(coreConstant.event.CLOSE_SUBMISSION_VIEW, submissionId);
      }
      var logAction = uiPerformanceLoggerConstant.MAKE_SUBMISSION,
        status = coreConstant.uiPeformanceLogger.SUCCESS;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
    }
    function onError() {
      var logAction = uiPerformanceLoggerConstant.MAKE_SUBMISSION,
        status = coreConstant.uiPeformanceLogger.FAIL;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
      loadingBarHandler.hideLoadingBar();
    }
    promise = actionsMediator.makeApplication(submissionId).then(onSuccess, onError);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.delete = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.deleteSubmissionModal', null /*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = submissionMediator.deleteSubmission(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.deletePreDraft = function (submissionId) {
    var promise = submissionMediator.deleteSubmission(submissionId);
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.modifySubmission = function (submissionId) {
    var promise;
    loadingBarHandler.showLoadingBar('submission.modifyingSubmission');
    promise = actionsMediator.modifySubmission(submissionId).then(function () {
      $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.handleAssignAccount = function (_submission4) {
    $uibModal.open({
      templateUrl: '/account/assign/assignAccountModal.tpl.html',
      controller: 'assignAccountModalController',
      backdrop: 'static',
      windowClass: 'assignAccountModal',
      resolve: {
        submission: function submission() {
          return _submission4;
        }
      }
    });
  };
  this.referSubmission = function (submissionId) {
    var submission = submissionMediator.getCurrentSubmission(),
      dropdownFilterFunctions = {
        secondaryDropdown: referralUnderwriterFilterFunction
      };
    function referralUnderwriterFilterFunction(referralUnderwriter) {
      return _.toInteger(referralUnderwriter.value) !== submission.responsibleUnderwriterSummary.id;
    }
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notification.decline*/, null /*reasonObject*/, 'submission.wizard.reasonModal.referModal', false, uiPerformanceLoggerConstant.REFER_SUBMISSION, handleClose, dropdownFilterFunctions, false);
    function handleClose(result) {
      loadingBarHandler.showLoadingBar('submission.wizard.reasonModal.referModal.loadingBar');
      var promise = actionsMediator.referSubmission(submissionId, result.reason, result.secondaryReason.value, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.retractReferral = function (submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null, null /*reason*/, 'submission.wizard.reasonModal.retractReferralModal', false, uiPerformanceLoggerConstant.RETRACT_REFERRAL, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.retractReferral(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.clearReferral = function (submissionId) {
    var _this6 = this;
    actionsMediator.getReferralClearanceType(submissionId).then(function (responseData) {
      var clearanceType = responseData.clearanceType,
        options = {};
      options.primaryAction = clearanceType === 'clear' ? _.get(_this6.i18n, 'clearReferralModal.clearReferralAction') : _.get(_this6.i18n, 'clearReferralModal.partiallyClearReferralAction');
      options.primaryActionLoadingBar = clearanceType === 'clear' ? _.get(_this6.i18n, 'clearReferralModal.clearingReferralLoadingBar') : _.get(_this6.i18n, 'clearReferralModal.partiallyClearingReferralLoadingBar');
      options.showSecondaryAction = false;
      options.summary = null;
      function handleClose(result) {
        var _this7 = this;
        if (result.primaryAction) {
          var promise = actionsMediator.clearReferral(submissionId, result.comments, false /*doDecline*/).then(function () {
            if (clearanceType === 'partiallyClear') {
              _this7.referSubmission(submissionId);
            }
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
          return promise;
        }
      }
      modalUtil.showCommentsModal(submissionId, null /*comments*/, options, 'submission.wizard.commentsModal.clearReferralModal', uiPerformanceLoggerConstant.CLEAR_REFERRAL, handleClose.bind(_this6));
    });
  };
  this.rewriteSubmission = function (_submissionId) {
    var _this8 = this;
    var modalInstance = $uibModal.open({
      templateUrl: '/wizard/rewriteSubmission/rewriteSubmissionModal.tpl.html',
      controller: 'rewriteSubmissionModalController',
      backdrop: 'static',
      windowClass: 'rewriteSubmissionModal',
      resolve: {
        submissionId: function submissionId() {
          return _submissionId;
        }
      }
    });
    modalInstance.result.then(function (response) {
      var logAction = uiPerformanceLoggerConstant.REWRITE_SUBMISSION,
        message = "".concat(_submissionId, " - ").concat(response.copyOptions);
      function onSuccess(response) {
        submissionMediator.loadSubmission(response.id).then(function (submission) {
          loadingBarHandler.hideLoadingBar();
          submissionMediator.setCurrentSubmission(submission);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        });
      }
      function onError() {
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
      }
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
      loadingBarHandler.showLoadingBar(_this8.i18n.rewriteSubmission.loadingBar);
      actionsMediator.rewriteSubmission(_submissionId, response.reason, response.details, response.startDate, response.endDate, response.copyOptions).then(onSuccess, onError);
    });
  };
  this.resubmitSubmission = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.resubmitModal', uiPerformanceLoggerConstant.RESUBMIT_SUBMISSION, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      function onSuccess(response) {
        $state.go('submission.form', {
          submissionId: response.id
        });
      }
      var promise = actionsMediator.resubmitSubmission(submissionId).then(onSuccess);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.submitRenewal = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.submitRenewalModal', uiPerformanceLoggerConstant.SUBMIT_RENEWAL, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      function onSuccess(response) {
        $state.go('submission.form', {
          submissionId: response.id
        });
      }
      var promise = actionsMediator.submitRenewal(submissionId).then(onSuccess);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.submitNonRenewal = function (submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, 'notification.submitNonRenewal', null /*reason*/, 'submission.wizard.reasonModal.submitNonRenewalModal', false, uiPerformanceLoggerConstant.SUBMIT_NON_RENEWAL, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.submitNonRenewal(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.retractNonRenewal = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.retractNonRenewalModal', uiPerformanceLoggerConstant.RETRACT_NON_RENEWAL, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = actionsMediator.retractNonRenewal(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.flagForNonRenewal = function (submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, 'notification.flagForNonRenewal', null /*reason*/, 'submission.wizard.reasonModal.flagforNonRenewalModal', false, uiPerformanceLoggerConstant.FLAG_FOR_NON_RENEWAL, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.flagForNonRenewal(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.clearNonRenewalFlag = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*removed'notification.clearNonRenewalFlag'*/, 'submission.wizard.reasonModal.clearFlagforNonRenewalModal', uiPerformanceLoggerConstant.CLEAR_NON_RENEWAL_FLAG, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = actionsMediator.clearNonRenewalFlag(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.disableAutomation = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.disableAutomationModal', uiPerformanceLoggerConstant.DISABLE_AUTOMATION, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = actionsMediator.disableAutomation(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.openDetailedHistory = function (_submission5) {
    var _this9 = this;
    $uibModal.open({
      templateUrl: '/detailedHistory/detailedHistoryModal.tpl.html',
      controller: 'detailedHistoryModalController',
      backdrop: 'static',
      windowClass: 'detailedHistoryModal',
      resolve: {
        submission: function submission() {
          return _submission5;
        },
        options: function options() {
          return {
            title: _.get(_this9.i18n, 'detailedHistory.title'),
            isReadOnly: true
          };
        }
      }
    });
  };
  this.startPrequalification = function (submissionId, preDraft) {
    if (!preDraft) {
      loadingBarHandler.showLoadingBar('submission.prequalifyingStarting');
    }
    $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_START_LOADING);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = submissionPrequalificationMediator.startPrequalification(submissionId).then(function (submission) {
      $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_CHANGE_FORM_ID, submission);
    }).finally(function () {
      loadingBarHandler.hideLoadingBar();
      $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_STOP_LOADING);
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.cancelPrequalification = function (submissionId, preDraft) {
    if (!preDraft) {
      loadingBarHandler.showLoadingBar('submission.prequalifyingCancelled');
    }
    $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_START_LOADING);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = submissionPrequalificationMediator.cancelPrequalification(submissionId).then(function (submission) {
      $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_CHANGE_FORM_ID, submission);
    }).finally(function () {
      loadingBarHandler.hideLoadingBar();
      $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_STOP_LOADING);
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.submitPrequalification = function (submissionId) {
    loadingBarHandler.showLoadingBar('submission.creatingSubmission');
    $rootScope.$broadcast(coreConstant.event.START_MAKING_APPLICATION);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = submissionPrequalificationMediator.submitPrequalification(submissionId).then(function (submissionSummary) {
      $rootScope.$broadcast(coreConstant.event.CLOSE_SUBMISSION_VIEW, submissionId);
      if (submissionSummary.originator !== submissionConstant.originator.UPLOAD_ACORD_PDF) {
        var params = {
            submissionId: submissionId
          },
          stateName = 'submission.default',
          reload = true;
        $state.go(stateName, params);
      }
    }).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.checkPrequalification = function (submissionId, preDraft) {
    if (!preDraft) {
      loadingBarHandler.showLoadingBar('submission.prequalifyingSubmission');
    }
    $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_START_LOADING);
    $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
    var promise = submissionPrequalificationMediator.checkPrequalification(submissionId).then(function (submission) {
      $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_CHANGE_FORM_ID, submission);
    }).finally(function () {
      loadingBarHandler.hideLoadingBar();
      $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_STOP_LOADING);
    });
    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    return promise;
  };
  this.markExpired = function (submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.markExpiredModal', false, uiPerformanceLoggerConstant.MARK_EXPIRED, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.markExpired(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.markNonRenewed = function (submissionId) {
    umModalUtil.showReasonModal(submissionId, null /*quoteId*/, null /*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.markNonRenewedModal', false, uiPerformanceLoggerConstant.MARK_NON_RENEWED, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.markNonRenewed(submissionId, result.reason, result.details);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.markRenewed = function (submissionId) {
    modalUtil.showConfirmationModal(submissionId, null /*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.markRenewedModal', uiPerformanceLoggerConstant.MARK_RENEWED, /*hideLoadingBar*/false, handleClose);
    function handleClose() {
      var promise = actionsMediator.markRenewed(submissionId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
  this.declineReferral = function (submissionId) {
    var options = {
      showSecondaryAction: false,
      summary: null
    };
    modalUtil.showCommentsModal(submissionId, null /*comments*/, options, 'submission.wizard.commentsModal.declineReferralModal', uiPerformanceLoggerConstant.DECLINE_REFERRAL, handleClose);
    function handleClose(result) {
      var promise = actionsMediator.declineReferral(submissionId, result.comments);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    }
  };
};
SubmissionActionUtil.$inject = ["$rootScope", "$state", "$uibModal", "formViewerConstant", "submissionConstant", "actionsMediator", "submissionMediator", "coreMediator", "coreConstant", "declineMediator", "markAsLostMediator", "uiPerformanceLoggerConstant", "modalUtil", "umModalUtil", "loadingBarHandler", "submissionStateMediator", "submissionCopyOptions", "reportMediator", "proposalActionsMediator", "submissionPrequalificationMediator", "currentSubmissionModel", "agentQuoteStatus", "appTypeConfigurationModel"];
angular.module('gw-um-submission').service('submissionActionUtil', SubmissionActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 495 */
/***/ (function(module) {

module.exports = JSON.parse("{\"reviewTitle\":\"Pending Changes\",\"reviewSubmitTitle\":\"Submit Pending Changes\",\"submitChanges\":\"Submit Changes\",\"submitChangesLoadingBarMessage\":\"Submitting Changes...\",\"reviewDiscardTitle\":\"Discard Pending Changes\",\"discardChanges\":\"Discard Changes\",\"discardChangesLoadingBarMessage\":\"Discarding Changes...\",\"reviewAcknowledgeTitle\":\"Acknowledge Changes\",\"acknowledgeChanges\":\"Acknowledge Changes\",\"submit\":{\"confirmActionButtonLabel\":\"Yes\",\"cancelActionButtonLabel\":\"No\"},\"checkClearance\":{\"clear\":{\"summary\":\"At this time, no matching submission has been found with the application data entered.\",\"title\":\"Clear\"},\"notClear\":{\"summary\":\"A submission with matching characteristics has been found in our system. Submittal may result in declination.\",\"title\":\"Not Clear\"}},\"confirmActionButtonLabel\":\"Yes\",\"cancelActionButtonLabel\":\"No\",\"detailedHistory\":{\"title\":\"Detailed History\"},\"clearReferralModal\":{\"cancel\":\"Cancel\",\"clearingReferralLoadingBar\":\"Clearing Referral...\",\"clearReferralAction\":\"Clear\",\"partiallyClearingReferralLoadingBar\":\"Partially Clearing Referral...\",\"partiallyClearReferralAction\":\"Partially Clear\",\"summary\":null,\"title\":\"Clear Referral\"},\"copySubmission\":{\"loadingBar\":\"Copying Submission...\"},\"rewriteSubmission\":{\"loadingBar\":\"Rewriting Submission...\"}}");

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

var path = '/wizard/addDocumentAction/addDocumentActionModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    class=\"addDocumentActionModal\">\n\n    <!--Content-->\n    <div>\n        <div>{{ i18n.submissionSummary }}</div>\n\n        <div>\n            <ui-select ng-model=\"viewModel.selectedAttachment\"\n                       theme=\"bootstrap\"\n                       close-on-select=\"true\"\n                       class=\"classicDropdown\">\n\n                <ui-select-match placeholder=\"{{viewModel.placeholderText}}\" allow-clear=\"true\">\n                    <span ng-bind=\"$select.selected.name\"></span>\n                </ui-select-match>\n\n                <ui-select-choices\n                    repeat=\"item in (viewModel.availableAttachments | filter: {name: $select.search}) track by item.id\">\n                    <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                </ui-select-choices>\n\n            </ui-select>\n        </div>\n\n        <div class=\"modal-body-seperator\">\n            <span class=\"label\">{{ i18n.or }}</span>\n        </div>\n\n        <div class=\"modal-body-section\">\n            <a class=\"btn btn-default btn-outline btn-thin\"\n               ng-click=\"showAddNewAttachmentModal()\">{{ i18n.addNewFile }}</a>\n        </div>\n    </div>\n</base-modal>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(499);

/*@ngInject*/
var AddDocumentActionModalController = function AddDocumentActionModalController($rootScope, $scope, attachments, collaborationMediator, modalUtil, coreConstant) {
  $scope.i18n = locale;
  $scope.viewModel = {
    availableAttachments: attachments,
    title: _.get($scope.i18n, 'title'),
    cancelButton: _.get($scope.i18n, 'cancel'),
    okButton: _.get($scope.i18n, 'addDocument'),
    selectedAttachment: null,
    placeholderText: _.get($scope.i18n, 'placeholder')
  };
  $scope.canEnableConfirmButton = function () {
    return $scope.viewModel.selectedAttachment;
  };
  $scope.showAddNewAttachmentModal = function () {
    modalUtil.showNewAttachmentModal().then(function (data) {
      $scope.$close(data);
    });
  };
  $scope.onConfirm = function () {
    $scope.$close($scope.viewModel.selectedAttachment);
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
AddDocumentActionModalController.$inject = ["$rootScope", "$scope", "attachments", "collaborationMediator", "modalUtil", "coreConstant"];
angular.module('gw-um-submission').controller('addDocumentActionModalController', AddDocumentActionModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 499 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Select document\",\"cancel\":\"Cancel\",\"addDocument\":\"Add Document\",\"placeholder\":\"Select a document\",\"submissionSummary\":\"Select an existing document to create a new section:\",\"addNewFile\":\"Upload a document to create a new section\",\"or\":\"or\"}");

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

var path = '/wizard/breadcrumbs/breadcrumbs.tpl.html';
var html = "<div class=\"wizardBreadcrumbs\">\n\n    <div class=\"wizardProgressStatus\"\n         ng-click=\"onClickFormName()\">\n        <h2 class=\"wizardProgressLabel\">{{progressLabel}}</h2>\n    </div>\n\n    <ul class=\"wizardSteps\"\n        ng-if=\"breadcrumbsViewModel.items.length > 0 && !breadcrumbsViewModel.loading\"\n        ng-class=\"{'narrow':breadcrumbsViewModel.isNarrow}\">\n        <li class=\"step\"\n            ng-repeat=\"item in breadcrumbsViewModel.items\"\n            ng-class=\"{ 'completed': isItemCompleted(item), 'in-progress': isItemInProgress(item), 'early-end': isItemEarlyEnd(item)}\">\n      <span class=\"stepContent\">\n        <span class=\"circle\"\n              uib-tooltip=\"{{item.name}}\"\n              tooltip-append-to-body=\"true\"\n              tooltip-enable=\"{{breadcrumbsViewModel.isNarrow}}\">\n            <span class=\"glyphicon glyphicon-option-horizontal\" ng-if=\"isItemInProgress(item)\"></span>\n            <span class=\"glyphicon glyphicon-ok\" ng-if=\"isItemCompleted(item)\"></span>\n            <span class=\"glyphicon glyphicon-remove\" ng-if=\"isItemEarlyEnd(item)\"></span>\n        </span>\n        <span class=\"stepLabel {{ item.stepCssSelector }}\"\n              ng-class=\"{ 'keepLabel': breadcrumbsViewModel.lastStepCompleted === item.name}\">{{item.name}}</span>\n      </span>\n        </li>\n    </ul>\n    <div class=\"loading\" ng-if=\"breadcrumbsViewModel.loading\">\n        <div class=\"icon-spinner\"></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(503);

/*@ngInject*/
var WizardBreadcrumbsController = function WizardBreadcrumbsController($scope, $stateParams, submissionConstant, breadcrumbsMediator, formViewerConstant, coreConstant, formatUtil) {
  var cachedPromise = null,
    recall = false;
  $scope.i18n = locale;
  $scope.breadcrumbsViewModel = {
    items: [],
    isNarrow: false,
    lastStepCompleted: null,
    loading: false
  };
  var _loadBreadcrumbs = function loadBreadcrumbs() {
    // if (cachedPromise) {
    //     recall = true;
    //     return;
    // }

    var promise;
    if ($scope.quoteId) {
      promise = breadcrumbsMediator.loadQuoteBreadcrumbs($scope.quoteId);
    } else if ($scope.reportId) {
      promise = breadcrumbsMediator.loadReportBreadcrumbs($scope.reportId);
    } else if ($scope.policyIssuanceId) {
      promise = breadcrumbsMediator.loadPolicyIssuanceBreadcrumbs($scope.policyIssuanceId);
    } else if ($scope.proposalId) {
      promise = breadcrumbsMediator.loadProposalBreadcrumbs($scope.proposalId);
    } else if ($scope.policyCancellationId) {
      promise = breadcrumbsMediator.loadPolicyCancellationBreadcrumbs($scope.policyCancellationId);
    } else if ($scope.endorsementId) {
      promise = breadcrumbsMediator.loadEndorsementBreadcrumbs($scope.endorsementId);
    } else if ($scope.policyRewriteId) {
      promise = breadcrumbsMediator.loadPolicyRewriteBreadcrumbs($scope.policyRewriteId);
    } else if ($scope.policyId) {
      promise = breadcrumbsMediator.loadPolicyBreadcrumbs($scope.policyId);
    } else {
      promise = breadcrumbsMediator.loadSubmissionBreadcrumbs($scope.submissionId);
    }
    promise.then(function (data) {
      $scope.breadcrumbsViewModel.items = _.map(_.cloneDeep(data), function (item) {
        if (item.translateName) {
          item.name = _.get($scope.i18n, item.name);
          item.stepCssSelector = formatUtil.formatAsSelector(item.name);
        }
        if ($scope.isItemCompleted(item) || $scope.isItemInProgress(item)) {
          $scope.breadcrumbsViewModel.lastStepCompleted = item.name;
        }
        return item;
      });
    }).finally(function () {
      $scope.breadcrumbsViewModel.loading = false;
      if (recall) {
        cachedPromise = null;
        recall = false;
        _loadBreadcrumbs();
      }
    });
  };
  var reloadBreadcrumbs = function reloadBreadcrumbs() {
    $scope.breadcrumbsViewModel.loading = true;
    $scope.breadcrumbsViewModel.items = [];
    _loadBreadcrumbs();
  };
  var handleScopeChange = function handleScopeChange(newValue, oldValue) {
    if (_.isNil(newValue) && _.isNil(oldValue)) {
      return;
    }
    reloadBreadcrumbs();
  };
  $scope.isItemCompleted = function (item) {
    return item.breadCrumbStatus === submissionConstant.breadcrumbsStatus.COMPLETE && !item.earlyEnd;
  };
  $scope.isItemInProgress = function (item) {
    return item.breadCrumbStatus === submissionConstant.breadcrumbsStatus.IN_PROGRESS;
  };
  $scope.isItemEarlyEnd = function (item) {
    return item.earlyEnd && item.breadCrumbStatus !== submissionConstant.breadcrumbsStatus.IN_PROGRESS;
  };
  $scope.$on(submissionConstant.event.REFRESH_BREADCRUMBS, function () {
    _loadBreadcrumbs();
  });
  $scope.$on(submissionConstant.event.RELOAD_SUBMISSION, function () {
    _loadBreadcrumbs();
  });
  $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
    if (parseInt($stateParams.submissionId) === submission.id) {
      _loadBreadcrumbs();
    }
  });
  $scope.$on(coreConstant.event.REFRESH_QUOTE, function (event, submissionId) {
    if (parseInt($stateParams.submissionId) === submissionId) {
      _loadBreadcrumbs();
    }
  });
  $scope.onClickFormName = function () {
    $scope.$emit(submissionConstant.event.TOGGLE_NAVIGATION_MENU);
  };
  $scope.$watch('submissionId', handleScopeChange);
  $scope.$watch('quoteId', handleScopeChange);
  $scope.$watch('reportId', handleScopeChange);
  $scope.$watch('policyIssuanceId', handleScopeChange);
  $scope.$watch('proposalId', handleScopeChange);
  $scope.$watch('policyCancellationId', handleScopeChange);
  $scope.$watch('endorsementId', handleScopeChange);
  $scope.$watch('policyId', handleScopeChange);
  $scope.$watch('policyRewriteId', handleScopeChange);
};
WizardBreadcrumbsController.$inject = ["$scope", "$stateParams", "submissionConstant", "breadcrumbsMediator", "formViewerConstant", "coreConstant", "formatUtil"];
angular.module('gw-um-submission').controller('wizardBreadcrumbsController', WizardBreadcrumbsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 503 */
/***/ (function(module) {

module.exports = JSON.parse("{\"submission\":{\"breadCrumbs\":{\"bind\":\"Bind\",\"cancelled\":\"Cancelled\",\"clear\":\"Clear\",\"create\":\"Create\",\"declined\":\"Declined\",\"expired\":\"Expired\",\"issue\":\"Issue\",\"lost\":\"Lost\",\"nonRenewed\":\"Non-Renewed\",\"prequalify\":\"Prequalify\",\"quote\":\"Quote\",\"rejected\":\"Rejected\",\"renewed\":\"Renewed\",\"submit\":\"Submit\"}},\"endorsement\":{\"breadCrumbs\":{\"create\":\"Create\",\"decline\":\"Decline\",\"issue\":\"Issue\",\"price\":\"Price\",\"rate\":\"Rate\",\"submit\":\"Submit\"}},\"externalReport\":{\"breadCrumbs\":{\"edit\":\"Edit\",\"view\":\"View\"}},\"policy\":{\"breadCrumbs\":{\"bound\":\"Bound\",\"beginIssuance\":\"Begin Issuance\",\"pendingIssuance\":\"Pending Issuance\",\"issued\":\"Issued\",\"cancelled\":\"Cancelled\",\"rewritten\":\"Rewritten\"}},\"policyCancellation\":{\"breadCrumbs\":{\"cancellationPending\":\"Pending\",\"cancellationRequested\":\"Requested\",\"cancellationRescind\":\"Rescinded\",\"cancellationRetract\":\"Retracted\",\"cancelled\":\"Cancelled\",\"create\":\"Create\"}},\"policyRewrite\":{\"breadCrumbs\":{\"create\":\"Create\",\"issue\":\"Issue\",\"price\":\"Price\",\"rate\":\"Rate\",\"submit\":\"Submit\"}},\"policyIssuance\":{\"breadCrumbs\":{\"bound\":\"Bound\",\"issued\":\"Issued\",\"pendingIssuance\":\"Pending Issuance\"}},\"proposal\":{\"breadCrumbs\":{\"bound\":\"Bind\",\"create\":\"Create\",\"quote\":\"Quote\"}},\"quote\":{\"breadCrumbs\":{\"bind\":\"Bind\",\"create\":\"Create\",\"declined\":\"Declined\",\"price\":\"Price\",\"quote\":\"Quote\",\"rate\":\"Rate\",\"replaced\":\"Replaced\",\"requestBind\":\"Request Bind\",\"withdrawn\":\"Withdrawn\"}}}");

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var WizardBreadcrumbsDirective = function WizardBreadcrumbsDirective(submissionConstant, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var $window = $(window),
      handleResize = function handleResize() {
        var maxSize = $scope.breadcrumbsViewModel.items.length * 66,
          stepsContainer = $elm.find('.wizardSteps');
        if (stepsContainer.width() < maxSize) {
          stepsContainer.addClass('narrow');
          $scope.breadcrumbsViewModel.isNarrow = true;
        } else {
          stepsContainer.removeClass('narrow');
          $scope.breadcrumbsViewModel.isNarrow = false;
        }
      };
    $scope.$on(coreConstant.event.ACTION_BUTTONS_PROCESSING_COMPLETED, handleResize);
    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, handleResize);
    $window.on('resize.breadcrumbs', _.debounce(handleResize, 200));
    $scope.$on('$destroy', function () {
      $window.off('resize.breadcrumbs', handleResize);
    });
    $scope.$watch('breadcrumbsViewModel.items', handleResize);
  };
  return {
    restrict: 'E',
    replace: true,
    controller: 'wizardBreadcrumbsController',
    scope: {
      submissionId: '<',
      quoteId: '<',
      reportId: '<',
      policyIssuanceId: '<',
      proposalId: '<',
      policyCancellationId: '<',
      endorsementId: '<',
      policyId: '<',
      policyRewriteId: '<',
      progressLabel: '<'
    },
    link: linkFunction,
    templateUrl: '/wizard/breadcrumbs/breadcrumbs.tpl.html'
  };
};
WizardBreadcrumbsDirective.$inject = ["submissionConstant", "coreConstant"];
angular.module('gw-um-submission').directive('wizardBreadcrumbs', WizardBreadcrumbsDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 505 */
/***/ (function(module, exports) {

/*@ngInject*/
var BreadcrumbsMediator = function BreadcrumbsMediator(breadcrumbsRepository) {
  this.loadSubmissionBreadcrumbs = function (submissionId) {
    return breadcrumbsRepository.loadSubmissionBreadcrumbs(submissionId);
  };
  this.loadQuoteBreadcrumbs = function (quoteId) {
    return breadcrumbsRepository.loadQuoteBreadcrumbs(quoteId);
  };
  this.loadReportBreadcrumbs = function (reportId) {
    return breadcrumbsRepository.loadReportBreadcrumbs(reportId);
  };
  this.loadPolicyIssuanceBreadcrumbs = function (policyIssuanceId) {
    return breadcrumbsRepository.loadPolicyIssuanceBreadcrumbs(policyIssuanceId);
  };
  this.loadProposalBreadcrumbs = function (proposalId) {
    return breadcrumbsRepository.loadProposalBreadcrumbs(proposalId);
  };
  this.loadPolicyCancellationBreadcrumbs = function (policyCancellationId) {
    return breadcrumbsRepository.loadPolicyCancellationBreadcrumbs(policyCancellationId);
  };
  this.loadEndorsementBreadcrumbs = function (endorsementId) {
    return breadcrumbsRepository.loadEndorsementBreadcrumbs(endorsementId);
  };
  this.loadPolicyBreadcrumbs = function (policyId) {
    return breadcrumbsRepository.loadPolicyBreadcrumbs(policyId);
  };
  this.loadPolicyRewriteBreadcrumbs = function (policyRewriteId) {
    return breadcrumbsRepository.loadPolicyRewriteBreadcrumbs(policyRewriteId);
  };
};
BreadcrumbsMediator.$inject = ["breadcrumbsRepository"];
angular.module('gw-um-submission').service('breadcrumbsMediator', BreadcrumbsMediator);

/***/ }),
/* 506 */
/***/ (function(module, exports) {

/*@ngInject*/
var BreadcrumbsRepository = function BreadcrumbsRepository(baseSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadSubmissionBreadcrumbs = function (submissionId) {
    var url = '/rest/Submission/' + submissionId + '/BreadCrumbs',
      cacheKey = 'submissionBreadcrumbs:' + submissionId;
    return this.get(cacheKey, url);
  };
  this.loadReportBreadcrumbs = function (externalReportId) {
    var url = '/rest/ExternalReport/' + externalReportId + '/BreadCrumbs',
      cacheKey = 'reportBreadcrumbs:' + externalReportId;
    return this.get(cacheKey, url);
  };
  this.loadQuoteBreadcrumbs = function (quoteId) {
    var url = '/rest/Quote/' + quoteId + '/breadCrumbs',
      cacheKey = 'quoteBreadcrumbs:' + quoteId;
    return this.get(cacheKey, url);
  };
  this.loadProposalBreadcrumbs = function (proposalId) {
    var url = '/rest/Proposal/' + proposalId + '/breadCrumbs',
      cacheKey = 'proposalBreadcrumbs:' + proposalId;
    return this.get(cacheKey, url);
  };
  this.loadPolicyIssuanceBreadcrumbs = function (policyIssuanceId) {
    var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/breadCrumbs',
      cacheKey = 'policyIssuanceBreadcrumbs:' + policyIssuanceId;
    return this.get(cacheKey, url);
  };
  this.loadPolicyCancellationBreadcrumbs = function (policyCancellationId) {
    var url = '/rest/PolicyCancellation/' + policyCancellationId + '/breadCrumbs',
      cacheKey = 'policyCancellationBreadcrumbs:' + policyCancellationId;
    return this.get(cacheKey, url);
  };
  this.loadPolicyBreadcrumbs = function (policyId) {
    var url = '/rest/Policy/' + policyId + '/breadCrumbs',
      cacheKey = 'policyBreadcrumbs:' + policyId;
    return this.get(cacheKey, url);
  };
  this.loadEndorsementBreadcrumbs = function (endorsementId) {
    var url = '/rest/Endorsement/' + endorsementId + '/breadCrumbs',
      cacheKey = 'endorsementBreadcrumbs:' + endorsementId;
    return this.get(cacheKey, url);
  };
  this.loadPolicyRewriteBreadcrumbs = function (policyRewriteId) {
    var url = '/rest/PolicyRewrite/' + policyRewriteId + '/breadCrumbs',
      cacheKey = 'policyRewriteBreadcrumbs:' + policyRewriteId;
    return this.get(cacheKey, url);
  };
};
BreadcrumbsRepository.$inject = ["baseSharedPromiseRepository"];
angular.module('gw-um-submission').service('breadcrumbsRepository', BreadcrumbsRepository);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

var path = '/wizard/changeProducts/changeProductsModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"okButton\"\n    cancel=\"cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"changeProductsModal\">\n        <div class=\"drawer\">\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <ui-required-indicator class=\"requiredIndicator\"\n                        value=\"{{viewModel.selectedProducts.length > 0 ? 'true' : ''}}\">\n                    </ui-required-indicator>\n                    <label class=\"productHeader\">{{ i18n.summary }}</label>\n                </div>\n            </div>\n\n            <div class=\"drawerRow\" ng-repeat=\"product in viewModel.authorizedProducts\">\n                <div class=\"drawerCol\">\n                    <label>\n                        <input type=\"checkbox\"\n                            name=\"product\"\n                            ng-change=\"handleClick(product)\"\n                            ng-checked=\"isChecked(product.value)\"\n                            ng-model=\"product.checked\" >\n                            {{product.name}}\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(510);

/*@ngInject*/
var ChangeProductsModalController = function ChangeProductsModalController($rootScope, $scope, options, coreMediator, preferenceModel, coreConstant) {
  $scope.i18n = locale;
  $scope.title = _.get($scope.i18n, 'title');
  $scope.cancelButton = _.get($scope.i18n, 'cancel');
  $scope.okButton = _.get($scope.i18n, 'createQuote');
  $scope.viewModel = {
    selectedProducts: _.split(options.selectedProducts, ','),
    savedSelectedProducts: _.split(options.selectedProducts, ',')
  };
  $scope.isChecked = function (name) {
    return _.indexOf($scope.viewModel.selectedProducts, name) === -1 ? false : true;
  };
  $scope.canEnableConfirmButton = function () {
    return !_.isEqual($scope.viewModel.selectedProducts.sort(), $scope.viewModel.savedSelectedProducts.sort()) && $scope.viewModel.selectedProducts.length !== 0;
  };
  function isProductRemoved() {
    var isProductRemoved = false;
    _.each($scope.viewModel.savedSelectedProducts, function (product) {
      if (!$scope.viewModel.selectedProducts.includes(product)) {
        isProductRemoved = true;
      }
    });
    return isProductRemoved;
  }
  ;
  $scope.handleClick = function (changeProduct) {
    if (changeProduct.checked) {
      $scope.viewModel.selectedProducts.push(changeProduct.value);
    } else {
      _.pull($scope.viewModel.selectedProducts, changeProduct.value);
    }
  };
  $scope.onConfirm = function () {
    $scope.$close({
      productShortNames: _.join($scope.viewModel.selectedProducts, ','),
      isProductRemoved: isProductRemoved()
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  function getAuthorizedProducts() {
    var dynamicDataSetParams = {
      name: 'User Authorized Products',
      submissionUri: 'com.firstbest.underwriting.submission.Submission:' + options.submissionId
    };
    coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(function (response) {
      _.each(response, function (product) {
        product.checked = $scope.isChecked(product.value);
      });
      $scope.viewModel.authorizedProducts = response;
    });
  }
  getAuthorizedProducts();
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ChangeProductsModalController.$inject = ["$rootScope", "$scope", "options", "coreMediator", "preferenceModel", "coreConstant"];
angular.module('gw-um-submission').controller('changeProductsModalController', ChangeProductsModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 510 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Change Products\",\"cancel\":\"Cancel\",\"createQuote\":\"OK\",\"summary\":\"Products & Coverages\"}");

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

var path = '/wizard/changeAgency/changeAgencyModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"changeAgencyModalContent\" ui-browser-detection>\n\n        <div class=\"agencyRow\">\n            <div class=\"agencyLabel\">\n                <div class=\"requiredIcon reasonRequired\"\n                     ng-if=\"!showCheckMarkForAgencyDropDown()\"></div>\n                <div class=\"glyphicon glyphicon-ok validIcon reasonValid\"\n                     ng-if=\"showCheckMarkForAgencyDropDown()\"></div>\n                <span>{{ i18n.agencyLabel }}</span>\n            </div>\n\n        <um-dropdown class-name=\"agencyList\"\n                     class=\"agencyList\"\n                     required=\"'true'\"\n                     option-list=\"viewModel.agencyList\"\n                     selected-value=\"getAgencyLabel()\"\n                     on-change=\"onSelectAgency(selectedOption)\">\n        </um-dropdown>\n\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(514);

/*@ngInject*/
var ChangeAgencyModalController = function ChangeAgencyModalController($rootScope, $scope, coreConstant, coreMediator, loadingBarHandler, submissionMediator, options) {
  $scope.i18n = locale;
  $scope.viewModel = {
    title: options.title ? options.title : _.get($scope.i18n, 'title'),
    cancelButton: options.cancelButtonLabel ? options.cancelButtonLabel : _.get($scope.i18n, 'cancel'),
    okButton: options.confirmActionButtonLabel ? options.confirmActionButtonLabel : _.get($scope.i18n, 'confirm'),
    loadingBar: options.processingIndicatorText ? options.processingIndicatorText : _.get($scope.i18n, 'loadingBar'),
    agencyList: [],
    originalAgencyId: String(submissionMediator.getCurrentSubmission().agencyId)
  };
  $scope.dataSetParameters = {
    name: _.get($scope.i18n, 'agencyDataSetName')
  };
  $scope.onConfirm = function () {
    var submissionUpdatePropertiesMap = {
      agencyId: $scope.viewModel.selectedAgency.value
    };
    loadingBarHandler.showLoadingBar($scope.viewModel.loadingBar);
    submissionMediator.updateSubmission(submissionMediator.getCurrentSubmission().id, submissionUpdatePropertiesMap).then(function () {
      loadingBarHandler.hideLoadingBar();
    });
    $scope.$close();
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.onSelectAgency = function (selectedAgency) {
    $scope.viewModel.selectedAgency = selectedAgency;
  };
  $scope.canEnableConfirmButton = function () {
    return $scope.showCheckMarkForAgencyDropDown();
  };
  $scope.showCheckMarkForAgencyDropDown = function () {
    return isValidAgencySelected();
  };
  function isValidAgencySelected() {
    return !!$scope.viewModel.selectedAgency && $scope.viewModel.selectedAgency.value !== $scope.viewModel.originalAgencyId;
  }
  coreMediator.getDynamicDataSetItems($scope.dataSetParameters).then(function (result) {
    $scope.viewModel.agencyList = result;
    initializeAgency();
  });
  function initializeAgency() {
    _.forEach($scope.viewModel.agencyList, function (agency) {
      if (agency.value === $scope.viewModel.originalAgencyId) {
        $scope.viewModel.selectedAgency = agency;
        return false;
      }
    });
  }
  $scope.getAgencyLabel = function () {
    var selectedAgency = $scope.viewModel.selectedAgency;
    return selectedAgency ? selectedAgency.name : _.get($scope.i18n, 'defaultPrimaryPrompt');
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ChangeAgencyModalController.$inject = ["$rootScope", "$scope", "coreConstant", "coreMediator", "loadingBarHandler", "submissionMediator", "options"];
angular.module('gw-um-submission').controller('changeAgencyModalController', ChangeAgencyModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 514 */
/***/ (function(module) {

module.exports = JSON.parse("{\"agencyLabel\":\"Agency:\",\"agencyDataSetName\":\"Hierarchical Agency List\"}");

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

var path = '/wizard/generateRatingAttachments/generateRatingAttachmentsModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"generateRatingAttachmentsModalContent modal-body\">\n\n        <div class=\"summary\">{{ ::i18n.summary }}</div>\n\n        <div>\n            <label>\n                <input class=\"allRatingAttachment\"\n                       type=\"checkbox\"\n                       ng-change=\"onAllCheckboxClick()\"\n                       ng-model=\"viewModel.allCheckboxSelected\">\n                <span class=\"ratingAttachment\">{{ ::i18n.allCheckbox }}</span>\n            </label>\n        </div>\n\n        <div class=\"ratingAttachmentGroups\">\n\n            <div class=\"ratingAttachmentGroup\"\n                 ng-repeat=\"ratingAttachmentGroup in viewModel.ratingAttachmentGroups\">\n\n                <span class=\"ratingAttachmentGroupLabel\">{{ ::ratingAttachmentGroup.name }}:</span>\n\n                <div ng-repeat=\"ratingAttachment in ratingAttachmentGroup.ratingAttachments\">\n\n                    <label class=\"ratingAttachment\">\n\n                        <input class=\"ratingAttachment\"\n                               type=\"checkbox\"\n                               ng-change=\"onCheckboxClick(ratingAttachment.value)\"\n                               ng-model=\"ratingAttachment.checked\">\n\n                        <span class=\"ratingAttachmentLabel\">{{ ::ratingAttachment.name }} ({{ attachment.byteCountToDisplaySize }})</span>\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(518);

/*@ngInject*/
var GenerateRatingAttachmentsModalController = function GenerateRatingAttachmentsModalController($rootScope, $scope, options, coreConstant) {
  $scope.i18n = locale;
  $scope.viewModel = {
    ratingAttachmentGroups: options.ratingAttachmentGroups,
    selectedRatingAttachments: [],
    allCheckboxSelected: false,
    title: _.get($scope.i18n, 'title'),
    cancelButton: _.get($scope.i18n, 'cancel'),
    okButton: _.get($scope.i18n, 'confirm')
  };
  $scope.onAllCheckboxClick = function () {
    $scope.viewModel.selectedRatingAttachments = [];
    if ($scope.viewModel.allCheckboxSelected) {
      _.each($scope.viewModel.ratingAttachmentGroups, function (ratingAttachmentGroup) {
        _.each(ratingAttachmentGroup.ratingAttachments, function (ratingAttachment) {
          ratingAttachment.checked = true;
          $scope.viewModel.selectedRatingAttachments.push(ratingAttachment.value);
        });
      });
    } else {
      _.each($scope.viewModel.ratingAttachmentGroups, function (ratingAttachmentGroup) {
        _.each(ratingAttachmentGroup.ratingAttachments, function (ratingAttachment) {
          ratingAttachment.checked = false;
        });
      });
    }
  };
  $scope.onCheckboxClick = function (ratingAttachmentValue) {
    if (_.includes($scope.viewModel.selectedRatingAttachments, ratingAttachmentValue)) {
      _.pull($scope.viewModel.selectedRatingAttachments, ratingAttachmentValue);
    } else {
      $scope.viewModel.selectedRatingAttachments.push(ratingAttachmentValue);
    }
  };
  $scope.canEnableConfirmButton = function () {
    return !(_.size($scope.viewModel.selectedRatingAttachments) === 0);
  };
  $scope.onConfirm = function () {
    $scope.$close({
      selectedRatingAttachments: $scope.viewModel.selectedRatingAttachments
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
GenerateRatingAttachmentsModalController.$inject = ["$rootScope", "$scope", "options", "coreConstant"];
angular.module('gw-um-submission').controller('generateRatingAttachmentsModalController', GenerateRatingAttachmentsModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 518 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Generate Rating Attachments\",\"cancel\":\"Cancel\",\"confirm\":\"Generate\",\"allCheckbox\":\"All\",\"summary\":\"Please select which rating attachments you would like to generate \"}");

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

var path = '/wizard/proposalQuotableProduct/proposalQuotableProductModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"okButton\"\n    cancel=\"cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div>\n        <div class=\"drawer\">\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <div class=\"requiredIcon\"\n                         ng-if=\"!showCheckMark()\"></div>\n                    <div class=\"glyphicon glyphicon-ok validIcon\"\n                         ng-if=\"showCheckMark()\"></div>\n                    <label>{{ i18n.quoteSummary }}</label>\n                </div>\n            </div>\n\n            <div uib-dropdown dropdown-append-to-body=\"true\">\n                <button uib-dropdown-toggle>\n                      <span class=\"dropdownInnerWrapper\">\n                        <span class=\"dropdownLabel\">{{selectedProduct}}</span>\n                        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                      </span>\n                </button>\n\n                <div class=\"scrollable-menu quote-menu\"\n                     uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n                    <div ng-repeat=\"(key, value) in quotableProducts\">\n                        <div class=\"drawerRow\"\n                             ng-if=\"key !== 'null'\">\n                            <div class=\"drawerCol\">\n                                <label class=\"groupHeading\">\n                                    {{ key }}\n                                </label>\n                            </div>\n                        </div>\n\n                        <div class=\"drawerRow groupItem\"\n                             ng-repeat=\"item in value\"\n                             ng-click=\"handleClick(item)\">\n                            <div class=\"drawerCol\">\n                                <label>\n                                    {{ item.name }}\n                                </label>\n                            </div>\n                        </div>\n\n                    </div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</base-modal>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(522);

/*@ngInject*/
var ProposalQuotableProductController = function ProposalQuotableProductController($rootScope, $scope, options, coreConstant) {
  $scope.i18n = locale;
  $scope.selectedProduct = _.get($scope.i18n, 'prompt');
  $scope.cancelButton = _.get($scope.i18n, 'cancel');
  $scope.okButton = _.get($scope.i18n, 'createQuote');
  $scope.title = _.get($scope.i18n, 'title');
  $scope.selectedQuotableProduct = null;
  $scope.quotableProducts = _.groupBy(options.quotableProducts, 'grouping');
  $scope.showCheckMark = function () {
    return !_.isNil($scope.selectedQuotableProductId);
  };
  $scope.canEnableConfirmButton = function () {
    return $scope.selectedQuotableProductId !== null;
  };
  $scope.onConfirm = function () {
    $scope.$close({
      submissionId: _.split($scope.selectedQuotableProduct.value, '::')[0],
      selectedQuotableProductId: $scope.selectedQuotableProductId
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.handleClick = function (quotableProduct) {
    $scope.selectedQuotableProduct = quotableProduct;
    $scope.selectedProduct = quotableProduct.name;
    $scope.selectedQuotableProductId = _.split($scope.selectedQuotableProduct.value, '::')[1];
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ProposalQuotableProductController.$inject = ["$rootScope", "$scope", "options", "coreConstant"];
angular.module('gw-um-submission').controller('proposalQuotableProductController', ProposalQuotableProductController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 522 */
/***/ (function(module) {

module.exports = JSON.parse("{\"prompt\":\"Please Choose\",\"cancel\":\"Cancel\",\"createQuote\":\"Create Quote\",\"title\":\"Select Product\",\"quoteSummary\":\"Select any product for this quote:\"}");

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

var path = '/wizard/quotableProductTemplates/quotableProductTemplatesModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div>\n        <div class=\"drawer\">\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <ui-required-indicator class=\"requiredIndicator\"\n                                           value=\"{{getRequiredIndicatorValue()}}\">\n                    </ui-required-indicator>\n                    <label ng-if=\"viewModel.isProposalAction === false\">{{ ::i18n.quoteSummary }}</label>\n                    <label ng-if=\"viewModel.isProposalAction === true\">{{ ::i18n.proposalSummary }}</label>\n                </div>\n            </div>\n\n            <div class=\"drawerRow\" ng-repeat=\"quotableProduct in viewModel.quotableProducts\">\n                <div class=\"drawerCol\">\n                    <label>\n                        <input class=\"productList\"\n                               type=\"{{viewModel.inputType}}\"\n                               name=\"quotableProduct\"\n                               ng-click=\"handleClick(quotableProduct)\"\n                               ng-value=\"$scope.viewModel.selectedQuotableProductId === quotableProduct.id\">\n                        {{quotableProduct.name}}\n                    </label>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</base-modal>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(526);

/*@ngInject*/
var QuotableProductTemplatesModalController = function QuotableProductTemplatesModalController($rootScope, $scope, options, coreConstant) {
  $scope.i18n = locale;
  $scope.viewModel = {
    quotableProducts: options.quotableProducts,
    selectedQuotableProductId: -1,
    selectedQuotableProductIds: [],
    isProposalAction: options.isProposalAction,
    inputType: options.isProposalAction ? 'checkbox' : 'radio',
    title: _.get($scope.i18n, 'title'),
    cancelButton: _.get($scope.i18n, 'cancel'),
    okButton: options.isProposalAction === true ? _.get($scope.i18n, 'createProposal') : _.get($scope.i18n, 'createQuote')
  };
  $scope.canEnableConfirmButton = function () {
    return !($scope.viewModel.isProposalAction === true ? $scope.viewModel.selectedQuotableProductIds.length === 0 : $scope.viewModel.selectedQuotableProductId === -1);
  };
  $scope.getRequiredIndicatorValue = function () {
    if ($scope.viewModel.isProposalAction) {
      return $scope.viewModel.selectedQuotableProductIds.length !== 0 ? 'true' : '';
    } else {
      return $scope.viewModel.selectedQuotableProductId !== -1 ? 'true' : '';
    }
  };
  $scope.handleClick = function (quotableProduct) {
    if ($scope.viewModel.isProposalAction) {
      if (_.indexOf($scope.viewModel.selectedQuotableProductIds, quotableProduct.id) === -1) {
        $scope.viewModel.selectedQuotableProductIds.push(quotableProduct.id);
      } else {
        _.pull($scope.viewModel.selectedQuotableProductIds, quotableProduct.id);
      }
    } else {
      $scope.viewModel.selectedQuotableProductId = quotableProduct.id;
    }
  };
  $scope.onConfirm = function () {
    $scope.$close({
      selectedQuotableProductId: $scope.viewModel.selectedQuotableProductId,
      selectedQuotableProductIds: $scope.viewModel.selectedQuotableProductIds
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
QuotableProductTemplatesModalController.$inject = ["$rootScope", "$scope", "options", "coreConstant"];
angular.module('gw-um-submission').controller('quotableProductTemplatesModalController', QuotableProductTemplatesModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 526 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Select Product\",\"cancel\":\"Cancel\",\"createProposal\":\"Create Proposal\",\"createQuote\":\"Create Quote\",\"proposalSummary\":\"Select any product for this proposal:\",\"quoteSummary\":\"Select any product for this quote:\"}");

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

var path = '/wizard/quoteSelection/quoteSelectionModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    class=\"modal-body-height-400\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"quoteSelectionContent\" ui-browser-detection>\n        <div class=\"header\">\n            <input class=\"checkboxHeader\"\n                   type=\"checkbox\"\n                   ng-change=\"onAllCheckboxClick($event)\"\n                   ng-model=\"viewModel.allSelected\">\n            <span class=\"quotesHeader\">{{::i18n.quotes}}</span>\n            <span class=\"statusHeader\">{{::i18n.status}}</span>\n        </div>\n        <div class=\"quoteRowsContainer\">\n            <div class=\"quoteRow\"\n                 ng-class=\"{disabled: (!quoteSummary.actionEnabled && !quoteSummary.incomplete)}\"\n                 ng-repeat=\"quoteSummary in viewModel.quoteSummaries track by $index\">\n                <input class=\"checkboxInput\"\n                       type=\"checkbox\"\n                       ng-model=\"quoteSummary.isSelected\"\n                       ng-disabled=\"::!quoteSummary.actionEnabled\"\n                       ng-change=\"onCheckboxClick()\"\n                       ng-class=\"{opaque: (!quoteSummary.actionEnabled && !quoteSummary.incomplete)}\">\n                <span class=\"quoteDescription\">{{::quoteSummary.summary}}</span>\n\n                <div class=\"step\"\n                     ng-class=\"{ 'completed': isItemCompleted(quoteSummary.breadcrumb), 'in-progress': isItemInProgress(quoteSummary.breadcrumb), 'early-end': isItemEarlyEnd(quoteSummary.breadcrumb)}\">\n                    <span class=\"stepContent\">\n                        <span class=\"circle\">\n                            <span class=\"glyphicon glyphicon-option-horizontal\"\n                                  ng-if=\"isItemInProgress(quoteSummary.breadcrumb)\"></span>\n                            <span class=\"glyphicon glyphicon-ok\" ng-if=\"isItemCompleted(quoteSummary.breadcrumb)\"></span>\n                            <span class=\"glyphicon glyphicon-remove\" ng-if=\"isItemEarlyEnd(quoteSummary.breadcrumb)\"></span>\n                        </span>\n                        <span class=\"stepLabel {{ quoteSummary.breadcrumb.stepCssSelector }}\">{{quoteSummary.breadcrumb.name}}</span>\n                    </span>\n                </div>\n\n                <span class=\"actionStatus ready\"\n                      ng-if=\"::quoteSummary.actionEnabled\">{{::i18n.ready}}</span>\n                <span class=\"actionStatus incomplete\"\n                      ng-if=\"::quoteSummary.incomplete\">{{::i18n.incomplete}}</span>\n            </div>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(530);

/*@ngInject*/
var QuoteSelectionModalController = function QuoteSelectionModalController($rootScope, $scope, $q, formatUtil, coreMediator, options, coreConstant, quoteActionsMediator, breadcrumbsMediator, submissionConstant, quoteStatus) {
  $scope.i18n = locale;
  $scope.viewModel = {
    title: _.get($scope.i18n, options.transition),
    cancelButton: _.get($scope.i18n, 'cancel'),
    okButton: _.get($scope.i18n, options.transition),
    quoteSummaries: [],
    isLoading: true,
    allSelected: true
  };
  function onInit() {
    _.each(options.quoteSummaries, function (quoteSummary) {
      var lastBreadCrumbCompleted = null;
      _.each(quoteSummary.breadcrumb, function (breadcrumb) {
        if ($scope.isItemCompleted(breadcrumb) || $scope.isItemInProgress(breadcrumb)) {
          if (breadcrumb.translateName) {
            breadcrumb.name = _.get($scope.i18n, breadcrumb.name);
            breadcrumb.stepCssSelector = formatUtil.formatAsSelector(breadcrumb.name);
          }
          if (quoteSummary.status === quoteStatus.VALID_RATING && breadcrumb.name === 'Rate') {
            breadcrumb.breadCrumbStatus = submissionConstant.breadcrumbsStatus.COMPLETE;
          }
          lastBreadCrumbCompleted = breadcrumb;
        }
      });
      quoteSummary.breadcrumb = lastBreadCrumbCompleted;
    });
    $scope.viewModel.quoteSummaries = options.quoteSummaries;
  }
  $scope.isItemCompleted = function (breadcrumb) {
    return breadcrumb.breadCrumbStatus === submissionConstant.breadcrumbsStatus.COMPLETE && !breadcrumb.earlyEnd;
  };
  $scope.isItemInProgress = function (breadcrumb) {
    return breadcrumb.breadCrumbStatus === submissionConstant.breadcrumbsStatus.IN_PROGRESS;
  };
  $scope.isItemEarlyEnd = function (breadcrumb) {
    return breadcrumb.earlyEnd && breadcrumb.breadCrumbStatus !== submissionConstant.breadcrumbsStatus.IN_PROGRESS;
  };
  $scope.onAllCheckboxClick = function ($event) {
    var selected = $event.target.checked;
    _.each($scope.viewModel.quoteSummaries, function (quoteSummary) {
      if (quoteSummary.actionEnabled) {
        quoteSummary.isSelected = selected;
      }
    });
  };
  $scope.onCheckboxClick = function () {
    var areAllSelected = true;
    _.each($scope.viewModel.quoteSummaries, function (quoteSummary) {
      if (quoteSummary.actionEnabled && !quoteSummary.isSelected) {
        areAllSelected = false;
      }
    });
    $scope.viewModel.allSelected = areAllSelected;
  };
  $scope.onConfirm = function () {
    var selectedQuoteSummaries = _.filter($scope.viewModel.quoteSummaries, function (quoteSummary) {
        return quoteSummary.isSelected;
      }),
      selectedQuoteIds = _.map(selectedQuoteSummaries, _.property('id'));
    $scope.$close({
      quoteIds: selectedQuoteIds
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.canEnableConfirmButton = function () {
    var isQuoteSummarySelected = false;
    _.each($scope.viewModel.quoteSummaries, function (quoteSummary) {
      if (quoteSummary.isSelected) {
        isQuoteSummarySelected = true;
      }
    });
    return isQuoteSummarySelected;
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  onInit();
};
QuoteSelectionModalController.$inject = ["$rootScope", "$scope", "$q", "formatUtil", "coreMediator", "options", "coreConstant", "quoteActionsMediator", "breadcrumbsMediator", "submissionConstant", "quoteStatus"];
angular.module('gw-um-submission').controller('quoteSelectionModalController', QuoteSelectionModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 530 */
/***/ (function(module) {

module.exports = JSON.parse("{\"cancel\":\"Cancel\",\"quotes\":\"Quotes\",\"status\":\"Status\",\"ready\":\"Ready\",\"incomplete\":\"Unavailable\",\"generate rating\":\"Get Rate\",\"start pricing\":\"Start Pricing\",\"start quote\":\"Convert to Quote\",\"quote\":{\"breadCrumbs\":{\"bind\":\"Bind\",\"create\":\"Create\",\"declined\":\"Declined\",\"price\":\"Price\",\"quote\":\"Quote\",\"rate\":\"Rate\",\"replaced\":\"Replaced\",\"requestBind\":\"Request Bind\",\"withdrawn\":\"Withdrawn\"}}}");

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

var path = '/wizard/reason/reasonModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    class=\"modal-body-height-400\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"reasonModalContent\" ui-browser-detection>\n\n        <div class=\"summary\" ng-if=\"viewModel.summary\"\n                       ng-bind-html=\"viewModel.summary\"></div>\n\n            <div class=\"reasonRow\">\n                <div class=\"reasonLabel\">\n                    <div class=\"requiredIcon reasonRequired\"\n                         ng-if=\"!viewModel.primaryReasonIsOptional && !showCheckMarkForPrimaryReason()\"></div>\n                    <div class=\"glyphicon glyphicon-ok validIcon reasonValid\"\n                         ng-if=\"!viewModel.primaryReasonIsOptional && showCheckMarkForPrimaryReason()\"></div>\n                    <span>{{ i18n.reason }}</span>\n                </div>\n\n            <um-dropdown class-name=\"primaryReasonList\"\n                         class=\"reasonList primaryReasonList\"\n                         required=\"'true'\"\n                         option-list=\"viewModel.primaryReasonList\"\n                         selected-value=\"getPrimaryReasonLabel()\"\n                         on-change=\"onSelectPrimaryReason(selectedOption)\">\n            </um-dropdown>\n\n\n            <input type=\"text\"\n                   class=\"otherReason\"\n                   ng-if=\"viewModel.showPrimaryOtherReason\"\n                   ng-model=\"viewModel.primaryOtherReason\"/>\n        </div>\n\n        <div class=\"reasonRow\" ng-if=\"viewModel.showSecondaryReason\">\n            <div class=\"reasonLabel\">\n                <div class=\"requiredIcon secondReasonRequired\"\n                     ng-if=\"!viewModel.secondaryDropdownIsOptional && !showCheckMarkForSecondaryReason()\"></div>\n                <div class=\"glyphicon glyphicon-ok validIcon secondReasonValid\"\n                     ng-if=\"!viewModel.secondaryDropdownIsOptional && showCheckMarkForSecondaryReason()\"></div>\n                <span>{{ viewModel.secondaryLabel }}</span>\n            </div>\n\n            <!--Secondary Reason Dropdown-->\n            <um-dropdown class-name=\"secondaryReasonList\"\n                         class=\"reasonList secondaryReasonList\"\n                         required=\"'true'\"\n                         option-list=\"viewModel.secondaryReasonList\"\n                         selected-value=\"getSecondaryReasonLabel()\"\n                         on-change=\"onSelectSecondaryReason(selectedOption)\">\n            </um-dropdown>\n\n\n            <input type=\"text\"\n                   class=\"otherReason\"\n                   ng-if=\"viewModel.showSecondaryOtherReason\"\n                   ng-model=\"viewModel.secondaryOtherReason\"/>\n        </div>\n\n        <div class=\"reasonRow comments\">\n            <div class=\"reasonLabel\">{{ i18n.comments }}</div>\n\n            <textarea class=\"comments\"\n                      ng-model=\"viewModel.comments\"></textarea>\n        </div>\n\n        <ui-date-range ng-if=\"viewModel.showDates\"\n                       date-value=\"viewModel.dateRange\"\n                       value-updated=\"dateRangeUpdated(value)\"\n                       start-date-label=\"viewModel.startDateLabel\"\n                       end-date-label=\"viewModel.endDateLabel\"\n                       timezone-mode=\"viewModel.timezoneMode\">\n        </ui-date-range>\n\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(534);

/*@ngInject*/
var ReasonModalController = function ReasonModalController($rootScope, $scope, coreConstant, coreMediator, dateUtil, primaryDropdown, secondaryDropdown, options) {
  $scope.i18n = locale;
  $scope.viewModel = {
    title: options.title,
    cancelButton: _.get($scope.i18n, 'cancel'),
    okButton: _.get($scope.i18n, 'confirm'),
    summary: options.summary,
    primaryReasonList: [],
    secondaryReasonList: [],
    selectedPrimaryReason: options.selectedPrimaryReason,
    selectedSecondaryReason: options.selectedSecondaryReason,
    primaryReasonIsOptional: options.primaryReasonIsOptional,
    secondaryDropdownIsOptional: options.secondaryDropdownIsOptional,
    primaryOtherReason: '',
    secondaryOtherReason: '',
    showSecondaryReason: secondaryDropdown !== null,
    secondaryLabel: options.secondaryLabel,
    showPrimaryOtherReason: false,
    showSecondaryOtherReason: false,
    comments: options.comments,
    showDates: options.showDates,
    startDateLabel: options.startDateLabel,
    endDateLabel: options.endDateLabel,
    startDate: null,
    endDate: null,
    timezoneMode: options.timezoneMode
  };
  $scope.onSelectPrimaryReason = function (choice) {
    $scope.viewModel.selectedPrimaryReason = choice;
    $scope.viewModel.showPrimaryOtherReason = choice.value.toLowerCase() === 'other';
    $scope.viewModel.primaryOtherReason = '';
  };
  $scope.onSelectSecondaryReason = function (choice) {
    $scope.viewModel.selectedSecondaryReason = choice;
    $scope.viewModel.showSecondaryOtherReason = choice.value.toLowerCase() === 'other';
    $scope.viewModel.secondaryOtherReason = '';
  };
  $scope.getPrimaryReasonLabel = function () {
    var selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason;
    return selectedPrimaryReason ? selectedPrimaryReason.name : _.get($scope.i18n, 'defaultPrimaryPrompt');
  };
  $scope.getSecondaryReasonLabel = function () {
    var selectedSecondaryReason = $scope.viewModel.selectedSecondaryReason;
    return selectedSecondaryReason ? selectedSecondaryReason.name : _.get($scope.i18n, 'defaultSecondaryPrompt');
  };
  $scope.onConfirm = function () {
    var selectedPrimaryReason = '',
      selectedSecondaryReason = $scope.viewModel.selectedSecondaryReason,
      finalDetails,
      dateRangeInputFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    if ($scope.viewModel.selectedPrimaryReason) {
      if ($scope.viewModel.selectedPrimaryReason.name.toLowerCase() === 'other') {
        selectedPrimaryReason = $scope.viewModel.primaryOtherReason;
      } else {
        selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason.value;
      }
    }
    if (selectedSecondaryReason && selectedSecondaryReason.value) {
      finalDetails = 'Lost to:' + selectedSecondaryReason.value + '; ' + $scope.viewModel.comments;
    } else {
      finalDetails = $scope.viewModel.comments;
    }
    $scope.$close({
      reason: selectedPrimaryReason,
      secondaryReason: selectedSecondaryReason,
      details: $scope.viewModel.comments,
      startDate: $scope.viewModel.startDate,
      endDate: $scope.viewModel.endDate
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  function primaryReasonIsNotSelected() {
    var hasPrimaryReasonSelection = $scope.viewModel.selectedPrimaryReason && $scope.viewModel.selectedPrimaryReason.value,
      primaryOtherReasonIsRequired = $scope.viewModel.showPrimaryOtherReason === true,
      isValidPrimaryOtherReason = primaryOtherReasonIsRequired ? $scope.viewModel.primaryOtherReason.length > 0 : true;
    return !$scope.viewModel.primaryReasonIsOptional && (!hasPrimaryReasonSelection || !isValidPrimaryOtherReason);
  }
  function secondaryReasonIsNotSelected() {
    var hasSecondaryReasonSelection = $scope.viewModel.selectedSecondaryReason && $scope.viewModel.selectedSecondaryReason.value;
    return !$scope.viewModel.secondaryDropdownIsOptional && !hasSecondaryReasonSelection;
  }
  function datesNotSelected() {
    var hasSecondaryReasonSelection = $scope.viewModel.startDate && $scope.viewModel.endDate;
    return $scope.viewModel.showDates && !hasSecondaryReasonSelection;
  }
  $scope.dateRangeUpdated = function (value) {
    $scope.viewModel.startDate = dateUtil.parseDateRangeStartDateToMilliseconds(value);
    $scope.viewModel.endDate = dateUtil.parseDateRangeEndDateToMilliseconds(value);
  };
  $scope.canEnableConfirmButton = function () {
    return !(primaryReasonIsNotSelected() || secondaryReasonIsNotSelected() || datesNotSelected());
  };
  $scope.showCheckMarkForPrimaryReason = function () {
    return !primaryReasonIsNotSelected();
  };
  $scope.showCheckMarkForSecondaryReason = function () {
    return !secondaryReasonIsNotSelected();
  };
  coreMediator.getDynamicDataSetItems(primaryDropdown).then(function (result) {
    $scope.viewModel.primaryReasonList = options.primaryDropdownFilterFunction ? _.filter(result, options.primaryDropdownFilterFunction) : result;
    setReasonFields();
  });
  function setReasonFields() {
    var foundSelectedReason = false;
    if ($scope.viewModel.selectedPrimaryReason.name.toLowerCase() === 'other') {
      $scope.viewModel.showPrimaryOtherReason = true;
      $scope.viewModel.primaryOtherReason = $scope.viewModel.selectedPrimaryReason.value;
    } else {
      _.forEach($scope.viewModel.primaryReasonList, function (reason) {
        if (reason.value === $scope.viewModel.selectedPrimaryReason.value) {
          foundSelectedReason = true;
          return false;
        }
      });
    }
    if (!foundSelectedReason && $scope.viewModel.selectedPrimaryReason.ordering === -999) {
      $scope.viewModel.showPrimaryOtherReason = true;
      $scope.viewModel.primaryOtherReason = $scope.viewModel.selectedPrimaryReason.value;
      $scope.viewModel.selectedPrimaryReason.name = 'Other';
    } else {
      $scope.viewModel.selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason ? $scope.viewModel.selectedPrimaryReason : _.get(translations, 'defaultPrimaryPrompt');
    }
  }
  if ($scope.viewModel.showSecondaryReason) {
    coreMediator.getDynamicDataSetItems(secondaryDropdown).then(function (result) {
      $scope.viewModel.secondaryReasonList = options.secondaryDropdownFilterFunction ? _.filter(result, options.secondaryDropdownFilterFunction) : result;
    });
  }
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ReasonModalController.$inject = ["$rootScope", "$scope", "coreConstant", "coreMediator", "dateUtil", "primaryDropdown", "secondaryDropdown", "options"];
angular.module('gw-um-submission').controller('reasonModalController', ReasonModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 534 */
/***/ (function(module) {

module.exports = JSON.parse("{\"cancel\":\"Cancel\",\"confirm\":\"Confirm\",\"defaultPrimaryPrompt\":\"Select Reason\",\"reason\":\"Reason:\",\"comments\":\"Comments:\"}");

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

var path = '/wizard/reason/form/reasonFormModal.tpl.html';
var html = "<base-modal modal-title=\"title\"\n            ok=\"confirmButton\"\n            cancel=\"cancelButton\"\n            is-confirm-disabled=\"!canEnableConfirmButton()\"\n\t\t\tclass=\"modal-body-height-400\"\n            on-confirm=\"onConfirm()\"\n            on-cancel=\"onCancel()\">\n\n    <div class=\"reasonFormModal\" ui-browser-detection>\n        <!--Content-->\n        <ui-form-viewer submission-id=\"{{ ::submissionId }}\"\n                        form-id=\"{{ ::formId }}\"\n                        printable=\"false\"\n                        effective-date=\"{{ ::effectiveDate }}\"\n                        currency-code=\"{{ ::currencyCode }}\">\n        </ui-form-viewer>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(538);

/*@ngInject*/
var ReasonFormModalController = function ReasonFormModalController($rootScope, $scope, cancelActionCallback, confirmActionCallback, coreConstant, formViewerModel, loadingBarHandler, localizationRoot, logAction, submission, reasonFormId) {
  $scope.i18n = locale[localizationRoot];
  $scope.title = $scope.i18n.title;
  $scope.confirmButton = $scope.i18n.confirmButton;
  $scope.cancelButton = $scope.i18n.cancelButton;
  $scope.formId = reasonFormId;
  $scope.submissionId = submission.id;
  $scope.confirmActionCallback = confirmActionCallback;
  $scope.cancelActionCallback = cancelActionCallback;
  $scope.logAction = logAction;
  $scope.effectiveDate = submission.effectiveDate;
  $scope.currencyCode = submission.currencyCode;
  $scope.canEnableConfirmButton = function () {
    var formStructure = formViewerModel.getFormStructure($scope.formId);
    if (formStructure && formStructure.formModel && formStructure.formModel.totalRequiredFieldCount === 0) {
      return true;
    }
    return false;
  };
  $scope.onConfirm = function () {
    loadingBarHandler.showLoadingBar($scope.i18n.loadingBar);
    startPerformanceLog($scope.logAction, $scope.submissionId);
    $scope.confirmActionCallback($scope.submissionId).then(function () {
      stopPerformanceLog($scope.logAction, coreConstant.uiPeformanceLogger.SUCCESS);
      loadingBarHandler.hideLoadingBar();
      $scope.$close();
    }, function () {
      stopPerformanceLog($scope.logAction, coreConstant.uiPeformanceLogger.FAIL);
    });
  };
  $scope.onCancel = function () {
    $scope.cancelActionCallback($scope.submissionId).then(function () {
      $scope.$dismiss();
    });
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  function startPerformanceLog(logAction, submissionId) {
    if (logAction) {
      var message = submissionId.toString();
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
    }
  }
  function stopPerformanceLog(logAction, status) {
    if (logAction) {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
    }
  }
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ReasonFormModalController.$inject = ["$rootScope", "$scope", "cancelActionCallback", "confirmActionCallback", "coreConstant", "formViewerModel", "loadingBarHandler", "localizationRoot", "logAction", "submission", "reasonFormId"];
angular.module('gw-um-submission').controller('reasonFormModalController', ReasonFormModalController);

/***/ }),
/* 538 */
/***/ (function(module) {

module.exports = JSON.parse("{\"decline\":{\"cancelButton\":\"Cancel\",\"confirmButton\":\"Decline\",\"loadingBar\":\"Declining Submission...\",\"title\":\"Decline Submission\"},\"markAsLost\":{\"cancelButton\":\"Cancel\",\"confirmButton\":\"Mark as Lost\",\"loadingBar\":\"Marking Submission as Lost...\",\"title\":\"Mark Submission as Lost\"}}");

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

var path = '/wizard/selection/selectionModal.tpl.html';
var html = "<div class=\"selectionModalContent\" ui-browser-detection>\n\n    <!--Header-->\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{::viewModel.title }}</h3>\n        <button ng-click=\"$dismiss()\" class=\"close\"><span class=\"glyphicon glyphicon-remove\"></span></button>\n    </div>\n\n    <!--Content-->\n    <div class=\"modal-body\">\n\n        <div class=\"selectionRow\"\n             ng-if = \"viewModel.dropdownItems.length>0\">\n            <div class=\"selectionLabel\">\n                <div class=\"requiredIcon\" ng-if=\"!showCheckMarkForPrimaryReason()\"></div>\n                <div class=\"glyphicon glyphicon-ok validIcon\" ng-if=\"showCheckMarkForPrimaryReason()\"></div>\n                {{::viewModel.summary }}\n            </div>\n\n            <div uib-dropdown dropdown-append-to-body=\"true\" class=\"selectionDropdown\">\n              <button uib-dropdown-toggle>\n                  <span class=\"dropdownInnerWrapper\">\n                    <span class=\"dropdownLabel\">{{ viewModel.selectedPrompt }}</span>\n                    <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                  </span>\n              </button>\n\n              <ul class=\"scrollable-menu selection-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n                  <li ng-repeat=\"item in viewModel.dropdownItems\"\n                      ng-click=\"onSelectItem(item)\"\n                      ng-class=\"{'active' : viewModel.selectedItem.value === item.name}\">\n                      {{ item.name }}\n                  </li>\n              </ul>\n            </div>\n        </div>\n\n        <div class=\"warningSummary\" ng-if = \"viewModel.dropdownItems.length===0\">\n            <p>{{::viewModel.warningSummary }}</p>\n        </div>\n\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\"\n         ng-if = \"viewModel.dropdownItems.length>0\">\n\n        <button class=\"btn btn-primary\"\n                ng-click=\"onClose()\"\n                ng-if=\"viewModel.dropdownItems.length>0\"\n                ng-disabled=\"isConfirmButtonDisabled()\">{{::viewModel.confirm }}</button>\n        <button class=\"btn btn-default\"\n                ng-click=\"$dismiss()\">{{ i18n.cancelButton }}</button>\n\n    </div>\n\n    <div class=\"modal-footer\"\n         ng-if = \"viewModel.dropdownItems.length===0\">\n        <button class=\"btn btn-primary\"\n                ng-click=\"$dismiss()\">{{ i18n.okButton }}</button>\n\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(542);

/*@ngInject*/
var SelectionModalController = function SelectionModalController($rootScope, $scope, coreMediator, selectionDropdown, options, localization, coreConstant) {
  $scope.i18n = locale;
  $scope.viewModel = {
    title: options.title,
    summary: options.summary,
    ok: options.ok,
    cancel: options.cancel,
    confirm: options.confirm,
    dropdownItems: [],
    selectedPrompt: options.selectedPrimaryPrompt,
    selectedItem: null,
    warningSummary: options.warningSummary
  };
  $scope.onSelectItem = function (item) {
    $scope.viewModel.selectedItem = item;
    $scope.viewModel.selectedPrompt = item.name;
  };
  $scope.onClose = function () {
    var selectedPrimaryReason = '';
    if ($scope.viewModel.selectedItem) {
      selectedPrimaryReason = $scope.viewModel.selectedItem.value;
    }
    $scope.$close($scope.viewModel.selectedItem.value);
  };
  function primaryReasonIsNotSelected() {
    var hasPrimaryReasonSelection = $scope.viewModel.selectedItem && $scope.viewModel.selectedItem.value;
    return !hasPrimaryReasonSelection;
  }
  $scope.isConfirmButtonDisabled = function () {
    return primaryReasonIsNotSelected();
  };
  $scope.showCheckMarkForPrimaryReason = function () {
    return !primaryReasonIsNotSelected();
  };
  coreMediator.getDynamicDataSetItems(selectionDropdown).then(function (result) {
    $scope.viewModel.dropdownItems = result;
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
SelectionModalController.$inject = ["$rootScope", "$scope", "coreMediator", "selectionDropdown", "options", "localization", "coreConstant"];
angular.module('gw-um-submission').controller('selectionModalController', SelectionModalController);

/***/ }),
/* 542 */
/***/ (function(module) {

module.exports = JSON.parse("{\"cancelButton\":\"Cancel\",\"okButton\":\"OK\"}");

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

var path = '/wizard/splitSubmission/splitSubmissionModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    class=\"splitSubmissionModal\">\n\n    <div class=\"drawer\">\n        <div class=\"drawerRow\">\n            <div class=\"drawerCol\">\n                <ui-required-indicator class=\"requiredIndicator\"\n                                       value=\"{{viewModel.selectedSplitProducts.length > 0 ? 'true' : ''}}\">\n                </ui-required-indicator>\n                <label class=\"summary\">{{ i18n.summary }}</label>\n            </div>\n        </div>\n        <div class=\"drawerRow\">\n            <div class=\"drawerCol\">\n                <label>{{ i18n.copySummary }}</label>\n            </div>\n        </div>\n\n        <div class=\"drawerRow\" ng-repeat=\"product in viewModel.submissionProductsList\">\n            <div class=\"drawerCol\">\n                <label class=\"productName\">\n                    <input type=\"checkbox\"\n                           name=\"product\"\n                           ng-change=\"handleClick(product)\"\n                           ng-model=\"product.checked\">\n                    {{product.name}}\n                </label>\n            </div>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(546);

/*@ngInject*/
var SplitSubmissionModalController = function SplitSubmissionModalController($rootScope, $scope, options, coreMediator, coreConstant) {
  $scope.i18n = locale;
  $scope.viewModel = {
    title: _.get($scope.i18n, 'title'),
    cancelButton: _.get($scope.i18n, 'cancel'),
    okButton: _.get($scope.i18n, 'splitSubmission'),
    submissionProductsList: [],
    selectedSplitProducts: [],
    productShortNames: _.split(options.productShortNames, ','),
    splitButtonTooltip: ''
  };
  $scope.getSplitButtonTooltip = function () {
    if ($scope.viewModel.selectedSplitProducts.length === 0) {
      return _.get($scope.i18n, 'selectAtLeastOneProductTooltip');
    } else if ($scope.viewModel.selectedSplitProducts.length === $scope.viewModel.submissionProductsList.length) {
      return _.get($scope.i18n, 'cannotSelectAllProductsTooltip');
    }
    return null;
  };
  $scope.canEnableConfirmButton = function () {
    return !($scope.viewModel.selectedSplitProducts.length === 0 || $scope.viewModel.selectedSplitProducts.length === $scope.viewModel.submissionProductsList.length);
  };
  $scope.handleClick = function (product) {
    if (product.checked) {
      $scope.viewModel.selectedSplitProducts.push(product.value);
    } else {
      _.pull($scope.viewModel.selectedSplitProducts, product.value);
    }
  };
  $scope.onConfirm = function () {
    $scope.$close({
      productShortNames: $scope.viewModel.selectedSplitProducts
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  function getAuthorizedProducts() {
    var dynamicDataSetParams = {
      name: 'User Authorized Products',
      submissionUri: 'com.firstbest.underwriting.submission.Submission:' + options.submissionId
    };
    coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(function (response) {
      _.each(response, function (item) {
        if (_.indexOf($scope.viewModel.productShortNames, item.value) !== -1) {
          $scope.viewModel.submissionProductsList.push(item);
        }
      });
    });
  }
  getAuthorizedProducts();
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
SplitSubmissionModalController.$inject = ["$rootScope", "$scope", "options", "coreMediator", "coreConstant"];
angular.module('gw-um-submission').controller('splitSubmissionModalController', SplitSubmissionModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 546 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Split Submission\",\"cancel\":\"Cancel\",\"splitSubmission\":\"Split Submission\",\"selectAtLeastOneProductTooltip\":\"You must select at least one product.\",\"cannotSelectAllProductsTooltip\":\"You cannot select all products when splitting submissions. Select only the products you want to move to the new submission.\",\"summary\":\"Please select the products you would like to split into a new submission:\",\"copySummary\":\"All applicable Application forms, Worksheets and Reports, as well as all collaboration content, will be copied to the newly created submission.\"}");

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

var path = '/wizard/copySubmission/copySubmissionModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    class=\"copySubmissionModal\">\n\n    <div class=\"drawer\">\n\n        <div class=\"drawerRow\">\n\n            <div class=\"drawerCol\">\n\n                <input type=\"radio\"\n                       ng-model=\"viewModel.copyOptions\"\n                       ng-value=\"viewModel.fullSubmissionCopyOptions\"/>\n            </div>\n\n            <div class=\"drawerCol\">\n                <label ng-click=\"onClickFullSubmissionLabel()\"\n                       class=\"radioLabel\">{{ ::i18n.fullSubmissionLabel }}</label>\n            </div>\n        </div>\n\n        <div class=\"drawerRow fullSubmissionSublabelRow\">\n\n            <div class=\"drawerCol rowSpacer\"></div>\n\n            <div class=\"drawerCol\">\n                <label>{{ ::i18n.fullSubmissionSublabel }}</label>\n            </div>\n        </div>\n\n        <div class=\"drawerRow\">\n\n            <div class=\"drawerCol\">\n\n                <input type=\"radio\"\n                       class=\"copyOnlyApplicationData\"\n                       ng-model=\"viewModel.copyOptions\"\n                       ng-value=\"viewModel.applicationOnlyCopyOptions\"/>\n            </div>\n\n            <div class=\"drawerCol\">\n                <label ng-click=\"onClickApplicationOnlyLabel()\"\n                       class=\"radioLabel\">{{ ::i18n.applicationOnlyLabel }}</label>\n            </div>\n        </div>\n\n        <div class=\"drawerRow\">\n\n            <div class=\"drawerCol rowSpacer\"></div>\n\n            <div class=\"drawerCol\">\n                <label>{{ ::i18n.applicationOnlySublabel }}</label>\n            </div>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(550);

/*@ngInject*/
var CopySubmissionModalController = function CopySubmissionModalController($rootScope, $scope, coreConstant, submissionCopyOptions) {
  $scope.i18n = locale;
  $scope.viewModel = {
    title: _.get($scope.i18n, 'title'),
    cancelButton: _.get($scope.i18n, 'cancel'),
    okButton: _.get($scope.i18n, 'confirm'),
    fullSubmissionCopyOptions: [submissionCopyOptions.ALL],
    applicationOnlyCopyOptions: [submissionCopyOptions.SUBMISSION_APPLICATION_FORMS]
  };
  $scope.viewModel.copyOptions = $scope.viewModel.fullSubmissionCopyOptions;
  $scope.onClickFullSubmissionLabel = function () {
    $scope.viewModel.copyOptions = $scope.viewModel.fullSubmissionCopyOptions;
  };
  $scope.onClickApplicationOnlyLabel = function () {
    $scope.viewModel.copyOptions = $scope.viewModel.applicationOnlyCopyOptions;
  };
  $scope.onConfirm = function () {
    $scope.$close({
      copyOptions: $scope.viewModel.copyOptions
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
CopySubmissionModalController.$inject = ["$rootScope", "$scope", "coreConstant", "submissionCopyOptions"];
angular.module('gw-um-submission').controller('copySubmissionModalController', CopySubmissionModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 550 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Copy Submission\",\"cancel\":\"Cancel\",\"confirm\":\"Copy\",\"fullSubmissionLabel\":\"Full Submission\",\"fullSubmissionSublabel\":\"Copy includes all applications, worksheets, reports and collaboration items (excluding tasks)\",\"applicationOnlyLabel\":\"Application only\",\"applicationOnlySublabel\":\"Copy includes just the application forms\"}");

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

var path = '/wizard/rewriteSubmission/rewriteSubmissionModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    class=\"rewriteSubmissionModal\">\n\n    <div class=\"rewriteSubmissionContent\" ui-browser-detection>\n\n        <div class=\"summary\" ng-if=\"viewModel.summary\"\n             ng-bind-html=\"viewModel.summary\"></div>\n\n        <div class=\"reasonRow\">\n            <div class=\"reasonLabel\">\n                <div class=\"requiredIcon reasonRequired\"\n                     ng-if=\"!viewModel.primaryReasonIsOptional && !showCheckMarkForPrimaryReason()\"></div>\n                <div class=\"glyphicon glyphicon-ok validIcon reasonValid\"\n                     ng-if=\"!viewModel.primaryReasonIsOptional && showCheckMarkForPrimaryReason()\"></div>\n                <span>{{ i18n.reason }}</span>\n            </div>\n            \n            <um-dropdown class-name=\"primaryReasonList\"\n                         class=\"reasonList rewriteReasonList\"\n                         required=\"'true'\"\n                         option-list=\"viewModel.primaryReasonList\"\n                         selected-value=\"getPrimaryReasonLabel()\"\n                         on-change=\"onSelectPrimaryReason(selectedOption)\">\n            </um-dropdown>\n\n            <input type=\"text\"\n                   class=\"otherReason\"\n                   ng-if=\"viewModel.showPrimaryOtherReason\"\n                   ng-model=\"viewModel.primaryOtherReason\"/>\n        </div>\n\n        <div class=\"reasonRow comments\">\n            <div class=\"reasonLabel\">{{ i18n.comments }}</div>\n\n            <textarea class=\"comments\"\n                      ng-model=\"viewModel.comments\"></textarea>\n        </div>\n\n        <ui-date-range ng-if=\"viewModel.showDates\"\n                       date-value=\"viewModel.dateRange\"\n                       value-updated=\"dateRangeUpdated(value)\"\n                       start-date-label=\"viewModel.startDateLabel\"\n                       end-date-label=\"viewModel.endDateLabel\"\n                       timezone-mode=\"viewModel.timezoneMode\">\n        </ui-date-range>\n\n        <div class=\"contentLabel\">{{ i18n.contentLabel }}</div>\n\n        <div class=\"drawer\">\n\n            <div class=\"drawerRow\">\n\n                <div class=\"drawerCol\">\n\n                    <input type=\"radio\"\n                           ng-model=\"viewModel.copyOptions\"\n                           ng-value=\"viewModel.fullSubmissionCopyOptions\"/>\n                </div>\n\n                <div class=\"drawerCol\">\n                    <label ng-click=\"onClickFullSubmissionLabel()\"\n                           class=\"radioLabel\">{{ ::i18n.fullSubmissionLabel }}</label>\n                </div>\n            </div>\n\n            <div class=\"drawerRow fullSubmissionSublabelRow\">\n\n                <div class=\"drawerCol rowSpacer\"></div>\n\n                <div class=\"drawerCol\">\n                    <label>{{ ::i18n.fullSubmissionSublabel }}</label>\n                </div>\n            </div>\n\n            <div class=\"drawerRow\">\n\n                <div class=\"drawerCol\">\n\n                    <input type=\"radio\"\n                           class=\"copyOnlyApplicationData\"\n                           ng-model=\"viewModel.copyOptions\"\n                           ng-value=\"viewModel.applicationOnlyCopyOptions\"/>\n                </div>\n\n                <div class=\"drawerCol\">\n                    <label ng-click=\"onClickApplicationOnlyLabel()\"\n                           class=\"radioLabel\">{{ ::i18n.applicationOnlyLabel }}</label>\n                </div>\n            </div>\n\n            <div class=\"drawerRow\">\n\n                <div class=\"drawerCol rowSpacer\"></div>\n\n                <div class=\"drawerCol\">\n                    <label>{{ ::i18n.applicationOnlySublabel }}</label>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(554);

/*@ngInject*/
var rewriteSubmissionModalController = function rewriteSubmissionModalController($rootScope, $scope, coreConstant, coreMediator, dateUtil, submissionId, submissionCopyOptions) {
  $scope.i18n = locale;
  var primaryDropdown = {
    name: "Rewrite Reasons",
    submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId
  };
  $scope.viewModel = {
    title: _.get($scope.i18n, 'title'),
    cancelButton: _.get($scope.i18n, 'cancel'),
    okButton: _.get($scope.i18n, 'confirm'),
    primaryReasonList: [],
    selectedPrimaryReason: {
      name: _.get($scope.i18n, 'defaultPrimaryPrompt')
    },
    primaryReasonIsOptional: false,
    primaryOtherReason: '',
    showPrimaryOtherReason: false,
    comments: '',
    showDates: true,
    startDateLabel: _.get($scope.i18n, 'startDateLabel'),
    endDateLabel: _.get($scope.i18n, 'endDateLabel'),
    startDate: null,
    endDate: null,
    timezoneMode: 'utc',
    fullSubmissionCopyOptions: [submissionCopyOptions.ALL],
    applicationOnlyCopyOptions: [submissionCopyOptions.SUBMISSION_APPLICATION_FORMS]
  };
  $scope.onSelectPrimaryReason = function (choice) {
    $scope.viewModel.selectedPrimaryReason = choice;
    $scope.viewModel.showPrimaryOtherReason = choice.value.toLowerCase() === 'other';
    $scope.viewModel.primaryOtherReason = '';
  };
  $scope.getPrimaryReasonLabel = function () {
    var selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason;
    return selectedPrimaryReason ? selectedPrimaryReason.name : _.get($scope.i18n, 'defaultPrimaryPrompt');
  };
  $scope.viewModel.copyOptions = $scope.viewModel.fullSubmissionCopyOptions;
  $scope.onClickFullSubmissionLabel = function () {
    $scope.viewModel.copyOptions = $scope.viewModel.fullSubmissionCopyOptions;
  };
  $scope.onClickApplicationOnlyLabel = function () {
    $scope.viewModel.copyOptions = $scope.viewModel.applicationOnlyCopyOptions;
  };
  $scope.onConfirm = function () {
    var selectedPrimaryReason = '',
      dateRangeInputFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    if ($scope.viewModel.selectedPrimaryReason) {
      if ($scope.viewModel.selectedPrimaryReason.name.toLowerCase() === 'other') {
        selectedPrimaryReason = $scope.viewModel.primaryOtherReason;
      } else {
        selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason.value;
      }
    }
    $scope.$close({
      reason: selectedPrimaryReason,
      details: $scope.viewModel.comments,
      startDate: $scope.viewModel.startDate,
      endDate: $scope.viewModel.endDate,
      copyOptions: $scope.viewModel.copyOptions
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  function primaryReasonIsNotSelected() {
    var hasPrimaryReasonSelection = $scope.viewModel.selectedPrimaryReason && $scope.viewModel.selectedPrimaryReason.value,
      primaryOtherReasonIsRequired = $scope.viewModel.showPrimaryOtherReason === true,
      isValidPrimaryOtherReason = primaryOtherReasonIsRequired ? $scope.viewModel.primaryOtherReason.length > 0 : true;
    return !$scope.viewModel.primaryReasonIsOptional && (!hasPrimaryReasonSelection || !isValidPrimaryOtherReason);
  }
  function datesNotSelected() {
    var hasDatesSelected = $scope.viewModel.startDate && $scope.viewModel.endDate;
    return $scope.viewModel.showDates && !hasDatesSelected;
  }
  $scope.dateRangeUpdated = function (value) {
    $scope.viewModel.startDate = dateUtil.parseDateRangeStartDateToMilliseconds(value);
    $scope.viewModel.endDate = dateUtil.parseDateRangeEndDateToMilliseconds(value);
  };
  $scope.canEnableConfirmButton = function () {
    return !(primaryReasonIsNotSelected() || datesNotSelected());
  };
  $scope.showCheckMarkForPrimaryReason = function () {
    return !primaryReasonIsNotSelected();
  };
  coreMediator.getDynamicDataSetItems(primaryDropdown).then(function (result) {
    $scope.viewModel.primaryReasonList = result;
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
rewriteSubmissionModalController.$inject = ["$rootScope", "$scope", "coreConstant", "coreMediator", "dateUtil", "submissionId", "submissionCopyOptions"];
angular.module('gw-um-submission').controller('rewriteSubmissionModalController', rewriteSubmissionModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 554 */
/***/ (function(module) {

module.exports = JSON.parse("{\"cancel\":\"Cancel\",\"confirm\":\"Confirm\",\"defaultPrimaryPrompt\":\"Select Rewrite Reason\",\"reason\":\"Reason:\",\"comments\":\"Comments:\",\"title\":\"Rewrite Submission\",\"startDateLabel\":\"Effective Date:\",\"endDateLabel\":\"Expiration Date:\",\"contentLabel\":\"Content:\",\"fullSubmissionLabel\":\"Full Submission\",\"fullSubmissionSublabel\":\"Include all applications, worksheets, reports and collaboration items (excluding tasks)\",\"applicationOnlyLabel\":\"Application only\",\"applicationOnlySublabel\":\"Include just the application forms\"}");

/***/ }),
/* 555 */
/***/ (function(module, exports) {

/*@ngInject*/
var WizardActionHandlerUtil = function WizardActionHandlerUtil(reportActionUtil, submissionAction, submissionActionUtil, submissionTransition, quoteActionUtil, renewalTransition, endorsementActionUtil, modalUtil, quoteTransition, quoteAction, proposalAction, quoteMediator, proposalActionUtil, externalReportAction, policyIssuanceAction, policyIssuanceActionUtil, policyAction, policyActionUtil, policyCancellationAction, policyCancellationActionUtil, endorsementTransition, submissionMediator, functionActionUtil, policyRewriteActionUtil, policyRewriteTransition) {
  this.handleAction = function (action, file, quoteId, reportId, proposalId, policyId, policyIssuanceId, endorsementId, policyCancellationId, policyRewriteId) {
    var isQuote = action.context ? action.context.indexOf('quote') !== -1 : false,
      isReport = action.context ? action.context.indexOf('report') !== -1 : false,
      isPolicyIssuance = action.context ? action.context.indexOf('PolicyIssuance') !== -1 : false,
      isProposalAction = action.context ? action.context.indexOf('proposal') !== -1 : false,
      isPolicyCancellation = action.context ? action.context.indexOf('PolicyCancellation') !== -1 : false,
      isPolicyRewrite = action.context ? action.context.indexOf('PolicyRewrite') !== -1 : false,
      isPolicyReissue = action.context ? action.context.indexOf('PolicyReissue') !== -1 : false,
      isPolicy = action.context ? action.context.indexOf('policy') !== -1 : false,
      isEndorsement = action.context ? action.context.indexOf('Endorsement') !== -1 : false,
      submission,
      identifierName,
      identifier;
    if (action.enabled) {
      submission = submissionMediator.getCurrentSubmission();
      if (action.functionType) {
        if (isQuote) {
          identifierName = 'quoteId';
          identifier = quoteId;
        } else if (isEndorsement) {
          identifierName = 'endorsementId';
          identifier = endorsementId;
        } else if (isPolicyIssuance) {
          identifierName = 'issuanceId';
          identifier = policyIssuanceId;
        }
        functionActionUtil.handleAction(action, submission, identifierName, identifier);
      } else if (isQuote) {
        this.handleQuoteAction(action, submission, quoteId);
      } else if (isReport) {
        this.handleReportAction(action, submission, reportId);
      } else if (isPolicyIssuance) {
        this.handlePolicyIssuanceAction(action, submission, policyIssuanceId);
      } else if (isProposalAction) {
        this.handleProposalAction(action, submission, proposalId);
      } else if (isPolicyCancellation) {
        this.handlePolicyCancellationAction(action, submission, policyCancellationId);
      } else if (isEndorsement) {
        this.handleEndorsementAction(action, submission, endorsementId);
      } else if (isPolicyRewrite || isPolicyReissue) {
        this.handlePolicyRewriteAction(action, submission, policyRewriteId, isPolicyReissue);
      } else if (isPolicy) {
        this.handlePolicyAction(action, submission, policyId);
      } else {
        this.handleSubmissionAction(action, submission);
      }
    }
  };
  this.handleSubmissionAction = function (action, submission) {
    var isCreateReport = action.groupName === 'Reports';
    if (isCreateReport) {
      reportActionUtil.createReport(submission.id, action.name);
    } else {
      switch (action.name) {
        case submissionAction.SUBMIT_MODIFICATIONS:
          submissionActionUtil.handleSubmitModifications(submission);
          break;
        case submissionTransition.LOST:
          submissionActionUtil.handleMarkSubmissionAsLost(submission);
          break;
        case submissionAction.DISCARD_MODIFICATIONS:
          submissionActionUtil.handleDiscardModifications(submission);
          break;
        case submissionAction.ACKNOWLEDGE_MODIFICATIONS:
          submissionActionUtil.handleAcknowledgeModifications(submission);
          break;
        case submissionAction.ASSIGN_ACCOUNT:
          submissionActionUtil.handleAssignAccount(submission);
          break;
        case submissionTransition.CLEAR:
          submissionActionUtil.handleClear(submission.id);
          break;
        case submissionTransition.DECLINE:
          submissionActionUtil.handleDecline(submission);
          break;
        case submissionTransition.REJECT:
          submissionActionUtil.handleReject(submission.id);
          break;
        case submissionTransition.NOT_CLEAR:
          submissionActionUtil.handleNotClear(submission.id);
          break;
        case submissionTransition.CLEAR_READY:
          submissionActionUtil.handleClearReady(submission.id);
          break;
        case submissionTransition.REVERT_TO_CLEAR:
          submissionActionUtil.handleRevertToClear(submission.id);
          break;
        case submissionAction.COPY_SUBMISSION:
          submissionActionUtil.handleCopySubmission(submission.id);
          break;
        case submissionAction.CHECK_CLEARANCE:
          submissionActionUtil.handleCheckClearance(submission.id);
          break;
        case submissionTransition.REACTIVATE:
          submissionActionUtil.handleReactivate(submission.id);
          break;
        case submissionTransition.REEVALUATE:
          submissionActionUtil.handleReevaluate(submission.id);
          break;
        case submissionTransition.CREATE_QUOTE:
          quoteActionUtil.getQuotableProductTemplates(submission.id);
          break;
        case submissionAction.CREATE_PROPOSAL:
          submissionActionUtil.getQuotableProductTemplates(submission.id);
          break;
        case submissionTransition.SET_SUBMISSION_PRODUCTS:
          submissionActionUtil.changeProducts(submission.id);
          break;
        case submissionTransition.UPDATE_STATUS_REASON:
          submissionActionUtil.updateStatusReason(submission.id);
          break;
        case submissionAction.SUBMIT_APPLICATION:
          submissionActionUtil.submitApplication(submission.id);
          break;
        case submissionAction.MODIFY_APPLICATION:
        case submissionAction.MODIFY_SUBMISSION:
        case submissionAction.MODIFY_BOUND_SUBMISSION:
          submissionActionUtil.modifySubmission(submission.id);
          break;
        case submissionTransition.DELETE:
          submissionActionUtil.delete(submission.id);
          break;
        case submissionAction.DELETE_PRE_DRAFT:
          submissionActionUtil.deletePreDraft(submission.id);
          break;
        case submissionTransition.MAKE_APPLICATION:
          submissionActionUtil.makeApplication(submission.id);
          break;
        case submissionAction.REFER:
          submissionActionUtil.referSubmission(submission.id);
          break;
        case submissionAction.RETRACT_REFERRAL:
          submissionActionUtil.retractReferral(submission.id);
          break;
        case submissionAction.CLEAR_REFERRAL:
          submissionActionUtil.clearReferral(submission.id);
          break;
        case submissionAction.DECLINE_REFERRAL:
          submissionActionUtil.declineReferral(submission.id);
          break;
        case submissionAction.SPLIT_SUBMISSION:
          submissionActionUtil.splitSubmission(submission.id);
          break;
        case submissionAction.REWRITE_SUBMISSION:
          submissionActionUtil.rewriteSubmission(submission.id);
          break;
        case submissionTransition.RESUBMIT:
          submissionActionUtil.resubmitSubmission(submission.id);
          break;
        case renewalTransition.SUBMIT_RENEWAL:
          submissionActionUtil.submitRenewal(submission.id);
          break;
        case renewalTransition.SUBMIT_NON_RENEWAL:
          submissionActionUtil.submitNonRenewal(submission.id);
          break;
        case renewalTransition.RETRACT_NON_RENEWAL:
          submissionActionUtil.retractNonRenewal(submission.id);
          break;
        case renewalTransition.FLAG_FOR_NON_RENEWAL:
          submissionActionUtil.flagForNonRenewal(submission.id);
          break;
        case renewalTransition.CLEAR_NON_RENEWAL_FLAG:
          submissionActionUtil.clearNonRenewalFlag(submission.id);
          break;
        case submissionAction.DISABLE_AUTOMATION:
          submissionActionUtil.disableAutomation(submission.id);
          break;
        case submissionAction.DETAILED_HISTORY:
          submissionActionUtil.openDetailedHistory(submission);
          break;
        case submissionTransition.START_PREQUALIFICATION:
          submissionActionUtil.startPrequalification(submission.id, action.preDraft);
          break;
        case submissionTransition.CANCEL_PREQUALIFICATION:
          submissionActionUtil.cancelPrequalification(submission.id, action.preDraft);
          break;
        case submissionTransition.CHECK_PREQUALIFICATION:
          submissionActionUtil.checkPrequalification(submission.id, action.preDraft);
          break;
        case submissionTransition.SUBMIT_PREQUALIFICATION:
          submissionActionUtil.submitPrequalification(submission.id);
          break;
        case renewalTransition.MARK_EXPIRED:
          submissionActionUtil.markExpired(submission.id);
          break;
        case renewalTransition.MARK_NON_RENEWED:
          submissionActionUtil.markNonRenewed(submission.id);
          break;
        case renewalTransition.MARK_RENEWED:
          submissionActionUtil.markRenewed(submission.id);
          break;
        case submissionAction.CREATE_ENDORSEMENT:
          endorsementActionUtil.startEndorsement(submission.id);
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  this.handleQuoteAction = function (action, submission, quoteId) {
    switch (action.name) {
      case quoteTransition.DECLINE_QUOTE:
        quoteActionUtil.handleDeclineToBind(quoteId, submission.id);
        break;
      case quoteTransition.DELETE:
        quoteActionUtil.deleteQuote(quoteId, submission.id);
        break;
      case quoteTransition.COPY_QUOTE:
        quoteActionUtil.copyQuote(quoteId, submission.id);
        break;
      case quoteAction.COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL:
        quoteActionUtil.copyQuoteForMultiQuoteProposal(quoteId, submission.id);
        break;
      case quoteAction.GENERATE_QUOTE:
        quoteActionUtil.generateQuote(quoteId, submission.id);
        break;
      case quoteTransition.MODIFY_QUOTE:
        quoteActionUtil.modifyQuote(quoteId, submission.id);
        break;
      case quoteTransition.START_QUOTE:
        quoteActionUtil.startQuote(quoteId, submission.id);
        break;
      case quoteTransition.GENERATE_RATING:
        quoteActionUtil.generateRating(quoteId, submission.id);
        break;
      case quoteTransition.START_PRICING:
        quoteActionUtil.startPricing(quoteId, submission.id);
        break;
      case quoteTransition.MODIFY_PRICING:
        quoteActionUtil.modifyPricing(quoteId, submission.id);
        break;
      case quoteTransition.MODIFY_RATING:
        quoteActionUtil.modifyRating(quoteId, submission.id);
        break;
      case quoteTransition.SEND:
        quoteActionUtil.sendProposal(quoteId, submission.id);
        break;
      case quoteTransition.BEGIN_BINDING:
        quoteActionUtil.beginBinding(quoteId, submission.id);
        break;
      case quoteTransition.REQUEST_BINDING:
        quoteActionUtil.requestBinding(quoteId, submission.id);
        return;
      case quoteTransition.BIND:
        quoteActionUtil.bindQuote(quoteId, submission.id);
        return;
      case proposalAction.SEND_BINDER:
        quoteMediator.getQuote(quoteId).then(function (quote) {
          proposalActionUtil.sendBinder(submission.id, quote.proposalId);
        }.bind(this));
        return;
      case quoteTransition.GENERATE_BINDER:
        quoteActionUtil.generateBinder(quoteId, submission.id);
        return;
      case quoteAction.ADD_DOCUMENT:
        quoteActionUtil.addQuoteDocument(submission.id, quoteId);
        return;
      case quoteTransition.UNBIND:
        quoteActionUtil.unbind(quoteId, submission.id);
        return;
      case quoteAction.REFRESH_QUOTE:
        var quoteIds = [quoteId];
        quoteActionUtil.refreshQuoteByIds(quoteIds);
        return;
      case quoteTransition.MODIFY_BINDER:
        quoteActionUtil.modifyBinder(quoteId, submission.id);
        return;
      case quoteAction.ADD_SECTION:
        quoteActionUtil.addSection(quoteId, submission.id);
        return;
      case quoteAction.DELETE_SECTION:
        quoteActionUtil.deleteSection(quoteId, submission.id);
        return;
      case quoteAction.GENERATE_RATING_ATTACHMENTS:
        quoteActionUtil.generateRatingAttachments(quoteId, submission.id);
        return;
      case quoteAction.REVERT_TO_SENT:
        quoteActionUtil.revertToSent(quoteId, submission.id);
        break;
      case quoteTransition.WITHDRAW_QUOTE:
        quoteActionUtil.withdrawQuote(quoteId, submission.id);
        break;
      case quoteTransition.WITHDRAW_REQUEST:
        quoteActionUtil.withdrawRequest(quoteId, submission.id);
        break;
      default:
        modalUtil.showActionNotImplementedModal(action.name);
        break;
    }
  };
  this.handleReportAction = function (action, submission, reportId) {
    switch (action.name) {
      case externalReportAction.GENERATE_REPORT:
        reportActionUtil.generateReport(reportId);
        break;
      case externalReportAction.DELETE_REPORT:
        reportActionUtil.deleteReport(submission.id, reportId);
        break;
      case externalReportAction.EDIT_REPORT:
        reportActionUtil.editReport(reportId);
        break;
      default:
        modalUtil.showActionNotImplementedModal(action.name);
        break;
    }
  };
  this.handlePolicyIssuanceAction = function (action, submission, policyIssuanceId) {
    switch (action.name) {
      case policyIssuanceAction.BEGIN_ISSUANCE:
        policyIssuanceActionUtil.beginIssuance(policyIssuanceId);
        break;
      case policyIssuanceAction.REVERT_TO_BOUND:
        policyIssuanceActionUtil.revertToBound(submission.id, policyIssuanceId);
        break;
      case policyIssuanceAction.SUBMIT_FOR_ISSUANCE:
        policyIssuanceActionUtil.submitForIssuance(submission.id, policyIssuanceId);
        break;
      case policyIssuanceAction.MODIFY_ISSUANCE:
        policyIssuanceActionUtil.modifyIssuance(policyIssuanceId);
        break;
      case policyIssuanceAction.MARK_AS_ISSUED:
        policyIssuanceActionUtil.markAsIssued(submission.id, policyIssuanceId);
        break;
      case policyIssuanceAction.REVERT_TO_PENDING_ISSUANCE:
        policyIssuanceActionUtil.revertToPendingIssuance(submission.id, policyIssuanceId);
        break;
      default:
        modalUtil.showActionNotImplementedModal(action.name);
        break;
    }
  };
  this.handleProposalAction = function (action, submission, proposalId) {
    switch (action.name) {
      case proposalAction.COPY_PROPOSAL:
        proposalActionUtil.copyProposal(submission.id, proposalId);
        break;
      case proposalAction.MODIFY_PROPOSAL:
        proposalActionUtil.modifyProposal(proposalId, submission.id);
        break;
      case proposalAction.DELETE_PROPOSAL:
        proposalActionUtil.deleteProposal(submission.id, proposalId);
        break;
      case proposalAction.CREATE_QUOTE:
        proposalActionUtil.getQuotableProductTemplates(submission.id, proposalId);
        break;
      case proposalAction.SEND_PROPOSAL:
        proposalActionUtil.sendProposal(submission.id, proposalId);
        break;
      case proposalAction.BEGIN_BINDING_PROPOSAL:
        proposalActionUtil.beginBinding(submission.id, proposalId);
        break;
      case proposalAction.DECLINE_TO_BIND_PROPOSAL_FROM_SENT:
        proposalActionUtil.declineToBindFromSent(submission.id, proposalId);
        break;
      case proposalAction.DECLINE_TO_BIND_PROPOSAL:
        proposalActionUtil.declineToBind(submission.id, proposalId);
        break;
      case proposalAction.REQUEST_TO_BIND_PROPOSAL_FROM_SENT:
        proposalActionUtil.requestToBindFromSent(submission.id, proposalId);
        break;
      case proposalAction.REQUEST_TO_BIND_PROPOSAL:
        proposalActionUtil.requestBinding(submission.id, proposalId);
        break;
      case proposalAction.BIND_PROPOSAL_FROM_SENT:
        proposalActionUtil.bindProposalFromSent(submission.id, proposalId);
        break;
      case proposalAction.ADD_DOCUMENT:
        proposalActionUtil.addProposalDocument(submission.id, proposalId);
        break;
      case proposalAction.SEND_BINDER:
        proposalActionUtil.sendBinder(submission.id, proposalId);
        break;
      case proposalAction.BIND_PROPOSAL:
        proposalActionUtil.bindProposal(submission.id, proposalId);
        break;
      case proposalAction.ADD_SECTION:
        proposalActionUtil.addSection(submission.id, proposalId);
        break;
      case proposalAction.DELETE_SECTION:
        proposalActionUtil.deleteSection(submission.id, proposalId);
        break;
      case proposalAction.GENERATE_BINDER_PROPOSAL:
        proposalActionUtil.generateBinder(submission.id, proposalId);
        break;
      case proposalAction.GENERATE_QUOTES:
        proposalActionUtil.generateQuotes(submission.id, proposalId);
        break;
      default:
        modalUtil.showActionNotImplementedModal(action.name);
        break;
    }
  };
  this.handlePolicyAction = function (action, submission, policyId) {
    switch (action.name) {
      case policyAction.CANCEL:
        policyActionUtil.cancel(policyId);
        break;
      case policyAction.REINSTATE:
        policyActionUtil.reinstatePolicy(submission.id, policyId);
        break;
      case policyAction.ENDORSE:
        policyActionUtil.startEndorsement(policyId);
        break;
      case policyAction.REWRITE:
        policyActionUtil.startPolicyRewrite(policyId);
        break;
      case policyAction.REISSUE:
        policyActionUtil.startPolicyReissue(policyId);
        break;
      default:
        modalUtil.showActionNotImplementedModal(action.name);
        break;
    }
  };
  this.handlePolicyCancellationAction = function (action, submission, policyCancellationId) {
    switch (action.name) {
      case policyCancellationAction.REQUEST_CANCELLATION:
        policyCancellationActionUtil.requestCancellation(policyCancellationId);
        break;
      case policyCancellationAction.SUBMIT_FOR_CANCELLATION:
        policyCancellationActionUtil.submitForCancellation(policyCancellationId);
        break;
      case policyCancellationAction.MARK_AS_CANCELLED:
        policyCancellationActionUtil.markAsCancelled(policyCancellationId);
        break;
      case policyCancellationAction.DELETE_DRAFT_CANCELLATION:
        policyCancellationActionUtil.deleteDraftCancellation(submission.id, policyCancellationId);
        break;
      case policyCancellationAction.RETRACT_CANCELLATION_REQUEST:
        policyCancellationActionUtil.retractCancellationRequest(submission.id, policyCancellationId);
        break;
      case policyCancellationAction.RESCIND_CANCELLATION:
        policyCancellationActionUtil.rescindCancellation(submission.id, policyCancellationId);
        break;
      case policyCancellationAction.REVERT_TO_CANCELLATION_PENDING:
        policyCancellationActionUtil.revertToCancellationPending(submission.id, policyCancellationId);
        break;
      default:
        modalUtil.showActionNotImplementedModal(action.name);
        break;
    }
  };
  this.handleEndorsementAction = function (action, submission, endorsementId) {
    switch (action.name) {
      case endorsementTransition.CREATE:
        endorsementActionUtil.createEndorsement(endorsementId);
        break;
      case endorsementTransition.DELETE:
        endorsementActionUtil.deleteEndorsement(endorsementId, submission.id);
        break;
      case endorsementTransition.REFRESH_QUOTE:
        endorsementActionUtil.refreshQuote(endorsementId, submission.id);
        break;
      case endorsementTransition.SUBMIT:
        endorsementActionUtil.submitEndorsement(endorsementId, submission.id);
        break;
      case endorsementTransition.CREATE_ENDORSEMENT_QUOTE:
        endorsementActionUtil.startRating(endorsementId);
        break;
      case endorsementTransition.SUBMIT_FOR_ISSUANCE:
        endorsementActionUtil.submitEndorsementForIssuance(endorsementId);
        break;
      case endorsementTransition.MARK_AS_ISSUED:
        endorsementActionUtil.markEndorsementAsIssued(endorsementId, submission.id);
        break;
      case endorsementTransition.REVERT_TO_SUBMITTED:
        endorsementActionUtil.revertEndorsementToSubmitted(endorsementId);
        break;
      case endorsementTransition.APPROVE:
        endorsementActionUtil.approveEndorsement(endorsementId, submission.id);
        break;
      case endorsementTransition.DECLINE:
        endorsementActionUtil.declineEndorsement(endorsementId, submission.id);
        break;
      case endorsementTransition.GENERATE_RATING:
        endorsementActionUtil.generateRating(endorsementId, submission.id);
        break;
      case endorsementTransition.GENERATE_RATING_ATTACHMENTS:
        endorsementActionUtil.generateRatingAttachments(endorsementId, submission.id);
        break;
      case endorsementTransition.START_PRICING:
        endorsementActionUtil.startPricing(endorsementId, submission.id);
        break;
      case endorsementTransition.MODIFY_RATING:
        endorsementActionUtil.modifyRating(endorsementId, submission.id);
        break;
      case endorsementTransition.MODIFY_PRICING:
        endorsementActionUtil.modifyPricing(endorsementId, submission.id);
        break;
      case endorsementTransition.REVIEW_CHANGES:
        endorsementActionUtil.reviewChanges(endorsementId);
        break;
      case endorsementTransition.REVERT_TO_PENDING_ISSUANCE:
        endorsementActionUtil.revertToPendingIssuance(endorsementId);
        break;
      default:
        modalUtil.showActionNotImplementedModal(action.name);
        break;
    }
  };
  this.handlePolicyRewriteAction = function (action, submission, policyRewriteId, isReissue) {
    switch (action.name) {
      case policyRewriteTransition.CREATE:
        policyRewriteActionUtil.createPolicyRewrite(policyRewriteId, isReissue);
        break;
      case policyRewriteTransition.DELETE:
        policyRewriteActionUtil.deletePolicyRewrite(policyRewriteId, submission.id, isReissue);
        break;
      case policyRewriteTransition.REFRESH_QUOTE:
        policyRewriteActionUtil.refreshQuote(policyRewriteId, isReissue);
        break;
      case policyRewriteTransition.SUBMIT:
        policyRewriteActionUtil.submitPolicyRewrite(policyRewriteId, isReissue);
        break;
      case policyRewriteTransition.START_RATING:
        policyRewriteActionUtil.startRating(policyRewriteId, isReissue);
        break;
      case policyRewriteTransition.SUBMIT_FOR_ISSUANCE:
        policyRewriteActionUtil.submitPolicyRewriteForIssuance(policyRewriteId, isReissue);
        break;
      case policyRewriteTransition.MARK_AS_ISSUED:
        policyRewriteActionUtil.markPolicyRewriteAsIssued(policyRewriteId, submission.id, isReissue);
        break;
      case policyRewriteTransition.REVERT_TO_SUBMITTED:
        policyRewriteActionUtil.revertPolicyRewriteToSubmitted(policyRewriteId, isReissue);
        break;
      case policyRewriteTransition.GENERATE_RATING:
        policyRewriteActionUtil.generateRating(policyRewriteId);
        break;
      case policyRewriteTransition.GENERATE_RATING_ATTACHMENTS:
        policyRewriteActionUtil.generateRatingAttachments(policyRewriteId, submission.id);
        break;
      case policyRewriteTransition.START_PRICING:
        policyRewriteActionUtil.startPricing(policyRewriteId);
        break;
      case policyRewriteTransition.MODIFY_RATING:
        policyRewriteActionUtil.modifyRating(policyRewriteId);
        break;
      case policyRewriteTransition.MODIFY_PRICING:
        policyRewriteActionUtil.modifyPricing(policyRewriteId);
        break;
      case policyRewriteTransition.REVIEW_CHANGES:
        policyRewriteActionUtil.reviewChanges(policyRewriteId, isReissue);
        break;
      default:
        modalUtil.showActionNotImplementedModal(action.name);
        break;
    }
  };
};
WizardActionHandlerUtil.$inject = ["reportActionUtil", "submissionAction", "submissionActionUtil", "submissionTransition", "quoteActionUtil", "renewalTransition", "endorsementActionUtil", "modalUtil", "quoteTransition", "quoteAction", "proposalAction", "quoteMediator", "proposalActionUtil", "externalReportAction", "policyIssuanceAction", "policyIssuanceActionUtil", "policyAction", "policyActionUtil", "policyCancellationAction", "policyCancellationActionUtil", "endorsementTransition", "submissionMediator", "functionActionUtil", "policyRewriteActionUtil", "policyRewriteTransition"];
angular.module('gw-um-submission').service('wizardActionHandlerUtil', WizardActionHandlerUtil);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var WizardActionUtil = function WizardActionUtil($q, submissionConstant, submissionActionsRepository, quoteActionsRepository, reportActionsRepository, policyIssuanceActionsRepository, proposalActionsRepository, policyActionsRepository, policyCancellationActionsRepository, endorsementActionsRepository, policyRewriteActionsRepository) {
  var allActionsPromise = null;

  // Possible ids include: submissionId, quoteId, reportId, policyIssuanceId, proposalId, policyId, policyCancellationId, and endorsementId
  this.getAllActions = function (ids) {
    var promisesList = [],
      actionPromise,
      quotePromise,
      reportPromise,
      policyIssuancePromise,
      proposalPromise,
      policyPromise,
      policyCancellationPromise,
      endorsementPromise,
      policyRewritePromise,
      emptyPromise;
    if (allActionsPromise) {
      return allActionsPromise;
    }
    if (ids.submissionId) {
      actionPromise = submissionActionsRepository.loadSubmissionActions(ids.submissionId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_SUBMISSION;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(actionPromise);
    }
    if (ids.quoteId) {
      quotePromise = quoteActionsRepository.loadQuoteActions(ids.quoteId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_QUOTE;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(quotePromise);
    }
    if (ids.reportId) {
      reportPromise = reportActionsRepository.loadReportActions(ids.reportId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_REPORT;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(reportPromise);
    }
    if (ids.policyIssuanceId) {
      policyIssuancePromise = policyIssuanceActionsRepository.loadPolicyIssuanceActions(ids.policyIssuanceId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_POLICY_ISSUANCE;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(policyIssuancePromise);
    }
    if (ids.proposalId) {
      proposalPromise = proposalActionsRepository.loadProposalActions(ids.proposalId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_PROPOSAL;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(proposalPromise);
    }
    if (ids.policyId) {
      policyPromise = policyActionsRepository.loadPolicyActions(ids.policyId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_POLICY;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(policyPromise);
    }
    if (ids.policyCancellationId) {
      policyCancellationPromise = policyCancellationActionsRepository.loadPolicyCancellationActions(ids.policyCancellationId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_POLICY_CANCELLATION;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(policyCancellationPromise);
    }
    if (ids.endorsementId) {
      endorsementPromise = endorsementActionsRepository.loadEndorsementActions(ids.endorsementId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_ENDORSEMENT;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(endorsementPromise);
    }
    if (ids.policyRewriteId) {
      policyRewritePromise = policyRewriteActionsRepository.loadPolicyRewriteActions(ids.policyRewriteId).then(function (responseData) {
        var actions = {};
        actions['contextType'] = submissionConstant.CONTEXT_POLICY_REWRITE;
        if (responseData === null) {
          actions['actions'] = null;
        } else {
          actions['actions'] = responseData.actions;
        }
        return actions;
      });
      promisesList.push(policyRewritePromise);
    }
    if (promisesList.length === 0) {
      emptyPromise = $q.defer();
      emptyPromise.resolve([]);
      return emptyPromise.promise;
    }
    allActionsPromise = $q.all(promisesList);
    return allActionsPromise;
  };
  this.resetActions = function () {
    allActionsPromise = null;
  };
  this.getActionIds = function (hierarchicalContextList) {
    var actionIds = {};
    _.each(hierarchicalContextList, function (hierarchicalContext) {
      if (hierarchicalContext.contextType === submissionConstant.CONTEXT_SUBMISSION) {
        actionIds.submissionId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_QUOTE) {
        actionIds.quoteId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_REPORT) {
        actionIds.reportId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_ISSUANCE) {
        actionIds.policyIssuanceId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_PROPOSAL) {
        actionIds.proposalId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY) {
        actionIds.policyId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_CANCELLATION) {
        actionIds.policyCancellationId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_ENDORSEMENT) {
        actionIds.endorsementId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_REWRITE) {
        actionIds.policyRewriteId = hierarchicalContext.contextId;
      }
    });
    return actionIds;
  };
};
WizardActionUtil.$inject = ["$q", "submissionConstant", "submissionActionsRepository", "quoteActionsRepository", "reportActionsRepository", "policyIssuanceActionsRepository", "proposalActionsRepository", "policyActionsRepository", "policyCancellationActionsRepository", "endorsementActionsRepository", "policyRewriteActionsRepository"];
angular.module('gw-um-submission').service('wizardActionUtil', WizardActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/wizard/wizard.tpl.html';
var html = "<div class=\"wizardContainer\"\n     ng-class=\"{ displayInline: !isExtraSmallScreen }\">\n\n    <div class=\"wizardLeftSideContainer\"\n         ng-if=\"isExtraSmallScreen\">\n\n        <action-buttons-bar context=\"context\"\n                            actions=\"actions\"\n                            time-last-modified=\"actionsTimeLastModified\"\n                            notify-action-clicked=\"handleAction(action, file)\"></action-buttons-bar>\n    </div>\n\n    <div class=\"wizardRightSideContainer\">\n\n        <wizard-breadcrumbs\n            context=\"viewModel.context\"\n            submission-id=\"viewModel.submissionId\"\n            quote-id=\"viewModel.quoteId\"\n            report-id=\"viewModel.reportId\"\n            policy-issuance-id=\"viewModel.policyIssuanceId\"\n            proposal-id=\"viewModel.proposalId\"\n            policy-cancellation-id=\"viewModel.policyCancellationId\"\n            endorsement-id=\"viewModel.endorsementId\"\n            policy-id=\"viewModel.policyId\"\n            policy-rewrite-id=\"viewModel.policyRewriteId\"\n            progress-label=\"viewModel.wizardProgressLabel\">\n        </wizard-breadcrumbs>\n\n        <action-buttons-bar ng-if=\"!isExtraSmallScreen\"\n                            context=\"context\"\n                            actions=\"actions\"\n                            time-last-modified=\"actionsTimeLastModified\"\n                            notify-action-clicked=\"handleAction(action, file)\"></action-buttons-bar>\n\n        <div class=\"collaborationTogglerWrapper\" ng-class=\"{'anyTogglerActive': isOneDrawerOpen()}\">\n\n            <!--Snippets-->\n            <div class=\"togglerButton snippets\"\n                 ng-class=\"{'active': viewModel.openDrawers.snippets}\"\n                 ng-if=\"viewModel.totalSnippetsItems > 0\"\n                 uib-tooltip=\"{{ ::viewModel.i18n.snippetsIconTooltip }}\"\n                 tooltip-popup-delay=\"500\"\n                 tooltip-append-to-body=\"true\"\n                 tooltip-placement=\"bottom\">\n                <a class=\"btn btn-default btn-outline btn-icon\"\n                   ng-click=\"onToggleSnippets()\"\n                   ng-class=\"{'active': viewModel.openDrawers.snippets}\"\n                   ng-disabled=\"!submissionViewModel.hasSubmissionLoaded\">\n                    <span class=\"glyphicon glyphicon-scissors\"></span>\n                </a>\n            </div>\n\n            <!--Checklist-->\n            <div ng-if=\"viewModel.isUnderwriterWorkstation && viewModel.checklistItemCount\"\n                 class=\"togglerButton\"\n                 ng-class=\"{'active': viewModel.openDrawers.checklist}\"\n                 uib-tooltip=\"{{ ::viewModel.i18n.checklistIconTooltip }}\"\n                 tooltip-popup-delay=\"500\"\n                 tooltip-append-to-body=\"true\"\n                 tooltip-placement=\"bottom\">\n                <a class=\"btn btn-default btn-outline btn-icon\"\n                   ng-click=\"onToggleChecklist()\"\n                   ng-class=\"{'active': viewModel.openDrawers.checklist}\"\n                   ng-disabled=\"!submissionViewModel.hasSubmissionLoaded\">\n                    <span class=\"glyphicon glyphicon-check checklistIconButton\"></span>\n                </a>\n                <span ng-if=\"viewModel.uncheckedChecklistItemCount > 0\"\n                      class=\"checklistToggleBadge\"\n                      ui-browser-detection>{{ viewModel.uncheckedChecklistItemCount }}</span>\n            </div>\n\n            <!--Collaboration-->\n            <div class=\"togglerButton\"\n                 ng-class=\"{'active': viewModel.openDrawers.collaboration}\"\n                 uib-tooltip=\"{{ ::viewModel.i18n.collaborationIconTooltip }}\"\n                 tooltip-popup-delay=\"500\"\n                 tooltip-append-to-body=\"true\"\n                 tooltip-placement=\"left\">\n                <a class=\"btn btn-default btn-outline btn-icon\"\n                   ng-click=\"onToggleCollaboration()\"\n                   ng-class=\"{'active': viewModel.openDrawers.collaboration}\"\n                   ng-disabled=\"!submissionViewModel.hasSubmissionLoaded\">\n                    <img class=\"svgicon icon-collaboration_all_button iconAll\"\n                         src=\"" + __webpack_require__(559) + "\" class=\"iconAll\">\n                </a>\n            </div>\n\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "66dded5873a1fedd1daf2486e5ddff47.svg";

/***/ }),
/* 560 */
/***/ (function(module, exports) {

/*@ngInject*/
var WizardContextModel = function WizardContextModel($rootScope, submissionConstant) {
  var contextId = 0,
    contextType = null,
    contextLabel = '',
    contextUri = '',
    hierarchicalContextList = [];
  this.setContextId = function (contextId) {
    this.contextId = contextId;
  };
  this.getContextId = function () {
    return this.contextId;
  };
  this.setContextType = function (contextType) {
    this.contextType = contextType;
  };
  this.getContextType = function () {
    return this.contextType;
  };
  this.setContextLabel = function (contextLabel) {
    this.contextLabel = contextLabel;
  };
  this.getContextLabel = function () {
    return this.contextLabel;
  };
  this.setContextUri = function (contextUri) {
    this.contextUri = contextUri;
  };
  this.getContextUri = function () {
    return this.contextUri;
  };
  this.setHierarchicalContextList = function (hierarchicalContextList) {
    this.hierarchicalContextList = hierarchicalContextList;
  };
  this.getHierarchicalContextList = function () {
    return this.hierarchicalContextList;
  };
  this.setContext = function (context) {
    this.contextId = context.contextId;
    this.contextType = context.contextType;
    this.contextLabel = context.contextLabel;
    this.contextUri = context.contextUri;
    this.hierarchicalContextList = context.hierarchicalContextList;
  };
  this.getContext = function () {
    return {
      contextId: this.contextId,
      contextType: this.contextType,
      contextLabel: this.contextLabel,
      contextUri: this.contextUri,
      hierarchicalContextList: this.hierarchicalContextList
    };
  };
  this.resetContext = function () {
    contextId = 0;
    contextType = null;
    contextLabel = '';
    contextUri = '';
    hierarchicalContextList = [];
  };
};
WizardContextModel.$inject = ["$rootScope", "submissionConstant"];
angular.module('gw-um-submission').service('wizardContextModel', WizardContextModel);

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(562);
/*@ngInject*/
var WizardController = function WizardController($rootScope, $scope, $stateParams, $state, $timeout, appTypeConfigurationModel, currentSubmissionModel, submissionMediator, checklistMediator, submissionStateMediator, submissionConstant, coreConstant, quoteMediator, formViewerConstant, wizardMediator, wizardActionUtil, wizardActionHandlerUtil) {
  $scope.viewModel = {
    submission: null,
    submissionId: $stateParams.submissionId,
    proposalId: null,
    quoteId: null,
    reportId: null,
    policyIssuanceId: null,
    policyId: null,
    policyCancellationId: null,
    policyRewriteId: null,
    endorsementId: null,
    wizardProgressLabel: '',
    isUnderwriterWorkstation: appTypeConfigurationModel.isUnderwriterWorkstation(),
    uncheckedChecklistItemCount: 0,
    checklistItemCount: 0,
    openDrawers: {
      collaboration: false,
      activityStream: false,
      checklist: false,
      snippets: false
    },
    totalSnippetsItems: [],
    i18n: locale
  };
  $scope.actions = [];
  $scope.context = {
    identifier: 'submission',
    actions: {},
    fallthrough: submissionConstant.CONTEXT_SUBMISSION,
    model: {}
  };
  // Note that order of the context matters due to a "startsWith" check to select a context
  // This mean that contexts which contain a word that is used for the context selection needs to first (e.g. PolicyIssuance, PolicyCancellation, etc... before Policy)
  $scope.context.actions[submissionConstant.CONTEXT_QUOTE] = 'Quote';
  $scope.context.actions[submissionConstant.CONTEXT_REPORT] = 'Report';
  $scope.context.actions[submissionConstant.CONTEXT_PROPOSAL] = 'Proposal';
  $scope.context.actions[submissionConstant.CONTEXT_POLICY_ISSUANCE] = 'PolicyIssuance';
  $scope.context.actions[submissionConstant.CONTEXT_POLICY_CANCELLATION] = 'PolicyCancellation';
  $scope.context.actions[submissionConstant.CONTEXT_POLICY_REWRITE] = 'PolicyRewrite';
  $scope.context.actions[submissionConstant.CONTEXT_POLICY_REISSUE] = 'PolicyReissue';
  $scope.context.actions[submissionConstant.CONTEXT_POLICY] = 'Policy';
  $scope.context.actions[submissionConstant.CONTEXT_ENDORSEMENT] = 'Endorsement';
  function loadActions() {
    var actionIds = wizardActionUtil.getActionIds($scope.context.model.hierarchicalContextList);
    function loadActionsInternal() {
      wizardActionUtil.resetActions();
      wizardActionUtil.getAllActions(actionIds).then(function (allActions) {
        $scope.actions = allActions;
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    if (!_.isNil(currentSubmissionModel.getCurrentNewSubmission())) {
      loadActionsInternal();
    } else {
      submissionMediator.clearCurrentActionRegistrations().finally(function () {
        loadActionsInternal();
      });
    }
  }
  $scope.isOneDrawerOpen = function () {
    var isCollabOpen = $scope.viewModel.openDrawers.collaboration === true,
      isActivityOpen = $scope.viewModel.openDrawers.activityStream === true,
      isChecklistOpen = $scope.viewModel.openDrawers.checklist === true,
      isSnippetsOpen = $scope.viewModel.openDrawers.snippets === true;
    return isCollabOpen || isActivityOpen || isChecklistOpen || isSnippetsOpen;
  };
  $scope.onToggleChecklist = function () {
    $rootScope.$broadcast(submissionConstant.event.CLOSE_COLLABORATION);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_ACTIVITY_STREAM);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_SNIPPETS);
    $rootScope.$broadcast(submissionConstant.event.TOGGLE_CHECKLIST);
  };
  $scope.onToggleCollaboration = function () {
    $rootScope.$broadcast(submissionConstant.event.CLOSE_CHECKLIST);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_ACTIVITY_STREAM);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_SNIPPETS);
    $rootScope.$broadcast(submissionConstant.event.TOGGLE_COLLABORATION);
  };
  $scope.onToggleSnippets = function () {
    $rootScope.$broadcast(submissionConstant.event.CLOSE_CHECKLIST);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_COLLABORATION);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_ACTIVITY_STREAM);
    $rootScope.$broadcast(submissionConstant.event.TOGGLE_SNIPPETS);
  };
  $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
    if (parseInt($stateParams.submissionId) === submission.id) {
      refreshSubmission(submission);
    }
  });
  $scope.$on(submissionConstant.event.ACTIVITY_STREAM_DID_OPEN, function () {
    resetOpenDrawers();
    $scope.viewModel.openDrawers.activityStream = true;
  });
  $scope.$on(submissionConstant.event.COLLABORATION_DID_OPEN, function () {
    resetOpenDrawers();
    $scope.viewModel.openDrawers.collaboration = true;
  });
  $scope.$on(submissionConstant.event.CHECKLIST_DID_OPEN, function () {
    resetOpenDrawers();
    $scope.viewModel.openDrawers.checklist = true;
  });
  $scope.$on(submissionConstant.event.SNIPPETS_DID_OPEN, function () {
    resetOpenDrawers();
    $scope.viewModel.openDrawers.snippets = true;
  });
  $scope.$on(submissionConstant.event.ACTIVITY_STREAM_DID_CLOSE, resetOpenDrawers);
  $scope.$on(submissionConstant.event.COLLABORATION_DID_CLOSE, resetOpenDrawers);
  $scope.$on(submissionConstant.event.CHECKLIST_DID_CLOSE, resetOpenDrawers);
  $scope.$on(submissionConstant.event.SNIPPETS_DID_CLOSE, resetOpenDrawers);
  function resetOpenDrawers() {
    $scope.viewModel.openDrawers.activityStream = false;
    $scope.viewModel.openDrawers.collaboration = false;
    $scope.viewModel.openDrawers.checklist = false;
    $scope.viewModel.openDrawers.snippets = false;
  }
  function loadDrawersState() {
    $scope.viewModel.openDrawers.activityStream = _.get(submissionStateMediator.getActivityStreamState($stateParams.submissionId), 'isOpen');
    $scope.viewModel.openDrawers.checklist = _.get(submissionStateMediator.getChecklistState($stateParams.submissionId), 'isOpen');
    $scope.viewModel.openDrawers.collaboration = _.get(submissionStateMediator.getCollaborationState($stateParams.submissionId), 'isOpen');
    $scope.viewModel.openDrawers.snippets = _.get(submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId), 'isOpen');
  }
  function refreshSubmission(submission) {
    $scope.viewModel.submission = submission;
    refreshChecklistItemCount();
  }
  function refreshChecklistItemCount() {
    checklistMediator.getChecklistItems($stateParams.submissionId).then(function (checkListHierarchy) {
      $scope.viewModel.checklistItemCount = checkListHierarchy.totalCount;
      $scope.viewModel.uncheckedChecklistItemCount = checkListHierarchy.totalUncheckedCount;
    });
  }
  $scope.$on(submissionConstant.event.REFRESH_CHECKLIST_ITEM_COUNT, function () {
    refreshChecklistItemCount();
  });
  $scope.handleAction = function (action, file) {
    wizardActionHandlerUtil.handleAction(action, file, $scope.viewModel.quoteId, $scope.viewModel.reportId, $scope.viewModel.proposalId, $scope.viewModel.policyId, $scope.viewModel.policyIssuanceId, $scope.viewModel.endorsementId, $scope.viewModel.policyCancellationId, $scope.viewModel.policyRewriteId);
  };
  $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function (event, updateActionsMessage, entityType, entityId) {
    var contextActions, contextType;
    if (entityType === 'submission' && parseInt($scope.viewModel.submissionId) === entityId) {
      contextType = submissionConstant.CONTEXT_SUBMISSION;
    } else if (entityType === 'quote' && parseInt($scope.viewModel.quoteId) === entityId) {
      contextType = submissionConstant.CONTEXT_QUOTE;
    } else if (entityType === 'policyissuance' && parseInt($scope.viewModel.policyIssuanceId) === entityId) {
      contextType = submissionConstant.CONTEXT_POLICY_ISSUANCE;
    } else if (entityType === 'proposal' && parseInt($scope.viewModel.proposalId) === entityId) {
      contextType = submissionConstant.CONTEXT_PROPOSAL;
    } else if (entityType === 'policy' && parseInt($scope.viewModel.policyId) === entityId) {
      contextType = submissionConstant.CONTEXT_POLICY;
    } else if (entityType === 'policycancellation' && parseInt($scope.viewModel.policyCancellationId) === entityId) {
      contextType = submissionConstant.CONTEXT_POLICY_CANCELLATION;
    } else if (entityType === 'externalreport' && parseInt($scope.viewModel.reportId) === entityId) {
      contextType = submissionConstant.CONTEXT_REPORT;
    } else if (entityType === 'endorsement' && parseInt($scope.viewModel.endorsementId) === entityId) {
      contextType = submissionConstant.CONTEXT_ENDORSEMENT;
    } else if (entityType === 'policyrewrite' && parseInt($scope.viewModel.policyRewriteId) === entityId) {
      contextType = submissionConstant.CONTEXT_POLICY_REWRITE;
    } else if (entityType === 'policyreissue' && parseInt($scope.viewModel.policyReissueId) === entityId) {
      contextType = submissionConstant.CONTEXT_POLICY_REISSUE;
    }
    contextActions = _.find($scope.actions, {
      'contextType': contextType
    });
    if (contextActions) {
      contextActions.actions = updateActionsMessage.actions.actions;
    }
    $scope.actionsTimeLastModified = new Date().getTime();
  });
  $scope.$on(submissionConstant.event.CONTEXT_CHANGED, function (e, updatedContext) {
    var oldContext = $scope.context.model,
      updatedContextIsEmpty = _.isEmpty(updatedContext.hierarchicalContextList),
      oldContextIsEmpty = _.isEmpty(oldContext.hierarchicalContextList);
    $scope.context.model = updatedContext;
    $scope.viewModel.quoteId = null;
    $scope.viewModel.reportId = null;
    $scope.viewModel.policyIssuanceId = null;
    $scope.viewModel.proposalId = null;
    $scope.viewModel.policyId = null;
    $scope.viewModel.policyCancellationId = null;
    $scope.viewModel.endorsementId = null;
    $scope.viewModel.policyRewriteId = null;
    $scope.viewModel.policyReissueId = null;
    $scope.viewModel.wizardProgressLabel = updatedContext.contextLabel;
    _.each(updatedContext.hierarchicalContextList, function (hierarchicalContext) {
      if (hierarchicalContext.contextType === submissionConstant.CONTEXT_SUBMISSION) {
        $scope.viewModel.submissionId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_QUOTE) {
        $scope.viewModel.quoteId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_REPORT) {
        $scope.viewModel.reportId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_ISSUANCE) {
        $scope.viewModel.policyIssuanceId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_PROPOSAL) {
        $scope.viewModel.proposalId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY) {
        $scope.viewModel.policyId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_CANCELLATION) {
        $scope.viewModel.policyCancellationId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_ENDORSEMENT) {
        $scope.viewModel.endorsementId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_REWRITE) {
        $scope.viewModel.policyRewriteId = hierarchicalContext.contextId;
      } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_REISSUE) {
        $scope.viewModel.policyReissueId = hierarchicalContext.contextId;
      }
    });
    refreshChecklistItemCount();
    if (updatedContextIsEmpty || oldContextIsEmpty) {
      loadActions();
    } else {
      // Find the changes
      handleContextChanges(updatedContext, oldContext);
    }
  });
  function handleContextChanges(newContext, oldContext) {
    var contextsToAdd = _.filter(newContext.hierarchicalContextList, function (contextA) {
        var contextInOldList = _.find(oldContext.hierarchicalContextList, function (contextB) {
          return contextA.contextType === contextB.contextType && contextA.contextId === contextB.contextId;
        });
        return !contextInOldList;
      }),
      contextsToRemove = _.filter(oldContext.hierarchicalContextList, function (contextA) {
        var contextInNewList = _.find(newContext.hierarchicalContextList, function (contextB) {
          return contextB.contextType === contextA.contextType && contextB.contextId === contextA.contextId;
        });
        return !contextInNewList;
      }),
      registrationsToRemove = [],
      registration,
      actionIdsToAdd = {};
    if (!_.isEmpty(contextsToRemove)) {
      _.each(contextsToRemove, function (contextToRemove) {
        registration = {};
        registration.url = currentSubmissionModel.getActionsRegistration(contextToRemove.contextUri);
        registration.contextUri = contextToRemove.contextUri;
        registrationsToRemove.push(registration);
        _.remove($scope.actions, function (contextActions) {
          return contextActions.contextType === contextToRemove.contextType;
        });
      });
    }
    if (!_.isEmpty(contextsToAdd)) {
      actionIdsToAdd = wizardActionUtil.getActionIds(contextsToAdd);
    }
    submissionMediator.deleteActionRegistrations(registrationsToRemove).finally(function () {
      wizardActionUtil.resetActions();
      wizardActionUtil.getAllActions(actionIdsToAdd).then(function (allActions) {
        $scope.actions = _.concat($scope.actions, allActions);
      });
    });
    $scope.actionsTimeLastModified = new Date().getTime();
  }
  $scope.$on(coreConstant.event.QUOTE_DELETED, function () {
    $scope.viewModel.quoteId = null;
  });
  $scope.$on(submissionConstant.event.REFRESH_SNIPPETS_TOGGLER, function (e, snippetsList) {
    $scope.viewModel.totalSnippetsItems = snippetsList.length;
    if ($scope.viewModel.openDrawers.snippets && $scope.viewModel.totalSnippetsItems <= 0) {
      $rootScope.$broadcast(submissionConstant.event.CLOSE_SNIPPETS);
    }
  });
  $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
    submissionMediator.clearCurrentActionRegistrations().finally(function () {
      loadActions();
    });
  });
  loadActions();
  loadDrawersState();
  refreshSubmission(currentSubmissionModel.getCurrentSubmission());
};
WizardController.$inject = ["$rootScope", "$scope", "$stateParams", "$state", "$timeout", "appTypeConfigurationModel", "currentSubmissionModel", "submissionMediator", "checklistMediator", "submissionStateMediator", "submissionConstant", "coreConstant", "quoteMediator", "formViewerConstant", "wizardMediator", "wizardActionUtil", "wizardActionHandlerUtil"];
angular.module('gw-um-submission').controller('wizardController', WizardController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 562 */
/***/ (function(module) {

module.exports = JSON.parse("{\"checklistIconTooltip\":\"Show/hide checklist.\",\"collaborationIconTooltip\":\"Show/hide collaboration.\",\"snippetsIconTooltip\":\"Show/hide snippets.\"}");

/***/ }),
/* 563 */
/***/ (function(module, exports) {

/*@ngInject*/
var WizardMediator = function WizardMediator(wizardContextModel) {
  this.setContextId = function (contextId) {
    wizardContextModel.setContextId(contextId);
  };
  this.getContextId = function () {
    return wizardContextModel.getContextId();
  };
  this.setContextType = function (contextType) {
    wizardContextModel.setContextType(contextType);
  };
  this.getContextType = function () {
    return wizardContextModel.getContextType();
  };
  this.setContextLabel = function (contextLabel) {
    wizardContextModel.setContextLabel(contextLabel);
  };
  this.getContextLabel = function () {
    return wizardContextModel.getContextLabel();
  };
  this.setContextUri = function (contextUri) {
    wizardContextModel.setContextUri(contextUri);
  };
  this.getContextUri = function () {
    return wizardContextModel.getContextUri();
  };
  this.setHierarchicalContextList = function (hierarchicalContextList) {
    wizardContextModel.setHierarchicalContextList(hierarchicalContextList);
  };
  this.getHierarchicalContextList = function () {
    return wizardContextModel.getHierarchicalContextList();
  };
  this.setContext = function (context) {
    wizardContextModel.setContext(context);
  };
  this.getContext = function () {
    return wizardContextModel.getContext();
  };
  this.resetContext = function () {
    wizardContextModel.resetContext();
  };
};
WizardMediator.$inject = ["wizardContextModel"];
angular.module('gw-um-submission').service('wizardMediator', WizardMediator);

/***/ }),
/* 564 */,
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(50);
var uirouter = __webpack_require__(53);
var ngIdle = __webpack_require__(54);
var angularSanitize = __webpack_require__(55);
var uiBootstrap = __webpack_require__(56);
var uiSelect = __webpack_require__(57);
var relativeDate = __webpack_require__(73);
var coreModule = __webpack_require__(109);

/*@ngInject*/
var umExtensionsModule = angular.module('gw-um-extensions', [angularSanitize, ngIdle, uirouter.default, uiBootstrap, uiSelect, relativeDate.default.name, 'currencyFilter', 'isoCurrency', 'dibari.angular-ellipsis', 'ux', coreModule]).config(function () {}).run(["dynamicGridExtension", function (dynamicGridExtension) {}]);
__webpack_require__(94);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
module.exports = 'gw-um-extensions';

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(93);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(570);
var GridDataBrowserComponent = {
  templateUrl: '/gridDataBrowser.tpl.html',
  controller: 'gridDataBrowserController',
  bindings: {
    identifier: '<',
    columns: '<',
    stateParams: '<',
    advancedFilterType: '<',
    filterType: '<',
    translations: '<',
    initialRequestParams: '<',
    loadFilterHandler: '<',
    loadItemsHandler: '<',
    loadActionsHandler: '<',
    notifyHandleAction: '&',
    notifyHandleBulkAction: '&',
    showSelector: '<',
    singleSelect: '<'
  }
};
angular.module('gw-um-grid-data-browser').component('uiGridDataBrowser', GridDataBrowserComponent);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/gridDataBrowser.tpl.html';
var html = "<div class=\"header\"\r\n     ng-show=\"!$ctrl.isBulkActionActive\">\r\n\r\n    <div class=\"headerContent\">\r\n\r\n        <div class=\"headerLabel\">{{ ::$ctrl.translations.title }}</div>\r\n\r\n        <action-buttons-bar context=\"$ctrl.context\"\r\n                            actions=\"$ctrl.actions\"\r\n                            hidden-input-actions=\"$ctrl.hiddenInputActions\"\r\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\r\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"header bulkActionHeader\" ng-show=\"$ctrl.isBulkActionActive\">\r\n\r\n    <div class=\"headerContent\">\r\n\r\n        <div class=\"circleText\">{{ $ctrl.bulkActionCount }}</div>\r\n\r\n        <div class=\"headerLabel bulkActionLabel\">{{ ::$ctrl.translations.bulkActionLabel }}</div>\r\n\r\n        <button ng-click=\"$ctrl.onCancelBulkAction()\" class=\"btn actionButtonsBorderWidth cancel cancelBulkAction\">\r\n            <span>{{ ::$ctrl.translations.bulkActionCancelButtonLabel }}</span>\r\n        </button>\r\n\r\n        <button ng-click=\"$ctrl.onBulkAction()\"\r\n                class=\"btn btn-primary actionButtonsBorderWidth bulkActionButton\"\r\n                ng-disabled=\"$ctrl.bulkActionCount === 0\">\r\n            <span>{{ $ctrl.activeBulkAction.bulkActionLabel }}</span>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<!-- Tools -->\r\n<div class=\"tools\"\r\n     ng-if=\"!$ctrl.isBulkActionActive\">\r\n\r\n    <div class=\"toolsContent\">\r\n\r\n        <ui-advanced-filter-list\r\n            class=\"advancedFilterListWrapper\"\r\n            filter-model=\"$ctrl.filterModel\"\r\n            show-all-templates=\"true\"\r\n            advanced-filter-type=\"$ctrl.advancedFilterType\"\r\n            translations-key=\"$ctrl.identifier\"\r\n            allow-clear-filter=\"true\"\r\n            one-clear-filter=\"true\"\r\n            clear-filter-is-link=\"true\">\r\n        </ui-advanced-filter-list>\r\n    </div>\r\n</div>\r\n\r\n<!-- Grid -->\r\n<div class=\"grid\">\r\n\r\n    <div class=\"gridContainer\">\r\n\r\n        <!-- Grid Header -->\r\n        <div class=\"columnHeader\">\r\n\r\n            <div class=\"columnRow\">\r\n\r\n                <div class=\"colHover\"></div>\r\n\r\n                <div class=\"col bulkActionColumn\"\r\n                     ng-show=\"$ctrl.isShowSelector()\">\r\n                    <input type=\"checkbox\"\r\n                           ng-change=\"$ctrl.onBulkActionAllCheckboxClick()\"\r\n                           ng-model=\"$ctrl.isBulkActionAllSelected\"\r\n                           ng-show=\"!$ctrl.singleSelect\">\r\n                </div>\r\n\r\n                <div ng-repeat=\"column in $ctrl.columns track by $index\"\r\n                     class=\"{{ ::column.className }}\"\r\n                     ui-grid-sortable-header\r\n                     request-params=\"$ctrl.requestParams\"\r\n                     item-name=\"{{ ::column.name }}\"\r\n                     item-label=\"{{ ::column.label }}\"\r\n                     on-toggle=\"$ctrl.onSortChange($event, params)\"></div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"datagrid table\"\r\n             ux-datagrid=\"$ctrl.items\"\r\n             ng-if=\"!$ctrl.isLoading\"\r\n             ui-scroll-detection\r\n             ui-scroll-detection-target=\".columnHeader\"\r\n             ng-mousedown=\"$ctrl.onGridMouseDown($event)\">\r\n\r\n            <script type=\"template/html\"\r\n                    data-template-item=\"item\"\r\n                    data-template-name=\"default\">\r\n\r\n                <div class=\"columnRow\">\r\n\r\n                    <div class=\"columnRowWrapper\">\r\n\r\n                        <div class=\"col bulkActionColumn\"\r\n                             ng-if=\"$ctrl.isShowSelector()\">\r\n\r\n                            <input type=\"checkbox\"\r\n                                   ng-change=\"$ctrl.onBulkActionCheckboxClick($event, item)\"\r\n                                   ng-model=\"item.selected\"/>\r\n                        </div>\r\n\r\n                        <div ng-repeat=\"column in $ctrl.columns track by $index\"\r\n                             class=\"col {{ ::column.className }}\"\r\n                             row-index=\"{{ ::$parent.$index }}\"\r\n                             ng-click=\"$ctrl.onClickRow($event, item)\">\r\n\r\n                            <span ng-repeat=\"columnItem in (column.getColumnItems(item) || [item]) track by $index\"\r\n                                  ng-class=\"{ 'tag': column.isTag(columnItem), 'columnText': !column.isTag(columnItem)}\"\r\n                                  uib-tooltip=\"{{ ::column.getValue(columnItem) }}\"\r\n                                  tooltip-append-to-body=\"true\"\r\n                                  tooltip-popup-delay=\"500\"\r\n                                  tooltip-enable=\"{{ item['enableTooltip.' + column.name] }}\"\r\n                                  ui-is-tooltip-enabled=\"item['enableTooltip.' + column.name]\">{{ ::column.getValue(columnItem) }}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </script>\r\n        </div>\r\n\r\n        <ui-grid-paging-component\r\n            ng-hide=\"$ctrl.totalItems === 0\"\r\n            start-index=\"$ctrl.requestParams.startIndex\"\r\n            page-size=\"$ctrl.requestParams.pageSize\"\r\n            total-records=\"$ctrl.totalItems\"\r\n            record-count-text=\"$ctrl.translations.recordCountText\"\r\n            records-count-text=\"$ctrl.translations.recordsCountText\"\r\n            on-change=\"$ctrl.onPagingChange($event, params)\">\r\n        </ui-grid-paging-component>\r\n\r\n        <div class=\"gridEmpty\"\r\n             ng-if=\"$ctrl.isGridEmpty && !$ctrl.isLoading\">{{ ::$ctrl.translations.emptyGrid }}\r\n        </div>\r\n\r\n        <div class=\"icon-spinner\"\r\n             ng-if=\"$ctrl.isLoading\">\r\n            <img src=\"" + __webpack_require__(569) + "\"/>\r\n        </div>\r\n    </div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d499ab556d929865f461acb8f2a13bf.svg";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {var locale = __webpack_require__(93);

/*@ngInject*/
var GridDataBrowserController = function GridDataBrowserController($rootScope, currentUserModel, $scope, $timeout, $element, $state, coreConstant, advancedFilterModel, advancedFilterMediator, navigationStateModel, gridDataBrowserConstant, formTemplateStatus, uIFormTemplateAction) {
  var _this11 = this;
  this.$onInit = function () {
    $element.addClass('gridDataBrowser');
    $element.addClass(this.identifier);
    this.i18n = locale;
    this.isLoading = true;
    this.filterModel = null;
    this.items = [];
    this.totalItems = 0;
    this.isGridEmpty = true;
    this.isBulkActionActive = false;
    this.activeBulkAction = null;
    this.bulkActionLabel = '';
    this.isBulkActionAllSelected = false;
    this.isBulkActionAllProcessing = false;
    this.bulkActionLastSelectedIndex = -1;
    this.bulkActionCount = 0;
    this.bulkActionSelectedItems = [];
    this.bulkActionFilterUri = null;
    this.bulkActionExcludedItems = [];
    this.requestParams = {
      key: this.initialRequestParams.key,
      startIndex: this.initialRequestParams.startIndex,
      pageSize: this.initialRequestParams.pageSize,
      sortType: this.initialRequestParams.sortType
    };
    this.actions = [];
    this.hiddenInputActions = {};
    this.context = {
      identifier: this.identifier,
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.resetNavigationState();
    this.loadFilter();
    this.loadActions();
  };
  this.isShowSelector = function () {
    return this.showSelector || this.isBulkActionActive;
  };
  this.loadActions = function () {
    var _this = this;
    this.loadActionsHandler().then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: _this.context.model.contextType
      });
      _this.actions = allActions;
      _this.hiddenInputActions = actions.hiddenInputActions;
      _this.actionsTimeLastModified = new Date().getTime();
      if (allActions.length === 1 && allActions[0].actions && allActions[0].actions.length === 1 && allActions[0].actions[0].defaultExecute) {
        _this.handleAction(allActions[0].actions[0]);
      }
    });
  };
  this.loadItems = function () {
    var _this2 = this;
    this.isLoading = true;
    return this.loadItemsHandler(this.filterModel.filter.uri, this.requestParams).then(function (items) {
      _this2.items = items.records;
      _this2.totalItems = items.totalRecords;
      _this2.isGridEmpty = _this2.totalItems === 0;

      // specific to dynamicGrid
      if (!_this2.isBulkActionActive && _this2.showSelector) {
        if (_this2.items) {
          if (_this2.isBulkActionActive && _this2.activeBulkAction.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
            var originalItemslength = _this2.items.length;
            _this2.items = _.filter(_this2.items, function (item) {
              return item.isValid;
            });
            _this2.totalItems = items.totalRecords - (originalItemslength - _this2.items.length);
            _this2.isGridEmpty = _this2.totalItems === 0;
          }
          _.each(_this2.items, function (item) {
            if (item.selected && !_this2.bulkActionSelectedItems.find(function (i) {
              return i.id === item.id;
            })) {
              _this2.bulkActionSelectedItems.push(item);
            }
          });
        }
        $scope.$emit(coreConstant.event.gridSelectionChanged, _this2.bulkActionSelectedItems);
      }
      $timeout(function () {
        $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
        _this2.isLoading = false;
      }, 0);
    });
  };
  this.useFilter = function (filter) {
    var _this3 = this;
    if (!_.isNil(filter)) {
      advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
        advancedFilterModel.buildFilter(_this3.advancedFilterType, filterTemplate, filter, true);
        _this3.filterModel = advancedFilterModel.getAdvancedFilterModel(_this3.advancedFilterType);
        _this3.loadItems();
      });
    }
  };
  this.loadFilter = function () {
    var _this4 = this;
    var existingFilterModel = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType);
    if (!this.loadFilterHandler && !_.isNil(existingFilterModel) && !_.isNil(existingFilterModel.filter)) {
      this.filterModel = existingFilterModel;
      this.loadItems();
    } else {
      if (this.loadFilterHandler) {
        this.loadFilterHandler().then(function (filter) {
          _this4.useFilter(filter);
        });
      } else {
        advancedFilterMediator.getFilters(this.filterType).then(function (filters) {
          var filter = _.first(filters);
          _this4.useFilter(filter);
        });
      }
    }
  };
  this.onClickRow = function (event, item) {
    if (this.isShowSelector()) {
      this.handleBulkActionRowSelection(event, item, true);
    } else {
      var detailState = this.stateParams.getDetailState(item);
      var navigationModel = {
        parentState: this.stateParams.browser,
        currentState: detailState.name,
        data: detailState.params
      };
      $state.go(detailState.name, detailState.params);
      navigationStateModel.saveViewState(this.stateParams.browser, navigationModel);
    }
  };
  this.onPagingChange = function (event, params) {
    var _this5 = this;
    this.requestParams.startIndex = params.startIndex;
    this.bulkActionLastSelectedIndex = -1;
    this.loadItems().then(function () {
      _this5.updateBulkActionSelection();
    });
  };
  this.onSortChange = function (event, params) {
    var _this6 = this;
    this.requestParams.key = params.key;
    this.requestParams.sortType = params.sortType;
    this.bulkActionLastSelectedIndex = -1;
    this.loadItems().then(function () {
      _this6.updateBulkActionSelection();
    });
  };
  this.resetNavigationState = function () {
    navigationStateModel.saveViewState(this.stateParams.browser, null);
  };
  this.handleAction = function (action, file) {
    if (action.isBulkAction && action.enabled) {
      if (action.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
        this.applyCriterionFilters({
          'Status': formTemplateStatus.DRAFT
        });
      }
      this.isBulkActionActive = true;
      this.activeBulkAction = action;
    } else {
      this.notifyHandleAction({
        action: action,
        file: file
      });
    }
  };
  this.onBulkAction = function () {
    this.notifyHandleBulkAction({
      action: this.activeBulkAction,
      selectedItems: this.bulkActionSelectedItems,
      excludedItems: this.bulkActionExcludedItems,
      filterUri: this.bulkActionFilterUri
    });
  };
  this.onCancelBulkAction = function () {
    this.resetBulkActionState();
  };
  this.onBulkActionCheckboxClick = function (event, item) {
    this.handleBulkActionRowSelection(event, item, false);
    if (event) {
      event.stopPropagation();
    }
  };
  this.onBulkActionAllCheckboxClick = function () {
    var _this7 = this;
    this.bulkActionSelectedItems = [];
    this.bulkActionFilterUri = null;
    this.bulkActionExcludedItems = [];
    this.isBulkActionAllProcessing = this.isBulkActionAllSelected;
    _.each(this.items, function (item) {
      item.selected = _this7.isBulkActionAllProcessing;
      // specific to dynamicGrid
      if (!_this7.isBulkActionActive && _this7.showSelector) {
        if (item.selected && _this7.bulkActionSelectedItems.indexOf(item) < 0) {
          _this7.bulkActionSelectedItems.push(item);
        } else if (_this7.bulkActionSelectedItems.indexOf(item) >= 0) {
          _this7.bulkActionSelectedItems.splice(_this7.bulkActionSelectedItems.indexOf(item), 1);
        }
      }
    });
    if (this.isBulkActionAllProcessing) {
      this.bulkActionFilterUri = this.filterModel.filter.uri;
      this.bulkActionCount = this.totalItems;
    } else {
      this.bulkActionCount = 0;
    }
    $scope.$emit(coreConstant.event.gridSelectionChanged, this.bulkActionSelectedItems);
  };
  this.updateBulkActionSelection = function () {
    var _this8 = this;
    if (this.isBulkActionAllProcessing) {
      this.bulkActionCount = this.totalItems - _.size(this.bulkActionExcludedItems);
      _.each(this.items, function (item) {
        var exclusions = _.find(_this8.bulkActionExcludedItems, function (bulkActionExcludedItem) {
          return bulkActionExcludedItem.id === item.id;
        });
        item.selected = _.isNil(exclusions);
      });
    } else {
      _.each(this.items, function (item) {
        var selected = _.find(_this8.bulkActionSelectedItems, function (bulkActionSelectedItem) {
          return bulkActionSelectedItem.id === item.id;
        });
        item.selected = !_.isNil(selected);
      });
    }
  };
  this.resetBulkActionState = function () {
    this.resetPublishFormTemplatesActionState();
    this.isBulkActionActive = false;
    this.activeBulkAction = null;
    this.isBulkActionAllSelected = false;
    this.isBulkActionAllProcessing = false;
    this.bulkActionCount = 0;
    this.bulkActionSelectedItems = [];
    this.bulkActionFilterUri = null;
    this.bulkActionExcludedItems = [];
    _.each(this.items, function (item) {
      if (item.selected) {
        item.selected = false;
      }
    });
  };
  this.handleBulkActionRowSelection = function (event, rowItem, toggleSelected) {
    var _this9 = this;
    if (this.singleSelect) {
      _.each(this.items, function (item, index) {
        if (item.id !== rowItem.id) {
          item.selected = false;
        }
      });
      rowItem.selected = true;
      this.handleBulkActionSelection(rowItem, null);
      this.bulkActionCount = 1;
    } else {
      var shiftKeyPressed = event && event.shiftKey,
        previouslySelected = this.handleBulkActionCheckboxToggle(rowItem, toggleSelected, shiftKeyPressed);
      this.handleBulkActionSelection(rowItem, previouslySelected);
      if (shiftKeyPressed) {
        this.handleBulkActionShiftKeySelection(rowItem);
      } else if (!_.isNil(event)) {
        _.each(this.items, function (item, index) {
          if (item.id === rowItem.id) {
            _this9.bulkActionLastSelectedIndex = index;
            return false;
          }
        });
      }
    }
  };
  this.handleBulkActionCheckboxToggle = function (item, toggleSelected, shiftKeyPressed) {
    var previouslySelected = false;
    if (toggleSelected && !shiftKeyPressed) {
      item.selected = !item.selected;
    } else if (shiftKeyPressed) {
      previouslySelected = toggleSelected ? item.selected : !item.selected;
      item.selected = true;
    }
    return previouslySelected;
  };
  this.handleBulkActionSelection = function (item, previouslySelected) {
    if (this.singleSelect) {
      this.bulkActionSelectedItems = [];
    }
    if (item.selected) {
      if (!previouslySelected) {
        this.bulkActionCount++;
        /* this.showSelector is direct select mode -- doesn't use exclude mode */
        if (!_.isNil(this.bulkActionFilterUri) && !this.showSelector) {
          _.remove(this.bulkActionExcludedItems, function (bulkActionExcludedItem) {
            return bulkActionExcludedItem.id === item.id;
          });
        } else {
          this.bulkActionSelectedItems.push(item);
        }
      }
    } else {
      this.isBulkActionAllSelected = false;
      this.bulkActionCount--;
      if (!_.isNil(this.bulkActionFilterUri) && !this.showSelector) {
        this.bulkActionExcludedItems.push(item);
      } else {
        _.remove(this.bulkActionSelectedItems, function (bulkActionSelectedItem) {
          return bulkActionSelectedItem.id === item.id;
        });
      }
    }
    $scope.$emit(coreConstant.event.gridSelectionChanged, this.bulkActionSelectedItems);
  };
  this.handleBulkActionShiftKeySelection = function (rowItem) {
    var _this10 = this;
    var currentSelectedIndex;
    _.each(this.items, function (item, index) {
      if (item.id === rowItem.id) {
        currentSelectedIndex = index;
        return false;
      }
    });
    _.each(this.items, function (item, index) {
      if (index < currentSelectedIndex && index > _this10.bulkActionLastSelectedIndex || index > currentSelectedIndex && index < _this10.bulkActionLastSelectedIndex) {
        if (!item.selected) {
          _this10.handleBulkActionRowSelection(null, item, true);
        }
      }
    });
  };
  this.onGridMouseDown = function (event) {
    if (event.target.offsetWidth <= event.clientX + 15) {
      $timeout(function () {
        $('.datagrid').click();
      }, 0);
    }
  };
  $scope.$on(coreConstant.event.FILTER_SAVED, function (event, filter) {
    advancedFilterModel.getAdvancedFilterModel(_this11.advancedFilterType).filter = filter;
    $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
  });
  $scope.$on(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE, function () {
    _this11.resetBulkActionState();
    _this11.loadFilter();
    $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
  });
  this.applyCriterionFilters = function (criterionFilters) {
    var currentFilterChanged;
    var filterNames = Object.keys(criterionFilters);
    var selectedCriterionTemplates = this.filterModel.selectedFilterCriterionTemplates;
    _.each(selectedCriterionTemplates, function (selectedCriterionTemplate) {
      if (_.isEmpty(filterNames)) {
        return false;
      }
      if (filterNames.includes(selectedCriterionTemplate.name)) {
        selectedCriterionTemplate.value = criterionFilters[selectedCriterionTemplate.name];
        currentFilterChanged = true;
        _.pull(filterNames, selectedCriterionTemplate.name);
      }
    });
    if (currentFilterChanged) {
      this.isLoading = true;
      this.updateFilter();
    }
  };
  this.resetPublishFormTemplatesActionState = function () {
    if (_this11.activeBulkAction.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
      _this11.applyCriterionFilters({
        'Status': ''
      });
    }
  };
  this.updateFilter = function () {
    var filter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);
    if (!advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).temporary) {
      filter.temporary = true;
      filter.uri = null;
    }
    filter.userId = currentUserModel.getCurrentUser().userId;
    advancedFilterMediator.saveFilter(filter).then(function (filter) {
      $scope.$emit(coreConstant.event.FILTER_SAVED, filter);
    });
  };
};
GridDataBrowserController.$inject = ["$rootScope", "currentUserModel", "$scope", "$timeout", "$element", "$state", "coreConstant", "advancedFilterModel", "advancedFilterMediator", "navigationStateModel", "gridDataBrowserConstant", "formTemplateStatus", "uIFormTemplateAction"];
angular.module('gw-um-grid-data-browser').controller('gridDataBrowserController', GridDataBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

var path = '/dynamicGrid.tpl.html';
var html = "<ui-grid-data-browser\r\n    identifier=\"'dynamicGrid'\"\r\n    columns=\"columns\"\r\n    state-params=\"stateParams\"\r\n    advanced-filter-type=\"advancedFilterType\"\r\n    filter-type=\"filterType\"\r\n    translations=\"translations\"\r\n    initial-request-params=\"initialRequestParams\"\r\n    load-items-handler=\"loadItemsHandler\"\r\n    load-actions-handler=\"loadActionsHandler\"\r\n    notify-handle-action=\"handleAction(action, file)\"\r\n    notify-handle-bulk-action=\"handleBulkAction(action, selectedItems, excludedItems, filterId)\"\r\n    show-selector=\"showSelector\"\r\n    single-select=\"false\">\r\n</ui-grid-data-browser>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

var path = '/dynamicGridModal.tpl.html';
var html = "<div class=\"dynamicGridModal\">\r\n\r\n  <div class=\"dynamicGrid\">\r\n\r\n    <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\">{{::title}}</h3>\r\n        <button class=\"close\"\r\n                ng-click=\"onCancel()\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n        </button>\r\n    </div>\r\n\r\n    <div ui-browser-detection class=\"modal-body\">\r\n        <ui-grid-data-browser\r\n            identifier=\"'dynamicGrid'\"\r\n            columns=\"columns\"\r\n            state-params=\"stateParams\"\r\n            advanced-filter-type=\"advancedFilterType\"\r\n            filter-type=\"filterType\"\r\n            translations=\"translations\"\r\n            initial-request-params=\"initialRequestParams\"\r\n            load-filter-handler=\"loadFilterHandler\"\r\n            load-items-handler=\"loadItemsHandler\"\r\n            load-actions-handler=\"loadActionsHandler\"\r\n            notify-handle-action=\"handleAction(action, file)\"\r\n            notify-handle-bulk-action=\"handleBulkAction(action, selectedItems, excludedItems, filterId)\"\r\n            show-selector=\"showSelector\"\r\n            single-select=\"singleSelect\">\r\n        </ui-grid-data-browser>\r\n    </div>\r\n\r\n    <!--Footer-->\r\n    <div class=\"modal-footer\">\r\n        <div class=\"resultInfo\">\r\n            <span class=\"dynamicDataResults\">{{result.totalRecords}} Results</span>\r\n            <span class=\"dynamicDataMaxDisplay\" ng-show=\"result.totalRecords>=initialRequestParams.pageSize\">(Max. Display)</span>\r\n\t\t\t<span class=\"dynamicDataSelected\" ng-show=\"!singleSelect\">| {{selected.length}} Selected</span>\r\n        </div>\r\n\r\n        <button class=\"btn btn-default cancelButton\"\r\n                ng-click=\"onCancel()\"\r\n                >{{::cancelButton}}</button>\r\n         <button class=\"btn btn-primary okButton okButton\"\r\n                 ng-disabled=\"!(selected.length>0)\"\r\n                 ng-click=\"onOk()\"\r\n                 >{{okButton}}</button>\r\n        <button class=\"btn btn-default thirdButton\"\r\n                ng-click=\"onThirdButton()\"\r\n                ng-show=\"thirdButton\"\r\n                >{{::thirdButton}}</button>\r\n    </div>\r\n\r\n  </div>\r\n\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

/*@ngInject*/
var DynamicDataRepository = function DynamicDataRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getFilter = function (dataName, filterType, context) {
    var url = '/rest/DynamicData/' + dataName + '/filter/type/' + filterType,
      params = {};
    return this.post(url, context, {
      params: params
    }).then(function (result) {
      return result;
    });
  };
  this.find = function (dataName, criteria, filterUri) {
    var url = '/rest/DynamicData/' + dataName + '/filter',
      config = {
        params: {
          filterUri: filterUri
        }
      };
    return this.post(url, criteria, config).then(function (result) {
      return result;
    });
  };
  this.execute = function (dataName, actionName, target) {
    var url = '/rest/DynamicData/' + dataName + '/action/' + actionName;
    return this.post(url, target).then(function (result) {
      return result;
    });
  };
};
DynamicDataRepository.$inject = ["baseRepository"];
angular.module('gw-um-extensions').service('dynamicDataRepository', DynamicDataRepository);

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {var locale = __webpack_require__(94);

/*@ngInject*/
var DynamicGridController = function DynamicGridController($rootScope, $scope, $filter, $stateParams, options, localization, coreMediator, coreConstant, loadingBarHandler, advancedFilterType, filterType, dataSetType, dynamicDataRepository, modalUtil, gridDataBrowserConstant) {
  $scope.i18n = locale;
  $scope.translations = locale;
  $scope.title = 'Demo Dynamic Grid';
  $scope.showSelector = true;
  $scope.singleSelect = false;
  $scope.dataName = "producer";
  $scope.context = {
    submissionId: $stateParams.submissionId,
    formId: $stateParams.formId
  };
  $scope.selected = [];
  $scope.cancelButton = 'Cancel';
  $scope.okButton = 'Select';
  $scope.thirdButton = "No Match";
  $scope.columns = [];
  $scope.advancedFilterType = 'dynamicGrid';
  $scope.filterType = 101;
  $scope.initialRequestParams = {
    key: 'name',
    sortType: 'asc',
    startIndex: 0,
    pageSize: 25
  };
  if (options.customOptions) {
    if (options.customOptions.confirmationTitle) {
      $scope.title = options.customOptions.confirmationTitle;
    }
    if (options.customOptions.yesButtonLabel) {
      $scope.okButton = options.customOptions.yesButtonLabel;
    }
    if (options.customOptions.noButtonLabel) {
      $scope.cancelButton = options.customOptions.noButtonLabel;
    }
    if (options.customOptions.processingIndicatorText) {
      $scope.processingIndicatorText = options.customOptions.processingIndicatorText;
    }
    if (options.customOptions.parameters) {
      $scope.parameters = JSON.parse(options.customOptions.parameters);
      Object.assign($scope, $scope.parameters);
    }
  } else {
    $scope.view = $stateParams.view;
  }

  // get more details about the context from the function button triggering this
  if (options.context) {
    Object.assign($scope.context, options.context);
  }
  $scope.stateParams = {
    browser: 'um.dynamicGrid',
    getDetailState: function getDetailState(input) {}
  };

  // load configuration from system preference system.views.<view> using $scope.view
  if ($scope.view) {
    $scope.advancedFilterType = $scope.view;
    coreMediator.loadDefaultPreferences().then(function (preferences) {
      var prefKey = 'system.views.' + $scope.view;
      if (preferences[prefKey]) {
        var prefValue = preferences[prefKey].value;
        var viewProps = JSON.parse(prefValue);
        Object.assign($scope, viewProps);
        if (viewProps.columns) {
          _.each(viewProps.columns, function (column) {
            column.getValue = function (item) {
              return item[column.valueProp];
            };
          });
        }
      }
      // still make the function button parameters overwrite the system preferences since the button config is easier to change
      if (options.customOptions) {
        if (options.customOptions.confirmationTitle) {
          $scope.title = options.customOptions.confirmationTitle;
        }
        if (options.customOptions.yesButtonLabel) {
          $scope.okButton = options.customOptions.yesButtonLabel;
        }
        if (options.customOptions.noButtonLabel) {
          $scope.cancelButton = options.customOptions.noButtonLabel;
        }
        if (options.customOptions.processingIndicatorText) {
          $scope.processingIndicatorText = options.customOptions.processingIndicatorText;
        }
        if (options.customOptions.parameters) {
          $scope.parameters = JSON.parse(options.customOptions.parameters);
          Object.assign($scope, $scope.parameters);
        }
      }
    });
  }

  // load the default filter using $scope.context
  $scope.loadFilterHandler = function () {
    return dynamicDataRepository.getFilter($scope.dataName, $scope.filterType, $scope.context).then(function (result) {
      return result;
    });
  };

  // load grid data items
  $scope.loadItemsHandler = function (filterUri, requestParams) {
    if ($scope.width) {
      $('.modal-content').width($scope.width);
    }
    if ($scope.height) {
      $('.modal-content').height($scope.height);
    }
    var criteria = {
      sortBy: requestParams.key,
      sortDirection: requestParams.sortType,
      startIndex: requestParams.startIndex,
      maxResults: requestParams.pageSize
    };
    criteria.context = $scope.context;
    return dynamicDataRepository.find($scope.dataName, criteria, filterUri).then(function (result) {
      $scope.result = {
        totalRecords: result.count,
        records: result.items
      };
      // save the items not in current display list separately
      $scope.selectedOutOfResults = [];
      if (result.selectedItems) {
        $scope.selected = result.selectedItems;
        _.each(result.selectedItems, function (item) {
          var exists = false;
          _.each(result.items, function (existing) {
            // use toString to compare just in case some ids are saved as string, some as number
            if (item["id"] && existing["id"] && item["id"].toString() === existing["id"].toString()) {
              exists = true;
            }
          });
          if (!exists) {
            $scope.selectedOutOfResults.push(item);
          }
        });
      }
      return $scope.result;
    });
  };

  // not really used -- just to fill parameters for gridDataBrowser
  $scope.action = {
    name: "Select",
    valid: true,
    enabled: true,
    buttonBarAction: true,
    /*isBulkAction:true,*/bulkActionLabel: 'Confirm',
    defaultExecute: true
  };
  $scope.loadActionsHandler = function () {
    return coreMediator.loadDefaultPreferences().then(function (preferences) {
      return {
        actions: [$scope.action]
      };
    });
  };

  // not really used -- just to fill parameters for gridDataBrowser
  $scope.handleAction = function (action, file) {
    if (action.enabled) {
      switch
        //                default:
        //                    modalUtil.showActionNotImplementedModal(action.name);
        //                    break;
      (action.name) {}
    }
  };

  // not really used -- just to fill parameters for gridDataBrowser
  $scope.handleBulkAction = function (action, selectedItems, excludedItems, filterUri) {
    if (action.enabled) {
      switch (action.name) {
        default:
          return dynamicDataRepository.execute($scope.dataName, action.name, {
            data: selectedItems
          }).then(function (result) {
            return result;
          });
          $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
          break;
      }
    }
  };

  // track selected items independent of gridDataBrowser
  $scope.$on(coreConstant.event.gridSelectionChanged, function (event, selected) {
    $scope.selected = $scope.selectedOutOfResults.concat([]);
    // only add items not in the non-display selected set
    _.each(selected, function (item) {
      var exists = false;
      _.each($scope.selected, function (existing) {
        if (item["id"] && existing["id"] && item["id"].toString() === existing["id"].toString()) {
          exists = true;
        }
      });
      if (!exists) {
        $scope.selected.push(item);
      }
    });
  });

  // main action
  $scope.onOk = function () {
    var target = {
      name: $scope.dataName,
      context: $scope.context,
      count: $scope.selected.length,
      items: $scope.selected
    };
    loadingBarHandler.showLoadingBar($scope.processingIndicatorText);
    return dynamicDataRepository.execute($scope.dataName, $scope.okButton, target).then(function (result) {
      loadingBarHandler.hideLoadingBar();
      $scope.$close();
      return result;
    });
  };
  $scope.onThirdButton = function () {
    var target = {
      name: $scope.dataName,
      context: $scope.context,
      count: $scope.selected.length,
      items: $scope.selected
    };
    loadingBarHandler.showLoadingBar($scope.processingIndicatorText);
    return dynamicDataRepository.execute($scope.dataName, $scope.thirdButton, target).then(function (result) {
      loadingBarHandler.hideLoadingBar();
      $scope.$close();
      return result;
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
DynamicGridController.$inject = ["$rootScope", "$scope", "$filter", "$stateParams", "options", "localization", "coreMediator", "coreConstant", "loadingBarHandler", "advancedFilterType", "filterType", "dataSetType", "dynamicDataRepository", "modalUtil", "gridDataBrowserConstant"];
angular.module('gw-um-extensions').controller('dynamicGridController', DynamicGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 577 */
/***/ (function(module, exports) {

/*@ngInject*/
var DynamicGridExtension = function DynamicGridExtension($rootScope, coreConstant, $uibModal) {
  $rootScope.$on(coreConstant.event.functionExecute, function (event, customOptions, context) {
    if (customOptions.functionClass === 'DynamicGridPopup') {
      $uibModal.open({
        templateUrl: '/dynamicGridModal.tpl.html',
        controller: 'dynamicGridController',
        windowClass: 'dynamicGridModal',
        resolve: {
          options: function options() {
            return {
              customOptions: customOptions,
              context: context
            };
          }
        },
        keyboard: false,
        backdrop: 'static'
      });
    }
  }.bind(this));
};
DynamicGridExtension.$inject = ["$rootScope", "coreConstant", "$uibModal"];
angular.module('gw-um-extensions').service('dynamicGridExtension', DynamicGridExtension);

/***/ }),
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "15cc5dd965b1d13936ca0d0337ef7dbb.svg";

/***/ }),
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {// require('jquery');
// window.$ = $;
// window.jQuery = $;

__webpack_require__(0);
__webpack_require__(2);
__webpack_require__(1780);
__webpack_require__(26);
__webpack_require__(50);
__webpack_require__(139);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(750);
__webpack_require__(751);
var authModule = __webpack_require__(110);
var coreModule = __webpack_require__(58);
var submissionGridModule = __webpack_require__(144);
var submissionModule = __webpack_require__(162);
var j2jsModule = __webpack_require__(143);
var umLandingModule = __webpack_require__(1783);
var extensionsModule = __webpack_require__(565);
angular.module('ums', [coreModule, authModule, submissionGridModule, submissionModule, j2jsModule, umLandingModule, extensionsModule]).config(function () {}).run(["$location", "appTypeConfigurationModel", "coreConstant", function ($location, appTypeConfigurationModel, coreConstant) {
  var consoleType;
  if (_.includes($location.absUrl(), '/umagent')) {
    consoleType = coreConstant.authorization.CONSOLE_TYPE_UM_AGENT;
  } else {
    consoleType = coreConstant.authorization.CONSOLE_TYPE_UM;
  }
  appTypeConfigurationModel.setConsoleType(consoleType);
}]).baseURL = './';
__webpack_require__(1815);
__webpack_require__(1816);
__webpack_require__(1817);
__webpack_require__(1818);
__webpack_require__(1822);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1784);
var angularGridsterModule = __webpack_require__(1785);
var headerModule = __webpack_require__(564);
angular.module('umLanding', [angularGridsterModule.name, headerModule]).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('landing', {
    url: '/landing',
    views: {
      'header': {
        templateUrl: '/common/header/appHeader.tpl.html',
        controller: 'appHeaderController'
      },
      'content': {
        templateUrl: '/landing/landing.tpl.html',
        controller: 'landingController'
      }
    }
  });
}]).value('landingConstant', {
  event: {
    TASKS_LOADED: 'landing.tasksLoaded',
    ACTIVITIES_LOADED: 'landing.activitiesLoaded',
    OPEN_TASK_DETAIL_DRAWER: 'landing.openTaskDetailDrawer',
    CLOSE_TASK_DETAIL_DRAWER: 'landing.closeTaskDetailDrawer'
  }
}).run(function () {});
__webpack_require__(1786);
__webpack_require__(1787);
__webpack_require__(1788);
__webpack_require__(1789);
__webpack_require__(1790);
__webpack_require__(1791);
__webpack_require__(1792);
__webpack_require__(1793);
__webpack_require__(1794);
__webpack_require__(1795);
__webpack_require__(1796);
__webpack_require__(1799);
__webpack_require__(1802);
__webpack_require__(1813);
__webpack_require__(1814);
module.exports = 'umLanding';

/***/ }),
/* 1784 */,
/* 1785 */,
/* 1786 */
/***/ (function(module, exports) {

/*@ngInject*/
var LandingMediator = function LandingMediator($q, coreMediator, loadActivityRepository, loadTaskRepository, loadWidgetLayoutTemplateRepository) {
  this.loadRecentActivityList = function (activityParams) {
    return loadActivityRepository.loadActivityStreamItems(activityParams);
  };
  this.loadTasks = function (taskParams) {
    return loadTaskRepository.loadTasks(taskParams);
  };
  this.getTaskDownloadUrl = function (taskParams) {
    return loadTaskRepository.getDownloadUrl(taskParams);
  };
  this.loadWidgetLayoutTemplate = function () {
    return loadWidgetLayoutTemplateRepository.loadWidgetLayoutTemplate();
  };
};
LandingMediator.$inject = ["$q", "coreMediator", "loadActivityRepository", "loadTaskRepository", "loadWidgetLayoutTemplateRepository"];
angular.module('umLanding').service('landingMediator', LandingMediator);

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var LandingController = function LandingController($scope, $window, $timeout, landingConstant, submissionGridConstant, landingMediator, modalUtil, preferenceModel, currentUserModel, $uibModal, coreMediator, xmlUtil, coreConstant, gridColumnModel, advancedFilterType, widgetType, advancedFilterMediator, browserUtil, appTypeConfigurationModel, filterType) {
  $scope.widgetTemplates = {};
  $scope.upodatedWidgetTemplates = {};
  $scope.widgetTimer = null;
  $scope.submissionFilterUri = null;
  $scope.submissionSortType = null;
  $scope.submissionSortKey = null;
  $scope.taskFilterUri = null;
  $scope.taskSortType = null;
  $scope.taskSortKey = null;
  $scope.submissionGridColumns = null;
  $scope.taskGridColumns = null;
  $scope.gridType = null;
  $scope.activityFilterUri = null;
  function handleResizeStart(event, $element, widget) {
    $scope.$broadcast(coreConstant.event.widget.RESIZE_START, widget);
  }
  function handleResizeStop(event, $element, widget) {
    $scope.$broadcast(coreConstant.event.widget.RESIZE_STOP, widget);
    saveWidgets();
  }
  function handleDragStart(event, $element, widget) {
    $scope.$broadcast(coreConstant.event.widget.DRAG_START, widget);
  }
  function handleDragStop(event, $element, widget) {
    $scope.$broadcast(coreConstant.event.widget.DRAG_STOP, widget);
    saveWidgets();
  }
  function showTermsAndConditions() {
    var termsAndConditionsAcceptedOnLogin = preferenceModel.get('general.copyrightLicense.accepted');
    var allowedTermsAndCondition = {},
      showTermsAndConditions = false;
    if (termsAndConditionsAcceptedOnLogin !== 'true') {
      var userType = currentUserModel.getCurrentUser().userType;
      if (userType === 'Underwriter' || userType === 'ServiceUser') {
        allowedTermsAndCondition = preferenceModel.get('system.allowedTermsAndConditionsCarrierRoles');
      } else if (userType === 'Agent') {
        allowedTermsAndCondition = preferenceModel.get('system.allowedTermsAndConditionsAgencyRoles');
      }
      var roleNameList = allowedTermsAndCondition.split(';');
      _.each(roleNameList, function (roleName) {
        var roleNames = currentUserModel.getCurrentUser().roleNames;
        _.each(roleNames, function (role) {
          if (role === roleName) {
            showTermsAndConditions = true;
            return false;
          }
        });
        if (showTermsAndConditions) {
          return false;
        }
      });
      if (showTermsAndConditions) {
        var promise;
        if (appTypeConfigurationModel.isAgentConsole()) {
          promise = coreMediator.getConfiguredFile('Agency Terms and Conditions');
        } else if (appTypeConfigurationModel.isUnderwriterWorkstation()) {
          promise = coreMediator.getConfiguredFile('Carrier Terms and Conditions');
        }
        if (!_.isNil(promise)) {
          promise.then(function (configuredFile) {
            if (!_.isEmpty(configuredFile) && !_.isNil(configuredFile.fileName) && !_.isNil(configuredFile.size)) {
              showTermsAndConditionsModal(configuredFile);
            }
          });
        }
      }
    }
  }
  function showTermsAndConditionsModal(configuredFile) {
    var modalInstance = $uibModal.open({
      templateUrl: '/landing/termsAndConditions/termsAndConditions.tpl.html',
      controller: 'termsAndConditionsController',
      windowClass: 'termsAndConditionsModal',
      resolve: {
        options: function options() {
          return {
            configuredFile: configuredFile
          };
        }
      },
      keyboard: false,
      backdrop: 'static'
    });
    if (browserUtil.isIE11()) {
      modalInstance.result.finally(function () {
        $window.location.reload();
      });
    }
  }

  /**
   * Gridster documentation found here: https://github.com/ManifestWebDesign/angular-gridster
   */
  $scope.gridsterOpts = {
    margins: [20, 20],
    outerMargin: true,
    pushing: true,
    floating: true,
    draggable: {
      enabled: true,
      handle: '.titlebarWidget',
      start: handleDragStart,
      stop: handleDragStop
    },
    resizable: {
      enabled: true,
      handles: ['se'],
      start: handleResizeStart,
      stop: handleResizeStop
    }
  };
  function checkUserWidgetAndFilterSelection() {
    var columns, columnsList;
    coreMediator.loadUserPreferences().then(function () {
      landingMediator.loadWidgetLayoutTemplate().then(function (widgetLayoutTemplate) {
        coreMediator.loadUserPreferences().then(function () {
          var widgetsObject = xmlUtil.parseStringWithoutFlattening(preferenceModel.get('view.widgets')),
            widgetArray;
          _.each(widgetLayoutTemplate.widgetTemplates, function (widgetTemplate) {
            if (widgetTemplate.options) {
              widgetTemplate.options = JSON.parse(widgetTemplate.options);
            }
          });
          if (widgetsObject.widgets) {
            _.each(widgetLayoutTemplate.widgetTemplates, function (widgetTemplate) {
              widgetArray = Array.isArray(widgetsObject.widgets.widget) ? widgetsObject.widgets.widget : [widgetsObject.widgets.widget];
              if (widgetArray) {
                _.each(widgetArray, function (item) {
                  if (widgetTemplate.type === parseInt(item.type)) {
                    widgetTemplate.sizeX = parseInt(item.sizeX);
                    widgetTemplate.sizeY = parseInt(item.sizeY);
                    widgetTemplate.row = parseInt(item.row);
                    widgetTemplate.col = parseInt(item.col);
                    if (widgetTemplate.type === 1) {
                      if (item.filterUri) {
                        advancedFilterMediator.getFilter(item.filterUri).then(function (filter) {
                          if (filter !== '' && !_.isNil(filter)) {
                            $scope.submissionFilterUri = item.filterUri;
                            gridColumnModel.updateSubmissionParamByName('filterUri', item.filterUri);
                            gridColumnModel.setSavedFilterUri(advancedFilterType.SUBMISSION_GRID, item.filterUri);
                          }
                        }.bind(this));
                      }
                      if (item.sortType) {
                        gridColumnModel.updateSubmissionParamByName('sortType', item.sortType);
                        gridColumnModel.updateSubmissionParamByName('key', item.sortKey);
                      }
                      if (!_.isNil(item.columns)) {
                        columns = '<columns>';
                        columnsList = item.columns;
                        _.each(columnsList.column, function (data) {
                          var column = '<column visible=' + '"' + data._visible + '"' + ' width=' + '"' + data._width + '"' + ' accessor=' + '"' + data._accessor + '"';
                          if (_.isNil(data._type) && !_.isNil(data._sort)) {
                            column += ' sort=' + '"' + data._sort + '"';
                          } else if (!_.isNil(data._type) && _.isNil(data._sort)) {
                            column += ' type=' + '"' + data._type + '"';
                          } else if (!_.isNil(data._type) && !_.isNil(data._sort)) {
                            column += ' type=' + '"' + data._type + '"' + ' sort=' + '"' + data._sort + '"';
                          }
                          column += '>' + data.__text + '</column>';
                          columns += column;
                        });
                        columns += '</columns>';
                        // not to use view.widgets columns for submissionGrid anymore
                        //$scope.submissionGridColumns = columns;
                      }
                    }
                    if (widgetTemplate.type === 2) {
                      if (item.filterUri) {
                        advancedFilterMediator.getFilter(item.filterUri).then(function (filter) {
                          if (filter !== '' && !_.isNil(filter)) {
                            $scope.taskFilterUri = item.filterUri;
                            gridColumnModel.updateTaskParamByName('filterUri', item.filterUri);
                            gridColumnModel.setSavedFilterUri(advancedFilterType.TASK_GRID, item.filterUri);
                          }
                        }.bind(this));
                      }
                      if (item.sortType) {
                        gridColumnModel.updateTaskParamByName('sortType', item.sortType);
                        gridColumnModel.updateTaskParamByName('key', item.sortKey);
                      }
                      if (!_.isNil(item.columns)) {
                        columns = '<columns>';
                        columnsList = item.columns;
                        _.each(columnsList.column, function (data) {
                          var column = '<column visible=' + '"' + data._visible + '"' + ' width=' + '"' + data._width + '"' + '>' + data.__text + '</column>';
                          columns += column;
                        });
                        columns += '</columns>';
                        $scope.taskGridColumns = columns;
                      }
                    }
                    if (widgetTemplate.type === 4) {
                      if (item.filterUri) {
                        advancedFilterMediator.getFilter(item.filterUri).then(function (filter) {
                          if (!_.isEmpty(filter)) {
                            $scope.activityFilterUri = item.filterUri;
                            gridColumnModel.updateActivityParamByName('filterUri', item.filterUri);
                            gridColumnModel.setSavedFilterUri(advancedFilterType.ACTIVITY_GRID, item.filterUri);
                          }
                        });
                      }
                    }
                  }
                }.bind(this));
              }
            }.bind(this));
          }
          $scope.widgetTemplates = widgetLayoutTemplate.widgetTemplates;
          $scope.$watch('widgetTemplates', function (items) {
            $scope.upodatedWidgetTemplates = items;
          }, true);
        }.bind(this));
      });
    });
  }
  $scope.$on(coreConstant.event.widget.RESIZE_STOP, function () {
    $timeout.cancel($scope.widgetTimer);
    $scope.widgetTimer = $timeout(function () {
      saveWidgets();
    }, 1000);
  });
  function saveWidgets() {
    $timeout.cancel($scope.widgetTimer);
    var value = getWidgetsXML($scope.upodatedWidgetTemplates);
    coreMediator.updateUserPreferences('view.widgets', value);
  }
  function saveUserWidget(type) {
    // update filter-specific user preference
    if (type == widgetType.SUBMISSIONS) {
      var filterUri = $scope.submissionFilterUri;
      if (!filterUri) {
        filterUri = gridColumnModel.getSubmissionParams().filterUri;
      }
      var prefName = "views." + $scope.gridType + ":" + filterUri;
      var item = findWidgetOfType($scope.upodatedWidgetTemplates, 1);
      var widgetXML = getWidgetXML(item);
      coreMediator.updateUserPreferences(prefName, widgetXML).then(function () {});
    }
  }
  function saveColumnPreferences() {
    var value;
    coreMediator.loadUserPreferences().then(function () {
      value = getWidgetsXML($scope.upodatedWidgetTemplates);
      coreMediator.updateUserPreferences('view.widgets', value).then(function () {
        $scope.widgetTimer = $timeout(function () {
          $scope.$broadcast(submissionGridConstant.event.RESET_GRID_COLUMNS, $scope.gridType);
        }, 500);
      });
    });
  }
  $scope.$on(coreConstant.event.FILTER_CHANGED, function (event, filterUri, filterType) {
    if (filterType === advancedFilterType.SUBMISSION_GRID) {
      $scope.submissionFilterUri = filterUri;
      saveWidgets();
    }
    if (filterType === advancedFilterType.TASK_GRID) {
      $scope.taskFilterUri = filterUri;
      saveWidgets();
    }
    if (filterType === advancedFilterType.ACTIVITY_GRID) {
      $scope.activityFilterUri = filterUri;
      saveWidgets();
    }
  }.bind(this));
  $scope.$on(submissionGridConstant.event.MODIFIED_COLUMN_SELECTION, function (event, gridPreference, columns) {
    var doSave = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    if (gridPreference === 'view.agent.homePageColumns' || gridPreference === 'view.uw.homePageColumns') {
      $scope.submissionGridColumns = columns;
      $scope.gridType = 'submissionGrid';
      if (doSave) {
        saveUserWidget(widgetType.SUBMISSIONS);
      }
    } else {
      if (gridPreference === 'view.tasksHomePageTaskColumnsForUnderwriter' || gridPreference === 'view.tasksHomePageTaskColumnsForAgent') {
        $scope.taskGridColumns = columns;
        $scope.gridType = 'taskGrid';
      }
    }
    if (doSave) {
      // the old whole landing page "view.widgets" preference
      saveColumnPreferences();
    }
  }.bind(this));
  $scope.$on(coreConstant.event.GRID_SORT_TYPE_CHANGED, function (event, params, filterType) {
    if (filterType === advancedFilterType.SUBMISSION_GRID) {
      $scope.submissionSortType = params.sortType;
      $scope.submissionSortKey = params.key;
      $scope.gridType = 'submissionGrid';
      saveUserWidget(1);
      saveWidgets();
    }
    if (filterType === advancedFilterType.TASK_GRID) {
      $scope.taskSortType = params.sortType;
      $scope.taskSortKey = params.key;
      saveWidgets();
    }
  }.bind(this));
  function getWidgetXML(item) {
    var xmlWidget = '<widget>';
    xmlWidget += '<sizeX>' + item.sizeX + '</sizeX>';
    xmlWidget += '<sizeY>' + item.sizeY + '</sizeY>';
    xmlWidget += '<row>' + item.row + '</row>';
    xmlWidget += '<col>' + item.col + '</col>';
    xmlWidget += '<type>' + item.type + '</type>';
    if (parseInt(item.type) === 1) {
      if (!_.isNil($scope.submissionFilterUri)) {
        xmlWidget += '<filterUri>' + $scope.submissionFilterUri + '</filterUri>';
      }
      if (!_.isNil($scope.submissionSortType)) {
        xmlWidget += '<sortType>' + $scope.submissionSortType + '</sortType>';
        xmlWidget += '<sortKey>' + $scope.submissionSortKey + '</sortKey>';
      }
      if (!_.isNil($scope.submissionGridColumns)) {
        xmlWidget += $scope.submissionGridColumns;
      }
    }
    if (parseInt(item.type) === 2) {
      if (!_.isNil($scope.taskFilterUri)) {
        xmlWidget += '<filterUri>' + $scope.taskFilterUri + '</filterUri>';
      }
      if (!_.isNil($scope.taskSortType)) {
        xmlWidget += '<sortType>' + $scope.taskSortType + '</sortType>';
        xmlWidget += '<sortKey>' + $scope.taskSortKey + '</sortKey>';
      }
      if (!_.isNil($scope.taskGridColumns)) {
        xmlWidget += $scope.taskGridColumns;
      }
    }
    if (parseInt(item.type) === 4) {
      if (!_.isNil($scope.activityFilterUri)) {
        xmlWidget += '<filterUri>' + $scope.activityFilterUri + '</filterUri>';
      }
    }
    xmlWidget += '</widget>';
    return xmlWidget;
  }
  function getWidgetsXML(items) {
    var xmlWidget = '<widgets>';
    _.each(items, function (item) {
      xmlWidget += getWidgetXML(item);
    });
    xmlWidget += '</widgets>';
    return xmlWidget;
  }
  function findWidgetOfType(items, type) {
    var result = null;
    _.each(items, function (item) {
      if (item.type == type) result = item;
    });
    return result;
  }
  $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
    gridColumnModel.reset();
  }.bind(this));
  showTermsAndConditions();
  checkUserWidgetAndFilterSelection();
};
LandingController.$inject = ["$scope", "$window", "$timeout", "landingConstant", "submissionGridConstant", "landingMediator", "modalUtil", "preferenceModel", "currentUserModel", "$uibModal", "coreMediator", "xmlUtil", "coreConstant", "gridColumnModel", "advancedFilterType", "widgetType", "advancedFilterMediator", "browserUtil", "appTypeConfigurationModel", "filterType"];
angular.module('umLanding').controller('landingController', LandingController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

var path = '/landing/landing.tpl.html';
var html = "<div class=\"landing\" app-mode-configuration>\n\n    <div class=\"content landingContent\">\n\n        <div gridster=\"gridsterOpts\">\n            <ul>\n                <li gridster-item=\"widgetTemplate\" ng-repeat=\"widgetTemplate in widgetTemplates\">\n\n                    <!--Submission Grid-->\n                    <ui-submission-grid class=\"submissionGridWidget\"\n                                        ng-if=\"::widgetTemplate.type === 1\"\n                                        widget-config=\"::widgetTemplate\"\n                                        filter-type=\"1\">\n                    </ui-submission-grid>\n\n                    <!--Task Grid-->\n                    <ui-task-grid class=\"taskGridWidget\"\n                                  ng-if=\"::widgetTemplate.type === 2\"\n                                  widget-config=\"::widgetTemplate\"\n                                  filter-type=\"3\">\n                    </ui-task-grid>\n\n                    <!--URL-->\n                    <ui-external-url class=\"externalUrlWidget\"\n                                     ng-if=\"::widgetTemplate.type === 3\"\n                                     url=\"::widgetTemplate.options.baseUrl\"\n                                     title-label=\"::widgetTemplate.options.title\"\n                                     widget-config=\"::widgetTemplate\">\n                    </ui-external-url>\n\n                    <!--Recent Activity-->\n                    <ui-recent-activity class=\"recentActivityWidget\"\n                                        ng-if=\"::widgetTemplate.type === 4\"\n                                        widget-config=\"::widgetTemplate\"\n                                        filter-type=\"5\">\n                    </ui-recent-activity>\n\n                </li>\n            </ul>\n        </div>\n\n\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var LoadActivityRepository = function LoadActivityRepository(baseRepository, xmlUtil) {
  angular.extend(this, baseRepository);
  this.loadActivityStreamItems = function (activityParams) {
    var url = '/rest/ActivityEvent/filter',
      config = {
        params: {
          filterUri: activityParams.filterUri,
          startIndex: activityParams.startIndex,
          numberOfRows: activityParams.pageSize
        }
      };
    return this.get(url, config);
  };
  this.processGetResponseData = function (responseData) {
    var records = _.map(responseData.records, function (item) {
      item.note = xmlUtil.parseString(item.note);
      item.triggerTime = new Date(item.triggerTime);
      return item;
    });
    return {
      totalRecords: responseData.totalRecords,
      records: records
    };
  };
};
LoadActivityRepository.$inject = ["baseRepository", "xmlUtil"];
angular.module('umLanding').service('loadActivityRepository', LoadActivityRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadTaskRepository = function LoadTaskRepository(baseRepository, coreMediator) {
  var translationTable = {
    insuredName: 's.insured.name',
    assignedToName: 't.assignedTo.name',
    assignedByName: 't.assignedBy.name',
    productShortNames: 's.productShortNames',
    effectiveDate: 's.effectiveDate',
    dueDate: 't.dueDate',
    priority: 't.priority',
    resolutionDate: 't.resolutionDate'
  };
  angular.extend(this, baseRepository);
  this.loadTasks = function (taskParams) {
    var url = '/rest/SubmissionTask/filter',
      sortColumn = translationTable[taskParams.key] || taskParams.key,
      config = {
        params: {
          filterUri: taskParams.filterUri,
          resultType: 'grid',
          startIndex: taskParams.startIndex,
          numberOfRows: taskParams.pageSize,
          sortBy: sortColumn + ' ' + taskParams.sortType
        }
      };
    return this.get(url, config);
  };
  this.getDownloadUrl = function (requestParams) {
    return coreMediator.getSingleUseToken().then(function (token) {
      return "/tasks/tasks.csv?filterUri=".concat(requestParams.filterUri, "&t=").concat(encodeURIComponent(token));
    });
  };
};
LoadTaskRepository.$inject = ["baseRepository", "coreMediator"];
angular.module('umLanding').service('loadTaskRepository', LoadTaskRepository);

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadWidgetLayoutTemplateRepository = function LoadWidgetLayoutTemplateRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadWidgetLayoutTemplate = function () {
    var url = '/rest/WidgetLayoutTemplate';
    return this.get(url);
  };
};
LoadWidgetLayoutTemplateRepository.$inject = ["baseRepository"];
angular.module('umLanding').service('loadWidgetLayoutTemplateRepository', LoadWidgetLayoutTemplateRepository);

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

var path = '/landing/termsAndConditions/termsAndConditions.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"okButton\"\n    cancel=\"cancelButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"previewPane\">\n\n        <attachment-viewer class=\"attachmentViewerDirective pdfFrame\"\n                           configured-file-id=\"{{ viewModel.configuredFileId }}\"></attachment-viewer>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var TermsAndConditionsController = function TermsAndConditionsController($rootScope, $scope, options, attachmentMediator, attachmentUtil, localization, coreMediator, coreConstant) {
  localization.getTranslations().then(function (translations) {
    $scope.title = _.get(translations, 'termsAndCondition.title');
    $scope.okButton = _.get(translations, 'termsAndCondition.confirm');
    $scope.cancelButton = _.get(translations, 'termsAndCondition.cancel');
    $scope.isInModal = true;
    $scope.viewModel = {
      attachmentMimeType: options.configuredFile.mimeType,
      attachmentName: options.configuredFile.fileName,
      configuredFileId: options.configuredFile.id
    };
    $scope.onConfirm = function () {
      coreMediator.updateUserPreferences('general.copyrightLicense.accepted', 'true');
      $scope.$close();
    };
    $scope.onCancel = function () {
      coreMediator.updateUserPreferences('general.copyrightLicense.accepted', 'false');
      coreMediator.logout();
      $scope.$dismiss();
    };
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
TermsAndConditionsController.$inject = ["$rootScope", "$scope", "options", "attachmentMediator", "attachmentUtil", "localization", "coreMediator", "coreConstant"];
angular.module('umLanding').controller('termsAndConditionsController', TermsAndConditionsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIWidgetGridScrollManagerDirective = function UIWidgetGridScrollManagerDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm) {
    var element = $($elm),
      gridContainer = element.find('.scrollVerticalContainer'),
      scrollTimer,
      isIe11 = $('body').hasClass('ie11');
    function cancelExistingTimeout() {
      if (scrollTimer) {
        $timeout.cancel(scrollTimer);
      }
    }
    function handleScroll(event) {
      var newWidth = element.width() + event.target.scrollLeft;
      gridContainer.css('width', newWidth);
      function hideScrollBarOnScroll() {
        gridContainer.css('overflow-y', 'hidden');
        cancelExistingTimeout();
        scrollTimer = $timeout(function () {
          gridContainer.css('overflow-y', 'auto');
        }, 150);
      }
      if (isIe11) {
        hideScrollBarOnScroll();
      }
    }
    element.on('scroll', handleScroll);
    $scope.$on('$destroy', function () {
      element.off('scroll', handleScroll);
      cancelExistingTimeout();
    });
  };
  return {
    restrict: 'A',
    link: linkFunction,
    scope: {}
  };
};
UIWidgetGridScrollManagerDirective.$inject = ["$timeout"];
angular.module('umLanding').directive('uiWidgetGridScrollManager', UIWidgetGridScrollManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1797);
__webpack_require__(1798);
var ExternalUrlComponent = {
  templateUrl: '/landing/widget/externalUrl/externalUrl.tpl.html',
  controller: 'externalUrlController',
  bindings: {
    url: '<',
    titleLabel: '<',
    widgetConfig: '<'
  }
};
angular.module('umLanding').component('uiExternalUrl', ExternalUrlComponent);

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

var path = '/landing/widget/externalUrl/externalUrl.tpl.html';
var html = "<div class=\"externalUrlContent\">\n\n    <div class=\"titlebarWidget\">\n        <div class=\"titlebarContainer\">\n            <div class=\"titleLabel\">{{$ctrl.titleLabel}}</div>\n\n            <div class=\"actionButtonList\">\n\n                <div class=\"btn-group\"\n                     uib-dropdown\n                     dropdown-append-to-body=\"true\">\n\n                    <button type=\"button\"\n                            class=\"btn btn-xs\"\n                            uib-dropdown-toggle>\n                        <span class=\"glyphicon glyphicon-cog\"></span>\n                    </button>\n\n                    <ul class=\"dropdown-menu-right\"\n                        uib-dropdown-menu>\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isMinimized() }\">\n                            <a ng-click=\"$ctrl.minimize($event)\"\n                               ui-translate>widgetActions.minimize</a></li>\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isMaximized() }\">\n                            <a ng-click=\"$ctrl.maximize($event)\"\n                               ui-translate>widgetActions.maximize</a></li>\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isAtDefaultSize() }\">\n                            <a ng-click=\"$ctrl.returnToDefaultSize($event)\"\n                               ui-translate>widgetActions.returnToDefaultSize</a></li>\n\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"overlay\"\n         ng-if=\"$ctrl.showOverlay\"></div>\n\n    <content-iframe iframe-src=\"$ctrl.url\"/>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

/*@ngInject*/
var ExternalUrlController = function ExternalUrlController($controller, $scope, coreConstant) {
  angular.extend(this, $controller('baseWidgetController', {
    $scope: $scope
  }));
  this.showOverlay = false;
  this.onShowOverlay = function () {
    this.showOverlay = true;
  };
  this.onHideOverlay = function () {
    this.showOverlay = false;
  };
  this.$onInit = function () {
    this.onInit();
    $scope.$on(coreConstant.event.widget.RESIZE_START, this.onShowOverlay.bind(this));
    $scope.$on(coreConstant.event.widget.RESIZE_STOP, this.onHideOverlay.bind(this));
    $scope.$on(coreConstant.event.widget.DRAG_START, this.onShowOverlay.bind(this));
    $scope.$on(coreConstant.event.widget.DRAG_STOP, this.onHideOverlay.bind(this));
  };
};
ExternalUrlController.$inject = ["$controller", "$scope", "coreConstant"];
angular.module('umLanding').controller('externalUrlController', ExternalUrlController);

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1800);
__webpack_require__(1801);
var RecentActivityComponent = {
  templateUrl: '/landing/widget/recentActivity/recentActivity.tpl.html',
  controller: 'recentActivityController',
  bindings: {
    widgetConfig: '<',
    filterType: '<'
  }
};
angular.module('umLanding').component('uiRecentActivity', RecentActivityComponent);

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

var path = '/landing/widget/recentActivity/recentActivity.tpl.html';
var html = "<div class=\"recentActivityContainer\">\n\n    <div class=\"titlebarWidget\">\n        <div class=\"titlebarContainer\">\n            <span class=\"titleLabel\" ui-translate>recentActivity.title</span>:\n\n            <!--Active Filter-->\n            <um-dropdown class-name=\"activityFilter\"\n                         class=\"landingTitle activityFilter\"\n                         option-list=\"$ctrl.filters\"\n                         required=\"'true'\"\n                         selected-value=\"$ctrl.selectedFilterName\"\n                         status-text=\"$ctrl.getFilterStatus()\"\n                         on-change=\"$ctrl.onFilterChange(selectedOption)\">\n            </um-dropdown>\n\n            <div class=\"btn-group saveButton\"\n                 uib-dropdown\n                 ng-if=\"$ctrl.isFilterEdited() || !$ctrl.isDefaultFilter()\">\n                <button id=\"split-button\"\n                        type=\"button\"\n                        class=\"btn large-button grey saveButton\"\n                        ng-click=\"$ctrl.onSaveFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter() && $ctrl.isFilterEdited()\"\n                        ui-translate>advancedFilter.saveFilterLabel\n                </button>\n                <button id=\"split-button-as\"\n                        type=\"button\"\n                        class=\"btn large-button grey saveFilterAsButton saveButton\"\n                        ng-click=\"$ctrl.onSaveFilterAs()\"\n                        ng-if=\"$ctrl.isDefaultFilter() || (!$ctrl.isDefaultFilter() && !$ctrl.isFilterEdited())\"\n                        ui-translate>advancedFilter.saveFilterAsLabel\n                </button>\n                <button type=\"button\"\n                        class=\"btn toggleButton grey saveButton\"\n                        uib-dropdown-toggle>\n                    <span class=\"caret\"></span>\n                </button>\n                <ul class=\"dropdown-menu\"\n                    uib-dropdown-menu role=\"menu\">\n                    <li role=\"menuitem\"\n                        ng-click=\"$ctrl.onSaveFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter() && $ctrl.isFilterEdited()\">\n                        <a ui-translate>advancedFilter.saveFilterLabel</a>\n                    </li>\n                    <li role=\"menuitem\"\n                        ng-click=\"$ctrl.onSaveFilterAs()\">\n                        <a ui-translate>advancedFilter.saveFilterAsLabel</a>\n                    </li>\n                    <li role=\"menuitem\"\n                        ng-click=\"$ctrl.onDeleteFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter()\">\n                        <a ui-translate>advancedFilter.deleteFilterLabel</a>\n                    </li>\n                    <li role=\"menuitem\">\n                        <a ng-click=\"$ctrl.resetFilter($event)\"\n                           ng-if=\"$ctrl.isFilterEdited()\"\n                           ui-translate>advancedFilter.resetFilter</a></li>\n                </ul>\n            </div>\n\n            <!--Search-->\n            <div class=\"submissionFilter gridster-no-drag\"\n                 ng-click=\"$ctrl.onToggleSearch()\"\n                 ng-if=\"$ctrl.hasFilterPermission && $ctrl.filterModel && $ctrl.advancedFilterType\"\n                 uib-tooltip=\"{{ $ctrl.searchIconTooltip }}\"\n                 tooltip-popup-delay=\"500\"\n                 tooltip-append-to-body=\"true\"\n                 tooltip-placement=\"bottom\">\n                <span class=\"glyphicon glyphicon-search toggleButton activityFilterSearchIcon\"></span>\n            </div>\n\n            <div class=\"actionButtonList\">\n\n                <div class=\"btn-group\"\n                     uib-dropdown\n                     dropdown-append-to-body=\"true\">\n\n                    <button type=\"button\"\n                            class=\"btn btn-xs\"\n                            uib-dropdown-toggle\n                            uib-tooltip=\"{{ ::$ctrl.showOrHideToolsTooltip }}\"\n                            tooltip-popup-delay=\"500\"\n                            tooltip-append-to-body=\"true\"\n                            tooltip-placement=\"bottom\">\n                        <span class=\"glyphicon glyphicon-cog\"></span>\n                    </button>\n\n                    <ul class=\"dropdown-menu-right\"\n                        uib-dropdown-menu>\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isMinimized() }\">\n                            <a ng-click=\"$ctrl.minimize($event)\"\n                               ui-translate>widgetActions.minimize</a></li>\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isMaximized() }\">\n                            <a ng-click=\"$ctrl.maximize($event)\"\n                               ui-translate>widgetActions.maximize</a></li>\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isAtDefaultSize() }\">\n                            <a ng-click=\"$ctrl.returnToDefaultSize($event)\"\n                               ui-translate>widgetActions.returnToDefaultSize</a></li>\n\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"landing gridWindow\"\n         app-mode-configuration>\n\n        <!--Search Form-->\n        <div class=\"activityStreamSearchForm\"\n             ng-if=\"$ctrl.isSearchOpen\"\n             ng-class=\"{ 'is-open': $ctrl.isSearchOpen }\">\n\n            <ui-advanced-filter-list\n                class=\"advancedFilterListWrapper\"\n                ng-if=\"$ctrl.isSearchOpen\"\n                filter-model=\"$ctrl.filterModel\"\n                show-all-templates=\"false\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\">\n            </ui-advanced-filter-list>\n        </div>\n\n        <div class=\"content landingContent ng-isolate-scope\"\n             ui-widget-grid-scroll-manager\n             ui-scroll-detection\n             scroll-fixed-grid-arrow>\n            <div class=\"scrollVerticalContainer\">\n                <div ng-repeat=\"activityItems in $ctrl.recentActivityList\"\n                     class=\"activityItem\">\n                <span class=\"submissionName\"\n                      ng-click=\"$ctrl.openSubmission(activityItems[0].submissionId)\">\n                    {{ ::activityItems[0].submissionDisplayName }}\n                </span>\n                    <div class=\"activityItemTime\">\n                        <time>{{ ::activityItems[0].triggerTime | date: 'short' }}</time>\n                        &nbsp;\n                        <span class=\"activityMessage\">{{ ::getRecentActivityMessage(activityItems[0]) }}</span>\n                        <button class=\"btn-link glyphicon\"\n                                ng-if=\"activityItems.length>1\"\n                                ng-click=\"toggleGroup(activityItems[0])\"\n                                ng-class=\"{'glyphicon-chevron-right': !activityItems[0].isOpen, 'glyphicon-chevron-down': activityItems[0].isOpen}\">\n                        </button>\n                        <div ng-repeat=\"childItem in activityItems\" ng-if=\"activityItems[0].isOpen\"\n                             class=\"activityItem\">\n                            <div class=\"activityItemTime childItem\" ng-if=\"childItem!=activityItems[0]\">\n                                <time>{{ ::childItem.triggerTime | date: 'short' }}</time>\n                                &nbsp;\n                                <span class=\"activityMessage\">{{ ::getRecentActivityMessage(childItem) }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <ui-grid-paging-component\n            ng-hide=\"$ctrl.totalRecords === 0\"\n            class=\"landingPagination\"\n            start-index=\"$ctrl.requestParams.startIndex\"\n            page-size=\"$ctrl.requestParams.pageSize\"\n            total-records=\"$ctrl.totalRecords\"\n            record-count-text=\"$ctrl.recordCountText\"\n            records-count-text=\"$ctrl.recordsCountText\"\n            translation-key=\"$ctrl.translationKey\"\n            on-change=\"$ctrl.onPagingChange($event, params)\"></ui-grid-paging-component>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(74);

/*@ngInject*/
var RecentActivityController = function RecentActivityController($scope, $rootScope, $controller, landingMediator, coreConstant, landingConstant, submissionGridConstant, appTypeConfigurationModel, advancedFilterType, authorizationConstants, persistentConnection, gridColumnModel, localization, currentUserModel, coreMediator) {
  var _this = this;
  angular.extend(this, $controller('baseGridWidgetController', {
    $scope: $scope
  }));
  this.i18n = locale;
  this.advancedFilterType = advancedFilterType.ACTIVITY_GRID;
  this.recentActivityList = [];
  this.showPaging = false;
  this.isLoaded = false;
  this.$onInit = function () {
    this.gridLoadedEvent = landingConstant.event.ACTIVITIES_LOADED;
    this.requestParams = this.getFilterParams();
    this.userId = currentUserModel.getCurrentUser().userId;
    this.hasFilterPermission = currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_ADVANCED_FILTER);
    this.onInitGridWidget();
  };
  localization.getTranslationByKey('homePage.grid').then(function (translations) {
    _this.recordCountText = _.get(translations, 'submissionCount');
    _this.recordsCountText = _.get(translations, 'submissionsCount');
    _this.showOrHideToolsTooltip = _.get(translations, 'showOrHideToolsTooltip');
    _this.searchIconTooltip = _.get(translations, 'searchIconTooltip');
  });
  this.onPagingChange = function ($event, params) {
    this.requestParams.pageSize = params.pageSize;
    this.requestParams.startIndex = params.startIndex;
    this.loadRecords();
  };
  this.loadRecordsInt = function (requestParams) {
    var _this2 = this;
    return landingMediator.loadRecentActivityList(requestParams).then(function (result) {
      var recentActivityList = [];

      // Map recent activity collection down to the latest entry per submission
      recentActivityList = result.records;
      recentActivityList = _.chain(recentActivityList).orderBy(['triggerTime'], ['desc']).value();
      recentActivityList = _.groupBy(recentActivityList, 'submissionId');
      recentActivityList = _.chain(recentActivityList).orderBy(['0.triggerTime'], ['desc']).value();
      _this2.recentActivityList = recentActivityList;
      /*
       * If the server returns totalRecords as -1, that means that
       * the client should use the previous totalRecords value.
       */
      if (result.totalRecords === -1) {
        result.totalRecords = _this2.savedTotalRecords;
      }
      _this2.totalRecords = result.totalRecords;
      if (_this2.totalRecords >= 0) {
        _this2.savedTotalRecords = _this2.totalRecords;
      }
      _this2.showPaging = _this2.totalRecords > requestParams.pageSize;
      _this2.isGridEmpty = _this2.records.length === 0;
      _this2.isLoading = false;
      _this2.isLoaded = true;
      _this2.recalculateGridPaging();
      return result;
    });
  };
  this.recalculateGridPaging = function () {
    $scope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
  };
  $scope.getRecentActivityMessage = function (activityItem) {
    var message = activityItem.note.simpleMessage;
    message += ' by ' + activityItem.actorDisplayName;
    if (activityItem.note.statusReason && !_this.isAgent) {
      message += ' - ' + activityItem.note.statusReason;
    }
    if (activityItem.note.statusDetail && !_this.isAgent) {
      message += ' - ' + activityItem.note.statusDetail;
    }
    return message;
  };
  $scope.toggleGroup = function (activityItem) {
    activityItem.isOpen = !activityItem.isOpen;
  };
  this.setOpenFilterUri = function (filterUri) {
    gridColumnModel.setOpenFilterUri(this.advancedFilterType, filterUri);
  };
  this.getOpenFilterUri = function () {
    return gridColumnModel.getOpenFilterUri(this.advancedFilterType);
  };
  this.setFilterParams = function (filterParams) {
    gridColumnModel.setActivityParams(filterParams);
  };
  this.getFilterParams = function () {
    return gridColumnModel.getActivityParams();
  };
  this.setSelectedFilterName = function (filterName) {
    gridColumnModel.setSelectedActivityFilterName(filterName);
  };
  this.getSelectedFilterName = function () {
    return gridColumnModel.getSelectedActivityFilterName();
  };
  this.loadListOnFilterChange = function () {
    this.openFilter = null;
    this.calculateFilterParams();
    this.resetGridPaging();
  };
  this.initLandingPage = function () {
    this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    this.updateDefaultSortColumn();
    this.updateColumnsFromPreferences();
    this.generateColumns();
    this.updateFilterFromPreferences();
  };
  $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function () {
    _this.updateColumnsFromPreferences();
    _this.resetGridColumns();
  });
  $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, function () {
    _this.loadListOnFilterChange();
  });
  $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
    persistentConnection.connect().then(function () {
      _this.isUserTypeUpdated = true;
      _this.isAgent = appTypeConfigurationModel.isAgentConsole();
      _this.initLandingPage();
    });
  });
  $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
};
RecentActivityController.$inject = ["$scope", "$rootScope", "$controller", "landingMediator", "coreConstant", "landingConstant", "submissionGridConstant", "appTypeConfigurationModel", "advancedFilterType", "authorizationConstants", "persistentConnection", "gridColumnModel", "localization", "currentUserModel", "coreMediator"];
angular.module('umLanding').controller('recentActivityController', RecentActivityController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1803);
__webpack_require__(1804);
__webpack_require__(1805);
__webpack_require__(1806);
__webpack_require__(1808);
__webpack_require__(1809);
__webpack_require__(1810);
__webpack_require__(1811);
__webpack_require__(1812);
var TaskGridComponent = {
  templateUrl: '/landing/widget/taskGrid/taskGrid.tpl.html',
  controller: 'taskGridController',
  bindings: {
    widgetConfig: '<',
    filterType: '<'
  }
};
angular.module('umLanding').component('uiTaskGrid', TaskGridComponent);

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {var locale = __webpack_require__(74);

/*@ngInject*/
var TaskGridController = function TaskGridController($stateParams, $state, $rootScope, $scope, $controller, $uibModal, preferenceModel, $window, advancedFilterModel, advancedFilterType, appTypeConfigurationModel, authorizationConstants, coreConstant, landingConstant, submissionGridConstant, gridColumnModel, landingMediator, persistentConnection, uiPerformanceLoggerConstant, modalUtil, localization, taskGridMediator, currentUserModel, coreMediator) {
  var _this = this;
  angular.extend(this, $controller('baseGridWidgetController', {
    $scope: $scope
  }));
  this.i18n = locale;
  this.advancedFilterType = advancedFilterType.TASK_GRID;
  this.pageSizeOptions = [25, 50, 100];
  localization.getTranslationByKey('homePage').then(function (result) {
    this.translations = result;
    this.recordCountText = _.get(result, 'grid.taskCount');
    this.recordsCountText = _.get(result, 'grid.tasksCount');
    this.showOrHideToolsTooltip = _.get(result, 'grid.showOrHideToolsTooltip');
    this.searchIconTooltip = _.get(result, 'grid.searchIconTooltip');
  }.bind(this));
  this.$onInit = function () {
    this.columnPreference = this.isAgent ? 'view.tasksHomePageTaskColumnsForAgent' : 'view.tasksHomePageTaskColumnsForUnderwriter';
    this.selectedFilterName = this.getSelectedFilterName();
    this.isTask = true;
    this.requestParams = this.getFilterParams();
    this.uiPerformanceLogAction = uiPerformanceLoggerConstant.TASK_HOME;
    this.hasFilterPermission = appTypeConfigurationModel.isUnderwriterWorkstation();
    this.gridLoadedEvent = landingConstant.event.TASKS_LOADED;
    this.openDetailDrawerEvent = landingConstant.event.OPEN_TASK_DETAIL_DRAWER;
    this.closeDetailDrawerEvent = landingConstant.event.CLOSE_TASK_DETAIL_DRAWER;
    this.isBulkUpdateEnabled = currentUserModel.hasAuthorization(authorizationConstants.TASK_ADD_MODIFY);
    this.isMultiSelectEnabled = currentUserModel.hasAuthorization(authorizationConstants.SUBMISSION_TASK_BULK_UPDATE);
    this.multiSelectMaximumBatchSize = preferenceModel.get('system.maxBulkUpdateTasks');
    this.onInitGridWidget();
    this.pageSize = this.requestParams.pageSize;
  };
  this.onPagingChange = function ($event, params) {
    this.requestParams.pageSize = params.pageSize;
    this.requestParams.startIndex = params.startIndex;
    this.loadGrid();
  };
  this.setOpenFilterUri = function (filterUri) {
    gridColumnModel.setOpenFilterUri(this.advancedFilterType, filterUri);
  };
  this.getOpenFilterUri = function () {
    return gridColumnModel.getOpenFilterUri(this.advancedFilterType);
  };
  this.setFilterParams = function (filterParams) {
    gridColumnModel.setTaskParams(filterParams);
  };
  this.getFilterParams = function () {
    return gridColumnModel.getTaskParams();
  };
  this.setSelectedFilterName = function (filterName) {
    gridColumnModel.setSelectedTaskFilterName(filterName);
  };
  this.getSelectedFilterName = function () {
    return gridColumnModel.getSelectedTaskFilterName();
  };
  this.openTask = function (task) {
    if (!this.isBulkUpdateMode) {
      this.openSubmission(task.submissionId, task.id);
    }
  };
  this.loadRecordsInt = function (requestParams) {
    return landingMediator.loadTasks(this.requestParams);
  };
  this.generateColumns = function () {
    this.colViewModel = gridColumnModel.getTaskGridColumns();
    this.dropdownColumns = gridColumnModel.getTaskDropdownColumns();
  };
  this.resetParams = function (params) {
    gridColumnModel.setTaskParams(params);
  };
  this.onShowReassignBulkUpdateConfirmation = function () {
    var selectedTaskCount = $scope.multiSelectUtil.getMultiSelectCount();
    var config = {
        cancelButtonLabel: this.translations.widgets.taskGrid.cancel,
        confirmActionButtonLabel: this.translations.widgets.taskGrid.reassignButton,
        summary: this.translations.widgets.taskGrid.reassignMessage,
        title: this.translations.widgets.taskGrid.reassignTitle
      },
      modalInstance;
    config.summary = config.summary.replace('{1}', selectedTaskCount);
    config.title = config.title.replace('{1}', selectedTaskCount > 1 ? 's' : '');
    config.summary = config.summary.replace('{2}', selectedTaskCount > 1 ? 's' : '');
    modalInstance = $uibModal.open({
      templateUrl: '/landing/widget/taskGrid/reassign/reassignModal.tpl.html',
      controller: 'reassignModalController',
      windowClass: 'reassignModal',
      backdrop: 'static',
      resolve: {
        options: {
          title: config.title,
          summary: config.summary
        }
      }
    });
    modalInstance.result.then(function (assignee) {
      var _$scope$multiSelectMo = $scope.multiSelectModel,
        multiSelectItemList = _$scope$multiSelectMo.multiSelectItemList,
        isMultiSelectUsingExclusion = _$scope$multiSelectMo.isMultiSelectUsingExclusion;
      var params = {};
      if (isMultiSelectUsingExclusion) {
        params.excludedSubmissionIds = multiSelectItemList;
        params.filterUri = this.filterModel.filter.uri;
      } else {
        params.taskIds = multiSelectItemList;
      }
      $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR);
      taskGridMediator.reassignTaskList(params, assignee).then(function () {
        $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR);
        this.loadGrid();
        $scope.multiSelectUtil.onCancelMultiSelect();
      }.bind(this));
    }.bind(this));
  };
  this.onShowResolveBulkUpdateConfirmation = function () {
    var selectedTaskCount = $scope.multiSelectUtil.getMultiSelectCount();
    var config = {
        cancelButtonLabel: this.translations.widgets.taskGrid.cancel,
        confirmActionButtonLabel: this.translations.widgets.taskGrid.resolveButton,
        summary: this.translations.widgets.taskGrid.resolveMessage,
        title: this.translations.widgets.taskGrid.resolveTitle
      },
      modalInstance;
    config.summary = config.summary.replace('{1}', selectedTaskCount);
    config.title = config.title.replace('{1}', selectedTaskCount > 1 ? 's' : '');
    config.summary = config.summary.replace('{2}', selectedTaskCount > 1 ? 's' : '');
    modalInstance = $uibModal.open({
      templateUrl: '/landing/widget/taskGrid/resolve/resolveModal.tpl.html',
      controller: 'resolveModalController',
      windowClass: 'resolveModal',
      backdrop: 'static',
      resolve: {
        options: {
          title: config.title,
          summary: config.summary
        }
      }
    });
    modalInstance.result.then(function (resolutionNotes) {
      var _$scope$multiSelectMo2 = $scope.multiSelectModel,
        multiSelectItemList = _$scope$multiSelectMo2.multiSelectItemList,
        isMultiSelectUsingExclusion = _$scope$multiSelectMo2.isMultiSelectUsingExclusion;
      var params = {};
      if (isMultiSelectUsingExclusion) {
        var filterUri = this.filterModel.filter.uri;
        var openFilterUri = this.getOpenFilterUri();
        params.excludedSubmissionIds = multiSelectItemList;
        params.filterUri = openFilterUri || filterUri;
      } else {
        params.taskIds = multiSelectItemList;
      }
      $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR);
      taskGridMediator.resolveTaskList(params, resolutionNotes).then(function () {
        $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR);
        this.loadGrid();
        $scope.multiSelectUtil.onCancelMultiSelect();
      }.bind(this));
    }.bind(this));
  };
  this.loadListOnFilterChange = function () {
    this.openFilter = null;
    this.calculateFilterParams();
    this.resetGridPaging();
  };
  this.initLandingPage = function () {
    this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    this.updateDefaultSortColumn();
    this.updateColumnsFromPreferences();
    this.generateColumns();
    this.updateFilterFromPreferences();
  };
  this.isMultiSelectMode = function () {
    return $scope.multiSelectModel.isMultiSelectMode;
  };
  this.openSubmission = _.debounce(function (submissionId, taskId) {
    var params = {
        submissionId: submissionId,
        collabType: "task",
        collabId: taskId
      },
      stateName = 'submission.collab';
    if (!this.isMultiSelectMode()) {
      if (submissionId === parseInt($stateParams.submissionId)) {
        return;
      }
      if (this.isColSelectDropdownOpen) {
        this.updateDropdownClosed();
        return;
      }
      if (!this.isSearchOpen) {
        this.setOpenFilterUri(null);
      }
      this.isLoading = true;
      $state.go(stateName, params);
    }
  }.bind(this), 200, {
    leading: true
  });
  this.setSelectedItem = function (event, selectedItem) {
    if (!this.isMultiSelectMode()) {
      if (this.isBulkUpdateMode) {
        this.handleBulkUpdateRowClick(selectedItem);
      } else {
        if (selectedItem.selected) {
          selectedItem.selected = false;
          this.isDrawerOpen = false;
          return;
        }
        if ($(event.currentTarget).hasClass('toggleDrawer')) {
          this.isDrawerOpen = true;
        }
        _.forEach(this.records, function (item) {
          item.selected = item === selectedItem;
        });
        $scope.$broadcast(this.openDetailDrawerEvent);
      }
    } else {
      $scope.multiSelectUtil.handleMultiSelectRowClick(selectedItem);
    }
  };
  this.onDownloadUrlClick = function () {
    landingMediator.getTaskDownloadUrl(this.requestParams).then(function (url) {
      $window.open(url, '_blank');
    });
  };
  this.getColumnClassName = function (name) {
    return _.lowerFirst(name).replace(/\s/g, '') + ' Checkbox';
  };
  this.onReassignSelection = function () {
    this.onShowReassignBulkUpdateConfirmation();
  };

  // this funny syntax is used to pass in the callback via a directive that doesn't
  // use isolate scope - multi-select-reassign-callback="$ctrl.onReassignSelectionCallback"
  this.onReassignSelectionCallback = this.onReassignSelection.bind(this);
  this.onResolveSelection = function () {
    this.onShowResolveBulkUpdateConfirmation();
  };

  // this funny syntax is used to pass in the callback via a directive that doesn't
  // use isolate scope - multi-select-reassign-callback="$ctrl.onReassignSelectionCallback"
  this.onResolveSelectionCallback = this.onResolveSelection.bind(this);
  this.updatePageSize = function (pageSize) {
    var pageSizeInt = _.toInteger(pageSize);
    gridColumnModel.updateTaskParamByName('pageSize', pageSizeInt);
    _this.resetGridPaging(pageSizeInt);
  };
  this.resetGridPaging = function (pageSize) {
    $scope.$broadcast(coreConstant.event.RESET_GRID_PAGING, pageSize);
  };
  $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function (event, type) {
    if (type === 'taskGrid') {
      this.updateColumnsFromPreferences();
      this.resetGridColumns();
    }
  }.bind(this));
  $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, function () {
    this.loadListOnFilterChange();
  }.bind(this));
  $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
    persistentConnection.connect().then(function () {
      this.isUserTypeUpdated = true;
      this.isAgent = appTypeConfigurationModel.isAgentConsole();
      this.initLandingPage();
    }.bind(this));
  }.bind(this));
  this.getTaskDefinition = function (definition) {
    return _.replace(_.replace(definition, 'Other::', ''));
  };
  $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
};
TaskGridController.$inject = ["$stateParams", "$state", "$rootScope", "$scope", "$controller", "$uibModal", "preferenceModel", "$window", "advancedFilterModel", "advancedFilterType", "appTypeConfigurationModel", "authorizationConstants", "coreConstant", "landingConstant", "submissionGridConstant", "gridColumnModel", "landingMediator", "persistentConnection", "uiPerformanceLoggerConstant", "modalUtil", "localization", "taskGridMediator", "currentUserModel", "coreMediator"];
angular.module('umLanding').controller('taskGridController', TaskGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

/*@ngInject*/
var TaskGridMediator = function TaskGridMediator(bulkResolveRepository, bulkReassignRepository) {
  this.resolveTaskList = function (params, resolutionNotes) {
    return bulkResolveRepository.resolve(params, resolutionNotes);
  };
  this.reassignTaskList = function (params, assignee) {
    return bulkReassignRepository.reassign(params, assignee);
  };
};
TaskGridMediator.$inject = ["bulkResolveRepository", "bulkReassignRepository"];
angular.module('umLanding').service('taskGridMediator', TaskGridMediator);

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

var path = '/landing/widget/taskGrid/taskGrid.tpl.html';
var html = "<div class=\"taskGridContainer\"\n     ui-submission-grid-multi-select\n     multi-select-title=\"homePage.widgets.taskGrid.bulkReassign.headerTitle\"\n     multi-select-cog-menu-label=\"homePage.widgets.taskGrid.bulkReassign.cogMenuLabel\"\n     multi-select-reassign-callback=\"$ctrl.onReassignSelectionCallback\"\n     multi-select-resolve-callback=\"$ctrl.onResolveSelectionCallback\"\n     multi-select-maximum-batch-size=\"$ctrl.multiSelectMaximumBatchSize\"\n     show-resolve-action=\"true\"\n     ng-class=\"{ multiSelect: multiSelectModel.isMultiSelectMode}\">\n\n    <div class=\"titlebarWidget\">\n\n        <!--Title Bar-->\n        <div class=\"titlebarContainer\">\n            <span ui-translate class=\"titleLabel\">taskListWidget.title</span>:\n\n            <!--Active Filter-->\n            <um-dropdown class-name=\"taskFilter\"\n                         class=\"landingTitle taskFilter\"\n                         option-list=\"$ctrl.filters\"\n                         required=\"'true'\"\n                         selected-value=\"$ctrl.selectedFilterName\"\n                         status-text=\"$ctrl.getFilterStatus()\"\n                         on-change=\"$ctrl.onFilterChange(selectedOption)\">\n            </um-dropdown>\n\n            <div class=\"btn-group saveButton\"\n                 uib-dropdown\n                 ng-if=\"$ctrl.isFilterEdited() || !$ctrl.isDefaultFilter()\">\n                <button id=\"split-button\"\n                        type=\"button\"\n                        class=\"btn large-button grey saveButton\"\n                        ng-click=\"$ctrl.onSaveFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter() && $ctrl.isFilterEdited()\"\n                        ui-translate>advancedFilter.saveFilterLabel\n                </button>\n                <button id=\"split-button-as\"\n                        type=\"button\"\n                        class=\"btn large-button grey saveFilterAsButton saveButton\"\n                        ng-click=\"$ctrl.onSaveFilterAs()\"\n                        ng-if=\"$ctrl.isDefaultFilter() || (!$ctrl.isDefaultFilter() && !$ctrl.isFilterEdited())\"\n                        ui-translate>advancedFilter.saveFilterAsLabel\n                </button>\n                <button type=\"button\"\n                        class=\"btn toggleButton grey saveButton\"\n                        uib-dropdown-toggle>\n                    <span class=\"caret\"></span>\n                </button>\n                <ul class=\"dropdown-menu\"\n                    uib-dropdown-menu role=\"menu\">\n                    <li role=\"menuitem\"\n                        ng-click=\"$ctrl.onSaveFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter() && $ctrl.isFilterEdited()\">\n                        <a ui-translate>advancedFilter.saveFilterLabel</a>\n                    </li>\n                    <li role=\"menuitem\"\n                        ng-click=\"$ctrl.onSaveFilterAs()\">\n                        <a ui-translate>advancedFilter.saveFilterAsLabel</a>\n                    </li>\n                    <li role=\"menuitem\"\n                        class=\"deleteFilterInTaskGrid\"\n                        ng-click=\"$ctrl.onDeleteFilter()\"\n                        ng-if=\"!$ctrl.isDefaultFilter()\">\n                        <a ui-translate>advancedFilter.deleteFilterLabel</a>\n                    </li>\n                    <li role=\"menuitem\">\n                        <a ng-click=\"$ctrl.resetFilter($event)\"\n                           ng-if=\"$ctrl.isFilterEdited()\"\n                           ui-translate>advancedFilter.resetFilter</a></li>\n                </ul>\n            </div>\n\n            <!--Search-->\n            <div class=\"submissionFilter gridster-no-drag\"\n                 ng-click=\"$ctrl.onToggleSearch()\"\n                 ng-if=\"$ctrl.hasFilterPermission && $ctrl.filterModel && $ctrl.advancedFilterType\"\n                 uib-tooltip=\"{{ $ctrl.searchIconTooltip }}\"\n                 tooltip-popup-delay=\"500\"\n                 tooltip-append-to-body=\"true\"\n                 tooltip-placement=\"bottom\">\n                <span class=\"glyphicon glyphicon-search toggleButton\"></span>\n            </div>\n\n            <!--Action Buttons-->\n            <div class=\"actionButtonList laterButton\">\n\n                <div class=\"btn-group gridster-no-drag\"\n                     uib-dropdown\n                     dropdown-append-to-body=\"true\">\n\n                    <button type=\"button\"\n                            class=\"btn btn-xs\"\n                            uib-dropdown-toggle\n                            uib-tooltip=\"{{ $ctrl.showOrHideToolsTooltip }}\"\n                            tooltip-popup-delay=\"500\"\n                            tooltip-append-to-body=\"true\"\n                            tooltip-placement=\"bottom\">\n                        <span class=\"glyphicon glyphicon-cog\"></span>\n                    </button>\n\n                    <ul class=\"dropdown-menu-right taskGridActionMenuDropdown\"\n                        uib-dropdown-menu>\n\n                        <!--Download Link-->\n                        <li role=\"menuitem\">\n                            <a uib-dropdown\n                               auto-close=\"outsideClick\"\n                               ng-click=\"$ctrl.onDownloadUrlClick()\">\n                                <span ui-translate>homePage.widgets.taskGrid.downloadCsv</span>\n                            </a>\n                        </li>\n\n                        <!--Configure Column Dropdown Row-->\n                        <li role=\"menuitem\">\n                            <a uib-dropdown\n                               uib-dropdown-toggle\n                               auto-close=\"outsideClick\"\n                               dropdown-append-to-body=\"true\"\n                               class=\"submissionGridConfigureColumns\">\n\n                                <span ui-translate>widgetActions.configureColumns</span>\n\n                                <!--Configure Column Dropdown Menu-->\n                                <div class=\"submissionGridColumnDropdownMenu\"\n                                     uib-dropdown-menu>\n                                    <ul>\n                                        <!--Item List-->\n                                        <li class=\"columnFilterRow\"\n                                            ng-class=\"{ disabled: col.disabled }\"\n                                            ng-repeat=\"col in $ctrl.dropdownColumns\"\n                                            ng-click=\"$ctrl.onColumnCheckboxClick($event, col)\">\n\n                                            <input type=\"checkbox\"\n                                                   class=\"columnCheckbox {{$ctrl.getColumnClassName(col.displayName)}}\"\n                                                   ng-model=\"col.visible\"\n                                                   ng-change='$ctrl.onColumnCheckboxClick($event, col)'\n                                                   ng-disabled=\"col.disabled\"/>\n\n                                            <span>{{ col.displayName }}</span>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </a>\n                        </li>\n\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isMinimized() }\">\n\n                            <a class=\"taskGridMinimize\" ng-click=\"$ctrl.minimize($event)\"\n                               ui-translate>widgetActions.minimize</a>\n                        </li>\n\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isMaximized() }\">\n\n                            <a class=\"taskGridMaximize\" ng-click=\"$ctrl.maximize($event)\"\n                               ui-translate>widgetActions.maximize</a>\n                        </li>\n\n                        <li role=\"menuitem\"\n                            ng-class=\"{ disabled : $ctrl.isAtDefaultSize() }\">\n\n                            <a class=\"taskGridReturnToDefaultSize\" ng-click=\"$ctrl.returnToDefaultSize($event)\"\n                               ui-translate>widgetActions.returnToDefaultSize</a>\n                        </li>\n\n                        <li role=\"menuitem\"\n                            ng-if=\"$ctrl.isMultiSelectEnabled\"\n                            ng-include=\"'/ui/grid/multiSelect/template/multiSelectButton.tpl.html'\"></li>\n\n                    </ul>\n                </div>\n\n            </div>\n        </div>\n    </div>\n\n    <div class=\"landing gridWindow\"\n         app-mode-configuration>\n\n        <!--Search Form-->\n        <div class=\"activityStreamSearchForm\"\n             ng-if=\"$ctrl.isSearchOpen\"\n             ng-class=\"{ 'is-open': $ctrl.isSearchOpen }\">\n\n            <ui-advanced-filter-list\n                class=\"advancedFilterListWrapper\"\n                ng-if=\"$ctrl.isSearchOpen\"\n                filter-model=\"$ctrl.filterModel\"\n                show-all-templates=\"false\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\">\n            </ui-advanced-filter-list>\n        </div>\n\n        <!--Bulk Update Header-->\n        <div class=\"bulkUpdateHeader\"\n             ng-if=\"$ctrl.isBulkUpdateMode\">\n\n            <div class=\"instructions\" ui-translate>homePage.widgets.taskGrid.instructions</div>\n\n            <button class=\"btn btn-sm btn-default cancelBulkUpdate\"\n                    ng-click=\"$ctrl.onCancelBulkUpdate()\"\n                    ui-translate>homePage.widgets.taskGrid.cancel\n            </button>\n\n            <button class=\"btn btn-sm btn-primary reassignBulkUpdate\"\n                    ng-click=\"$ctrl.onShowReassignBulkUpdateConfirmation()\"\n                    ng-disabled=\"!$ctrl.selectedBulkItems.length\"\n                    ui-translate>homePage.widgets.taskGrid.reassignButton\n            </button>\n\n            <button class=\"btn btn-sm btn-primary resolveBulkUpdate\"\n                    ng-click=\"$ctrl.onShowResolveBulkUpdateConfirmation()\"\n                    ng-disabled=\"!$ctrl.selectedBulkItems.length\"\n                    ui-translate>homePage.widgets.taskGrid.resolveButton\n            </button>\n        </div>\n\n\n        <!--Grid-->\n        <div class=\"content landingContent\"\n             ui-widget-grid-scroll-manager\n             ui-scroll-detection\n             scroll-fixed-grid-arrow>\n\n            <div class=\"multiSelectHeader\"\n                 ng-include=\"'/ui/grid/multiSelect/template/multiSelectHeader.tpl.html'\"></div>\n\n            <!--Grid Header-->\n            <div class=\"columnHeader\">\n                <div class=\"columnRow columnDisposition\">\n\n                    <!--MultiSelect Column-->\n                    <div class=\"column col rowSelector\"\n                         ng-if=\"multiSelectModel.isMultiSelectMode\">\n\n                        <input type=\"checkbox\"\n                               ng-click=\"multiSelectUtil.onToggleSelectAllCheckbox()\"\n                               ng-checked=\"multiSelectUtil.isSelectAllCheckboxSelected()\">\n                    </div>\n\n                    <div class=\"col colSelect\"\n                         ng-if=\"$ctrl.isBulkUpdateMode\">\n\n                        <input type=\"checkbox\"\n                               ng-model=\"$ctrl.bulkUpdateSelectAll\"\n                               ng-change=\"$ctrl.onBulkUpdateSelectAllRecords()\">\n                    </div>\n\n                    <div class=\"colResolved\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"resolutionDate\"\n                         item-label=\"homePage.grid.header.resolved\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colResolved\"></div>\n\n                    <div class=\"colPriority\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"priority\"\n                         item-label=\"homePage.grid.header.priority\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colPriority\"></div>\n\n                    <div class=\"colCreatedDate\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"createdDate\"\n                         item-label=\"homePage.grid.header.createdDate\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colCreatedDate\"></div>\n\n                    <div class=\"colDefault colDueDate\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"dueDate\"\n                         item-label=\"homePage.grid.header.dueDate\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colDueDate\"></div>\n\n                    <div class=\"colResolvedDate\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"resolutionDate\"\n                         item-label=\"homePage.grid.header.resolvedDate\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colResolvedDate\"></div>\n\n                    <div class=\"colDefault colTaskSummary\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"definition\"\n                         item-label=\"homePage.grid.header.taskSummary\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colTaskSummary\"></div>\n\n                    <div class=\"colInsuredName\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"insuredName\"\n                         item-label=\"homePage.grid.header.insured\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colInsuredName\"></div>\n\n                    <div class=\"colDefault colAssignedTo\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"assignedToName\"\n                         item-label=\"homePage.grid.header.assignedTo\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colAssignedTo\"></div>\n\n                    <div class=\"colDefault colAssignedBy\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"assignedByName\"\n                         item-label=\"homePage.grid.header.assignedBy\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colAssignedBy\"></div>\n\n                    <div class=\"colDefault colTaskDetails\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"details\"\n                         item-label=\"homePage.grid.header.taskDetails\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colTaskDetails\"></div>\n\n                    <div class=\"colDefault colSubmissionProduct\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"productShortNames\"\n                         item-label=\"homePage.grid.header.coverage\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colCoverage\"></div>\n\n                    <div class=\"colDate\"\n                         ui-grid-sortable-header\n                         reset-grid-headers=\"$ctrl.resetGridHeaders($value)\"\n                         item-name=\"effectiveDate\"\n                         item-label=\"homePage.grid.header.effective\"\n                         request-params=\"$ctrl.requestParams\"\n                         ng-if=\"$ctrl.colViewModel.colEffectiveDate\"></div>\n                    <div class=\"col scrollBar\"></div>\n                </div>\n            </div>\n\n\n            <div class=\"scrollVerticalContainer\">\n                <div class=\"datagrid table\"\n                     ux-datagrid=\"$ctrl.records\"\n                     options=\"{chunks:{size: $ctrl.pageSize}}\"\n                     ng-if=\"!$ctrl.isLoading\">\n\n                    <script type=\"template/html\"\n                            data-template-item=\"item\"\n                            data-template-name=\"default\">\n\n                        <div class=\"rowDrawerWrapper\"\n                             ng-class=\"{\n                                selected: multiSelectUtil.isRowSelected(item.id) || item.selected && $ctrl.isDrawerOpen,\n                                bulkSelection: item.selected && $ctrl.isBulkUpdateMode\n                             }\">\n\n                            <div class=\"columnRow\"\n                                 ng-class=\"{ selected: multiSelectUtil.isRowSelected(item.id) || item.selected }\"\n                                 ng-click=\"$ctrl.setSelectedItem($event, item)\">\n\n                                <!--MultiSelect Column-->\n                                <div class=\"col rowSelector\"\n                                     ng-if=\"multiSelectModel.isMultiSelectMode\">\n\n                                    <input type=\"checkbox\"\n                                           ng-checked=\"multiSelectUtil.isRowSelected(item.id)\"/>\n                                </div>\n\n                                <div class=\"col colSelect\"\n                                     ng-if=\"$ctrl.isBulkUpdateMode\">\n                                    <input type=\"checkbox\"\n                                           ng-model=\"item.selected\"\n                                           ng-change=\"$ctrl.setSelectedItem($event, item)\">\n                                </div>\n\n                                <div class=\"col colResolved resolved\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     ng-if=\"$ctrl.colViewModel.colResolved\">\n                                    <span class=\"glyphicon glyphicon-ok\"\n                                          ng-if=\"item.resolutionDate\"></span>\n                                </div>\n                                <div class=\"col colPriority priority\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     ng-if=\"$ctrl.colViewModel.colPriority\">\n                                      <span class=\"glyphicon\"\n                                            ng-class=\"{'glyphicon-arrow-down' : item.priority===1,\n                                                        'glyphicon-minus' : item.priority===2,\n                                                        'glyphicon-arrow-up' : item.priority===3}\"></span>\n                                </div>\n\n                                <div class=\"col colCreatedDate\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     ng-if=\"$ctrl.colViewModel.colCreatedDate\">\n                                    {{ item.createdDate | utcDateFilter: $ctrl.shortDateFormat }}\n                                </div>\n\n                                <div class=\"col colDefault colDueDate\"\n                                     ng-class=\"{'pastDue' : $ctrl.isPastDue(item.dueDate)}\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     ng-if=\"$ctrl.colViewModel.colDueDate\">\n                                    {{ item.dueDate | utcDateFilter: $ctrl.shortDateFormat:true }}\n                                </div>\n                                <div class=\"col colResolvedDate\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     ng-if=\"$ctrl.colViewModel.colResolvedDate\">\n                                    {{ item.resolutionDate | utcDateFilter: $ctrl.shortDateFormat }}\n                                </div>\n\n                                <div class=\"col colDefault colTaskSummary\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{$ctrl.getTaskDefinition(item.definition)}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isTaskSummaryTooltip}}\"\n                                     ui-is-tooltip-enabled=\"item.isTaskSummaryTooltip\"\n                                     ng-if=\"$ctrl.colViewModel.colTaskSummary\">\n                                    {{ $ctrl.getTaskDefinition(item.definition) }}\n                                </div>\n                                <div class=\"col colInsuredName\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.insuredName}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isTaskInsuredTooltip}}\"\n                                     ui-is-tooltip-enabled=\"item.isTaskInsuredTooltip\"\n                                     ng-if=\"$ctrl.colViewModel.colInsuredName\">\n                                    {{ item.insuredName }}\n                                </div>\n                                <div class=\"col colDefault colAssignedTo\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.assignedToName}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isTaskAssignedToTooltip}}\"\n                                     ui-is-tooltip-enabled=\"item.isTaskAssignedToTooltip\"\n                                     ng-if=\"$ctrl.colViewModel.colAssignedTo && item.assignedToName\">\n                                    {{ item.assignedToName }}\n                                </div>\n\n                                <div class=\"col colDefault colAssignedToGroupName\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.assignedToGroupName}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{::$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isTaskAssignedToTooltip}}\"\n                                     ui-is-tooltip-enabled=\"item.isTaskAssignedToTooltip\"\n                                     ng-if=\"$ctrl.colViewModel.colAssignedTo && item.assignedToGroupName && !item.assignedToName\">\n                                    {{ item.assignedToGroupName }}\n                                </div>\n                                <div class=\"col colDefault colAssignedBy\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.assignedByName}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isTaskAssignedByTooltip}}\"\n                                     ui-is-tooltip-enabled=\"item.isTaskAssignedByTooltip\"\n                                     ng-if=\"$ctrl.colViewModel.colAssignedBy\">\n                                    {{ item.assignedByName }}\n                                </div>\n                                <div class=\"col colDefault colTaskDetails\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     uib-tooltip=\"{{item.details}}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"{{$ctrl.toolTipDelay}}\"\n                                     tooltip-enable=\"{{item.isTaskDetailsTooltip}}\"\n                                     ui-is-tooltip-enabled=\"item.isTaskDetailsTooltip\"\n                                     ng-if=\"$ctrl.colViewModel.colTaskDetails\">\n                                    {{ item.details }}\n                                </div>\n                                <div class=\"col colDefault colCoverage\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     ng-if=\"$ctrl.colViewModel.colCoverage\">\n                                    {{ item.productShortNames }}\n                                </div>\n                                <div class=\"col colDate\"\n                                     ng-click=\"$ctrl.openTask(item)\"\n                                     ng-if=\"$ctrl.colViewModel.colEffectiveDate\">\n                                    {{ item.effectiveDate | utcDateFilter: $ctrl.shortDateFormat }}\n                                </div>\n                            </div>\n\n                            <div class=\"toggleDrawer\"\n                                 ng-click=\"$ctrl.setSelectedItem($event, item)\">\n                                <span class=\"glyphicon glyphicon-chevron-right\"></span>\n                            </div>\n\n                            <task-details-drawer-directive\n                                item-model=\"item\"\n                                col-view-model=\"$ctrl.colViewModel\"\n                                is-agent=\"$ctrl.isAgent\"></task-details-drawer-directive>\n\n                        </div>\n\n                    </script>\n                </div>\n\n                <div class=\"gridEmpty\"\n                     ng-if=\"$ctrl.isGridEmpty && !$ctrl.isLoading\" ui-translate>homePage.grid.emptyTaskMessage\n                </div>\n\n            </div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"$ctrl.isLoading\"></div>\n        </div>\n\n        <ui-grid-paging-component\n            ng-hide=\"$ctrl.totalRecords === 0\"\n            class=\"landingPagination\"\n            start-index=\"$ctrl.requestParams.startIndex\"\n            page-size=\"$ctrl.pageSize\"\n            total-records=\"$ctrl.totalRecords\"\n            record-count-text=\"$ctrl.recordCountText\"\n            records-count-text=\"$ctrl.recordsCountText\"\n            on-change=\"$ctrl.onPagingChange($event, params)\"></ui-grid-paging-component>\n\n        <div class=\"taskGridPageSize\" ng-if=\"$ctrl.totalRecords !== 0\">\n            <div class=\"taskGridPageSizeLabel\">{{::$ctrl.i18n.homePage.widgets.taskGrid.pageSizeLabel}}</div>\n            <div class=\"taskGridPageSizeDropdownWrapper\">\n                <select\n                    ng-model=\"$ctrl.pageSize\"\n                    ng-options=\"option for option in $ctrl.pageSizeOptions\"\n                    ng-change=\"$ctrl.updatePageSize($ctrl.pageSize)\">\n                </select>\n            </div>\n        </div>\n    </div>\n\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(1807);

/*@ngInject*/
var ReassignModalController = function ReassignModalController($rootScope, $scope, $filter, options, localization, coreMediator, coreConstant, submissionConstant) {
  $scope.taskReassignI18n = locale;
  localization.getTranslations().then(function (result) {
    this.translations = result;
    $scope.saveButton = _.get(this.translations, 'homePage.widgets.taskGrid.reassignButton');
    $scope.cancelButton = _.get(this.translations, 'homePage.widgets.taskGrid.cancel');
  }.bind(this));
  $scope.title = options.title;
  $scope.summary = options.summary;
  $scope.filteredItemsList = [];
  $scope.reassignViewModel = {
    selectedAssignee: null
  };
  $scope.onConfirm = function () {
    $scope.$close($scope.reassignViewModel.selectedAssignee);
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  coreMediator.loadUsersList().then(function (users) {
    $scope.peopleList = users;
  });
  $scope.filterItems = function (searchText) {
    var filteredItemsList = [];
    var maxItems = 150;
    if (!_.isEmpty(searchText)) {
      filteredItemsList = _.filter($scope.peopleList, function (item) {
        return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
      });
      //if after searching there are over 150 participants - still only display submissionParticipants
      if (filteredItemsList.length > maxItems) {
        filteredItemsList = [{
          id: 0,
          name: getLongListWarning($scope.peopleList.length),
          disabled: true
        }];
      }
    } else {
      if ($scope.peopleList.length > maxItems) {
        filteredItemsList = [{
          id: 0,
          name: getLongListWarning($scope.peopleList.length),
          disabled: true
        }];
      } else {
        filteredItemsList = $scope.peopleList;
      }
    }
    $scope.filteredItemsList = filteredItemsList;
  };
  function getLongListWarning(listLength) {
    var message = $scope.taskReassignI18n.longListMessage;
    message = _.replace(message, '{0}', $filter('number')(listLength));
    return message;
  }
  ;
  $scope.canEnableConfirmButton = function () {
    return $scope.reassignViewModel.selectedAssignee;
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ReassignModalController.$inject = ["$rootScope", "$scope", "$filter", "options", "localization", "coreMediator", "coreConstant", "submissionConstant"];
angular.module('umLanding').controller('reassignModalController', ReassignModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1807 */
/***/ (function(module) {

module.exports = JSON.parse("{\"longListMessage\":\"Too many results ({0} items). Please revise your search to display users other than submission participants.\"}");

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

var path = '/landing/widget/taskGrid/reassign/reassignModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"saveButton\"\n    cancel=\"cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"reassignModalContent\">\n\n        <div class=\"summaryText\">{{ ::summary }}</div>\n\n        <div class=\"peoplePicker\">\n            <ui-select class=\"dropdownFormComponent dropdownComponentSelect reassignTaskPeoplePicker\"\n                       ng-model=\"reassignViewModel.selectedAssignee\"\n                       theme=\"select2\"\n                       on-select=\"$ctrl.handleSelect($select)\"\n                       append-to-body=\"true\"\n                       dropdown-unselect-item\n                       dropdown-handle-focus>\n\n                <ui-select-match allow-clear=\"true\">\n\n                    <ui-user-avatar class=\"assignedToAvatar\"\n                                    ng-if=\"reassignViewModel.selectedAssignee.group !== 'User Groups'\"\n                                    userid=\"{{ reassignViewModel.selectedAssignee.id }}\"></ui-user-avatar>\n\n                    <span ng-bind=\"reassignViewModel.selectedAssignee.name\"></span>\n\n                </ui-select-match>\n\n                <ui-select-choices group-by=\"'group'\"\n                                   refresh=\"filterItems($select.search)\"\n                                   refresh-delay=\"250\"\n                                   repeat=\"item in filteredItemsList track by $index\"\n                                   ui-disable-choice=\"item.disabled === true\">\n\n                    <span ng-bind-html=\"item.name | highlight: $select.search\"></span>\n                    <span ng-if=\"item.group === 'Submission Participants' && item.roles && item.disabled !== true\"> ({{ item.roles }})</span>\n\n                </ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

/*@ngInject*/
var BulkReassignRepository = function BulkReassignRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.reassign = function (params, assignee) {
    var url = '/rest/SubmissionTask/bulkUpdate',
      config = {
        params: params
      },
      body = {};
    if (assignee.group === 'User Groups') {
      body.assignedToId = null;
      body.assignedToFullName = null;
      body.assignedToGroupId = assignee.id;
      body.assignedToGroupName = assignee.name;
    } else {
      body.assignedToId = assignee.id;
      body.assignedToFullName = assignee.name;
      body.assignedToGroupId = null;
      body.assignedToGroupName = null;
    }
    return this.post(url, body, config);
  };
};
BulkReassignRepository.$inject = ["baseRepository"];
angular.module('umLanding').service('bulkReassignRepository', BulkReassignRepository);

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

var path = '/landing/widget/taskGrid/resolve/resolveModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"saveButton\"\n    cancel=\"cancelButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"resolveModalContent\">\n\n        <div class=\"summaryText\">{{ ::summary }}</div>\n\n        <div class=\"resolutionNotes\">\n            <textarea ng-model=\"resolutionNotes\"\n                      ng-change=\"onChange(resolutionNotes)\"></textarea>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ResolveModalController = function ResolveModalController($rootScope, $scope, options, localization, coreConstant) {
  localization.getTranslations().then(function (result) {
    this.translations = result;
    $scope.saveButton = _.get(this.translations, 'homePage.widgets.taskGrid.resolveButton');
    $scope.cancelButton = _.get(this.translations, 'homePage.widgets.taskGrid.cancel');
  }.bind(this));
  $scope.title = options.title;
  $scope.summary = options.summary;
  $scope.resolutionNotes = '';
  $scope.onConfirm = function () {
    $scope.$close($scope.resolutionNotes);
  };
  $scope.onChange = function (resolutionNotes) {
    $scope.resolutionNotes = resolutionNotes;
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ResolveModalController.$inject = ["$rootScope", "$scope", "options", "localization", "coreConstant"];
angular.module('umLanding').controller('resolveModalController', ResolveModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

/*@ngInject*/
var BulkResolveRepository = function BulkResolveRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.resolve = function (params, resolutionNotes) {
    var url = '/rest/SubmissionTask/bulkUpdate',
      config = {
        params: params
      },
      body = {
        status: 1,
        comments: resolutionNotes
      };
    return this.post(url, body, config);
  };
};
BulkResolveRepository.$inject = ["baseRepository"];
angular.module('umLanding').service('bulkResolveRepository', BulkResolveRepository);

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var TaskDetailsDrawerDirective = function TaskDetailsDrawerDirective($timeout, $document, coreMediator, landingConstant, dateUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var timerDelay = 300,
      timeoutList = [];
    $scope.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    $scope.itemModel.drawerOpen = false;
    $scope.assignedToImage = null;
    $scope.assignedByImage = null;
    $scope.resolvedByImage = null;
    $scope.assignedToImageLoading = false;
    $scope.assignedByImageLoading = false;
    $scope.resolvedByImageLoading = false;
    function loadAssignedToImage() {
      if (!$scope.itemModel.assignedToId) {
        return;
      }
      $scope.assignedToImageLoading = true;
      coreMediator.loadProfileImage($scope.itemModel.assignedToId).then(function (assignedToImage) {
        $scope.assignedToImage = assignedToImage;
        $scope.assignedToImageLoading = false;
      });
    }
    function loadAssignedByImage() {
      if (!$scope.itemModel.assignedById) {
        return;
      }
      $scope.assignedByImageLoading = true;
      coreMediator.loadProfileImage($scope.itemModel.assignedById).then(function (assignedByImage) {
        $scope.assignedByImage = assignedByImage;
        $scope.assignedByImageLoading = false;
      });
    }
    function loadResolvedByImage() {
      if (!$scope.itemModel.resolvedById) {
        return;
      }
      $scope.resolvedByImageLoading = true;
      coreMediator.loadProfileImage($scope.itemModel.resolvedById).then(function (resolvedByImage) {
        $scope.resolvedByImage = resolvedByImage;
        $scope.resolvedByImageLoading = false;
      });
    }
    function scrollDrawerIntoView() {
      var $scrollContainer = $elm.parents('.scrollVerticalContainer');
      var scrollContainerHeight = $scrollContainer.prop('offsetHeight'),
        scrollContainerPosition = $scrollContainer.prop('scrollTop'),
        currentRowPosition = $elm.parent().position().top,
        currentRowHeight = 60,
        drawerHeight = 0,
        drawerBottomPosition = 0,
        scrollToValue = 0;
      timeoutList.push($timeout(function () {
        drawerHeight = $elm.prop('offsetHeight');
        drawerBottomPosition = currentRowPosition + currentRowHeight + drawerHeight;
        drawerColumnsEmpty();
        if (drawerBottomPosition > scrollContainerHeight) {
          scrollToValue = scrollContainerPosition - (scrollContainerHeight - drawerBottomPosition);
          $scrollContainer.animate({
            scrollTop: scrollToValue
          }, 200);
        }
      }, timerDelay));
    }
    function drawerColumnsEmpty() {
      $elm.find('.drawerCol').each(function () {
        var $drawerColumn = $(this);
        if ($drawerColumn.children().length > 1) {
          $drawerColumn.css('visibility', 'visible');
        } else {
          $drawerColumn.hide();
        }
      });
    }
    $scope.$on(landingConstant.event.OPEN_TASK_DETAIL_DRAWER, function () {
      if ($scope.itemModel.selected) {
        loadAssignedToImage();
        loadAssignedByImage();
        loadResolvedByImage();
        $scope.itemModel.drawerOpen = true;
        scrollDrawerIntoView();
      }
    });
    $scope.$on(landingConstant.event.CLOSE_TASK_DETAIL_DRAWER, function () {
      if ($scope.itemModel.drawerOpen) {
        timeoutList.push($timeout(function () {
          $scope.itemModel.drawerOpen = false;
        }, timerDelay));
      }
    });
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'E',
    replace: true,
    scope: {
      itemModel: '<?',
      colViewModel: '<?',
      isAgent: '<?'
    },
    link: linkFunction,
    templateUrl: '/landing/directives/taskDetailsDrawer/taskDetailsDrawerDirective.tpl.html'
  };
};
TaskDetailsDrawerDirective.$inject = ["$timeout", "$document", "coreMediator", "landingConstant", "dateUtil"];
angular.module('umLanding').directive('taskDetailsDrawerDirective', TaskDetailsDrawerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

var path = '/landing/directives/taskDetailsDrawer/taskDetailsDrawerDirective.tpl.html';
var html = "<div class=\"drawer\">\n\n    <div class=\"drawerRow\" ng-if=\"itemModel.drawerOpen\">\n\n        <div class=\"drawerCol taskDrawerCol\">\n            <h5 class=\"detailTitle\" ui-translate>homePage.grid.details.taskDetails.title</h5>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.details && !colViewModel.colTaskDetails\">\n                <label ui-translate>homePage.grid.details.taskDetails.taskDetails</label>\n                <span class=\"detailValue\">{{ itemModel.details }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.assignedToName && !colViewModel.colAssignedTo\">\n                <label class=\"userLabel\" ui-translate>homePage.grid.details.taskDetails.assignedTo</label>\n                <ui-user-avatar\n                    ng-src=\"{{ assignedToImage }}\"\n                    userid=\"{{ itemModel.assignedToId }}\"\n                    is-loading=\"assignedToImageLoading\"\n                    submissionid=\"{{ itemModel.submissionId }}\"></ui-user-avatar>\n                <span class=\"detailValue\">{{ itemModel.assignedToName }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.dueDate && !colViewModel.colDueDate\">\n                <label ui-translate>homePage.grid.details.taskDetails.dueDate</label>\n                <span class=\"detailValue\">{{ itemModel.dueDate | utcDateFilter: shortDateFormat }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"!isAgent && itemModel.priority && !colViewModel.colPriority\">\n                <label ui-translate>homePage.grid.details.taskDetails.priority</label>\n                <span class=\"detailValue\">\n                    <span class=\"glyphicon\"\n                          ng-class=\"{'glyphicon-arrow-down' : itemModel.priority===1,\n                            'glyphicon-minus' : itemModel.priority===2,\n                            'glyphicon-arrow-up' : itemModel.priority===3\n                        }\"></span>\n                </span>\n            </div>\n        </div>\n\n        <div class=\"drawerCol taskDrawerCol\">\n            <h5 class=\"detailTitle\" ui-translate>homePage.grid.details.taskResolution.title</h5>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.resolvedByName\">\n                <label class=\"userLabel\" ui-translate>homePage.grid.details.taskResolution.resolvedBy</label>\n                <ui-user-avatar\n                    ng-src=\"{{ resolvedByImage }}\"\n                    userid=\"{{ itemModel.resolvedById }}\"\n                    is-loading=\"resolvedByImageLoading\"\n                    submissionid=\"{{ itemModel.submissionId }}\"></ui-user-avatar>\n                <span class=\"detailValue\">{{ itemModel.resolvedByName }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.resolutionDate\">\n                <label ui-translate>homePage.grid.details.taskResolution.resolutionDate</label>\n                <span class=\"detailValue\">{{ itemModel.resolutionDate | utcDateFilter: shortDateFormat }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.comments\">\n                <label ui-translate>homePage.grid.details.taskResolution.comments</label>\n                <span class=\"detailValue\">{{ itemModel.comments }}</span>\n            </div>\n        </div>\n\n        <div class=\"drawerCol taskDrawerCol\">\n            <h5 class=\"detailTitle\" ui-translate>homePage.grid.details.submissionDetails.title</h5>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.insuredName && !colViewModel.colInsuredName\">\n                <label ui-translate>homePage.grid.details.submissionDetails.insuredName</label>\n                <span class=\"detailValue\">{{ itemModel.insuredName }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.submissionNumber\">\n                <label ui-translate>homePage.grid.details.submissionDetails.submissionNumber</label>\n                <span class=\"detailValue\">{{ itemModel.submissionNumber }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.effectiveDate && !colViewModel.colEffectiveDate\">\n                <label ui-translate>homePage.grid.details.submissionDetails.effectiveDate</label>\n                <span class=\"detailValue\">{{ itemModel.effectiveDate | utcDateFilter: shortDateFormat }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.productShortNames && !colViewModel.colCoverage\">\n                <label ui-translate>homePage.grid.details.submissionDetails.products</label>\n                <span class=\"detailValue\">{{ itemModel.productShortNames }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.submissionStatus\">\n                <label ui-translate>homePage.grid.details.submissionDetails.status</label>\n                <span class=\"detailValue\" ui-translate>submission.status.{{itemModel.submissionStatus}}</span>\n            </div>\n        </div>\n\n        <div class=\"drawerCol\">\n            <h5 class=\"detailTitle\" ui-translate>homePage.grid.details.taskHistory.title</h5>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.assignedByName && !colViewModel.colAssignedBy\">\n                <label class=\"userLabel\" ui-translate>homePage.grid.details.taskHistory.assignedBy</label>\n                <ui-user-avatar\n                    ng-src=\"{{ assignedByImage }}\"\n                    userid=\"{{ itemModel.assignedById }}\"\n                    is-loading=\"assignedByImageLoading\"\n                    submissionid=\"{{ itemModel.submissionId }}\"></ui-user-avatar>\n                <span class=\"detailValue\">{{ itemModel.assignedByName }}</span>\n            </div>\n            <div class=\"detailItem\"\n                 ng-if=\"itemModel.createdDate\">\n                <label ui-translate>homePage.grid.details.taskHistory.assignedDate</label>\n                <span class=\"detailValue\">{{ itemModel.createdDate | utcDateFilter: shortDateFormat + ' hh:mm a' : true}}</span>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

angular.module('umConfig', []).constant('moduleConfigConstant', {
  submission: {
    showHeader: true,
    routes: {
      'extension': {
        url: '/submission/:submissionId/extensions/:extension',
        views: {
          'header': {
            templateUrl: '/common/header/appHeader.tpl.html',
            controller: 'appHeaderController'
          },
          'content': {
            templateUrl: '/dynamicGrid.tpl.html',
            controller: 'dynamicGridController'
          }
        }
      },
      'submission': {
        url: '/submission/:submissionId',
        views: {
          'header': {
            templateUrl: '/common/header/appHeader.tpl.html',
            controller: 'appHeaderController'
          },
          'content': {
            templateUrl: '/submission.tpl.html',
            controller: 'submissionController'
          }
        }
      },
      'submission.print': {
        url: '/print/:formId',
        views: {
          'mainContent': {
            templateUrl: '/content/print/printOverview.tpl.html',
            controller: 'printOverviewController'
          }
        },
        params: {
          print: true,
          formSummaryInstanceId: null,
          ownerUriId: null
        }
      },
      'submission.printCollaboration': {
        url: '/print/collaboration/:collabType',
        views: {
          'mainContent': {
            templateUrl: '/content/print/printCollaboration.tpl.html',
            controller: 'printOverviewController'
          }
        },
        params: {
          print: true,
          formSummaryInstanceId: null,
          ownerUriId: null
        }
      },
      'submission.printFormSummaryGridDetail': {
        url: '/print/:formId/detail/:ownerUriId/:formSummaryInstanceId',
        views: {
          'mainContent': {
            templateUrl: '/content/print/printOverview.tpl.html',
            controller: 'printOverviewController'
          }
        },
        params: {
          print: true
        }
      },
      'submission.accountSubmissionsGrid': {
        url: '/account/:accountId/list',
        views: {
          'mainContent': {
            templateUrl: '/content/accountSubmissionsGrid/accountSubmissions.tpl.html',
            controller: 'accountSubmissionsController'
          }
        }
      },
      'submission.default': {
        url: '/default',
        views: {
          'mainContent': {
            templateUrl: '/form/submissionFormViewer.tpl.html',
            controller: 'submissionFormViewerController'
          }
        }
      },
      'submission.collab': {
        url: '/collab/:collabType/:collabId',
        views: {
          'mainContent': {
            templateUrl: '/form/submissionFormViewer.tpl.html',
            controller: 'submissionFormViewerController'
          }
        }
      },
      'submission.form': {
        url: '/form/:formId',
        views: {
          'mainContent': {
            templateUrl: '/form/submissionFormViewer.tpl.html',
            controller: 'submissionFormViewerController'
          }
        },
        params: {
          formId: {
            value: null,
            squash: true
          }
        }
      },
      'submission.formSummaryGridDetail': {
        url: '/form/:formId/detail/:ownerUriId/:formSummaryInstanceId',
        views: {
          'mainContent': {
            templateUrl: '/formViewer/component/formSummary/detail/formSummaryGridDetail.tpl.html',
            controller: 'formSummaryGridDetailController'
          }
        },
        resolve: {
          /*@ngInject*/
          effectiveDate: ["currentSubmissionModel", function effectiveDate(currentSubmissionModel) {
            return {
              get: function get() {
                return currentSubmissionModel.getCurrentSubmission().effectiveDate;
              }
            };
          }],
          /*@ngInject*/
          currencyCode: ["currentSubmissionModel", function currencyCode(currentSubmissionModel) {
            return {
              get: function get() {
                return currentSubmissionModel.getCurrentSubmission().currencyCode;
              }
            };
          }],
          printable: function printable() {
            return {
              get: function get() {
                return true;
              }
            };
          }
        }
      },
      'submission.document': {
        url: '/document/:attachmentId',
        views: {
          'mainContent': {
            templateUrl: '/content/document/document.tpl.html',
            controller: 'documentController'
          }
        }
      },
      'submission.quote': {
        url: '/quote/:quoteId',
        views: {
          'mainContent': {
            templateUrl: '/content/quoteSummaries/quoteSummaries.tpl.html',
            controller: 'quoteSummariesController'
          }
        }
      },
      'submission.quotes': {
        url: '/quotes',
        views: {
          'mainContent': {
            templateUrl: '/content/quoteSummaries/quoteSummaries.tpl.html',
            controller: 'quoteSummariesController'
          }
        }
      },
      'submission.proposal': {
        url: '/proposal/:proposalId',
        views: {
          'mainContent': {
            templateUrl: '/content/proposalSummary/proposalSummary.tpl.html',
            controller: 'proposalSummaryController'
          }
        }
      },
      'submission.proposals': {
        url: '/proposals',
        views: {
          'mainContent': {
            templateUrl: '/content/proposalSummaries/proposalSummaries.tpl.html',
            controller: 'proposalSummariesController'
          }
        }
      },
      'submission.reports': {
        url: '/reports',
        views: {
          'mainContent': {
            templateUrl: '/content/reportsSummary/reportsSummary.tpl.html',
            controller: 'reportsSummaryController'
          }
        }
      },
      'submission.policies': {
        url: '/policies',
        views: {
          'mainContent': {
            templateUrl: '/content/policiesSummaryGrid/policiesSummary.tpl.html',
            controller: 'policiesSummaryController'
          }
        }
      },
      'submission.policy': {
        url: '/policies/:policyId',
        views: {
          'mainContent': {
            templateUrl: '/content/policiesSummaryGrid/policiesSummary.tpl.html',
            controller: 'policiesSummaryController'
          }
        }
      },
      'submission.externalContent': {
        url: '/externalContent/:externalContentId',
        views: {
          'mainContent': {
            templateUrl: '/content/externalContent/externalContent.tpl.html',
            controller: 'externalContentController'
          }
        },
        params: {
          externalContentUrl: null,
          externalContentPopoutUrl: null
        }
      }
    }
  }
});

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ApplicationController = function ApplicationController($rootScope, $scope, $location, $state, $timeout, coreConstant, appTypeConfigurationModel, coreMediator, userStateModel, localization, persistentConnection, uiPerformanceLogger, notificationPopupUtil, authenticationUtil, refreshLoginTokenUtil) {
  var bootstrapRedirect,
    timeoutList = [],
    notificationLoadingBarPromise = null,
    notificationLoadingBarScope = null;
  $scope.appIsReady = false;
  function goToLoginPage() {
    $scope.appIsReady = true;
    if ($state.current.name !== 'password' && !$location.search().token) {
      if (!bootstrapRedirect) {
        bootstrapRedirect = $location.url();
        if (_.startsWith(bootstrapRedirect, '/login') || bootstrapRedirect === '') {
          bootstrapRedirect = null;
        }
      }
      coreMediator.disconnect();
      $state.go('login', {
        username: $location.search().username,
        login: $location.search().login,
        externalToken: $location.search().externalToken
      });
    }
  }
  function setAvailableToChat() {
    var visibleForChat = true;
    coreMediator.setChatVisibility(visibleForChat).then(function () {
      userStateModel.setVisibleForChat(visibleForChat);
    });
  }
  function bootstrapApplication(skipRedirection) {
    //as soon as logged in, set available to chat to true
    setAvailableToChat();
    coreMediator.bootstrapApplication().then(function () {
      $scope.appIsReady = true;
      if (!skipRedirection) {
        if (bootstrapRedirect) {
          $location.url(bootstrapRedirect);
          bootstrapRedirect = null;
        } else {
          $state.go('landing');
        }
      }
    });
  }
  $scope.$on(coreConstant.event.BOOT_APPLICATION, function () {
    bootstrapApplication();
  });
  $scope.$on(coreConstant.event.INVALID_SESSION, function () {
    // Remove the login details if there was an invalid session error, as this may indicate the token has
    // expired.
    coreMediator.removeLoginToken();
    coreMediator.removeClientId();
    refreshLoginTokenUtil.stop();
    goToLoginPage();
  });
  $scope.$on(coreConstant.event.START_UI_PERFORMANCE_LOG, function (event, logAction, message) {
    uiPerformanceLogger.startLog(logAction, message);
  });
  $scope.$on(coreConstant.event.END_UI_PERFORMANCE_LOG, function (event, logAction, status, newMessage, isLogOut) {
    uiPerformanceLogger.endLog(logAction, status, newMessage, isLogOut);
  });
  $scope.$on(coreConstant.event.END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING, function (event, logAction) {
    uiPerformanceLogger.endLogWithoutLogging(logAction);
  });
  $scope.$on('$stateChangeSuccess', function (event, toState) {
    $scope.isPrintPreview = toState.name.indexOf('print') !== -1;
  });
  $scope.$on(coreConstant.event.CREATE_NOTIFICATION, function (event, notification) {
    timeoutList.push($timeout(function () {
      // Note that multiple notifications can fire within the timeout of a notification, causing an update to the notification
      // attached to the scope.
      // Therefore care must be taken by the underlying controller to perform a one-time binding of the passed notification
      $scope.notification = notification;
      notificationPopupUtil.displayChatNotification($scope);
    }.bind(this), 0));
  }.bind(this));
  $scope.$on(coreConstant.event.SHOW_FADING_NOTIFICATION, function (event, notification) {
    timeoutList.push($timeout(function () {
      $scope.notification = notification;
      notificationPopupUtil.displayNotificationPopup($scope);
    }, 0));
  });
  $scope.$on(coreConstant.event.SHOW_FADING_NOTIFICATION_LOADING_BAR, function (event, notification) {
    notificationLoadingBarScope = $rootScope.$new(true);
    notificationLoadingBarScope.notification = notification;
    notificationLoadingBarScope.isLoadingBar = true;
    notificationLoadingBarPromise = notificationPopupUtil.displayNotificationPopup(notificationLoadingBarScope);
  });
  $scope.$on(coreConstant.event.CONCLUDE_FADING_NOTIFICATION_LOADING_BAR, function (event, notification) {
    if (!_.isNil(notificationLoadingBarScope)) {
      notificationLoadingBarScope.notification = notification;
      notificationLoadingBarScope.isLoadingBar = false;
    }
  });
  $scope.$on(coreConstant.event.HIDE_FADING_NOTIFICATION_LOADING_BAR, function (event, isHard) {
    if (!_.isNil(notificationLoadingBarPromise)) {
      notificationLoadingBarPromise.then(function (notification) {
        notification.kill(isHard);
      });
      notificationLoadingBarPromise = null;
    }
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  localization.getTranslations().then(function () {
    authenticationUtil.attemptAutoAuthentication().then(bootstrapApplication, goToLoginPage);
  });
};
ApplicationController.$inject = ["$rootScope", "$scope", "$location", "$state", "$timeout", "coreConstant", "appTypeConfigurationModel", "coreMediator", "userStateModel", "localization", "persistentConnection", "uiPerformanceLogger", "notificationPopupUtil", "authenticationUtil", "refreshLoginTokenUtil"];
angular.module('ums').controller('applicationController', ApplicationController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(1819);
var locale = __webpack_require__(74);

/*@ngInject*/
var UIBusinessCardDirective = function UIBusinessCardDirective($window, $document, $rootScope, $timeout, $state, coreMediator, coreConstant, authorizationConstants, submissionStateMediator, currentSubmissionModel, currentUserModel, submissionStateModel, organizationType) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.businessCardViewModel = {
      i18n: locale
    };
    $scope.isBusinessCardClicked = false;
    $scope.isCardOpenTemporary = true;
    $scope.mayCloseCard = true;
    $scope.isCardHasMouseFocus = false;
    $scope.LEFT_ARROW = 1;
    $scope.RIGHT_ARROW = 2;
    $scope.TOP_ARROW = 3;
    $scope.BOTTOM_ARROW = 4;
    $scope.RIGHT_BOTTOM_ARROW = 5;
    $scope.xPos = -9999;
    $scope.yPos = -9999;
    $scope.cardWidth = 400;
    $scope.showSendEmailLink = true;
    $scope.timeoutList = [];
    $scope.onCardClick = function () {
      $scope.mayCloseCard = false;
      if ($scope.showBusinessCard) {
        $scope.isBusinessCardClicked = true;
        $scope.isCardOpenTemporary = false;
        $rootScope.isBusinessCardFreezed = true;
      }
    };
    $scope.openEmailEditor = function () {
      var userId = $scope.viewModel.id,
        params = {},
        stateName = '';
      if (!_.isNil(currentSubmissionModel.getCurrentSubmission())) {
        $rootScope.$broadcast(coreConstant.event.HANDLE_EMAIL_FROM_BUSINESS_CARD, $scope.submissionId, parseInt(userId));
        /*
         * UMS-26310
         * Use the chatMessageId, emailMessageId, or notificationId property
         * as a query parameter in the "POST /Email/SendNotification" request.
         * This is step 2a of 6.
         * The next step is in the EmailResource.sendEmailNotification method.
         * The previous step is in the function handling SHOW_USER_BUSINESS_CARD below.
         */
        var options = undefined;
        if ($scope.chatMessageId) {
          options = {
            variables: {
              chatMessageId: $scope.chatMessageId
            }
          };
        } else if ($scope.emailMessageId) {
          options = {
            variables: {
              emailMessageId: $scope.emailMessageId
            }
          };
        } else if ($scope.notificationId) {
          options = {
            variables: {
              notificationId: $scope.notificationId
            }
          };
        }
        coreMediator.sendEmailNotification('notification.sendEmailFromEmailCollaborationTool', /*isCustom=*/true, $scope.submissionId, options);
      } else {
        params = {
          submissionId: $scope.submissionId
        };
        stateName = 'submission.default';
        currentSubmissionModel.sendMailUserId = parseInt(userId);
        currentSubmissionModel.doCreateDraftEmail = true;
        $state.go(stateName, params, {
          reload: true
        });
      }
      cleanData();
    };
    $scope.onCloseButtonClicked = function () {
      cleanData();
    };
    $scope.onMouseEnter = function () {
      $scope.isCardHasMouseFocus = true;
    };
    $scope.onMouseLeave = function () {
      $scope.isCardHasMouseFocus = false;
      $scope.timeoutList.push($timeout(function () {
        if (!$scope.isBusinessCardClicked && $scope.isCardOpenTemporary && $scope.showBusinessCard) {
          $scope.showBusinessCard = false;
        }
      }, 1000));
    };
    $scope.$on(coreConstant.event.HIDE_BUSINESS_CARD, function () {
      if ($scope.isCardOpenTemporary && !$scope.isCardHasMouseFocus) {
        cleanData();
      }
    });
    $scope.$on(coreConstant.event.SHOW_ORGANIZATION_CARD, function (arg1, event, organizationId) {
      var xPos = event.pageX - event.offsetX;
      var yPos = event.pageY - event.offsetY;
      $scope.isUserCard = false;
      coreMediator.loadOrganizationById(organizationId).then(function (organizationSummary) {
        organizationSummary.organizationType = organizationSummary.organizationType === organizationType.AGENCY ? 'AGENCY' : 'CARRIER';
        formatAddress(organizationSummary);
        showBusinessCardContinue(event, organizationSummary, xPos, yPos, true);
      });
    });
    function formatAddress(organizationSummary) {
      var city = organizationSummary.city,
        state = organizationSummary.state,
        postalCode = organizationSummary.postalCode,
        values = [];
      if (!_.isNil(city)) {
        values.push(city);
      }
      if (!_.isNil(state)) {
        values.push(state);
      }
      if (!_.isNil(postalCode)) {
        values.push(postalCode);
      }
      if (!_.isEmpty(values)) {
        organizationSummary.addressLine3 = _.join(values, ', ');
      }
    }

    /*
     * Ignore any error from the coreMediator.loadUserById call
     * in the function handling SHOW_USER_BUSINESS_CARD below.
     * See the function handling HANDLE_ERROR in uiErrorHandler.js.
     */
    $scope.$on(coreConstant.event.HANDLE_ERROR, function (event, payload) {
      if ($scope.preventDefaultErrorHandling && $scope.preventDefaultErrorHandling.identifier === payload.identifier) {
        event.preventDefault();
        $scope.preventDefaultErrorHandling = undef;
      }
    });
    $scope.$on(coreConstant.event.SHOW_USER_BUSINESS_CARD, function (arg1, event, usersummary, userid, isGroup, submissionId, hasBusinessCard, notificationId, chatMessageId, emailMessageId) {
      var xPos = event.pageX - event.offsetX;
      var yPos = event.pageY - event.offsetY;
      $scope.isUserCard = true;
      /*
       * UMS-26310
       * Save the chatMessageId, emailMessageId, and notificationId properties
       * so that they can be used in a call to coreMediator.loadUserById.
       * This is step 1 of 6.
       * The next step is either in the openEmailEditor function above
       * or the function handling '$stateChangeStart' in submissionController.js.
       */
      $scope.chatMessageId = chatMessageId;
      $scope.emailMessageId = emailMessageId;
      $scope.notificationId = notificationId;
      if (isGroup) {
        return;
      }
      if (!_.isNil(usersummary)) {
        showBusinessCardContinue(event, JSON.parse(usersummary), xPos, yPos, hasBusinessCard);
      } else {
        if (_.isEmpty(userid) /*system user*/) {
          coreMediator.loadUserById(userid, submissionId, notificationId, chatMessageId, emailMessageId).then(function (userProfile) {
            showBusinessCardContinue(event, userProfile, xPos, yPos, hasBusinessCard);
          }, function (err) {
            $scope.preventDefaultErrorHandling = err;
          });
        }
      }
      $scope.isGroup = isGroup;
      $scope.submissionId = submissionId;
    });
    $scope.$on('$destroy', function () {
      $document.off('click', handleDocumentClick);
      _.each($scope.timeoutList, function (item) {
        if (item) {
          $timeout.cancel(item);
        }
      });
    });
    function showBusinessCardContinue(event, dataObject, xPos, yPos, hasBusinessCard) {
      $scope.showBusinessCard = true;
      $scope.xPos = xPos;
      $scope.yPos = yPos;
      if (!_.isNil($(event.target).closest('.userBusinessCard')) && hasBusinessCard) {
        var targetElem = $(event.target).closest('.userBusinessCard'),
          rect;
        if (_.isNil(targetElem[0])) {
          targetElem = $(event.target).closest('.organizationCard');
        }
        rect = targetElem[0].getBoundingClientRect();
        if ($window.innerWidth > 768) {
          if (isBottomDirection()) {
            $scope.xPos = rect.left + 2;
            $scope.yPos -= rect.height + 10;
            setBottomArrow();
          } else {
            $scope.xPos = rect.left + rect.width - 20;
            $scope.yPos = rect.top + rect.height / 2;
            setLeftArrow();
          }
        }
      } else {
        if (isBottomDirection()) {
          if (isRightDirection()) {
            setRightBottomArrow();
          } else {
            setBottomArrow();
          }
        } else if (isRightDirection()) {
          setRightArrow();
        } else if (isLeftDirection()) {
          if (canDisplayWithBottomArrow()) {
            setBottomArrow();
          } else {
            setLeftArrow();
          }
        } else {
          setTopArrow();
        }
      }
      $scope.locationStyle = {
        'left': $scope.xPos,
        'top': $scope.yPos
      };
      $scope.viewModel = dataObject;
      $scope.mayCloseCard = false;
      showProfileImage();
    }
    function setBottomArrow() {
      // business card with bottom arrow
      $scope.direction = $scope.BOTTOM_ARROW;
      $scope.xPos -= 45;
      $scope.yPos -= 150;
    }
    function setLeftArrow() {
      // business card with left arrow
      $scope.direction = $scope.LEFT_ARROW;
      $scope.xPos += 35;
      $scope.yPos -= 30;
    }
    function setRightArrow() {
      // business card with right arrow
      $scope.direction = $scope.RIGHT_ARROW;
      $scope.xPos -= $scope.cardWidth + 15;
      $scope.yPos -= 25;
    }
    function setTopArrow() {
      // business card with top arrow
      $scope.direction = $scope.TOP_ARROW;
      $scope.xPos -= 55;
      $scope.yPos += 40;
    }
    function setRightBottomArrow() {
      // business card with right-bottom arrow
      $scope.direction = $scope.RIGHT_BOTTOM_ARROW;
      $scope.xPos -= $scope.cardWidth + 15;
      $scope.yPos -= 75;
    }
    function isRightDirection() {
      return $scope.xPos > $scope.cardWidth + 90;
    }
    function isLeftDirection() {
      return $window.innerWidth > 768 && !isRightDirection();
    }
    function isTopDirection() {
      return $window.innerWidth > 768 && $window.innerWidth < 970;
    }
    function isBottomDirection() {
      return $window.innerHeight < $scope.yPos + 200;
    }
    function canDisplayWithBottomArrow() {
      return $scope.yPos > 200;
    }
    function showProfileImage() {
      var sendMailUserId = $scope.viewModel.id;
      $scope.showSendEmailLink = false;
      if ($scope.isUserCard) {
        coreMediator.loadProfileImage(sendMailUserId).then(function (underwriterImage) {
          $scope.hasAvatar = !!underwriterImage;
          $scope.underwriterImage = 'data:image/png;base64,' + underwriterImage;
        });
        $scope.showSendEmailLink = true;
        $scope.showSendEmailLink = currentUserModel.hasAuthorization(authorizationConstants.SEND_EMAIL);
        var newSubmission = submissionStateModel.getNewSubmission();
        if (currentUserModel.getCurrentUser().userId === sendMailUserId || !_.isNil(newSubmission)) {
          $scope.showSendEmailLink = false;
        }
      }
    }
    function cleanData() {
      $scope.showBusinessCard = false;
      $rootScope.isBusinessCardFreezed = false;
      $scope.isCardHasMouseFocus = false;
      $scope.isBusinessCardClicked = false;
      $scope.isCardOpenTemporary = true;
      $scope.viewModel = {};
      $scope.hasAvatar = false;
      $scope.underwriterImage = null;
    }
    function handleDocumentClick() {
      $scope.$apply(function () {
        if ($scope.mayCloseCard) {
          cleanData();
        }
        $scope.mayCloseCard = true;
      });
    }
    $document.on('click', handleDocumentClick);
  };
  return {
    restrict: 'AE',
    link: linkFunction,
    templateUrl: '/common/businessCard/uiBusinessCard.tpl.html'
  };
};
UIBusinessCardDirective.$inject = ["$window", "$document", "$rootScope", "$timeout", "$state", "coreMediator", "coreConstant", "authorizationConstants", "submissionStateMediator", "currentSubmissionModel", "currentUserModel", "submissionStateModel", "organizationType"];
angular.module('umCore').directive('uiBusinessCard', UIBusinessCardDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/common/businessCard/uiBusinessCard.tpl.html';
var html = "<div class=\"businessCard\"\n     ng-show=\"showBusinessCard\"\n     ng-mouseenter=\"onMouseEnter()\"\n     ng-mouseleave=\"onMouseLeave()\"\n     ng-click=\"onCardClick()\"\n     ng-style=\"locationStyle\" \n     ng-class=\"{'businessCardLeftArrow' : direction === LEFT_ARROW,\n                'businessCardRightArrow' : direction === RIGHT_ARROW,\n                'businessCardTopArrow' : direction === TOP_ARROW,\n                'businessCardBottomArrow': direction === BOTTOM_ARROW,\n                'businessCardRightBttomArrow': direction === RIGHT_BOTTOM_ARROW\n            }\">\n    \n    <span class=\"closeButton glyphicon glyphicon-remove\" ng-click=\"onCloseButtonClicked()\"></span>\n\n    <div class=\"cardRow\" ng-if=\"isUserCard\">\n        <div class=\"cardCol\">\n            <img class=\"userImage\"\n                 ng-src=\"{{underwriterImage}}\"\n                 ng-if=\"hasAvatar && !isGroup\">\n            <img ng-src=\"" + __webpack_require__(1820) + "\"\n                 ng-if=\"!hasAvatar && !isGroup\">\n            <img ng-src=\"" + __webpack_require__(1821) + "\"\n                 ng-if=\"isGroup\">\n        </div>\n        \n        <div class=\"cardCol\">\n            <div class=\"item\">\n                <label class=\"name\">{{viewModel.name}}\n                    <span ng-if=\"viewModel.availableToChat\"\n                          class=\"glyphicon glyphicon-online\"></span>\n                    <span ng-if=\"!viewModel.availableToChat\"\n                          class=\"glyphicon glyphicon-offline\"></span></label>\n            </div>\n            <div class=\"item\" ng-if=\"viewModel.phoneNumber\">\n                <span class=\"glyphicon glyphicon-earphone icon\"></span>{{::viewModel.phoneNumber}}\n                <label class=\"phoneLabel\">{{::businessCardViewModel.i18n.businessCard.work}}</label>\n            </div>\n            <div class=\"item\" ng-if=\"viewModel.cellPhoneNumber\">\n                <span class=\"glyphicon glyphicon-earphone icon\"></span>{{::viewModel.cellPhoneNumber}}\n                <label class=\"phoneLabel\">{{::businessCardViewModel.i18n.businessCard.mobile}}</label>\n            </div>\n            <div class=\"item\" ng-if=\"viewModel.faxNumber\">\n                <span class=\"glyphicon glyphicon-print icon\"></span>{{::viewModel.faxNumber}}\n            </div>\n            <div class=\"item\" ng-if=\"viewModel.emailAddress\">\n                <span class=\"glyphicon glyphicon-envelope icon\"></span>\n                <a href=\"mailto:{{viewModel.emailAddress}}\" target=\"_top\" >{{::viewModel.emailAddress}}</a>\n            </div>\n           \n        </div>\n    </div>\n\n    <div class=\"cardRow\" ng-if=\"!isUserCard\">\n        <div class=\"cardCol\">\n            <div class=\"fa fa-building-o orgImage\"></div>\n        </div>\n\n        <div class=\"cardCol orgCol\">\n            <div class=\"orgItem\">\n                <label class=\"header\">{{viewModel.organizationType}}</label>\n            </div>\n            <div class=\"orgItem\">\n                <label class=\"name organizationName\"\n                       uib-tooltip=\"{{ viewModel.name }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.name}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.code\">\n                <label class=\"leading code\">{{::businessCardViewModel.i18n.businessCard.code}}</label>\n                <label class=\"data codeLabel\"\n                       uib-tooltip=\"{{ viewModel.code }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.code}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.addressLine1\">\n                <label class=\"leading address\">{{::businessCardViewModel.i18n.businessCard.address}}</label>\n                <label class=\"data addressLabel addressLabel1\"\n                       uib-tooltip=\"{{ viewModel.addressLine1 }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.addressLine1}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.addressLine2\">\n                <label class=\"leading address\"></label>\n                <label class=\"data addressLabel addressLabel2\"\n                       uib-tooltip=\"{{ viewModel.addressLine2 }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.addressLine2}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.addressLine3\">\n                <label class=\"leading address\"></label>\n                <label class=\"data addressLabel addressLabel3\"\n                       uib-tooltip=\"{{ viewModel.addressLine3 }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.addressLine3}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.phoneNumber\">\n                <span class=\"glyphicon glyphicon-earphone phoneIcon leading\"></span>\n                <label class=\"data phone\"\n                       uib-tooltip=\"{{ viewModel.phoneNumber }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.phoneNumber}}</label>\n            </div>\n\n            <div class=\"orgItem parentHeader\" ng-if=\"viewModel.parentName\">\n                <label class=\"header\">{{::businessCardViewModel.i18n.businessCard.parent}}</label>\n            </div>\n            <div class=\"orgItem parentSection\" ng-if=\"viewModel.parentName\">\n                <span class=\"parentName\"\n                      uib-tooltip=\"{{ viewModel.parentName }}\"\n                      tooltip-popup-delay=\"500\">{{viewModel.parentName}}</span>\n                <span class=\"parentCode\"\n                      uib-tooltip=\"{{ viewModel.parentCode }}\"\n                      tooltip-popup-delay=\"500\">{{viewModel.parentCode}}</span>\n            </div>\n\n        </div>\n    </div>\n    <div class=\"sendEmail\" ng-if=\"showSendEmailLink\" ng-click=\"openEmailEditor()\">\n        <label>{{::businessCardViewModel.i18n.businessCard.sendEmailButton}}</label>\n    </div>\n\n    <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fac3a19bbed393ffc20c8403d845f315.png";

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0ffa6ddcadfedaffccfce459b67b9104.png";

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(1823);
__webpack_require__(1824);
__webpack_require__(1825);
__webpack_require__(1831);
__webpack_require__(1832);
__webpack_require__(1833);
__webpack_require__(1834);
__webpack_require__(1835);
__webpack_require__(1836);

/*@ngInject*/
var AppHeaderController = function AppHeaderController($rootScope, $scope, $uibModal, localization, coreMediator, coreConstant, modalUtil, authenticationMediator, appTypeConfigurationModel, submissionMediator, userStateModel, currentUserModel, authorizationConstants, uiPerformanceLoggerConstant, submissionUtil, headerUtil, currentSubmissionModel, userLoginType) {
  $scope.viewModel = {
    isCreatingSubmission: false,
    createSubmissionPermission: false
  };
  function init() {
    submissionUtil.restoreCreateSubmissionModal();
    $scope.viewModel.createSubmissionPermission = currentUserModel.hasAuthorization(authorizationConstants.SUBMISSION_CREATE);
    if (appTypeConfigurationModel.isUnderwriterWorkstation()) {
      $scope.viewModel.logoConfiguredFileName = 'HTML Underwriter Logo';
    } else if (appTypeConfigurationModel.isAgentConsole()) {
      $scope.viewModel.logoConfiguredFileName = 'HTML Agent Logo';
    }
    localization.getTranslationByKey('appHeader').then(function (translations) {
      var availableToChatMenuItem = {
          identifier: 'availableToChat',
          enabled: !userStateModel.isVisibleForChat(),
          iconClass: 'glyphicon-online',
          label: _.get(translations, 'userProfileDropdown.menuItems.availableToChat'),
          action: setAvailableToChat
        },
        notAvailableToChatMenuItem = {
          identifier: 'notAvailableToChat',
          enabled: userStateModel.isVisibleForChat(),
          iconClass: 'glyphicon-offline',
          label: _.get(translations, 'userProfileDropdown.menuItems.notAvailableToChat'),
          action: setNotAvailableToChat
        },
        profileMenuItem = {
          identifier: 'profile',
          enabled: true,
          iconClass: 'glyphicon-user',
          label: _.get(translations, 'userProfileDropdown.menuItems.profile'),
          action: showUserProfile
        },
        myAuthorityMenuItem = {
          identifier: 'myAuthority',
          enabled: appTypeConfigurationModel.getUserType() === 'Underwriter',
          iconClass: 'glyphicon-briefcase',
          label: _.get(translations, 'userProfileDropdown.menuItems.myAuthority'),
          action: showMyAuthority
        },
        externalAccountsMenuItem = {
          identifier: 'externalAccounts',
          enabled: true,
          iconClass: 'glyphicon-user',
          label: _.get(translations, 'userProfileDropdown.menuItems.externalAccounts'),
          action: showExternalAccounts
        },
        logoutMenuItem = {
          identifier: 'logout',
          enabled: true,
          iconClass: 'glyphicon-log-out',
          label: _.get(translations, 'userProfileDropdown.menuItems.logout'),
          action: logout
        };
      $scope.viewModel.menuItems = [availableToChatMenuItem, notAvailableToChatMenuItem, profileMenuItem, myAuthorityMenuItem, externalAccountsMenuItem, logoutMenuItem];
      coreMediator.loadUserProfile().then(function (userProfile) {
        var currentUser = userProfile,
          isAgentUser = currentUser.userType === 'Agent',
          changePasswordMenuItem;
        coreMediator.loadDefaultPreferences().then(function (preferences) {
          if ((isAgentUser && preferences['system.disablePasswordAndProfileManagementAgent'].value === 'false' || !isAgentUser && preferences['system.disablePasswordAndProfileManagementUnderwriter'].value === 'false') && currentUserModel.getCurrentUser().loginType !== userLoginType.SINGLE_SIGN_ON) {
            changePasswordMenuItem = {
              identifier: 'changePassword',
              enabled: true,
              iconClass: 'glyphicon-lock',
              label: _.get(translations, 'userProfileDropdown.menuItems.changePassword'),
              action: showChangePassword
            };
            $scope.viewModel.menuItems.splice(3, 0, changePasswordMenuItem);
            $scope.viewModel.menuItems.join();
          }
        }.bind(this));
      });
      $scope.viewModel.newSubmissionLabel = _.get(translations, 'newSubmissionLabel');
    });
  }
  function setAvailableToChat() {
    var visibleForChat = true;
    coreMediator.setChatVisibility(visibleForChat).then(function () {
      userStateModel.setVisibleForChat(visibleForChat);
    });
  }
  function setNotAvailableToChat() {
    var visibleForChat = false;
    coreMediator.setChatVisibility(visibleForChat).then(function () {
      userStateModel.setVisibleForChat(visibleForChat);
    });
  }
  function showUserProfile() {
    modalUtil.showUserProfile();
  }
  function showChangePassword() {
    authenticationMediator.showChangePasswordPopup();
  }
  function showMyAuthority() {
    coreMediator.getDynamicDataSetItems({
      name: 'Underwriter Letter of Authority Forms'
    }).then(function (dataSetItems) {
      if (!_.isEmpty(dataSetItems)) {
        $uibModal.open({
          templateUrl: '/common/header/myAuthorityModal/myAuthorityModal.tpl.html',
          controller: 'myAuthorityModalController',
          windowClass: 'myAuthorityModal',
          resolve: {
            letterOfAuthorityForms: function letterOfAuthorityForms() {
              return dataSetItems;
            }
          },
          keyboard: false,
          backdrop: 'static'
        });
      } else {
        localization.getTranslationByKey('myAuthorityModal').then(function (translations) {
          modalUtil.showGenericConfirm({
            title: _.get(translations, 'noAuthoritiesTitle'),
            summary: _.get(translations, 'noAuthoritiesMessage'),
            cancelButtonLabel: _.get(translations, 'noAuthoritiesCancelButtonLabel')
          });
        });
      }
    });
  }
  function showExternalAccounts() {
    $uibModal.open({
      templateUrl: '/common/header/externalAccountModal/externalAccountModal.tpl.html',
      controller: 'externalAccountModalController',
      backdrop: 'static',
      windowClass: 'externalAccountModal'
    });
  }
  function logout() {
    submissionMediator.resetOpenSubmissionList();
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.LOGOUT, coreConstant.uiPeformanceLogger.SUCCESS);
    coreMediator.logout().then(function () {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.LOGOUT, coreConstant.uiPeformanceLogger.SUCCESS, '', true);
    }, function () {
      // On Error
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.LOGOUT, coreConstant.uiPeformanceLogger.FAIL, '', true);
    });
  }
  function updateMenuItemsWithVisibleForChat() {
    _.each($scope.viewModel.menuItems, function (menuItem) {
      if (menuItem.identifier === 'availableToChat') {
        menuItem.enabled = !userStateModel.isVisibleForChat();
      } else if (menuItem.identifier === 'notAvailableToChat') {
        menuItem.enabled = userStateModel.isVisibleForChat();
      }
    });
  }
  $scope.$on(coreConstant.event.ACORD_UPLOAD_NOTIFICATION, function (event, options, actionId) {
    var isAcordUploadCompleteReviewEffectiveDate = options.notificationName === 'acordUploadCompleteReviewEffectiveDate',
      isAcordUploadComplete = options.notificationName === 'acordUploadComplete',
      currentSubmission = currentSubmissionModel.getCurrentSubmission();
    if (isAcordUploadCompleteReviewEffectiveDate || isAcordUploadComplete) {
      if (!_.isNil(currentSubmission) && currentSubmission.id === parseInt(actionId)) {
        // if user is currently on same submission then we will display notification with 'OK' button.
        options.cancelButtonLabel = _.get(translations, 'alert.okButtonLabel');
        delete options.confirmActionButtonLabel;
      }
    }
    options.isAcordUploadCompleteReviewEffectiveDate = isAcordUploadCompleteReviewEffectiveDate;
    options.isAcordUploadComplete = isAcordUploadComplete;
    $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, options, actionId);
  });
  $scope.isActiveNavElement = function (type) {
    return headerUtil.isActiveNavElement(type);
  };
  $scope.isCreateSubmissionDisabled = function () {
    return $scope.viewModel.isCreatingSubmission || !$scope.viewModel.createSubmissionPermission;
  };
  $scope.onCreateSubmission = function () {
    function handleSuccess(newSubmissionPayload) {
      $scope.viewModel.isCreatingSubmission = false;
    }
    function handleError() {
      var logAction = uiPerformanceLoggerConstant.NEW_SUBMISSION,
        status = coreConstant.uiPeformanceLogger.FAIL;
      $scope.viewModel.isCreatingSubmission = false;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
    }
    if (!$scope.viewModel.isCreatingSubmission) {
      var logAction = uiPerformanceLoggerConstant.NEW_SUBMISSION,
        message = 'newSubmission';
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
      $scope.viewModel.isCreatingSubmission = true;
      submissionUtil.createNewSubmission().then(handleSuccess, handleError);
    }
  };
  $scope.$on(coreConstant.event.CHAT_VISIBILITY_CHANGED, function () {
    updateMenuItemsWithVisibleForChat();
  });
  init();
};
AppHeaderController.$inject = ["$rootScope", "$scope", "$uibModal", "localization", "coreMediator", "coreConstant", "modalUtil", "authenticationMediator", "appTypeConfigurationModel", "submissionMediator", "userStateModel", "currentUserModel", "authorizationConstants", "uiPerformanceLoggerConstant", "submissionUtil", "headerUtil", "currentSubmissionModel", "userLoginType"];
angular.module('ums').controller('appHeaderController', AppHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1823 */
/***/ (function(module) {

module.exports = JSON.parse("{\"appHeader\":{\"homeLabel\":\"Home\",\"newSubmissionLabel\":\"New Submission\",\"userProfileDropdown\":{\"menuItems\":{\"profile\":\"Profile\",\"chatAvailability\":\"Chat Availability\",\"logout\":\"Logout\",\"changePassword\":\"Change Password\",\"myAuthority\":\"My Authority\",\"externalAccounts\":\"External Accounts\",\"availableToChat\":\"Available to Chat\",\"notAvailableToChat\":\"Not Available to Chat\"}}}}");

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

var path = '/common/header/appHeader.tpl.html';
var html = "<ui-header show-chat-icon=\"true\"\n           logo-configured-file-name=\"viewModel.logoConfiguredFileName\"\n           menu-items=\"viewModel.menuItems\">\n\n    <ui-header-left-side>\n\n        <div class=\"navElement home\"\n             ng-class=\"{ active: isActiveNavElement('landing')}\">\n\n            <button class=\"navButton btnHome\"\n                    ui-sref=\"landing\"\n                    ui-translate>appHeader.homeLabel\n            </button>\n        </div>\n\n        <active-submission-dropdown></active-submission-dropdown>\n    </ui-header-left-side>\n\n    <ui-header-right-side>\n\n        <div class=\"navElement newSubmission\">\n\n            <button class=\"btn btn-primary btnSubmission\"\n                    ng-disabled=\"isCreateSubmissionDisabled()\"\n                    ng-click=\"onCreateSubmission()\">\n                {{ ::viewModel.newSubmissionLabel }}\n            </button>\n        </div>\n\n        <ui-help></ui-help>\n\n        <ui-chat-notification></ui-chat-notification>\n\n        <ui-notification></ui-notification>\n    </ui-header-right-side>\n</ui-header>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1826);
__webpack_require__(1828);
__webpack_require__(1830);
var ChatNotificationComponent = {
  templateUrl: '/common/header/chatNotification/chatNotification.tpl.html',
  controller: 'chatController'
};
angular.module('ums').component('uiChatNotification', ChatNotificationComponent);

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/common/header/chatNotification/chatNotification.tpl.html';
var html = "<div class=\"notifications chat\"\n     ng-click=\"$ctrl.onIconClick($event)\"\n     uib-tooltip=\"{{ ::$ctrl.tooltip }}\"\n     tooltip-popup-delay=\"500\"\n     tooltip-append-to-body=\"true\"\n     tooltip-placement=\"bottom\">\n\n    <img src=\"" + __webpack_require__(1827) + "\"\n         class=\"chatNotificationButton notificationButton\">\n\n    <span ng-if=\"$ctrl.numberOfUnacknowledged > 0\"\n          class=\"notificationToggleBadge\">{{ $ctrl.numberOfUnacknowledged }}</span>\n</div>\n\n<div class=\"arrowUp\" ng-if=\"$ctrl.isOpen\"></div>\n\n<div class=\"notificationPopout chat\"\n     ng-if=\"$ctrl.isOpen\"\n     ui-auto-close\n     on-close=\"$ctrl.onIconClick()\"\n     is-open=\"$ctrl.isOpen\">\n\n    <div class=\"header\">\n\n        <div class=\"notificationHeaderLabel\"\n             ui-locale>chatNotification|chatNotification.popout.title</div>\n\n        <div class=\"unreadFilterToggle\">\n\n            <div class=\"filter allFilter\"\n                 ng-class=\"{'selected': $ctrl.isFilterSelected('all')}\"\n                 ng-click=\"$ctrl.selectFilter('all')\"\n                 ui-locale>chatNotification|chatNotification.popout.all</div>\n\n            <div class=\"filter unreadFilter\"\n                 ng-class=\"{'selected': $ctrl.isFilterSelected('unread')}\"\n                 ng-click=\"$ctrl.selectFilter('unread')\"\n                 ui-locale>chatNotification|chatNotification.popout.unread</div>\n        </div>\n\n        <div class=\"markAllAsRead\"\n             ng-class=\"{'disabled': $ctrl.areAllNotificationsRead()}\"\n             ng-click=\"$ctrl.markAllAsRead()\"\n             ui-locale>chatNotification|chatNotification.popout.markAllAsRead</div>\n    </div>\n\n    <ul class=\"content\">\n\n        <li class=\"dockPanelCell\"\n            ng-class=\"{'read': notification.read, 'unread': !notification.read, 'acknowledged': notification.acknowledged, 'unacknowledged': !notification.acknowledged}\"\n            ng-repeat=\"notification in $ctrl.chatNotificationModel.getNotifications() | limitTo: $ctrl.limit\"\n            ng-if=\"$ctrl.chatNotificationModel.getNotifications().length > 0 && !$ctrl.isLoading\"\n            ng-mouseover=\"$ctrl.showControls(notification)\"\n            ng-mouseleave=\"$ctrl.hideControls(notification)\"\n            row-id=\"{{ $index }}\">\n\n            <div class=\"cellLeftSide\">\n\n                <ui-user-avatar userid=\"{{ ::notification.actorId }}\"\n                                submissionid=\"{{ ::notification.submissionId }}\"\n                                notification-id=\"{{ ::notification.id }}\"></ui-user-avatar>\n            </div>\n\n            <div class=\"cellContent\">\n\n                <div class=\"insuredNameContainer\"\n                     uib-tooltip=\"{{ ::notification.insuredName }}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\"\n                     tooltip-enable=\"{{ $ctrl.chatNotificationTooltips[notification.id] }}\">\n\n                    <span class=\"insuredName\"\n                          ng-click=\"$ctrl.onInsuredNameClick(notification)\"\n                          ui-is-tooltip-enabled=\"$ctrl.chatNotificationTooltips[notification.id]\"\n                          ui-is-tooltip-enabled-check-parent-width=\"true\">{{ ::notification.insuredName }}</span>\n                </div>\n\n                <div class=\"message\">\n                  <p ui-browser-detection>\n\t\t\t\t\t<strong>{{ $ctrl.getNotificationActor(notification) }}:</strong>\n                    \"{{ ::notification.message }}\"\n                  </p>\n                </div>\n            </div>\n\n            <div class=\"cellRightSide\">\n\n                <div class=\"cellRightSideTopContainer\">\n\n                    <span class=\"newNotificationIndicator\"\n                          ng-if=\"!notification.acknowledged && !$ctrl.areControlsVisible(notification)\"\n                          ui-locale>chatNotification|chatNotification.popout.new</span>\n\n                    <input type=\"checkbox\"\n                           class=\"markAsReadCheckbox\"\n                           ng-if=\"$ctrl.areControlsVisible(notification)\"\n                           uib-tooltip=\"{{ $ctrl.getMarkAsReadTooltip(notification) }}\"\n                           tooltip-popup-delay=\"500\"\n                           tooltip-append-to-body=\"true\"\n                           tooltip-placement=\"left\"\n                           ng-model=\"notification.read\"\n                           ng-change=\"$ctrl.toggleRead(notification)\"/>\n                </div>\n\n                <div class=\"cellRightSideBottomContainer\">\n\n                    <ui-reload-relative-time time=\"{{ ::notification.timeCreated }}\"\n                                             interval=\"1\"\n                                             use-moment=\"true\"></ui-reload-relative-time>\n                </div>\n            </div>\n        </li>\n\n        <li ng-if=\"$ctrl.chatNotificationModel.getNotifications().length === 0 && !$ctrl.isLoading\"\n            class=\"noNotifications\">\n\n            <span ng-if=\"$ctrl.isFilterSelected('all')\"\n                  ui-locale>chatNotification|chatNotification.popout.noNotifications</span>\n\n            <span ng-if=\"$ctrl.isFilterSelected('unread')\"\n                  ui-locale>chatNotification|chatNotification.popout.noUnreadNotifications</span>\n        </li>\n\n        <li ng-if=\"$ctrl.isLoading\"\n            class=\"loadingNotifications\">\n\n            <div class=\"icon-spinner\">\n\n                <img src=\"" + __webpack_require__(778) + "\" />\n            </div>\n        </li>\n    </ul>\n\n    <div class=\"footer\">\n\n        <div class=\"loadMoreContainer\">\n\n            <span class=\"loadMore\"\n                  ng-class=\"{'disabled': $ctrl.shouldDisableLoadMore(), 'hidden': $ctrl.isLoadingMore}\"\n                  ng-click=\"$ctrl.onLoadMoreClick($event)\"\n                  ui-locale>chatNotification|chatNotification.popout.loadMore</span>\n\n            <div class=\"loadingMoreNotifications\"\n                 ng-if=\"$ctrl.isLoadingMore\">\n\n                <div class=\"icon-spinner\">\n\n                    <img src=\"" + __webpack_require__(778) + "\" />\n                </div>\n            </div>\n        </div>\n\n        <div class=\"unreadNotificationsCount\"\n             ng-if=\"$ctrl.shouldShowUnreadNotificationsCount()\">{{ $ctrl.getUnreadNotificationsCount() }}</div>\n    </div>\n\n    <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0c50fe67b0af375e8487d45f8f49449c.svg";

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, i18n) {/*@ngInject*/
var ChatController = function ChatController($rootScope, $scope, $state, $q, localization, coreConstant, coreMediator, currentUserModel, currentSubmissionModel, chatNotificationModel, notificationType, submissionStateMediator, submissionConstant, preferenceModel) {
  var _this6 = this;
  var openingSubmissionFromNotificationMarksNotificationAsReadPreference = preferenceModel.get('system.openingSubmissionFromNotificationMarksNotificationAsRead');
  var openingSubmissionFromNotificationMarksNotificationAsRead = openingSubmissionFromNotificationMarksNotificationAsReadPreference === 'true' || _.isNil(openingSubmissionFromNotificationMarksNotificationAsReadPreference);
  localization.setupLocale('chatNotification', __webpack_require__(1829));
  this.isOpen = false;
  this.chatNotificationModel = chatNotificationModel;
  this.limit = coreConstant.chatNotifications.loadLimit;
  this.limitIncrement = coreConstant.chatNotifications.loadLimit;
  this.userId = currentUserModel.getCurrentUser().userId;
  this.disableLoadMore = false;
  this.numberOfUnacknowledged = 0;
  this.numberOfUnread = 0;
  this.tooltip = i18n.t('chatNotification|chatNotification.tooltip');
  this.markAsReadTooltip = i18n.t('chatNotification|chatNotification.popout.markAsRead');
  this.markAsUnreadTooltip = i18n.t('chatNotification|chatNotification.popout.markAsUnread');
  this.controlsVisible = {};
  this.chatNotificationTooltips = {};
  this.unreadLabel = i18n.t('chatNotification|chatNotification.popout.unread');
  this.isLoading = false;
  this.isLoadingMore = false;
  this.init = function () {
    var isLoadingMore = false;
    if (!chatNotificationModel.areNotificationsPopulated()) {
      this.getNotifications(isLoadingMore);
    }
    this.getCounts();
  };
  this.onIconClick = function () {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      this.numberOfUnacknowledged = 0;
      this.disableLoadMore = false;
      coreMediator.acknowledgeByUserId(this.userId, notificationType.CHAT);
    } else {
      this.controlsVisible = {};
      this.chatNotificationTooltips = {};
      if (this.limit >= chatNotificationModel.getNotifications().length) {
        this.disableLoadMore = true;
      }
    }
  };
  this.onLoadMoreClick = function () {
    var isLoadingMore = true;
    if (!this.disableLoadMore) {
      this.limit += this.limitIncrement;
      this.getNotifications(isLoadingMore);
    }
  };
  this.onInsuredNameClick = function (notification) {
    var _this = this;
    var promise;
    if (notification.read) {
      promise = $q.when();
    } else {
      if (openingSubmissionFromNotificationMarksNotificationAsRead) {
        promise = coreMediator.markAsReadByNotificationId(notification.id, true);
      } else {
        promise = $q.when();
      }
    }
    promise.then(function () {
      var params = {
          submissionId: notification.submissionId
        },
        stateName = 'submission.form';
      _this.onIconClick();
      if (_.isNil(currentSubmissionModel.getCurrentSubmission()) || currentSubmissionModel.getSelectedSubmission().id !== notification.submissionId) {
        submissionStateMediator.openChatCollaboration(notification.submissionId);
        $state.go(stateName, params);
      } else {
        $rootScope.$broadcast(submissionConstant.event.OPEN_CHAT_COLLABORATION);
      }
    });
  };
  this.getNotificationActor = function (notification) {
    var actorName = notification.actorName === 'AUTHENTICATION_SERVER' ? 'System' : notification.actorName;
    return actorName;
  };
  this.getNotifications = function (isLoadingMore) {
    var _this2 = this;
    if (isLoadingMore) {
      this.isLoadingMore = true;
    } else {
      this.isLoading = true;
    }
    coreMediator.resetUserNotificationRegistrations(notificationType.CHAT).finally(function () {
      var latest = true;
      var unreadOnly = _this2.isFilterSelected(coreConstant.chatNotifications.filters.UNREAD);
      coreMediator.findByNotifiedUserId(_this2.userId, notificationType.CHAT, 0, _this2.limit + _this2.limitIncrement, latest, unreadOnly).then(function (notifications) {
        if (_this2.limit >= notifications.length) {
          _this2.disableLoadMore = true;
        }
        chatNotificationModel.setNotifications(notifications);
      }).finally(function () {
        _this2.isLoading = false;
        _this2.isLoadingMore = false;
      });
    });
  };
  this.getCounts = function () {
    var _this3 = this;
    var latest = true;
    coreMediator.countUnacknowledgedByUserId(this.userId, notificationType.CHAT, latest).then(function (numberOfUnacknowledged) {
      _this3.numberOfUnacknowledged = numberOfUnacknowledged;
    });
    coreMediator.countUnreadByUserId(this.userId, notificationType.CHAT, latest).then(function (numberOfUnread) {
      _this3.numberOfUnread = numberOfUnread;
    });
  };
  this.isFilterSelected = function (filter) {
    return chatNotificationModel.getSelectedFilter() === filter;
  };
  this.selectFilter = function (filter) {
    var isLoadingMore = false;
    if (chatNotificationModel.getSelectedFilter() !== filter) {
      chatNotificationModel.setSelectedFilter(filter);
      this.limit = coreConstant.chatNotifications.loadLimit;
      this.disableLoadMore = false;
      this.getNotifications(isLoadingMore);
    }
  };
  this.areAllNotificationsRead = function () {
    return this.numberOfUnread === 0;
  };
  this.markAllAsRead = function () {
    var _this4 = this;
    if (!this.areAllNotificationsRead()) {
      // set local notifications as read
      this.numberOfUnread = 0;
      _.each(chatNotificationModel.getNotifications(), function (notification) {
        notification.read = true;
      });
      // call backend
      coreMediator.markAllAsReadByUserId(this.userId, notificationType.CHAT).then(function () {
        coreMediator.acknowledgeByUserId(_this4.userId, notificationType.CHAT);
      });
    }
  };
  this.showControls = function (notification) {
    this.controlsVisible[notification.id] = true;
  };
  this.hideControls = function (notification) {
    this.controlsVisible[notification.id] = false;
  };
  this.areControlsVisible = function (notification) {
    return this.controlsVisible[notification.id];
  };
  this.getMarkAsReadTooltip = function (notification) {
    var tooltip;
    if (notification.read) {
      tooltip = this.markAsUnreadTooltip;
    } else {
      tooltip = this.markAsReadTooltip;
    }
    return tooltip;
  };
  this.toggleRead = function (notification) {
    var _this5 = this;
    var hideControls = this.isFilterSelected(coreConstant.chatNotifications.filters.UNREAD);
    coreMediator.markAsReadByNotificationId(notification.id, notification.read).then(function () {
      if (!notification.acknowledged) {
        coreMediator.acknowledgeByNotificationId(notification.id);
      }
      if (hideControls) {
        _this5.hideControls(notification);
      }
    });
  };
  this.getUnreadNotificationsCount = function () {
    return "".concat(this.numberOfUnread, " ").concat(this.unreadLabel);
  };
  this.shouldShowUnreadNotificationsCount = function () {
    return this.numberOfUnread > 0;
  };
  this.shouldDisableLoadMore = function () {
    return this.disableLoadMore || this.isLoading || this.isLoadingMore;
  };
  $scope.$on(coreConstant.event.CREATE_NOTIFICATION, function (event, notification) {
    if (notificationType.CHAT === notification.type) {
      if (_this6.isFilterSelected(coreConstant.chatNotifications.filters.UNREAD) && !notification.read || _this6.isFilterSelected(coreConstant.chatNotifications.filters.ALL)) {
        chatNotificationModel.prependNotification(notification);
        if (chatNotificationModel.getNotifications().length > _this6.limit) {
          _this6.disableLoadMore = false;
        }
        _this6.getCounts();
      }
    }
  });
  $scope.$on(coreConstant.event.UPDATE_NOTIFICATION, function (event, notifications) {
    var getCounts = false;
    _.each(notifications, function (notification) {
      var isLoadingMore = false;
      if (notificationType.CHAT === notification.type) {
        if (_this6.isFilterSelected(coreConstant.chatNotifications.filters.UNREAD) && notification.read) {
          chatNotificationModel.removeNotification(notification);
          if (chatNotificationModel.getNotifications().length === 0) {
            _this6.getNotifications(isLoadingMore);
          } else if (_this6.limit >= chatNotificationModel.getNotifications().length) {
            _this6.disableLoadMore = true;
          }
        } else {
          chatNotificationModel.updateNotification(notification);
        }
        getCounts = true;
      }
    });
    if (getCounts) {
      _this6.getCounts();
    }
  });
  $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
    chatNotificationModel.clearNotifications();
    currentUserModel.clearRegistrations();
    currentUserModel.clearNotificationRegistrations();
  });
  this.init();
};
ChatController.$inject = ["$rootScope", "$scope", "$state", "$q", "localization", "coreConstant", "coreMediator", "currentUserModel", "currentSubmissionModel", "chatNotificationModel", "notificationType", "submissionStateMediator", "submissionConstant", "preferenceModel"];
angular.module('ums').controller('chatController', ChatController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(18)["default"]))

/***/ }),
/* 1829 */
/***/ (function(module) {

module.exports = JSON.parse("{\"chatNotification\":{\"popout\":{\"title\":\"Chat\",\"loadMore\":\"Load more\",\"noNotifications\":\"You have no Chat Notifications\",\"noUnreadNotifications\":\"All Chat Notifications have been read\",\"all\":\"All\",\"unread\":\"Unread\",\"markAsRead\":\"Mark as Read\",\"markAsUnread\":\"Mark as Unread\",\"markAllAsRead\":\"Mark All as Read\",\"new\":\"New\"},\"tooltip\":\"View submission chats.\"}}");

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ChatNotificationModel = function ChatNotificationModel(coreConstant) {
  var notifications = [],
    notificationsPopulated = false,
    selectedFilter = coreConstant.chatNotifications.filters.ALL;
  this.areNotificationsPopulated = function () {
    return notificationsPopulated;
  };
  this.prependNotification = function (notification) {
    _.remove(notifications, function (existingNotification) {
      return existingNotification.submissionId === notification.submissionId;
    });
    notifications.unshift(notification);
  };
  this.removeNotification = function (notificationToRemove) {
    _.remove(notifications, function (notification) {
      return notification.id === notificationToRemove.id;
    });
  };
  this.updateNotification = function (notification) {
    var arrayLength = notifications.length;
    for (var i = 0; i < arrayLength; i++) {
      if (notifications[i].id === notification.id) {
        notifications[i] = notification;
      }
    }
  };
  this.getNotifications = function () {
    return notifications;
  };
  this.clearNotifications = function () {
    notifications = [];
    notificationsPopulated = false;
  };
  this.setNotifications = function (newNotifications) {
    notifications = newNotifications;
    notificationsPopulated = true;
  };
  this.setSelectedFilter = function (filter) {
    selectedFilter = filter;
  };
  this.getSelectedFilter = function () {
    return selectedFilter;
  };
};
ChatNotificationModel.$inject = ["coreConstant"];
angular.module('ums').service('chatNotificationModel', ChatNotificationModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

var path = '/common/header/externalAccountModal/externalAccountModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"okButton\"\n    cancel=\"cancelButton\"\n    class=\"externalAccount\"\n    is-confirm-disabled=\"canEnableConfirmButton()\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"headerContainer\">\n        <label class=\"descriptionColumn\" ui-translate>externalAccount.description</label>\n        <label class=\"usernameColumn\" ui-translate>externalAccount.username</label>\n        <label class=\"passwordColumn\" ui-translate>externalAccount.password</label>\n        <label class=\"passwordColumn\" ui-translate>externalAccount.verifyPassword</label>\n    </div>\n\n    <div class=\"accountsContainer\" ng-repeat=\"externalAccount in viewModel.externalAccounts\">\n        <div class=\"accountsRow\">\n            <div class=\"descriptionColumn\">\n                <div class=\"invalidIcon\"\n                     ng-if=\"isInvalid(externalAccount)\"></div>\n                <div  class=\"glyphicon glyphicon-ok\"\n                      ng-if=\"isComplete(externalAccount)\"></div>\n                <label>{{::externalAccount.description}}</label>\n                <span class=\"passwordMismatch\"\n                      ng-if=\"showIncorrectPassword(externalAccount)\"\n                      ui-translate>externalAccount.passwordMismatch</span>\n            </div>\n            <input class=\"usernameColumn\"\n                   ng-model=\"externalAccount.username\"\n                   ui-max-chars=\"255\"\n                   required\n                   autocomplete=\"off\"\n                   ng-change=\"onChange()\"/>\n            <input class=\"passwordColumn\"\n                   type=\"password\"\n                   required\n                   ui-max-chars=\"255\"\n                   ng-model=\"externalAccount.password\"\n                   autocomplete=\"off\"\n                   ng-change=\"onChange()\"/>\n            <input class=\"passwordColumn\"\n                   type=\"password\"\n                   required\n                   ui-max-chars=\"255\"\n                   ng-model=\"externalAccount.verifyPassword\"\n                   autocomplete=\"off\"\n                   ng-change=\"onChange()\"/>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ExternalAccountModalController = function ExternalAccountModalController($rootScope, $scope, $uibModalInstance, coreConstant, currentUserModel, localization, loadingBarHandler, externalAccountRepository) {
  localization.getTranslations().then(function (translations) {
    var fillerText = 'thisIsFiller',
      isValueChange = false;
    $scope.title = _.get(translations, 'externalAccount.title');
    $scope.cancelButton = _.get(translations, 'externalAccount.cancelButton');
    $scope.okButton = _.get(translations, 'externalAccount.okButton');
    $scope.viewModel = {
      'externalAccounts': null
    };
    $scope.isComplete = function (externalAccount) {
      return !_.isNil(externalAccount.username) && !_.isNil(externalAccount.password) && !_.isNil(externalAccount.verifyPassword) && externalAccount.password === externalAccount.verifyPassword;
    };
    $scope.isInvalid = function (externalAccount) {
      var fieldPopulated = !_.isNil(externalAccount.username) || !_.isNil(externalAccount.password) || !_.isNil(externalAccount.verifyPassword),
        fieldBlank = _.isNil(externalAccount.username) || _.isNil(externalAccount.password) || _.isNil(externalAccount.verifyPassword),
        passwordMismatch = !_.isNil(externalAccount.password) && !_.isNil(externalAccount.verifyPassword) && externalAccount.password !== externalAccount.verifyPassword;
      return fieldPopulated && fieldBlank || passwordMismatch;
    };
    $scope.onConfirm = function () {
      var accountsToSave = [],
        userId = currentUserModel.getCurrentUser().userId;
      loadingBarHandler.showLoadingBar('externalAccount.savingLoadingBar');
      _.each($scope.viewModel.externalAccounts, function (account) {
        if (!_.isNil(account.username) && !_.isNil(account.password) && !_.isNil(account.verifyPassword)) {
          if (account.password === fillerText || account.verifyPassword === fillerText) {
            account.password = account.verifyPassword = null;
          }
          accountsToSave.push(account);
        }
      });
      externalAccountRepository.save(userId, accountsToSave).finally(function () {
        loadingBarHandler.hideLoadingBar();
      });
      $uibModalInstance.close();
    };
    $scope.onCancel = function () {
      $uibModalInstance.close();
    };
    $scope.canEnableConfirmButton = function () {
      var validateArr = [],
        isValid;
      if (isValueChange) {
        _.each($scope.viewModel.externalAccounts, function (externalAccount) {
          isValid = _.isNil(externalAccount.username) && _.isNil(externalAccount.password) && _.isNil(externalAccount.verifyPassword) || !_.isNil(externalAccount.username) && !_.isNil(externalAccount.password) && !_.isNil(externalAccount.verifyPassword) && externalAccount.password === externalAccount.verifyPassword;
          validateArr.push(isValid);
        });
        return validateArr.indexOf(false) > -1 ? true : false;
      } else {
        return true;
      }
    };
    $scope.showIncorrectPassword = function (externalAccount) {
      return !_.isNil(externalAccount.password) && !_.isNil(externalAccount.verifyPassword) && externalAccount.password !== externalAccount.verifyPassword;
    };
    $scope.init = function () {
      var userId = currentUserModel.getCurrentUser().userId;
      externalAccountRepository.getExternalAccounts(userId).then(function (externalAccounts) {
        _.each(externalAccounts, function (externalAccount) {
          if (!_.isEmpty(externalAccount.username)) {
            externalAccount.verifyPassword = externalAccount.password = fillerText;
          }
        });
        $scope.viewModel.externalAccounts = externalAccounts;
      });
    };
    $scope.onChange = function () {
      isValueChange = true;
    };
    $scope.init();
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ExternalAccountModalController.$inject = ["$rootScope", "$scope", "$uibModalInstance", "coreConstant", "currentUserModel", "localization", "loadingBarHandler", "externalAccountRepository"];
angular.module('ums').controller('externalAccountModalController', ExternalAccountModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

/*@ngInject*/
var ExternalAccountRepository = function ExternalAccountRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getExternalAccounts = function (userId) {
    var url = '/rest/UnderwritingUser/' + userId + '/externalAuthentications';
    return this.get(url);
  };
  this.save = function (userId, externalAuthentications) {
    var url = '/rest/UnderwritingUser/' + userId + '/saveExternalAuthentications';
    return this.post(url, externalAuthentications);
  };
};
ExternalAccountRepository.$inject = ["baseRepository"];
angular.module('ums').service('externalAccountRepository', ExternalAccountRepository);

/***/ }),
/* 1834 */
/***/ (function(module) {

module.exports = JSON.parse("{\"myAuthorityModal\":{\"title\":\"My Authority\",\"closeButton\":\"Close\",\"noAuthoritiesTitle\":\"My Authority\",\"noAuthoritiesMessage\":\"No Letters of Authority have been found.\",\"noAuthoritiesCancelButtonLabel\":\"OK\"}}");

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

var path = '/common/header/myAuthorityModal/myAuthorityModal.tpl.html';
var html = "<base-modal modal-title=\"title\"\n            ok=\"closeButton\"\n            on-confirm=\"closePopUp()\"\n            on-cancel=\"closePopUp()\"\n            class=\"myAuthorityModal\" >\n\n    <div ui-browser-detection>\n\n        <div class=\"letterOfAuthorityForms\">\n            <div class=\"disabledDropdown\" ng-if=\"disableLetterOfAuthorityFormsDropdown\">\n                <span>{{ letterOfAuthorityForms[0].name }}</span>\n            </div>\n\n            <um-dropdown class-name=\"letterOfAuthorityDropdown\"\n                         required=\"'true'\"\n                         option-list=\"letterOfAuthorityForms\"\n                         selected-value=\"formId\"\n                         on-change=\"handleSelect(selectedOption)\">\n            </um-dropdown>\n        </div>\n\n        <!--Content-->\n        <div class=\"contentContainer\">\n            <ui-form-viewer form-id=\"{{ formId }}\"\n                            printable=\"false\">\n            </ui-form-viewer>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var MyAuthorityModalController = function MyAuthorityModalController($rootScope, $scope, localization, coreConstant, letterOfAuthorityForms, $uibModalInstance) {
  localization.getTranslationByKey('myAuthorityModal').then(function (translations) {
    $scope.title = _.get(translations, 'title');
    $scope.closeButton = _.get(translations, 'closeButton');
    $scope.letterOfAuthorityForms = letterOfAuthorityForms;
    $scope.selectedLetterOfAuthorityForm = letterOfAuthorityForms[0];
    $scope.formId = $scope.selectedLetterOfAuthorityForm.value;
    $scope.disableLetterOfAuthorityFormsDropdown = _.size($scope.letterOfAuthorityForms) === 1;
    $scope.handleSelect = function (selectedOption) {
      $scope.formId = selectedOption.value;
    };
    $scope.closePopUp = function () {
      $uibModalInstance.close();
    };
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
MyAuthorityModalController.$inject = ["$rootScope", "$scope", "localization", "coreConstant", "letterOfAuthorityForms", "$uibModalInstance"];
angular.module('ums').controller('myAuthorityModalController', MyAuthorityModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ })
]),[[1779,1,2,0]]]);
});